import type { GraphQLClient, RequestOptions } from 'graphql-request';
import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
type GraphQLClientRequestHeaders = RequestOptions['requestHeaders'];
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** ISO 8601 date string (YYYY-MM-DD) */
  Date: { input: any; output: any; }
  /** ISO 8601 date-time string */
  DateTime: { input: any; output: any; }
  /** Arbitrary JSON value used for raw CMS payloads and audit metadata. */
  JSON: { input: any; output: any; }
  /**
   * An exact Healthie termination status: "Cancelled", "Re-Scheduled", or "No-Show".
   * Accepts and returns strings with this exact spelling and casing. Other values,
   * including completed-visit outcomes such as "Occurred", are rejected. Inline
   * GraphQL values must be quoted strings.
   */
  TerminationAppointmentStatusChange: { input: any; output: any; }
};

/** Canonical provider-registry identity selected by ACCESS provisioning policy. */
export type PlatformAccessAgentProvider = {
  __typename?: 'AccessAgentProvider';
  /**
   * The care agent's Healthie user id. Chat channel members are keyed on Healthie
   * ids, so a caller matching the agent against a channel needs this rather than
   * the registry id.
   */
  healthieUserId: Scalars['String']['output'];
  providerId: Scalars['ID']['output'];
};

export type PlatformAccessAlignmentAttempt = {
  __typename?: 'AccessAlignmentAttempt';
  alignmentType?: Maybe<PlatformAccessAlignmentType>;
  cmsResultCode?: Maybe<Scalars['String']['output']>;
  cmsResultText?: Maybe<Scalars['String']['output']>;
  cmsStatus: Scalars['String']['output'];
  conditions: Array<Scalars['String']['output']>;
  externalSubmissionId?: Maybe<Scalars['ID']['output']>;
  providerReferralRequired: Scalars['Boolean']['output'];
  recommendationSnapshot?: Maybe<Scalars['JSON']['output']>;
  referralEpisodeCorrelationKey?: Maybe<Scalars['String']['output']>;
  referralHandoffId?: Maybe<Scalars['ID']['output']>;
  resultReceivedAt?: Maybe<Scalars['DateTime']['output']>;
  submissionId: Scalars['ID']['output'];
  submittedAt: Scalars['DateTime']['output'];
  track: PlatformAccessTrack;
};

/** Read-only Platform recommendation; displaying it performs no mutation. */
export type PlatformAccessAlignmentRecommendation = {
  __typename?: 'AccessAlignmentRecommendation';
  alignmentType?: Maybe<PlatformAccessAlignmentType>;
  configurationVersion: Scalars['String']['output'];
  evaluatedAt: Scalars['DateTime']['output'];
  evidence: PlatformAccessRecommendationEvidence;
  reasons: Array<PlatformAccessRecommendationReason>;
  recommendation?: Maybe<PlatformAccessRecommendationDecision>;
  status: PlatformAccessRecommendationStatus;
  track?: Maybe<PlatformAccessTrack>;
};

export type PlatformAccessAlignmentReviewDetail = {
  __typename?: 'AccessAlignmentReviewDetail';
  accessEnrollmentId: Scalars['ID']['output'];
  /** Stored alignment attempts in reverse chronological order. */
  alignmentAttempts: Array<PlatformAccessAlignmentAttempt>;
  /** Server-owned CKM-first alignment recommendation snapshot. */
  alignmentRecommendation: PlatformAccessAlignmentRecommendation;
  auditEvents: Array<PlatformAccessAuditEvent>;
  availableActions: Array<PlatformAccessReviewAction>;
  candidateTrack: PlatformAccessTrack;
  /** Reason recorded with that opt-out; null unless opted out. */
  commsOptOutReason?: Maybe<Scalars['String']['output']>;
  /**
   * When ops recorded the patient's request to stop participating, from this or
   * any other of their enrollments; null unless opted out. The state is
   * unchanged. See `recordAccessCommsOptOut`.
   */
  commsOptedOutAt?: Maybe<Scalars['DateTime']['output']>;
  /** Admin user id of the reviewer who recorded that opt-out; null unless opted out or recorded without one. */
  commsOptedOutBy?: Maybe<Scalars['String']['output']>;
  /** Current ICD-10 diagnoses from clinical-records (Zus); not ACCESS-eligibility filtered. */
  diagnoses: Array<PlatformAccessClinicalDiagnosis>;
  finalTrack?: Maybe<PlatformAccessTrack>;
  healthieUrl?: Maybe<Scalars['String']['output']>;
  /** Engine-owned active flag; false once the enrollment is terminal (including UNALIGNED_BY_CMS). */
  isActive: Scalars['Boolean']['output'];
  latestEligibilityResult?: Maybe<Scalars['JSON']['output']>;
  /** Fixed measure slots for ACCESS review (always six rows; null value/date when missing). */
  measurements: Array<PlatformAccessClinicalMeasurement>;
  patient: PlatformAccessPatientSummary;
  patientId?: Maybe<Scalars['ID']['output']>;
  patientRecord?: Maybe<PlatformPatient>;
  referralContext?: Maybe<PlatformAccessReferralContext>;
  selfReportedConditionKeys: Array<Scalars['String']['output']>;
  /** Current durable enrollment state. */
  status: PlatformAccessEnrollmentStatus;
  /**
   * Effective date of the CMS un-alignment, as CMS reported it; null unless
   * `status` is UNALIGNED_BY_CMS. See `recordAccessCmsUnalignment`.
   */
  unalignedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The $align submission id CMS quoted when un-aligning; null when its notice carried none. */
  unalignmentCmsSubmissionId?: Maybe<Scalars['String']['output']>;
  /** Reason recorded with the CMS un-alignment; null unless un-aligned. */
  unalignmentReason?: Maybe<Scalars['String']['output']>;
  zusPatientUrl?: Maybe<Scalars['String']['output']>;
};

export type PlatformAccessAlignmentReviewQueueConnection = {
  __typename?: 'AccessAlignmentReviewQueueConnection';
  nodes: Array<PlatformAccessAlignmentReviewQueueNode>;
  pageInfo: PlatformAccessPageInfo;
};

export type PlatformAccessAlignmentReviewQueueInput = {
  page?: InputMaybe<PlatformAccessAlignmentReviewQueuePageInput>;
};

export type PlatformAccessAlignmentReviewQueueNode = {
  __typename?: 'AccessAlignmentReviewQueueNode';
  accessEnrollmentId: Scalars['ID']['output'];
  candidateTrack: PlatformAccessTrack;
  createdAt: Scalars['DateTime']['output'];
  finalTrack?: Maybe<PlatformAccessTrack>;
  glp1Status?: Maybe<Scalars['String']['output']>;
  healthieUserId: Scalars['ID']['output'];
  latestEligibilityResult?: Maybe<Scalars['JSON']['output']>;
  patientId?: Maybe<Scalars['ID']['output']>;
  patientRecord?: Maybe<PlatformPatient>;
  referralStatus?: Maybe<Scalars['String']['output']>;
  selfReportedConditionKeys: Array<Scalars['String']['output']>;
  status: PlatformAccessEnrollmentStatus;
  updatedAt: Scalars['DateTime']['output'];
  zusSyncStatus?: Maybe<Scalars['String']['output']>;
};

export type PlatformAccessAlignmentReviewQueuePageInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

export enum PlatformAccessAlignmentType {
  FollowOn = 'FOLLOW_ON',
  Initial = 'INITIAL'
}

export type PlatformAccessAuditEvent = {
  __typename?: 'AccessAuditEvent';
  action: Scalars['String']['output'];
  actorId?: Maybe<Scalars['String']['output']>;
  actorType: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  fromStatus?: Maybe<PlatformAccessEnrollmentStatus>;
  id: Scalars['ID']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  sourceSystem: Scalars['String']['output'];
  toStatus?: Maybe<PlatformAccessEnrollmentStatus>;
};

/** An ACCESS patient's baseline body measurements. See `accessBaselineBodyMeasurements`. */
export type PlatformAccessBaselineBodyMeasurements = {
  __typename?: 'AccessBaselineBodyMeasurements';
  heightCm?: Maybe<Scalars['Float']['output']>;
  weight?: Maybe<PlatformAccessBaselineWeight>;
};

export enum PlatformAccessBaselineOapMeasureCategory {
  BloodPressure = 'BLOOD_PRESSURE',
  Bmi = 'BMI',
  BodyWeight = 'BODY_WEIGHT',
  Egfr = 'EGFR',
  Hba1C = 'HBA1C',
  LdlC = 'LDL_C',
  Uacr = 'UACR'
}

/**
 * PHI-safe, inspection-only state for the current baseline obligation. Resolving
 * this type never creates a report/submission, starts Temporal, or contacts CMS.
 */
export type PlatformAccessBaselineOapOperationalState = {
  __typename?: 'AccessBaselineOapOperationalState';
  acceptedAt?: Maybe<Scalars['DateTime']['output']>;
  accessEnrollmentId: Scalars['ID']['output'];
  failedAt?: Maybe<Scalars['DateTime']['output']>;
  generatedAt?: Maybe<Scalars['DateTime']['output']>;
  hasAcceptedCorrelation: Scalars['Boolean']['output'];
  missingRequiredMeasureCategories: Array<PlatformAccessBaselineOapMeasureCategory>;
  readiness: PlatformAccessBaselineOapReadiness;
  readyToSubmitAt?: Maybe<Scalars['DateTime']['output']>;
  rejectedAt?: Maybe<Scalars['DateTime']['output']>;
  reportId?: Maybe<Scalars['ID']['output']>;
  reportStatus?: Maybe<PlatformAccessBaselineOapReportStatus>;
  reportVersion?: Maybe<Scalars['Int']['output']>;
  reportingPeriodDueAt?: Maybe<Scalars['DateTime']['output']>;
  reportingPeriodStartAt?: Maybe<Scalars['DateTime']['output']>;
  resultReceivedAt?: Maybe<Scalars['DateTime']['output']>;
  retryCount: Scalars['Int']['output'];
  submissionId?: Maybe<Scalars['ID']['output']>;
  submissionStatus?: Maybe<PlatformAccessBaselineOapSubmissionStatus>;
  submittedAt?: Maybe<Scalars['DateTime']['output']>;
  submittingAt?: Maybe<Scalars['DateTime']['output']>;
  supersededAt?: Maybe<Scalars['DateTime']['output']>;
  terminalResult: PlatformAccessBaselineOapTerminalResult;
  track?: Maybe<PlatformAccessTrack>;
  workflowId?: Maybe<Scalars['ID']['output']>;
};

export enum PlatformAccessBaselineOapReadiness {
  AuthorNotReady = 'AUTHOR_NOT_READY',
  Incomplete = 'INCOMPLETE',
  NotAligned = 'NOT_ALIGNED',
  ParticipantNotConfigured = 'PARTICIPANT_NOT_CONFIGURED',
  PatientNotLinked = 'PATIENT_NOT_LINKED',
  Ready = 'READY',
  ReadFailed = 'READ_FAILED'
}

export enum PlatformAccessBaselineOapReportStatus {
  Accepted = 'ACCEPTED',
  Draft = 'DRAFT',
  Failed = 'FAILED',
  ReadyToSubmit = 'READY_TO_SUBMIT',
  Rejected = 'REJECTED',
  Submitted = 'SUBMITTED',
  Submitting = 'SUBMITTING',
  Superseded = 'SUPERSEDED',
  Unknown = 'UNKNOWN'
}

export enum PlatformAccessBaselineOapSubmissionStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Retryable = 'RETRYABLE',
  Submitted = 'SUBMITTED',
  Unknown = 'UNKNOWN'
}

export enum PlatformAccessBaselineOapTerminalResult {
  Duplicate = 'DUPLICATE',
  IncompleteData = 'INCOMPLETE_DATA',
  IncorrectTrack = 'INCORRECT_TRACK',
  NotAvailable = 'NOT_AVAILABLE',
  PatientNotAligned = 'PATIENT_NOT_ALIGNED',
  ReportingPeriodClosed = 'REPORTING_PERIOD_CLOSED',
  Success = 'SUCCESS',
  UnknownTerminal = 'UNKNOWN_TERMINAL'
}

/** One baseline body weight reading. */
export type PlatformAccessBaselineWeight = {
  __typename?: 'AccessBaselineWeight';
  /** When the weight was measured. */
  recordedAt: Scalars['DateTime']['output'];
  source: PlatformAccessBaselineWeightSource;
  weightKg: Scalars['Float']['output'];
};

/** Where an ACCESS baseline weight came from. */
export enum PlatformAccessBaselineWeightSource {
  /** Synced from Apple Health. */
  AppleHealth = 'APPLE_HEALTH',
  /** Self-reported through Berry Street (the booking flow or the app). */
  BerryStreetSelfReported = 'BERRY_STREET_SELF_REPORTED',
  /** The body weight in the enrollment's CMS-accepted baseline OAP report. Final. */
  CmsBaselineReport = 'CMS_BASELINE_REPORT'
}

/**
 * Why a post-alignment row is not billable. One member per `billable` term, so a
 * row failing several reports several.
 */
export enum PlatformAccessBillableBlockedReason {
  /**
   * No current baseline OAP report that CMS accepted with result `success` —
   * `baselineOapSubmissionCompletedAt` is null.
   */
  BaselineNotAccepted = 'BASELINE_NOT_ACCEPTED',
  /** The enrollment is no longer active. */
  Inactive = 'INACTIVE',
  /** State is not ALIGNED or ALIGNED_SUCCESSFULLY_SWITCHED. */
  NotAligned = 'NOT_ALIGNED',
  /**
   * `enrollment.sourceSystem` is a non-production fixture, e.g.
   * `manual-production-test`. A synthetic patient can align and have a baseline
   * CMS accepted exactly like a real one, so nothing else in this list excludes
   * it from a bill-ready view.
   */
  TestFixture = 'TEST_FIXTURE'
}

/** How an enrollment's Care Initiation Update obligation was met (BSE-3948). */
export enum PlatformAccessCareInitiationDeliveryStatus {
  /** An audited attempt: no fax number on record, or an unusable one (FAX_MISSING / FAX_INVALID). */
  Attempted = 'ATTEMPTED',
  /** Delivered outside the fax job, recorded with a delivery resolution. */
  DeliveredExternally = 'DELIVERED_EXTERNALLY',
  /** Recorded as not required (for example a test or the wrong patient). */
  NotRequired = 'NOT_REQUIRED',
  /** The fax was submitted to the vendor. */
  Sent = 'SENT'
}

/**
 * One generated version of a patient's ACCESS care plan. `contentJson` is the
 * CarePlanDocument (shape versioned by `schemaVersion`) — the consumer contract
 * for the NP review surface; `renderedMarkdown` is the transmittable document.
 *
 * `resolvable: false` IS A SECURITY BOUNDARY HERE, NOT A FORMALITY. Do not remove
 * it, and do not add a `@ResolveReference` for this type.
 *
 * The key exists so another subgraph may REFERENCE a care plan by id; it must not
 * make one FETCHABLE by id. This subgraph is protected by a single process-wide
 * shared bearer API key with caller-asserted reviewer identity, so a resolvable
 * key would make every row in the table id-addressable to any holder of that key
 * — `contentJson`, `renderedMarkdown`, `sourceProvenance.diagnoses`, `advisories`
 * — for any patient, on any enrollment including inactive and replaced ones, with
 * no provider, patient, enrollment or permission scope. Holding a UUID is not
 * authorization.
 *
 * WHAT `resolvable: false` DOES AND DOES NOT BUY, MEASURED RATHER THAN ASSUMED.
 * It is a ROUTER-level guarantee: composition records that no subgraph may
 * entity-fetch an `AccessCarePlan`, so the router will never plan an `_entities`
 * call for one. It is NOT a subgraph-level runtime block —
 * `@apollo/subgraph` still lists this type in the subgraph's own `_Entity` union
 * and still honours a registered `__resolveReference`, which was verified
 * directly. A caller holding the shared API key reaches this subgraph without
 * going through the router, so the flag alone would not stop them. That is why the
 * regression test in `access-care-plan-entity-auth.e2e.spec.ts` EXECUTES the
 * `_entities` path against the real production resolver graph, and why the rule
 * above ("do not add a `@ResolveReference` for this type") is the operative one.
 *
 * Nothing needs the entity path: this type is declared in exactly one subgraph, so
 * the router cannot plan an entity fetch for it, and provider-portal reads care
 * plans through `accessNpReviewQueue(npProviderId:)` and the approve/edit mutation
 * responses.
 */
export type PlatformAccessCarePlan = {
  __typename?: 'AccessCarePlan';
  accessEnrollmentId: Scalars['ID']['output'];
  /**
   * Findings recorded on this plan whose remedy is UPSTREAM of the draft, so they
   * deliberately do NOT set `requiresAttention` (which means "regenerate this" and
   * blocks editing too). A review surface must render these separately from the
   * flagged state.
   *
   * They are not merely informational: while an advisory is present,
   * `approveAccessCarePlan` refuses the plan and returns an error naming the
   * reason and the upstream correction. `editAccessCarePlan` still succeeds — the
   * narrative is the part the reviewer can fix.
   *
   * NOT A SUBSTITUTE FOR `approvalBlocks`, AND NOT A GATE. This list is only what
   * was PERSISTED AT GENERATION, so it is empty on a plan written before advisory
   * persistence and on a plan whose head is frozen at an old snapshot — while the
   * server refuses both. Render this list; read `approvalBlocks` to decide whether
   * approval is possible.
   */
  advisories: Array<PlatformAccessCarePlanAdvisory>;
  /**
   * Whether this plan currently trips the approve mutation's TRACK-PRECEDENCE
   * guard. Not a re-implementation: `approveAccessCarePlan` calls this exact
   * derivation (`carePlanApprovalBlocksFromBundleSnapshot`) over this exact column
   * inside its transaction, and refuses on anything but `CLEAR`.
   *
   * WHAT IT RE-EVALUATES, PRECISELY. The plan's own IMMUTABLE generation snapshot,
   * with CURRENT code. It does NOT read current live enrollment data. So it
   * reflects today's rules applied to the facts this version was generated from —
   * which is the right basis, because approval freezes THIS version — but a
   * realignment recorded on the enrollment after generation is not visible here
   * until the plan is regenerated. What it is NOT is a replay of what was
   * PERSISTED at generation: that is `advisories`, which is empty on rows written
   * before advisory persistence and on rows frozen at an old snapshot, while the
   * server still refuses them.
   *
   * READ THIS, NOT `advisories`, TO DECIDE WHETHER TO OFFER APPROVAL.
   *
   * SCOPE — READ BEFORE USE. This reports ONE class of refusal. It is deliberately
   * not a general `canApprove`. `approveAccessCarePlan` also requires:
   * `requiresAttention` false (exposed on this type), DRAFT status, the latest
   * version for its enrollment, an active enrollment that is still the patient's
   * current one, a caller matching the enrollment's assigned NP, and the two
   * approval-readiness facts in `careUpdateApprovalBlockers` — an addressable
   * care-team recipient in the snapshot, and a configured medical-director name.
   * Those two facts are read from snapshot sections this derivation never looks at
   * (`careTeam`, `orgContacts`), so the mutation also refuses a snapshot that is
   * `CLEAR` here but missing them; that refusal names those sections and is an
   * engineering escalation, not a clinical finding.
   *
   * IT DOES NOT REQUIRE TRANSMISSION READINESS. Recipient organization, fax and
   * phone live in `careUpdateTransmissionBlockers`, which is intentionally
   * stricter and gates FAXING the Care Update, never approval; those gaps are
   * fixed upstream in care-team ingest, not by the reviewing NP, and the document
   * renders them as [pending] so nothing is hidden.
   *
   * `status: CLEAR` therefore means "not blocked for THIS reason", never "approval
   * will succeed".
   */
  approvalBlocks: PlatformAccessCarePlanApprovalBlocks;
  approvedAt?: Maybe<Scalars['DateTime']['output']>;
  approvedBy?: Maybe<Scalars['String']['output']>;
  /**
   * Current server-owned baseline approval blockers for a DRAFT, using the same
   * accepted OAP evidence checks enforced at approval. An empty list does not
   * bypass other approval guards. Non-DRAFT artifacts return an empty list and
   * are not revalidated. Queue and history reads batch the report lookup.
   */
  baselineApprovalBlockedReasons: Array<Scalars['String']['output']>;
  /**
   * Care team from the generation INPUT BUNDLE, not from contentJson.
   *
   * contentJson.careTeam is LLM output; the validator checks each emitted member
   * against the bundle but never requires the list to be complete, so a valid
   * document can silently omit a clinician. This field is the source snapshot the
   * plan was generated from — and it is the only place NPI is available, since
   * NPI deliberately does not round-trip through the model.
   */
  careTeam: Array<PlatformAccessCarePlanCareTeamMember>;
  contentJson: Scalars['JSON']['output'];
  generatedAt: Scalars['DateTime']['output'];
  /** 'care-plan-generation-pipeline' | 'np-edit' — version provenance. */
  generatedBy: Scalars['String']['output'];
  /**
   * Readable explanations of stored generation-validation failures, not a live
   * approval gate. Server-owned messages omit raw clinical issue details. Empty
   * when validationPassed is true, including Healthie filing-only attention.
   * Failed legacy rows without usable issues receive a generic explanation.
   */
  generationValidationMessages: Array<Scalars['String']['output']>;
  healthieUserId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  langfuseTraceId?: Maybe<Scalars['String']['output']>;
  /** Frozen NP-only medication context; null on legacy plans. Not part of the outgoing Care Update. */
  medicationReview?: Maybe<PlatformAccessCarePlanMedicationReview>;
  renderedMarkdown: Scalars['String']['output'];
  requiresAttention: Scalars['Boolean']['output'];
  schemaVersion: Scalars['Int']['output'];
  /**
   * Source provenance behind the plan's clinical values, projected from the
   * generation input bundle. This is what makes the review drawer's "Most Recent"
   * column and its per-value source attribution resolvable at all — `contentJson`
   * carries neither.
   */
  sourceProvenance: PlatformAccessCarePlanSourceProvenance;
  status: PlatformAccessCarePlanStatus;
  track: PlatformAccessTrack;
  validationPassed: Scalars['Boolean']['output'];
  version: Scalars['Int']['output'];
};

/**
 * One advisory finding on a care plan: a defect the reviewer cannot resolve on
 * this draft.
 *
 * Today the only rule is `track-precedence-conflict` — the enrollment is aligned
 * on eCKM while its own diagnoses carry a code CMS scores as CKM, and CKM takes
 * precedence, so the document was generated against the wrong required-measure set
 * and payment track. Regeneration cannot clear it (it is re-derived from the
 * enrollment on every run); only a CMS unalignment/realignment can. That is why it
 * must not block EDITING, and why it must block APPROVAL — approval is permanent.
 */
export type PlatformAccessCarePlanAdvisory = {
  __typename?: 'AccessCarePlanAdvisory';
  /** Track the enrollment is currently aligned on. */
  assignedTrack: PlatformAccessTrack;
  /** Normalized ICD-10 code(s) that triggered the advisory. */
  codes: Array<Scalars['String']['output']>;
  /** Reviewer-facing explanation, safe to render verbatim. */
  detail: Scalars['String']['output'];
  /** Track those codes imply under ACCESS precedence. */
  impliedTrack: PlatformAccessTrack;
  /** Stable machine id for the finding, e.g. 'track-precedence-conflict'. */
  rule: Scalars['String']['output'];
};

/**
 * One reason `approveAccessCarePlan` refuses this plan, with the finding it
 * enforces. Safe to render as-is: `message` names the actual remedy, which for a
 * track conflict is an upstream CMS unalignment/realignment — never a
 * regeneration, which cannot clear it.
 */
export type PlatformAccessCarePlanApprovalBlock = {
  __typename?: 'AccessCarePlanApprovalBlock';
  /**
   * The advisory this block enforces — the same object that appears in
   * `advisories` once the plan is regenerated with advisory persistence, so the
   * banner a reviewer reads and the refusal they hit are one finding. Present here
   * even when `advisories` is empty, which is the case this field exists for.
   */
  advisory: PlatformAccessCarePlanAdvisory;
  /** Reviewer-facing explanation of the block and its remedy, safe to render verbatim. */
  message: Scalars['String']['output'];
  /**
   * Stable machine id for the refusal, e.g. 'unresolved-track-precedence-conflict'
   * — a string rather than an enum for the same reason
   * `AccessCarePlanAdvisory.rule` is, and matching the reason the mutation's error
   * message names.
   */
  reason: Scalars['String']['output'];
};

export enum PlatformAccessCarePlanApprovalBlockStatus {
  /** At least one block was raised; `blocks` says which, and why. */
  Blocked = 'BLOCKED',
  /**
   * Every input the guard reads was present in the plan's snapshot, and the guard
   * raised no track-precedence block. Returned ONLY in that case, and it is the
   * ONLY status under which `approveAccessCarePlan` proceeds past this guard —
   * same derivation, same column. Still not a promise that approval succeeds; the
   * mutation's other guards apply. See the scope note on
   * `AccessCarePlan.approvalBlocks`.
   */
  Clear = 'CLEAR',
  /**
   * Undetermined: the guard could not be run over this plan's generation
   * snapshot, so no block could be derived. Either the plan carries no snapshot at
   * all, or the snapshot holds a malformed track, alignment code or diagnosis row
   * — a value the guard cannot evaluate as stored.
   *
   * NOT APPROVABLE, and enforced as such. `approveAccessCarePlan` runs this same
   * derivation and refuses this status outright, naming the reason
   * `unevaluable-inputs-snapshot`. Do not read this as CLEAR.
   *
   * WITHOUT EXCEPTION, INCLUDING THE WHOLLY ABSENT SNAPSHOT. The mutation runs
   * this derivation before it narrows the column for anything of its own, so no
   * earlier guard can intercept a plan carrying no snapshot and refuse it under a
   * different, unnamed message. Every INDETERMINATE shape reaches one refusal
   * path and carries this reason and this reviewer copy.
   *
   * A DIFFERENT PROBLEM FROM `BLOCKED`, WITH A DIFFERENT REMEDY. `BLOCKED` is a
   * wrong-track enrollment, cleared upstream by a CMS unalignment/realignment.
   * This is a data defect in the stored plan: no realignment clears it and no
   * narrative edit clears it. Surface it as "cannot be verified — engineering
   * follow-up", not as a clinical or alignment finding, and do not offer Approve.
   */
  Indeterminate = 'INDETERMINATE'
}

/**
 * Result of running the approve mutation's track-precedence guard against a care
 * plan's own immutable generation snapshot. `approveAccessCarePlan` runs THIS
 * derivation, so agreement holds in both directions: this never reports `CLEAR`
 * where the mutation refuses for this class, and the mutation never approves a
 * plan this reports as `BLOCKED` or `INDETERMINATE`. See
 * `AccessCarePlan.approvalBlocks` for the scope this does and does not cover.
 */
export type PlatformAccessCarePlanApprovalBlocks = {
  __typename?: 'AccessCarePlanApprovalBlocks';
  /** Non-empty exactly when `status` is BLOCKED. */
  blocks: Array<PlatformAccessCarePlanApprovalBlock>;
  /**
   * BRANCH ON THIS, never on `blocks` being empty. An empty list is also what
   * INDETERMINATE returns, and an INDETERMINATE plan is NOT approvable.
   */
  status: PlatformAccessCarePlanApprovalBlockStatus;
};

/**
 * One identified care-team member, as captured in the plan's input bundle.
 * Source-owned: never LLM-generated, so NPI here cannot be fabricated.
 */
export type PlatformAccessCarePlanCareTeamMember = {
  __typename?: 'AccessCarePlanCareTeamMember';
  name: Scalars['String']['output'];
  npi?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  /** True once the patient confirmed this member. */
  verified: Scalars['Boolean']['output'];
};

/**
 * A row of the Care Update's Baseline Clinical Measures table.
 *
 * The five track measures match `contentJson.baselineAndGoals[].measure`. HEIGHT
 * and BMI deliberately do NOT: the track config folds BMI into WEIGHT
 * ("Weight / BMI") and has no height measure, so the LLM emits no baseline row
 * for either and neither is part of the validator's contract. The renderer prints
 * both anyway (BSE-3491), so both are explained here.
 */
export enum PlatformAccessCarePlanMeasure {
  /**
   * Body mass index — normally DERIVED from the selected weight and the standing
   * height rather than read from a record, so that the PCP can reconcile it
   * against the two rows printed above it. See `mostRecent.derivation`.
   */
  Bmi = 'BMI',
  Bp = 'BP',
  EgfrUacr = 'EGFR_UACR',
  Hba1C = 'HBA1C',
  /**
   * Standing height. Undated: the bundle carries exactly one, from the Healthie
   * profile rather than a dated metric entry, which is why the Care Update prints
   * the same value in the Baseline and the Most Recent column.
   */
  Height = 'HEIGHT',
  LdlC = 'LDL_C',
  Weight = 'WEIGHT'
}

export type PlatformAccessCarePlanMedicationReview = {
  __typename?: 'AccessCarePlanMedicationReview';
  /** Source-dated history from the 12 months before generation; not verified current use. */
  history: Array<PlatformAccessCarePlanMedicationReviewItem>;
  historyAvailable: Scalars['Boolean']['output'];
  /** Local program GLP prescriptions used by the outgoing document, without a recency cutoff. */
  programPrescriptions: Array<PlatformAccessCarePlanMedicationReviewItem>;
  undatedHistoryCount: Scalars['Int']['output'];
};

export type PlatformAccessCarePlanMedicationReviewItem = {
  __typename?: 'AccessCarePlanMedicationReviewItem';
  dosage?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** Original prescription/authored/asserted date; never an ingestion timestamp. */
  recordedAt?: Maybe<Scalars['String']['output']>;
  source: Scalars['String']['output'];
  /** Source status, not a clinical determination of current use. */
  status?: Maybe<Scalars['String']['output']>;
};

/**
 * How a derived reading was computed, and from what.
 *
 * A BMI on the Care Update is not a measurement — the renderer calculates it from
 * the weight and the height printed directly above it (BSE-3491) so the receiving
 * clinician can check the three rows against each other. Publishing that value
 * with a source system and a collection date would present arithmetic as an
 * observation. Publishing the INPUTS instead keeps the chain checkable: each input
 * is a full reading, with its own system, record id and collection date.
 */
export type PlatformAccessCarePlanSourceDerivation = {
  __typename?: 'AccessCarePlanSourceDerivation';
  /** The computation in words, e.g. 'BMI = weight (kg) / height (m)²'. */
  formula: Scalars['String']['output'];
  /** The readings the value was computed from, in formula order. */
  inputs: Array<PlatformAccessCarePlanSourceReading>;
};

/**
 * One coded diagnosis behind the plan.
 *
 * Normally a row captured in the input bundle from clinical_records. One case is
 * not: when `enrollment.finalIcd10Code` — the ICD-10 submitted to CMS for
 * alignment, and the code the document's primary problem must equal — has no
 * bundle diagnosis behind it, it is projected here with `sourceSystem`
 * ACCESS_ENROLLMENT. `validateCarePlanDocument` explicitly permits that
 * sparse / referral-confirmed path, so without this row the diagnosis the whole
 * Care Update rests on would have no provenance at all.
 *
 * That row carries nulls for `system`, `display` and `recordedAt` because the
 * enrollment holds none of them; in particular `enrollment.alignmentDate` is when
 * CMS aligned the patient, not when a diagnosis was recorded, and is deliberately
 * not reported as one.
 *
 * Carries no `sourceRecordId`: bundle diagnoses hold a provenance label only. See
 * the note on AccessCarePlanSourceProvenance.
 */
export type PlatformAccessCarePlanSourceDiagnosis = {
  __typename?: 'AccessCarePlanSourceDiagnosis';
  code: Scalars['String']['output'];
  display?: Maybe<Scalars['String']['output']>;
  /** When the diagnosis was RECORDED at the source; null when the source carried none. */
  recordedAt?: Maybe<Scalars['DateTime']['output']>;
  sourceSystem: PlatformAccessCarePlanSourceSystem;
  /** Code system as the source reported it; null when the snapshot omitted it. */
  system?: Maybe<Scalars['String']['output']>;
};

/** One care-plan measure with the source readings behind it. */
export type PlatformAccessCarePlanSourceMeasure = {
  __typename?: 'AccessCarePlanSourceMeasure';
  measure: PlatformAccessCarePlanMeasure;
  /**
   * The reading the Care Update reports in its "Most Recent" column, or null when
   * the bundle carries none for this measure. Selected by the same code the fax
   * renderer uses, so the review drawer and the faxed Care Update cannot disagree
   * about which reading is current.
   */
  mostRecent?: Maybe<PlatformAccessCarePlanSourceReading>;
  /**
   * Every source reading for this measure in the bundle, most recent first. The
   * "Most Recent" value alone is not checkable without seeing which records were
   * available and which one was selected.
   *
   * WEIGHT lists body-weight readings only — the LOINC group also contains BMI,
   * and a BMI is not a body weight; those rows are listed under BMI.
   *
   * Three rows' `mostRecent` need not appear verbatim in this list. BP: a paired
   * Zus readout is assembled from a systolic and a diastolic row, both listed
   * here individually because those are the records a reviewer opens. BMI: the
   * selected value is normally derived and names its inputs on `derivation`,
   * while this list holds the BMI-coded rows the bundle carries — including the
   * ones the derivation did not use. HEIGHT: the transmitted value is the
   * standing profile height, so any height-coded measurement rows are listed
   * unselected, where a disagreement with the profile is visible.
   */
  readings: Array<PlatformAccessCarePlanSourceReading>;
};

/**
 * Where every clinical value in a care plan came from: a projection of the
 * generation input-bundle snapshot (`AccessCarePlan.inputBundleJson`).
 *
 * Source-owned end to end — nothing in this type or its children round-trips
 * through the model, so no value here can be fabricated. It is the reviewer's
 * audit path: `contentJson` is LLM output with no source identity on it, so
 * without this a clinician is checking generated text against generated text.
 *
 * A PROJECTION, not the snapshot. The snapshot is an internal replay artifact
 * whose shape follows the generation pipeline (prompt, track and validator
 * revisions live alongside the clinical bundle); publishing it verbatim would put
 * an unversioned blob on the supergraph.
 *
 * EVERY VALUE THE CARE UPDATE TRANSMITS IS COVERED. That includes the two rows
 * the renderer adds under Weight — a code-owned Height and a DERIVED BMI — which
 * are not track measures and so have no `baselineAndGoals` entry. A transmitted
 * clinical value this type cannot explain is the gap the ticket exists to close.
 *
 * TWO FIELDS ARE ABSENT UPSTREAM AND ARE THEREFORE NOT MODELLED HERE: a
 * measurement/assay `method` (does not exist on measurements or diagnoses
 * anywhere in clinical_records or the Zus Observation selection set), and a
 * source record id on DIAGNOSES (bundle diagnoses carry a provenance label only).
 * No nullable placeholder is published for either — a field that always resolves
 * to null reads as "the source had none" and would let a reviewer believe a
 * record was checked when nothing was ever captured. Tracked on BSE-3504.
 */
export type PlatformAccessCarePlanSourceProvenance = {
  __typename?: 'AccessCarePlanSourceProvenance';
  /**
   * Coded diagnoses the plan was generated from, as captured in the bundle —
   * plus, when no bundle diagnosis backs it, the enrollment's final alignment
   * code (see AccessCarePlanSourceDiagnosis).
   */
  diagnoses: Array<PlatformAccessCarePlanSourceDiagnosis>;
  /**
   * One entry per row of the Care Update's Baseline Clinical Measures table,
   * always all seven, in report order: the five track measures plus HEIGHT and
   * BMI. A row the bundle carries no reading for is an explicit empty slot.
   */
  measures: Array<PlatformAccessCarePlanSourceMeasure>;
};

/**
 * One source reading behind a care-plan measure. `sourceSystem`,
 * `sourceRecordId` and `collectedAt` are the fields that make the value checkable
 * against the originating record.
 */
export type PlatformAccessCarePlanSourceReading = {
  __typename?: 'AccessCarePlanSourceReading';
  /** LOINC code, or null for a reading that carries none (device vitals, composites). */
  code?: Maybe<Scalars['String']['output']>;
  /**
   * When the SOURCE collected the reading — not when we ingested it. Null when
   * the source carried no usable timestamp; never substituted with the generation
   * time, because a fabricated collection date is what would make an unverifiable
   * value look verified.
   */
  collectedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Set ONLY on a reading that was computed rather than read from a source record
   * — today, the derived BMI. Null on every measured reading, and that difference
   * is the point: a derived value has no record to open, so it publishes what it
   * was computed from instead of a record id and a collection date it does not
   * have.
   */
  derivation?: Maybe<PlatformAccessCarePlanSourceDerivation>;
  /** The reading as the Care Update renders it — e.g. '7.4 %', '152/88 mm Hg'. */
  displayValue: Scalars['String']['output'];
  /**
   * Source record identity. For a flattened FHIR Observation panel this is the
   * observation's root id, so a composite reading points at the one record it came
   * from. Null for sources the bundle carries no resource id for — including
   * Healthie interim vitals, whose metric-entry id the bundle does not retain.
   */
  sourceRecordId?: Maybe<Scalars['String']['output']>;
  sourceSystem: PlatformAccessCarePlanSourceSystem;
  /** Unit as the SOURCE carried it, which is not always the display unit. */
  unit?: Maybe<Scalars['String']['output']>;
  /** Single numeric value; null for a text-only or composite reading. */
  value?: Maybe<Scalars['Float']['output']>;
  /** Verbatim source text when the source reported the value as text. */
  valueText?: Maybe<Scalars['String']['output']>;
};

/**
 * Producing system for one source value, from the input bundle's provenance
 * label.
 */
export enum PlatformAccessCarePlanSourceSystem {
  /**
   * The ACCESS enrollment record itself — the diagnosis submitted to CMS for
   * alignment, confirmed by a PCP referral or a manual document review. Used only
   * where that code has no clinical_records diagnosis behind it, so the reviewer
   * is pointed at the record that genuinely carries it instead of at Zus.
   */
  AccessEnrollment = 'ACCESS_ENROLLMENT',
  /**
   * Not a producing system: the value was computed here, from the readings in
   * `AccessCarePlanSourceReading.derivation`. There is no record to open, and this
   * member exists so a computed value can never be read as a measured one.
   */
  Derived = 'DERIVED',
  /** Connected device or in-app entry, via a Healthie metric entry. */
  HealthieMetric = 'HEALTHIE_METRIC',
  /**
   * A provenance label this build does not recognise. Reported rather than
   * dropped: the reading's value, date and record id are still source-owned and
   * still checkable, and silently omitting a reading from an audit list is worse
   * than naming its system imprecisely.
   */
  Other = 'OTHER',
  /** Electronic Zus sync. */
  Zus = 'ZUS',
  /** Lab transcribed by an authorized reviewer from a Zus document. */
  ZusManualDocumentReview = 'ZUS_MANUAL_DOCUMENT_REVIEW'
}

export enum PlatformAccessCarePlanStatus {
  Approved = 'APPROVED',
  Draft = 'DRAFT',
  Superseded = 'SUPERSEDED'
}

/** An approved filed version for Admin's fax job. A skip reason prohibits sending. */
export type PlatformAccessCareUpdateFax = {
  __typename?: 'AccessCareUpdateFax';
  carePlanId: Scalars['ID']['output'];
  faxNumber?: Maybe<Scalars['String']['output']>;
  healthieDocumentId: Scalars['ID']['output'];
  healthieUserId: Scalars['ID']['output'];
  recipientName?: Maybe<Scalars['String']['output']>;
  recipientNpi?: Maybe<Scalars['String']['output']>;
  skipReason?: Maybe<Scalars['String']['output']>;
  version: Scalars['Int']['output'];
};

export enum PlatformAccessCareUpdateFaxOutcome {
  Skipped = 'SKIPPED',
  Submitted = 'SUBMITTED',
  Unknown = 'UNKNOWN'
}

/** One ICD-10 diagnosis currently available from clinical-records. */
export type PlatformAccessClinicalDiagnosis = {
  __typename?: 'AccessClinicalDiagnosis';
  /** When the source recorded the diagnosis, if known. */
  diagnosedAt?: Maybe<Scalars['DateTime']['output']>;
  icd10Code: Scalars['String']['output'];
  /** Where this diagnosis came from (Zus sync vs. manual referral entry). */
  source: PlatformAccessClinicalSource;
};

/** Measure types surfaced read-only on the ACCESS Alignment review detail. */
export enum PlatformAccessClinicalMeasureType {
  BloodPressureSystolic = 'BLOOD_PRESSURE_SYSTOLIC',
  Bmi = 'BMI',
  Egfr = 'EGFR',
  Hba1C = 'HBA1C',
  LdlC = 'LDL_C',
  Uacr = 'UACR'
}

/** One fixed measure slot for ACCESS review (latest value, or nulls when missing). */
export type PlatformAccessClinicalMeasurement = {
  __typename?: 'AccessClinicalMeasurement';
  /** Qualifier for the surfaced numeric boundary; null when the slot is empty. */
  comparator?: Maybe<PlatformAccessLabComparator>;
  /** Clinical qualifier when the value is questionable (e.g. a uACR from a non-urinary specimen); null when unqualified. Persists across reloads — not just the write response. */
  flag?: Maybe<Scalars['String']['output']>;
  measureType: PlatformAccessClinicalMeasureType;
  measuredAt?: Maybe<Scalars['DateTime']['output']>;
  /** Provenance of the surfaced value; null when the slot is empty or Healthie-derived. */
  source?: Maybe<PlatformAccessClinicalSource>;
  value?: Maybe<Scalars['Float']['output']>;
};

/**
 * Provenance of a clinical-records value surfaced on ACCESS review: electronic
 * Zus sync, reviewed Zus document, or referral transcription.
 */
export enum PlatformAccessClinicalSource {
  Referral = 'REFERRAL',
  Zus = 'ZUS',
  ZusManualDocumentReview = 'ZUS_MANUAL_DOCUMENT_REVIEW'
}

/** Specimen a uACR (or its albumin/creatinine components) was measured from. */
export enum PlatformAccessClinicalSpecimen {
  Serum = 'SERUM',
  Unknown = 'UNKNOWN',
  Urine = 'URINE'
}

export type PlatformAccessDiagnosisCatalog = {
  __typename?: 'AccessDiagnosisCatalog';
  canonicalSourceUrl: Scalars['String']['output'];
  options: Array<PlatformAccessDiagnosisOption>;
  retrievalSourceUrl: Scalars['String']['output'];
  retrievedAt: Scalars['String']['output'];
  track: PlatformAccessTrack;
  version: Scalars['String']['output'];
};

export type PlatformAccessDiagnosisOption = {
  __typename?: 'AccessDiagnosisOption';
  code: Scalars['String']['output'];
  display: Scalars['String']['output'];
};

export type PlatformAccessEligibilityAddressInput = {
  state: Scalars['String']['input'];
};

export type PlatformAccessEligibilityLegalNameInput = {
  first: Scalars['String']['input'];
  last: Scalars['String']['input'];
};

export type PlatformAccessEligibilityPatientInput = {
  address?: InputMaybe<PlatformAccessEligibilityAddressInput>;
  administrativeGender: Scalars['String']['input'];
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  legalName: PlatformAccessEligibilityLegalNameInput;
};

export type PlatformAccessEnrollment = {
  __typename?: 'AccessEnrollment';
  candidateTrack: PlatformAccessTrack;
  createdAt: Scalars['DateTime']['output'];
  finalIcd10Code?: Maybe<Scalars['String']['output']>;
  finalTrack?: Maybe<PlatformAccessTrack>;
  healthieUserId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  patientId?: Maybe<Scalars['ID']['output']>;
  patientRecord?: Maybe<PlatformPatient>;
  status: PlatformAccessEnrollmentStatus;
  updatedAt: Scalars['DateTime']['output'];
};

/**
 * The patient's versioned consent acceptance, submitted WITH the enrollment so it
 * is persisted in the same transaction as the enrollment row.
 *
 * Both signup surfaces previously kept this only in their own funnel state and
 * appended it after the enrollment call returned, so any post-commit failure kept
 * the enrollment and destroyed the compliance record. Optional on the wire only
 * so a caller that has not been migrated still enrolls; a null consent is a gap
 * to be closed, not a supported mode.
 */
export type PlatformAccessEnrollmentConsentInput = {
  acceptedAt: Scalars['DateTime']['input'];
  /**
   * Underlying CMS / informed-consent item ids accepted — NOT the (fewer) visible
   * checkbox ids, so the trail covers every disclosure a collapsed checkbox rolls up.
   */
  acceptedItemIds: Array<Scalars['String']['input']>;
  /** Copy/item-set version string, owned by the submitting surface. */
  version: Scalars['String']['input'];
};

/** Which identifier an `accessEnrollmentLookup` query resolved through. */
export enum PlatformAccessEnrollmentLookupMatchedBy {
  AccessEnrollmentId = 'ACCESS_ENROLLMENT_ID',
  CmsSubmissionId = 'CMS_SUBMISSION_ID',
  HealthieUserId = 'HEALTHIE_USER_ID'
}

/**
 * One resolved lookup. Exactly one of two shapes: a hit (`matchedBy` +
 * `enrollment` set, `ambiguous` false) or an ambiguous CMS submission uuid
 * (`ambiguous` true, both nullable fields null). A uuid that names more than one
 * enrollment is never resolved to either — ops must escalate, not guess. A query
 * that matches nothing returns null rather than this type.
 */
export type PlatformAccessEnrollmentLookupResult = {
  __typename?: 'AccessEnrollmentLookupResult';
  /** True when the CMS submission uuid names more than one distinct enrollment. */
  ambiguous: Scalars['Boolean']['output'];
  enrollment?: Maybe<PlatformAccessEnrollmentSummary>;
  matchedBy?: Maybe<PlatformAccessEnrollmentLookupMatchedBy>;
};

export enum PlatformAccessEnrollmentStatus {
  Aligned = 'ALIGNED',
  AlignedSuccessfullySwitched = 'ALIGNED_SUCCESSFULLY_SWITCHED',
  AlignmentPending = 'ALIGNMENT_PENDING',
  AwaitingRejection = 'AWAITING_REJECTION',
  EligibilityPending = 'ELIGIBILITY_PENDING',
  FailedAlignment = 'FAILED_ALIGNMENT',
  FailedEligibility = 'FAILED_ELIGIBILITY',
  NeedsReview = 'NEEDS_REVIEW',
  NoStateAvailable = 'NO_STATE_AVAILABLE',
  PcpReferralPending = 'PCP_REFERRAL_PENDING',
  /** CMS un-aligned the beneficiary after a successful $align (recorded out of band). Terminal, inactive. */
  UnalignedByCms = 'UNALIGNED_BY_CMS'
}

/** Patient-facing enrollment summary — no PII beyond the Healthie user id. */
export type PlatformAccessEnrollmentSummary = {
  __typename?: 'AccessEnrollmentSummary';
  adminReferralCorrelationKey?: Maybe<Scalars['String']['output']>;
  /** Set exactly once on a successful alignment transition; null if never aligned. */
  alignmentDate?: Maybe<Scalars['DateTime']['output']>;
  candidateTrack?: Maybe<PlatformAccessTrack>;
  /**
   * When ops recorded this Healthie user's request to stop participating; null
   * when they have not opted out. The opt-out is the patient's, so it is reported
   * whichever of their enrollments it was recorded from.
   */
  commsOptedOutAt?: Maybe<Scalars['DateTime']['output']>;
  /** When this enrollment was created (the patient's ACCESS signup). Never changes. */
  createdAt: Scalars['DateTime']['output'];
  finalTrack?: Maybe<PlatformAccessTrack>;
  healthieUserId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  status: PlatformAccessEnrollmentStatus;
};

export type PlatformAccessFailedAlignmentCorrectionContext = {
  __typename?: 'AccessFailedAlignmentCorrectionContext';
  alignmentRecommendation: PlatformAccessAlignmentRecommendation;
  failedAttempt: PlatformAccessAlignmentAttempt;
  referralEvidence: PlatformAccessReferralEpisodeEvidence;
};

export enum PlatformAccessLabComparator {
  Eq = 'EQ',
  Gt = 'GT',
  Gte = 'GTE',
  Lt = 'LT',
  Lte = 'LTE'
}

export enum PlatformAccessLdlMethod {
  Calculated = 'CALCULATED',
  Direct = 'DIRECT'
}

/**
 * The submitted member id is actively enrolled under a different patient — a
 * data-quality conflict needing human review. Permanent for the submitting
 * patient (do not retry) and never presented as "already enrolled".
 */
export type PlatformAccessMemberIdConflict = {
  __typename?: 'AccessMemberIdConflict';
  memberId: Scalars['String']['output'];
};

/**
 * One row of an NP's review queue: an aligned enrollment assigned to them, with
 * patient display facts (MBI last-4 only — never the full member id) and the
 * latest care-plan version (any status).
 */
export type PlatformAccessNpReviewQueueItem = {
  __typename?: 'AccessNpReviewQueueItem';
  accessEnrollmentId: Scalars['ID']['output'];
  alignmentDate?: Maybe<Scalars['DateTime']['output']>;
  /** Exact durable acceptance time of the current successful baseline OAP report. */
  baselineOapSubmissionCompletedAt?: Maybe<Scalars['DateTime']['output']>;
  healthieUserId: Scalars['ID']['output'];
  latestCarePlan?: Maybe<PlatformAccessCarePlan>;
  memberIdLast4: Scalars['String']['output'];
  patientDateOfBirth?: Maybe<Scalars['String']['output']>;
  patientLegalFirstName: Scalars['String']['output'];
  patientLegalLastName: Scalars['String']['output'];
  patientState?: Maybe<Scalars['String']['output']>;
  track: PlatformAccessTrack;
};

/** Result of a baseline OAP bundle preview (generation only, no CMS submission). */
export type PlatformAccessOapBundlePreview = {
  __typename?: 'AccessOapBundlePreview';
  accessEnrollmentId: Scalars['ID']['output'];
  /** The generated FHIR access-data-reporting-bundle document (raw JSON). */
  bundle: Scalars['JSON']['output'];
  memberId: Scalars['String']['output'];
  missingMeasures: Array<Scalars['String']['output']>;
  presentMeasures: Array<Scalars['String']['output']>;
  reportType: Scalars['String']['output'];
  track: PlatformAccessTrack;
};

export enum PlatformAccessOnboardingOutcome {
  AlreadyEnrolled = 'ALREADY_ENROLLED',
  Enrolled = 'ENROLLED',
  Failed = 'FAILED',
  Hold = 'HOLD',
  NoState = 'NO_STATE',
  Processing = 'PROCESSING'
}

export type PlatformAccessPageInfo = {
  __typename?: 'AccessPageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
};

export type PlatformAccessPatientSummary = {
  __typename?: 'AccessPatientSummary';
  administrativeGender: Scalars['String']['output'];
  dateOfBirth?: Maybe<Scalars['String']['output']>;
  legalFirstName: Scalars['String']['output'];
  legalLastName: Scalars['String']['output'];
  state?: Maybe<Scalars['String']['output']>;
};

export type PlatformAccessPostAlignmentQueueConnection = {
  __typename?: 'AccessPostAlignmentQueueConnection';
  nodes: Array<PlatformAccessPostAlignmentQueueNode>;
  pageInfo: PlatformAccessPageInfo;
};

export type PlatformAccessPostAlignmentQueueInput = {
  /**
   * When true, return only rows whose `billable` is true. Applied in the
   * database (not to the fetched page), so pagination stays correct.
   */
  billableOnly?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<PlatformAccessPostAlignmentQueuePageInput>;
};

export type PlatformAccessPostAlignmentQueueNode = {
  __typename?: 'AccessPostAlignmentQueueNode';
  accessEnrollmentId: Scalars['ID']['output'];
  /** When the latest ALIGN attempt completed (resultReceivedAt) or was submitted. */
  alignmentAttemptAt?: Maybe<Scalars['DateTime']['output']>;
  alignmentDate?: Maybe<Scalars['DateTime']['output']>;
  /** Healthie provider id of the NP assigned to this enrollment. */
  assignedNpProviderId?: Maybe<Scalars['String']['output']>;
  /**
   * The current report's CMS `$report-data` result code, restricted to the codes
   * this repo documents. Any code we do not recognize collapses to
   * `unrecognized`, so no CMS-authored bytes are rendered. Null when there is no
   * current report or CMS has returned no code yet.
   */
  baselineOapCmsResultCode?: Maybe<Scalars['String']['output']>;
  /**
   * Server-derived baseline submission deadline: alignment date plus the
   * baseline submission window. Null until the enrollment has an alignment date.
   */
  baselineOapDueAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * When the sweep last attempted baseline generation for this enrollment,
   * whether it succeeded or refused. Null until the sweep has looked at it.
   */
  baselineOapLastEvaluatedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * The last reason the automatic sweep refused to generate a baseline bundle
   * for this enrollment: an `AccessBaselineBundleErrorCode` (e.g.
   * `INSUFFICIENT_DATA`) or `UNCHANGED_BUNDLE_AFTER_REJECTION` when the bundle
   * still matches a rejected report. Null when the sweep has never refused,
   * and null once a current report exists — it supersedes any earlier refusal.
   */
  baselineOapLastRefusalCode?: Maybe<Scalars['String']['output']>;
  /**
   * The measure categories named by that last refusal. Empty whenever
   * `baselineOapLastRefusalCode` is null or the refusal named no measures.
   */
  baselineOapMissingMeasures: Array<PlatformAccessBaselineOapMeasureCategory>;
  /**
   * Status of the enrollment's CURRENT baseline OAP report
   * (`currentOapReportId`). Null when the enrollment has no current report.
   */
  baselineOapReportStatus?: Maybe<PlatformAccessBaselineOapReportStatus>;
  /**
   * Exact durable CMS acceptance time of the current successful baseline OAP
   * report. Null until `$report-data` succeeds with result `success`. Not derived
   * from alignmentDate or care-plan generation.
   */
  baselineOapSubmissionCompletedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Ready to bill: the enrollment is in ALIGNED or ALIGNED_SUCCESSFULLY_SWITCHED,
   * is active, and `baselineOapSubmissionCompletedAt` is non-null. That last term
   * is the source of truth for CMS acceptance — see
   * `baselineOapSubmissionCompletedAt()` in `src/cms/baseline-oap-completion.ts`.
   * This flag encodes no other CMS claim rules.
   */
  billable: Scalars['Boolean']['output'];
  /**
   * Which of the `billable` terms this row fails, empty when `billable` is true.
   * Derived from the same evaluation as `billable`, so the two can never
   * disagree; a row is billable exactly when this list is empty.
   */
  billableBlockedReasons: Array<PlatformAccessBillableBlockedReason>;
  candidateTrack: PlatformAccessTrack;
  /**
   * When the obligation was met: the fax's occurrence time for SENT and
   * ATTEMPTED, the recorded delivery time for DELIVERED_EXTERNALLY (or when it
   * was recorded), and the record time for NOT_REQUIRED. Null exactly when
   * careInitiationDeliveryStatus is null.
   */
  careInitiationDeliveredAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * How the Care Initiation Update to the PCP was delivered (BSE-3948). The
   * earliest event that met the obligation wins. Null while it is still due, so
   * the countdown applies.
   */
  careInitiationDeliveryStatus?: Maybe<PlatformAccessCareInitiationDeliveryStatus>;
  cmsResultCode?: Maybe<Scalars['String']['output']>;
  cmsResultText?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /**
   * ICD-10 that goes on the claim (enrollment.finalIcd10Code). Same column as
   * `submittedIcd10Code`, exposed under the claim-facing name.
   */
  finalIcd10Code?: Maybe<Scalars['String']['output']>;
  finalTrack?: Maybe<PlatformAccessTrack>;
  healthieUserId: Scalars['ID']['output'];
  /**
   * Whether this enrollment is still active. One of the three `billable` terms,
   * exposed because a row can otherwise read as ALIGNED with an accepted baseline
   * and still be non-billable with nothing on screen to explain it.
   */
  isActive: Scalars['Boolean']['output'];
  /** Medicare Beneficiary Identifier (enrollment.memberId). */
  memberId: Scalars['String']['output'];
  status: PlatformAccessEnrollmentStatus;
  /** ICD-10 submitted for alignment (enrollment.finalIcd10Code). */
  submittedIcd10Code?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type PlatformAccessPostAlignmentQueuePageInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type PlatformAccessProviderReferralInput = {
  evidenceUrl?: InputMaybe<Scalars['String']['input']>;
  patientReferralId?: InputMaybe<Scalars['ID']['input']>;
  required: Scalars['Boolean']['input'];
};

export enum PlatformAccessRecommendationDecision {
  No = 'NO',
  Yes = 'YES'
}

/** Confirmed diagnosis evidence used by the recommendation evaluator. */
export type PlatformAccessRecommendationDiagnosisEvidence = {
  __typename?: 'AccessRecommendationDiagnosisEvidence';
  diagnosedAt?: Maybe<Scalars['DateTime']['output']>;
  icd10Code: Scalars['String']['output'];
  source: PlatformAccessClinicalSource;
};

export type PlatformAccessRecommendationEvidence = {
  __typename?: 'AccessRecommendationEvidence';
  diagnoses: Array<PlatformAccessRecommendationDiagnosisEvidence>;
  measurements: Array<PlatformAccessRecommendationMeasurementEvidence>;
  referralPresent: Scalars['Boolean']['output'];
};

export enum PlatformAccessRecommendationEvidenceSource {
  Healthie = 'HEALTHIE',
  Referral = 'REFERRAL',
  Zus = 'ZUS',
  ZusManualDocumentReview = 'ZUS_MANUAL_DOCUMENT_REVIEW'
}

/** Normalized measurement evidence; rule thresholds remain server-owned. */
export type PlatformAccessRecommendationMeasurementEvidence = {
  __typename?: 'AccessRecommendationMeasurementEvidence';
  comparator?: Maybe<PlatformAccessLabComparator>;
  measureType: PlatformAccessClinicalMeasureType;
  measuredAt?: Maybe<Scalars['DateTime']['output']>;
  offTarget?: Maybe<Scalars['Boolean']['output']>;
  source?: Maybe<PlatformAccessRecommendationEvidenceSource>;
  status: PlatformAccessRecommendationMeasurementStatus;
  unit?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export enum PlatformAccessRecommendationMeasurementStatus {
  AmbiguousBound = 'AMBIGUOUS_BOUND',
  FutureDated = 'FUTURE_DATED',
  Missing = 'MISSING',
  OutOfRange = 'OUT_OF_RANGE',
  ReadFailed = 'READ_FAILED',
  Stale = 'STALE',
  Undated = 'UNDATED',
  UnsupportedUnit = 'UNSUPPORTED_UNIT',
  Usable = 'USABLE'
}

/** One server-owned explanation, already ordered for reviewer display. */
export type PlatformAccessRecommendationReason = {
  __typename?: 'AccessRecommendationReason';
  code: Scalars['String']['output'];
  measureType?: Maybe<PlatformAccessClinicalMeasureType>;
  message: Scalars['String']['output'];
  track?: Maybe<PlatformAccessTrack>;
};

export enum PlatformAccessRecommendationStatus {
  Available = 'AVAILABLE',
  Unavailable = 'UNAVAILABLE'
}

/** A non-fatal advisory raised while recording referral clinical data. */
export type PlatformAccessReferralClinicalWarning = {
  __typename?: 'AccessReferralClinicalWarning';
  /** The measure the warning relates to, when applicable. */
  measureType?: Maybe<PlatformAccessClinicalMeasureType>;
  message: Scalars['String']['output'];
};

export type PlatformAccessReferralContext = {
  __typename?: 'AccessReferralContext';
  evidenceUrl?: Maybe<Scalars['String']['output']>;
  latestOutcome?: Maybe<PlatformAccessReferralOutcome>;
  patientReferralId?: Maybe<Scalars['ID']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type PlatformAccessReferralEpisodeDiagnosis = {
  __typename?: 'AccessReferralEpisodeDiagnosis';
  diagnosedAt?: Maybe<Scalars['DateTime']['output']>;
  icd10Code: Scalars['String']['output'];
};

export type PlatformAccessReferralEpisodeEvidence = {
  __typename?: 'AccessReferralEpisodeEvidence';
  correlationKey: Scalars['String']['output'];
  diagnoses: Array<PlatformAccessReferralEpisodeDiagnosis>;
  handoffId: Scalars['ID']['output'];
  measurements: Array<PlatformAccessReferralEpisodeMeasurement>;
};

export type PlatformAccessReferralEpisodeMeasurement = {
  __typename?: 'AccessReferralEpisodeMeasurement';
  measureType: PlatformAccessClinicalMeasureType;
  measuredAt?: Maybe<Scalars['DateTime']['output']>;
  value: Scalars['Float']['output'];
};

export type PlatformAccessReferralEvidenceInput = {
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  receivedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export enum PlatformAccessReferralOutcome {
  DiagnosisNotCovered = 'DIAGNOSIS_NOT_COVERED',
  Received = 'RECEIVED',
  Rejected = 'REJECTED',
  UnableToObtain = 'UNABLE_TO_OBTAIN'
}

export type PlatformAccessRejectionQueueConnection = {
  __typename?: 'AccessRejectionQueueConnection';
  nodes: Array<PlatformAccessRejectionQueueNode>;
  pageInfo: PlatformAccessPageInfo;
};

export type PlatformAccessRejectionQueueInput = {
  page?: InputMaybe<PlatformAccessRejectionQueuePageInput>;
};

export type PlatformAccessRejectionQueueNode = {
  __typename?: 'AccessRejectionQueueNode';
  accessEnrollmentId: Scalars['ID']['output'];
  candidateTrack: PlatformAccessTrack;
  createdAt: Scalars['DateTime']['output'];
  finalTrack?: Maybe<PlatformAccessTrack>;
  healthieUserId: Scalars['ID']['output'];
  status: PlatformAccessEnrollmentStatus;
  updatedAt: Scalars['DateTime']['output'];
};

export type PlatformAccessRejectionQueuePageInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

/** Result of a submitAccessRequest mutation. */
export type PlatformAccessRequest = {
  __typename?: 'AccessRequest';
  /** The approver referenced on the created ticket(s): the requester's override when supplied, otherwise the service's default. Null when neither is set. */
  approver?: Maybe<PlatformApprover>;
  parent: PlatformLinearTicketRef;
  serviceId: PlatformServiceId;
  subTickets: Array<PlatformLinearTicketRef>;
  submittedByEmail: Scalars['String']['output'];
};

export enum PlatformAccessReviewAction {
  RejectNotAlignable = 'REJECT_NOT_ALIGNABLE',
  RequestEligibilityRerun = 'REQUEST_ELIGIBILITY_RERUN',
  RequestReferral = 'REQUEST_REFERRAL',
  SaveFinalDiagnosis = 'SAVE_FINAL_DIAGNOSIS'
}

export enum PlatformAccessTrack {
  Ckm = 'CKM',
  Eckm = 'ECKM'
}

/** One albumin or creatinine component reading for uACR computation. */
export type PlatformAccessUacrComponentInput = {
  /** Concentration unit, e.g. mg/dL, mg/L, g/L, g/dL (creatinine also accepts mmol/L). */
  unit: Scalars['String']['input'];
  value: Scalars['Float']['input'];
};

/**
 * uACR from its lab components. The albumin/creatinine ratio is computed and both
 * components are stored as their own measurement rows. A non-URINE specimen is
 * accepted but flagged (uACR is defined for urine).
 */
export type PlatformAccessUacrComponentsInput = {
  albumin: PlatformAccessUacrComponentInput;
  creatinine: PlatformAccessUacrComponentInput;
  /** Defaults to URINE. Anything else is stored but flagged as a warning. */
  specimen?: InputMaybe<PlatformAccessClinicalSpecimen>;
};

/**
 * An in-progress or already-approved PA already exists for this patient, program,
 * and product/SKU. No new row or Develop case was created.
 */
export type PlatformActivePriorAuthorizationConflict = {
  __typename?: 'ActivePriorAuthorizationConflict';
  /** Patient-facing drug label for the conflict copy. */
  drugName: Scalars['String']['output'];
  existingPriorAuthorization: PlatformPriorAuthorization;
  reason: PlatformActivePriorAuthorizationConflictReason;
};

/**
 * Why a second PA for the same patient + program + product/SKU was refused
 * when forceSubmit was omitted or false.
 * `IN_PROGRESS` is any local PENDING row. `ALREADY_APPROVED` is COMPLETE with
 * outcome APPROVED. `expirationDate` is not consulted, so a lapsed approval
 * still conflicts unless forceSubmit is true. Terminal denial, cancellation,
 * failure, not-submitted, and COMPLETE + OTHER do not conflict.
 */
export enum PlatformActivePriorAuthorizationConflictReason {
  AlreadyApproved = 'ALREADY_APPROVED',
  InProgress = 'IN_PROGRESS'
}

/** An activity journal entry logged by a patient, capturing exercise/movement data. */
export type PlatformActivityJournalEntry = PlatformJournalEntryBase & {
  __typename?: 'ActivityJournalEntry';
  /** Comments */
  comments: Array<PlatformEntryComment>;
  /** When the entry was created */
  createdAt: Scalars['DateTime']['output'];
  /** User ID of creator */
  createdBy: Scalars['String']['output'];
  /** Optional description */
  description?: Maybe<Scalars['String']['output']>;
  /** Unique identifier */
  id: Scalars['ID']['output'];
  /** The device or app integration that wrote the entry, such as 'apple_health', 'google_fit' or 'fitbit'. Null when the entry was logged by hand or its source isn't known, and on the entry createJournalEntry and updateJournalEntry return, which don't read it. */
  thirdPartySource?: Maybe<Scalars['String']['output']>;
  /** IANA timezone identifier */
  timezone?: Maybe<Scalars['String']['output']>;
  /** Unit of measurement */
  unit: Scalars['String']['output'];
  /** Activity duration or metric value */
  value?: Maybe<Scalars['Float']['output']>;
};

export type PlatformAddHealthieStripeCardInput = {
  /** Card type label. Options: 'personal' (default), 'hsa', 'fsa'. */
  cardTypeLabel?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  /** Stripe token from the frontend card tokenization */
  token: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};

export type PlatformAddHealthieStripeCardResponse = {
  __typename?: 'AddHealthieStripeCardResponse';
  card?: Maybe<PlatformHealthieStripeCard>;
  messages: Array<PlatformHealthieMessage>;
  /** Stripe-level error string, if any */
  stripeError?: Maybe<Scalars['String']['output']>;
};

/**
 * Input for adding an additional (non-primary) provider to a patient's Healthie
 * care team.
 */
export type PlatformAddPatientAdditionalProviderInput = {
  /** Internal patient registry id */
  patientId: Scalars['ID']['input'];
  /** Canonical provider-registry id of the provider to add. Resolved to the provider's Healthie id internally. A no-op if this provider is already the patient's primary provider or already an additional provider. */
  providerId: Scalars['ID']['input'];
  /**
   * Turn the observed silent-drop case into a failed mutation instead of a
   * warning. Healthie can accept `updateClient` and return an
   * `other_provider_ids` that omits the requested provider; by default that is
   * logged and non-blocking, because the booking commit this normally runs inside
   * must not fail on it. Opt in when the caller records DURABLE state on the
   * strength of this write, cannot afford a false success, AND has nothing left to
   * do with the result — the exception replaces the `Patient`, so it also costs the
   * caller `healthieCareTeamProviderIds` and anything it would have done between
   * this call and its own decision. ACCESS chart provisioning is the worked example
   * of the other choice: it stamps `chart_provisioned_at`, which permanently
   * removes the enrollment from its repair sweep, and it still sends `false`,
   * because it has an independent Healthie tag write to land before it decides and
   * it reads the echo itself. The already-primary / already-a-member early return
   * is a confirmed success and is never affected by this flag.
   *
   * Defence in depth, not the caller's only evidence. A caller must not depend on
   * the deployed API honouring this flag — during a rolling deploy it may not be
   * the same build — so select `Patient.healthieCareTeamProviderIds` on the result
   * and decide from that. This flag then only changes whether an unconfirmed write
   * arrives as a thrown error or as a normal result the caller reads.
   */
  requireCareTeamConfirmation?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Address information for subscriber or dependent */
export type PlatformAddress = {
  __typename?: 'Address';
  /** Street address line 1 */
  address1?: Maybe<Scalars['String']['output']>;
  /** Street address line 2 */
  address2?: Maybe<Scalars['String']['output']>;
  /** City */
  city?: Maybe<Scalars['String']['output']>;
  /** 5 or 9-digit ZIP code */
  postalCode?: Maybe<Scalars['String']['output']>;
  /** Two-letter state code (e.g. NY, CA) */
  state?: Maybe<Scalars['String']['output']>;
};

/**
 * A reference agenda item belonging to a session step.
 * Seed data — frontend maps `key` to display content.
 */
export type PlatformAgendaItem = {
  __typename?: 'AgendaItem';
  /** Default display order within step + type group */
  defaultOrdinal: Scalars['Int']['output'];
  /** Default session number (1–12) — template assignment */
  defaultStep: Scalars['Int']['output'];
  /** Unique identifier */
  id: Scalars['ID']['output'];
  /** Stable key for frontend content mapping */
  key: Scalars['String']['output'];
  /** Supplementary data (resource URLs, prompt text, etc.) */
  metadata?: Maybe<Scalars['JSON']['output']>;
  /** Type of agenda item */
  type: PlatformAgendaItemType;
};

/** Type of agenda item within a session */
export enum PlatformAgendaItemType {
  FocusPoint = 'FOCUS_POINT',
  ReflectionPrompt = 'REFLECTION_PROMPT',
  Resource = 'RESOURCE'
}

/** Why a record id was not upserted by `syncProvidersFromAirtable`. */
export enum PlatformAirtableSyncSkipReason {
  /** The row exists but failed the completeness gate (see `failedFields`). */
  IncompleteRow = 'INCOMPLETE_ROW',
  /** The supplied id is not a well-formed Airtable record id (`rec…`). */
  InvalidRecordId = 'INVALID_RECORD_ID',
  /** No row with this id exists on the Airtable Records API. */
  RecordNotFound = 'RECORD_NOT_FOUND',
  /** The row passed the gate but the registry upsert threw. */
  UpsertFailed = 'UPSERT_FAILED'
}

/**
 * One allergy or intolerance record. Statuses are verbatim, so an unconfirmed, refuted or resolved
 * record is never presented as a confirmed allergy.
 */
export type PlatformAllergyIntolerance = {
  __typename?: 'AllergyIntolerance';
  absentFromSourceAt?: Maybe<Scalars['DateTime']['output']>;
  /** Any of food, medication, environment, biologic. */
  categories: Array<Scalars['String']['output']>;
  clinicalStatus?: Maybe<Scalars['String']['output']>;
  /** RxNorm, else SNOMED, else the first other coding. Null for text-only records. */
  code?: Maybe<Scalars['String']['output']>;
  /** low, high or unable-to-assess. */
  criticality?: Maybe<Scalars['String']['output']>;
  display?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastOccurrenceAt?: Maybe<Scalars['DateTime']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  onsetAt?: Maybe<Scalars['DateTime']['output']>;
  reactions: Array<PlatformAllergyReaction>;
  source: Scalars['String']['output'];
  /** When the source recorded it (FHIR recordedDate). Not a clinical date. */
  sourceRecordedAt?: Maybe<Scalars['DateTime']['output']>;
  sourceResourceId: Scalars['String']['output'];
  /** rxnorm, snomed, the coding's system URI, or text. */
  system: Scalars['String']['output'];
  /** allergy or intolerance. */
  type?: Maybe<Scalars['String']['output']>;
  verificationStatus?: Maybe<Scalars['String']['output']>;
};

/** One reaction on an allergy record. */
export type PlatformAllergyReaction = {
  __typename?: 'AllergyReaction';
  description?: Maybe<Scalars['String']['output']>;
  manifestations: Array<PlatformClinicalCoding>;
  /** Onset as the source sent it. Kept as text because sources send partial dates. */
  onset?: Maybe<Scalars['String']['output']>;
  /** mild, moderate or severe. */
  severity?: Maybe<Scalars['String']['output']>;
  substance?: Maybe<PlatformClinicalCoding>;
};

/**
 * The patient's existing upcoming initial GLP-1 consultation — what the
 * ALREADY_SCHEDULED terminal renders (GLPX-241). Snapshotted from the booking
 * step submission the double-booking guard stamped, not re-fetched from Healthie.
 * The provider is surfaced here (unlike the booked screen) because the patient
 * scheduled this visit in a prior session and the prescriber grounds the
 * "you already scheduled" message.
 */
export type PlatformAlreadyScheduledAppointment = {
  __typename?: 'AlreadyScheduledAppointment';
  /** ISO 8601 start time (UTC) of the existing consult. */
  appointmentTime: Scalars['DateTime']['output'];
  /** Prescriber display name, when available; null otherwise. */
  providerName?: Maybe<Scalars['String']['output']>;
};

/** A serving-size measure surfaced by Nutritionix (e.g. {measure: 'tbsp', qty: 1, servingWeight: 21}). */
export type PlatformAltMeasure = {
  __typename?: 'AltMeasure';
  /** Human-readable measure name (e.g. 'tbsp', 'cup', 'piece'). */
  measure: Scalars['String']['output'];
  /** Quantity of the measure (e.g. 1 for one tbsp). */
  qty: Scalars['Float']['output'];
  /** Display sequence ordering from Nutritionix. Null when the source measure has no ordering recorded. */
  seq?: Maybe<Scalars['Int']['output']>;
  /** Grams represented by `qty` of this measure (Nutritionix's serving_weight). */
  servingWeight: Scalars['Float']['output'];
};

export type PlatformApplyHealthieTagsResponse = {
  __typename?: 'ApplyHealthieTagsResponse';
  messages: Array<PlatformHealthieMessage>;
  tags: Array<PlatformHealthieTag>;
};

export type PlatformAppointmentAvailabilityInput = {
  appointmentType: PlatformAppointmentType;
  excludeAppointmentHealthieIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  extraBusyIntervals?: InputMaybe<Array<PlatformPatientExtraBusyIntervalInput>>;
  patientHealthieId?: InputMaybe<Scalars['ID']['input']>;
  /** Exactly one patient id may be supplied. Null leaves slots patient-agnostic. */
  patientId?: InputMaybe<Scalars['ID']['input']>;
  /** Canonical provider-registry ids. Callers supply their own eligible set; this domain applies no matching policy. */
  providerIds: Array<Scalars['ID']['input']>;
  /**
   * Whether this session is allowed sub-24-hour booking — a trusted boolean
   * the calling program domain resolves from its own authorization policy
   * and passes through, like `sessionId`. This domain has no opinion on how
   * that policy is decided. Null and false are identical: fail closed.
   *
   * Minimum-notice enforcement applies only to appointment types whose
   * catalog entry carries the notice policy (the MNT types; the GLP-1 types
   * are deliberately time-first and never notice-filtered). For enforced
   * types, a provider's floor is `Provider.profile.minimumNoticeMinutes`
   * (null → 1440, including providers unknown to provider-matching). Not
   * allowed, the floor is additionally clamped to at least 1440, so only an
   * allowed session ever sees a same-day opt-in's sub-24-hour slots; a floor
   * at or above 1440 applies as-is either way. Slots inside the effective
   * floor are excluded from the result, exactly like held slots.
   */
  sameDayBookingAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  /** The requesting session, if any. Slots that overlap another session's hold are excluded whether or not this is set; passing it additionally exempts this session's own holds from that exclusion, so a caller re-reading availability to commit its own held slot still sees it. */
  sessionId?: InputMaybe<Scalars['ID']['input']>;
  /** Inclusive bounds on slot start time. Null returns the full warmed window. `start` after `end` is an error, not an empty result. */
  window?: InputMaybe<PlatformAvailabilityWindowInput>;
};

export type PlatformAppointmentAvailabilitySlot = {
  __typename?: 'AppointmentAvailabilitySlot';
  startTime: Scalars['DateTime']['output'];
};

export type PlatformAppointmentBooked = {
  __typename?: 'AppointmentBooked';
  /** Healthie appointment id — the only durable handle on the appointment; this domain persists no booking table. */
  appointmentHealthieId: Scalars['ID']['output'];
  /** The instant actually booked. Under `flexibility` it may differ from the requested `startTime`. */
  appointmentTime: Scalars['DateTime']['output'];
};

/** The fee's current state: SUCCEEDED, FAILED (see failureCode), or PENDING while the outcome is not known. */
export type PlatformAppointmentFeeCharged = {
  __typename?: 'AppointmentFeeCharged';
  operation: PlatformPaymentOperation;
};

export enum PlatformAppointmentFeeType {
  LateCancel = 'LATE_CANCEL',
  LateReschedule = 'LATE_RESCHEDULE',
  NoShow = 'NO_SHOW'
}

/**
 * An advisory, Redis-backed hold on one provider's time slot for one
 * (sessionId, appointmentType) pair. It is a soft lock: it reserves nothing in
 * Healthie, and Healthie's own availability enforcement remains the final
 * authority at booking time. What it does do is exclusivity between sessions --
 * while a hold is live, `appointmentAvailability` hides every slot whose
 * interval overlaps `[startTime, startTime + this appointment type's duration)`
 * from every other session, across every appointment type that provider can be
 * booked for (a hold is on the provider's time, not on one visit type -- e.g. a
 * 30-minute GLP1_INITIAL_CONSULT hold at 3:00pm also hides that provider's
 * 3:15pm GLP1_FOLLOW_UP slot, not just an exact 3:00pm one). This reduces
 * same-slot collisions between concurrently browsing sessions; it does not
 * guarantee they cannot occur, and a lapsed hold is not an error condition
 * anywhere in this API.
 */
export type PlatformAppointmentHold = {
  __typename?: 'AppointmentHold';
  appointmentType: PlatformAppointmentType;
  /** Authoritative expiry, computed server-side at write time. A UI renders its countdown from this rather than guessing a duration. */
  expiresAt: Scalars['DateTime']['output'];
  /** Canonical provider-registry id, matching ProviderAvailability.providerId. */
  providerId: Scalars['ID']['output'];
  startTime: Scalars['DateTime']['output'];
};

export type PlatformAppointmentNotFoundError = {
  __typename?: 'AppointmentNotFoundError';
  appointmentHealthieId: Scalars['ID']['output'];
  message: Scalars['String']['output'];
};

/** The patient's existing or pending appointment overlaps the requested slot. Nothing was written. */
export type PlatformAppointmentPatientScheduleConflictError = {
  __typename?: 'AppointmentPatientScheduleConflictError';
  conflictingEndTime: Scalars['DateTime']['output'];
  conflictingStartTime: Scalars['DateTime']['output'];
  message: Scalars['String']['output'];
  requestedStartTime: Scalars['DateTime']['output'];
};

/**
 * The slot was not bookable — Healthie's `enforce_availability` rejected it, or
 * under `flexibility` no slot in the window was free. Nothing was written.
 */
export type PlatformAppointmentSlotUnavailableError = {
  __typename?: 'AppointmentSlotUnavailableError';
  /** Human-readable summary, safe to surface to the patient. */
  message: Scalars['String']['output'];
  /** The requested target instant, echoed back so a caller placing several appointments knows which one failed. */
  requestedStartTime: Scalars['DateTime']['output'];
};

/**
 * What Healthie records about whether the visit happened. Orthogonal to time: a
 * `SCHEDULED` appointment whose time has passed simply has no outcome recorded
 * yet, and is not evidence the visit occurred.
 *
 * The members below are Healthie's five default outcomes plus the unset case.
 * Healthie types the underlying `pm_status` as a free string, not an enum,
 * because an organisation may define custom statuses on top of the defaults
 * (`AppointmentSetting.pm_statuses`). Berry Street defines none today, so
 * `UNKNOWN` should never be returned in practice — it exists so that a custom
 * status added later, or a spelling change in the defaults, surfaces as
 * indeterminate instead of being silently read as something benign. A caller
 * asking "does this patient hold a visit that blocks rebooking" should request
 * `[SCHEDULED, UNKNOWN]` and fail closed.
 */
export enum PlatformAppointmentStatus {
  Cancelled = 'CANCELLED',
  LateCancellation = 'LATE_CANCELLATION',
  NoShow = 'NO_SHOW',
  Occurred = 'OCCURRED',
  Rescheduled = 'RESCHEDULED',
  /** Booked, with no outcome recorded — Healthie's `pm_status` is unset. */
  Scheduled = 'SCHEDULED',
  /** A `pm_status` outside Healthie's five defaults. Indeterminate, not benign. */
  Unknown = 'UNKNOWN'
}

export type PlatformAppointmentStatusChanged = {
  __typename?: 'AppointmentStatusChanged';
  appointmentHealthieId: Scalars['ID']['output'];
  /** Only cancellations confirmed during this invocation, in ascending visit order. */
  cancelledFutureAppointmentHealthieIds: Array<Scalars['ID']['output']>;
  /** Whether the selected appointment, requested status, and initiating actor qualify for future cancellation, even if none are found. */
  cascadeEligible: Scalars['Boolean']['output'];
  status: Scalars['TerminationAppointmentStatusChange']['output'];
};

/**
 * A bookable visit. The code — not a Healthie appointment-type id, and not a
 * free-form slug — is the unit every scheduling operation is keyed on. Adding a
 * program means adding a code and its catalog entry.
 */
export enum PlatformAppointmentType {
  Glp1FollowUp = 'GLP1_FOLLOW_UP',
  Glp1InitialConsult = 'GLP1_INITIAL_CONSULT',
  MntFollowUp = 'MNT_FOLLOW_UP',
  MntInitialVisit = 'MNT_INITIAL_VISIT'
}

export type PlatformAppointmentWindowInput = {
  /** Inclusive upper bound. Null is unbounded into the future. */
  end?: InputMaybe<Scalars['DateTime']['input']>;
  /** Inclusive lower bound. Null is unbounded into the past. */
  start?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PlatformApproveAccessCarePlanInput = {
  /** NP identifier from the review surface (persisted on the plan + audit event). */
  approvedBy: Scalars['String']['input'];
  carePlanId: Scalars['ID']['input'];
};

/**
 * The person accountable for a service's access grants. Rendered on every Linear
 * ticket the request opens (an "Approver" row in the body plus a `{{approver}}`
 * template token) and, when `email` matches a Linear user, added to that ticket
 * as a subscriber. Reference only — nothing blocks on their sign-off.
 */
export type PlatformApprover = {
  __typename?: 'Approver';
  /**
   * Work email. Drives the Linear subscriber lookup and the mailto link.
   * Optional: a name-only approver still renders on the ticket but isn't
   * subscribed.
   */
  email?: Maybe<Scalars['String']['output']>;
  /** Display name shown on the ticket, e.g. "Cooper Schmitz". */
  name: Scalars['String']['output'];
};

export type PlatformAssignAccessNpInput = {
  accessEnrollmentId: Scalars['ID']['input'];
  /** Who performed the assignment (ops/admin identifier, persisted to audit). */
  assignedBy: Scalars['String']['input'];
  /** Healthie provider id of the NP; null unassigns. */
  npProviderId?: InputMaybe<Scalars['String']['input']>;
};

export type PlatformAssignAccessNpPayload = {
  __typename?: 'AssignAccessNpPayload';
  accessEnrollmentId: Scalars['ID']['output'];
  assignedNpProviderId?: Maybe<Scalars['String']['output']>;
};

export type PlatformAssignDietitianInput = {
  /** Canonical patient-registry id. */
  patientId: Scalars['ID']['input'];
  /** Canonical provider-registry id of a dietitian the caller has already selected as eligible. */
  providerId: Scalars['ID']['input'];
};

export type PlatformAssignDietitianPayload = {
  __typename?: 'AssignDietitianPayload';
  /** The dietitian assignment now in effect. */
  assignment: PlatformProviderAssignment;
};

export type PlatformAssignMedicareBridgeCaseInput = {
  assignedUserId: Scalars['ID']['input'];
  /** Replaces the ops note when sent. Omit to leave the current note. */
  blockerNote?: InputMaybe<Scalars['String']['input']>;
  caseId: Scalars['ID']['input'];
  /** Retries with the same key write nothing further. */
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  /** Required. Stored on the ledger. */
  reason: Scalars['String']['input'];
};

export type PlatformAssignMedicareBridgeCasePayload = {
  __typename?: 'AssignMedicareBridgeCasePayload';
  medicareBridgeCase: PlatformMedicareBridgeCase;
};

export type PlatformAssignPrescriberInput = {
  /** Canonical patient-registry id. */
  patientId: Scalars['ID']['input'];
  /** Canonical provider-registry id of a prescriber the caller has already selected as eligible. */
  providerId: Scalars['ID']['input'];
};

export type PlatformAssignPrescriberPayload = {
  __typename?: 'AssignPrescriberPayload';
  /** The prescriber assignment now in effect. */
  assignment: PlatformProviderAssignment;
};

/**
 * A document assigned to the signed-in provider, with attestation state against
 * the current published version. Viewer-scoped — not an entity.
 */
export type PlatformAssignedProviderDocument = {
  __typename?: 'AssignedProviderDocument';
  /** When the current version was attested; null while PENDING */
  attestedAt?: Maybe<Scalars['DateTime']['output']>;
  document: PlatformProviderDocument;
  status: PlatformAttestationStatus;
};

export type PlatformAttachInsuranceCardImagesInput = {
  /** Back of the card. At least one of `cardFront` / `cardBack` must be supplied. */
  cardBack?: InputMaybe<PlatformInsuranceCardImageInput>;
  /** Front of the card. At least one of `cardFront` / `cardBack` must be supplied. */
  cardFront?: InputMaybe<PlatformInsuranceCardImageInput>;
  /** Canonical patient-registry id. */
  patientId: Scalars['ID']['input'];
};

export type PlatformAttachInsuranceCardImagesPayload = {
  __typename?: 'AttachInsuranceCardImagesPayload';
  /** True when the images were written to the policy. */
  attached: Scalars['Boolean']['output'];
  /** Set when `attached` is false. These are terminal business outcomes a retry cannot fix — callers advance past them. Transient Healthie failures surface as mutation errors instead, so the client can retry without losing patient-captured photos. */
  skippedReason?: Maybe<PlatformInsuranceCardAttachSkipReason>;
};

/** Input for attaching an insurance policy to a patient's Healthie chart. */
export type PlatformAttachInsurancePolicyInput = {
  /** Subscriber group number, when known */
  groupNumber?: InputMaybe<Scalars['String']['input']>;
  /** Policyholder's date of birth. The patient's own DOB when the policy holder is SELF (the default). */
  holderDateOfBirth?: InputMaybe<Scalars['String']['input']>;
  /** Policyholder's relationship to the patient. Defaults to SELF when omitted. */
  holderRelationship?: InputMaybe<PlatformPolicyHolderRelationship>;
  /** Healthie InsurancePlan id for the patient's payer */
  insurancePlanId: Scalars['String']['input'];
  /** Subscriber member id */
  memberId: Scalars['String']['input'];
  /** Internal patient registry id */
  patientId: Scalars['ID']['input'];
};

export type PlatformAttachInsurancePolicyPayload = {
  __typename?: 'AttachInsurancePolicyPayload';
  /** True when the policy was written to (or already matched) the Healthie chart. */
  attached: Scalars['Boolean']['output'];
  /** Set when `attached` is false. This mutation never throws — every failure mode, including a Healthie-side error, surfaces here instead. */
  skippedReason?: Maybe<PlatformInsurancePolicyAttachSkipReason>;
};

export type PlatformAttestDocumentVersionInput = {
  /** Version ID from ProviderDocument.currentVersion. Attestation binds to this exact version. */
  versionId: Scalars['ID']['input'];
};

export type PlatformAttestDocumentVersionResult = PlatformAttestationRecorded | PlatformDocumentVersionSupersededError;

/** A prior attestation by the signed-in provider, including superseded versions. */
export type PlatformAttestationHistoryItem = {
  __typename?: 'AttestationHistoryItem';
  attestedAt: Scalars['DateTime']['output'];
  documentId: Scalars['ID']['output'];
  documentTitle: Scalars['String']['output'];
  versionId: Scalars['ID']['output'];
  versionLabel: Scalars['String']['output'];
};

/** An immutable attestation record for the signed-in provider. */
export type PlatformAttestationRecorded = {
  __typename?: 'AttestationRecorded';
  /** True when an existing immutable attestation was returned unchanged */
  alreadyAttested: Scalars['Boolean']['output'];
  /** Server timestamp of the original attestation — unchanged on duplicate attest */
  attestedAt: Scalars['DateTime']['output'];
  documentId: Scalars['ID']['output'];
  versionId: Scalars['ID']['output'];
  versionLabel: Scalars['String']['output'];
};

/** Whether the signed-in provider has attested to the current published version. */
export enum PlatformAttestationStatus {
  Completed = 'COMPLETED',
  Pending = 'PENDING'
}

/**
 * Authorization details returned when an automatic decision is found.
 * Contains Berry Street's pre-configured authorization rules for the plan.
 */
export type PlatformAuthorizationDetails = {
  __typename?: 'AuthorizationDetails';
  /** Calendar year deductible amount */
  calendarYearDeductible?: Maybe<Scalars['Float']['output']>;
  /** Coinsurance percentage (0-100) */
  coinsurance?: Maybe<Scalars['Float']['output']>;
  /** Copay amount in dollars */
  copay?: Maybe<Scalars['Float']['output']>;
  /** Default number of authorized visits */
  defaultVisits?: Maybe<Scalars['Int']['output']>;
  /** List of authorized diagnostic codes */
  diagnosticCodes?: Maybe<Array<Scalars['String']['output']>>;
  /** Additional notes about the decision */
  notes?: Maybe<Scalars['String']['output']>;
  /** Whether telemedicine is authorized */
  telemedicineAuthorized?: Maybe<Scalars['Boolean']['output']>;
};

/** Automatic benefits decision from Airtable */
export enum PlatformAutomaticBenefitsDecision {
  /** Benefits are automatically confirmed */
  Confirm = 'CONFIRM',
  /** Benefits are automatically rejected */
  Reject = 'REJECT',
  /** No automatic decision found in Airtable */
  Unknown = 'UNKNOWN'
}

/**
 * Input for automatic benefits decision lookup.
 * Assumes coverage is active - use eligibilityCheck query first if status is unknown.
 */
export type PlatformAutomaticBenefitsDecisionInput = {
  /** Payer ID */
  payerId: Scalars['String']['input'];
  /** Specific plan name */
  planName: Scalars['String']['input'];
  /** Insurance plan type */
  planType: PlatformInsuranceType;
};

/** Automatic benefits decision response from Airtable */
export type PlatformAutomaticBenefitsDecisionResponse = {
  __typename?: 'AutomaticBenefitsDecisionResponse';
  /** Authorization details (only present when decision is CONFIRM or REJECT) */
  authorizationDetails?: Maybe<PlatformAuthorizationDetails>;
  /** The automatic benefits decision from Airtable, or UNKNOWN if not found */
  decision: PlatformAutomaticBenefitsDecision;
  /** Response type categorizing the payer/plan */
  responseType: PlatformBenefitsCheckResponseType;
};

/**
 * Why the appointment picker has slots — or, when it doesn't, which empty
 * outcome the patient hit. Lets the client branch its empty-state copy instead
 * of collapsing every empty result into a single "check back soon" message.
 * Mirrors the outcome the service already records for observability.
 */
export enum PlatformAvailabilityOutcome {
  /** Matched providers currently have no open slots (supply gap). `slots` is empty; more may open up soon. */
  NoAvailability = 'NO_AVAILABILITY',
  /** No provider covers the patient's state/payer (coverage gap). `slots` is empty; checking back won't help, since we're not available there yet. */
  NoMatchedProviders = 'NO_MATCHED_PROVIDERS',
  /** Matched providers have open slots — `slots` is non-empty. */
  Ok = 'OK'
}

export type PlatformAvailabilityRange = {
  __typename?: 'AvailabilityRange';
  end: Scalars['DateTime']['output'];
  start: Scalars['DateTime']['output'];
};

/** An inclusive range of instants. */
export type PlatformAvailabilityRangeInput = {
  end: Scalars['DateTime']['input'];
  start: Scalars['DateTime']['input'];
};

/**
 * The appointment picker's resolved availability: the open slots plus the
 * `outcome` that explains an empty result. Fetched by the APPOINTMENT_PICKER
 * dynamic step in place of the bare `availableSlots` list, so the client can
 * branch its empty-state copy on `outcome` (a coverage gap is not the same as a
 * transient supply gap).
 */
export type PlatformAvailabilityResult = {
  __typename?: 'AvailabilityResult';
  /** Why `slots` is (or isn't) empty. */
  outcome: PlatformAvailabilityOutcome;
  /**
   * The prescribers the patient can choose between, in display order, at most
   * five. Prescribers with an opening come first, in assignment-rank order (the
   * in-network tier, then the booking override, then the assignment score, with
   * nurse practitioner, open-slot count and provider id breaking ties). When only
   * one or two have an opening, eligible prescribers without one fill the list
   * to five in the same rank order. When none or three or more have an opening,
   * no prescriber without one is listed. Never includes a prescriber who is not
   * eligible for this session's state and payer. Empty when the session is not
   * offered a prescriber choice, for NO_MATCHED_PROVIDERS, and when none has an
   * opening. The same whatever `providerId` is.
   */
  prescribers: Array<PlatformPrescriberOption>;
  /**
   * The times this session can book, deduped and ascending. With `providerId`,
   * only that displayed prescriber's times; empty when they are not among
   * `prescribers`. Without it, the times of every prescriber the session can
   * book with: the displayed prescribers when the session is offered a choice,
   * every surfaced prescriber otherwise. Empty for NO_MATCHED_PROVIDERS and
   * NO_AVAILABILITY. A failed schedule lookup is an error, never an empty list.
   */
  slots: Array<PlatformAvailabilitySlot>;
};

/** An open appointment time the patient can pick. */
export type PlatformAvailabilitySlot = {
  __typename?: 'AvailabilitySlot';
  /** ISO 8601 start time (UTC). */
  startTime: Scalars['DateTime']['output'];
};

export type PlatformAvailabilityWindowInput = {
  end: Scalars['DateTime']['input'];
  start: Scalars['DateTime']['input'];
};

export type PlatformBackfillMarketingSmsOptInsInput = {
  /** Sends only when true; false returns the counts and sends nothing. */
  apply?: Scalars['Boolean']['input'];
  /** Emails to skip, compared case-insensitively. */
  excludeEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Caps how many eligible leads this call sends; null sends all. */
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type PlatformBackfillMarketingSmsOptInsPayload = {
  __typename?: 'BackfillMarketingSmsOptInsPayload';
  dryRun: Scalars['Boolean']['output'];
  /** Leads left after the skips: what an apply run sends, before `limit`. */
  eligible: Scalars['Int']['output'];
  /** Leads whose latest phone step opted in. */
  optedIn: Scalars['Int']['output'];
  /** Identifies sent; 0 on a dry run. */
  sent: Scalars['Int']['output'];
  /** Opted-in leads skipped because a session of theirs saved a booking confirm. */
  skippedConfirmed: Scalars['Int']['output'];
  /** Opted-in leads skipped because their session later switched to another email. */
  skippedEmailChanged: Scalars['Int']['output'];
  skippedExcluded: Scalars['Int']['output'];
  skippedInvalidPhone: Scalars['Int']['output'];
};

/**
 * Cumulative progress for an in-flight backfill — sourced from the
 * `getBackfillProgress` workflow query, which counts pages and records
 * processed across `continueAsNew` rotations.
 *
 * @shareable across registries: patient and provider both define this
 * identically (it's the wire form of the workflow query's return value).
 * Without @shareable, supergraph composition rejects the duplicate
 * non-shareable object type.
 */
export type PlatformBackfillProgress = {
  __typename?: 'BackfillProgress';
  /**
   * Last `(createdAt, id)` cursor seen by the page walker, JSON-encoded
   * for transport. Null at the start of a run and at completion.
   */
  cursor?: Maybe<Scalars['String']['output']>;
  /** Pages of registry rows processed across all rotations of this run. */
  pagesProcessed: Scalars['Int']['output'];
  /** Records whose sync threw after exhausting activity retries. Non-fatal — the backfill skips past them and continues. */
  totalFailed: Scalars['Int']['output'];
  /** Total records processed (synced + skipped + failed) across all rotations. */
  totalProcessed: Scalars['Int']['output'];
};

/**
 * Lifecycle state of a Navi Health backfill workflow execution, mapped from
 * Temporal's `WorkflowExecutionStatusName`. The "no execution has ever been
 * started" case is signalled via `latestRun: null` on the status query
 * rather than a dedicated enum value — there is no live execution to map.
 *
 * Patient and provider subgraphs declare identical copies; Federation v2
 * auto-merges enums by name across subgraphs.
 */
export enum PlatformBackfillState {
  /** Cancelled via Temporal API (graceful) — not the same as TERMINATED. */
  Cancelled = 'CANCELLED',
  /** Drain loop exited cleanly — every eligible record was enqueued. */
  Completed = 'COMPLETED',
  /**
   * Previous run continued as a new execution; the latest execution carries
   * the live progress. The status mapper returns the latest run's state, so
   * this is exposed for completeness but rarely surfaces.
   */
  ContinuedAsNew = 'CONTINUED_AS_NEW',
  /** Workflow failed unrecoverably. */
  Failed = 'FAILED',
  /** Currently running (includes a workflow that has just `continueAsNew`'d). */
  Running = 'RUNNING',
  /** Terminated by an operator via the registry's cancel mutation. */
  Terminated = 'TERMINATED',
  /** Hit its execution timeout. Should not happen — the workflow continues-as-new. */
  TimedOut = 'TIMED_OUT',
  /** Temporal returned a status we don't have an explicit mapping for. */
  Unknown = 'UNKNOWN'
}

/** A populated base-profile value with its existing capture provenance. */
export type PlatformBaseProfileField = {
  __typename?: 'BaseProfileField';
  confidence?: Maybe<PlatformProfileFieldConfidence>;
  key: PlatformBaseProfileFieldKey;
  provenance?: Maybe<PlatformProfileFieldProvenance>;
  value: Scalars['String']['output'];
};

/**
 * Every prose field stored on the base profile. This is broader than
 * ProfileFieldKey, which intentionally contains only fields writable by Perry's
 * onboarding interview.
 */
export enum PlatformBaseProfileFieldKey {
  Beverages = 'BEVERAGES',
  Constraints = 'CONSTRAINTS',
  CulturalFoodContext = 'CULTURAL_FOOD_CONTEXT',
  EatingDay = 'EATING_DAY',
  FoodEnvironment = 'FOOD_ENVIRONMENT',
  FoodPreferences = 'FOOD_PREFERENCES',
  HealthGoals = 'HEALTH_GOALS',
  Household = 'HOUSEHOLD',
  PastAttempts = 'PAST_ATTEMPTS',
  Schedule = 'SCHEDULE',
  WhatSuccessLooksLike = 'WHAT_SUCCESS_LOOKS_LIKE',
  WhyHere = 'WHY_HERE'
}

export type PlatformBenefitsCheck = {
  __typename?: 'BenefitsCheck';
  appointmentHealthieId: Scalars['ID']['output'];
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  developCaseId?: Maybe<Scalars['String']['output']>;
  diagnoses: Array<PlatformDiagnosis>;
  drugResults: Array<PlatformDrugBenefitsResult>;
  failureCode?: Maybe<Scalars['String']['output']>;
  failureMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  patientCoverageStatus?: Maybe<Scalars['String']['output']>;
  /** medicare | medicare_advantage | tricare | medicaid | other | ... */
  patientCoverageType?: Maybe<Scalars['String']['output']>;
  patientHealthieId: Scalars['ID']['output'];
  /** commercial | government | question_not_asked | unable_to_determine */
  patientPlanFundSource?: Maybe<Scalars['String']['output']>;
  pharmacyBenefitManagerName?: Maybe<Scalars['String']['output']>;
  programType: PlatformProgramType;
  providerHealthieId: Scalars['ID']['output'];
  selectedProducts: Array<PlatformGlp1Product>;
  status: PlatformBenefitsCheckStatus;
  submittedAt: Scalars['DateTime']['output'];
};

/** Benefits check response type indicating the categorization of the payer/plan */
export enum PlatformBenefitsCheckResponseType {
  /** Coverage status could not be determined */
  CoverageStatusMissing = 'COVERAGE_STATUS_MISSING',
  /** EPO plan type */
  EpoPayer = 'EPO_PAYER',
  /** Error occurred during lookup */
  Error = 'ERROR',
  /** Insurance card exists but needs correction in Healthie */
  FixInsuranceCardInHealthie = 'FIX_INSURANCE_CARD_IN_HEALTHIE',
  /** HMO plan type */
  HmoPayer = 'HMO_PAYER',
  /** Hold - referral required before proceeding */
  HoldReferralRequired = 'HOLD_REFERRAL_REQUIRED',
  /** Coverage is inactive */
  InactiveCoverage = 'INACTIVE_COVERAGE',
  /** Known group with automatic decision available */
  KnownGroup = 'KNOWN_GROUP',
  /** Known payer with automatic decision available */
  KnownPayer = 'KNOWN_PAYER',
  /** Medicaid payer */
  MedicaidPayer = 'MEDICAID_PAYER',
  /** Medicare payer */
  MedicarePayer = 'MEDICARE_PAYER',
  /** Requires remote benefit check */
  RemoteBenefitCheck = 'REMOTE_BENEFIT_CHECK',
  /** Request insurance card from patient */
  RequestInsuranceCard = 'REQUEST_INSURANCE_CARD',
  /** Unknown payer without automatic decision */
  UnknownPayer = 'UNKNOWN_PAYER'
}

export enum PlatformBenefitsCheckStatus {
  Cancelled = 'CANCELLED',
  Complete = 'COMPLETE',
  Failed = 'FAILED',
  Pending = 'PENDING'
}

/** An ICD-10 selection made by a provider on an additional-benefits request. */
export type PlatformBenefitsRequestDiagnosisInput = {
  code: Scalars['String']['input'];
  display: Scalars['String']['input'];
};

/** Two-state billability verdict for a specific provider/payer/state/date combination. */
export enum PlatformBillabilityVerdict {
  Billable = 'BILLABLE',
  NotBillable = 'NOT_BILLABLE'
}

/** Filters and paging for a patient's blood-pressure history. */
export type PlatformBloodPressureHistoryInput = {
  from?: InputMaybe<Scalars['DateTime']['input']>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  /** Order ascending for callers that need the first captured reading. */
  oldestFirst?: Scalars['Boolean']['input'];
  patientId: Scalars['ID']['input'];
  to?: InputMaybe<Scalars['DateTime']['input']>;
};

/** A page of canonical blood-pressure readings. */
export type PlatformBloodPressurePage = {
  __typename?: 'BloodPressurePage';
  hasMore: Scalars['Boolean']['output'];
  readings: Array<PlatformBloodPressureReading>;
};

/** A canonical blood-pressure reading. Values are normalized to mm[Hg]. */
export type PlatformBloodPressureReading = {
  __typename?: 'BloodPressureReading';
  /** True only when this call created the canonical pair; false for an exact retry or history result. */
  created: Scalars['Boolean']['output'];
  diastolic: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  /** Measurement time used for history ordering and bounds. */
  measuredAt: Scalars['DateTime']['output'];
  sourceId: Scalars['String']['output'];
  systolic: Scalars['Float']['output'];
  unit: Scalars['String']['output'];
};

/** Unit accepted when recording blood pressure. Values are persisted as mm[Hg]. */
export enum PlatformBloodPressureUnit {
  Kpa = 'KPA',
  Mmhg = 'MMHG'
}

export type PlatformBookAppointmentInput = {
  /** Catalog appointment type; resolves the Healthie appointment type id and contact type. A type with no catalog entry is rejected. */
  appointmentType: PlatformAppointmentType;
  /** Appointments this booking replaces and may ignore. */
  excludeAppointmentHealthieIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Intervals selected in this flow but not yet written to Healthie. */
  extraBusyIntervals?: InputMaybe<Array<PlatformPatientExtraBusyIntervalInput>>;
  /**
   * Optional flexible placement: book the nearest bookable slot within the window
   * around `startTime` instead of the exact instant, preferring the exact instant
   * when it is free. Absent books exactly `startTime`. The search and the create
   * run together inside this mutation — a caller cannot reproduce it by reading
   * `appointmentAvailability` and then booking, because another session can take
   * the chosen slot in between.
   */
  flexibility?: InputMaybe<PlatformSlotFlexibilityInput>;
  /** Canonical patient-registry id; resolved to a Healthie id server-side. */
  patientId: Scalars['ID']['input'];
  /** Canonical provider-registry id; resolved to a Healthie id server-side. */
  providerId: Scalars['ID']['input'];
  /**
   * Same semantics as `AppointmentAvailabilityInput.sameDayBookingAllowed`.
   * A `startTime` inside the effective notice floor returns
   * `AppointmentSlotUnavailableError` with nothing written, and under
   * `flexibility` the search never selects a slot inside the floor. Enforced
   * here as well as at availability, the two surfaces that decide what a
   * patient sees and what actually books — a hold is a soft, advisory lock
   * and deliberately does not re-check this.
   */
  sameDayBookingAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  /** ISO 8601 target start time. */
  startTime: Scalars['DateTime']['input'];
};

/** Successful placement or a recoverable slot conflict. */
export type PlatformBookAppointmentResult = PlatformAppointmentBooked | PlatformAppointmentPatientScheduleConflictError | PlatformAppointmentSlotUnavailableError;

export type PlatformBookGlp1AppointmentInput = {
  /** ISO 8601 appointment start time. */
  appointmentTime: Scalars['DateTime']['input'];
  bmiAtScreening: Scalars['Float']['input'];
  /**
   * The parent or legal guardian who booked this consult for a patient under
   * 18. When set, the consult's Healthie appointment notes carry: "Patient is a
   * minor. Booked by guardian {firstName} {lastName} ({email}). Guardian must
   * be present at the start of the first session to give verbal consent."
   * Best-effort: a failed note write never fails the booking. Null writes
   * nothing, and a replay of an already-booked `idempotencyKey` does not write
   * it again.
   */
  bookedByGuardian?: InputMaybe<PlatformGlp1ConsultGuardianInput>;
  comorbidities: Array<PlatformComorbidityFlag>;
  /** Null when the diabetes-type follow-up wasn't asked. */
  diabetesType?: InputMaybe<PlatformDiabetesType>;
  /**
   * Caller-supplied dedupe key, stable across retries of the same logical
   * booking (the onboarding funnel uses `patientId:appointmentTime` — one patient
   * can't hold two consults at the same instant). A second call with a key that
   * already booked short-circuits to the existing booking instead of creating a
   * duplicate Healthie appointment.
   */
  idempotencyKey: Scalars['String']['input'];
  /**
   * Booking-time coverage evidence; medication-program classifies it. Omit when
   * the caller has no coverage evidence. Does not change visit billability or
   * who can be booked.
   */
  medicareEvidence?: InputMaybe<PlatformMedicareCoverageEvidenceInput>;
  /** Canonical patient-registry id; resolved to a Healthie id server-side. */
  patientId: Scalars['ID']['input'];
  /** Canonical provider-registry id of the booked provider; resolved to a Healthie id server-side. The caller assigns the provider (e.g. the onboarding funnel picks a free one from the eligible set). */
  providerId: Scalars['ID']['input'];
  /**
   * Legacy caller-supplied in-network signal, retained for compatibility and
   * caller-side observability. Medication-program does not use it; claim
   * billability is determined at claim submission time.
   */
  providerPayerEnrolled: Scalars['Boolean']['input'];
  /**
   * Finish a booking whose intake row already exists for `idempotencyKey`.
   * A missing row returns `Glp1ConsultNotBookableError` (`ALREADY_SCHEDULED`)
   * and writes nothing: no demographics update and no appointment. Callers that
   * already found a live consult set this so a failed history re-read cannot
   * open a second initial consult. Omit for a new booking.
   */
  replayOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Clinical step data and chart-note source, persisted unchanged for audit.
   * Optional `_questionnaireV1` metadata carries original and charting questions,
   * labels, units, provenance, and declared action-output keys. The note validates
   * this metadata, renders selected answer labels, omits declared output rows,
   * and promotes clinicalFlags. Metadata-free legacy callers remain supported.
   */
  screeningAnswers: Scalars['JSON']['input'];
  verdict: PlatformGlp1EligibilityVerdict;
  verdictReasons: Array<Scalars['String']['input']>;
  vitals: PlatformVitalsInput;
};

/** Successful booking or a recoverable, user-actionable booking failure. */
export type PlatformBookGlp1AppointmentResult = PlatformGlp1Booked | PlatformGlp1ConsultNotBookableError | PlatformGlp1NotPrescribedError | PlatformSlotUnavailableError;

/**
 * Input for booking a GLP-1 follow-up visit. Unlike the initial booking it
 * carries no screening payload — the patient is already enrolled, so there's no
 * verdict, vitals, or intake to record.
 */
export type PlatformBookGlp1FollowUpAppointmentInput = {
  /** ISO 8601 appointment start time. */
  appointmentTime: Scalars['DateTime']['input'];
  /** Canonical patient-registry id; resolved to a Healthie id server-side. */
  patientId: Scalars['ID']['input'];
  /** Canonical provider-registry id of the assigned prescriber; resolved to a Healthie id server-side. */
  providerId: Scalars['ID']['input'];
  /**
   * Legacy caller-supplied in-network signal, retained for compatibility and
   * caller-side observability. Medication-program does not use it; claim
   * billability is determined at claim submission time.
   */
  providerPayerEnrolled: Scalars['Boolean']['input'];
};

export type PlatformBookMntInitialVisitInput = {
  /** ISO 8601 start time of the initial visit, as selected by the patient. */
  appointmentTime: Scalars['DateTime']['input'];
  /**
   * Whether to book the three-visit recurring follow-up series after the initial.
   * The caller derives this from the dietitian's match result (provider-matching's
   * recurring-follow-up eligibility); the domain does not re-derive it. False books
   * the initial visit alone.
   */
  bookRecurringFollowUps: Scalars['Boolean']['input'];
  /**
   * The parent or legal guardian who booked this visit for a patient under 18.
   * When set, the initial appointment's Healthie notes also carry: "Patient is
   * a minor. Booked by guardian {firstName} {lastName} ({email}). Guardian must
   * be present at the start of the first session to give verbal consent."
   * Null writes nothing. Replaying an already-booked `idempotencyKey` does not
   * write it again.
   */
  bookedByGuardian?: InputMaybe<PlatformMntVisitGuardianInput>;
  /**
   * Insured vs cash-pay classification. Drives the Healthie user group the patient
   * is placed in (CBF parity: insured and private-pay groups are distinct) and is
   * recorded on the visit for billing.
   */
  coverage: PlatformMntCoverage;
  /**
   * Dietitian-services selections from the services menu. Values are the
   * onboarding step's stable option ids (e.g. `meal_plans`); the domain records
   * them verbatim on this booking record as nutrition intake context — there is
   * no Healthie write for this field (matching CBF).
   */
  dietitianServices: Array<Scalars['String']['input']>;
  /**
   * Caller-supplied dedupe key, stable across retries of the same logical booking
   * (the onboarding funnel uses `patientId:appointmentTime`). A second call with a
   * key that already booked short-circuits to the existing result — including its
   * recorded follow-ups — instead of creating duplicates.
   */
  idempotencyKey: Scalars['String']['input'];
  /** Canonical patient-registry id; resolved to a Healthie id server-side. */
  patientId: Scalars['ID']['input'];
  /**
   * Patient-written context for the visit, attached to the created Healthie
   * appointment's notes (CBF parity: the booking flow's appointment-notes
   * string). Null or blank writes nothing. The domain prefixes it
   * "Appointment notes: " to match the copy dietitians already see from CBF.
   */
  patientNote?: InputMaybe<Scalars['String']['input']>;
  /**
   * The dietitian's hourly cash-pay rate in USD — provider-matching's
   * `provider.profile.cashPayRate`, as shown to the patient at selection. Only
   * read for CASH_PAY bookings, where it prices the Healthie
   * `advance_appointment_prices` the visit bills at; null applies the domain's
   * default rate. Ignored for INSURED.
   */
  providerCashPayRate?: InputMaybe<Scalars['Float']['input']>;
  /** Canonical provider-registry id of the selected dietitian; resolved to a Healthie id server-side. */
  providerId: Scalars['ID']['input'];
  /**
   * Explicit opt-in to confirmed RD-primary care-team reconciliation. Only
   * book-dietitian currently enables it. Omitted/false keeps legacy fresh/resume
   * assignment; true never reassigns a previously booked visit on resume.
   */
  reconcileCareTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Chart traceability token written to the Healthie patient's
   * `record_identifier` (CBF parity: session-level traceability from chart back
   * to intake). The caller supplies its session id; the domain treats it as
   * opaque.
   */
  recordIdentifier?: InputMaybe<Scalars['String']['input']>;
  /**
   * Whether this session is allowed sub-24-hour booking; forwarded verbatim
   * to `scheduling.bookAppointment` for the initial visit and the follow-up
   * series (follow-ups are placed weeks out, so it is moot there in
   * practice). Resolved by the caller — this domain does not re-derive it from
   * `coverage`, so the derivation has exactly one home. Absent fails closed to
   * the 24-hour floor.
   */
  sameDayBookingAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Visit-reason category labels collected at the front door, order-insignificant
   * — the same `specialtyCategories` vocabulary provider-matching's
   * `matchDietitians` uses (category label is the natural key; there is no
   * separate id space). Drives Healthie visit-reason tags and the chart's
   * intake notes, and the domain derives the eating-disorder chart default from
   * them (CBF parity: eating-disorder-indicating reasons set Healthie's
   * `apply_eating_disorder_default` feature toggle — derived here, never
   * caller-supplied, so the flag can't contradict the reasons). Primacy is a
   * matching/copy concern upstream; the chart write does not distinguish.
   */
  visitReasons: Array<Scalars['String']['input']>;
};

/**
 * Result of the initial-visit booking. Follow-up outcomes never appear here as
 * errors: a failed follow-up is reported in `followUpFailures` on the success
 * payload, because initial success remains success when a follow-up fails.
 */
export type PlatformBookMntInitialVisitResult = PlatformMntCareTeamNotReady | PlatformMntInitialVisitBooked | PlatformMntSlotUnavailableError;

/**
 * The patient's booked GLP-1 appointment, snapshotted from the session's booking
 * commit: what the APPOINTMENT_CONFIRMATION terminal and the BOOKING_CELEBRATION
 * step render.
 */
export type PlatformBookedAppointment = {
  __typename?: 'BookedAppointment';
  /**
   * Healthie appointment id, stamped by the booking action on success. Null
   * on an edge-case session where the booking snapshot predates this field.
   */
  appointmentHealthieId?: Maybe<Scalars['String']['output']>;
  /** ISO 8601 booked time (UTC). */
  appointmentTime: Scalars['DateTime']['output'];
  /**
   * True when this booked GLP-1 consult was identified for Medicare Bridge
   * assessment. It does not mean eligibility was reviewed or coverage was approved.
   */
  medicareBridgeAssessmentPending: Scalars['Boolean']['output'];
  /**
   * The prescriber on the booked appointment, read from the provider the booking
   * commit recorded, never from the picker's selection. Null only for a booking
   * snapshot that predates the recorded provider. A failed profile read is an
   * error on this field, never null, so a client can tell "no recorded
   * provider" from "profile unavailable"; the booking itself is unaffected.
   */
  prescriber?: Maybe<PlatformPrescriberProfile>;
  /**
   * Two-letter USPS state code the appointment was matched against, sourced
   * from the session's state step submission. Null when unavailable.
   */
  stateCode?: Maybe<Scalars['String']['output']>;
};

/** Manual booking-priority override tier for a provider. */
export enum PlatformBookingPrioritization {
  /** Ranked behind NORMAL providers. */
  Deprioritized = 'DEPRIORITIZED',
  /** No override. */
  Normal = 'NORMAL',
  /** Ranked ahead of NORMAL providers. */
  Prioritized = 'PRIORITIZED'
}

/**
 * A booking session that holds pre-populated data for partner-initiated flows.
 * Sessions are created by external systems (e.g., Amazon HBC) and consumed
 * by the customer-booking-flow application.
 */
export type PlatformBookingSession = {
  __typename?: 'BookingSession';
  /** Full booking-flow URL containing the token (partner-ready) */
  applyUrl: Scalars['String']['output'];
  /** When the session was completed; null while ACTIVE */
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  /** When the session was created */
  createdAt: Scalars['DateTime']['output'];
  /** Pre-populated date of birth from partner */
  dateOfBirth?: Maybe<Scalars['Date']['output']>;
  /** Pre-populated email from partner */
  email?: Maybe<Scalars['String']['output']>;
  /** Employer name from partner */
  employer?: Maybe<Scalars['String']['output']>;
  /** When the session expires */
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  /** Partner-supplied identifier for correlating this referral with their own system */
  externalId?: Maybe<Scalars['String']['output']>;
  /** Pre-populated first name from partner */
  firstName?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the session */
  id: Scalars['ID']['output'];
  /** Insurer/payer name from partner */
  insurer?: Maybe<Scalars['String']['output']>;
  /** Pre-populated last name from partner */
  lastName?: Maybe<Scalars['String']['output']>;
  /** Partner that initiated this session (e.g., 'amazon-hbc', null for organic) */
  partner?: Maybe<Scalars['String']['output']>;
  /** Pre-populated phone number from partner, normalized to E.164 */
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** 2-letter US state code pre-populated by partner */
  stateCode?: Maybe<Scalars['String']['output']>;
  /** Current status of the session */
  status: PlatformBookingSessionStatus;
  /** URL-safe token used to access the session */
  token: Scalars['String']['output'];
  /** When the session was last updated */
  updatedAt: Scalars['DateTime']['output'];
  /** Pre-populated visit-reason category labels from partner */
  visitReasons: Array<Scalars['String']['output']>;
  /** 5-digit US ZIP code pre-populated by partner */
  zipCode?: Maybe<Scalars['String']['output']>;
};

/** Status of a booking session */
export enum PlatformBookingSessionStatus {
  /** Session is active and can be used */
  Active = 'ACTIVE',
  /** Session has been completed */
  Completed = 'COMPLETED'
}

/**
 * Order and delivery lifecycle of a patient's blood-pressure cuff. NOT_ORDERED is
 * projected when no order exists; the first persisted state is READY_TO_ORDER.
 */
export enum PlatformBpCuffDeliveryStatus {
  Cancelled = 'CANCELLED',
  Connected = 'CONNECTED',
  Delivered = 'DELIVERED',
  InFulfillment = 'IN_FULFILLMENT',
  ManualReview = 'MANUAL_REVIEW',
  NotOrdered = 'NOT_ORDERED',
  Ordered = 'ORDERED',
  OrderFailed = 'ORDER_FAILED',
  ReadyToOrder = 'READY_TO_ORDER',
  Shipped = 'SHIPPED'
}

export type PlatformBpCuffShippingAddressInput = {
  city: Scalars['String']['input'];
  countryCode?: Scalars['String']['input'];
  line1: Scalars['String']['input'];
  line2?: InputMaybe<Scalars['String']['input']>;
  postalCode: Scalars['String']['input'];
  state: Scalars['String']['input'];
};

/**
 * The product is not on the current Medicare Bridge checklist.
 * No prior authorization was created.
 */
export type PlatformBridgeProductNotAllowed = {
  __typename?: 'BridgeProductNotAllowed';
  caseId: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  product: PlatformGlp1Product;
};

/**
 * An open Medicare Bridge case is ELIGIBLE on an older checklist.
 * No prior authorization was created.
 */
export type PlatformBridgeReviewRequired = {
  __typename?: 'BridgeReviewRequired';
  caseId: Scalars['ID']['output'];
  /** What the provider should do next. */
  message: Scalars['String']['output'];
};

/**
 * Result of a cancelChatHistoryImport call.
 *
 * `cancelled: false` means the run was already finished, which is reported
 * rather than raised so an operator can fire this without first checking
 * whether they are too late.
 */
export type PlatformCancelChatHistoryImportResult = {
  __typename?: 'CancelChatHistoryImportResult';
  /** False when the run had already reached a terminal state. */
  cancelled: Scalars['Boolean']['output'];
  runId: Scalars['String']['output'];
  /** Temporal workflow ID, `chat-history-import-<runId>` */
  workflowId: Scalars['String']['output'];
};

export type PlatformCancelHealthieAppointmentResponse = {
  __typename?: 'CancelHealthieAppointmentResponse';
  appointment?: Maybe<PlatformHealthieAppointment>;
  messages: Array<PlatformHealthieMessage>;
};

/** Input for `cancelPatientNavihealthBackfill`. */
export type PlatformCancelPatientNavihealthBackfillInput = {
  /**
   * Free-text reason recorded on the workflow's terminate event. Admin
   * prefixes the operator email so it's grep-able in Temporal UI.
   */
  reason?: InputMaybe<Scalars['String']['input']>;
};

/** Result of `cancelPatientNavihealthBackfill`. */
export type PlatformCancelPatientNavihealthBackfillResult = {
  __typename?: 'CancelPatientNavihealthBackfillResult';
  runId?: Maybe<Scalars['ID']['output']>;
  /** True when Temporal accepted the terminate; false when no running execution was found. */
  terminated: Scalars['Boolean']['output'];
  workflowId: Scalars['ID']['output'];
};

export type PlatformCancelProviderEmailOriginBackfillInput = {
  reason?: InputMaybe<Scalars['String']['input']>;
  stage: PlatformProviderEmailOriginBackfillStage;
};

export type PlatformCancelProviderEmailOriginBackfillResult = {
  __typename?: 'CancelProviderEmailOriginBackfillResult';
  runId?: Maybe<Scalars['ID']['output']>;
  terminated: Scalars['Boolean']['output'];
  workflowId: Scalars['ID']['output'];
};

export type PlatformCancelProviderNavihealthBackfillInput = {
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type PlatformCancelProviderNavihealthBackfillResult = {
  __typename?: 'CancelProviderNavihealthBackfillResult';
  runId?: Maybe<Scalars['ID']['output']>;
  terminated: Scalars['Boolean']['output'];
  workflowId: Scalars['ID']['output'];
};

/** A single fact captured from the interview conversation. */
export type PlatformCapturedProfileFieldInput = {
  confidence: PlatformProfileFieldConfidence;
  field: PlatformProfileFieldKey;
  provenance: PlatformProfileFieldProvenance;
  /**
   * When the patient said it: the send time of the message the capture came from.
   * Orders captures of the same field across turns. Omitted, the capture always
   * applies, as before.
   */
  sourceAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Plain-language summary of what the patient said. */
  value: Scalars['String']['input'];
};

export type PlatformCardSetup = {
  __typename?: 'CardSetup';
  /** Confirm the card with Stripe's browser or mobile SDK using this secret. */
  clientSecret: Scalars['String']['output'];
  /** After this instant completeCardSetup reports EXPIRED; start a new setup. */
  expiresAt: Scalars['DateTime']['output'];
  /** Pass to completeCardSetup. */
  id: Scalars['ID']['output'];
  /** The publishable key of the Stripe account that created this setup; load it in the SDK that confirms `clientSecret`. */
  publishableKey: Scalars['String']['output'];
};

export type PlatformCardSetupCompleted = {
  __typename?: 'CardSetupCompleted';
  savedCard: PlatformSavedCard;
};

/** The setup can never complete; start a new one. */
export type PlatformCardSetupFailedError = {
  __typename?: 'CardSetupFailedError';
  message: Scalars['String']['output'];
  reason: PlatformCardSetupFailureReason;
};

export enum PlatformCardSetupFailureReason {
  Canceled = 'CANCELED',
  /** The card is already saved for a different patient. */
  CardBelongsToAnotherPatient = 'CARD_BELONGS_TO_ANOTHER_PATIENT',
  CardDeclined = 'CARD_DECLINED',
  Expired = 'EXPIRED'
}

/** The patient has not finished the setup yet. Retry later; nothing changed. */
export type PlatformCardSetupIncompleteError = {
  __typename?: 'CardSetupIncompleteError';
  message: Scalars['String']['output'];
};

/**
 * A Stripe SetupIntent for saving a card on file (no charge). The client confirms
 * it in the browser, which is what lets Apple Pay / Google Pay supply the card.
 *
 * @shareable: both onboarding and medication-program declare this type
 * identically as a wire shape, not an entity — required, or supergraph
 * composition rejects the duplicate.
 */
export type PlatformCardSetupIntent = {
  __typename?: 'CardSetupIntent';
  /** Stripe client secret the browser confirms the intent with. */
  clientSecret: Scalars['String']['output'];
  /**
   * The Stripe publishable key of the account that created this setup; the
   * browser must load this key.
   */
  publishableKey: Scalars['String']['output'];
};

export type PlatformCardSetupStarted = {
  __typename?: 'CardSetupStarted';
  cardSetup: PlatformCardSetup;
};

/** No setup was started and nothing changed; keep the existing card flow. */
export type PlatformCardSetupUnavailableError = {
  __typename?: 'CardSetupUnavailableError';
  message: Scalars['String']['output'];
  reason: PlatformCardSetupUnavailableReason;
};

export enum PlatformCardSetupUnavailableReason {
  /** Setups without a patient are not enabled; start one with `patientId`. */
  PatientRequired = 'PATIENT_REQUIRED'
}

/**
 * A care-agent crisis escalation (chat.care_agent_escalations row). Created by the
 * crisis guardrail when it detects crisis language in a patient message; an OPEN
 * row pauses all automated replies for that patient until a human resolves it.
 * PHI-safe: carries IDs + matched screen terms only, never patient free text.
 */
export type PlatformCareEscalation = {
  __typename?: 'CareEscalation';
  /** ISO-8601 timestamp of when the escalation was created */
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** The screen term(s) that matched — for human triage */
  matchedTerms: Array<Scalars['String']['output']>;
  patientHealthieId: Scalars['ID']['output'];
  providerHealthieId: Scalars['ID']['output'];
  /** Why we escalated. v1: 'guardrail_keyword' */
  reason: Scalars['String']['output'];
  /** ISO-8601 timestamp of when it was resolved (null while open) */
  resolvedAt?: Maybe<Scalars['String']['output']>;
  /** Who resolved it (audit label, e.g. an admin email; null while open) */
  resolvedBy?: Maybe<Scalars['String']['output']>;
  status: PlatformCareEscalationStatus;
  /** Crisis tier: 'emergency' | 'concerning' — drives triage urgency */
  tier: Scalars['String']['output'];
};

/**
 * Status of a care-agent crisis escalation. OPEN = automated replies are paused
 * for the patient; RESOLVED = a human cleared it and the agent may resume.
 */
export enum PlatformCareEscalationStatus {
  Open = 'OPEN',
  Resolved = 'RESOLVED'
}

export type PlatformCarePlanGoalNarrativeEditInput = {
  measure: Scalars['String']['input'];
  narrative: Scalars['String']['input'];
};

/**
 * Narrative-only edits an NP may make to a care plan. Structured fields (ICD-10
 * codes, targets, cadences, baseline values, labs, care team) are NOT editable —
 * they are machine-checked against the generation inputs. An edit creates a NEW
 * version (generatedBy 'np-edit') superseding the current draft.
 */
export type PlatformCarePlanNarrativeEditsInput = {
  /** Per-measure goal narratives, keyed by the measure enum (BP, WEIGHT, HBA1C, LDL_C, EGFR_UACR). */
  goalNarratives?: InputMaybe<Array<PlatformCarePlanGoalNarrativeEditInput>>;
  initialAssessment?: InputMaybe<Scalars['String']['input']>;
  medicationsNarrative?: InputMaybe<Scalars['String']['input']>;
  patientSummary?: InputMaybe<Scalars['String']['input']>;
  treatmentPlan?: InputMaybe<Scalars['String']['input']>;
};

/** Which copy variant the CASH_PAY_AGREEMENT screen renders, by entry point. */
export enum PlatformCashPayAgreementVariant {
  /** An insured MNT lead whose payer + state matched zero dietitians. */
  PlanNotAccepted = 'PLAN_NOT_ACCEPTED',
  /** The Self-pay payer pick — GLP-1 is insurance-only, so the agreement replaces the program menu. */
  SelfPay = 'SELF_PAY'
}

/**
 * Session-specific presentation context for cash-pay journeys (GLPX-325),
 * derived server-side from the same submission rows and guard predicates the
 * machine routes on.
 */
export type PlatformCashPayContext = {
  __typename?: 'CashPayContext';
  /** Which agreement variant the current cursor hosts. Null off the agreement step. */
  agreementVariant?: Maybe<PlatformCashPayAgreementVariant>;
  /** The current cursor's latest agreement answer is a decline — the machine is resting on the agreement step. */
  declined: Scalars['Boolean']['output'];
  /**
   * An insured GLP-1 leg is live in this journey (selected and eligible). A
   * combined confirm still bills insurance for it, so insurance-framed card
   * disclosures and the card-upload step remain relevant even under an MNT
   * cash-pay agreement.
   */
  insuredGlp1Live: Scalars['Boolean']['output'];
  /**
   * An insured MNT leg is live in this journey: MNT is selected and books
   * through insurance, not under a cash-pay agreement. False for a GLP-1-only
   * journey, which `mntCashPay: false` alone cannot tell apart from insured MNT.
   */
  insuredMntLive: Scalars['Boolean']['output'];
  /** MNT books CASH_PAY: an affirmative express agreement is on the active path. */
  mntCashPay: Scalars['Boolean']['output'];
  /**
   * The CREDIT_CARD step lists the card's terms above the wallet and card form.
   * Follows the `welcome-card-terms` session feature, frozen at session
   * creation; false for a session whose flow does not declare it.
   */
  showCardTerms: Scalars['Boolean']['output'];
};

export type PlatformChangeAppointmentStatusInput = {
  appointmentHealthieId: Scalars['ID']['input'];
  /** Caller-supplied label such as provider-portal or patient-app, used only for observability. Logged as requestSource after trimming; omitted, null, or blank values log unknown. */
  source?: InputMaybe<Scalars['String']['input']>;
  status: Scalars['TerminationAppointmentStatusChange']['input'];
  /** Optional Healthie actor; omitted uses the service account and disables cascades for Cancelled. A Cancelled cascade requires this actor to be the appointment's patient. Trusted callers authorize the actor and appointment before invoking this mutation; Healthie also enforces the actor's permissions. */
  triggeringUserHealthieId?: InputMaybe<Scalars['ID']['input']>;
};

export type PlatformChangeAppointmentStatusPayload = PlatformAppointmentNotFoundError | PlatformAppointmentStatusChanged;

export type PlatformChargeAppointmentFeeInput = {
  /** Approved fee in the currency's minor unit; greater than 0. */
  amountCents: Scalars['Int']['input'];
  /** Healthie appointment id of the appointment the fee is for; stored with the fee, not looked up. */
  appointmentHealthieId: Scalars['ID']['input'];
  currency?: PlatformCurrency;
  feeType: PlatformAppointmentFeeType;
  /**
   * The caller's stable id for this fee (at most 200 characters). Send the same
   * key to settle or retry the fee; it is collected at most once across all
   * attempts.
   */
  idempotencyKey: Scalars['String']['input'];
  /** Canonical patient-registry id of the patient charged; authorized by the caller. */
  patientId: Scalars['ID']['input'];
};

export type PlatformChargeAppointmentFeePayload = PlatformAppointmentFeeCharged | PlatformFeeChargeRejectedError;

/**
 * One attachment already hosted on our GetStream CDN. The caller uploads the file
 * to the channel through its own connected Stream client and passes the URL the
 * upload returned; the domain attaches it unchanged. A URL on any other host is
 * rejected with BAD_USER_INPUT, so the mutation cannot be used to attach
 * arbitrary external content. Stream enforces its own size limit at upload time,
 * where the uploader sees the error.
 */
export type PlatformChatAttachmentInput = {
  /** Content type from the upload. image/* becomes an image attachment, anything else a file. */
  mimeType: Scalars['String']['input'];
  /** Filename shown to members. */
  title: Scalars['String']['input'];
  /** Stream CDN URL returned by the upload. */
  url: Scalars['String']['input'];
};

/**
 * Input item for a one-time chat backfill. providerHealthieId is always required.
 *
 * Shape 1 — patient-provider pair: provide patientHealthieId → triggers backfillChatForPair.
 * Shape 2 — known conversation: provide conversationId → triggers provisionChatForConversation directly.
 * Shape 3 — provider account only: omit both → triggers backfillProviderChatAccount (ensures provider
 *   GetStream user exists so the chat page loads, without requiring an active conversation).
 */
export type PlatformChatBackfillPairInput = {
  /** Shape 2: Healthie conversation ID — triggers provisionChatForConversation directly */
  conversationId?: InputMaybe<Scalars['String']['input']>;
  /** Shape 1: Healthie patient user ID — triggers backfillChatForPair */
  patientHealthieId?: InputMaybe<Scalars['String']['input']>;
  providerHealthieId: Scalars['String']['input'];
};

/** Stream Chat channel for a patient-provider conversation. */
export type PlatformChatChannel = {
  __typename?: 'ChatChannel';
  /** Stream Chat channel ID (opaque, e.g. ch_k2J9dB3pLmNx) */
  channelId: Scalars['String']['output'];
  /** All members of this channel with their Stream user IDs and account roles */
  members: Array<PlatformChatChannelMember>;
};

/** A member of a Stream Chat channel. */
export type PlatformChatChannelMember = {
  __typename?: 'ChatChannelMember';
  /**
   * Business role of this account: 'patient' | 'provider'.
   * Use this to identify which member is which without assuming caller role.
   */
  accountRole: Scalars['String']['output'];
  /**
   * Display name as provisioned to GetStream. Null when the account was created
   * before names were synced and no later sync has filled it.
   */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Healthie user id of this member. Callers still keyed on Healthie ids join on this. */
  healthieUserId: Scalars['String']['output'];
  /** GetStream user ID for this member — pass to connectUser() or use for UI identity */
  streamUserId: Scalars['String']['output'];
};

export type PlatformChatChannelRecentTurnsInput = {
  /** Opaque chat-domain channel identity, as returned by `chatChannels`. */
  channelId: Scalars['ID']['input'];
  /** How many of the most recent turns to return. Defaults to 50, capped at 200. */
  limit?: InputMaybe<Scalars['Int']['input']>;
};

/** One turn in a channel, oldest first within a page. */
export type PlatformChatChannelTurn = {
  __typename?: 'ChatChannelTurn';
  /** When the message was sent, ISO-8601. */
  occurredAt: Scalars['String']['output'];
  role: PlatformChatChannelTurnRole;
  /** Opaque logical message identity. Preserve verbatim; do not parse. */
  sourceId: Scalars['ID']['output'];
  text: Scalars['String']['output'];
};

/**
 * Who produced a turn in a channel.
 *
 * Wider than `PatientChatHistoryRole` on purpose: a reply path has to see the
 * human provider's half of the conversation, while long-term-memory ingestion
 * deliberately does not.
 */
export enum PlatformChatChannelTurnRole {
  Patient = 'PATIENT',
  Perry = 'PERRY',
  Provider = 'PROVIDER'
}

/** A position in the cohort walk, ordered by channel creation then id. */
export type PlatformChatHistoryImportCursorInput = {
  /** ISO-8601, exactly as the manifest's endCursor carried it. */
  createdAt: Scalars['String']['input'];
  id: Scalars['String']['input'];
};

/** A single required/optional consent checkbox. A required checkbox must be checked (value `true`) before the step can advance. */
export type PlatformCheckboxField = {
  __typename?: 'CheckboxField';
  /**
   * Optional expandable legal detail shown when the patient taps the checkbox's
   * term (e.g. the full ACCESS Program Terms text). Null when the label alone
   * is the full disclosure.
   */
  detail?: Maybe<PlatformConsentDetail>;
  /** Optional helper text shown beneath the field. */
  helperText?: Maybe<Scalars['String']['output']>;
  /** Field id; the key to submit this value (`true`/`false`) under. */
  id: Scalars['String']['output'];
  /** Label shown beside the checkbox. */
  label: Scalars['String']['output'];
  /** Whether the box must be checked before advancing. */
  required: Scalars['Boolean']['output'];
};

/** A single-select input with a fixed set of options. */
export type PlatformChoiceField = {
  __typename?: 'ChoiceField';
  /** Optional helper text shown beneath the field. */
  helperText?: Maybe<Scalars['String']['output']>;
  /** Field id; the key to submit the selected option value under. */
  id: Scalars['String']['output'];
  /** Label shown to the patient. */
  label: Scalars['String']['output'];
  /** Selectable options; submit the chosen option's `value`. */
  options: Array<PlatformStepFieldOption>;
  /** How the client must present the selectable options. */
  presentation: PlatformChoiceFieldPresentation;
  /** Whether the patient must answer before advancing. */
  required: Scalars['Boolean']['output'];
};

/** Supported visual presentations for a single-select field. */
export enum PlatformChoiceFieldPresentation {
  Dropdown = 'DROPDOWN',
  RadioCards = 'RADIO_CARDS',
  /** Radio cards in a responsive two-column grid — for long option lists. */
  RadioCardsTwoColumn = 'RADIO_CARDS_TWO_COLUMN'
}

export type PlatformClearGlp1NotPrescribedDecisionInput = {
  patientHealthieId: Scalars['ID']['input'];
  /** @deprecated Ignored. The acting provider comes from the verified provider assertion (x-bst-provider-assertion). Stop sending it; this argument will be removed. */
  providerHealthieId?: InputMaybe<Scalars['ID']['input']>;
};

/** A code as the source sent it. Any part is null when the source omitted it. */
export type PlatformClinicalCoding = {
  __typename?: 'ClinicalCoding';
  code?: Maybe<Scalars['String']['output']>;
  display?: Maybe<Scalars['String']['output']>;
  system?: Maybe<Scalars['String']['output']>;
};

/**
 * A lab test Clinical Records recognizes across sources. Each value is one analyte, not a panel;
 * callers choose which tests they show and group them into panels. Clinical Records owns the codes
 * that identify each test, and the set grows as callers need more tests.
 */
export enum PlatformClinicalLabTest {
  AlanineAminotransferase = 'ALANINE_AMINOTRANSFERASE',
  Albumin = 'ALBUMIN',
  AlkalinePhosphatase = 'ALKALINE_PHOSPHATASE',
  AspartateAminotransferase = 'ASPARTATE_AMINOTRANSFERASE',
  BasophilCount = 'BASOPHIL_COUNT',
  BasophilPercentage = 'BASOPHIL_PERCENTAGE',
  BloodUreaNitrogen = 'BLOOD_UREA_NITROGEN',
  Calcium = 'CALCIUM',
  CarbonDioxide = 'CARBON_DIOXIDE',
  Chloride = 'CHLORIDE',
  Creatinine = 'CREATININE',
  DirectBilirubin = 'DIRECT_BILIRUBIN',
  EosinophilCount = 'EOSINOPHIL_COUNT',
  EosinophilPercentage = 'EOSINOPHIL_PERCENTAGE',
  EstimatedGlomerularFiltrationRate = 'ESTIMATED_GLOMERULAR_FILTRATION_RATE',
  FreeThyroxine = 'FREE_THYROXINE',
  Glucose = 'GLUCOSE',
  HdlCholesterol = 'HDL_CHOLESTEROL',
  Hematocrit = 'HEMATOCRIT',
  Hemoglobin = 'HEMOGLOBIN',
  HemoglobinA1C = 'HEMOGLOBIN_A1C',
  LdlCholesterol = 'LDL_CHOLESTEROL',
  Lipase = 'LIPASE',
  LymphocyteCount = 'LYMPHOCYTE_COUNT',
  LymphocytePercentage = 'LYMPHOCYTE_PERCENTAGE',
  MeanCorpuscularHemoglobin = 'MEAN_CORPUSCULAR_HEMOGLOBIN',
  MeanCorpuscularHemoglobinConcentration = 'MEAN_CORPUSCULAR_HEMOGLOBIN_CONCENTRATION',
  MeanCorpuscularVolume = 'MEAN_CORPUSCULAR_VOLUME',
  MonocyteCount = 'MONOCYTE_COUNT',
  MonocytePercentage = 'MONOCYTE_PERCENTAGE',
  NeutrophilCount = 'NEUTROPHIL_COUNT',
  NeutrophilPercentage = 'NEUTROPHIL_PERCENTAGE',
  NonHdlCholesterol = 'NON_HDL_CHOLESTEROL',
  PlateletCount = 'PLATELET_COUNT',
  Potassium = 'POTASSIUM',
  RedBloodCellCount = 'RED_BLOOD_CELL_COUNT',
  RedCellDistributionWidth = 'RED_CELL_DISTRIBUTION_WIDTH',
  Sodium = 'SODIUM',
  ThyroidStimulatingHormone = 'THYROID_STIMULATING_HORMONE',
  TotalBilirubin = 'TOTAL_BILIRUBIN',
  TotalCholesterol = 'TOTAL_CHOLESTEROL',
  TotalProtein = 'TOTAL_PROTEIN',
  Triglycerides = 'TRIGLYCERIDES',
  WhiteBloodCellCount = 'WHITE_BLOOD_CELL_COUNT'
}

/** One lab test's results for a patient. */
export type PlatformClinicalLabTestHistory = {
  __typename?: 'ClinicalLabTestHistory';
  /**
   * The test's results from every source, newest `effectiveAt` first, undated last. Excludes
   * soft-invalidated rows, which include results a source cancelled or entered in error. Rows that
   * repeat one reading (same `effectiveAt`, value and unit, from one source or several) collapse to
   * the most recently ingested row. Results the source coded only with a lab's local code are not
   * recognized. Empty when nothing is stored here, which does not mean the patient never had the
   * test.
   */
  results: Array<PlatformMeasurement>;
  test: PlatformClinicalLabTest;
};

/**
 * One source MedicationRequest or MedicationStatement. A row records that a course was ordered or
 * reported, not that the patient took, tolerated or completed it. Named ClinicalMedication because the
 * medications subgraph owns Medication.
 */
export type PlatformClinicalMedication = {
  __typename?: 'ClinicalMedication';
  /** Set when a later complete pull of this resource kind no longer returned the record. */
  absentFromSourceAt?: Maybe<Scalars['DateTime']['output']>;
  /** When the request was authored or the statement asserted. Not the course start. */
  authoredOn?: Maybe<Scalars['DateTime']['output']>;
  /** MedicationRequest courseOfTherapyType code (continuous, acute, seasonal), else its text. */
  courseOfTherapyType?: Maybe<Scalars['String']['output']>;
  /** True means the request must not be performed. Null for statements. */
  doNotPerform?: Maybe<Scalars['Boolean']['output']>;
  /** The first free-text dosage instruction. */
  dosageText?: Maybe<Scalars['String']['output']>;
  /** Course end. */
  effectiveEnd?: Maybe<Scalars['DateTime']['output']>;
  /** Course start. Often null while effectiveEnd is set, which means the course ended then, not that it began then. */
  effectiveStart?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  /** MedicationRequest intent (e.g. order, proposal, plan). Null for statements. */
  intent?: Maybe<Scalars['String']['output']>;
  /** RxNorm display, else the source concept text. */
  name: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  /** Why the drug was prescribed or taken. */
  reasonCodes: Array<PlatformClinicalCoding>;
  resourceKind: PlatformClinicalMedicationResourceKind;
  /** Null for text-only records. */
  rxnormCode?: Maybe<Scalars['String']['output']>;
  source: Scalars['String']['output'];
  sourceResourceId: Scalars['String']['output'];
  /** FHIR status, verbatim. Null when the source omitted it. */
  status?: Maybe<Scalars['String']['output']>;
  /** Why the course has its status (e.g. stopped for intolerance), as coded by the source. */
  statusReasons: Array<PlatformClinicalCoding>;
  /** rxnorm or text. */
  system: Scalars['String']['output'];
};

/** Which FHIR resource a clinical medication row came from. */
export enum PlatformClinicalMedicationResourceKind {
  MedicationRequest = 'MEDICATION_REQUEST',
  MedicationStatement = 'MEDICATION_STATEMENT'
}

export type PlatformCloseDocumentRequestInput = {
  id: Scalars['ID']['input'];
  outcome: PlatformDocumentRequestOutcome;
};

export type PlatformCloseMedicareBridgeCaseInput = {
  caseId: Scalars['ID']['input'];
  /** Retries with the same key write nothing further. */
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  outcome: PlatformMedicareBridgeCloseOutcome;
  /** Required. Stored on the ledger. */
  reason: Scalars['String']['input'];
};

export type PlatformCloseMedicareBridgeCasePayload = {
  __typename?: 'CloseMedicareBridgeCasePayload';
  medicareBridgeCase: PlatformMedicareBridgeCase;
};

/**
 * A cohort is a group of patients managed by an instructor under a program.
 * One cohort can span multiple Healthie recurring appointment series.
 */
export type PlatformCohort = {
  __typename?: 'Cohort';
  /** Healthie recurring appointment series linked to this cohort */
  cohortSeries: Array<PlatformCohortSeries>;
  /** When the cohort was created */
  createdAt: Scalars['DateTime']['output'];
  /** Unique identifier for the cohort */
  id: Scalars['ID']['output'];
  /** Provider ID of the instructor leading this cohort */
  instructorId: Scalars['String']['output'];
  /** The program this cohort is an instance of */
  program: PlatformProgram;
  /** When the cohort was last updated */
  updatedAt: Scalars['DateTime']['output'];
};

/**
 * Maps a Healthie recurring appointment series to a cohort.
 * One cohort can have multiple series (e.g., sessions 1-8 weekly, 9-16 biweekly).
 */
export type PlatformCohortSeries = {
  __typename?: 'CohortSeries';
  /** Whether this series is currently active */
  active: Scalars['Boolean']['output'];
  /** The cohort this series belongs to */
  cohort: PlatformCohort;
  /** When the series mapping was created */
  createdAt: Scalars['DateTime']['output'];
  /** Healthie recurring appointment ID for this series */
  healthieRecurringAppointmentId: Scalars['String']['output'];
  /** Unique identifier for the series mapping */
  id: Scalars['ID']['output'];
  /** When the series mapping was last updated */
  updatedAt: Scalars['DateTime']['output'];
};

export type PlatformCombinedOnboardingResults = {
  __typename?: 'CombinedOnboardingResults';
  accessOutcome?: Maybe<PlatformAccessOnboardingOutcome>;
  /** The booked GLP-1 consultation, or null when no GLP-1 appointment was booked. */
  glp1Appointment?: Maybe<PlatformCombinedResultsAppointment>;
  /**
   * True when this booked GLP-1 consult was identified for Medicare Bridge
   * assessment. It does not mean eligibility was reviewed or coverage was approved.
   */
  medicareBridgeAssessmentPending: Scalars['Boolean']['output'];
  /** The booked initial MNT visit and successful follow-ups, or null when no MNT appointment was booked. */
  mntAppointments?: Maybe<PlatformMntCombinedResultsAppointments>;
};

/** A booked appointment displayed on the immediate welcome-v2 results screen. */
export type PlatformCombinedResultsAppointment = {
  __typename?: 'CombinedResultsAppointment';
  /** Healthie appointment id. Null only for a legacy GLP-1 booking without a persisted id. */
  appointmentHealthieId?: Maybe<Scalars['String']['output']>;
  /** The appointment's booked start time. */
  appointmentTime: Scalars['DateTime']['output'];
};

/**
 * ICD-10-mappable comorbidity flags. The medication-program domain owns
 * this enum because that's where the ICD-10 derivation lives. Callers
 * (onboarding, future admin tooling, partner integrations) map their own
 * vocabulary INTO this enum at their boundary.
 */
export enum PlatformComorbidityFlag {
  Cvd = 'CVD',
  Hyperlipidemia = 'HYPERLIPIDEMIA',
  Hypertension = 'HYPERTENSION',
  MetabolicSyndrome = 'METABOLIC_SYNDROME',
  Nafld = 'NAFLD',
  Osa = 'OSA',
  Osteoarthritis = 'OSTEOARTHRITIS',
  Pcos = 'PCOS',
  Prediabetes = 'PREDIABETES',
  Type2Diabetes = 'TYPE2_DIABETES'
}

/** Input for completing a booking session */
export type PlatformCompleteBookingSessionInput = {
  /** User-edited date of birth (overrides pre-populated value if provided) */
  dateOfBirth: Scalars['Date']['input'];
  /** User-edited email (overrides pre-populated value if provided) */
  email: Scalars['String']['input'];
  /** User-edited first name (overrides pre-populated value if provided) */
  firstName: Scalars['String']['input'];
  /** Healthie user ID of the patient who completed booking */
  healthieUserId: Scalars['String']['input'];
  /** Session ID */
  id: Scalars['ID']['input'];
  /** User-edited last name (overrides pre-populated value if provided) */
  lastName: Scalars['String']['input'];
};

export type PlatformCompleteCardSetupInput = {
  cardSetupId: Scalars['ID']['input'];
  /**
   * Canonical patient-registry id. A setup started without a patient binds its
   * card to this patient; one started with a patient must name the same patient
   * (otherwise a top-level error).
   */
  patientId: Scalars['ID']['input'];
};

export type PlatformCompleteCardSetupPayload = PlatformCardSetupCompleted | PlatformCardSetupFailedError | PlatformCardSetupIncompleteError;

export type PlatformCompleteGlp1PrescriptionTaskInput = {
  outcome: PlatformGlp1PrescriptionTaskOutcome;
  /** @deprecated Ignored. The acting provider comes from the verified provider assertion (x-bst-provider-assertion). Stop sending it; this argument will be removed. */
  providerHealthieId?: InputMaybe<Scalars['ID']['input']>;
  skipReason?: InputMaybe<Scalars['String']['input']>;
  taskId: Scalars['ID']['input'];
};

/** Unauthenticated client-side booking input (completeCheckout). */
export type PlatformCompleteHealthieCheckoutInput = {
  appointmentTypeId: Scalars['ID']['input'];
  /** How the session connects. Common values: 'Secure Videochat', 'Healthie Video Call', 'phone_call'. Actual options depend on the appointment type. */
  contactType: Scalars['String']['input'];
  date: Scalars['String']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  location?: InputMaybe<Scalars['String']['input']>;
  phoneNumber: Scalars['String']['input'];
  price: Scalars['String']['input'];
  providerId: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  timezone: Scalars['String']['input'];
};

export type PlatformCompleteHealthieCheckoutResponse = {
  __typename?: 'CompleteHealthieCheckoutResponse';
  appointment?: Maybe<PlatformHealthieAppointment>;
  messages: Array<PlatformHealthieMessage>;
};

/** Role that can complete a session goal */
export enum PlatformCompletedByRole {
  /** Goal completed by the patient */
  Patient = 'PATIENT',
  /** Goal completed by the provider */
  Provider = 'PROVIDER'
}

/**
 * One source Condition record. Unlike the merged per-code diagnosis view, each source assertion is its
 * own row with its own status and dates, so a condition one record asserts and another resolves
 * appears twice.
 */
export type PlatformCondition = {
  __typename?: 'Condition';
  /** Clinical abatement. Null when the source did not state one. */
  abatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Set when a later complete pull no longer returned this record. Null while the source still returns it. */
  absentFromSourceAt?: Maybe<Scalars['DateTime']['output']>;
  /** FHIR clinicalStatus (active, recurrence, relapse, inactive, remission, resolved), verbatim. Null when the source omitted it. */
  clinicalStatus?: Maybe<Scalars['String']['output']>;
  /** ICD-10 when the source carried one, else SNOMED. Null for text-only records. */
  code?: Maybe<Scalars['String']['output']>;
  display?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Clinical onset. Null when the source did not state one. */
  onsetAt?: Maybe<Scalars['DateTime']['output']>;
  /** Our provenance label for the producer, e.g. zus. */
  source: Scalars['String']['output'];
  /** When the source recorded the assertion (FHIR recordedDate). Not a clinical date. */
  sourceRecordedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The record's id within its source. */
  sourceResourceId: Scalars['String']['output'];
  /** icd10, snomed or text. */
  system: Scalars['String']['output'];
};

/**
 * One condition as asserted across every source record that carries it: the records sharing a code
 * (or, for text-only records, a display) collapsed into one, with the dates they span. Excludes
 * records the source no longer returns.
 */
export type PlatformConditionSummary = {
  __typename?: 'ConditionSummary';
  /** The newest record's FHIR clinicalStatus, verbatim. Null when it omitted one. */
  clinicalStatus?: Maybe<Scalars['String']['output']>;
  /** ICD-10 when the records carried one, else SNOMED. Null for text-only records. */
  code?: Maybe<Scalars['String']['output']>;
  /** The newest record's display. */
  display?: Maybe<Scalars['String']['output']>;
  /** The earliest clinical onset any record states. Null when none states one. */
  firstOnsetAt?: Maybe<Scalars['DateTime']['output']>;
  /** The earliest date any source recorded the assertion. Not a clinical date. */
  firstRecordedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The newest date any source recorded the assertion. Not a clinical date. */
  lastRecordedAt?: Maybe<Scalars['DateTime']['output']>;
  /** How many source records assert it. */
  recordCount: Scalars['Int']['output'];
  /** icd10, snomed or text. */
  system: Scalars['String']['output'];
};

/**
 * Result of a confirmChatHistoryImport call: the accepted run, not its outcome.
 *
 * Read the outcome from the `chatHistoryImportConfirmProgress` workflow query,
 * or from the `chat-history-import-confirm-complete` log line, which carries
 * `filesLanded`, `filesNotLanded` and `rowsWritten`.
 */
export type PlatformConfirmChatHistoryImportResult = {
  __typename?: 'ConfirmChatHistoryImportResult';
  runId: Scalars['String']['output'];
  /** Temporal workflow ID, `chat-history-import-confirm-<runId>` */
  workflowId: Scalars['String']['output'];
};

/** Input for confirming a completed upload */
export type PlatformConfirmUploadInput = {
  /** The document ID returned from getDocumentUploadUrl */
  documentId: Scalars['ID']['input'];
  /**
   * When true, after confirming, files the upload into the patient's record, visible to the patient
   * and kept out of charting, and stores the record document id on the upload. Up to three tries; each
   * try audits a DOWNLOAD by the patient and extends retention. If filing fails the call fails, and the
   * upload stays confirmed but not filed. Absent or false: confirm only.
   */
  fileToPatientRecord?: InputMaybe<Scalars['Boolean']['input']>;
  /** Healthie user ID (required) - used to verify document ownership */
  healthieUserId: Scalars['ID']['input'];
};

/** Expandable legal detail for a CheckboxField, surfaced when its term is tapped. */
export type PlatformConsentDetail = {
  __typename?: 'ConsentDetail';
  blocks: Array<PlatformConsentDetailBlock>;
  title: Scalars['String']['output'];
};

/** One block of expandable consent detail copy. Blocks render in order. */
export type PlatformConsentDetailBlock = {
  __typename?: 'ConsentDetailBlock';
  /** Set for ORDERED_LIST blocks. */
  items?: Maybe<Array<Scalars['String']['output']>>;
  kind: PlatformConsentDetailBlockKind;
  /** Set for PARAGRAPH and SUBHEADING blocks. */
  text?: Maybe<Scalars['String']['output']>;
};

/** The kind of content block within a ConsentDetail — PARAGRAPH/SUBHEADING carry `text`, ORDERED_LIST carries `items`. */
export enum PlatformConsentDetailBlockKind {
  OrderedList = 'ORDERED_LIST',
  Paragraph = 'PARAGRAPH',
  Subheading = 'SUBHEADING'
}

/**
 * A patient's consent-banner state, captured client-side and recorded on the
 * session for downstream event-gating. Mirrors a CMP's consent event
 * (mode/autoShow/acceptedCategories) plus whether a consent cookie was
 * already present at capture.
 */
export type PlatformConsentSnapshot = {
  __typename?: 'ConsentSnapshot';
  /** Consent categories the visitor accepted, or null if not reported. */
  acceptedCategories?: Maybe<Array<Scalars['String']['output']>>;
  /** Whether the banner auto-displayed for this visitor, or null if not reported. */
  autoShow?: Maybe<Scalars['Boolean']['output']>;
  /** Whether a consent cookie was already present at capture time. */
  cookiePresent: Scalars['Boolean']['output'];
  /** Consent-banner interaction mode reported by the CMP (e.g. "explicit", "implicit"), or null if not reported. */
  mode?: Maybe<Scalars['String']['output']>;
};

/** An icon + optional title + body item on a ContentList. */
export type PlatformContentItem = {
  __typename?: 'ContentItem';
  /** Item body copy. */
  body: Scalars['String']['output'];
  /** Icon token; the client maps this to a glyph. Null (or unrecognized) renders no icon. */
  icon?: Maybe<Scalars['String']['output']>;
  /** Optional short label: the timing beside the title on a TIMELINE list (e.g. "Today"), a trailing pill on a DIVIDED list (e.g. "Free"). Null for none. */
  meta?: Maybe<Scalars['String']['output']>;
  /** Optional item title. */
  title?: Maybe<Scalars['String']['output']>;
};

/**
 * Page framing for a ContentStep. How the list itself renders is its
 * `ContentList.style`; a new design adds a value here only when it needs framing
 * the existing layouts lack.
 */
export enum PlatformContentLayout {
  /**
   * A program pitch: a centered eyebrow, the heading shown as the program's
   * sign, the body and illustration, then the list and note on a sheet.
   */
  ProgramOverview = 'PROGRAM_OVERVIEW',
  /**
   * A centered heading over the illustration, then the list and note on a
   * full-bleed sheet with the support line beneath them.
   */
  Sheet = 'SHEET',
  /** Heading, body and illustration, then the list, on the plain page. */
  Standard = 'STANDARD'
}

/**
 * A ContentStep's ordered items. The engine owns the copy and structure; the
 * client owns only the icon token → glyph map and must render no icon for a
 * token it doesn't recognize.
 */
export type PlatformContentList = {
  __typename?: 'ContentList';
  /** Optional section label shown above the items, or null. */
  heading?: Maybe<Scalars['String']['output']>;
  /** The items, in display order. */
  items: Array<PlatformContentItem>;
  /** How the items render. */
  style: PlatformContentListStyle;
};

/** How a ContentList renders its items. */
export enum PlatformContentListStyle {
  /** A stacked card per item. */
  Cards = 'CARDS',
  /** A divided icon list; an item's `meta` is a trailing pill. */
  Divided = 'DIVIDED',
  /** A dotted vertical timeline; an item's `meta` is its timing label. */
  Timeline = 'TIMELINE'
}

/** Short text shown beneath a ContentStep's list. */
export type PlatformContentNote = {
  __typename?: 'ContentNote';
  /** The note's copy. */
  text: Scalars['String']['output'];
  /** How the note is set. */
  tone: PlatformContentNoteTone;
};

/**
 * How a ContentNote is set. NEUTRAL is a grey alert, so a sheet's note can sit
 * quietly on the sheet.
 */
export enum PlatformContentNoteTone {
  /** Muted, centered fine print. */
  FinePrint = 'FINE_PRINT',
  /** A grey alert. */
  Neutral = 'NEUTRAL'
}

/**
 * Static content — interstitials, confirmations, and terminal end screens. Carries
 * no fields. Mid-flow, submitting advances the cursor with empty data; at a
 * terminal cursor (see `OnboardingSessionWithStep.terminal`) it's a leaf with no
 * advance, so `ctaLabel` is null.
 */
export type PlatformContentStep = {
  __typename?: 'ContentStep';
  /** When set, the CTA deep-links into the patient app at this path (resolved client-side against the app base URL) instead of advancing the flow — used by terminal steps like the existing-patient redirect. */
  appHref?: Maybe<Scalars['String']['output']>;
  /** Optional body copy beneath the heading. */
  body?: Maybe<Scalars['String']['output']>;
  /** Label for the CTA button, or null at a terminal with no CTA. */
  ctaLabel?: Maybe<Scalars['String']['output']>;
  /** Optional advance-button copy shown while its submit is in flight. Null falls back to the client's default ("Working…") — set only for steps whose submit does something worth naming. */
  ctaLoadingLabel?: Maybe<Scalars['String']['output']>;
  /** Optional small uppercase label shown above the heading, or null. */
  eyebrow?: Maybe<Scalars['String']['output']>;
  /** Heading shown to the patient. */
  heading: Scalars['String']['output'];
  /**
   * Semantic illustration token (e.g. a hero photo, an outcome-graph variant),
   * or null when the step has none. The client owns the token → art map and
   * must render nothing for a token it doesn't recognize.
   */
  illustration?: Maybe<Scalars['String']['output']>;
  /**
   * The step's item list, same items as `list.items`, or null when the step has
   * no list. Filled alongside `list` for one release.
   * @deprecated Use list.items
   */
  items?: Maybe<Array<PlatformContentItem>>;
  /** How the client frames the page around the list. STANDARD when the step declares no layout. */
  layout: PlatformContentLayout;
  /** Ordered items rendered beneath the body, or null when the step has none. */
  list?: Maybe<PlatformContentList>;
  /** Optional note shown beneath the list, or null. */
  note?: Maybe<PlatformContentNote>;
};

export type PlatformCopayOption = {
  __typename?: 'CopayOption';
  amountCents: Scalars['Int']['output'];
  supplyDurationDays?: Maybe<Scalars['Int']['output']>;
};

export type PlatformCorrectAccessReferralEvidenceInput = {
  accessEnrollmentId: Scalars['ID']['input'];
  diagnoses: Array<PlatformRecordAccessReferralDiagnosisInput>;
  failedAlignmentSubmissionId: Scalars['ID']['input'];
  measurements: Array<PlatformRecordAccessReferralMeasurementInput>;
};

export type PlatformCorrectMedicareBridgeIdentificationInput = {
  caseId: Scalars['ID']['input'];
  /** Retries with the same key write nothing further. Omit to treat the call as a new correction. */
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  /** Required. Stored on the ledger. Blank reasons are rejected. */
  reason: Scalars['String']['input'];
  to: PlatformMedicareBridgeIdentification;
};

/** The case after a successful identification correction. */
export type PlatformCorrectMedicareBridgeIdentificationPayload = {
  __typename?: 'CorrectMedicareBridgeIdentificationPayload';
  medicareBridgeCase: PlatformMedicareBridgeCase;
};

/** Insurance coverage/plan information */
export type PlatformCoverage = {
  __typename?: 'Coverage';
  /** Eligibility begin date */
  eligibilityBeginDate?: Maybe<Scalars['Date']['output']>;
  /** Plan end date */
  endDate?: Maybe<Scalars['Date']['output']>;
  /** Trading partner service ID from Stedi (payer ID) */
  payerId: Scalars['String']['output'];
  /** Payer/insurance company name */
  payerName: Scalars['String']['output'];
  /** Plan name/details */
  planName?: Maybe<Scalars['String']['output']>;
  /** Type of insurance plan */
  planType?: Maybe<PlatformInsuranceType>;
  /** Plan start date */
  startDate?: Maybe<Scalars['Date']['output']>;
  /** Coverage status */
  status: PlatformCoverageStatus;
};

/** Status of insurance coverage */
export enum PlatformCoverageStatus {
  /** Coverage is currently active */
  Active = 'ACTIVE',
  /** Coverage is not active */
  Inactive = 'INACTIVE',
  /** Coverage status could not be determined */
  Unknown = 'UNKNOWN'
}

/**
 * The payer-confirmed coverage the Stedi 271 returned, snapshotted on the
 * confirm-coverage submission. Drives the COVERAGE_FOUND review screen. Sensitive
 * identifiers (member id, group number) arrive already masked for display.
 */
export type PlatformCoverageSummary = {
  __typename?: 'CoverageSummary';
  /** Subscriber date of birth the payer has on file (as returned). */
  dateOfBirth?: Maybe<Scalars['String']['output']>;
  /** Subscriber first name the payer has on file. */
  firstName?: Maybe<Scalars['String']['output']>;
  /** Masked group number. Null when not applicable / not returned. */
  groupNumber?: Maybe<Scalars['String']['output']>;
  /** Subscriber last name the payer has on file. */
  lastName?: Maybe<Scalars['String']['output']>;
  /** Masked member id, e.g. W28****210. Null when the payer didn't return one. */
  memberId?: Maybe<Scalars['String']['output']>;
  /** Payer name. */
  payerName?: Maybe<Scalars['String']['output']>;
  /** Plan / group name as returned by the payer. */
  planName?: Maybe<Scalars['String']['output']>;
};

/** Input for creating a new booking session */
export type PlatformCreateBookingSessionInput = {
  /** Pre-populated date of birth */
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  /** Pre-populated email */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Employer name */
  employer?: InputMaybe<Scalars['String']['input']>;
  /** When the session expires */
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Partner-supplied identifier for correlating this referral with their own system */
  externalId?: InputMaybe<Scalars['String']['input']>;
  /** Pre-populated first name */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Insurer/payer name */
  insurer?: InputMaybe<Scalars['String']['input']>;
  /** Pre-populated last name */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Partner that initiated this session (e.g., 'amazon-hbc') */
  partner?: InputMaybe<Scalars['String']['input']>;
  /** Phone number, normalized to E.164 */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** 2-letter US state code */
  stateCode?: InputMaybe<Scalars['String']['input']>;
  /** Visit-reason category labels */
  visitReasons?: InputMaybe<Array<Scalars['String']['input']>>;
  /** 5-digit US ZIP code */
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

/** Input for linking a Healthie recurring appointment series to a cohort */
export type PlatformCreateCohortSeriesInput = {
  /** ID of the cohort to link the series to */
  cohortId: Scalars['ID']['input'];
  /** Healthie recurring appointment ID for this series */
  healthieRecurringAppointmentId: Scalars['String']['input'];
};

export type PlatformCreateDocumentRequestInput = {
  documentType: PlatformDocumentType;
  patientHealthieId: Scalars['ID']['input'];
  requestText: Scalars['String']['input'];
};

export type PlatformCreateEhrChartingNoteDraftInput = {
  /** The EHR appointment the note documents. Its EHR date becomes the note's date of service. */
  appointmentId: Scalars['ID']['input'];
  patient: PlatformEhrVitalsPatientInput;
};

export type PlatformCreateEhrChartingNoteDraftPayload = {
  __typename?: 'CreateEhrChartingNoteDraftPayload';
  /** Null when an existing draft was returned and nothing was written. */
  authoredBy?: Maybe<PlatformEhrChartingNoteAuthor>;
  /** The SOAP draft for this patient and appointment: the existing one, or the one just created. */
  chartingNoteId: Scalars['ID']['output'];
};

export type PlatformCreateEhrFormResponseInput = {
  /** The single answer text, written finished. */
  answer: Scalars['String']['input'];
  /** Ties the response to this EHR appointment. Left out or null, none. */
  appointmentId?: InputMaybe<Scalars['ID']['input']>;
  form: PlatformEhrForm;
  /** A JSON string stored with the response. Left out or null, none. */
  metadata?: InputMaybe<Scalars['String']['input']>;
  /** The note's name in the EHR. */
  name: Scalars['String']['input'];
  patient: PlatformEhrVitalsPatientInput;
};

export type PlatformCreateEhrFormResponsePayload = {
  __typename?: 'CreateEhrFormResponsePayload';
  /** The new EHR form response id. Null when the EHR rejected the write; messages then say why. */
  chartingNoteId?: Maybe<Scalars['ID']['output']>;
  messages: Array<PlatformEhrWriteMessage>;
};

export type PlatformCreateEhrWeightEntryInput = {
  /** When the weight was recorded, passed to the EHR as given. Left out, the EHR uses the time of the write. */
  createdAt?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** The weight, passed to the EHR as given. */
  metricStat: Scalars['String']['input'];
  /** Passed to the EHR when set. Left out, the EHR notifies the provider when the poster is a patient. */
  notifyProvider?: InputMaybe<Scalars['Boolean']['input']>;
  patient: PlatformEhrVitalsPatientInput;
};

export type PlatformCreateEhrWeightEntryPayload = {
  __typename?: 'CreateEhrWeightEntryPayload';
  /** The new EHR entry id. Null when the EHR rejected the write; messages then say why. */
  entryId?: Maybe<Scalars['ID']['output']>;
  messages: Array<PlatformEhrWriteMessage>;
};

/** Input parameters for creating a health metric entry (e.g., steps, activity minutes) via Healthie */
export type PlatformCreateHealthMetricEntryInput = {
  /** Metric category in Healthie (e.g., 'Steps', 'Activity Minutes') */
  category: Scalars['String']['input'];
  /** When the metric was recorded (ISO 8601) */
  createdAt: Scalars['DateTime']['input'];
  /** Optional description (e.g., 'Synced from Apple Health') */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The reading's id in the `externalIdType` system: 1 to 255 characters, not all whitespace. Set with `externalIdType`, or leave both unset. */
  externalId?: InputMaybe<Scalars['String']['input']>;
  /** The system the reading came from. Set with `externalId`, or leave both unset. Recorded with the reading where the store keeps it, never used to dedupe: a repeat creates another entry. Healthie doesn't store it. */
  externalIdType?: InputMaybe<PlatformJournalEntryExternalIdType>;
  /** Healthie user ID of the patient */
  healthieUserId: Scalars['ID']['input'];
  /** Metric value as a string (e.g., '5000', '30') */
  metricStat: Scalars['String']['input'];
  /** Third-party source identifier (e.g., 'apple_health', 'health_connect') */
  thirdPartySource?: InputMaybe<Scalars['String']['input']>;
};

/** Result of creating a health metric entry */
export type PlatformCreateHealthMetricEntryPayload = {
  __typename?: 'CreateHealthMetricEntryPayload';
  /** Healthie entry ID of the created metric entry */
  entryId: Scalars['ID']['output'];
};

export type PlatformCreateHealthieAppointmentInput = {
  appointmentTypeId: Scalars['ID']['input'];
  /** How the session connects. Common values: 'Secure Videochat', 'Healthie Video Call', 'phone_call'. Actual options depend on the appointment type. */
  contactType: Scalars['String']['input'];
  date: Scalars['String']['input'];
  location?: InputMaybe<Scalars['String']['input']>;
  /** Healthie patient ID */
  patientId: Scalars['ID']['input'];
  /** Healthie provider ID */
  providerId: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  timezone: Scalars['String']['input'];
};

export type PlatformCreateHealthieAppointmentResponse = {
  __typename?: 'CreateHealthieAppointmentResponse';
  appointment?: Maybe<PlatformHealthieAppointment>;
  messages: Array<PlatformHealthieMessage>;
};

export type PlatformCreateHealthiePatientInput = {
  additionalRecordIdentifier?: InputMaybe<Scalars['String']['input']>;
  /** Healthie ID of the assigned provider (dietitian) */
  assignedProviderId?: InputMaybe<Scalars['ID']['input']>;
  dob?: InputMaybe<Scalars['String']['input']>;
  /** Skip sending the Healthie welcome email */
  dontSendWelcome?: InputMaybe<Scalars['Boolean']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  gender?: InputMaybe<Scalars['String']['input']>;
  lastName: Scalars['String']['input'];
  legalName?: InputMaybe<Scalars['String']['input']>;
  /** JSON metadata blob */
  metadata?: InputMaybe<Scalars['String']['input']>;
  otherProviderIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  recordIdentifier?: InputMaybe<Scalars['String']['input']>;
  skippedEmail?: InputMaybe<Scalars['Boolean']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type PlatformCreateHealthiePatientResponse = {
  __typename?: 'CreateHealthiePatientResponse';
  messages: Array<PlatformHealthieMessage>;
  patient?: Maybe<PlatformHealthiePatient>;
};

/** Input for creating a comment on a journal entry */
export type PlatformCreateJournalEntryCommentInput = {
  /** Comment text content */
  content: Scalars['String']['input'];
  /** ID of the journal entry to comment on */
  entryId: Scalars['ID']['input'];
  /** Patient registry id of the commenting patient, `userId`'s. When set, it is checked against `userId`'s patient registry id, looked up (`BAD_USER_INPUT` when they differ), and `journal-comments-navihealth` is evaluated for it and the comment saved for it. Unset, it is looked up from `userId`. */
  patientRegistryId?: InputMaybe<Scalars['ID']['input']>;
  /** ID of the user creating the comment */
  userId: Scalars['ID']['input'];
};

/** Input for creating any journal entry type via the unified mutation */
export type PlatformCreateJournalEntryInput = {
  /** When the entry was recorded (defaults to current time) */
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /**
   * Who the entry is attributed to. Trusted callers only: the platform API key or a machine token;
   * any other caller that sets it gets `BAD_USER_INPUT`. Unset: LOSEIT for a LOSEIT_FOOD_LOG external
   * id, else PATIENT. When set it wins over that default, LOSEIT_FOOD_LOG included. Stored only where
   * the entry is stored in NaviHealth; Healthie requests are the same with or without it.
   */
  createdByKind?: InputMaybe<PlatformJournalEntryCreatedByKind>;
  /** Description or notes (required for FOOD, optional for others — validated server-side) */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Emotion tags — FOOD only */
  emotions?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Type of journal entry to create. WATER_INTAKE still works, but a day's water total belongs in upsertDailyTotal, which updates the day's entry instead of adding one. */
  entryType: PlatformJournalEntryType;
  /** The entry's id in the `externalIdType` system: 1 to 255 characters, not all whitespace. Set with `externalIdType`, or leave both unset. */
  externalId?: InputMaybe<Scalars['String']['input']>;
  /**
   * The system the entry came from. Set with `externalId`, or leave both unset. Where the entry is
   * stored in NaviHealth the pair is the create's idempotency key per patient: the first write wins,
   * a repeat with the same pair returns the existing entry and writes nothing, and deleting the entry
   * frees the pair. Healthie doesn't store the pair, so a create stored there is still not idempotent.
   */
  externalIdType?: InputMaybe<PlatformJournalEntryExternalIdType>;
  /** Image attachment — FOOD only */
  image?: InputMaybe<PlatformImageInput>;
  /** How the macros were sourced, stored with them — FOOD only. Read back as FoodJournalEntry.macroMetadata. */
  macroMetadata?: InputMaybe<PlatformFoodEntryMacroMetadataInput>;
  /** Meal category — FOOD only */
  mealType?: InputMaybe<PlatformMealType>;
  /** Metric value — required for WEIGHT, ACTIVITY, WATER_INTAKE, STOOL (validated server-side) */
  metricStat?: InputMaybe<Scalars['String']['input']>;
  /** Nutritional metrics — FOOD only */
  nutritionalMetrics?: InputMaybe<Array<PlatformNutritionalMetricInput>>;
  /** Custom symptom text — SYMPTOM only */
  otherSymptom?: InputMaybe<Scalars['String']['input']>;
  /** Healthie user id of the patient the entry is for. Ignored when `patientRegistryId` is set. */
  patientId?: InputMaybe<Scalars['ID']['input']>;
  /** Patient registry id of the patient the entry is for. Takes precedence over the Healthie id. At least one of the two is required. */
  patientRegistryId?: InputMaybe<Scalars['ID']['input']>;
  /** Symptom catalog ids (1-15) or names; while symptoms are stored in NaviHealth, an id outside the catalog is dropped and an unknown name is kept as an other symptom — SYMPTOM only */
  symptoms?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type PlatformCreateMedicationInput = {
  comments?: InputMaybe<Scalars['String']['input']>;
  directions?: InputMaybe<Scalars['String']['input']>;
  dosage: Scalars['String']['input'];
  endDate?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  patientId: Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export type PlatformCreateOnboardingEntryLinkInput = {
  facts?: InputMaybe<PlatformPatientFactsInput>;
  flowId: Scalars['String']['input'];
};

/** A patient's mailing address, mapped onto the Healthie client's primary location. Named CreatePatient-scoped to avoid colliding with other subgraphs' PatientAddressInput in the federated supergraph. */
export type PlatformCreatePatientAddressInput = {
  /** City */
  city?: InputMaybe<Scalars['String']['input']>;
  /** Street address (line 1). The only required address line. */
  line1: Scalars['String']['input'];
  /** Apartment, suite, unit, etc. */
  line2?: InputMaybe<Scalars['String']['input']>;
  /** Two-letter US state code */
  state?: InputMaybe<Scalars['String']['input']>;
  /** ZIP code */
  zip?: InputMaybe<Scalars['String']['input']>;
};

/**
 * What a booking knows about the patient it is creating. The platform decides
 * the patient's group from these neutral inputs; callers never send group ids.
 */
export type PlatformCreatePatientBookingInput = {
  /**
   * How the patient pays. Null sets no group, except for the two production
   * organizations with fixed groups (78783 and 8103), which keep theirs.
   */
  coverage?: InputMaybe<PlatformPatientCoverage>;
  /**
   * An opaque JSON object, stored as the new client's metadata. The platform
   * does not read its keys.
   */
  metadata?: InputMaybe<Scalars['String']['input']>;
  /** True when the provider brought the patient, rather than Berry Street. */
  providerSourced: Scalars['Boolean']['input'];
  /** The booking session id, stored as the new client's record identifier. */
  recordIdentifier?: InputMaybe<Scalars['String']['input']>;
};

/** A file to put in a patient's record. */
export type PlatformCreatePatientDocumentInput = {
  /** The file, base64-encoded. The platform API accepts request bodies up to 40 MB. */
  fileBase64: Scalars['String']['input'];
  /** Name shown for the document, also used as the file's name. */
  filename: Scalars['String']['input'];
  /** The patient, the domain's patient key. */
  healthieUserId: Scalars['ID']['input'];
  /** The file's MIME type. */
  mimeType: Scalars['String']['input'];
  /** Whether the patient can see the document. */
  visibleToPatient: Scalars['Boolean']['input'];
};

/**
 * Input for creating a brand-new patient identity, provisioning the patient in
 * Healthie in the same operation.
 */
export type PlatformCreatePatientInput = {
  /** Patient's mailing address. Set on the Healthie client at creation (e-prescribing + claims). Best-effort — a failure to persist the address never fails patient creation. */
  address?: InputMaybe<PlatformCreatePatientAddressInput>;
  /**
   * When false, a patient that already has an external id is rejected and left
   * unchanged. Omitted or true returns that patient with no Healthie call.
   * Onboarding sends false unless email ownership was proven by a trusted
   * channel, the session's own patient, or a completed challenge. A reservation
   * that still has no external id is resumed either way.
   */
  adoptProvisionedIdentity?: InputMaybe<Scalars['Boolean']['input']>;
  /** Canonical provider-registry id of the provider to assign as the patient's primary provider. Resolved to the provider's Healthie id internally at creation. */
  assignedProviderId: Scalars['ID']['input'];
  /**
   * Presence turns on booking mode; absent keeps the behaviour described on
   * `createPatient`. Booking mode links the client that already uses this email
   * instead of creating a second one, chooses the new client's group from
   * `coverage`, and makes sure the linked client is active with the assigned
   * provider as its primary.
   */
  booking?: InputMaybe<PlatformCreatePatientBookingInput>;
  /** Patient's date of birth */
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  /** Patient's email address — globally unique across the registry */
  email: Scalars['String']['input'];
  /** Patient's legal first name */
  firstName: Scalars['String']['input'];
  /** Patient's legal last name */
  lastName: Scalars['String']['input'];
  /** Patient's phone number */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Patient's sex at birth */
  sexAtBirth?: InputMaybe<Scalars['String']['input']>;
  /** Patient's IANA timezone (e.g. America/New_York), captured client-side. Set on the Healthie client at creation. */
  timezone?: InputMaybe<Scalars['String']['input']>;
};

/** Input for creating a new patient note. The authoring provider is inferred from the request context. */
export type PlatformCreatePatientNoteInput = {
  /** Free-text body content */
  body: Scalars['String']['input'];
  /** Internal patient-registry ID */
  patientId: Scalars['ID']['input'];
};

/** Omitted fields are not sent to Healthie. */
export type PlatformCreateReferringPhysicianInput = {
  businessName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  faxNumber?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<PlatformReferringPhysicianLocationInput>;
  npi?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  referral?: InputMaybe<PlatformReferringPhysicianReferralInput>;
  specialty?: InputMaybe<Scalars['String']['input']>;
};

export type PlatformCreateReferringPhysicianPayload = {
  __typename?: 'CreateReferringPhysicianPayload';
  /** The existing physician Healthie matched instead of creating one. */
  duplicatedPhysician?: Maybe<PlatformReferringPhysician>;
  /** Healthie's validation messages. Empty on success. */
  messages: Array<PlatformReferringPhysicianMessage>;
  /** The physician Healthie created. Null when Healthie matched an existing one or rejected the input. */
  referringPhysician?: Maybe<PlatformReferringPhysician>;
};

export type PlatformCreateSupportConversationInput = {
  /** References from prepareSupportAttachment, after upload succeeds. Omitted/null/empty sends text only. Files are revalidated and must belong to the acting provider. */
  attachmentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  message: Scalars['String']['input'];
  patientId?: InputMaybe<Scalars['String']['input']>;
  subject: Scalars['String']['input'];
  /** Tags to attach after creation. Omitted, null or empty retains required PRESCRIBER; duplicates are applied once. Tags do not grant conversation access. */
  tags?: InputMaybe<Array<PlatformSupportConversationTag>>;
};

export type PlatformCreateSupportConversationPayload = {
  __typename?: 'CreateSupportConversationPayload';
  /** Immediate public confirmation, including submitted context if setup needs repair. */
  conversation?: Maybe<PlatformSupportConversation>;
  /** Present once creation is acknowledged, even if subsequent setup fails. Never resend on partial setup. */
  conversationId?: Maybe<Scalars['ID']['output']>;
  error?: Maybe<PlatformSupportError>;
  /** Steps requiring manual repair in Intercom; creation is never retried automatically. */
  incompleteSteps: Array<Scalars['String']['output']>;
  setupComplete: Scalars['Boolean']['output'];
};

/** Grouping of a provider credential, for choosing an icon. */
export enum PlatformCredentialCategory {
  /** Health coaching, fitness or wellness credential (NBC-HWC, CPT, RYT). */
  CoachingFitness = 'COACHING_FITNESS',
  /** Academic degree (MS, MPH, PhD). */
  Degree = 'DEGREE',
  /** National dietitian registration (RD, RDN). */
  DieteticsCredential = 'DIETETICS_CREDENTIAL',
  /** Clinical specialty board certification (CDCES, CSSD, IBCLC). */
  SpecialtyCertification = 'SPECIALTY_CERTIFICATION',
  /** State licensure or certification to practice (LD, LDN, CDN). */
  StateLicense = 'STATE_LICENSE'
}

/**
 * A CRM event-processing ledger row. One per logical event (e.g. a Healthie
 * policy.created → Intercom sync). Temporal executes and owns transient retries;
 * this record is the durable, queryable state and the source for manual re-drive.
 * Bulk statistics are queried directly against the DB — this type exists for
 * single-row lookup (e.g. verifying a re-drive).
 */
export type PlatformCrmEvent = {
  __typename?: 'CrmEvent';
  /** How many times the event has been driven (initial run = 1, +1 per re-drive). */
  attempts: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** Trigger identifier, e.g. "healthie.policy.created". */
  eventName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Message from the most recent failure, if any. */
  lastError?: Maybe<Scalars['String']['output']>;
  /** When the event reached a terminal state. */
  processedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Primary resource the event concerns, e.g. the Healthie policy id. */
  resourceId: Scalars['String']['output'];
  /** pending | processing | completed | failed */
  status: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** Per-id outcome of a bulk retry request. */
export type PlatformCrmEventRetryResult = {
  __typename?: 'CrmEventRetryResult';
  /** Human-readable detail (e.g. the new workflow id, or why it was skipped). */
  detail?: Maybe<Scalars['String']['output']>;
  /** The requested CrmEvent id. */
  id: Scalars['ID']['output'];
  /** started | not-found | no-redrive-mapping */
  status: Scalars['String']['output'];
};

/** Result of preparing and delivering a complementary-program booking link. */
export type PlatformCrossSellBookingLinkDelivery = {
  __typename?: 'CrossSellBookingLinkDelivery';
  chatStatus: PlatformCrossSellChatDeliveryStatus;
  smsStatus: PlatformCrossSellSmsDeliveryStatus;
};

/** An eligible complementary-program offer for the authenticated provider's current session. */
export type PlatformCrossSellBookingOffer = {
  __typename?: 'CrossSellBookingOffer';
  /**
   * Whether chat no longer blocks the offer. True after the chat message was
   * accepted, or when the provider is a prescriber and chat is not used.
   */
  chatDeliveryCompleted: Scalars['Boolean']['output'];
  /**
   * When the link last reached the patient on a completed channel, or null when no
   * channel has completed. Chat is ignored for prescribers, who do not use chat.
   */
  sentAt?: Maybe<Scalars['DateTime']['output']>;
  /** Whether this appointment's Customer.io SMS event was already accepted. */
  smsDeliveryCompleted: Scalars['Boolean']['output'];
  targetProgram: PlatformCrossSellTargetProgram;
};

export enum PlatformCrossSellChatDeliveryStatus {
  AlreadyProcessed = 'ALREADY_PROCESSED',
  Failed = 'FAILED',
  InFlight = 'IN_FLIGHT',
  Sent = 'SENT',
  /** Chat was not attempted. A prescriber has no patient chat channel. */
  Skipped = 'SKIPPED'
}

export enum PlatformCrossSellSmsDeliveryStatus {
  AlreadyProcessed = 'ALREADY_PROCESSED',
  EventAccepted = 'EVENT_ACCEPTED',
  Failed = 'FAILED',
  InFlight = 'IN_FLIGHT'
}

export enum PlatformCrossSellTargetProgram {
  Glp_1 = 'GLP_1',
  Mnt = 'MNT'
}

/** ISO 4217 currency of an amount. */
export enum PlatformCurrency {
  Usd = 'USD'
}

/** Daily aggregated health metric stored locally (not forwarded to Healthie) */
export type PlatformDailyHealthMetric = {
  __typename?: 'DailyHealthMetric';
  /** Metric category */
  category: PlatformHealthMetricCategory;
  /** Date for the aggregated value (UTC) */
  date: Scalars['DateTime']['output'];
  /** Healthie patient user ID */
  healthieUserId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** Source of the data (e.g., 'apple_health', 'health_connect') */
  thirdPartySource?: Maybe<Scalars['String']['output']>;
  /** Aggregated value (e.g., total minutes, total calories) */
  value: Scalars['Float']['output'];
};

/**
 * Entry types upsertDailyTotal keeps a running total of per patient and local day. Water and steps
 * are one total per day (steps per day and source). Sleep is one total per sleep session: a
 * HealthKit night or a Health Connect session, named by the write's `externalId`, so a Health Connect
 * night with several sessions keeps one entry per session while the store is Healthie.
 */
export enum PlatformDailyTotalType {
  /** Minutes slept in one sleep session (a HealthKit night or a Health Connect session) counted toward that day */
  SleepDuration = 'SLEEP_DURATION',
  /** Steps taken that day, as a whole count */
  Steps = 'STEPS',
  /** Water drunk that day, in millilitres */
  WaterIntake = 'WATER_INTAKE'
}

/**
 * An ISO-8601 date input (YYYY-MM-DD). `min`/`max` are inclusive ISO dates.
 * Rendered as a MM/DD/YYYY masked text input; the value stays ISO `YYYY-MM-DD`.
 */
export type PlatformDateField = {
  __typename?: 'DateField';
  /** Optional helper text shown beneath the field. */
  helperText?: Maybe<Scalars['String']['output']>;
  /** Field id; the key to submit this value under. */
  id: Scalars['String']['output'];
  /** Label shown to the patient. */
  label: Scalars['String']['output'];
  /** Inclusive latest accepted date (ISO `YYYY-MM-DD`), if bounded. */
  max?: Maybe<Scalars['String']['output']>;
  /** Inclusive earliest accepted date (ISO `YYYY-MM-DD`), if bounded. */
  min?: Maybe<Scalars['String']['output']>;
  /**
   * Minimum age in years for inline client-side validation (e.g. an 18+ gate on
   * a date-of-birth field), or null when the field has no age floor. Server
   * eligibility remains the authority for correctness.
   */
  minAge?: Maybe<Scalars['Int']['output']>;
  /** Whether the patient must answer before advancing. */
  required: Scalars['Boolean']['output'];
};

/** Input for deleting a document */
export type PlatformDeleteDocumentInput = {
  /** The document ID to delete */
  documentId: Scalars['ID']['input'];
  /** Healthie user ID (required) - used to verify document ownership */
  healthieUserId: Scalars['ID']['input'];
  /** Healthie user ID of the person performing the delete (for audit logging) */
  performedByUserId: Scalars['ID']['input'];
  /**
   * When true and the upload is filed in the patient's record, first removes it from the record and
   * clears the stored record document id. If the removal fails the call fails and nothing is deleted.
   * Absent or false: soft delete only.
   */
  removeFromPatientRecord?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PlatformDeleteEhrMetricEntryInput = {
  /** The EHR entry id. Blank and NaviHealth (nh-) ids are BAD_USER_INPUT. */
  entryId: Scalars['ID']['input'];
  patient: PlatformEhrVitalsPatientInput;
};

export type PlatformDeleteEhrMetricEntryPayload = {
  __typename?: 'DeleteEhrMetricEntryPayload';
  /** False when the EHR rejected the delete; messages then say why. */
  deleted: Scalars['Boolean']['output'];
  messages: Array<PlatformEhrWriteMessage>;
};

/** Input for deleting a patient external ID record. */
export type PlatformDeletePatientExternalIdInput = {
  /** ID of the PatientExternalId record to delete */
  externalIdRecordId: Scalars['ID']['input'];
  /** Optional note explaining why this external ID is being removed (logged for audit purposes, not persisted) */
  note?: InputMaybe<Scalars['String']['input']>;
};

/** Input for deleting a provider external ID record. */
export type PlatformDeleteProviderExternalIdInput = {
  /** ID of the ProviderExternalId record to delete */
  externalIdRecordId: Scalars['ID']['input'];
  /** Optional note explaining why this external ID is being removed (logged for audit purposes, not persisted) */
  note?: InputMaybe<Scalars['String']['input']>;
};

export type PlatformDeleteReferringPhysicianInput = {
  /** Healthie's referring physician id. */
  id: Scalars['ID']['input'];
  /** The patient the physician must already be linked to. */
  patient: PlatformReferringPhysicianPatientInput;
};

export type PlatformDeleteReferringPhysicianPayload = {
  __typename?: 'DeleteReferringPhysicianPayload';
  /** The deleted physician's id. Null when Healthie rejected the delete. */
  deletedId?: Maybe<Scalars['ID']['output']>;
  /** Healthie's validation messages. Empty on success. */
  messages: Array<PlatformReferringPhysicianMessage>;
};

export type PlatformDeleteRudderstackSyncEventResult = {
  __typename?: 'DeleteRudderstackSyncEventResult';
  /** Whether a matching row was found and deleted. */
  deleted: Scalars['Boolean']['output'];
};

/** Dependent covered under the subscriber's policy */
export type PlatformDependent = {
  __typename?: 'Dependent';
  /** Mailing address */
  address?: Maybe<PlatformAddress>;
  /** Date of birth */
  dateOfBirth?: Maybe<Scalars['Date']['output']>;
  /** First name */
  firstName?: Maybe<Scalars['String']['output']>;
  /** Gender: F, M, or U (unknown) */
  gender?: Maybe<Scalars['String']['output']>;
  /** Group number (if provided by payer) */
  groupNumber?: Maybe<Scalars['String']['output']>;
  /** Last name */
  lastName?: Maybe<Scalars['String']['output']>;
  /** Member ID for the dependent (if provided by payer) */
  memberId?: Maybe<Scalars['String']['output']>;
  /** Middle name */
  middleName?: Maybe<Scalars['String']['output']>;
  /** Human-readable relationship description */
  relationToSubscriber?: Maybe<Scalars['String']['output']>;
  /** Relationship code to subscriber (e.g. 01=spouse, 19=child) */
  relationToSubscriberCode?: Maybe<Scalars['String']['output']>;
};

export type PlatformDeterminationDetails = {
  __typename?: 'DeterminationDetails';
  isExplicitPlanExclusion?: Maybe<Scalars['Boolean']['output']>;
  isOnFormulary?: Maybe<Scalars['Boolean']['output']>;
  isPriorAuthActingAsExceptionRequest?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Patient-reported diabetes type when the diabetes follow-up was asked.
 * Null when not asked (patient didn't flag diabetes/prediabetes upstream).
 * Prediabetes is represented via `ComorbidityFlag.PREDIABETES`, not here.
 */
export enum PlatformDiabetesType {
  Type_1 = 'TYPE_1',
  Type_2 = 'TYPE_2'
}

export type PlatformDiagnosis = {
  __typename?: 'Diagnosis';
  code: Scalars['String']['output'];
};

export type PlatformDiagnosisInput = {
  code: Scalars['String']['input'];
};

/** A group of results ordered and reported together. */
export type PlatformDiagnosticReport = {
  __typename?: 'DiagnosticReport';
  absentFromSourceAt?: Maybe<Scalars['DateTime']['output']>;
  /** LOINC when present, else the first real coding. Null for text-only reports. */
  code?: Maybe<Scalars['String']['output']>;
  /** The reporting clinician's free-text conclusion. */
  conclusion?: Maybe<Scalars['String']['output']>;
  conclusionCodes: Array<PlatformClinicalCoding>;
  display?: Maybe<Scalars['String']['output']>;
  /** End of the report's clinical period. */
  effectiveEnd?: Maybe<Scalars['DateTime']['output']>;
  /** Start of the report's clinical period. */
  effectiveStart?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  /** When the report was released. Not a clinical date. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * The report's stored results, including each component reading of a panel Observation. Excludes
   * soft-invalidated readings. A result the source never sent is missing here.
   */
  results: Array<PlatformMeasurement>;
  source: Scalars['String']['output'];
  sourceResourceId: Scalars['String']['output'];
  /** FHIR status, verbatim. */
  status?: Maybe<Scalars['String']['output']>;
  /** loinc, the coding's system URI, or text. */
  system: Scalars['String']['output'];
};

/** A live onboarding-owned MNT appointment hold. */
export type PlatformDietitianAppointmentHold = {
  __typename?: 'DietitianAppointmentHold';
  /** Authoritative scheduling expiry; clients derive the countdown from this instant. */
  expiresAt: Scalars['DateTime']['output'];
  providerId: Scalars['ID']['output'];
  startTime: Scalars['DateTime']['output'];
};

/** The requested provider/time is no longer open. The existing MNT hold, if any, is unchanged. */
export type PlatformDietitianAppointmentUnavailableError = {
  __typename?: 'DietitianAppointmentUnavailableError';
  message: Scalars['String']['output'];
  providerId: Scalars['ID']['output'];
  startTime: Scalars['DateTime']['output'];
};

export type PlatformDietitianAvailabilitySlot = {
  __typename?: 'DietitianAvailabilitySlot';
  startTime: Scalars['DateTime']['output'];
};

/**
 * Which dietitian card presentation this session sees, assigned server-side by
 * the `dietitian-card-variant` GrowthBook experiment.
 */
export enum PlatformDietitianCardVariant {
  /** Today's card. */
  Control = 'CONTROL',
  /** Spells out each credential with an icon. */
  Credentials = 'CREDENTIALS',
  /** Adds the patient rating and review count. */
  Reviews = 'REVIEWS'
}

/** One credential a dietitian lists, e.g. RDN. */
export type PlatformDietitianCredential = {
  __typename?: 'DietitianCredential';
  /** Icon grouping. Null when the acronym is not in the curated definitions. */
  category?: Maybe<PlatformDietitianCredentialCategory>;
  /** Acronym in display casing, e.g. `PhD`. */
  displayCode: Scalars['String']['output'];
  /** Spelled-out name. Null when the acronym is not in the curated definitions. */
  fullName?: Maybe<Scalars['String']['output']>;
};

/** Grouping of a dietitian credential, for choosing an icon. */
export enum PlatformDietitianCredentialCategory {
  CoachingFitness = 'COACHING_FITNESS',
  Degree = 'DEGREE',
  DieteticsCredential = 'DIETETICS_CREDENTIAL',
  SpecialtyCertification = 'SPECIALTY_CERTIFICATION',
  StateLicense = 'STATE_LICENSE'
}

/**
 * A ranked, eligible dietitian. List order is the booking-display order: AI
 * ranking (with Prioritized overrides hoisted first) when the ranking platform is
 * available, otherwise the heuristic tier order (Prioritized, visit-reason
 * matched, unmatched, Deprioritized — each by composite score descending). On
 * both paths, Deprioritized overrides — and providers under the caller's
 * `minimumBookingRank` floor — sink below every other provider, unless fewer
 * than 3 undemoted slot-having providers exist, in which case demoted providers
 * keep their ranked position so they can backfill a thin pool.
 */
export type PlatformDietitianMatch = {
  __typename?: 'DietitianMatch';
  /**
   * This provider's open MNT_INITIAL_VISIT slots within the request's
   * `availabilityWindow` — the same fetch used internally for ranking features,
   * surfaced so a caller doesn't have to query scheduling separately. Empty when
   * the provider has no openings, the caller passed no window, or the
   * availability fetch degraded (an outage here never fails matching itself).
   */
  availability: Array<PlatformDietitianAvailabilitySlot>;
  /** Server-computed specialty match used by picker presentation and filters. */
  isGreatMatch: Scalars['Boolean']['output'];
  /** Patient visit reasons this provider serves, de-duplicated in the patient's primary-then-secondary input order. */
  matchedVisitReasons: Array<Scalars['String']['output']>;
  provider: PlatformProvider;
};

/**
 * One window of ranked, eligible dietitians plus the coordinate where the next
 * window starts. Unlimited requests (`limit` null) return every match with a
 * null `nextOffset`.
 */
export type PlatformDietitianMatchPage = {
  __typename?: 'DietitianMatchPage';
  /**
   * Distinct non-English languages spoken across the patient's eligible pool
   * before the `languages` filter, sorted. Every value can be passed back as a
   * filter and return at least one eligible provider. Empty when no eligible
   * provider has a language on file.
   */
  availableLanguages: Array<Scalars['String']['output']>;
  /** Durable identity of this match call, used to join rendered-card analytics to the candidate set. */
  matchLogId: Scalars['ID']['output'];
  matches: Array<PlatformDietitianMatch>;
  /**
   * Canonical-rank offset of the next window, or null when no further
   * slot-having matches exist past this one. Pinned rows never shift this
   * coordinate space — page with this value, never by counting rows.
   */
  nextOffset?: Maybe<Scalars['Int']['output']>;
};

/** One ranked, eligible dietitian and that provider's open MNT initial-visit slots. */
export type PlatformDietitianOption = {
  __typename?: 'DietitianOption';
  /** Open MNT initial-visit times for this provider, ascending. */
  availability: Array<PlatformAvailabilitySlot>;
  /** Whole-dollar out-of-pocket price for each recurring follow-up. Null when the provider publishes no rate. */
  followUpSessionPriceUsd?: Maybe<Scalars['Int']['output']>;
  /**
   * Whole-dollar out-of-pocket price for this provider's initial visit at their
   * hourly cash-pay rate — the number a cash-pay booking bills. Null when the
   * provider publishes no rate (nutrition-program applies its default).
   */
  initialSessionPriceUsd?: Maybe<Scalars['Int']['output']>;
  /** Whether server-side specialty matching classified this provider as a great match. */
  isGreatMatch: Scalars['Boolean']['output'];
  /** Provider-match log row this rendered option belongs to. */
  matchLogId: Scalars['ID']['output'];
  /** Patient visit reasons this provider matches, in the patient's submitted order. */
  matchedVisitReasons: Array<Scalars['String']['output']>;
  profile: PlatformDietitianProfile;
  /** Canonical provider-registry id. */
  providerId: Scalars['ID']['output'];
};

/**
 * One page of the dietitian-picker read model. Match inputs and ranking
 * experiments are derived server-side from the onboarding session; the browser
 * supplies only the opaque session handle. Pages contain only providers with
 * an opening in the requested `availableBetween` range, in the rank order
 * computed over the whole scheduling window — a page can never understate
 * availability, and an empty first page means no matched provider has a
 * bookable slot in that range.
 */
export type PlatformDietitianOptions = {
  __typename?: 'DietitianOptions';
  /**
   * The range this page was filtered by: the requested `availableBetween`, or
   * the default next 14 days, intersected with the scheduling window. The date
   * filter opens on it.
   */
  availableBetween: PlatformAvailabilityRange;
  /**
   * Non-English languages spoken by the session's matched dietitians before the
   * `languages` filter, sorted — the language filter's options. Empty when no
   * matched dietitian has a language on file; the client hides the filter then.
   */
  availableLanguages: Array<Scalars['String']['output']>;
  /**
   * Card presentation for this session. Stable per visitor (bucketed like the
   * ranking experiments); CONTROL when GrowthBook is unavailable.
   */
  cardVariant: PlatformDietitianCardVariant;
  currentHold?: Maybe<PlatformDietitianAppointmentHold>;
  followUpDurationMinutes: Scalars['Int']['output'];
  initialVisitDurationMinutes: Scalars['Int']['output'];
  /**
   * The furthest instant the read can reach — the last instant the date filter
   * can usefully select.
   */
  maxSchedulingWindowEnd: Scalars['DateTime']['output'];
  /**
   * Offset to request the next page with, in matching's canonical rank
   * coordinates. Null when no further page exists. Clients page with this
   * value, never by counting rows — a pinned held provider can make a page
   * one row longer without moving the coordinate space.
   */
  nextOffset?: Maybe<Scalars['Int']['output']>;
  options: Array<PlatformDietitianOption>;
  /**
   * Exclusive upper bound of the scheduling window every page's availability was
   * read against. The lower bound is the request instant. It reaches past the
   * default window when `availableBetween` does.
   */
  schedulingWindowEnd: Scalars['DateTime']['output'];
};

/**
 * Onboarding-owned provider snapshot returned by the dietitian aggregate. The
 * canonical source remains provider-matching's `Provider.profile`; onboarding
 * copies the value because its Next.js client consumes this subgraph directly.
 */
export type PlatformDietitianProfile = {
  __typename?: 'DietitianProfile';
  /** Mean of those ratings (1-5). Null exactly when reviewCount is 0. */
  averageRating?: Maybe<Scalars['Float']['output']>;
  cashPayRate?: Maybe<Scalars['Float']['output']>;
  /** The credentials string split into individual credentials, in listed order. Empty when `credentials` lists none. */
  credentialDetails: Array<PlatformDietitianCredential>;
  credentials?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** Non-English languages the dietitian speaks, sorted. Empty means English only or none on file. */
  languages: Array<Scalars['String']['output']>;
  longBio?: Maybe<Scalars['String']['output']>;
  recurringEnabled: Scalars['Boolean']['output'];
  /** Count of 1-5 star post-visit ratings patients have left, all time. 0 when unrated. */
  reviewCount: Scalars['Int']['output'];
  shortBio?: Maybe<Scalars['String']['output']>;
  specialtyCategories: Array<Scalars['String']['output']>;
};

/**
 * A document uploaded by a patient.
 * Supports soft delete and 7-year retention for HIPAA compliance.
 */
export type PlatformDocument = {
  __typename?: 'Document';
  /** When the S3 upload was verified */
  confirmedAt?: Maybe<Scalars['DateTime']['output']>;
  /** When the document record was created */
  createdAt: Scalars['DateTime']['output'];
  /** The request this document answers. Null for a freeform upload. */
  documentRequest?: Maybe<PlatformDocumentRequest>;
  /** Type of document (LAB, etc.) */
  documentType: PlatformDocumentType;
  /**
   * Id of this upload's copy in the patient's EHR record, as returned by
   * medication-program's `ehrDocuments` (`EhrDocument.id`). Null until the copy
   * exists. Treat it as opaque.
   */
  ehrDocumentId?: Maybe<Scalars['ID']['output']>;
  /** File size in bytes */
  fileSize: Scalars['Int']['output'];
  /** Original filename provided by the user */
  filename: Scalars['String']['output'];
  /** Healthie document ID (set after successful Healthie sync). Same value as `ehrDocumentId`; new callers read `ehrDocumentId`. */
  healthieDocumentId?: Maybe<Scalars['ID']['output']>;
  /** Healthie user ID of the patient who owns this document */
  healthieUserId: Scalars['ID']['output'];
  /** Unique identifier */
  id: Scalars['ID']['output'];
  /** MIME type of the file (application/pdf, image/jpeg, image/png) */
  mimeType: Scalars['String']['output'];
};

/** Input for requesting a presigned download URL */
export type PlatformDocumentDownloadInput = {
  /** The document ID to download */
  documentId: Scalars['ID']['input'];
  /** Healthie user ID (required) - used to verify document ownership */
  healthieUserId: Scalars['ID']['input'];
  /** Healthie user ID of the person performing the download (for audit logging) */
  performedByUserId: Scalars['ID']['input'];
};

/** Filter options for documents queries */
export type PlatformDocumentFiltersInput = {
  /** Optional filter by document type */
  documentType?: InputMaybe<PlatformDocumentType>;
  /** Healthie user ID (required) - passed from patient-app-api after JWT validation */
  healthieUserId: Scalars['ID']['input'];
};

/** The patient whose documents a call reads. */
export type PlatformDocumentPatientInput = {
  /** The caller's EHR patient id (the Healthie user id today). The platform always reads this patient's documents; the registry is only checked against it. */
  externalId: Scalars['ID']['input'];
  /** Berry Street patient registry id, when the caller has one. */
  patientId?: InputMaybe<Scalars['ID']['input']>;
};

/** Federation stub — resolved by document-upload subgraph. */
export type PlatformDocumentRequest = {
  __typename?: 'DocumentRequest';
  /** Set when status leaves OPEN. Null while open. */
  closedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /** Count of confirmed, not-deleted linked documents. Derived; not stored. */
  documentCount: Scalars['Int']['output'];
  documentType: PlatformDocumentType;
  /** Confirmed, not-deleted linked documents only. */
  documents: Array<PlatformDocument>;
  id: Scalars['ID']['output'];
  /** Latest confirmed linked document timestamp. Null when none. Derived. */
  lastDocumentAt?: Maybe<Scalars['DateTime']['output']>;
  patientHealthieId: Scalars['ID']['output'];
  /** Required for every documentType. Blank/whitespace rejected at the service. */
  requestText: Scalars['String']['output'];
  /** Canonical provider-registry id. Null for system/CX-raised rows not created via this GraphQL surface. Never a Healthie id. */
  requestedByProviderId?: Maybe<Scalars['ID']['output']>;
  status: PlatformDocumentRequestStatus;
  updatedAt: Scalars['DateTime']['output'];
};

export type PlatformDocumentRequestDownloadInput = {
  /** A confirmed document linked to this exact request. */
  documentId: Scalars['ID']['input'];
  /** The request through which the acting provider may access the document. */
  documentRequestId: Scalars['ID']['input'];
};

export enum PlatformDocumentRequestOutcome {
  Cancelled = 'CANCELLED',
  Resolved = 'RESOLVED'
}

export enum PlatformDocumentRequestStatus {
  Cancelled = 'CANCELLED',
  Open = 'OPEN',
  Resolved = 'RESOLVED'
}

/** Type of document uploaded by the patient, and of a provider document request. */
export enum PlatformDocumentType {
  /** Lab results and test reports */
  Lab = 'LAB',
  /** Anything that is not a lab document. Specifics live in requestText when this is a request. */
  Other = 'OTHER'
}

/**
 * The submitted version is no longer current. Carries the now-current version so
 * the client can re-render and re-attest without a refetch.
 */
export type PlatformDocumentVersionSupersededError = {
  __typename?: 'DocumentVersionSupersededError';
  currentVersion: PlatformProviderDocumentVersion;
  documentId: Scalars['ID']['output'];
  message: Scalars['String']['output'];
};

/** Response containing a presigned URL for downloading a document from S3 */
export type PlatformDownloadUrlResponse = {
  __typename?: 'DownloadUrlResponse';
  /** The presigned S3 URL for downloading the file (expires in 5 minutes) */
  downloadUrl: Scalars['String']['output'];
  /** When the presigned URL expires */
  expiresAt: Scalars['DateTime']['output'];
};

export type PlatformDrugBenefitsResult = {
  __typename?: 'DrugBenefitsResult';
  copayDisplay?: Maybe<Scalars['String']['output']>;
  copayOptions: Array<PlatformCopayOption>;
  coverage: PlatformDrugCoverage;
  /** insurer_reported_value | diagnoses_not_covered | quantity_limit_pa_required | ... */
  coverageDetailCode?: Maybe<Scalars['String']['output']>;
  determinationDetails?: Maybe<PlatformDeterminationDetails>;
  dose?: Maybe<Scalars['String']['output']>;
  hasActivePriorAuth?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  ndc?: Maybe<Scalars['String']['output']>;
  priorAuthRequired: PlatformPaRequirement;
  product: PlatformGlp1Product;
  quantity?: Maybe<Scalars['Int']['output']>;
  /**
   * Catalog-derived display fields resolved at read time from the GLP-1 SKU
   * catalog (not persisted on the BenefitsCheck row). Null when ndc is missing
   * or no longer matches a known SKU.
   */
  skuId?: Maybe<Scalars['ID']['output']>;
};

export enum PlatformDrugCoverage {
  Covered = 'COVERED',
  NotCovered = 'NOT_COVERED'
}

/**
 * A pending or unexpired approved prior authorization for the same product
 * already exists. No new prior authorization was created. The existing row is
 * linked to this case only when it is an allowed Bridge package submitted at
 * or after the case opened and at or after the current eligible review, and
 * it is not already linked to another case. `message` names a Medicare Bridge
 * prior authorization when that row is linked to this case. Otherwise it says
 * the prior authorization is not linked to this case.
 */
export type PlatformDuplicateBridgePriorAuth = {
  __typename?: 'DuplicateBridgePriorAuth';
  caseId: Scalars['ID']['output'];
  existingPriorAuthorization: PlatformPriorAuthorization;
  message: Scalars['String']['output'];
};

/**
 * A bespoke, data-fetching screen. The client renders custom UI for `kind`
 * (fetching that kind's data itself) and submits the values for `fields` — the
 * validated submission contract (e.g. a single `appointmentTime`).
 */
export type PlatformDynamicStep = {
  __typename?: 'DynamicStep';
  /** Field values to seed on rewind (field id → prior value), or null. */
  currentValues?: Maybe<Scalars['JSON']['output']>;
  /** The validated submission contract for this screen. */
  fields: Array<PlatformStepField>;
  /** Which bespoke screen to render (and which data the client fetches). */
  kind: PlatformDynamicStepKind;
};

/**
 * Which bespoke screen a DynamicStep renders — and, implicitly, which data the
 * client fetches for it.
 */
export enum PlatformDynamicStepKind {
  /** Final terminal for an ACCESS-only journey whose enrollment started (ENROLLED or PROCESSING): checking-eligibility copy while the Medicare eligibility check runs, with app-store links; fetches nothing and submits nothing. */
  AccessEligibilityPending = 'ACCESS_ELIGIBILITY_PENDING',
  /** One-time add-program offer after a single-program commercial menu pick: the `add_program` choice's non-`skip` option names the offered program (copy is client-owned, keyed by that value); submits that program or `skip`. */
  AddProgramOffer = 'ADD_PROGRAM_OFFER',
  /** Already-scheduled terminal (GLPX-241): fetches `alreadyScheduledAppointment`, renders the patient's existing upcoming consult (date/time + prescriber) with the same app-download card as the booked screen; submits nothing. */
  AlreadyScheduled = 'ALREADY_SCHEDULED',
  /** Booked-appointment confirmation (terminal): fetches `bookedAppointment`, renders the booked time; submits nothing. */
  AppointmentConfirmation = 'APPOINTMENT_CONFIRMATION',
  /**
   * Time-first appointment picker: fetches `availability`. When
   * `availability.prescribers` is non-empty, tapping a time calls
   * `holdGlp1Appointment` (with the chosen prescriber, or none for "Any
   * available clinician"), and the step submits `appointmentTime`, the held
   * `providerId` and `prescriberChoice` (`ANY` or `PRESCRIBER`). Otherwise it
   * submits `appointmentTime` alone. The submission books nothing. With a
   * `providerId`, the flow's booking step books exactly that prescriber at that
   * time if they are still displayed with it open, whether or not the hold is
   * still live, and never substitutes another prescriber: otherwise it returns
   * the patient here with an inline "time no longer available" retry. Without
   * one, confirm assigns a free prescriber server-side.
   */
  AppointmentPicker = 'APPOINTMENT_PICKER',
  /** Final shared post-booking terminal with Berry Street app-download actions. */
  AppDownload = 'APP_DOWNLOAD',
  /**
   * Post-booking introduction to the booked GLP-1 prescriber (non-terminal):
   * fetches `bookedAppointment` and renders its `prescriber` and
   * `appointmentTime`; submits nothing. Reached only after the flow's booking
   * commit recorded a booked GLP-1 consult, and only for a session that was
   * offered the prescriber chooser.
   */
  BookingCelebration = 'BOOKING_CELEBRATION',
  /** Commit confirmation and recovery host: submits consent fields, lets the client emit a conversion for a newly started booking or ACCESS enrollment before navigating, and keeps recoverable GLP-1/MNT input failures on the current confirmation step while the client renders the named input editor in place. */
  BookingConfirm = 'BOOKING_CONFIRM',
  /** Optional referring-provider form with CMS NPI Registry autocomplete and manual entry. */
  CareTeam = 'CARE_TEAM',
  /** Express cash-pay agreement: renders from `cashPayContext` (`agreementVariant` picks the copy, `declined` selects the resting explanation) and submits `cash_pay_agreement` as `agree` or `decline`. Agreement is the only source of CASH_PAY booking classification; a decline with nothing else live rests on this step. */
  CashPayAgreement = 'CASH_PAY_AGREEMENT',
  /** Booked GLP-1/MNT appointments and ACCESS outcomes after the shared welcome-v2 confirmation. */
  CombinedResults = 'COMBINED_RESULTS',
  /** Coverage-found review: fetches `coverageSummary` (the payer-confirmed insurance from the Stedi check), renders it read-only for the patient to confirm; submits nothing. */
  CoverageFound = 'COVERAGE_FOUND',
  /** Credit-card capture (Stripe Elements): tokenizes the card client-side, submits the single-use `stripe_token` (+ `card_label`). The card attaches to the patient at booking commit. */
  CreditCard = 'CREDIT_CARD',
  /** Provider-first MNT picker: fetches `dietitianOptions`, holds a selected provider/time, and submits authoritative `providerId` + `appointmentTime` values. */
  DietitianPicker = 'DIETITIAN_PICKER',
  /** GLP-1 ineligible explanation (GLPX-309): fetches `glp1IneligibleOutcome`, renders reason-bucket copy; submits nothing. Non-final — a lead without ACCESS rests here. */
  Glp1Ineligible = 'GLP1_INELIGIBLE',
  /**
   * Optional front/back insurance-card photo capture. The engine includes this
   * step for any journey whose coverage snapshot carries a member id and a
   * selected payer — every program commit attempts the best-effort Healthie
   * policy write, so cash-pay journeys are the only ones with nothing to
   * attach to. Submits `card_front` / `card_back` as base64-encoded JPEG, PNG,
   * HEIC, or HEIF bytes with their MIME types (HEIC/HEIF is converted to JPEG
   * before the Healthie policy write); an empty form skips with no writes.
   */
  InsuranceCardUpload = 'INSURANCE_CARD_UPLOAD',
  /** Medical-background form whose optional sections are controlled by `medicalBackgroundContext`. */
  MedicalBackground = 'MEDICAL_BACKGROUND',
  /** Payer picker: fetches `payerOptions` (big-five cards + long-tail typeahead), submits the chosen `payerId` and `label`. */
  PayerPicker = 'PAYER_PICKER',
  /**
   * Skippable prescription-photo capture for a patient who reports currently
   * taking a GLP-1. Submits `photo` as base64 JPEG or PNG with `photo_content_type`,
   * or `skipped` = `true` with no photo. A saved photo is not echoed back;
   * `delivery` is `saved`, `staged`, or `skipped`.
   */
  PrescriptionPhoto = 'PRESCRIPTION_PHOTO',
  /** Program select menu: renders a selector card per option on the step's `programs` field (card copy is client-owned, keyed by option value), submits the chosen `programs` values. */
  ProgramMenu = 'PROGRAM_MENU',
  /** Secondary visit-reason picker (multi-select, optional): fetches `visitReasonOptions` excluding the primary pick, submits any additional category labels as `secondary_visit_reasons`. */
  VisitReasonsSecondary = 'VISIT_REASONS_SECONDARY',
  /** Primary visit-reason picker (single-select): fetches `visitReasonOptions`, submits the chosen category label as `primary_visit_reason`. */
  VisitReasonPrimary = 'VISIT_REASON_PRIMARY'
}

export type PlatformEditAccessCarePlanInput = {
  carePlanId: Scalars['ID']['input'];
  /** NP identifier from the review surface (persisted on the version + audit event). */
  editedBy: Scalars['String']['input'];
  edits: PlatformCarePlanNarrativeEditsInput;
};

/** An entry on the patient's EHR chart. Null chartingNote when the entry is a document, not a note. */
export type PlatformEhrChartingItem = {
  __typename?: 'EhrChartingItem';
  chartingNote?: Maybe<PlatformEhrChartingNote>;
  id: Scalars['ID']['output'];
};

/**
 * A charting note (a Healthie form answer group), read live and not persisted. Dates are the EHR's
 * own strings, unparsed. A null is a value the EHR returned as null.
 */
export type PlatformEhrChartingNote = {
  __typename?: 'EhrChartingNote';
  addendums: Array<PlatformEhrChartingNoteAddendum>;
  appointment?: Maybe<PlatformEhrChartingNoteAppointment>;
  /** The EHR's status, for example SIGNED or SIGNED_AND_LOCKED. */
  chartNoteStatus?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  /** The EHR's id of the form the note was filled on. */
  customModuleFormId?: Maybe<Scalars['ID']['output']>;
  /** Set when the note was deleted in the EHR. */
  deletedAt?: Maybe<Scalars['String']['output']>;
  /** False for a saved draft. */
  finished: Scalars['Boolean']['output'];
  formAnswers: Array<PlatformEhrChartingNoteAnswer>;
  /** The EHR's note id. */
  id: Scalars['ID']['output'];
  isLocked: Scalars['Boolean']['output'];
  /** A JSON string the writer stored with the note. */
  metadata?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  patient?: Maybe<PlatformEhrChartingNotePatient>;
  signings: Array<PlatformEhrChartingNoteSigning>;
  updatedAt: Scalars['String']['output'];
};

export type PlatformEhrChartingNoteAddendum = {
  __typename?: 'EhrChartingNoteAddendum';
  content?: Maybe<Scalars['String']['output']>;
  /** In the EHR's own datetime format. */
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type PlatformEhrChartingNoteAnswer = {
  __typename?: 'EhrChartingNoteAnswer';
  answer?: Maybe<Scalars['String']['output']>;
  customModuleId?: Maybe<Scalars['ID']['output']>;
  customModuleLabel?: Maybe<Scalars['String']['output']>;
  customModuleModType?: Maybe<Scalars['String']['output']>;
  /** The answer as the EHR renders it. */
  displayedAnswer?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  /** In the EHR's own datetime format. Null when the EHR returned none. */
  updatedAt?: Maybe<Scalars['String']['output']>;
  /** The EHR user id the answer was written for. */
  userId?: Maybe<Scalars['ID']['output']>;
};

export type PlatformEhrChartingNoteAppointment = {
  __typename?: 'EhrChartingNoteAppointment';
  appointmentTypeName?: Maybe<Scalars['String']['output']>;
  /** In the EHR's own datetime format. */
  date?: Maybe<Scalars['String']['output']>;
  /** The EHR's appointment id. */
  id: Scalars['ID']['output'];
  pmStatus?: Maybe<Scalars['String']['output']>;
  /** The EHR user id the appointment belongs to. Null when the EHR returned none. */
  userId?: Maybe<Scalars['String']['output']>;
};

/** Who the EHR records as the author of a charting note write. */
export enum PlatformEhrChartingNoteAuthor {
  Organization = 'ORGANIZATION',
  Provider = 'PROVIDER'
}

export enum PlatformEhrChartingNoteContentOutcome {
  KeptSigned = 'KEPT_SIGNED',
  Saved = 'SAVED'
}

/** The order `ehrChartingNotes` asks the EHR for. */
export enum PlatformEhrChartingNoteOrder {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export type PlatformEhrChartingNotePatient = {
  __typename?: 'EhrChartingNotePatient';
  firstName?: Maybe<Scalars['String']['output']>;
  /** The EHR user id. */
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
};

export type PlatformEhrChartingNoteSigning = {
  __typename?: 'EhrChartingNoteSigning';
  /** The EHR user id of the signer. Null when the EHR returned no user. */
  userId?: Maybe<Scalars['ID']['output']>;
};

export enum PlatformEhrChartingNoteStepOutcome {
  AlreadyDone = 'ALREADY_DONE',
  Done = 'DONE',
  Failed = 'FAILED',
  NotRequested = 'NOT_REQUESTED',
  SkippedDeadline = 'SKIPPED_DEADLINE',
  SkippedOrganizationAuth = 'SKIPPED_ORGANIZATION_AUTH',
  SkippedUnsigned = 'SKIPPED_UNSIGNED'
}

/** Which of the patient's EHR charting notes `ehrChartingNotes` returns: one page, in the order given. */
export type PlatformEhrChartingNotesInput = {
  /** Only notes on this form. Left out, notes on every form. */
  form?: InputMaybe<PlatformEhrForm>;
  /** How many notes to skip. Negative is BAD_USER_INPUT. */
  offset: Scalars['Int']['input'];
  /** Required, never defaulted: callers that take the first note depend on it. */
  orderBy: PlatformEhrChartingNoteOrder;
  /** Page size, 1 to 100 (the EHR's cap). Anything else is BAD_USER_INPUT. */
  pageSize: Scalars['Int']['input'];
  patient: PlatformEhrVitalsPatientInput;
  /** True returns only notes on forms marked for charting. Left out, the EHR applies no such filter. */
  useForCharting?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The EHR user who wrote a comment. */
export type PlatformEhrCommentAuthor = {
  __typename?: 'EhrCommentAuthor';
  /** Null when the EHR returned no avatar. */
  avatarUrl?: Maybe<Scalars['String']['output']>;
  /** Null when the EHR returned no name. */
  fullName?: Maybe<Scalars['String']['output']>;
  /** The EHR user id. */
  id: Scalars['ID']['output'];
};

/**
 * A file in the patient's EHR record, read live (metadata only). Not persisted
 * locally. Not the files that answer a document request, which are
 * `DocumentRequest.documents` on the document-upload subgraph.
 */
export type PlatformEhrDocument = {
  __typename?: 'EhrDocument';
  contentType?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  displayName?: Maybe<Scalars['String']['output']>;
  extension?: Maybe<Scalars['String']['output']>;
  /**
   * Id of the file, as returned by `ehrDocuments`; Healthie document ids today.
   * Treat it as opaque. Callers store it (the provider portal's opened-file
   * state and lab alert keys), so its value must not change for a file.
   * Equals `Document.ehrDocumentId` for the EHR copy of a patient upload.
   */
  id: Scalars['ID']['output'];
};

/** The patient whose EHR record `ehrDocuments` or `ehrPrescriptions` reads. */
export type PlatformEhrDocumentPatientInput = {
  /** The caller's EHR patient id (the Healthie user id today). Both reads read this patient's record; only `ehrDocuments` checks the registry against it. A blank value is BAD_USER_INPUT for `ehrDocuments`; an empty string returns no prescriptions from `ehrPrescriptions`. */
  externalId: Scalars['ID']['input'];
  /** Berry Street patient registry id, when the caller has one. `ehrPrescriptions` ignores it. */
  patientId?: InputMaybe<Scalars['ID']['input']>;
};

/** A GLP-1 form: `ehrChartingNotes` filters by it and `createEhrFormResponse` writes one response to it. The caller never names a form id. */
export enum PlatformEhrForm {
  /** The GLP-1 follow-up questionnaire. */
  Glp1FollowUpQuestionnaire = 'GLP1_FOLLOW_UP_QUESTIONNAIRE',
  /** The GLP-1 screening intake form. */
  Glp1Screening = 'GLP1_SCREENING'
}

/** The height and weight on the patient's EHR profile, read live. Every value is the EHR's string, unparsed. */
export type PlatformEhrHeightWeight = {
  __typename?: 'EhrHeightWeight';
  /** The height in inches as a bare number, for example "73.0". */
  height?: Maybe<Scalars['String']['output']>;
  /** The height with its units. */
  heightStr?: Maybe<Scalars['String']['output']>;
  /** The last weight, for example "171.0 Lbs". */
  weight?: Maybe<Scalars['String']['output']>;
  weightPercentile?: Maybe<Scalars['String']['output']>;
  weightPercentileStandard?: Maybe<Scalars['String']['output']>;
};

/**
 * Which of the patient's EHR measurement entries `ehrMetricEntries` returns. Dates bound by whole
 * days. A value left out is not sent, so the EHR applies no filter or its own order.
 */
export type PlatformEhrMetricEntriesInput = {
  /** One EHR metric category, passed as given (for example heart_rate or Weight). Left out, every category. */
  category?: InputMaybe<Scalars['String']['input']>;
  /** A date; entries before the start of that day. */
  endDate?: InputMaybe<Scalars['String']['input']>;
  /** Sort by the entry's creation time. Left out, the EHR applies its own order. */
  orderBy?: InputMaybe<PlatformEhrMetricEntryOrder>;
  patient: PlatformEhrVitalsPatientInput;
  /** A date such as 2026-10-01; entries from the start of that day. */
  startDate?: InputMaybe<Scalars['String']['input']>;
};

/**
 * A measurement entry in the patient's EHR record (a Healthie metric entry such as weight, height,
 * heart rate or blood pressure), read live and not persisted. Values are what the EHR returned,
 * unparsed. Activity, steps, sleep duration, water and stool entries are journaling's, never these.
 */
export type PlatformEhrMetricEntry = {
  __typename?: 'EhrMetricEntry';
  /** The EHR's category name, for example Heart Rate. */
  category?: Maybe<Scalars['String']['output']>;
  /** The entry's comments in the EHR. */
  comments: Array<PlatformEhrMetricEntryComment>;
  /** When the entry was recorded, in the EHR's own datetime format (not always ISO 8601). */
  createdAt?: Maybe<Scalars['String']['output']>;
  /** Free text the poster added. Null when the EHR returned none. */
  description?: Maybe<Scalars['String']['output']>;
  /** The EHR's entry id. */
  id: Scalars['ID']['output'];
  /** The value as the EHR stores it, with no unit. */
  metricStat?: Maybe<Scalars['Float']['output']>;
  /** The value as the EHR formats it. */
  metricStatString?: Maybe<Scalars['String']['output']>;
  /** The EHR user id of whoever posted the entry. */
  posterId?: Maybe<Scalars['ID']['output']>;
  /** The poster's IANA timezone in the EHR; the app groups entries into days by it. */
  posterTimezone?: Maybe<Scalars['String']['output']>;
};

/** A comment on an EHR measurement entry. Null fields are ones the EHR did not return. */
export type PlatformEhrMetricEntryComment = {
  __typename?: 'EhrMetricEntryComment';
  /** Who wrote the comment. Null when the EHR returned no author. */
  author?: Maybe<PlatformEhrCommentAuthor>;
  /** The comment text. */
  content?: Maybe<Scalars['String']['output']>;
  /** In the EHR's own datetime format. */
  createdAt?: Maybe<Scalars['String']['output']>;
  /** The EHR's comment id. */
  id: Scalars['ID']['output'];
};

/** The order `ehrMetricEntries` asks the EHR for. */
export enum PlatformEhrMetricEntryOrder {
  /** Oldest first. */
  CreatedAtAsc = 'CREATED_AT_ASC',
  /** Newest first. */
  CreatedAtDesc = 'CREATED_AT_DESC'
}

/**
 * A prescription in the patient's EHR record (Healthie, from DoseSpot), read live
 * and not persisted. Every string is what the EHR returned: dates are not parsed,
 * blanks are not trimmed, and nulls stay null.
 */
export type PlatformEhrPrescription = {
  __typename?: 'EhrPrescription';
  /** Date when prescription became ineffective, passed through as Healthie returns it at API version 2024-06-01, where it is a String rather than the ISO8601DateTime of 2024-07-01 on. */
  dateInactive?: Maybe<Scalars['String']['output']>;
  /** Date prescription was written, passed through as Healthie returns it at API version 2024-06-01, where it is a String rather than the ISO8601DateTime of 2024-07-01 on. */
  dateWritten?: Maybe<Scalars['String']['output']>;
  /** Display name for the prescription. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** The dosage (strength) of the prescription. */
  dosage?: Maybe<Scalars['String']['output']>;
  /** Date when prescription became effective, passed through as Healthie returns it at API version 2024-06-01, where it is a String rather than the ISO8601DateTime of 2024-07-01 on. */
  effectiveDate?: Maybe<Scalars['String']['output']>;
  /** The EHR's prescription id (Healthie today). Opaque. */
  id: Scalars['ID']['output'];
  /** The name of the pharmacy assigned in DoseSpot. */
  pharmacyName?: Maybe<Scalars['String']['output']>;
};

/** The SOAP note text, one field per section. Send empty strings for empty sections. */
export type PlatformEhrSoapNoteContentInput = {
  assessment: Scalars['String']['input'];
  interventions: Scalars['String']['input'];
  objective: Scalars['String']['input'];
  plan: Scalars['String']['input'];
  providerNotes: Scalars['String']['input'];
  sessionDetails: Scalars['String']['input'];
  subjective: Scalars['String']['input'];
};

/**
 * The patient whose EHR weight, height, measurement entries, charting notes or forms a call reads or writes. Keyed on the Healthie user id,
 * like glucoseReadings(patientHealthieId): the callers hold only that id, and these operations
 * read and write Healthie directly, so a registry lookup would add a call and a failure mode.
 */
export type PlatformEhrVitalsPatientInput = {
  /** The caller's EHR patient id (the Healthie user id today). The call reads and writes this chart as given and does no patient-access check, so the caller must confirm the patient is theirs. A blank value is BAD_USER_INPUT. */
  externalId: Scalars['ID']['input'];
};

/**
 * Which of the patient's EHR weight entries `ehrWeightEntries` returns. Send one
 * pair or neither: dates bound by whole days, datetimes by instants. With neither,
 * the EHR applies no date filter.
 */
export type PlatformEhrWeightEntriesInput = {
  /** A date; entries before the start of that day. */
  endDate?: InputMaybe<Scalars['String']['input']>;
  /** A datetime string; entries before it. */
  endDateTime?: InputMaybe<Scalars['String']['input']>;
  patient: PlatformEhrVitalsPatientInput;
  /** A date such as 2026-10-01; entries from the start of that day. */
  startDate?: InputMaybe<Scalars['String']['input']>;
  /** A datetime string; entries after it. */
  startDateTime?: InputMaybe<Scalars['String']['input']>;
};

/**
 * A weight entry in the patient's EHR record (a Healthie Weight metric entry),
 * read live and not persisted. Values are what the EHR returned, unparsed.
 */
export type PlatformEhrWeightEntry = {
  __typename?: 'EhrWeightEntry';
  /** When the entry was recorded, in the EHR's own datetime format (not always ISO 8601). */
  createdAt?: Maybe<Scalars['String']['output']>;
  /** The EHR's entry id. */
  id: Scalars['ID']['output'];
  /** The recorded weight as the EHR stores it, with no unit. */
  metricStat?: Maybe<Scalars['Float']['output']>;
};

/** The patient's weight graph from the EHR (Healthie metric graph data), read live and not persisted. */
export type PlatformEhrWeightGraph = {
  __typename?: 'EhrWeightGraph';
  /** Null when the EHR returned none. */
  dataPoints?: Maybe<Array<PlatformEhrWeightGraphPoint>>;
};

export type PlatformEhrWeightGraphInput = {
  /** End of the EHR's graph date range, passed to it as given. */
  endDate?: InputMaybe<Scalars['String']['input']>;
  patient: PlatformEhrVitalsPatientInput;
  /** Start of the EHR's graph date range, passed to it as given. */
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export type PlatformEhrWeightGraphPoint = {
  __typename?: 'EhrWeightGraphPoint';
  /** When the entry was recorded, in the EHR's own datetime format. */
  createdAt: Scalars['String']['output'];
  entryId?: Maybe<Scalars['ID']['output']>;
  /** The value as the EHR returned it. */
  value?: Maybe<Scalars['Float']['output']>;
};

/** A field-level message the EHR returned with a write. */
export type PlatformEhrWriteMessage = {
  __typename?: 'EhrWriteMessage';
  field?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

/**
 * Error information from Stedi eligibility check.
 * Structure is dynamic and varies by error type.
 * Common fields observed: message, code, description, location, followUpAction
 */
export type PlatformEligibilityError = {
  __typename?: 'EligibilityError';
  /**
   * Complete error object from Stedi API.
   * Structure varies by error type - no assumptions are made about fields.
   * Clients should handle this as a flexible JSON object.
   *
   * Example structures:
   * - { "message": "Member ID not found" }
   * - { "code": "AAA*N**72", "description": "Invalid/Missing Provider Identification", "location": "NM1*IL" }
   * - { "message": "System timeout", "code": "TIMEOUT", "followUpAction": "R" }
   */
  raw: Scalars['JSON']['output'];
};

/**
 * Input for coverage eligibility request.
 *
 * Either memberId OR (firstName AND lastName) must be provided.
 * If memberId is provided, firstName and lastName are optional.
 * If memberId is not provided, both firstName and lastName are required.
 */
export type PlatformEligibilityRequestInput = {
  /** Patient's date of birth (optional) */
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  /** Patient's first name (required if memberId is not provided) */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Patient's last name (required if memberId is not provided) */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Member ID (required if firstName and lastName are not provided) */
  memberId?: InputMaybe<Scalars['String']['input']>;
  /** Payer ID (trading partner service ID) */
  payerId: Scalars['String']['input'];
  /**
   * Request configuration for this eligibility check.
   * Controls automatic retry behavior, timeouts, and request correlation.
   */
  requestOptions?: InputMaybe<PlatformRequestOptions>;
};

/** Complete eligibility check response */
export type PlatformEligibilityResponse = {
  __typename?: 'EligibilityResponse';
  /**
   * Automatic benefits decision from Airtable based on coverage information.
   * Automatically looks up the decision using payerId, planType, and planName from coverage.
   * Returns ERROR response type if coverage is missing required fields for lookup.
   */
  automaticBenefitsDecision: PlatformAutomaticBenefitsDecisionResponse;
  /** Insurance coverage/plan information */
  coverage: PlatformCoverage;
  /** List of dependents covered under this policy */
  dependents: Array<PlatformDependent>;
  /**
   * Errors returned from Stedi API.
   * Empty array if no errors occurred.
   * Each error is a flexible JSON object - structure varies by error type.
   */
  errors: Array<PlatformEligibilityError>;
  /** Subscriber (patient/member) information */
  subscriber: PlatformSubscriber;
  /** Raw X12 EDI response from Stedi (for debugging) */
  x12?: Maybe<Scalars['String']['output']>;
};

/**
 * Detected conflict in email addresses within a patient.
 * Conflicts occur when a patient has multiple email addresses but none marked as primary.
 */
export type PlatformEmailConflict = {
  __typename?: 'EmailConflict';
  /** List of conflicting emails for this patient */
  emails: Array<PlatformPatientEmail>;
  /** Patient ID with the conflict */
  patientId: Scalars['ID']['output'];
  /** Suggested primary email address (oldest by createdAt) */
  suggestedPrimary: Scalars['String']['output'];
};

/** Status of an email address record. */
export enum PlatformEmailStatus {
  /** Currently valid and in use */
  Active = 'ACTIVE',
  /** Flagged for data quality review (bounced, disputed ownership, etc.) */
  Disputed = 'DISPUTED',
  /** Replaced by a newer email address */
  Superseded = 'SUPERSEDED'
}

/**
 * A patient's enrollment in a cohort.
 * Tracks who is enrolled in which cohort.
 */
export type PlatformEnrollment = {
  __typename?: 'Enrollment';
  /** Whether this enrollment is currently active */
  active: Scalars['Boolean']['output'];
  /** The cohort the patient has been enrolled in */
  cohort: PlatformCohort;
  /** When the patient was enrolled */
  enrolledAt: Scalars['DateTime']['output'];
  /** Healthie client ID for the enrolled patient */
  healthieClientId: Scalars['String']['output'];
  /** Unique identifier for the enrollment */
  id: Scalars['ID']['output'];
};

export type PlatformEnsureGlp1EnrollmentInput = {
  /** Healthie appointment that triggered enrollment */
  appointmentHealthieId?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Ignored — prescriber is derived from latest occurred GLP-1 appointment */
  assignedProviderHealthieId?: InputMaybe<Scalars['ID']['input']>;
  patientHealthieId: Scalars['ID']['input'];
};

export type PlatformEnsureGlp1PrescriptionTaskInput = {
  appointmentHealthieId: Scalars['ID']['input'];
};

export type PlatformEnsurePatientDietitianInput = {
  patientId: Scalars['ID']['input'];
  providerId: Scalars['ID']['input'];
};

export type PlatformEnsurePatientDietitianPayload = {
  __typename?: 'EnsurePatientDietitianPayload';
  outcome: PlatformPatientCareTeamAssignmentOutcome;
  /** Diagnostic reason only for REQUIRES_REVIEW; never patient-facing copy. */
  reason?: Maybe<Scalars['String']['output']>;
};

export type PlatformEnsurePatientPrescriberInput = {
  patientId: Scalars['ID']['input'];
  providerId: Scalars['ID']['input'];
};

export type PlatformEnsurePatientPrescriberPayload = {
  __typename?: 'EnsurePatientPrescriberPayload';
  outcome: PlatformPatientCareTeamAssignmentOutcome;
  /** Diagnostic reason only for REQUIRES_REVIEW; never patient-facing copy. */
  reason?: Maybe<Scalars['String']['output']>;
};

/** A comment left on a food journal entry by a provider or patient */
export type PlatformEntryComment = {
  __typename?: 'EntryComment';
  /** The person who wrote the comment */
  author: PlatformFoodEntryCommentAuthor;
  /** The comment text content */
  content: Scalars['String']['output'];
  /** When the comment was created */
  createdAt: Scalars['DateTime']['output'];
  /** The reaction's emoji, such as 👍, when isReaction is true. Null otherwise, and when comments are served from Healthie. */
  emoji?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the comment */
  id: Scalars['ID']['output'];
  /** True when the comment is a reaction. Null when comments are served from Healthie, which the platform does not ask for this. */
  isReaction?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Returned when an entry link can't start a session. An already-used link is
 * not an error — it resumes its session — so this is only EXPIRED or INVALID.
 * The client should show a friendly message and a path to start fresh.
 */
export type PlatformEntryLinkUnusableError = {
  __typename?: 'EntryLinkUnusableError';
  /** Human-readable summary, safe to surface to the patient. */
  message: Scalars['String']['output'];
  reason: PlatformEntryLinkUnusableReason;
};

/** Why an entry link could not start a session. */
export enum PlatformEntryLinkUnusableReason {
  /** The link is past its expiry. */
  Expired = 'EXPIRED',
  /** The token doesn't resolve to a usable link (unknown, tampered, or wrong flow). */
  Invalid = 'INVALID'
}

/**
 * Detected conflict in external IDs within a patient-system combination.
 * Conflicts occur when a patient has multiple IDs from the same system but none marked as primary.
 */
export type PlatformExternalIdConflict = {
  __typename?: 'ExternalIdConflict';
  /** List of conflicting external IDs for this patient-system */
  externalIds: Array<PlatformPatientExternalId>;
  /** Patient ID with the conflict */
  patientId: Scalars['ID']['output'];
  /** Suggested primary external ID (oldest by createdAt) */
  suggestedPrimary: Scalars['String']['output'];
  /** External system name */
  system: PlatformExternalSystem;
};

/** Status of an external ID record. */
export enum PlatformExternalIdStatus {
  /** Currently valid and in use */
  Active = 'ACTIVE',
  /** Flagged for data quality review */
  Disputed = 'DISPUTED',
  /** Replaced by a newer ID */
  Superseded = 'SUPERSEDED'
}

/** External system names that patients can have identifiers in. */
export enum PlatformExternalSystem {
  /** Clerk authentication system */
  Clerk = 'CLERK',
  /** Customer.io marketing automation platform */
  CustomerIo = 'CUSTOMER_IO',
  /** Healthie EHR system */
  Healthie = 'HEALTHIE',
  /** Healthify (Navi Health) — populated by the Berry Street identity propagation webhook */
  Healthify = 'HEALTHIFY',
  /** Intercom customer communication platform */
  Intercom = 'INTERCOM',
  /** Photon — GLP-1 e-prescribing; canonical patient id from enrollment provisioning */
  Photon = 'PHOTON',
  /** Zus Health — FHIR Patient resource id, stamped on sync */
  Zus = 'ZUS',
  /** Zus Health — Universal Patient Identifier (UPID), stamped on sync */
  ZusUpid = 'ZUS_UPID'
}

/**
 * Per-service form input declared by a `ServiceCatalogEntry`. Lets a tile
 * collect structured information beyond `accessLevel` and `justification` —
 * e.g. \"which GitHub email\", \"which AWS accounts\", \"which Linear teams\".
 */
export type PlatformExtraFieldDefinition = {
  __typename?: 'ExtraFieldDefinition';
  /** Short hint text rendered under the field. */
  helpText?: Maybe<Scalars['String']['output']>;
  /** Stable machine key. Used as `{{extraField.<key>}}` in sub-task templates. */
  key: Scalars['String']['output'];
  kind: PlatformExtraFieldKind;
  /** Form-label text shown to the requester. */
  label: Scalars['String']['output'];
  /** Available options for SELECT/MULTI_SELECT. Empty for TEXT/EMAIL. */
  options: Array<Scalars['String']['output']>;
  /** Form placeholder for TEXT/EMAIL fields. */
  placeholder?: Maybe<Scalars['String']['output']>;
  required: Scalars['Boolean']['output'];
};

/** How an extra field on a catalog entry should be rendered + validated. */
export enum PlatformExtraFieldKind {
  /** Single-line free text, validated as an email address. */
  Email = 'EMAIL',
  /** Pick one or more options from `options`. */
  MultiSelect = 'MULTI_SELECT',
  /** Pick one option from `options`. */
  Select = 'SELECT',
  /** Single-line free text. */
  Text = 'TEXT'
}

/** One key/values pair on `SubmitAccessRequestInput.extraFields`. */
export type PlatformExtraFieldValueInput = {
  /** Matches `ExtraFieldDefinition.key` on the relevant `ServiceCatalogEntry`. */
  key: Scalars['String']['input'];
  /** One or more values. Single-value fields (TEXT/EMAIL/SELECT) send length-1; MULTI_SELECT sends N. */
  values: Array<Scalars['String']['input']>;
};

/** Refused: nothing was stored or charged by this call. */
export type PlatformFeeChargeRejectedError = {
  __typename?: 'FeeChargeRejectedError';
  message: Scalars['String']['output'];
  reason: PlatformFeeChargeRejectionReason;
};

export enum PlatformFeeChargeRejectionReason {
  /** The same idempotencyKey was used with a different appointment, fee type or amount. */
  FeeChanged = 'FEE_CHANGED'
}

/** Serving details of a scanned product or nutrition label on a food entry */
export type PlatformFoodEntryBarcodeData = {
  __typename?: 'FoodEntryBarcodeData';
  /** The serving size the product or label states */
  originalServingSize: PlatformFoodEntryServingSize;
  /** Servings eaten, as a multiple of originalServingSize. Null when not recorded; the app shows that as 1. */
  servingMultiplier?: Maybe<Scalars['Float']['output']>;
};

/** Serving details of a scanned product or nutrition label */
export type PlatformFoodEntryBarcodeDataInput = {
  /** The serving size the product or label states */
  originalServingSize: PlatformFoodEntryServingSizeInput;
  /** Servings eaten, as a multiple of originalServingSize */
  servingMultiplier?: InputMaybe<Scalars['Float']['input']>;
};

/** Author information for a food journal entry comment */
export type PlatformFoodEntryCommentAuthor = {
  __typename?: 'FoodEntryCommentAuthor';
  /** URL to the author's avatar image, if available */
  avatarUrl?: Maybe<Scalars['String']['output']>;
  /** Full name of the comment author */
  fullName: Scalars['String']['output'];
  /** Unique identifier for the author */
  id: Scalars['ID']['output'];
};

/** How the app sourced a food entry's macros, as it recorded them when the entry was logged or last edited in the app */
export type PlatformFoodEntryMacroMetadata = {
  __typename?: 'FoodEntryMacroMetadata';
  /** Serving details of a scanned product or nutrition label. Null for other sources, and when not recorded or not in the expected shape. */
  barcodeData?: Maybe<PlatformFoodEntryBarcodeData>;
  /** When the app recorded the macros. Null when not recorded or not a valid date-time. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Where the macros came from */
  source: PlatformFoodEntryMacroSource;
};

/** How the app sourced a food entry's macros, written with them */
export type PlatformFoodEntryMacroMetadataInput = {
  /** Serving details of a scanned product or nutrition label */
  barcodeData?: InputMaybe<PlatformFoodEntryBarcodeDataInput>;
  /** When the app recorded the macros */
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Where the macros came from */
  source: PlatformFoodEntryMacroSource;
};

/** Where the macros on a food entry came from */
export enum PlatformFoodEntryMacroSource {
  /** Scanned from a product barcode */
  Barcode = 'BARCODE',
  /** Estimated from the entry's description */
  Description = 'DESCRIPTION',
  /** Imported from Lose It! */
  Loseit = 'LOSEIT',
  /** Logged in Healthify or NaviHealth, which doesn't yet record how the macros were worked out */
  Navihealth = 'NAVIHEALTH',
  /** Read from a photo of a nutrition label */
  NutritionLabel = 'NUTRITION_LABEL',
  /** Estimated from a photo of the meal */
  Photo = 'PHOTO',
  /** Taken from a restaurant menu search */
  RestaurantSearch = 'RESTAURANT_SEARCH'
}

/** A serving size as a product or nutrition label states it */
export type PlatformFoodEntryServingSize = {
  __typename?: 'FoodEntryServingSize';
  /** Human-readable serving size, such as '1 cup (240 ml)' */
  description: Scalars['String']['output'];
  /** Number of units in one serving */
  quantity: Scalars['Float']['output'];
  /** Unit of quantity, such as 'serving' or 'cup' */
  unit: Scalars['String']['output'];
};

/** A serving size as a product or nutrition label states it */
export type PlatformFoodEntryServingSizeInput = {
  /** Human-readable serving size, such as '1 cup (240 ml)' */
  description: Scalars['String']['input'];
  /** Number of units in one serving */
  quantity: Scalars['Float']['input'];
  /** Unit of quantity, such as 'serving' or 'cup' */
  unit: Scalars['String']['input'];
};

/**
 * A food journal entry logged by a patient, capturing meal information,
 * nutritional data, emotional context, and provider feedback.
 */
export type PlatformFoodJournalEntry = PlatformJournalEntryBase & {
  __typename?: 'FoodJournalEntry';
  /** Comments from providers or other users on this entry */
  comments: Array<PlatformEntryComment>;
  /** When the entry was created */
  createdAt: Scalars['DateTime']['output'];
  /** The entry owner's Healthie user id, or `unknown` when journaling has none */
  createdBy: Scalars['String']['output'];
  /** Patient's description of the food consumed */
  description?: Maybe<Scalars['String']['output']>;
  /** List of emotion tags associated with this meal (e.g., 'happy', 'stressed') */
  emotions: Array<Scalars['String']['output']>;
  /** Unique identifier for the food journal entry */
  id: Scalars['ID']['output'];
  /** URL to an image of the meal, if provided */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** Detailed ingredient breakdown for this meal (stored in PostgreSQL). Loaded from patient-app-api, whose internal food-entries ingredients route has no ED check. The platform doesn't gate it for eating-disorder (ED) patients: the caller owns the ED check. */
  ingredients: Array<PlatformIngredient>;
  /** The Healthie entry id an entry served from NaviHealth (an `nh-` id) is linked to. Null for an entry served from Healthie, whose `id` is already its Healthie id, and for a NaviHealth entry with no linked Healthie entry. Treat it as opaque. */
  linkedHealthieEntryId?: Maybe<Scalars['ID']['output']>;
  /** How the app sourced this entry's macros, as it recorded them with the entry. Null when nothing was recorded, or the recorded source is not a FoodEntryMacroSource. */
  macroMetadata?: Maybe<PlatformFoodEntryMacroMetadata>;
  /** The meal category (breakfast, lunch, dinner, or snack) */
  mealType?: Maybe<PlatformMealType>;
  /** Nutritional information tracked for this meal (e.g., calories, macros) */
  nutritionalMetrics: Array<PlatformNutritionalMetric>;
  /** Ingredients of a snap-logged NaviHealth meal, read from NaviHealth only and never from patient-app-api. Empty for every other entry, and when the journaling-navihealth-snap-ingredients flag is off. Not gated for eating-disorder (ED) patients on the platform: the caller owns the ED check (patient-app-api's getEntry is the only gate). */
  snapIngredients: Array<PlatformIngredient>;
  /** IANA timezone identifier for the poster (e.g., 'America/Los_Angeles') */
  timezone?: Maybe<Scalars['String']['output']>;
  /** When the entry was last modified */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** The available name and measurement of a food-journal ingredient. */
export type PlatformFoodJournalSnapshotIngredient = {
  __typename?: 'FoodJournalSnapshotIngredient';
  name: Scalars['String']['output'];
  /** Null when a measurement is unavailable. */
  quantity?: Maybe<Scalars['Float']['output']>;
  /** Null when a unit is unavailable. */
  unit?: Maybe<Scalars['String']['output']>;
};

export type PlatformFoodJournalSnapshotInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  healthieUserId: Scalars['ID']['input'];
};

export type PlatformFoodJournalSnapshotPage = {
  __typename?: 'FoodJournalSnapshotPage';
  healthieUserId: Scalars['ID']['output'];
  pageInfo: PlatformFoodJournalSnapshotPageInfo;
  records: Array<PlatformFoodJournalSnapshotRecord>;
};

export type PlatformFoodJournalSnapshotPageInfo = {
  __typename?: 'FoodJournalSnapshotPageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
};

/** A broad, current food-log snapshot; image data is intentionally excluded. */
export type PlatformFoodJournalSnapshotRecord = {
  __typename?: 'FoodJournalSnapshotRecord';
  comments: Array<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  emotions: Array<Scalars['String']['output']>;
  ingredients: Array<PlatformFoodJournalSnapshotIngredient>;
  mealType?: Maybe<PlatformMealType>;
  occurredAt: Scalars['DateTime']['output'];
  sourceId: Scalars['ID']['output'];
};

/** A standard form: the client renders `fields` generically and submits their values. */
export type PlatformFormStep = {
  __typename?: 'FormStep';
  /**
   * Optional label for the advance button. Null falls back to the client's
   * default ("Continue"/"Skip") — set only for steps that need commit-specific
   * wording (e.g. a booking confirmation's "Book appointment").
   */
  ctaLabel?: Maybe<Scalars['String']['output']>;
  /**
   * Optional advance-button copy shown while its submit is in flight. Null
   * falls back to the client's default ("Continuing…") — set only for steps
   * whose submit does something worth naming (e.g. "Booking…" for the step
   * that actually books the appointment).
   */
  ctaLoadingLabel?: Maybe<Scalars['String']['output']>;
  /**
   * Field values to seed the form with on rewind (field id → prior value), or
   * null when the patient has no prior submission for this step.
   */
  currentValues?: Maybe<Scalars['JSON']['output']>;
  /**
   * Optional fine print shown beneath the advance button — e.g. a consent
   * acknowledgment or SMS messaging terms. Null when the step needs none.
   */
  disclaimer?: Maybe<Scalars['String']['output']>;
  /** Ordered fields to render. */
  fields: Array<PlatformStepField>;
  /**
   * Optional step-level intro shown above the fields — framing/context for the
   * form as a whole. Null when the step needs no preamble.
   */
  lead?: Maybe<Scalars['String']['output']>;
  /**
   * Optional bold step title shown above the lead. Use when the form itself is
   * the point of the screen (e.g. a consent step whose fields are all
   * checkboxes) and needs a prominent title like the bespoke screens have. Null
   * when the fields' own labels carry the screen.
   */
  title?: Maybe<Scalars['String']['output']>;
};

export type PlatformGeneratePatientPriorAuthDocumentsInput = {
  /** Exact GLP-1 prescription task whose appointment supplies Form 1 clinical charting notes. */
  glp1PrescriptionTaskId?: InputMaybe<Scalars['ID']['input']>;
  patientHealthieId: Scalars['ID']['input'];
  /**
   * Exact prior authorization whose request fields appear in the PDFs. The
   * document rows and Develop evidence must be linked to this same PA.
   */
  priorAuthorizationId: Scalars['ID']['input'];
};

export type PlatformGeneratePatientPriorAuthDocumentsPayload = {
  __typename?: 'GeneratePatientPriorAuthDocumentsPayload';
  documents: Array<PlatformPriorAuthDocument>;
  generatedAt: Scalars['DateTime']['output'];
  patientHealthieId: Scalars['ID']['output'];
};

/** Input for querying daily health metrics */
export type PlatformGetDailyHealthMetricsInput = {
  /** Optional category filter (returns all categories if not specified) */
  categories?: InputMaybe<Array<PlatformHealthMetricCategory>>;
  /** End date (inclusive) */
  endDate: Scalars['DateTime']['input'];
  /** Healthie user id of the patient. When `patientRegistryId` is also set, read only if the registry holds no primary Healthie user id for it or the registry lookup fails. That fallback stays until every registry patient has exactly one primary Healthie user id (BSE-3718). */
  healthieUserId?: InputMaybe<Scalars['ID']['input']>;
  /** Patient registry id of the patient. Takes precedence over the Healthie id. At least one of the two is required. */
  patientRegistryId?: InputMaybe<Scalars['ID']['input']>;
  /** Start date (inclusive) */
  startDate: Scalars['DateTime']['input'];
};

/** Input parameters for querying food journal entries */
export type PlatformGetFoodEntriesInput = {
  /** Filter entries created on or before this date */
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Healthie user id of the patient whose entries to retrieve. When `patientRegistryId` is also set, read only if the registry holds no primary Healthie user id for it or the registry lookup fails. That fallback stays until every registry patient has exactly one primary Healthie user id (BSE-3718). */
  patientId?: InputMaybe<Scalars['ID']['input']>;
  /** Patient registry id of the patient whose entries to retrieve. Takes precedence over the Healthie id. At least one of the two is required. */
  patientRegistryId?: InputMaybe<Scalars['ID']['input']>;
  /** Order in which to return results (defaults to newest first) */
  sortOrder?: InputMaybe<PlatformSortOrder>;
  /** Filter entries created on or after this date */
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Input parameters for querying journal entries */
export type PlatformGetJournalEntriesInput = {
  /** Filter parameters for the query */
  filters: PlatformJournalEntryFiltersInput;
  /** Pagination parameters (optional) */
  pagination?: InputMaybe<PlatformPaginationInput>;
};

/** Input for requesting a presigned upload URL */
export type PlatformGetUploadUrlInput = {
  /** When set, the upload answers this request. Rejected if the request is not OPEN or the patient does not match. */
  documentRequestId?: InputMaybe<Scalars['ID']['input']>;
  /** Type of document being uploaded */
  documentType: PlatformDocumentType;
  /** File size in bytes (must be <= 10MB) */
  fileSize: Scalars['Int']['input'];
  /** Original filename */
  filename: Scalars['String']['input'];
  /** Healthie user ID (required) - passed from patient-app-api after JWT validation */
  healthieUserId: Scalars['ID']['input'];
  /** MIME type of the file (must be application/pdf, image/jpeg, or image/png) */
  mimeType: Scalars['String']['input'];
};

/** Local mirror slice of a GLP-1 Healthie appointment. Reused on prescriptionReview and glp1PrescriptionTasks. */
export type PlatformGlp1Appointment = {
  __typename?: 'Glp1Appointment';
  appointmentHealthieId: Scalars['ID']['output'];
  appointmentTypeHealthieId: Scalars['ID']['output'];
  date: Scalars['DateTime']['output'];
  patientHealthieId: Scalars['ID']['output'];
  providerHealthieId: Scalars['ID']['output'];
  status?: Maybe<Scalars['String']['output']>;
};

/** A live onboarding-owned GLP-1 initial-consult hold. */
export type PlatformGlp1AppointmentHold = {
  __typename?: 'Glp1AppointmentHold';
  /** Authoritative scheduling expiry; clients derive the countdown from this instant. */
  expiresAt: Scalars['DateTime']['output'];
  /** The prescriber held, including the one the server picked for Any. */
  providerId: Scalars['ID']['output'];
  startTime: Scalars['DateTime']['output'];
};

/** Patient-facing GLP-1 visit kind, independent of environment-specific Healthie appointment-type ids. */
export enum PlatformGlp1AppointmentKind {
  FollowUp = 'FOLLOW_UP',
  Initial = 'INITIAL'
}

/**
 * The GLP-1 appointment facts used to choose a patient-app screen. All fields read
 * the webhook-synced local mirror and can therefore lag Healthie briefly.
 */
export type PlatformGlp1AppointmentSummary = {
  __typename?: 'Glp1AppointmentSummary';
  /** All mirrored GLP-1 appointments, newest first. */
  appointments: Array<PlatformGlp1PatientAppointment>;
  /** Most recent occurred GLP-1 appointment, initial or follow-up. */
  latestOccurred?: Maybe<PlatformGlp1PatientAppointment>;
  /** Most recent occurred initial consultation. */
  latestOccurredInitial?: Maybe<PlatformGlp1PatientAppointment>;
  /** Earliest follow-up at or after now minus 60 minutes without a terminal Healthie outcome. */
  upcomingFollowup?: Maybe<PlatformGlp1PatientAppointment>;
  /** Earliest initial consultation at or after now minus 60 minutes without a terminal Healthie outcome. */
  upcomingInitial?: Maybe<PlatformGlp1PatientAppointment>;
};

/**
 * No displayed prescriber (or not the requested one) is open at that time for
 * this session, or another session holds it. The existing GLP-1 hold, if any,
 * is unchanged; the client refreshes `availability` and clears the selected
 * time.
 */
export type PlatformGlp1AppointmentUnavailableError = {
  __typename?: 'Glp1AppointmentUnavailableError';
  message: Scalars['String']['output'];
  /** The requested prescriber; null for Any. */
  providerId?: Maybe<Scalars['ID']['output']>;
  startTime: Scalars['DateTime']['output'];
};

/** Successful GLP-1 booking. */
export type PlatformGlp1Booked = {
  __typename?: 'Glp1Booked';
  appointmentHealthieId: Scalars['ID']['output'];
  appointmentTime: Scalars['DateTime']['output'];
  /**
   * True when this call returned the booking an earlier call with the same
   * `idempotencyKey` already made, so nothing in this call's input (such as the
   * provider or `providerPayerEnrolled`) describes it. Follow-up bookings are
   * always false.
   */
  idempotentReplay: Scalars['Boolean']['output'];
  /**
   * True when this call recorded onboarding Medicare evidence on a Bridge case,
   * including a replay of a reference already on the case. False when the flag
   * is off, the evidence does not classify, or this call did not record one.
   * Follow-up bookings are always false.
   */
  medicareBridgeCaseOpened: Scalars['Boolean']['output'];
  providerHealthieId: Scalars['ID']['output'];
};

/** The guardian named on a GLP-1 consult booked for a patient under 18. */
export type PlatformGlp1ConsultGuardianInput = {
  /** The guardian's email, which is also the account's email. */
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
};

/**
 * The patient may not book an initial GLP-1 consultation: they already hold a
 * live upcoming one, or they completed one within the last 30 days and the next
 * visit is a follow-up rather than a second initial. Cancelled, re-scheduled and
 * no-showed visits never block — that patient is free to rebook.
 *
 * Enforced at the booking call (the trust boundary) so a stale client, a direct
 * API call, or a second run through any funnel can't book ungated.
 */
export type PlatformGlp1ConsultNotBookableError = {
  __typename?: 'Glp1ConsultNotBookableError';
  /**
   * The consult the patient already holds. Present only when `reason` is
   * `ALREADY_SCHEDULED` — a recently completed visit leaves nothing to render.
   */
  existingConsult?: Maybe<PlatformUpcomingGlp1Consult>;
  /** Human-readable summary, safe to surface to the patient. */
  message: Scalars['String']['output'];
  /** Which rule blocked the booking; drives which terminal the caller renders. */
  reason: PlatformGlp1ConsultNotBookableReason;
};

/** Why an initial GLP-1 consultation can't be booked right now. */
export enum PlatformGlp1ConsultNotBookableReason {
  /** A live upcoming initial consultation already exists. */
  AlreadyScheduled = 'ALREADY_SCHEDULED',
  /** An initial consultation occurred within the last 30 days. */
  RecentlyCompleted = 'RECENTLY_COMPLETED'
}

export enum PlatformGlp1EligibilityVerdict {
  Eligible = 'ELIGIBLE',
  Ineligible = 'INELIGIBLE',
  NeedsReview = 'NEEDS_REVIEW'
}

/**
 * High-level, non-diagnostic outcome bucket for a GLP-1 ineligible verdict
 * (GLPX-309). Never names a specific condition. Precedence when several reasons
 * apply: SAFETY > EATING_DISORDER > BMI (only when BMI is the sole disqualifier
 * kind) > HEALTH_HISTORY, which is also the fallback for missing/unrecognized
 * reasons.
 */
export enum PlatformGlp1IneligibleBucket {
  Bmi = 'BMI',
  EatingDisorder = 'EATING_DISORDER',
  HealthHistory = 'HEALTH_HISTORY',
  Safety = 'SAFETY'
}

/** Program a GLP-1-ineligible lead's journey continues into. */
export enum PlatformGlp1IneligibleContinuation {
  Access = 'ACCESS',
  Mnt = 'MNT'
}

/**
 * Drives the GLP1_INELIGIBLE screen (GLPX-309): the reason bucket to render plus
 * the program the lead's journey continues into, which decides whether the
 * screen shows a Continue CTA (into that program's segment) or rests with no
 * forward edge.
 */
export type PlatformGlp1IneligibleOutcome = {
  __typename?: 'Glp1IneligibleOutcome';
  bucket: PlatformGlp1IneligibleBucket;
  /** Program the Continue CTA advances into; null when the lead rests here. */
  continuesTo?: Maybe<PlatformGlp1IneligibleContinuation>;
};

/**
 * System of record for a patient's GLP-1 intake at the moment of booking.
 * Immutable once created. Captures the screening verdict, the data the
 * patient screened with, the derived ICD-10 diagnoses, and the formatted
 * subjective-intake note that lands in the Healthie chart.
 */
export type PlatformGlp1IntakeRecord = {
  __typename?: 'Glp1IntakeRecord';
  appointmentHealthieId: Scalars['ID']['output'];
  bmiAtScreening: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** ICD-10 codes derived from screening answers; same list submitted to Develop on the BV. */
  diagnoses: Array<PlatformDiagnosis>;
  id: Scalars['ID']['output'];
  patientHealthieId: Scalars['ID']['output'];
  providerHealthieId: Scalars['ID']['output'];
  /**
   * Clinical step data keyed by stepId, including raw answers and optional server-owned
   * `_questionnaireV1` metadata. `question` preserves patient-facing wording;
   * `chartingQuestion` is an optional separate note label. Metadata lists declared
   * action outputs, which are not patient answers. Raw-blob readers must skip
   * underscore-prefixed keys. Older records may lack metadata.
   */
  screeningAnswers: Scalars['JSON']['output'];
  /** HTML-formatted chart note that was submitted to Healthie via the screening form-answer-group. */
  subjectiveIntakeNote: Scalars['String']['output'];
  verdict: PlatformGlp1EligibilityVerdict;
  verdictReasons: Array<Scalars['String']['output']>;
};

/** GLP-1 medication option from the SKU catalog. */
export type PlatformGlp1MedicationOption = {
  __typename?: 'Glp1MedicationOption';
  daysSupply: Scalars['Int']['output'];
  defaultDirections: Scalars['String']['output'];
  dose: Scalars['String']['output'];
  label: Scalars['String']['output'];
  ndc: Scalars['String']['output'];
  packageType: Scalars['String']['output'];
  product: PlatformGlp1Product;
  quantity: Scalars['Int']['output'];
  skuId: Scalars['ID']['output'];
};

/**
 * The patient is not actively prescribed, so they're not eligible for a GLP-1
 * follow-up visit. Enforced at the booking call (the trust boundary) so a stale
 * client, a direct API call, or an old follow-up link can't book ungated. Gated
 * on the same ACTIVE-prescription signal that drives follow-up eligibility. Also
 * returned fail-closed when the prescription lookup itself fails.
 */
export type PlatformGlp1NotPrescribedError = {
  __typename?: 'Glp1NotPrescribedError';
  /** Human-readable summary, safe to surface to the patient. */
  message: Scalars['String']['output'];
};

/** A patient-facing appointment from the local GLP-1 Healthie mirror. */
export type PlatformGlp1PatientAppointment = {
  __typename?: 'Glp1PatientAppointment';
  appointmentHealthieId: Scalars['ID']['output'];
  date: Scalars['DateTime']['output'];
  kind: PlatformGlp1AppointmentKind;
  /** Raw Healthie pm_status. Null means the appointment is still scheduled. */
  status?: Maybe<Scalars['String']['output']>;
};

/** Result of upserting or clearing provider-private patient notes. */
export type PlatformGlp1PatientPrescriberNotesPayload = {
  __typename?: 'Glp1PatientPrescriberNotesPayload';
  /** Null when cleared. */
  notes?: Maybe<Scalars['String']['output']>;
  patientHealthieId: Scalars['ID']['output'];
  providerHealthieId: Scalars['ID']['output'];
};

export type PlatformGlp1PrescriptionTask = {
  __typename?: 'Glp1PrescriptionTask';
  appointmentHealthieId: Scalars['ID']['output'];
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  outcome?: Maybe<PlatformGlp1PrescriptionTaskOutcome>;
  priorAuthorizationId?: Maybe<Scalars['ID']['output']>;
  skipReason?: Maybe<Scalars['String']['output']>;
  status: PlatformGlp1PrescriptionTaskStatus;
};

export type PlatformGlp1PrescriptionTaskContext = {
  __typename?: 'Glp1PrescriptionTaskContext';
  appointment: PlatformGlp1Appointment;
  benefitsCheck?: Maybe<PlatformBenefitsCheck>;
  patient: PlatformMedicationProgramPatient;
  prescriptions: Array<PlatformMedicationProgramPrescription>;
  prevAppointments: Array<PlatformGlp1Appointment>;
  priorAuthorizations: Array<PlatformPriorAuthorization>;
  task: PlatformGlp1PrescriptionTask;
};

export type PlatformGlp1PrescriptionTaskListItem = {
  __typename?: 'Glp1PrescriptionTaskListItem';
  appointment: PlatformGlp1Appointment;
  patient: PlatformMedicationProgramPatient;
  task: PlatformGlp1PrescriptionTask;
};

export enum PlatformGlp1PrescriptionTaskOutcome {
  Prescribed = 'PRESCRIBED',
  PriorAuthCompleted = 'PRIOR_AUTH_COMPLETED',
  PriorAuthStarted = 'PRIOR_AUTH_STARTED',
  Skipped = 'SKIPPED'
}

export enum PlatformGlp1PrescriptionTaskStatus {
  Completed = 'COMPLETED',
  New = 'NEW',
  Pending = 'PENDING'
}

export type PlatformGlp1PrescriptionTasksResult = {
  __typename?: 'Glp1PrescriptionTasksResult';
  tasks: Array<PlatformGlp1PrescriptionTaskListItem>;
  totalCount: Scalars['Int']['output'];
};

export enum PlatformGlp1Product {
  FoundayoOral = 'FOUNDAYO_ORAL',
  MounjaroInjector = 'MOUNJARO_INJECTOR',
  OzempicInjector = 'OZEMPIC_INJECTOR',
  WegovyInjector = 'WEGOVY_INJECTOR',
  WegovyOral = 'WEGOVY_ORAL',
  ZepboundKwikpen = 'ZEPBOUND_KWIKPEN'
}

export type PlatformGlucoseHistoryInput = {
  patientHealthieId: Scalars['ID']['input'];
};

export type PlatformGlucoseReading = {
  __typename?: 'GlucoseReading';
  id: Scalars['ID']['output'];
  observedAt: Scalars['DateTime']['output'];
  /** Recognized acquisition source; null for unsupported canonical provenance. */
  source?: Maybe<PlatformGlucoseSource>;
  unit: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type PlatformGlucoseReadingIngestInput = {
  code: Scalars['String']['input'];
  observedAt: Scalars['DateTime']['input'];
  sourceResourceId: Scalars['ID']['input'];
  system: Scalars['String']['input'];
  unit: Scalars['String']['input'];
  value: Scalars['Float']['input'];
};

export enum PlatformGlucoseSource {
  AppleHealth = 'APPLE_HEALTH',
  HealthConnect = 'HEALTH_CONNECT'
}

/** Input to rewind a session one step. */
export type PlatformGoBackOnboardingStepInput = {
  /** Opaque session handle returned at session start. */
  sessionId: Scalars['ID']['input'];
};

/** Successful rewind (previous session step) or a business error the client must handle. */
export type PlatformGoBackOnboardingStepResult = PlatformOnboardingSessionWithStep | PlatformSessionNotFoundError;

/**
 * A parent or legal guardian booking for a patient under 18. The account's
 * email and phone are the guardian's; every other patient detail is the
 * patient's.
 */
export type PlatformGuardianBookingContext = {
  __typename?: 'GuardianBookingContext';
  /** The patient's first name, for copy addressed to the guardian about the patient. */
  patientFirstName: Scalars['String']['output'];
};

/** Health metric category types supported for HealthKit sync */
export enum PlatformHealthMetricCategory {
  /** Active calories burned - summed daily, stored locally only */
  ActiveCalories = 'ACTIVE_CALORIES',
  /** Active minutes - summed daily, stored locally only */
  ActivityMinutes = 'ACTIVITY_MINUTES',
  /** Blood glucose (mg/dL) - stored locally only, NOT sent to Healthie */
  BloodGlucose = 'BLOOD_GLUCOSE',
  /** Heart rate (bpm) - aggregated to daily avg/min/max */
  HeartRate = 'HEART_RATE',
  /** Steps count - summed daily */
  Steps = 'STEPS'
}

/** A single health metric reading (e.g., one heart rate sample) */
export type PlatformHealthMetricReadingInput = {
  /** When the reading was recorded (ISO 8601) */
  recordedAt: Scalars['DateTime']['input'];
  /** Metric value as a number (e.g., 72 for heart rate, 5000 for steps) */
  value: Scalars['Float']['input'];
};

/** Physical address for a Healthie user. */
export type PlatformHealthieAddress = {
  __typename?: 'HealthieAddress';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  line1?: Maybe<Scalars['String']['output']>;
  line2?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

/**
 * An appointment from Healthie EHR.
 *
 * Timestamp fields are passed through from Healthie as raw strings.
 * `date` uses ISO 8601 format (e.g. `2025-12-10T19:30:00-05:00`).
 * `start` and `end` use a space-separated format (e.g. `2025-12-10 19:30:00 -0500`).
 */
export type PlatformHealthieAppointment = {
  __typename?: 'HealthieAppointment';
  actualDuration?: Maybe<Scalars['Int']['output']>;
  appointmentLabel?: Maybe<Scalars['String']['output']>;
  appointmentType?: Maybe<PlatformHealthieAppointmentType>;
  contactType?: Maybe<Scalars['String']['output']>;
  /** ISO 8601 datetime with timezone offset */
  date?: Maybe<Scalars['String']['output']>;
  /** Space-separated datetime: YYYY-MM-DD HH:MM:SS +/-ZZZZ */
  end?: Maybe<Scalars['String']['output']>;
  externalVideochatUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  length?: Maybe<Scalars['Int']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  /** Patient for this appointment (partial — use healthiePatient(id) for full profile) */
  patient?: Maybe<PlatformHealthiePatient>;
  pmStatus?: Maybe<Scalars['String']['output']>;
  /** Provider for this appointment (partial — use healthieProvider(id) for full profile) */
  provider?: Maybe<PlatformHealthieProvider>;
  /** Space-separated datetime: YYYY-MM-DD HH:MM:SS +/-ZZZZ */
  start?: Maybe<Scalars['String']['output']>;
  zoomJoinUrl?: Maybe<Scalars['String']['output']>;
  zoomStartUrl?: Maybe<Scalars['String']['output']>;
};

/**
 * Filter for appointment list queries.
 * Maps to Healthie's `appointments(filter:)` parameter.
 */
export enum PlatformHealthieAppointmentFilter {
  /** All appointments — combines PAST + FUTURE in two parallel requests */
  All = 'ALL',
  /** Appointments that did not occur (no-shows, etc.) */
  DidntOccur = 'DIDNT_OCCUR',
  /** Appointments that have ended (by time) */
  Ended = 'ENDED',
  /** Upcoming appointments (Healthie default) */
  Future = 'FUTURE',
  /** Completed past appointments */
  Past = 'PAST'
}

/** An appointment type defining the kind of visit. */
export type PlatformHealthieAppointmentType = {
  __typename?: 'HealthieAppointmentType';
  clientsCanBook?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  insuranceBillingEnabled?: Maybe<Scalars['Boolean']['output']>;
  isGroup?: Maybe<Scalars['Boolean']['output']>;
  length?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  pricing?: Maybe<Scalars['String']['output']>;
  pricingOption?: Maybe<Scalars['String']['output']>;
};

/** An availability slot for a provider. */
export type PlatformHealthieAvailabilitySlot = {
  __typename?: 'HealthieAvailabilitySlot';
  appointmentType?: Maybe<PlatformHealthieAppointmentType>;
  color?: Maybe<Scalars['String']['output']>;
  date: Scalars['String']['output'];
  hasWaitlistEnabled?: Maybe<Scalars['Boolean']['output']>;
  isFullyBooked?: Maybe<Scalars['Boolean']['output']>;
  length?: Maybe<Scalars['Int']['output']>;
  /** Healthie provider user ID */
  providerId?: Maybe<Scalars['String']['output']>;
};

/** A single form answer within a charting note. */
export type PlatformHealthieFormAnswer = {
  __typename?: 'HealthieFormAnswer';
  answer?: Maybe<Scalars['String']['output']>;
  customModuleId?: Maybe<Scalars['String']['output']>;
  displayedAnswer?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

/** A charting note (FormAnswerGroup) from Healthie. */
export type PlatformHealthieFormAnswerGroup = {
  __typename?: 'HealthieFormAnswerGroup';
  appointmentDate?: Maybe<Scalars['String']['output']>;
  /** ID of the linked appointment, if any */
  appointmentId?: Maybe<Scalars['String']['output']>;
  chartNoteStatus?: Maybe<Scalars['String']['output']>;
  formAnswers: Array<PlatformHealthieFormAnswer>;
  id: Scalars['ID']['output'];
  isLocked?: Maybe<Scalars['Boolean']['output']>;
  /** Healthie user ID of the patient */
  patientId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

/** Insurance authorization details for a policy. */
export type PlatformHealthieInsuranceAuthorization = {
  __typename?: 'HealthieInsuranceAuthorization';
  visitsAuthorized?: Maybe<Scalars['Int']['output']>;
  visitsLeft?: Maybe<Scalars['Int']['output']>;
  visitsUsed?: Maybe<Scalars['Int']['output']>;
};

/** An insurance plan in Healthie. */
export type PlatformHealthieInsurancePlan = {
  __typename?: 'HealthieInsurancePlan';
  id: Scalars['ID']['output'];
  payerId?: Maybe<Scalars['String']['output']>;
  payerName?: Maybe<Scalars['String']['output']>;
};

/** An insurance policy attached to a patient. */
export type PlatformHealthieInsurancePolicy = {
  __typename?: 'HealthieInsurancePolicy';
  id: Scalars['ID']['output'];
  insuranceAuthorization?: Maybe<PlatformHealthieInsuranceAuthorization>;
  priorityType?: Maybe<Scalars['String']['output']>;
};

/** An error or validation message returned by a Healthie mutation. */
export type PlatformHealthieMessage = {
  __typename?: 'HealthieMessage';
  field?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/**
 * A patient record from Healthie EHR.
 *
 * Named `HealthiePatient` (not `Patient`) intentionally — this is a proxy type
 * reflecting Healthie's data model. It will graduate to a domain-level `Patient`
 * type when internal abstraction is needed.
 */
export type PlatformHealthiePatient = {
  __typename?: 'HealthiePatient';
  /** Whether the patient account is active (not archived) */
  active: Scalars['Boolean']['output'];
  /** Archival datetime — null if active */
  archivedAt?: Maybe<Scalars['String']['output']>;
  /** Healthie ID of the patient's assigned provider */
  assignedProviderId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  dob?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  /** Name of the patient's user group */
  groupName?: Maybe<Scalars['String']['output']>;
  /** Healthie user ID (primary key for identity resolution) */
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  legalName?: Maybe<Scalars['String']['output']>;
  /** Patient's physical address */
  location?: Maybe<PlatformHealthieAddress>;
  /** JSON metadata blob (up to 128K) */
  metadata?: Maybe<Scalars['String']['output']>;
  /** Healthie organization ID */
  organizationId?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  preferredLanguageCode?: Maybe<Scalars['String']['output']>;
  /** Custom record identifier (MRN-like) */
  recordIdentifier?: Maybe<Scalars['String']['output']>;
  sex?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  /** Healthie ID of the patient's user group */
  userGroupId?: Maybe<Scalars['String']['output']>;
};

/**
 * A provider record from Healthie EHR.
 *
 * Named `HealthieProvider` (not `Provider`) intentionally — this is a proxy type
 * reflecting Healthie's data model. It will graduate to a domain-level `Provider`
 * type when internal abstraction is needed.
 */
export type PlatformHealthieProvider = {
  __typename?: 'HealthieProvider';
  /** Whether the provider account is active (not archived) */
  active: Scalars['Boolean']['output'];
  avatarUrl?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  /** Healthie provider ID */
  id: Scalars['ID']['output'];
  /** Whether the provider is actively practicing */
  isActiveProvider?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the provider is an organization admin */
  isOrgAdmin?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the provider is the organization owner */
  isOwner?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  licenseNum?: Maybe<Scalars['String']['output']>;
  /** JSON metadata blob (up to 128K) */
  metadata?: Maybe<Scalars['String']['output']>;
  /** National Provider Identifier */
  npi?: Maybe<Scalars['String']['output']>;
  /** Healthie organization ID */
  organizationId?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  profession?: Maybe<Scalars['String']['output']>;
  qualifications?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

/** Availability slots grouped by provider — returned by the multi-provider query. */
export type PlatformHealthieProviderAvailability = {
  __typename?: 'HealthieProviderAvailability';
  providerId: Scalars['ID']['output'];
  slots: Array<PlatformHealthieAvailabilitySlot>;
};

/** A Stripe payment card on file in Healthie. */
export type PlatformHealthieStripeCard = {
  __typename?: 'HealthieStripeCard';
  bankType?: Maybe<Scalars['String']['output']>;
  cardType?: Maybe<Scalars['String']['output']>;
  cardTypeLabel?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  expiration?: Maybe<Scalars['String']['output']>;
  expiringNextMonth?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  lastFour?: Maybe<Scalars['String']['output']>;
  sourceStatus?: Maybe<Scalars['String']['output']>;
  sourceType?: Maybe<Scalars['String']['output']>;
  stripeId?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

/** A tag in Healthie used for patient classification. */
export type PlatformHealthieTag = {
  __typename?: 'HealthieTag';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** A user group in Healthie. */
export type PlatformHealthieUserGroup = {
  __typename?: 'HealthieUserGroup';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type PlatformHoldAppointmentSlotInput = {
  appointmentType: PlatformAppointmentType;
  /** Canonical provider-registry id. The caller chooses the provider -- this domain applies no matching or assignment policy -- and a hold is per-provider: holding this slot does not affect any other provider's availability. */
  providerId: Scalars['ID']['input'];
  sessionId: Scalars['ID']['input'];
  startTime: Scalars['DateTime']['input'];
};

export type PlatformHoldDietitianAppointmentInput = {
  providerId: Scalars['ID']['input'];
  sessionId: Scalars['ID']['input'];
  startTime: Scalars['DateTime']['input'];
};

export type PlatformHoldDietitianAppointmentResult = PlatformDietitianAppointmentHold | PlatformDietitianAppointmentUnavailableError;

export type PlatformHoldGlp1AppointmentInput = {
  /**
   * Canonical provider-registry id of the chosen prescriber. Null for "Any
   * available clinician": the server holds the highest-ranked displayed
   * prescriber free at `startTime`.
   */
  providerId?: InputMaybe<Scalars['ID']['input']>;
  sessionId: Scalars['ID']['input'];
  startTime: Scalars['DateTime']['input'];
};

export type PlatformHoldGlp1AppointmentResult = PlatformGlp1AppointmentHold | PlatformGlp1AppointmentUnavailableError;

/** An ICD-10 code from the Healthie code catalog. */
export type PlatformIcdCode = {
  __typename?: 'IcdCode';
  code: Scalars['String']['output'];
  displayName?: Maybe<Scalars['String']['output']>;
  /** Healthie ICD code id. */
  id: Scalars['ID']['output'];
};

/** Image data for upload */
export type PlatformImageInput = {
  /** Base64-encoded image data, at most 8388608 characters (6 MiB decoded); longer fails with `BAD_USER_INPUT`. */
  data: Scalars['String']['input'];
  /** Original filename (optional) */
  filename?: InputMaybe<Scalars['String']['input']>;
  /** MIME type of the image (e.g., 'image/jpeg', 'image/png', 'image/heic') */
  mimeType: Scalars['String']['input'];
};

export type PlatformIncompletePatientProfileError = PlatformLabsError & {
  __typename?: 'IncompletePatientProfileError';
  message: Scalars['String']['output'];
  missingFields: Array<Scalars['String']['output']>;
};

export type PlatformIngestGlucoseReadingsInput = {
  patientId: Scalars['ID']['input'];
  readings: Array<PlatformGlucoseReadingIngestInput>;
  source: PlatformGlucoseSource;
};

export type PlatformIngestGlucoseReadingsPayload = {
  __typename?: 'IngestGlucoseReadingsPayload';
  acceptedCount: Scalars['Int']['output'];
  duplicateCount: Scalars['Int']['output'];
  receivedCount: Scalars['Int']['output'];
  rejectedCount: Scalars['Int']['output'];
};

/**
 * An ingredient on a food journal entry. Sourced from patient-app-api; the
 * platform journaling subgraph does not own this data on disk.
 */
export type PlatformIngredient = {
  __typename?: 'Ingredient';
  /** Alternate serving measures from Nutritionix. Empty when none were stored. */
  altMeasures: Array<PlatformAltMeasure>;
  /** When the ingredient row was created in patient-app-api. For a snap ingredient, the journal entry's createdAt. */
  createdAt: Scalars['DateTime']['output'];
  /** Source of the ingredient data. Null when patient-app-api did not record one. */
  dataSource?: Maybe<PlatformIngredientDataSource>;
  /** Source-system identifier (e.g., a Nutritionix id). Null when patient-app-api did not record one. */
  externalId?: Maybe<Scalars['String']['output']>;
  /** Id of the food journal entry the ingredient belongs to, as that entry's `id` serves it: a Healthie entry id, or an `nh-` id while food is served from NaviHealth. Treat it as opaque. */
  foodJournalEntryId: Scalars['ID']['output'];
  /** Stable ingredient id (UUID from patient-app-api when present, otherwise synthesized within a request). */
  id: Scalars['ID']['output'];
  /** Name of the ingredient (e.g., 'Chicken breast', 'Brown rice'). */
  name: Scalars['String']['output'];
  /** Nutritional metrics for this ingredient (calories, protein, carbs, etc.). Empty if patient-app-api had no macros stored, and always empty for snap ingredients, which carry none. */
  nutritionalMetrics: Array<PlatformNutritionalMetric>;
  /** Quantity of the ingredient (numeric value, paired with `unit`). */
  quantity: Scalars['Float']['output'];
  /** Unit of measurement (e.g., 'g', 'ml', 'pieces', 'cup', 'tbsp'). */
  unit: Scalars['String']['output'];
  /** When the ingredient row was last updated in patient-app-api. For a snap ingredient, the journal entry's updatedAt (its createdAt when it has none). */
  updatedAt: Scalars['DateTime']['output'];
};

/** Source of ingredient data */
export enum PlatformIngredientDataSource {
  /** Data sourced from Healthify */
  Healthify = 'HEALTHIFY',
  /** Data sourced from Nutritionix (common foods) */
  Nutritionix = 'NUTRITIONIX',
  /** Data sourced from Nutritionix (branded/packaged foods) */
  NutritionixBranded = 'NUTRITIONIX_BRANDED'
}

/**
 * A policy's authorization on the patient's record. Every value is the record's own string,
 * unchanged: visits can be "Unlimited", an empty string or any other text, and dates are not parsed.
 */
export type PlatformInsuranceAuthorization = {
  __typename?: 'InsuranceAuthorization';
  endOn?: Maybe<Scalars['String']['output']>;
  startOn?: Maybe<Scalars['String']['output']>;
  visitsAuthorized?: Maybe<Scalars['String']['output']>;
  visitsLeft?: Maybe<Scalars['String']['output']>;
  visitsUsed?: Maybe<Scalars['String']['output']>;
};

/**
 * One policy's benefit row on the patient's record. Every value is the record's own, unchanged:
 * amounts are strings such as "$20", never parsed.
 */
export type PlatformInsuranceBenefit = {
  __typename?: 'InsuranceBenefit';
  coinsurance?: Maybe<Scalars['String']['output']>;
  copay?: Maybe<Scalars['String']['output']>;
  deductibleCalendarYear?: Maybe<Scalars['String']['output']>;
  deductibleYearToDate?: Maybe<Scalars['String']['output']>;
  telemedicine?: Maybe<Scalars['Boolean']['output']>;
};

/** Why insurance-card images were not attached. */
export enum PlatformInsuranceCardAttachSkipReason {
  /** The patient has no Healthie identity in the registry. */
  NoHealthieIdentity = 'NO_HEALTHIE_IDENTITY',
  /** The patient's Healthie chart has no insurance policy to patch. Expected for leads whose best-effort policy write was skipped (e.g. a long-tail payer with no curated Healthie plan). */
  NoPolicyOnFile = 'NO_POLICY_ON_FILE'
}

/** An insurance card photo, stored as a file under this name and content type. */
export type PlatformInsuranceCardFileInput = {
  /** Base64-encoded file bytes, without a data-URI prefix. Stored unchanged. */
  content: Scalars['String']['input'];
  /** Content type stored with the card. */
  contentType: Scalars['String']['input'];
  /** File name stored with the card. */
  filename: Scalars['String']['input'];
};

/** One side of an insurance card as captured by the patient. */
export type PlatformInsuranceCardImageInput = {
  /** Base64-encoded image bytes, without a data-URI prefix. */
  content: Scalars['String']['input'];
  /** MIME type of the image. `image/jpeg`, `image/png`, `image/heic`, and `image/heif` are accepted; anything else is rejected before any Healthie call. `image/heic`/`image/heif` is converted to JPEG before the Healthie policy write — Healthie itself only ever receives JPEG or PNG. */
  contentType: Scalars['String']['input'];
};

/**
 * Who an insurance call is for. The registry patient is always the one externalId belongs to;
 * patientId is only compared with it.
 */
export type PlatformInsurancePatientInput = {
  /** The caller's EHR patient id (the Healthie user id today). The platform always reads and writes this chart; the registry is only checked against it. */
  externalId: Scalars['ID']['input'];
  /** Berry Street patient registry id, when the caller has one. */
  patientId?: InputMaybe<Scalars['ID']['input']>;
};

/** The insurance plan a policy is on, as the patient's record holds it. */
export type PlatformInsurancePlan = {
  __typename?: 'InsurancePlan';
  /** The plan's id on the patient's record. */
  id: Scalars['ID']['output'];
  payerId?: Maybe<Scalars['String']['output']>;
  payerName?: Maybe<Scalars['String']['output']>;
};

/**
 * A policy on the patient's record. Every string is the record's own value, unchanged: an empty
 * string stays empty, case and spacing are kept.
 */
export type PlatformInsurancePolicy = {
  __typename?: 'InsurancePolicy';
  /** The id of the back card photo's document on the patient's record. */
  cardBackDocumentId?: Maybe<Scalars['ID']['output']>;
  /** The id of the front card photo's document on the patient's record. */
  cardFrontDocumentId?: Maybe<Scalars['ID']['output']>;
  groupNumber?: Maybe<Scalars['String']['output']>;
  holderDateOfBirth?: Maybe<Scalars['String']['output']>;
  /** For example Self from the patient app, SELF from booking-flow. */
  holderRelationship?: Maybe<Scalars['String']['output']>;
  /** The policy's id on the patient's record. */
  id: Scalars['ID']['output'];
  memberId?: Maybe<Scalars['String']['output']>;
  plan?: Maybe<PlatformInsurancePlan>;
  /** For example primary, secondary or inactive. Any value the record holds, not only InsurancePolicyPriority's. */
  priority?: Maybe<Scalars['String']['output']>;
};

/** Why an insurance policy was not attached. */
export enum PlatformInsurancePolicyAttachSkipReason {
  /** An identical policy (same Healthie insurance-plan id and member id) is already on file; the write was a no-op rather than a duplicate append. */
  AlreadyOnFile = 'ALREADY_ON_FILE',
  /** The Healthie call itself failed. */
  HealthieError = 'HEALTHIE_ERROR',
  /** Healthie accepted the request but did not confirm the policy in its response. */
  HealthieNotConfirmed = 'HEALTHIE_NOT_CONFIRMED',
  /** The patient has no Healthie identity in the registry. */
  NoHealthieIdentity = 'NO_HEALTHIE_IDENTITY'
}

/**
 * A policy with its benefits, authorization and notes. Every string is the record's own value, unchanged: an
 * empty string stays empty, case and spacing are kept.
 */
export type PlatformInsurancePolicyDetails = {
  __typename?: 'InsurancePolicyDetails';
  /** Null when the policy has no authorization. */
  authorization?: Maybe<PlatformInsuranceAuthorization>;
  /** Null when the record has no benefits list for the policy. */
  benefits?: Maybe<Array<PlatformInsuranceBenefit>>;
  /** The policy's id on the patient's record. */
  id: Scalars['ID']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  /** Null when the policy has no insurance plan. */
  plan?: Maybe<PlatformInsurancePlan>;
  /** For example primary, secondary or inactive. Any value the record holds. */
  priority?: Maybe<Scalars['String']['output']>;
};

/** Who holds the policy. A field left out is not sent. */
export type PlatformInsurancePolicyHolderInput = {
  /** The holder's date of birth, stored as sent. Ignored when relationship is SELF: the record's value is cleared. */
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  relationship?: InputMaybe<PlatformPolicyHolderRelationship>;
};

/** Where an insurance policy sits on the patient's record. */
export enum PlatformInsurancePolicyPriority {
  Inactive = 'INACTIVE',
  Primary = 'PRIMARY',
  Secondary = 'SECONDARY'
}

/** Type of insurance plan */
export enum PlatformInsuranceType {
  Cobra = 'COBRA',
  Commercial = 'COMMERCIAL',
  Epo = 'EPO',
  GroupPolicy = 'GROUP_POLICY',
  Hmo = 'HMO',
  HmoMedicareRisk = 'HMO_MEDICARE_RISK',
  Indemnity = 'INDEMNITY',
  IndividualPolicy = 'INDIVIDUAL_POLICY',
  Medicaid = 'MEDICAID',
  Medicare = 'MEDICARE',
  MedicarePartA = 'MEDICARE_PART_A',
  MedicarePrimary = 'MEDICARE_PRIMARY',
  Other = 'OTHER',
  Pos = 'POS',
  Ppo = 'PPO',
  Qmb = 'QMB',
  SupplementalPolicy = 'SUPPLEMENTAL_POLICY'
}

/** The group a patient belongs to on the record. */
export type PlatformInsuranceUserGroup = {
  __typename?: 'InsuranceUserGroup';
  /** When the record created the group, as sent. */
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

/**
 * Identity of the Google Workspace user currently authenticated to the
 * internal-ops domain, along with the capabilities they've been granted by the
 * domain's capability registry.
 */
export type PlatformInternalOpsPrincipal = {
  __typename?: 'InternalOpsPrincipal';
  capabilities: Array<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  hostedDomain?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<Scalars['String']['output']>;
};

/** Union of all journal entry types */
export type PlatformJournalEntry = PlatformActivityJournalEntry | PlatformFoodJournalEntry | PlatformSleepDurationJournalEntry | PlatformStepsJournalEntry | PlatformStoolJournalEntry | PlatformSymptomJournalEntry | PlatformWaterIntakeJournalEntry | PlatformWeightJournalEntry;

/** Common fields shared by all journal entry types. Clients can query these via ... on JournalEntryBase without needing type-specific fragments. */
export type PlatformJournalEntryBase = {
  /** Comments from providers or other users on this entry */
  comments: Array<PlatformEntryComment>;
  /** When the entry was created */
  createdAt: Scalars['DateTime']['output'];
  /** The entry owner's Healthie user id, or `unknown` when journaling has none */
  createdBy: Scalars['String']['output'];
  /** Optional description or notes */
  description?: Maybe<Scalars['String']['output']>;
  /** Unique identifier */
  id: Scalars['ID']['output'];
  /** IANA timezone identifier (e.g., 'America/Los_Angeles') */
  timezone?: Maybe<Scalars['String']['output']>;
};

/** Comments on one journal entry, keyed by its entry id */
export type PlatformJournalEntryComments = {
  __typename?: 'JournalEntryComments';
  /** The entry's comments and reactions, oldest first */
  comments: Array<PlatformEntryComment>;
  /** Id of the journal entry, as returned by `journalEntries`; Healthie entry ids today. Treat it as opaque. */
  entryId: Scalars['ID']['output'];
};

/** Which of a patient's journal entries to read comments for */
export type PlatformJournalEntryCommentsInput = {
  /** Ids of the entries, as returned by `journalEntries`; Healthie entry ids today. Treat them as opaque. At most 5000. */
  entryIds: Array<Scalars['ID']['input']>;
  /** Patient registry id of the patient who owns the entries */
  patientId: Scalars['ID']['input'];
};

/**
 * Who a created entry is attributed to, stored as its creator where the store keeps one (NaviHealth's
 * `created_by`). Healthie doesn't store it.
 */
export enum PlatformJournalEntryCreatedByKind {
  /** Berry Street's care agent (Perry) */
  CareAgent = 'CARE_AGENT',
  /** A LoseIt food log */
  Loseit = 'LOSEIT',
  /** The patient, through the app or on their behalf */
  Patient = 'PATIENT'
}

/**
 * The system a journal write came from, sent with `externalId`, the write's id in that system. What
 * the pair does depends on the mutation: see `externalIdType` on CreateJournalEntryInput,
 * UpsertDailyTotalInput and CreateHealthMetricEntryInput.
 */
export enum PlatformJournalEntryExternalIdType {
  /** Apple HealthKit; `externalId` is the record's `sourceId`, a sample UUID or a stable daily id such as `HK-Steps-2026-10-07` or `HK-Sleep-2026-10-07` */
  HealthkitSourceId = 'HEALTHKIT_SOURCE_ID',
  /** Android Health Connect; `externalId` is the record's `sourceId`, such as `HC-Sleep-<session id>` */
  HealthConnectSourceId = 'HEALTH_CONNECT_SOURCE_ID',
  /** A LoseIt food log; `externalId` is its food-log id */
  LoseitFoodLog = 'LOSEIT_FOOD_LOG'
}

/** Journal entry kinds that can be read: the `types` filter on journalEntries. The writable JournalEntryType values plus the device kinds STEPS and SLEEP_DURATION. */
export enum PlatformJournalEntryFilterType {
  /** Exercise/movement activity */
  Activity = 'ACTIVITY',
  /** Food/meal logging */
  Food = 'FOOD',
  /** Sleep, synced from a device (SleepDurationJournalEntry). createJournalEntry and updateJournalEntry reject it; upsertDailyTotal writes it. journalEntries returns these entries only when SLEEP_DURATION is listed in `types`. */
  SleepDuration = 'SLEEP_DURATION',
  /** Steps for the day, synced from a device (StepsJournalEntry). Read-only: createJournalEntry and updateJournalEntry reject it. journalEntries returns these entries only when STEPS is listed in `types`. */
  Steps = 'STEPS',
  /** Bowel movement tracking (Bristol scale) */
  Stool = 'STOOL',
  /** Symptom tracking */
  Symptom = 'SYMPTOM',
  /** Water intake tracking */
  WaterIntake = 'WATER_INTAKE',
  /** Body weight measurement */
  Weight = 'WEIGHT'
}

/** Filter parameters for querying journal entries */
export type PlatformJournalEntryFiltersInput = {
  /** Filter entries created on or before this date */
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Healthie user id of the patient whose entries to retrieve. Send `patientRegistryId` where the caller has it; keep sending this for patients the patient registry doesn't hold yet. When `patientRegistryId` is also set, read only if the registry holds no primary Healthie user id for it or the registry lookup fails. That fallback stays until every registry patient has exactly one primary Healthie user id (BSE-3718). */
  patientId?: InputMaybe<Scalars['ID']['input']>;
  /** Patient registry id of the patient whose entries to retrieve. Takes precedence over `patientId`. At least one of the two is required. */
  patientRegistryId?: InputMaybe<Scalars['ID']['input']>;
  /** Order in which to return results (defaults to newest first) */
  sortOrder?: InputMaybe<PlatformSortOrder>;
  /** Filter entries created on or after this date */
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Entry types to return. Omitted or null returns FOOD, SYMPTOM, WEIGHT, ACTIVITY, WATER_INTAKE and STOOL entries; STEPS and SLEEP_DURATION entries come back only when listed. When set, the filter is applied before paging. A page can still be short while `hasMore` is true, when it leaves out an entry it can't return, such as a steps or sleep entry without a value, so page on `hasMore`, not on page length. An empty list fails with `BAD_USER_INPUT`. */
  types?: InputMaybe<Array<PlatformJournalEntryFilterType>>;
};

/** A legacy Healthie journal entry id and the NaviHealth entry it maps to, as returned by `journalEntryIdMap`. Store or hand out `servedId`; don't build an entry id from `key` and `id`. */
export type PlatformJournalEntryIdMapping = {
  __typename?: 'JournalEntryIdMapping';
  /** The Healthie entry id that was asked for */
  healthieEntryId: Scalars['ID']['output'];
  /** NaviHealth row id of the entry, digits only (for steps and sleep, the patient's day as yyyymmdd). Aggregated water and steps entries map to the patient's day row, so several Healthie ids can share one `key` and `id`. For sleep, `id` is the day in the patient's timezone; when `patientTimezoneApplied` is false, don't persist an `sl` mapping. */
  id: Scalars['ID']['output'];
  /** NaviHealth table key of the entry, such as `st` or `fl`; always one the platform's entry id codec knows */
  key: Scalars['String']['output'];
  /** Whether `id` was resolved in the patient's Healthie timezone. Always true for every key but `sl`. For `sl`, true only when the platform sent the patient's timezone and NaviHealth used it; a false `sl` mapping is a day in NaviHealth's stored profile zone, which may not be the patient's, so it must not be persisted. */
  patientTimezoneApplied: Scalars['Boolean']['output'];
  /** The id the subgraph serves for this entry right now: its `nh-` id while the entry's type is served from NaviHealth, else `healthieEntryId`. It changes when the type's store flag flips. */
  servedId: Scalars['ID']['output'];
};

/** Paginated result set for unified journal entries */
export type PlatformJournalEntryPage = {
  __typename?: 'JournalEntryPage';
  /** List of journal entries (mixed types) */
  entries: Array<PlatformJournalEntry>;
  /** Pagination metadata */
  pageInfo: PlatformPageInfo;
  /** Number of the patient's entries that match the filters, across all pages: the whole history when no dates are given. Counted only when selected. It is a count, not a page count: pages can be short, both when an entry can't be returned and, without `types`, because entries of other kinds are left out after reading, so page on `hasMore`. Null when the count fails; the error is in `errors` and `entries` still resolve. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Journal entry types that can be written: the discriminator for the unified create/update mutations */
export enum PlatformJournalEntryType {
  /** Exercise/movement activity */
  Activity = 'ACTIVITY',
  /** Food/meal logging */
  Food = 'FOOD',
  /** Bowel movement tracking (Bristol scale) */
  Stool = 'STOOL',
  /** Symptom tracking */
  Symptom = 'SYMPTOM',
  /** Water intake tracking */
  WaterIntake = 'WATER_INTAKE',
  /** Body weight measurement */
  Weight = 'WEIGHT'
}

export type PlatformLabAddress = {
  __typename?: 'LabAddress';
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  line1: Scalars['String']['output'];
  line2?: Maybe<Scalars['String']['output']>;
  postalCode: Scalars['String']['output'];
  state: Scalars['String']['output'];
};

/**
 * A walk-in lab branch (Patient Service Center).
 *
 * `locationId` is the provider's per-branch identifier.
 */
export type PlatformLabLocation = {
  __typename?: 'LabLocation';
  address: PlatformLabAddress;
  distanceMiles?: Maybe<Scalars['Float']['output']>;
  locationId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  network: PlatformLabNetwork;
  /** Opaque provider network identifier for the selected lab network. */
  networkLabId: Scalars['Int']['output'];
  supportedBillTypes: Array<Scalars['String']['output']>;
  supportsAppointmentScheduling: Scalars['Boolean']['output'];
  vendor: PlatformLabVendor;
};

/** Reference lab network for a walk-in / phlebotomy location. */
export enum PlatformLabNetwork {
  Bioreference = 'BIOREFERENCE',
  Labcorp = 'LABCORP',
  Other = 'OTHER',
  Quest = 'QUEST',
  SonoraQuest = 'SONORA_QUEST'
}

/** A lab order placed on behalf of a patient. */
export type PlatformLabOrder = {
  __typename?: 'LabOrder';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  modality: PlatformLabOrderModality;
  orderedAt: Scalars['DateTime']['output'];
  patientId: Scalars['ID']['output'];
  results: Array<PlatformLabResult>;
  status: PlatformLabOrderStatus;
  triggerReason: PlatformLabOrderTrigger;
  vendor: PlatformLabVendor;
  vendorOrderId: Scalars['ID']['output'];
};

/** Lab modality. v0 wires AT_HOME_KIT and WALK_IN. */
export enum PlatformLabOrderModality {
  AtHomeKit = 'AT_HOME_KIT',
  AtHomePhlebotomy = 'AT_HOME_PHLEBOTOMY',
  OnSite = 'ON_SITE',
  WalkIn = 'WALK_IN'
}

/** Lab order lifecycle status. */
export enum PlatformLabOrderStatus {
  AppointmentCancelled = 'APPOINTMENT_CANCELLED',
  AppointmentPending = 'APPOINTMENT_PENDING',
  AppointmentScheduled = 'APPOINTMENT_SCHEDULED',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Critical = 'CRITICAL',
  DrawCompleted = 'DRAW_COMPLETED',
  DrawScheduled = 'DRAW_SCHEDULED',
  Failed = 'FAILED',
  Ordered = 'ORDERED',
  PartialResults = 'PARTIAL_RESULTS',
  RedrawAvailable = 'REDRAW_AVAILABLE',
  RequisitionCreated = 'REQUISITION_CREATED'
}

/** Why a lab order was placed. */
export enum PlatformLabOrderTrigger {
  Intake = 'INTAKE',
  ManualOps = 'MANUAL_OPS',
  PatientSelfServe = 'PATIENT_SELF_SERVE',
  PreFollowup = 'PRE_FOLLOWUP',
  PrePaRenewal = 'PRE_PA_RENEWAL'
}

/** A lab result for an order. */
export type PlatformLabResult = {
  __typename?: 'LabResult';
  healthieDocumentId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  isCritical: Scalars['Boolean']['output'];
  isFinal: Scalars['Boolean']['output'];
  labOrderId: Scalars['ID']['output'];
  receivedAt: Scalars['DateTime']['output'];
};

/** Integrated lab vendor (extensible when adding providers). */
export enum PlatformLabVendor {
  Junction = 'JUNCTION'
}

export type PlatformLabsError = {
  message: Scalars['String']['output'];
};

/**
 * Lead name for the welcome-v2 EMAIL step's Freshpaint pixel, resolved from the
 * same confirm-coverage/self-pay-details (+ verify-coverage override) rows the
 * booking conversion's Meta match keys read — see `leadNameContext`.
 */
export type PlatformLeadName = {
  __typename?: 'LeadName';
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
};

/** Reference to a Linear issue that was created by the domain. */
export type PlatformLinearTicketRef = {
  __typename?: 'LinearTicketRef';
  /** Human-readable identifier (e.g. IT-123). */
  identifier: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type PlatformLinkMedicareBridgeCaseTargetInput = {
  caseId: Scalars['ID']['input'];
  kind: PlatformMedicareBridgeCaseLinkKind;
  /** Why this link is being recorded. Required. */
  reason: Scalars['String']['input'];
  targetId: Scalars['ID']['input'];
};

export type PlatformLinkMedicareBridgeCaseTargetPayload = {
  __typename?: 'LinkMedicareBridgeCaseTargetPayload';
  medicareBridgeCase: PlatformMedicareBridgeCase;
};

export type PlatformLinkReferringPhysicianInput = {
  patient: PlatformReferringPhysicianPatientInput;
  /** Healthie's referring physician id. */
  referringPhysicianId: Scalars['ID']['input'];
};

export type PlatformLinkReferringPhysicianPayload = {
  __typename?: 'LinkReferringPhysicianPayload';
  /** True when the patient was already linked and nothing was created. */
  alreadyLinked: Scalars['Boolean']['output'];
  /** Healthie's validation messages. Empty on success. */
  messages: Array<PlatformReferringPhysicianMessage>;
  /** The new referral, or the existing one when the patient was already linked. Null when Healthie rejected the create. */
  referral?: Maybe<PlatformReferringPhysicianReferral>;
};

export type PlatformLogMedicationTakeInput = {
  /** Amount taken, in the medication's `unit`. Omit when the patient didn't state one. */
  doseAmount?: InputMaybe<Scalars['Float']['input']>;
  /**
   * Calendar day the patient picked, `YYYY-MM-DD`. Stored exactly as sent — this
   * is the record of when the dose was taken, not a derivation. The first log for
   * a medication is what establishes its `startDate`.
   */
  doseDate: Scalars['String']['input'];
  /**
   * Wall-clock time the patient picked, `HH:mm` on a 24-hour clock. Stored as sent,
   * and returned as sent — no timezone conversion happens anywhere.
   */
  doseTime: Scalars['String']['input'];
  injectionSite?: InputMaybe<PlatformMedicationInjectionSite>;
  medicationId: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  patientHealthieId: Scalars['ID']['input'];
  /** Identifier of the pen or vial used for this dose. Stored exactly as supplied. */
  penOrVialId?: InputMaybe<Scalars['String']['input']>;
};

export type PlatformMarkAccessReferralAwaitingRejectionInput = {
  accessEnrollmentId: Scalars['ID']['input'];
  actorId?: InputMaybe<Scalars['ID']['input']>;
  healthieUserId: Scalars['String']['input'];
};

export type PlatformMarkAccessReferralAwaitingRejectionPayload = {
  __typename?: 'MarkAccessReferralAwaitingRejectionPayload';
  accessEnrollmentId: Scalars['ID']['output'];
  idempotent: Scalars['Boolean']['output'];
  status: PlatformAccessEnrollmentStatus;
};

/** Input for patient marking a goal complete */
export type PlatformMarkSessionGoalCompleteInput = {
  /** Session goal ID */
  id: Scalars['ID']['input'];
  /** Patient ID (for authorization) */
  patientId: Scalars['ID']['input'];
};

export type PlatformMarkSupportConversationReadInput = {
  conversationId: Scalars['ID']['input'];
};

export type PlatformMarkSupportConversationReadPayload = {
  __typename?: 'MarkSupportConversationReadPayload';
  conversation?: Maybe<PlatformSupportConversation>;
  error?: Maybe<PlatformSupportError>;
};

/**
 * Marks a text field as the canonical capture point for a lead's email or
 * phone number, for downstream marketing attribution. Set explicitly by the
 * flow definition — never inferred from the field's id or format — so a field
 * that merely happens to look like an email/phone (e.g. an emergency contact)
 * is never mistaken for the lead's own contact info. Null means the field is
 * not a capture point.
 */
export enum PlatformMarketingCaptureKind {
  /** This field captures the lead's email address. */
  Email = 'EMAIL',
  /** This field captures the lead's phone number. */
  Phone = 'PHONE'
}

export type PlatformMatchDietitiansInput = {
  /**
   * Inclusive bounds on the availability this match returns, mirroring
   * scheduling's `AvailabilityWindowInput`. Null uses this domain's own default
   * warmed window (ranking-only, no slots on the response) — pass this so a
   * caller displaying availability gets it from the same fetch this match
   * already performs for ranking, instead of querying scheduling again.
   */
  availabilityWindow?: InputMaybe<PlatformAvailabilityWindowInput>;
  /**
   * Pages only dietitians with an open slot in this range; ranking and each
   * match's `availability` still use the whole `availabilityWindow`. Applies to
   * bounded pages (`limit`). Must lie within `availabilityWindow` with start no
   * later than end, else the request is rejected.
   */
  availableBetween?: InputMaybe<PlatformAvailabilityWindowInput>;
  /**
   * Quality floor from the caller's `composite-percentile-threshold` GrowthBook
   * experiment: the caller's SDK owns assignment and exposure tracking and passes
   * the assigned value through. Null (or a negative value) disables the floor —
   * never hardcode a threshold here. Providers pass when
   * `(compositePercentile ?? 50) >= threshold`; if none pass, the single best
   * provider by that same coalesced percentile is returned instead of an empty set.
   */
  compositePercentileThreshold?: InputMaybe<Scalars['Float']['input']>;
  /**
   * Languages the patient wants their dietitian to speak, from the response's
   * `availableLanguages`. A provider matches when it speaks any of them. Applied
   * to the eligible pool before the quality floor, ranking and paging, so
   * offsets stay stable coordinates within one language selection. Pinned
   * providers (an active hold) bypass it but not the quality floor. Null or
   * empty applies no filter.
   */
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * Maximum matches returned. Applied after ranking and the availability join,
   * in rank order, counting only providers with at least one slot in the
   * window — zero-slot providers are dropped entirely when a limit is set, so
   * a bounded page can never understate availability. Null returns every
   * match, including zero-slot providers (today's unbounded behavior).
   */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Booking-rank floor from the caller's `minimum-booking-rank` GrowthBook
   * feature — the welcome-side equivalent of CBF's `minimum-provider-threshold`.
   * Providers whose bookingRank is below this value demote below every other
   * provider, exactly like a Deprioritized override (and subject to the same
   * thin-pool backfill). Providers without a bookingRank always pass. Null
   * disables the floor — never hardcode a threshold here.
   */
  minimumBookingRank?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Continuation offset in canonical-rank coordinates — the ranked slot-having
   * list with pinned providers occupying their natural ranks regardless of
   * slots. Callers page with the response's `nextOffset`, never by counting
   * rows. Only meaningful with `limit`. A plain offset, not a cursor: the
   * ranked list can shift between requests (ranking experiments, slots
   * filling), so a page boundary is best-effort — accepted because the
   * picker's "show more" tolerates drift and the list is re-ranked per
   * request anyway.
   */
  offset?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Canonical patient id; the trusted caller supplies it only after identity
   * proof. Forwarded to the internal availability fetch, which drops slots
   * overlapping that patient's scheduled appointments before ranking and
   * paging; a failed schedule read leaves slots unfiltered. Null leaves slots
   * patient-agnostic.
   */
  patientId?: InputMaybe<Scalars['ID']['input']>;
  /** Patient payer id (== Healthie InsurancePlan.payer_id). Null selects the cash-pay path: state licensure only, no payer-enrollment gate. */
  payerId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Eligible providers that must stay resolvable across a bounded, paged read —
   * a caller's active hold. Pinned providers always occupy their natural rank
   * in the offset coordinate space and bypass the slot-having and `languages`
   * filters, though not the quality floor (the hold itself is the patient's
   * claim on the provider). They are emitted exactly once: the offset-0 window
   * includes them in rank position when they fall inside it and appends them
   * when they rank past it; every later window omits them without shifting its
   * coordinates. Ignored without `limit`; a
   * pinned id that fails eligibility is simply absent.
   */
  pinnedProviderIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Optional plan network type. Frequently unknown; null is treated as open. Irrelevant on the cash-pay path. */
  planType?: InputMaybe<PlatformPlanType>;
  /** The patient's primary visit reason, from the specialtyCategories vocabulary. */
  primaryVisitReason?: InputMaybe<Scalars['String']['input']>;
  /**
   * Same semantics as scheduling's `AppointmentAvailabilityInput.sameDayBookingAllowed`
   * (GLPX-357), forwarded verbatim to the internal availability fetch this match
   * performs. Null and false are identical: fail closed to the 24-hour default.
   * Only applies to notice-enforced types (MNT today) — irrelevant to GLP-1
   * matching, which never calls this field.
   */
  sameDayBookingAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  /** The patient's secondary visit reasons, from the specialtyCategories vocabulary. */
  secondaryVisitReasons?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * The requesting session, if any. Slots that overlap another session's hold
   * are excluded whether or not this is set; passing it additionally exempts
   * this session's own holds from that exclusion, so a caller re-reading
   * availability to commit its own held slot still sees it.
   */
  sessionId?: InputMaybe<Scalars['ID']['input']>;
  /** Two-letter US state abbreviation of the patient. */
  stateCode: Scalars['String']['input'];
  /**
   * The patient's IANA timezone (e.g. America/New_York), captured from their
   * browser. Feeds the ranker's `same_timezone_region` feature by exact string
   * equality with the provider's Healthie-synced timezone — CBF's serving
   * computation, verbatim. Null (a session with no browser behind it) omits the
   * feature, the same shape as a provider with no timezone on file.
   */
  timezone?: InputMaybe<Scalars['String']['input']>;
  /**
   * Arm of the caller's `use-retained-ranking-model` GrowthBook experiment,
   * forwarded to the AI ranking call. The caller's SDK owns assignment and
   * exposure tracking — never select an arm here. Null omits the flag.
   */
  useRetainedRankingModel?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PlatformMatchPrescribersInput = {
  /** Patient payer id (== Healthie InsurancePlan.payer_id). */
  payerId: Scalars['String']['input'];
  /** Optional plan network type. Frequently unknown; null is treated as open. */
  planType?: InputMaybe<PlatformPlanType>;
  /** Two-letter US state abbreviation of the patient. */
  stateCode: Scalars['String']['input'];
};

/** Meal categories for food journal entries */
export enum PlatformMealType {
  /** Morning meal */
  Breakfast = 'BREAKFAST',
  /** Evening meal */
  Dinner = 'DINNER',
  /** Midday meal */
  Lunch = 'LUNCH',
  /** Light meal between main meals */
  Snack = 'SNACK'
}

/**
 * A single canonical clinical measurement (lab result or vital), stored source-agnostically.
 * One row per source reading — measurements are a time series and are NOT de-duplicated by code.
 * Rows are uniquely identified across re-recordings by the (source, sourceResourceId) pair.
 */
export type PlatformMeasurement = {
  __typename?: 'Measurement';
  /** Measurement code (e.g. a LOINC code) */
  code: Scalars['String']['output'];
  /** Human-readable label for the code, when known */
  display?: Maybe<Scalars['String']['output']>;
  /** When the measurement was clinically effective (taken/observed) */
  effectiveAt?: Maybe<Scalars['DateTime']['output']>;
  /** Unique identifier */
  id: Scalars['ID']['output'];
  /** The source's first interpretation code (e.g. H, L, N). Null when absent or a no-information placeholder. */
  interpretation?: Maybe<Scalars['String']['output']>;
  /** Soft-invalidation date. Null means valid/active; non-null means invalidated as of this date. */
  invalidFromDate?: Maybe<Scalars['DateTime']['output']>;
  /** The source's annotation text. Several notes are joined with blank lines. */
  note?: Maybe<Scalars['String']['output']>;
  /** Internal patient-registry ID this measurement belongs to */
  patientId: Scalars['ID']['output'];
  /** When this row was first recorded in the clinical-records store */
  recordedAt: Scalars['DateTime']['output'];
  /** Upper bound of the source's first reference range. Null when the source gave none, or gave text only. */
  referenceHigh?: Maybe<Scalars['Float']['output']>;
  /** Lower bound of the source's first reference range. Null when the source gave none, or gave text only. */
  referenceLow?: Maybe<Scalars['Float']['output']>;
  /** The source's reference range text, when it sent one. Many labs send text-only ranges. */
  referenceText?: Maybe<Scalars['String']['output']>;
  /** Originating system for this measurement (half of the natural upsert key) */
  source: Scalars['String']['output'];
  /** When the source itself recorded the reading, when known */
  sourceRecordedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Stable identifier of this reading within the source, when one exists */
  sourceResourceId?: Maybe<Scalars['String']['output']>;
  /** Status of the reading as reported by the source (e.g. "final", "cancelled") */
  status?: Maybe<Scalars['String']['output']>;
  /** Coding system the code belongs to (e.g. "loinc") */
  system: Scalars['String']['output'];
  /** Unit of measure for value (e.g. "mg/dL"), when applicable */
  unit?: Maybe<Scalars['String']['output']>;
  /** When this row was last updated in the clinical-records store */
  updatedAt: Scalars['DateTime']['output'];
  /** Numeric value, for quantitative measurements */
  value?: Maybe<Scalars['Float']['output']>;
  /** Textual value, for qualitative measurements that have no numeric value */
  valueText?: Maybe<Scalars['String']['output']>;
};

/** Session-specific presentation context for the shared Medical background step. */
export type PlatformMedicalBackgroundContext = {
  __typename?: 'MedicalBackgroundContext';
  /** True only when no earlier active-path step supplied complete height and weight. */
  collectHeightAndWeight: Scalars['Boolean']['output'];
  /** Whether to show the BMI and health-history insurance-coverage explanation. */
  showInsuranceCoverageCopy: Scalars['Boolean']['output'];
};

/** Composed current Patient App Medical History. */
export type PlatformMedicalHistory = {
  __typename?: 'MedicalHistory';
  allergies?: Maybe<Scalars['String']['output']>;
  allergiesSource?: Maybe<PlatformMedicalHistorySource>;
  allergiesUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  conditionIds: Array<Scalars['ID']['output']>;
  conditionOptions: Array<PlatformMedicalHistoryConditionOption>;
  conditionsSource?: Maybe<PlatformMedicalHistorySource>;
  conditionsUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  patientId: Scalars['ID']['output'];
  selectedConditions: Array<PlatformMedicalHistoryConditionOption>;
  socialHistory?: Maybe<PlatformMedicalHistorySocialHistory>;
  socialHistorySource?: Maybe<PlatformMedicalHistorySource>;
  socialHistoryUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  surgeriesHospitalizations?: Maybe<Scalars['String']['output']>;
  surgeriesHospitalizationsSource?: Maybe<PlatformMedicalHistorySource>;
  surgeriesHospitalizationsUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** A stable condition option owned by Clinical Records. */
export type PlatformMedicalHistoryConditionOption = {
  __typename?: 'MedicalHistoryConditionOption';
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
};

/** Structured patient-reported social history. */
export type PlatformMedicalHistorySocialHistory = {
  __typename?: 'MedicalHistorySocialHistory';
  alcohol: Scalars['Boolean']['output'];
  drinksPerWeek?: Maybe<Scalars['Int']['output']>;
  nonPrescribedSubstances: Scalars['Boolean']['output'];
  tobacco: PlatformMedicalHistoryTobacco;
};

/** Trusted producer that most recently wrote a Medical History section. */
export enum PlatformMedicalHistorySource {
  PatientApp = 'PATIENT_APP'
}

/** Patient-reported tobacco use. */
export enum PlatformMedicalHistoryTobacco {
  FormerSmoker = 'FORMER_SMOKER',
  No = 'NO',
  Yes = 'YES'
}

export enum PlatformMedicareBridgeActorType {
  Ops = 'OPS',
  Provider = 'PROVIDER',
  System = 'SYSTEM'
}

/** One Medicare Bridge assessment for a patient and program. */
export type PlatformMedicareBridgeCase = {
  __typename?: 'MedicareBridgeCase';
  assignedUserId?: Maybe<Scalars['ID']['output']>;
  /** Derived blocker code. Null when nothing is blocked. A Photon order state is not a blocker and does not confirm access. */
  blocker?: Maybe<Scalars['String']['output']>;
  /** Ops note. Follow-up tracking does not clear it. */
  blockerNote?: Maybe<Scalars['String']['output']>;
  /** Checklist the next review must use. */
  checklist: PlatformMedicareBridgeChecklist;
  closeReason?: Maybe<Scalars['String']['output']>;
  closedAt?: Maybe<Scalars['DateTime']['output']>;
  eligibilityReview: PlatformMedicareBridgeEligibilityReview;
  /** Newest first. `first` defaults to 50 and is capped at 100. */
  history: Array<PlatformMedicareBridgeCaseEvent>;
  id: Scalars['ID']['output'];
  identification: PlatformMedicareBridgeIdentification;
  identificationSource: PlatformMedicareBridgeEventSource;
  /** The newest provider review, or null when the case has none. Selecting this field requires a provider assertion. The MBI stays on the review. */
  latestReview?: Maybe<PlatformMedicareBridgeReview>;
  /** UNKNOWN until ops records OPS_PHARMACY_CONFIRMATION. A pickup, a first dose, a prescription, and a prior-authorization approval do not change this. */
  medicationAccess: PlatformMedicareBridgeMedicationAccess;
  /** Derived code for the next operational step. Null until follow-up tracking has run. */
  nextAction?: Maybe<Scalars['String']['output']>;
  openedAt: Scalars['DateTime']['output'];
  /**
   * Checklist keys an ELIGIBLE review still has to satisfy. Includes a
   * conditional item once the latest answers make it required. Every
   * always-required key when the case has no review.
   */
  outstandingRequirements: Array<Scalars['String']['output']>;
  /** Derived team that owns the next action. Null until follow-up tracking has run. */
  ownerTeam?: Maybe<Scalars['String']['output']>;
  patientHealthieId: Scalars['ID']['output'];
  /**
   * Prescriptions linked to this case, newest prescribedAt first.
   * A link is not dispensing and does not change medicationAccess.
   */
  prescriptions: Array<PlatformMedicationProgramPrescription>;
  /**
   * Prior authorizations linked to this case, newest submission first.
   * A link is not payer approval and does not change medicationAccess.
   */
  priorAuthorizations: Array<PlatformPriorAuthorization>;
  /** True when a new review can be submitted. False while GrowthBook `medication-program-medicare-bridge-review` is off, so the portal can hide the form. A retry of an already stored idempotency key still returns that review. */
  reviewSubmissionEnabled: Scalars['Boolean']['output'];
  snoozedUntil?: Maybe<Scalars['DateTime']['output']>;
  status: PlatformMedicareBridgeCaseStatus;
  workStateUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
};


/** One Medicare Bridge assessment for a patient and program. */
export type PlatformMedicareBridgeCaseHistoryArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type PlatformMedicareBridgeCaseConnection = {
  __typename?: 'MedicareBridgeCaseConnection';
  edges: Array<PlatformMedicareBridgeCaseEdge>;
  pageInfo: PlatformMedicareBridgeCasePageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PlatformMedicareBridgeCaseEdge = {
  __typename?: 'MedicareBridgeCaseEdge';
  cursor: Scalars['String']['output'];
  node: PlatformMedicareBridgeCase;
};

/** One append-only change to a Medicare Bridge case. Evidence is not exposed. */
export type PlatformMedicareBridgeCaseEvent = {
  __typename?: 'MedicareBridgeCaseEvent';
  actorType: PlatformMedicareBridgeActorType;
  createdAt: Scalars['DateTime']['output'];
  dimension: Scalars['String']['output'];
  fromValue?: Maybe<Scalars['String']['output']>;
  reason: Scalars['String']['output'];
  source: PlatformMedicareBridgeEventSource;
  toValue: Scalars['String']['output'];
};

export type PlatformMedicareBridgeCaseFilter = {
  assignedUserId?: InputMaybe<Scalars['ID']['input']>;
  blocker?: InputMaybe<Scalars['String']['input']>;
  includeSnoozed?: InputMaybe<Scalars['Boolean']['input']>;
  nextAction?: InputMaybe<Scalars['String']['input']>;
  ownerTeam?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<PlatformMedicareBridgeCaseStatus>;
};

export enum PlatformMedicareBridgeCaseLinkKind {
  Prescription = 'PRESCRIPTION',
  PriorAuthorization = 'PRIOR_AUTHORIZATION'
}

export type PlatformMedicareBridgeCasePageInfo = {
  __typename?: 'MedicareBridgeCasePageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
};

export enum PlatformMedicareBridgeCaseStatus {
  Closed = 'CLOSED',
  Open = 'OPEN'
}

/**
 * The checklist the next review must use. Older reviews keep the
 * checklistVersion they were submitted with.
 */
export type PlatformMedicareBridgeChecklist = {
  __typename?: 'MedicareBridgeChecklist';
  /** Ordered handoff shown with the review. Empty when this version has none. */
  handoffSteps: Array<Scalars['String']['output']>;
  items: Array<PlatformMedicareBridgeChecklistItem>;
  nextRoutes: Array<PlatformMedicareBridgeChecklistOption>;
  /** Whether a Part D denial must already exist. False for the CMS Bridge path. */
  partDDenialRequired: Scalars['Boolean']['output'];
  /** Provider-documents slug. Null until Clinical names the signed protocol. */
  protocolDocumentSlug?: Maybe<Scalars['String']['output']>;
  version: Scalars['String']['output'];
};

/** One item on the checklist the next review must use. */
export type PlatformMedicareBridgeChecklistItem = {
  __typename?: 'MedicareBridgeChecklistItem';
  /** Extra instruction for the provider. Null when the label is enough. */
  help?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  kind: PlatformMedicareBridgeChecklistItemKind;
  label: Scalars['String']['output'];
  options: Array<PlatformMedicareBridgeChecklistOption>;
  /** True when an ELIGIBLE review must satisfy this item regardless of other answers. */
  required: Scalars['Boolean']['output'];
  /** Null when the item is always required or not conditional. */
  requiredWhen?: Maybe<PlatformMedicareBridgeChecklistRequirement>;
};

export enum PlatformMedicareBridgeChecklistItemKind {
  Boolean = 'BOOLEAN',
  Choice = 'CHOICE',
  Choices = 'CHOICES',
  Date = 'DATE',
  Evidence = 'EVIDENCE',
  Number = 'NUMBER'
}

export type PlatformMedicareBridgeChecklistOption = {
  __typename?: 'MedicareBridgeChecklistOption';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** Another answer that makes a checklist item required for an ELIGIBLE review. */
export type PlatformMedicareBridgeChecklistRequirement = {
  __typename?: 'MedicareBridgeChecklistRequirement';
  /** Satisfied when the other answer includes any of these values. Empty when the condition is a range. */
  includesAny: Array<Scalars['String']['output']>;
  /** Checklist item key this condition reads. */
  key: Scalars['String']['output'];
  /** Inclusive lower bound on a numeric answer. Null when the condition is not a range. */
  numberGte?: Maybe<Scalars['Float']['output']>;
  /** Exclusive upper bound on a numeric answer. Null when the condition is not a range. */
  numberLt?: Maybe<Scalars['Float']['output']>;
};

export enum PlatformMedicareBridgeCloseOutcome {
  LostToFollowUpAccessUnknown = 'LOST_TO_FOLLOW_UP_ACCESS_UNKNOWN',
  MedicationAccessConfirmed = 'MEDICATION_ACCESS_CONFIRMED',
  NotEligible = 'NOT_ELIGIBLE',
  PatientDeclined = 'PATIENT_DECLINED',
  PaDeniedFinal = 'PA_DENIED_FINAL',
  RoutedToOtherCoverage = 'ROUTED_TO_OTHER_COVERAGE'
}

export enum PlatformMedicareBridgeEligibilityReview {
  Eligible = 'ELIGIBLE',
  NeedsInformation = 'NEEDS_INFORMATION',
  NotEligible = 'NOT_ELIGIBLE',
  NotStarted = 'NOT_STARTED'
}

/** Where a ledger row or the current identification came from. history.source uses every value. */
export enum PlatformMedicareBridgeEventSource {
  DevelopBv = 'DEVELOP_BV',
  DevelopPa = 'DEVELOP_PA',
  Glp1Appointment = 'GLP1_APPOINTMENT',
  ManualCorrection = 'MANUAL_CORRECTION',
  OnboardingBooking = 'ONBOARDING_BOOKING',
  PhotonPrescription = 'PHOTON_PRESCRIPTION',
  ProviderReview = 'PROVIDER_REVIEW',
  Reconciliation = 'RECONCILIATION',
  System = 'SYSTEM'
}

export enum PlatformMedicareBridgeIdentification {
  Indicated = 'INDICATED',
  RuledOut = 'RULED_OUT',
  Suspected = 'SUSPECTED'
}

export enum PlatformMedicareBridgeMedicationAccess {
  Confirmed = 'CONFIRMED',
  NotObtained = 'NOT_OBTAINED',
  Unknown = 'UNKNOWN'
}

/** One append-only provider review. This is not a prior-authorization decision. */
export type PlatformMedicareBridgeReview = {
  __typename?: 'MedicareBridgeReview';
  /** The checklist version this review was submitted against. */
  checklist: PlatformMedicareBridgeChecklist;
  checklistVersion: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  decision: PlatformMedicareBridgeReviewDecision;
  id: Scalars['ID']['output'];
  nextRoute?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  providerHealthieId: Scalars['ID']['output'];
  /** Answers keyed by checklist item. May include an MBI. Not written to the case ledger. */
  responses: Scalars['JSON']['output'];
  unresolvedItems: Array<Scalars['String']['output']>;
};

export enum PlatformMedicareBridgeReviewDecision {
  Eligible = 'ELIGIBLE',
  NeedsInformation = 'NEEDS_INFORMATION',
  NotEligible = 'NOT_ELIGIBLE'
}

/**
 * Booking-time coverage evidence. Medication-program classifies it. A carrier
 * name alone is not evidence. `planActive` is true only when the coverage check
 * confirmed an active plan; Stedi insurance type and response type are indicated
 * only then.
 */
export type PlatformMedicareCoverageEvidenceInput = {
  groupNumber?: InputMaybe<Scalars['String']['input']>;
  insuranceType?: InputMaybe<Scalars['String']['input']>;
  /** Selected payer id, including the CMS Medicare sentinel. */
  payerId?: InputMaybe<Scalars['String']['input']>;
  planActive?: InputMaybe<Scalars['Boolean']['input']>;
  planName?: InputMaybe<Scalars['String']['input']>;
  responseType?: InputMaybe<Scalars['String']['input']>;
};

export type PlatformMedication = {
  __typename?: 'Medication';
  comments?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  directions?: Maybe<Scalars['String']['output']>;
  dosage?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  frequency?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  mirrored?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  startDate?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export enum PlatformMedicationActiveFilter {
  Active = 'ACTIVE',
  All = 'ALL',
  Inactive = 'INACTIVE'
}

/** One pharmacy dispense. A fill shows the drug was handed over, not that it was taken. */
export type PlatformMedicationDispense = {
  __typename?: 'MedicationDispense';
  absentFromSourceAt?: Maybe<Scalars['DateTime']['output']>;
  /** The stored MedicationRequests that authorized this fill. A prescription the source never sent is missing here. */
  authorizingPrescriptions: Array<PlatformClinicalMedication>;
  daysSupplyUnit?: Maybe<Scalars['String']['output']>;
  daysSupplyValue?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  /** Same drug identity rules as ClinicalMedication.name. */
  name: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  quantityUnit?: Maybe<Scalars['String']['output']>;
  quantityValue?: Maybe<Scalars['Float']['output']>;
  rxnormCode?: Maybe<Scalars['String']['output']>;
  source: Scalars['String']['output'];
  sourceResourceId: Scalars['String']['output'];
  /** FHIR status, verbatim (e.g. completed, declined). */
  status?: Maybe<Scalars['String']['output']>;
  /** Why the dispense has its status (e.g. a declined fill), as coded by the source. */
  statusReasons: Array<PlatformClinicalCoding>;
  system: Scalars['String']['output'];
  whenHandedOver?: Maybe<Scalars['DateTime']['output']>;
  whenPrepared?: Maybe<Scalars['DateTime']['output']>;
};

export type PlatformMedicationFiltersInput = {
  active?: InputMaybe<PlatformMedicationActiveFilter>;
  patientId: Scalars['ID']['input'];
};

/** Where an injected dose was administered. */
export enum PlatformMedicationInjectionSite {
  Abdomen = 'ABDOMEN',
  Buttock = 'BUTTOCK',
  /** Anywhere the picker doesn't enumerate — never blocks logging a dose. */
  Other = 'OTHER',
  Thigh = 'THIGH',
  UpperArm = 'UPPER_ARM'
}

export type PlatformMedicationProgramEnrollment = {
  __typename?: 'MedicationProgramEnrollment';
  /** @deprecated Derived from latest occurred GLP-1 appointment in glp1_appointments mirror */
  assignedProviderHealthieId?: Maybe<Scalars['ID']['output']>;
  enrolledAt: Scalars['DateTime']['output'];
  failureCode?: Maybe<Scalars['String']['output']>;
  failureMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastSyncedToPhotonAt?: Maybe<Scalars['DateTime']['output']>;
  /** Federated patient edge — use patient.externalId(system: PHOTON) for Photon embed. */
  patient?: Maybe<PlatformPatient>;
  patientHealthieId: Scalars['ID']['output'];
  /** Canonical patient-registry id; set during ensure-glp1-enrollment provisioning. */
  patientId?: Maybe<Scalars['ID']['output']>;
  programType: PlatformProgramType;
  provisionedAt?: Maybe<Scalars['DateTime']['output']>;
  status: PlatformMedicationProgramEnrollmentStatus;
};

export enum PlatformMedicationProgramEnrollmentStatus {
  Active = 'ACTIVE',
  Failed = 'FAILED',
  Provisioning = 'PROVISIONING'
}

/** Healthie patient demographics (id, names, DOB). */
export type PlatformMedicationProgramPatient = {
  __typename?: 'MedicationProgramPatient';
  dob?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  /** Best available display name: preferred first (legalName ?? firstName) plus lastName; may be last-only when first is missing. */
  fullName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  legalName?: Maybe<Scalars['String']['output']>;
  patientHealthieId: Scalars['ID']['output'];
};

/** Platform-synced prescription row (Healthie + Photon). Used on prescriptionReview.patient and medicationProgramPrescriptionsByPatient. */
export type PlatformMedicationProgramPrescription = {
  __typename?: 'MedicationProgramPrescription';
  daysSupply?: Maybe<Scalars['Int']['output']>;
  drugDisplayName?: Maybe<Scalars['String']['output']>;
  /**
   * Normalized, capitalized drug name + consumption type derived from
   * drugDisplayName (e.g. "Wegovy Auto-injector", "Zepbound KwikPen"). When the
   * drug brand isn't recognized yet, holds the full original display name (so it's
   * reviewable). Null only when drugDisplayName itself is null.
   */
  drugNameClean?: Maybe<Scalars['String']['output']>;
  effectiveAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  /** Patient-reported date the prescription was picked up; null until the patient reports it via recordPrescriptionPickup. */
  pickedUpAt?: Maybe<Scalars['DateTime']['output']>;
  prescribedAt?: Maybe<Scalars['DateTime']['output']>;
  source: Scalars['String']['output'];
  status: PlatformPrescriptionStatus;
};

/** Closed set of administration routes currently resolved by medication tracking. */
export enum PlatformMedicationRoute {
  Oral = 'ORAL',
  Subcutaneous = 'SUBCUTANEOUS'
}

/**
 * One drug as recorded across every source request and statement for it: rows sharing an RxNorm code
 * (or, for text-only rows, a name) collapsed into one, with the dates they span. The span runs from
 * the earliest to the newest dated record; it is not evidence the patient took the drug throughout.
 * Excludes rows the source no longer returns and rows that never describe a course (do-not-perform,
 * draft, cancelled, not-taken, entered-in-error).
 */
export type PlatformMedicationSummary = {
  __typename?: 'MedicationSummary';
  /** Distinct free-text dosage instructions, newest first. */
  doses: Array<Scalars['String']['output']>;
  /** The earliest course start, else authored date, across the rows. */
  firstDate?: Maybe<Scalars['DateTime']['output']>;
  /** The newest course end, else course start, else authored date, across the rows. */
  lastDate?: Maybe<Scalars['DateTime']['output']>;
  /** The newest row's FHIR status, verbatim. Null when it omitted one. */
  latestStatus?: Maybe<Scalars['String']['output']>;
  /** The newest row's name. */
  name: Scalars['String']['output'];
  /** True when any row is a MedicationRequest, false when every row is a statement. */
  prescribed: Scalars['Boolean']['output'];
  /** How many source rows record it. */
  recordCount: Scalars['Int']['output'];
  rxnormCode?: Maybe<Scalars['String']['output']>;
  /** rxnorm or text. */
  system: Scalars['String']['output'];
};

/**
 * One logged dose.
 *
 * `doseDate` and `doseTime` are what the patient entered and the whole record of
 * when the dose was taken. There is no absolute instant: dose timing is the
 * patient's wall clock throughout, and no timezone is recorded to resolve one
 * against.
 */
export type PlatformMedicationTakeLog = {
  __typename?: 'MedicationTakeLog';
  createdAt: Scalars['DateTime']['output'];
  /** Amount taken, in the medication's `unit`. Null when the patient didn't state one. */
  doseAmount?: Maybe<Scalars['Float']['output']>;
  /** Calendar day the patient entered, `YYYY-MM-DD`. */
  doseDate: Scalars['String']['output'];
  /** Wall-clock time the patient entered, `HH:mm` on a 24-hour clock. */
  doseTime: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Injection site, for injectables. Null for oral doses or when unspecified. */
  injectionSite?: Maybe<PlatformMedicationInjectionSite>;
  /** The medication this dose was taken for. */
  medicationId: Scalars['ID']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  /** Identifier of the pen or vial used for this dose. Null when not recorded. */
  penOrVialId?: Maybe<Scalars['String']['output']>;
};

/**
 * A logged dose plus the identity of its medication — the calendar feed's row
 * shape, where doses from several medications are rendered together and each needs
 * a label. See `Query.medicationTakeLogs`.
 */
export type PlatformMedicationTakeLogEntry = {
  __typename?: 'MedicationTakeLogEntry';
  log: PlatformMedicationTakeLog;
  /** The medication's `displayName`, falling back to `name`. */
  medicationLabel: Scalars['String']['output'];
  /** The medication's dose unit (e.g. "mg"). Null when unreported. */
  unit?: Maybe<Scalars['String']['output']>;
};

/** Input for merging one provider record into another. */
export type PlatformMergeProvidersInput = {
  /** Provider to merge into the survivor and tombstone (status becomes MERGED). */
  loserId: Scalars['ID']['input'];
  /**
   * Optional ProviderExternalId row IDs to retain as primary, at most one per system.
   * Each must be ACTIVE and belong to one of these two providers. AIRTABLE cannot be
   * selected: its survivor primary is preserved. Other active IDs in selected systems
   * are superseded atomically. Omit to preserve the existing survivor-first behavior.
   */
  primaryExternalIdIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Why the merge is being performed. Recorded as the resolution note on every moved record and referenced from the tombstone. */
  reason: Scalars['String']['input'];
  /** Canonical provider to keep. MUST own the active, primary AIRTABLE external ID — the provider-matching reverse-ETL keys on the Airtable-origin canonical, so the survivor must be that record. */
  survivorId: Scalars['ID']['input'];
};

/** Opted-in assignment is not confirmed; no initial appointment was created. */
export type PlatformMntCareTeamNotReady = {
  __typename?: 'MntCareTeamNotReady';
  outcome: PlatformMntCareTeamNotReadyOutcome;
  /** Diagnostic reason for REQUIRES_REVIEW; never display directly to patients. */
  reason?: Maybe<Scalars['String']['output']>;
};

export enum PlatformMntCareTeamNotReadyOutcome {
  Pending = 'PENDING',
  RequiresReview = 'REQUIRES_REVIEW'
}

/** Successfully booked MNT appointments displayed after confirmation. */
export type PlatformMntCombinedResultsAppointments = {
  __typename?: 'MntCombinedResultsAppointments';
  /** Successfully booked recurring follow-ups in visit order. Failed attempts are omitted. */
  followUps: Array<PlatformCombinedResultsAppointment>;
  /** The successfully booked initial MNT appointment. */
  initial: PlatformCombinedResultsAppointment;
};

export enum PlatformMntCoverage {
  CashPay = 'CASH_PAY',
  Insured = 'INSURED'
}

export type PlatformMntFollowUpBooked = {
  __typename?: 'MntFollowUpBooked';
  appointmentHealthieId: Scalars['ID']['output'];
  appointmentTime: Scalars['DateTime']['output'];
};

export type PlatformMntFollowUpFailure = {
  __typename?: 'MntFollowUpFailure';
  /** Human-readable reason, safe for logs; not patient-facing copy. */
  reason: Scalars['String']['output'];
  /** The weekly target instant that could not be booked. */
  targetTime: Scalars['DateTime']['output'];
};

export type PlatformMntInitialVisitBooked = {
  __typename?: 'MntInitialVisitBooked';
  /** Healthie appointment id — the only durable handle on the appointment; appointments have no canonical id (scheduling persists no booking table). */
  appointmentHealthieId: Scalars['ID']['output'];
  appointmentTime: Scalars['DateTime']['output'];
  /** Follow-ups that could not be created, with the weekly target that failed. The initial visit and sibling follow-ups are unaffected. */
  followUpFailures: Array<PlatformMntFollowUpFailure>;
  /**
   * Follow-ups actually created, in visit order. Empty when
   * `bookRecurringFollowUps` was false or every follow-up failed. Times may
   * deviate from the weekly cadence: each follow-up is placed at the nearest
   * bookable slot within a small window around its weekly target (CBF's
   * dynamic recurring timing), falling back to the exact weekly instant.
   */
  followUps: Array<PlatformMntFollowUpBooked>;
};

/**
 * The initial slot was taken before booking completed (Healthie
 * `enforce_availability` rejection). No follow-ups are attempted. The caller
 * should refresh availability and have the patient repick only this appointment.
 * Mirrors medication-program's `SlotUnavailableError`; named per-domain because
 * result types are domain-owned, not shared across subgraphs.
 */
export type PlatformMntSlotUnavailableError = {
  __typename?: 'MntSlotUnavailableError';
  /** The slot that was no longer bookable. */
  appointmentTime: Scalars['DateTime']['output'];
  /** Human-readable summary, safe to surface to the patient. */
  message: Scalars['String']['output'];
};

/** The guardian named on an MNT visit booked for a patient under 18. */
export type PlatformMntVisitGuardianInput = {
  /** The guardian's email, which is also the account's email. */
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
};

/** A multi-select input with a fixed set of options. */
export type PlatformMultiSelectField = {
  __typename?: 'MultiSelectField';
  /** Optional helper text shown beneath the field. */
  helperText?: Maybe<Scalars['String']['output']>;
  /** Field id; the key to submit the array of selected option values under. */
  id: Scalars['String']['output'];
  /** Label shown to the patient. */
  label: Scalars['String']['output'];
  /** Selectable options; submit an array of chosen option `value`s. */
  options: Array<PlatformStepFieldOption>;
  /** Optional layout/instruction treatment. Null renders the default single-column layout with the standard "Choose all that apply" instruction. */
  presentation?: Maybe<PlatformMultiSelectFieldPresentation>;
  /** Whether the patient must answer before advancing. */
  required: Scalars['Boolean']['output'];
};

/** Optional visual presentation for a multi-select field. */
export type PlatformMultiSelectFieldPresentation = {
  __typename?: 'MultiSelectFieldPresentation';
  /** When true, the client suppresses its default "Choose all that apply" instruction text. */
  hideDefaultInstruction: Scalars['Boolean']['output'];
  /** How the client must lay out the option grid. */
  layout: PlatformMultiSelectLayout;
};

/** Supported option-grid layouts for a multi-select field. */
export enum PlatformMultiSelectLayout {
  ResponsiveTwoColumn = 'RESPONSIVE_TWO_COLUMN',
  SingleColumn = 'SINGLE_COLUMN'
}

export type PlatformMutation = {
  __typename?: 'Mutation';
  /** Add a Stripe payment card for a patient. */
  addHealthieStripeCard: PlatformAddHealthieStripeCardResponse;
  /**
   * Add an additional (non-primary) provider to a patient's Healthie care team
   * (`other_provider_ids`) — for a provider who should be able to see/manage the
   * patient's chart without displacing the existing primary provider (Healthie's
   * `dietitian_id`). Reads the patient's current provider set, unions in the
   * requested provider, and writes the result back under the registry's patient
   * lock. Active or unverified recovery blocks this write; unavailable recovery
   * status fails closed. A verified rollback permits subsequent assignments.
   * Direct external Healthie writes are not serialized.
   *
   * Idempotent: a no-op when the provider is already primary or already an
   * additional provider.
   *
   * The returned `Patient` carries `healthieCareTeamProviderIds`: the care-team
   * ids Healthie reported for this write. Select it if the outcome of this
   * mutation gates durable state — it is the only way for a caller to reach a
   * correct conclusion without trusting the deployed API's own interpretation.
   */
  addPatientAdditionalProvider: PlatformPatient;
  /** Apply one or more tags to a patient. */
  applyHealthieTags: PlatformApplyHealthieTagsResponse;
  /**
   * NP approval of the latest DRAFT care plan — freezes that version as the
   * approved record (later material input changes produce a new draft).
   *
   * Errors when the plan is flagged `requiresAttention`, or when it carries an
   * unresolved advisory (see `AccessCarePlan.advisories`); the error names the
   * block reason and the upstream correction that clears it.
   */
  approveAccessCarePlan: PlatformAccessCarePlan;
  /** Assign (or unassign) the reviewing NP for an enrollment. Ops/admin seam. */
  assignAccessNp: PlatformAssignAccessNpPayload;
  /** Same contract as `assignPrescriber`, for the dietitian. */
  assignDietitian: PlatformAssignDietitianPayload;
  /**
   * Assigns an open Medicare Bridge case to an ops user.
   * Requires GrowthBook `medication-program-medicare-bridge-follow-up`.
   * A blank reason, a closed case, and an unknown case are rejected.
   * A retry of idempotencyKey writes nothing further.
   * A concurrent update fails after one retry.
   */
  assignMedicareBridgeCase: PlatformAssignMedicareBridgeCasePayload;
  /**
   * Make this provider the patient's prescriber, replacing the current one; the
   * dietitian assignment is unaffected. Returns only after an independent
   * Healthie read confirms the chart. Assigning the current prescriber is a
   * confirmed no-op. No appointment is created. On failure nothing is recorded,
   * any partial Healthie change has been restored (a chart that can't be is
   * logged for support), and the error's `extensions.code` names the reason,
   * e.g. ASSIGNMENT_IN_PROGRESS while another assignment for the patient runs.
   * Safe to retry with the same input. Exposed only to trusted services.
   */
  assignPrescriber: PlatformAssignPrescriberPayload;
  /**
   * Attaches insurance-card photos to the patient's existing Healthie policy.
   * Healthie is the source of record for card images — there is no
   * registry-side copy.
   *
   * Reads the patient's policies from Healthie and patches the primary policy
   * by id via `updateClient`, sending only the card-image fields — the
   * policy's plan, member, group, and holder data are never resent or
   * altered, and a policy entry is never written without an id (which would
   * create a second policy instead of patching).
   *
   * A missing Healthie identity or a chart with no policy is reported in-band
   * as `attached: false` with a `skippedReason` — terminal business outcomes a
   * retry cannot fix (the upstream policy write is best-effort and may have
   * legitimately skipped), so callers advance past them. A Healthie-side
   * failure surfaces as a mutation error rather than a silent success, so the
   * client can retry without losing patient-captured photos. Re-submitting
   * replaces the previously uploaded image for each supplied side; Healthie
   * retains only the latest card per side, so an exact retry is idempotent.
   *
   * Exposed only to trusted program domains.
   */
  attachInsuranceCardImages: PlatformAttachInsuranceCardImagesPayload;
  /**
   * Best-effort attach of an insurance policy to a patient's Healthie chart
   * (`updateClient`'s `policies` array). Never throws: a missing Healthie
   * identity, an already-on-file policy, an unconfirmed Healthie write, or a
   * Healthie-side error all surface as an in-band `skippedReason` instead —
   * callers should not block a booking or patient-creation flow on this.
   *
   * Idempotent: an exact re-attach (same Healthie insurance-plan id and member
   * id) is a no-op; it never duplicates a policy.
   */
  attachInsurancePolicy: PlatformAttachInsurancePolicyPayload;
  /**
   * Attest that the signed-in provider has read the given version. Identity is
   * the verified provider assertion, never input. Idempotent: a duplicate attest
   * returns the original record unchanged. A superseded version returns
   * DocumentVersionSupersededError rather than a top-level error.
   */
  attestDocumentVersion: PlatformAttestDocumentVersionResult;
  /**
   * One-off PG-594 backfill. Back-office only, guarded by the global API-key
   * guard. Sends the E.164 phone and an SMS opt-in of true to Customer.io for
   * each welcome lead whose latest phone step opted in and who never saved a
   * booking confirm. Dry run unless `apply` is true. Safe to re-run: it re-sends
   * the same values. Sends are fire-and-forget; one lead's failure never stops
   * the run.
   */
  backfillMarketingSmsOptIns: PlatformBackfillMarketingSmsOptInsPayload;
  /**
   * Ops backfill for `drugNameClean`: re-derives it from each row's existing
   * `drugDisplayName` for the given local prescription ids and writes the result.
   * Pure DB transform — no Healthie/Photon calls (drugNameClean is fully
   * determined by drugDisplayName, which is already persisted). Ids that don't
   * exist are silently skipped. Returns the updated prescriptions. Idempotent —
   * re-running yields the same values.
   */
  backfillPrescriptionDrugNameClean: Array<PlatformMedicationProgramPrescription>;
  /**
   * Starts a sequential backfill of patient-tracked medications from already
   * synced Healthie and Photon prescriptions. `externalIds` are source-system
   * prescription ids; when the same id exists in both sources, both rows are
   * considered. Only ACTIVE or legacy DEPLETED prescriptions are eligible
   * (current Photon DEPLETED syncs are normalized to ACTIVE). Existing tracked
   * medications are left untouched and one failed prescription does not stop the
   * remainder.
   */
  backfillTrackedMedications: PlatformTriggerBackfillWorkflowResult;
  /**
   * Places one appointment in Healthie under `enforce_availability`. Internal:
   * exposed only to program domains (M2M), never to public clients.
   *
   * One call books one appointment. A recurring series is several calls: cadence,
   * ordering, and partial-failure reporting belong to the program domain that
   * owns the series, because this domain holds no state linking appointments to
   * each other and Healthie's native recurring-appointment series is deliberately
   * not used.
   *
   * Writes no provider assignment. Healthie requires the provider to already have
   * access to the patient's chart before `createAppointment`, and the calling
   * program domain has established that when it took the patient on — this
   * mutation neither adds a care-team member nor changes the primary provider.
   *
   * Holds are not consulted: a caller's own hold neither grants nor blocks a
   * booking, an expired hold is not an error, and Healthie remains the final
   * authority. A successful booking does not release the session's hold — the
   * slot is genuinely gone, and the hold lapses on its own TTL.
   *
   * Not idempotent: a repeated call books a second appointment. Callers that need
   * retry-safety own their own dedupe key and repair.
   *
   * Healthie and infrastructure failures raise top-level errors rather than
   * appearing in the result union. Provider slot rejection
   * (`AppointmentSlotUnavailableError`) and a conflict with the patient's own
   * schedule (`AppointmentPatientScheduleConflictError`) are the modelled outcomes.
   */
  bookAppointment: PlatformBookAppointmentResult;
  /**
   * Book a GLP-1 consult after the onboarding screening reaches an `eligible`
   * verdict. Orchestrates the cross-system writes atomically from the platform
   * side: updates Healthie demographics, books the appointment, reactivates an
   * inactive patient without sending a welcome email, submits the screening
   * form-answer-group (ICD-10 diagnoses + subjective intake note are derived
   * here), persists the Glp1IntakeRecord, and triggers the Develop benefits-
   * verification workflow. The Healthie writes are sequential and re-thrown on
   * failure — if any step before the platform writes fails, no IntakeRecord or
   * BenefitsCheck row is created.
   *
   * Returns a union: `Glp1Booked` on success, `SlotUnavailableError` when the
   * slot was taken before booking completed, or `Glp1ConsultNotBookableError`
   * when the patient already holds an upcoming consult or completed one in the
   * last 30 days — all recoverable, user-actionable conditions.
   * Transient/system failures still surface as top-level errors.
   * Idempotent on `input.idempotencyKey` — a retry of an already-booked key
   * returns the original booking without creating a duplicate, and is never
   * blocked by the appointment that retry created itself.
   * `replayOnly` refuses a key with no intake row before any new-booking write,
   * including when the consult-history read fails.
   */
  bookGlp1Appointment: PlatformBookGlp1AppointmentResult;
  /**
   * Book a GLP-1 follow-up visit for an already-enrolled patient. Resolves the
   * canonical patient/provider ids to Healthie and books through scheduling's
   * program-neutral `bookAppointment` path with Healthie availability
   * enforcement. Unlike `bookGlp1Appointment` it writes no screening form,
   * intake record, or benefits-verification — a follow-up has no screening.
   * Rejects with `Glp1NotPrescribedError` when the
   * patient has no occurred GLP-1 appointment on record (the eligibility gate,
   * enforced here since the booking call is the trust boundary; an active
   * prescription is not required; fail-closed on lookup error). The union member
   * name is retained for backward-compatibility. Returns `Glp1Booked`, or
   * `SlotUnavailableError` if the slot was taken before booking completed.
   */
  bookGlp1FollowUpAppointment: PlatformBookGlp1AppointmentResult;
  /**
   * The complete MNT initial-booking boundary: books the initial visit (and,
   * when requested, its recurring follow-up series) in Healthie. M2M only —
   * called by onboarding at shared confirmation, never a public client.
   *
   * Before booking, assigns primary-provider status to the selected dietitian,
   * because an MNT patient's dietitian is their care owner. Assignment failure
   * prevents booking. reconcileCareTeam explicitly enables preserving the
   * cross-program team with independent readback. PENDING or REQUIRES_REVIEW
   * returns MntCareTeamNotReady before scheduling, without falling back to
   * legacy assignment. Retry confirmation after PENDING; no automatic booking
   * retry occurs. A stored booking is returned/repaired without historical
   * reassign for opted-in calls; callers omitting the opt-in retain legacy behavior.
   */
  bookMntInitialVisit: PlatformBookMntInitialVisitResult;
  /**
   * Requests cancellation of a running import generation.
   *
   * Cancel rather than terminate, so the workflow still writes the manifest
   * recording where it stopped. Exists because the alternative is the Temporal
   * CLI: a failing run costs a page of re-uploaded attachments and a worker
   * task per attempt, and the runs worth stopping tend to be the out-of-hours
   * ones.
   */
  cancelChatHistoryImport: PlatformCancelChatHistoryImportResult;
  /** Cancel an appointment. */
  cancelHealthieAppointment: PlatformCancelHealthieAppointmentResponse;
  /**
   * Terminate a running patient → Navi Health backfill. Records the
   * supplied `reason` on the workflow's terminate event (Temporal UI +
   * history). Returns `terminated: false` when no running execution is
   * found — safe to call idempotently.
   */
  cancelPatientNavihealthBackfill: PlatformCancelPatientNavihealthBackfillResult;
  /**
   * Terminate the in-flight email-origin backfill for the given stage.
   * Idempotent when no run is active.
   */
  cancelProviderEmailOriginBackfill: PlatformCancelProviderEmailOriginBackfillResult;
  cancelProviderNavihealthBackfill: PlatformCancelProviderNavihealthBackfillResult;
  /**
   * Internal service operation. Sets the selected visit to "Cancelled", "Re-Scheduled",
   * or "No-Show". For a non-GLP-1 initial visit, "No-Show" also cancels scheduled
   * non-GLP-1 visits for the same patient/provider strictly after both that visit
   * and now. "Cancelled" does so only when triggeringUserHealthieId identifies the
   * appointment's patient; provider/staff cancellations and cancellations without
   * an actor id change only the selected visit. "Re-Scheduled" never cascades.
   *
   * Already-matching statuses are not written again; retrying re-reads Healthie
   * and resumes outstanding cancellations. This is not atomic: system failures
   * raise errors with confirmed progress in extensions. No rollback is attempted.
   * Repeated calls may include appointments booked since the previous call.
   * Actor token creation failure is logged and falls back to the admin account
   * for all writes without changing cascade eligibility; actor validation and
   * appointment write failures do not fall back.
   * Temporary actor token revocation is attempted in finally, including after
   * a write fails; cleanup failures are reported as system errors.
   * "Re-Scheduled" records an outcome; it does not book a replacement visit.
   */
  changeAppointmentStatus: PlatformChangeAppointmentStatusPayload;
  /**
   * Charge an approved no-show or late-change fee to the patient's saved card.
   * The first attempt charges the card paymentProfile returns; later attempts of
   * the same fee use the same account as the first attempt. Payments numbers
   * the attempts. Idempotent per `idempotencyKey`, and a repeat never charges
   * twice: it returns a collected fee unchanged, settles a PENDING one, and
   * starts a new attempt only when the latest attempt FAILED. Concurrent repeats
   * start at most one attempt. PENDING means the outcome is not known yet; call
   * again with the same input. A declined card, a card that needs the patient to
   * authenticate or a patient with no card is a FAILED charge in
   * AppointmentFeeCharged, not an error. FeeChargeRejectedError: nothing was
   * stored or charged.
   */
  chargeAppointmentFee: PlatformChargeAppointmentFeePayload;
  /**
   * Clears a not-prescribed decision for this patient's GLP-1 enrollment.
   * Appends a prescription_decisions row with decision "cleared" so stage
   * derivation falls through to prescribed / PA / needs_decision. Requires the
   * latest decision to be not_prescribed.
   *
   * The acting provider is inferred from the request auth context, never from the
   * input. Missing or invalid provider auth is rejected.
   */
  clearGlp1NotPrescribedDecision: PlatformPrescriptionReviewDecision;
  /** Close an OPEN request owned by the acting clinician (RESOLVED / CANCELLED). Wrong owner / closed / unknown id is not-found. */
  closeDocumentRequest: PlatformDocumentRequest;
  /**
   * Closes an open Medicare Bridge case with an explicit outcome.
   * Requires GrowthBook `medication-program-medicare-bridge-follow-up`.
   * MEDICATION_ACCESS_CONFIRMED is rejected unless medicationAccess is
   * already CONFIRMED. A completed prescription task does not close the
   * case. Closing clears ownerTeam, nextAction, and blocker.
   * A blank reason, a closed case, and an unknown case are rejected.
   * A retry of idempotencyKey returns the closed case and writes nothing
   * further. A concurrent update fails after one retry.
   */
  closeMedicareBridgeCase: PlatformCloseMedicareBridgeCasePayload;
  /** Mark an agenda item as complete for a patient */
  completeAgendaItem: PlatformPatientAgendaHistory;
  /** Mark a booking session as completed (idempotent) */
  completeBookingSession: PlatformBookingSession;
  /**
   * Verify a started card setup with the processor and, on success, make the
   * card the patient's default for later fee charges. The only path that saves
   * a card to a patient: neither the form's confirmation nor any webhook does.
   * Retry-safe: completing a completed setup returns the same card.
   */
  completeCardSetup: PlatformCompleteCardSetupPayload;
  /**
   * Closes an open prescription task (NEW or PENDING) as SKIPPED or PRESCRIBED.
   * When outcome is SKIPPED and the GrowthBook flag
   * `medication-program-glp1-skip-records-not-prescribed` is on, records an
   * enrollment-level not-prescribed decision (same decision row as
   * recordGlp1NotPrescribedDecision, without that mutation's task close) using
   * skipReason before completing the task, but only when this appointment is
   * the patient's latest occurred GLP-1 visit. This mutation then completes the
   * task with that skipReason. Earlier leftover tasks still skip; they do not
   * write the enrollment decision. Missing or non-ACTIVE enrollment is treated
   * the same way: skip closes the task and withholds the decision (retry cannot
   * create an enrollment). A transient decision write failure fails the
   * mutation; the task stays open so retry can repair it. Flag off (default):
   * skip closes the task only.
   * Auth: the acting provider is inferred from the request auth context, never
   * from the input, and must match appointment.providerHealthieId.
   */
  completeGlp1PrescriptionTask: PlatformGlp1PrescriptionTask;
  /** Book an appointment via the unauthenticated client checkout flow. */
  completeHealthieCheckout: PlatformCompleteHealthieCheckoutResponse;
  /**
   * Records that an uploaded import is in GetStream, after the uploads.
   *
   * Runs separately from `triggerChatHistoryImport` because a human uploads the
   * files with `stream-cli` in between, and Stream exposes no server-side import
   * API, so nothing here can observe the messages existing until then.
   *
   * Each file is verified against GetStream before any row is written for it. A
   * row for a message that never landed would make the live sync skip that note
   * permanently, whereas a missing row only causes a duplicate, which is visible
   * and fixable. Safe to re-run: `healthieNoteId` is unique and the inserts skip
   * duplicates, so files already confirmed write nothing.
   */
  confirmChatHistoryImport: PlatformConfirmChatHistoryImportResult;
  /**
   * Confirm that a document has been uploaded to S3, and file it into the patient's record when
   * fileToPatientRecord is true. A retry after a confirm is not-found, as before.
   *
   * Errors from filing: BAD_USER_INPUT when the record rejected the file; UPSTREAM_UNAVAILABLE on 429,
   * 5xx or a network failure.
   */
  confirmDocumentUpload: PlatformDocument;
  correctAccessReferralEvidence: PlatformAccessFailedAlignmentCorrectionContext;
  /**
   * Corrects identification on an open Medicare Bridge case. The acting
   * provider comes from the verified provider assertion, never from input.
   *
   * Requires a non-empty reason. `RULED_OUT` also closes the case with
   * closeReason `identification_ruled_out` and writes an identification event
   * and a status event.
   *
   * Idempotent on `idempotencyKey`: a retry returns the case and writes
   * nothing further. A supplied key is stored even when identification does
   * not change, so a later retry cannot apply that key as a new change.
   * Omitting the key treats each call as a new correction, and an unkeyed call
   * that does not change the case writes nothing.
   *
   * Rejects a blank reason, a missing or unauthenticated caller, a closed
   * case, and an unknown case id. A concurrent update fails after one retry.
   */
  correctMedicareBridgeIdentification: PlatformCorrectMedicareBridgeIdentificationPayload;
  /** Create a new booking session with optional pre-populated data */
  createBookingSession: PlatformBookingSession;
  /**
   * A Stripe SetupIntent for the credit-card step's Express Checkout Element,
   * for a flow (welcome-v2) that has no patient bound by the time this step
   * renders: creates the patient here, from demographics submitted so far,
   * registry-first through the same identity/ownership rules the booking
   * commit uses — then mints against it. Nothing is charged. Null when
   * creation or minting can't proceed (e.g. an unproven email claim), in which
   * case the card step renders the manual form alone; the booking commit's own
   * patient resolution is the backstop.
   */
  createCardSetupIntent?: Maybe<PlatformCardSetupIntent>;
  /** Link a Healthie recurring appointment series to a cohort */
  createCohortSeries: PlatformCohortSeries;
  /** Open a request for the acting clinician (x-bst-provider-assertion). Sets requestedByProviderId from that identity. CX/system (null requester) is not exposed here. */
  createDocumentRequest: PlatformDocumentRequest;
  /**
   * Creates the SOAP draft for one appointment in the patient's EHR record (Healthie) and stores
   * nothing here. The acting provider comes from the x-bst-provider-assertion header, never from
   * the input; the caller owns the check that the appointment belongs to the acting provider's
   * session. Returns the existing draft for this patient and appointment when there is one
   * (authoredBy null, nothing written). A create can time out after the EHR applied it, and a retry
   * is safe because the existing draft is looked up first; two calls at the same moment can still
   * create two drafts. A blank patient or appointment id, an appointment with no EHR date and an
   * appointment that is neither the patient's nor a group appointment the patient attends are
   * BAD_USER_INPUT. An EHR failure, the 40 second work limit and a missing organization-key
   * configuration are INTERNAL_SERVER_ERROR.
   */
  createEhrChartingNoteDraft: PlatformCreateEhrChartingNoteDraftPayload;
  /**
   * Writes one finished response on a GLP-1 form to the patient's EHR record (Healthie) and stores
   * nothing here. Allows 45 seconds, where reads allow 20. Not idempotent and never retried: a
   * timeout may still have landed, and a retry, or a call that landed after the caller timed out,
   * writes a second response. An EHR rejection returns a null chartingNoteId with its
   * messages and does not fail the call; an EHR transport or GraphQL failure fails it with
   * INTERNAL_SERVER_ERROR. A blank patient id is BAD_USER_INPUT.
   */
  createEhrFormResponse: PlatformCreateEhrFormResponsePayload;
  /**
   * Writes a Weight metric entry to the patient's EHR record (Healthie) and stores nothing here.
   * Not idempotent: a retry writes a second entry. An EHR rejection returns a null entryId with
   * its messages; an EHR transport or GraphQL failure fails the call.
   */
  createEhrWeightEntry: PlatformCreateEhrWeightEntryPayload;
  /** Create a health metric entry (weight, sleep, heart rate, etc.) in Healthie — machine-to-machine. For a day's steps total, use upsertDailyTotal, which keeps one entry per day and source. Not idempotent while Healthie is the store: a retry creates a second entry, with or without `externalId`. A Steps or Sleep Duration category whose type is served from NaviHealth is written there as the day's total instead (steps per `thirdPartySource`, sleep per `externalId`), last write wins, and the returned id is an `nh-` id. A steps total is dated by the device's local date: `createdAt` is taken as the device's local midnight (device sync's `recordedAt`), the date whose midnight it is at a UTC offset from -12:00 to +14:00, nearest the patient's offset when two qualify; an instant that is no quarter hour is dated in the patient's timezone. Errors: `BAD_USER_INPUT` when only one of `externalIdType` and `externalId` is set, or when `externalId` is empty, all whitespace or over 255 characters. When the patient registry lookup that picks the store fails, the write goes to Healthie. While the entry's type is served from NaviHealth: `NAVIHEALTH_UNAVAILABLE` when NaviHealth is unreachable, times out or answers 5xx (the write may still have landed); `NAVIHEALTH_REQUEST_FAILED` when NaviHealth refuses it; `NOT_FOUND` when NaviHealth doesn't know the patient; `CONFLICT` when NaviHealth reports a conflicting write. There is no fallback to Healthie. */
  createHealthMetricEntry: PlatformCreateHealthMetricEntryPayload;
  /** Book an appointment (provider-side, authenticated). */
  createHealthieAppointment: PlatformCreateHealthieAppointmentResponse;
  /** Create a new patient in Healthie. */
  createHealthiePatient: PlatformCreateHealthiePatientResponse;
  /** Create a journal entry of any writable type (food, symptom, weight, activity, water, stool). It doesn't write steps or sleep, so JournalEntryType has no value for them; steps and sleep totals go through upsertDailyTotal. The patient is the entry's poster. Written to the store the type is served from: Healthie, or NaviHealth while the type's store flag is on for the patient, which returns an `nh-` id. Without `externalIdType` and `externalId`, or while the entry's type is stored in Healthie, not idempotent: a retry creates a second entry. With them, a create stored in NaviHealth is first-write-wins: a repeat returns the existing entry. Errors: `BAD_USER_INPUT` when neither id is set, or when `patientRegistryId` is empty or has no Healthie user id in the patient registry, when `image.data` is over the limit, when only one of `externalIdType` and `externalId` is set, or when `externalId` is empty, all whitespace or over 255 characters, or when a caller that isn't trusted sets `createdByKind`. `INTERNAL_SERVER_ERROR` when the patient registry lookup of `patientRegistryId` fails; when the lookup of a Healthie user id's patient registry id fails, the write goes to Healthie. While the entry's type is served from NaviHealth: `NAVIHEALTH_UNAVAILABLE` when NaviHealth is unreachable, times out or answers 5xx (the write may still have landed); `NAVIHEALTH_REQUEST_FAILED` when NaviHealth refuses it; `NOT_FOUND` when NaviHealth doesn't know the patient; `CONFLICT` when NaviHealth reports a conflicting write. There is no fallback to Healthie. */
  createJournalEntry: PlatformJournalEntry;
  /** Create a comment on any journal entry. While `journal-comments-navihealth` is on for the commenting patient (`input.patientRegistryId`, else `userId`'s patient registry id, looked up), writes to NaviHealth; a patient NaviHealth has not linked yet fails with `INTERNAL_SERVER_ERROR`. A `userId` with no patient registry record, or whose lookup fails, writes to Healthie when `input.patientRegistryId` isn't set. Errors: `BAD_USER_INPUT` when `input.patientRegistryId` is empty or isn't `userId`'s patient registry id; `INTERNAL_SERVER_ERROR` when `input.patientRegistryId` is set and the lookup of `userId`'s patient registry id fails. */
  createJournalEntryComment: PlatformEntryComment;
  createMedication: PlatformMedication;
  /**
   * Mint a one-shot, expiring entry link that drops a caller into a flow with
   * PatientFacts already attached. Back-office only — currently guarded by the
   * global API-key guard (no per-caller identity); per-caller M2M scoping is
   * tracked in GLPX-86. Returns the link's start URL; the caller delivers it to
   * the user (email, push, deep link).
   */
  createOnboardingEntryLink: PlatformOnboardingEntryLink;
  /**
   * Create a brand-new patient identity and provision the patient in Healthie.
   *
   * Unlike `registerPatient` (which links an *existing* Healthie account), this
   * mutation is the entry point for patients who don't have a Healthie account
   * yet. It reserves the patient's email in the registry first — the registry's
   * globally-unique email constraint is the only email-uniqueness guard in the
   * system, since Healthie itself allows duplicate emails across clients — and
   * only then creates the Healthie client, so a retry after a partial failure
   * can never mint two Healthie clients for the same email.
   *
   * Idempotent on email when `adoptProvisionedIdentity` is omitted or true: if
   * the email is already registered and linked to an active Healthie external
   * id, returns the existing patient unchanged with no Healthie call. Set
   * `adoptProvisionedIdentity` to false to reject the patient when any external
   * id is already attached, including one that is not a Healthie id. If the
   * email is registered but not yet linked to any external id (a prior call
   * failed between creating the identity and provisioning Healthie), this call
   * resumes and completes provisioning for that same patient.
   *
   * With `booking`, a patient with no Healthie id is linked to the client that
   * already uses the email (exact match) or, when there is none, gets a new
   * client with the group, record identifier and metadata. A linked client that
   * is inactive or has another primary provider is reactivated and reassigned
   * after the link is saved; when that step fails the link stays, and a retry
   * repeats only that step. A concurrent call for the same email waits for the
   * first one. Group choice never refuses a booking; a group that cannot be
   * found falls back to the main organization's group. A timeout or error on any
   * read made before the lock (provider, email search, groups, client) fails the
   * call with no `extensions.code`, so a caller's REGISTRY_REFUSED fallback does
   * not run. When the email has no registry owner yet, the email search and the
   * check that no other identity owns the found client run before any registry
   * row is written.
   *
   * Errors in booking mode (`extensions.code`):
   * - REGISTRY_REFUSED: the email is disputed (flagged as not this patient's),
   *   the matching Healthie client is linked to another identity, or the patient
   *   has Healthie ids in conflict with none primary. The registry cannot take
   *   this patient in booking mode.
   * - CARE_TEAM_RECOVERY_IN_PROGRESS: the linked client needs a new primary
   *   provider, but a care-team recovery for the patient has not finished.
   *   Retry later; the link is saved.
   */
  createPatient: PlatformPatient;
  /**
   * Puts a file in a patient's record and returns its record document id, the id
   * patientDocumentFile takes. Exposed only to first-party backends (platform API key).
   *
   * Errors: BAD_USER_INPUT with extensions.reason OTHER for a blank healthieUserId, refused before any
   * call; BAD_USER_INPUT with no reason when the record rejected the file (do not retry);
   * UPSTREAM_UNAVAILABLE on 429, 5xx or a network failure, which may succeed on retry. A lost response
   * after a successful create can still leave a second file on retry.
   */
  createPatientDocument: Scalars['ID']['output'];
  /** Create a note for a patient. authorId is inferred from the request context, not the input. */
  createPatientNote: PlatformPatientNote;
  /**
   * Creates a referring physician in Healthie, linking it to input.referral's patient in
   * the same call when given. Healthie may match an existing physician and return it as
   * duplicatedPhysician instead. Healthie rejections come back as messages, not errors.
   * Not idempotent: Healthie decides what counts as a duplicate.
   *
   * Errors: BAD_USER_INPUT for a blank referral patient externalId; UPSTREAM_UNAVAILABLE
   * when Healthie fails or errors.
   */
  createReferringPhysician: PlatformCreateReferringPhysicianPayload;
  /** Creates an in-app conversation for the verified provider, then sends any files in an immediate attachment reply, tags, sets title/Patient ID, and assigns CX. Attachment failure after creation is partial setup (attachments), not an unsent conversation. Not idempotent: never automatically retry. Returns the acknowledged ID on partial setup; DELIVERY_UNKNOWN means check Intercom before resending. */
  createSupportConversation: PlatformCreateSupportConversationPayload;
  /** Deactivate a cohort series */
  deactivateCohortSeries: PlatformCohortSeries;
  /** Deactivate an enrollment */
  deactivateEnrollment: PlatformEnrollment;
  /**
   * Soft delete a document (marks as deleted but retains for HIPAA compliance), first removing it from
   * the patient's record when removeFromPatientRecord is true. A retry after a removal does not remove
   * again.
   *
   * Errors from the removal: BAD_USER_INPUT when the record rejected it; UPSTREAM_UNAVAILABLE on 429,
   * 5xx or a network failure.
   */
  deleteDocument: Scalars['Boolean']['output'];
  /**
   * Deletes one of the patient's measurement entries in the EHR (Healthie). First reads the entry,
   * and deletes only when it is a measurement the patient posted; otherwise BAD_USER_INPUT and
   * nothing is deleted. A retry after a delete landed fails the check with BAD_USER_INPUT. An EHR
   * rejection returns deleted false with its messages; an EHR transport or GraphQL failure, on the
   * read or the delete, fails the call with INTERNAL_SERVER_ERROR. A blank patient or entry id is
   * BAD_USER_INPUT.
   */
  deleteEhrMetricEntry: PlatformDeleteEhrMetricEntryPayload;
  /** Delete a payment card from a patient's account. */
  deleteHealthieStripeCard: Scalars['Boolean']['output'];
  /** Delete any journal entry by ID. Cleans up associated data. Ownership is the caller's to check (patient-app-api's guard reads `patientJournalEntry` first); this mutation isn't access control. False when there was no entry to delete, or, with `patientRegistryId`, the entry is another patient's. An `nh-` id, or a Healthie id of a type served from NaviHealth, is deleted in NaviHealth, which frees its external id. An `nh-` id of a type served from Healthie (after a rollback) deletes the Healthie entry NaviHealth links it to, and is false when there is none. Errors: `BAD_USER_INPUT` when `patientRegistryId` is empty or has no Healthie user id in the patient registry; `INTERNAL_SERVER_ERROR` when the patient registry lookup of `patientRegistryId`, or of an `nh-` id's owner, fails; when the lookup of a Healthie id's poster fails, the entry is deleted in Healthie. While a store flag is on: `BAD_USER_INPUT` for a steps or sleep entry served from NaviHealth, which is a day and isn't deleted by id (set its total to 0 with `upsertDailyTotal`); `NAVIHEALTH_UNAVAILABLE` when NaviHealth is unreachable, times out or answers 5xx (the delete may still have landed); `NAVIHEALTH_REQUEST_FAILED` when NaviHealth refuses it. */
  deleteJournalEntry: Scalars['Boolean']['output'];
  /** Delete a comment from a journal entry. While `journal-comments-navihealth` is on, refused with `FORBIDDEN` because comment ids are then NaviHealth ids. The flag is evaluated for `patientRegistryId`, the patient whose entry the comment is on; with the flag off, the comment's entry is read from Healthie and `patientRegistryId` must be its poster's patient registry id. Errors: `BAD_USER_INPUT` when `patientRegistryId` is empty or isn't the patient registry id of the entry's poster; `INTERNAL_SERVER_ERROR` when the lookup of the poster's patient registry id fails. */
  deleteJournalEntryComment: Scalars['Boolean']['output'];
  deleteMedication: Scalars['Boolean']['output'];
  /**
   * Delete an external ID record from a patient.
   *
   * Hard-deletes the external ID record, allowing the external system to re-associate
   * via webhook to a different (or new) patient. Useful for fixing data quality issues
   * where accounts were created with incorrect external system mappings.
   *
   * Cannot delete the last remaining active external ID for a patient — at least one must remain.
   *
   * Returns the updated patient.
   */
  deletePatientExternalId: PlatformPatient;
  /** Delete the calling provider's own note by ID. Fails if the note belongs to a different provider. */
  deletePatientNote: PlatformPatientNote;
  /**
   * Delete an external ID record from a provider.
   *
   * Hard-deletes the external ID record, allowing the external system to re-associate
   * via webhook to a different (or new) provider. Useful for fixing data quality issues
   * where accounts were created with incorrect external system mappings.
   *
   * Cannot delete the last remaining active external ID for a provider — at least one must remain.
   *
   * Returns the updated provider.
   */
  deleteProviderExternalId: PlatformProvider;
  /**
   * Deletes a referring physician in Healthie, only when it is one of input.patient's
   * referring physicians. Healthie rejections come back as messages.
   * Healthie dedups physicians, so the record may be shared with other patients.
   *
   * Errors: BAD_USER_INPUT for a blank id or externalId; REFERRING_PHYSICIAN_NOT_LINKED
   * when the physician is not one of the patient's referring physicians; UPSTREAM_UNAVAILABLE
   * when Healthie fails or errors.
   */
  deleteReferringPhysician: PlatformDeleteReferringPhysicianPayload;
  /**
   * Test/ops utility — deletes the `rudderstack_sync_events` row identified by
   * `(eventName, prescriptionId)`, undoing the idempotency guarantee so the
   * event can be resent (e.g. after `sendPrescriptionTakenEvent` returns
   * `skippedReason: "already_synced"`). Returns `deleted: false` if no matching
   * row existed.
   */
  deleteRudderstackSyncEvent: PlatformDeleteRudderstackSyncEventResult;
  /**
   * NP narrative edit — creates a new version (generatedBy 'np-edit') superseding
   * the current draft; the edited version is what approval then freezes.
   */
  editAccessCarePlan: PlatformAccessCarePlan;
  /**
   * Idempotent GLP-1 enrollment provisioning. Returns PROVISIONING immediately
   * and starts the ensure workflow asynchronously.
   */
  ensureGlp1Enrollment: PlatformMedicationProgramEnrollment;
  ensureGlp1PrescriptionTask: Scalars['Boolean']['output'];
  /**
   * Make the selected dietitian primary before an opted-in MNT booking. The
   * previous primary is retained when it is not another dietitian, and existing
   * additional providers are preserved. The target is saved before the first
   * Healthie write and uses the same confirmed readback, bounded assignment and
   * durable rollback retry contract as ensurePatientPrescriber.
   */
  ensurePatientDietitian: PlatformEnsurePatientDietitianPayload;
  /**
   * Ensure a selected prescriber is on the care team, preserving the primary.
   * A readable existing primary is required; otherwise PRIMARY_PROVIDER_UNRESOLVED
   * returns REQUIRES_REVIEW without starting recovery or writing Healthie.
   * Already-present providers are a confirmed no-op after these checks.
   * Trusted service callers select an eligible prescriber before calling.
   * No appointment is created by this mutation.
   * Every assignment saves its baseline and target in durable workflow history
   * before the first Healthie write. Retries read actual state; a verified
   * direct-add silent drop may temporarily assign the prescriber as primary.
   * Only CONFIRMED permits booking. PENDING is retryable; REQUIRES_REVIEW never
   * overwrites conflicting identity or care-team state. Infrastructure errors
   * propagate; an accepted recovery continues even if the caller disconnects.
   * Recovery has three assignment attempts before automatic rollback.
   * Preparation and rollback retry technical failures through Temporal until
   * the original team is verified, including across worker restarts. Booking
   * remains blocked while compensation is running. ASSIGNMENT_ROLLED_BACK means
   * the original care team was verified, but booking must not proceed in that
   * request. ROLLBACK_UNCONFIRMED requires support for a proven conflict or an
   * unexpectedly terminated recovery; further requests may resume only the
   * saved rollback before permitting another assignment.
   * No routine manual Temporal restart is required.
   */
  ensurePatientPrescriber: PlatformEnsurePatientPrescriberPayload;
  /**
   * Renders the three supporting PDFs for an existing prior authorization (admin preview /
   * manual Develop upload) and links the new document rows to it. Fails when the PA does not
   * belong to the patient. Each call creates new rows; it never overwrites earlier documents.
   */
  generatePatientPriorAuthDocuments: PlatformGeneratePatientPriorAuthDocumentsPayload;
  /** Request a presigned URL for uploading a document to S3 */
  getDocumentUploadUrl: PlatformUploadUrlResponse;
  /**
   * Move the session cursor one step back along the step path. Prior submissions
   * are preserved (the submissions table is append-only); a resubmission will
   * append a new row whose data wins for guard evaluation. Returns the session
   * unchanged when the session is terminal, the cursor is already at the initial
   * step, or the move would land on or cross a completed commit step. Returns a
   * SessionNotFoundError when the session id is unknown.
   */
  goBackOnboardingStep: PlatformGoBackOnboardingStepResult;
  /**
   * Places a hold, replacing (and thereby releasing) any prior hold for the
   * same (sessionId, appointmentType). Returns null, not an error, when the
   * target slot is already held by a different session -- a caller
   * distinguishes "I got it" from "someone else has it" by this return value.
   */
  holdAppointmentSlot?: Maybe<PlatformAppointmentHold>;
  /**
   * Validates the provider/time against this session's current eligible matches
   * and open MNT availability, then atomically places or replaces the session's
   * MNT hold. A contention loss is returned as data and leaves any prior hold
   * unchanged.
   */
  holdDietitianAppointment: PlatformHoldDietitianAppointmentResult;
  /**
   * Validates the time against this session's current `availability`
   * prescribers, then atomically places or replaces the session's GLP-1
   * initial-consult hold. With `providerId`, holds that displayed prescriber;
   * without it, the highest-ranked displayed prescriber open then. The hold
   * hides the slot from other sessions until it expires; it reserves nothing in
   * Healthie. Retry-safe: repeating the same input replaces the hold with an
   * identical one. A slot no longer offered, or held by another session, is
   * returned as data and leaves any prior hold unchanged.
   */
  holdGlp1Appointment: PlatformHoldGlp1AppointmentResult;
  /** Ingest canonical glucose readings with exact-retry idempotency. */
  ingestGlucoseReadings: PlatformIngestGlucoseReadingsPayload;
  /**
   * Links a prior authorization or prescription to a Medicare Bridge case.
   * Requires GrowthBook `medication-program-medicare-bridge-prescribing` and a
   * non-empty reason. The target must belong to the case's patient.
   *
   * Idempotent when that target is already linked to this case: the retry
   * returns the case and writes nothing further. A target already linked to
   * another case is rejected. Does not change medicationAccess, eligibility,
   * or prior-authorization status. A link is not payer approval or dispensing.
   */
  linkMedicareBridgeCaseTarget: PlatformLinkMedicareBridgeCaseTargetPayload;
  /**
   * Links the patient to a referring physician in Healthie. Idempotent: when the
   * patient already has a referral to that physician it is returned with
   * alreadyLinked true and nothing is created. When that check itself fails it is
   * logged and the referral is created anyway. Healthie rejections come back as messages.
   *
   * Errors: BAD_USER_INPUT for a blank externalId or referringPhysicianId;
   * UPSTREAM_UNAVAILABLE when the create fails or errors.
   */
  linkReferringPhysician: PlatformLinkReferringPhysicianPayload;
  /**
   * Record a dose the patient took against one of their tracked medications.
   *
   * Appends a log and sets the medication's viewedAt to the current time only when
   * viewedAt is null. Logging never changes the supply's state: a log past
   * `dosesCount` is accepted, leaves the supply active, and reads back as
   * `dosesRemaining` 0. Forecast fields remain functions of the log set and are
   * recomputed on read.
   *
   * Rejects with not-found when `medicationId` is unknown or belongs to another
   * patient. Rejects with a 400 when `doseDate` or `doseTime` is malformed, or
   * when the supply is inactive. Not idempotent: a retry after an ambiguous
   * failure can append a second log.
   */
  logMedicationTake: PlatformMedicationTakeLog;
  markAccessReferralAwaitingRejection: PlatformMarkAccessReferralAwaitingRejectionPayload;
  /** Record that the patient connected the cuff after a source-verified reading. */
  markBpCuffConnected: PlatformPatientProfile;
  /** Mark a session goal as complete (patient action) */
  markSessionGoalComplete: PlatformSessionGoal;
  /** Marks the owned conversation read in Intercom after a fresh authorization check. Repeating the request sets read=true again; applies to the whole conversation, including messages arriving during the request. No automatic retry. Failures return a typed error; refresh to reconcile an uncertain write. */
  markSupportConversationRead: PlatformMarkSupportConversationReadPayload;
  /** Set viewedAt on one tracked medication after verifying patient ownership. */
  markTrackedMedicationViewed: Scalars['Boolean']['output'];
  /**
   * Merge one provider record into another, consolidating a split canonical identity.
   *
   * Re-parents every active external ID and email from the loser onto the survivor
   * (demoting moved records to non-primary where the survivor already holds a primary
   * for that system / a primary email), backfills the survivor's NPI from the loser if
   * the survivor lacks one, then tombstones the loser (status=MERGED, mergedIntoId=survivor).
   *
   * The survivor MUST own the active, primary AIRTABLE external ID: the provider-matching
   * reverse-ETL keys on the Airtable-origin canonical, so consolidating onto any other
   * record would leave the matchable id unresolved. The mutation rejects otherwise.
   *
   * External IDs are moved, not deleted, so a subsequent source webhook for a moved ID
   * matches the survivor and does not recreate the split. Optional primaryExternalIdIds
   * overrides external-ID primary selection within the same serializable transaction.
   * Invalid selections reject the whole merge. A repeated merge is a no-op only when
   * any supplied selections are still active primaries on the active survivor; it never
   * changes selections on an already completed merge. Returns the surviving provider.
   */
  mergeProviders: PlatformProvider;
  /**
   * Mark the patient's onboarding interview as PAUSED — they opted out after being gently
   * encouraged. Idempotent. PAUSED is sticky (recomputing completeness from captures won't
   * override it) and mode selection treats it like COMPLETED, so the interview stops.
   */
  pausePatientBaseProfile: PlatformPatientBaseProfile;
  placeLabOrder: PlatformPlaceLabOrderResult;
  /** Creates or reuses the patient-scoped complementary-program link for Copy; does not deliver it. */
  prepareCrossSellBookingLink: PlatformOnboardingEntryLink;
  /** Authorizes a temporary attachment upload for an eligible verified provider. Does not send a message. Safe to retry; each attempt creates a fresh reference. File size, type and ownership are checked again before sending. */
  prepareSupportAttachment: PlatformPrepareSupportAttachmentPayload;
  /** Ensure ACCESS chart provisioning and submit eligibility as one idempotent program operation. */
  provisionAccessEnrollment: PlatformProvisionAccessEnrollmentResult;
  /**
   * Validate the uploaded object, pin its S3 VersionId, publish the draft, and
   * atomically supersede the previous PUBLISHED version. expectedCurrentVersionId
   * must match the current published version, or be null/omitted when none exists.
   */
  publishProviderDocumentVersion: PlatformProviderDocumentPublishingState;
  /**
   * Publish a transient event to an active provider's connected portal sessions.
   * Internal operation requiring the Platform API key; never exposed as a portal mutation.
   * No persistence, offline delivery or replay. Repeated calls publish distinct events.
   * UNAVAILABLE can mean publication was unconfirmed; retry only when duplicate hints are safe.
   */
  publishProviderEvent: PlatformPublishProviderEventPayload;
  /**
   * Reassign a patient's primary provider (Healthie's `dietitian_id`) to a
   * different canonical provider-registry provider.
   *
   * Idempotent: reassigning to the provider already assigned succeeds without
   * error, since setting Healthie's `dietitian_id` to its current value is a
   * no-op there. Registry assignments share a patient lock. Active or unverified
   * recovery blocks this write; unavailable recovery status fails closed.
   * A verified rollback permits subsequent assignments without manual restart.
   */
  reassignPrimaryProvider: PlatformPatient;
  /**
   * Admin job records a saved fax-log outcome without changing approval or the PDF.
   * Retry-safe per faxLogId/outcome. Rejects a mismatched filed document; database
   * errors are retryable and must never trigger another vendor submission.
   */
  recordAccessCareUpdateFax: PlatformRecordAccessCareUpdateFaxPayload;
  /**
   * Record a CMS un-alignment reported out of band. Moves the enrollment to
   * UNALIGNED_BY_CMS (terminal, inactive) so it leaves the post-alignment /
   * billable queue, the care-plan sweep and baseline OAP filing.
   */
  recordAccessCmsUnalignment: PlatformRecordAccessCmsUnalignmentPayload;
  /**
   * Record a patient's request to stop participating. Stops ACCESS patient comms
   * (Customer.io and Perry proactive nudges) without changing the enrollment state.
   * Idempotent; see `RecordAccessCommsOptOutInput` for errors.
   */
  recordAccessCommsOptOut: PlatformRecordAccessCommsOptOutPayload;
  recordAccessDocumentLab: PlatformRecordAccessDocumentLabPayload;
  /**
   * Append ICD-10 diagnoses + clinical measurements from a referral PDF into
   * clinical-records (source REFERRAL) for an ACCESS patient. Idempotent per
   * (patient, type, value, date); never overwrites Zus data.
   */
  recordAccessReferralClinicalData: PlatformRecordAccessReferralClinicalDataPayload;
  recordAccessReferralOutcome: PlatformRecordAccessReferralOutcomePayload;
  /**
   * Persist provider-selected ICD-10 codes with immutable request/provider provenance.
   * Exact retries are idempotent; conflicting reuse of a request ID is rejected atomically.
   * Patient identity is resolved through Patient Registry. Mapping or storage failures are
   * retryable. Existing diagnoses and other sources are never reconciled or deactivated.
   * Authenticated internal producers only; this does not confirm clinical status.
   */
  recordBenefitsRequestDiagnoses: PlatformRecordBenefitsRequestDiagnosesPayload;
  /** Atomically record one canonical blood-pressure reading. */
  recordBloodPressure: PlatformBloodPressureReading;
  /**
   * Records the client's current consent-banner state on the session --
   * overwrites any prior snapshot for the session (last-write-wins). Returns
   * SessionNotFoundError when the session id is unknown.
   */
  recordConsentSnapshot: PlatformRecordConsentSnapshotResult;
  /**
   * Records that the provider decided not to prescribe for this patient's GLP-1
   * enrollment. Appends a prescription_decisions row; the latest not_prescribed
   * decision drives prescriptionReview stage derivation (wins over Rx and PA).
   *
   * After that write, resolves the matching Task View–open prescription task for
   * the patient's latest occurred GLP-1 visit as COMPLETED / SKIPPED, using the
   * stored decision reason. The visit must belong to this patient and to the
   * acting provider. Completed tasks, other visits, and a task still in
   * PRIOR_AUTH_STARTED are left unchanged. No task is created when none exists.
   * The decision and its communication event stay idempotent: a retry does not
   * append another decision or emit the event again. A task-update failure
   * rejects with NOT_PRESCRIBED_TASK_UPDATE_FAILED after the decision is saved,
   * so a retry can close the task without repeating the clinical decision.
   *
   * The acting provider is inferred from the request auth context, never from the
   * input. Missing or invalid provider auth is rejected.
   */
  recordGlp1NotPrescribedDecision: PlatformPrescriptionReviewDecision;
  /** Record a single measurement into the canonical measurements store. Insert-only — rejects a (source, sourceResourceId) that already exists rather than overwriting it. */
  recordMeasurement: PlatformMeasurement;
  /**
   * Records ops confirmation that the pharmacy dispensed the medication.
   * Requires GrowthBook `medication-program-medicare-bridge-follow-up`.
   * A prescription, a prior-authorization approval, a patient-reported pickup,
   * a logged first dose, and a Photon order state do not confirm access.
   * A blank reason, a closed case, and an
   * unknown case are rejected. A retry of idempotencyKey writes nothing
   * further. A concurrent update fails after one retry. Confirming access
   * does not close the case.
   */
  recordMedicareBridgeMedicationAccess: PlatformRecordMedicareBridgeMedicationAccessPayload;
  /**
   * Records that ops told the patient about Bridge follow-up.
   * Requires GrowthBook `medication-program-medicare-bridge-follow-up`.
   * Does not send a message, confirm medication access, or close the case.
   * A blank reason, a closed case, and an unknown case are rejected.
   * A retry of idempotencyKey writes nothing further.
   * A concurrent update fails after one retry.
   */
  recordMedicareBridgePatientCommunication: PlatformRecordMedicareBridgePatientCommunicationPayload;
  /**
   * Projects a canonical acquisition-source choice to a Healthie tag matching
   * CBF's how-did-you-hear tags, so the dbt warehouse attribution models that
   * read those tags keep working unchanged. A no-op when the patient already
   * carries any acquisition-source tag (from either CBF or this mutation).
   * Exposed only to trusted program domains.
   */
  recordPatientAcquisitionSource: PlatformPatient;
  /**
   * Tags the patient's Healthie client `Minor – booked by guardian`, so
   * providers see on the chart that a parent or legal guardian booked this
   * patient while they were under 18. A no-op when the tag is already applied,
   * so retries are safe. Fails when the patient has no active Healthie identity
   * or Healthie does not confirm the tag; callers that must not block a booking
   * on it handle the error. Exposed only to trusted program domains.
   */
  recordPatientBookedByGuardian: PlatformRecordPatientBookedByGuardianPayload;
  /**
   * Records supplied vitals through the existing patient-reported vital path, replaces the exact
   * family-history response when supplied, and reconciles only this capability's family-history and
   * BMI-derived ICD-10 rows. Exact retries are idempotent. Healthie projection is best-effort after
   * canonical persistence and cannot roll back the canonical response. Exposed only to trusted
   * program domains.
   */
  recordPatientMedicalBackground: PlatformPatientMedicalBackground;
  /**
   * Record patient-reported pharmacy benefit coverage. Every field beyond the
   * patient id is optional (patients transcribe only what's legible on their
   * card). Replaces the row (latest write wins) — a patient-reported write has no
   * payer id, so the row reads as incomplete and the DoseSpot scrape later
   * re-populates it with the authoritative set. Returns the resulting coverage on
   * file, or null when nothing was provided and none exists.
   */
  recordPatientPharmacyCoverage?: Maybe<PlatformPatientPharmacyCoverage>;
  /**
   * Saves a provider referral and queues CBF-compatible outreach. API key only.
   * Identical retries with the same submissionId return the original link; different
   * data with that id returns a field error. Persistence or workflow-dispatch failures
   * raise system errors; retry with the same id, since the referral may already be saved.
   * Physician and provider-email failures retry in the worker without undoing acceptance.
   * Patient outreach uses the shared queued RudderStack delivery behavior.
   * The generated link carries this referral's analytics identity into onboarding.
   */
  recordPatientReferral: PlatformRecordPatientReferralPayload;
  /**
   * Canonically matches the confirmed provider against every source, not just
   * this command's own: when `npi` is supplied and already matches an existing
   * member (Zus-sourced or previously patient-reported), that row is the same
   * real provider — its facts are updated and it is verified in place, without
   * disturbing its source identity, so a later Zus pull still finds it. When
   * there is no NPI match (or none is supplied), this upserts within the
   * `patient_reported` source, keyed by provider name; a resubmission with a
   * changed name replaces the prior `patient_reported` row for the same
   * `sourceRecordId` rather than creating a second member.
   * `sourceRecordId` is provenance and retry traceability, not identity: it lets
   * an exact retry converge on the same row and lets a back-navigated correction
   * clean up the caller's stale `patient_reported` row.
   *
   * After canonical persistence, optimistically projects the corresponding
   * Healthie referring physician and patient referral link: any failure there —
   * a Healthie rejection or a transport failure alike — is logged and never
   * fails the command or is surfaced to the caller, and is reported only as
   * `healthieReferralLinked: false` on the payload. The canonical member is
   * always committed and verified; the projection is repaired operationally
   * (a later retry or backfill replays this same command), never by a
   * client-facing error. A failure of the canonical write itself throws.
   *
   * Exposed only to trusted program domains.
   */
  recordPatientReportedCareTeamMember: PlatformRecordPatientReportedCareTeamMemberPayload;
  /** Record patient-reported height in inches and project it to Healthie. */
  recordPatientReportedHeight: PlatformMeasurement;
  /** Record patient-reported weight in pounds and project it to Healthie. */
  recordPatientReportedWeight: PlatformMeasurement;
  /**
   * Records the patient-reported date a prescription was picked up (patient-app
   * self-report). Sets picked_up_at on the prescription identified by
   * `prescriptionId`, after verifying it belongs to the patient. Latest write
   * wins. Returns the updated prescription.
   */
  recordPrescriptionPickup: PlatformMedicationProgramPrescription;
  /**
   * Returns cached pharmacy benefit coverage when all routing fields are present;
   * otherwise runs DoseSpot automation, persists to `patient_rx_coverage`, and
   * returns the refreshed snapshot.
   */
  refreshPharmacyBenefitCoverage: PlatformPharmacyBenefitCoverage;
  /**
   * Register a patient identity in the registry.
   *
   * If a patient with the given healthieUserId already exists, returns the existing
   * patient as-is. If not, creates a new patient record with the provided data.
   *
   * This operation is idempotent - safe to call multiple times with the same input.
   * Email is only set on creation, never updated (to preserve authoritative data).
   */
  registerPatient: PlatformPatient;
  /**
   * Register a provider identity in the registry.
   *
   * If a provider with the given airtableRecordId already exists, returns the existing
   * provider as-is. If not, creates a new provider record with the provided data.
   *
   * This operation is idempotent - safe to call multiple times with the same input.
   * Email is only set on creation, never updated (to preserve authoritative data).
   */
  registerProvider: PlatformProvider;
  /**
   * Register a provider identity in the registry from a Healthie user ID.
   *
   * Resolves an existing provider by Healthie external ID, then NPI, then email.
   * If none match, creates a new provider record keyed on the Healthie ID — an
   * Airtable record ID is NOT required. Use this for admin-sourced backfills where
   * Healthie ID + email are the only available identifiers.
   *
   * This operation is idempotent - safe to call multiple times with the same input.
   * Email is only set on creation, never updated (to preserve authoritative data).
   */
  registerProviderFromHealthie: PlatformProvider;
  /** Releases a hold if one is live. Returns false, not an error, when there is nothing to release -- including a hold that already expired. */
  releaseAppointmentHold: Scalars['Boolean']['output'];
  /**
   * Soft-remove a dose the patient logged. The log keeps its row with `isRemoved`
   * set and drops out of every read, count and forecast.
   *
   * Works on logs under inactive supplies. The patient's GLP-1 journey is not
   * rolled back: a first-dose milestone stays recorded after its dose is removed.
   *
   * Rejects with not-found when `logId` is unknown or belongs to another
   * patient's medication. Idempotent: removing an already-removed log succeeds
   * and keeps its original removal time.
   */
  removeMedicationTake: PlatformRemoveMedicationTakePayload;
  /** Sends a public reply as the verified provider after a fresh ownership/tag check. Not idempotent: never automatically retry; DELIVERY_UNKNOWN means refresh before resending. */
  replyToSupportConversation: PlatformReplyToSupportConversationPayload;
  /**
   * Mint a short-lived signed PUT for a draft PDF. Creates the document and DRAFT
   * version on first use. Repeating identical slug, versionLabel, contentType,
   * and fileSizeBytes reuses that draft and returns a new URL.
   */
  requestProviderDocumentUpload: PlatformProviderDocumentUploadTarget;
  resolveAccessReview: PlatformResolveAccessReviewPayload;
  /**
   * Resolve all OPEN care-agent crisis escalations for a patient — the human recovery that re-enables
   * the ACCESS care agent for them after a crisis pause. Idempotent: resolving when nothing is open
   * returns resolvedCount: 0.
   *
   * `patientHealthieId` is the patient's Healthie user ID.
   * `resolvedBy` identifies who resolved it (recorded for audit).
   *
   * v1 interim surface (no UI yet) — see the care-escalation-resolve runbook. The future NP escalation
   * pipeline calls this same mutation.
   */
  resolveCareEscalation: PlatformResolveCareEscalationResult;
  /**
   * Resolve a patient email conflict by designating one email as primary.
   *
   * Sets the chosen email to isPrimary=true, status=ACTIVE and supersedes all other
   * active emails in the conflict group.
   * The resolution note and timestamp are stored on all affected records.
   *
   * Returns the updated patient. Use emails(includeAll: true) to see superseded records.
   */
  resolvePatientEmailConflict: PlatformPatient;
  /**
   * Resolve a patient external ID conflict by designating one record as primary.
   *
   * Sets the chosen external ID to isPrimary=true, status=ACTIVE and supersedes all
   * other active external IDs in the same patient-system conflict group.
   * The resolution note and timestamp are stored on all affected records.
   *
   * Returns the updated patient. Use externalIds(includeAll: true) to see superseded records.
   */
  resolvePatientExternalIdConflict: PlatformPatient;
  /**
   * Resolve a provider email conflict by designating one email as primary.
   *
   * Sets the chosen email to isPrimary=true, status=ACTIVE and supersedes all other
   * active emails in the conflict group.
   * The resolution note and timestamp are stored on all affected records.
   *
   * Returns the updated provider. Use emails(includeAll: true) to see superseded records.
   */
  resolveProviderEmailConflict: PlatformProvider;
  /**
   * Resolve a provider external ID conflict by designating one record as primary.
   *
   * Sets the chosen external ID to isPrimary=true, status=ACTIVE and supersedes all
   * other active external IDs in the same provider-system conflict group.
   * The resolution note and timestamp are stored on all affected records.
   *
   * Returns the updated provider. Use externalIds(includeAll: true) to see superseded records.
   */
  resolveProviderExternalIdConflict: PlatformProvider;
  /** Marks the owned conversation resolved by the prescriber after a fresh authorization check: stores the current time in the Resolved at attribute, marks it read and adds an internal note for support. Does not close it in Intercom. CONFIGURATION_REQUIRED while supportAvailability.resolveEnabled is false. */
  resolveSupportConversation: PlatformResolveSupportConversationPayload;
  /**
   * Re-emit the propagation event for a single patient. Equivalent to the
   * registry upsert tail path — `signalWithStart`s
   * `propagateIdentityToNavihealth` with workflow id
   * `propagate-identity:patient:<registryId>` and `USE_EXISTING` policy.
   * Two rapid calls collapse onto one execution that drains twice.
   */
  resyncPatientToNavihealth: PlatformResyncPatientToNavihealthResult;
  resyncProviderToNavihealth: PlatformResyncProviderToNavihealthResult;
  /**
   * Retire a document without deleting versions, attestations, or S3 objects.
   * Retired documents drop out of assignment and file access. Idempotent.
   */
  retireProviderDocument: PlatformRetireProviderDocumentResult;
  /**
   * Deletes any `patient_reported` care-team member rows matching
   * (patientId, sourceRecordId) — for a caller whose own draft submission was
   * abandoned (e.g. the patient cleared the form after an earlier submission
   * and skipped the step). Idempotent: deleting zero rows is success.
   *
   * Only `patient_reported` rows are affected. A row from another source that
   * was NPI-matched and verified by an earlier `recordPatientReportedCareTeamMember`
   * call (e.g. a Zus-sourced row) is never touched by this command — it stays
   * verified even after the retraction. This is an accepted edge, not a bug.
   *
   * Exposed only to trusted program domains.
   */
  retractPatientReportedCareTeamMember: Scalars['Boolean']['output'];
  retryAccessAlignment: PlatformRetryAccessAlignmentPayload;
  /**
   * Re-drive CRM events by id (bulk). For each id, starts a fresh Temporal
   * execution that replays the stored payload, incrementing the event's attempts.
   * Intended for events that failed after Temporal exhausted its own retries.
   */
  retryCrmEvents: Array<PlatformCrmEventRetryResult>;
  /**
   * Files an already-stored prescription photo into the patient's record.
   * Does not accept new bytes. A link that still needs an upload stays
   * `NEEDS_UPLOAD`. Unknown token is `UNAVAILABLE`. Safe to retry.
   */
  retryPrescriptionPhotoLink: PlatformPrescriptionPhotoLink;
  returnAccessReferralToReview: PlatformReturnAccessReferralToReviewPayload;
  /**
   * Saves the patient's primary insurance policy. First moves a private-pay patient to the matching
   * insurance group (private pay to insurance, provider-sourced private pay to provider-sourced
   * insurance; any other group is left alone). Then, in one write, sets the policy as primary with the
   * fields given and the card files, and makes currentPrimaryPolicyId inactive when it is set and
   * differs from policyId. A field left out is not sent.
   *
   * Always writes patient.externalId's chart. When the registry has no patient for externalId, that
   * patient's primary active record id is not externalId, or patientId names another patient, the
   * platform logs IDENTITY_FALLBACK and writes anyway.
   *
   * Not idempotent: without policyId every call adds a policy, so a caller must not retry blindly. A
   * failed write leaves the group move in place.
   *
   * Errors:
   * - NOT_FOUND: the record has no user with id externalId.
   * - BAD_USER_INPUT: a blank externalId, refused before any call, or the record refused a call with a
   *   status other than 429 or 5xx. extensions.reason is present only for a validation failure: OTHER
   *   for the blank externalId, and INVALID_CARD_IMAGE, INVALID_HOLDER_DATE_OF_BIRTH or OTHER when the
   *   record failed the group move's or the write's validation. The message is the platform's, never
   *   the input.
   * - UPSTREAM_UNAVAILABLE: the record answered 429, 5xx or not at all.
   * - INTERNAL_SERVER_ERROR: a fault in the platform itself.
   *
   * Exposed only to first-party backends with the platform API key.
   */
  savePatientInsurance: PlatformPatientInsurancePoliciesPayload;
  /**
   * Stores one patient-owned file in monorepo Documents and files the same bytes
   * into the patient's record. Idempotent on `idempotencyKey`: a repeat call
   * returns the existing document and does not create another file in either
   * destination. When the monorepo copy exists and the record copy does not, a
   * retry without `fileBase64` files the stored bytes; a new `fileBase64`
   * replaces those bytes before filing. A retryable record-copy failure
   * (`UPSTREAM_UNAVAILABLE`) returns the monorepo document with `complete: false`
   * so the caller can retry without another upload. A record rejection
   * (`BAD_USER_INPUT`) throws. A lost response after a successful record copy is
   * safe to retry.
   *
   * Exposed only to first-party backends (platform API key).
   *
   * Errors: BAD_USER_INPUT when `healthieUserId` is blank, the file is missing
   * on the first save, the bytes are not a JPEG, PNG, or PDF within 10MB, or
   * the record rejected the file. A signature mismatch deletes the unconfirmed
   * row and is BAD_USER_INPUT.
   */
  savePatientOwnedFile: PlatformPatientOwnedFileDelivery;
  /**
   * Save a payment method to the patient's Healthie-managed Stripe customer.
   * This stores a no-show card on file and never charges the patient.
   */
  savePaymentMethod: PlatformSavePaymentMethodResult;
  /**
   * Send a message into a channel on behalf of one of its members. Used for
   * system-authored content that must appear in the conversation: follow-up
   * notes and care-plan summaries (provider-portal), detailed meal plans
   * (provider-portal), automated welcome messages (berrystreet-admin).
   *
   * Exposed only to first-party backends (global API-key guard). Idempotent on
   * input.idempotencyKey. Attachments must already be on our GetStream CDN and
   * are attached as-is; a message with N attachments is one GetStream message
   * with N attachments, not N messages.
   *
   * The message is deliberately NOT stamped with healthieNoteId or silent, so the
   * GS→Healthie sync echoes it into Healthie for patients still reading there.
   *
   * Error codes (in extensions.code), checked in this order:
   * - CHANNEL_NOT_FOUND: channelId does not name an active channel
   * - FORBIDDEN: senderUserId is not a member of the channel
   * - BAD_USER_INPUT: an attachment url is not on our GetStream CDN
   */
  sendChatMessage: PlatformSendChatMessagePayload;
  /** Creates or reuses the appointment-scoped link and delivers it through provider chat and Customer.io SMS. */
  sendCrossSellBookingLink: PlatformCrossSellBookingLinkDelivery;
  /**
   * Ops utility that emits `log_first_dosage_reminder` via fire-and-forget
   * RudderStack `track()` for every active tracked medication linked to an active
   * prescription and created between 24 hours and 10 days ago, but only when the
   * patient has never created a dose log for any tracked medication. Logs on an
   * earlier or inactive medication, including removed logs, make later
   * medications ineligible. Each event is keyed to the patient's Healthie id and
   * contains `{ medication_id, route }`. Medications older than 10 days are no
   * longer retried. When RudderStack is disabled the run returns
   * `skippedReason: "rudderstack_disabled"` and does not claim a UTC day.
   *
   * The mutation atomically records a notification attempt before tracking. At
   * most one event of this type is queued per patient per UTC calendar day, even
   * across concurrent calls or several eligible medications. `sent` counts
   * patients this run newly notified, not Customer.io delivery. A lost claim is
   * not counted as sent. Processing continues after individual failures and
   * reports aggregate outcomes.
   */
  sendFirstDosageReminderEvents: PlatformSendFirstDosageReminderEventsPayload;
  /**
   * Test/ops utility — synchronously (re-)sends the `prescription.taken`
   * RudderStack event for a single prescription by id, bypassing the
   * active/Photon/3-day filters the scheduled batch applies.
   * Still respects the same idempotency guarantee as the batch job — returns
   * `skippedReason: "already_synced"` rather than sending a duplicate. Returns
   * `skippedReason: "rudderstack_disabled"` (no DB write) when the RudderStack
   * client has no write key/data plane URL configured.
   */
  sendPrescriptionTakenEvent: PlatformSendPrescriptionTakenEventResult;
  /** Send an idempotent provider-authored message to an existing patient DM. M2M-only. */
  sendProviderChatMessage: PlatformProviderChatMessageDelivery;
  /** Set a card as the default payment method for a patient. */
  setDefaultHealthieStripeCard: Scalars['Boolean']['output'];
  /** Select an active tracked medication owned by the patient as their default. */
  setDefaultTrackedMedication: Scalars['Boolean']['output'];
  /**
   * Upserts provider-private free-text notes for a patient. Latest write wins on
   * (patientHealthieId, providerHealthieId). Null or empty notes clears the row.
   * Requires ACTIVE GLP-1 enrollment. The acting provider is inferred from the
   * request auth context, never from the input, and must be the patient's latest
   * occurred GLP-1 prescriber. Returns the stored notes payload (notes null when
   * cleared).
   */
  setGlp1PatientPrescriberNotes: PlatformGlp1PatientPrescriberNotesPayload;
  /**
   * Stores card files on one existing policy and changes nothing else on it. A repeat sends the same
   * cards to the same policy again. Writes patient.externalId's chart under the same identity rule as
   * savePatientInsurance.
   *
   * Errors as savePatientInsurance, except that it never returns NOT_FOUND: nothing reads the user
   * first, so a missing user comes back as whatever the record answers the write with.
   *
   * Exposed only to first-party backends with the platform API key.
   */
  setInsurancePolicyCards: PlatformPatientInsurancePoliciesPayload;
  /**
   * Creates or replaces the patient's emergency contact on their Healthie chart
   * (a `NotificationContact` with `emergency: true`). Healthie is the source of
   * record — there is no registry-side copy.
   *
   * Upserts against the patient's existing emergency notification contact read
   * from Healthie, so retries and re-submissions update in place rather than
   * creating another contact (the read-then-write is not atomic, so only
   * sequential re-submission — not concurrent calls for the same patient — is
   * guaranteed duplicate-free; extra emergency contacts are tolerated by
   * updating the first and warning). Fails on a missing Healthie identity or a
   * Healthie-side error so the client can retry.
   *
   * Exposed only to trusted program domains.
   */
  setPatientEmergencyContact: Scalars['Boolean']['output'];
  /**
   * Hides an open Medicare Bridge case from the default queue until
   * snoozedUntil. Requires GrowthBook
   * `medication-program-medicare-bridge-follow-up`.
   * snoozedUntil must be in the future. A blank reason, a closed case,
   * and an unknown case are rejected. A retry of idempotencyKey writes
   * nothing further. A concurrent update fails after one retry.
   */
  snoozeMedicareBridgeCase: PlatformSnoozeMedicareBridgeCasePayload;
  /**
   * Start saving a card in the caller's own card form (Stripe Elements or the
   * mobile SDK), confirmed with `clientSecret` under `publishableKey`. Nothing
   * is charged. Payments picks the Stripe account; a setup without `patientId`
   * waits for completeCardSetup to bind its card to a patient. Retry-safe per
   * `idempotencyKey`: a repeat returns an open setup and never saves a second
   * card; a repeat with a different patient is a top-level error.
   * CardSetupUnavailableError: no setup was started; keep the existing card flow.
   */
  startCardSetup: PlatformStartCardSetupPayload;
  /**
   * Start a new onboarding session and return its first step. With an entry
   * token: starts a prefilled session, or resumes the one the link already
   * started; returns EntryLinkUnusableError if the link is expired or invalid.
   */
  startOnboardingSession: PlatformStartOnboardingSessionResult;
  /** Idempotently records DISCOVERY when this patient has no journey history; otherwise returns the existing current state. */
  startPatientGlp1Journey: PlatformPatientGlp1JourneyEvent;
  /**
   * Start the `backfillPatientsToNavihealth` Temporal workflow.
   *
   * Uses Temporal's `FAIL` conflict policy so a double-click returns
   * BACKFILL_ALREADY_RUNNING instead of silently attaching to the in-flight
   * execution. The kill switch is also checked before starting; rejection
   * is returned in-band as `NAVIHEALTH_PROPAGATION_DISABLED`.
   *
   * Provider-must-complete-first ordering is enforced operationally for
   * the initial backfill (one-time sequencing decision) — new providers
   * always exist in Navi Health before they take on patients in steady
   * state, so the gate is not encoded in the schema.
   */
  startPatientNavihealthBackfill: PlatformStartPatientNavihealthBackfillResult;
  /**
   * Start (or resume) a patient-scoped onboarding session for a trusted M2M
   * caller acting on behalf of an already-authenticated patient — no entry-link
   * token. Facts are supplied directly by the caller and run through the same
   * per-flow prefill mapper an entry link uses. Resumes the patient's existing
   * open session for the flow — however it was created — if one exists;
   * otherwise creates a new prefilled session bound to the patient. M2M-only.
   */
  startPatientOnboardingSession: PlatformOnboardingSessionWithStep;
  /**
   * Start (or resume) the provider email-origin backfill for one stage.
   * Dry-run by default (`apply` false). Labels only — never isPrimary,
   * status, inserts, or deletes. Idempotent under monotone upgrade.
   * Double-start for the same stage returns BACKFILL_ALREADY_RUNNING.
   */
  startProviderEmailOriginBackfill: PlatformStartProviderEmailOriginBackfillResult;
  startProviderNavihealthBackfill: PlatformStartProviderNavihealthBackfillResult;
  submitAccessAlignment: PlatformSubmitAccessAlignmentPayload;
  submitAccessEligibility: PlatformSubmitAccessEligibilityPayload;
  /**
   * Creates a Linear parent ticket on the IT team plus one sub-ticket per
   * provisioning step defined in the service catalog. Synchronous — the
   * mutation awaits Linear ticket creation and returns the refs. Linear is
   * the system of record for the request's lifecycle thereafter.
   */
  submitAccessRequest: PlatformAccessRequest;
  /** Accept a patient's confirmed cuff shipping address and create the current order idempotently. */
  submitBpCuffOrder: PlatformPatientProfile;
  /**
   * Saves the SOAP content into a draft note, then signs and locks it as asked. The acting provider
   * comes from the x-bst-provider-assertion header, never from the input; the caller owns the check
   * that the note belongs to the acting provider's session. A signed note keeps its content
   * (content KEPT_SIGNED, nothing written) when sign is false or the write ran as the organization.
   * When signing is in effect, a note the acting provider signed is kept and a note another provider
   * signed is rejected. Any failure before the content save fails the call: BAD_USER_INPUT for a
   * note that is not the patient's, is not a SOAP note, is signed by another provider while signing
   * is in effect, or is locked and unsigned; INTERNAL_SERVER_ERROR for an EHR failure, the 40 second
   * work limit or a missing organization-key configuration. After the save the call never fails and
   * reports each later step in the payload, so a retry is safe: a note the provider signed is kept
   * and anything else is saved again. A sign or lock step that does not fit in the work limit is
   * SKIPPED_DEADLINE.
   */
  submitEhrChartingNote: PlatformSubmitEhrChartingNotePayload;
  /**
   * Creates a local PriorAuthorization and starts the Develop submit workflow.
   * When a matching active PA already exists for this patient + program +
   * product/SKU (PENDING, or COMPLETE + APPROVED) and forceSubmit is omitted or
   * false, returns `ActivePriorAuthorizationConflict` and does not create a row or
   * start another Develop case. With `forceSubmit: true`, creates a new PENDING
   * row and Develop case when the blocker is a live in-progress PA or an
   * already-approved PA. A PENDING row with no developCaseId is still reused.
   * COMPLETE + APPROVED still conflicts by default; force is the auditable override
   * and expirationDate is ignored. Resubmission after DENIED, CANCELLED, FAILED,
   * NOT_SUBMITTED, or COMPLETE + OTHER remains allowed without force. A PA for a
   * different product/SKU is allowed. Concurrent non-force retries cannot both
   * create a row.
   *
   * While `medication-program-medicare-bridge-prescribing` is on, an open Bridge
   * case that is `ELIGIBLE` on the current checklist is checked in that same
   * transaction. An ELIGIBLE review on an older checklist returns
   * `BridgeReviewRequired`. A product outside the current checklist, and a
   * Zepbound vial or auto-injector, returns `BridgeProductNotAllowed`. Wegovy
   * HD is a Wegovy injection and is allowed. A pending PA with a Develop case,
   * or an unexpired approval, on any SKU of that product returns
   * `DuplicateBridgePriorAuth`; forceSubmit does not bypass that. The existing
   * row is linked only when it is an allowed Bridge package submitted at or
   * after the case opened and at or after the current eligible review, and it
   * is not already linked to another case. When the row is linked to this case,
   * the message names a Medicare Bridge prior authorization. Otherwise the
   * message says the prior authorization is not linked to this case.
   * An expired approval may be resubmitted. `NOT_STARTED`, `NEEDS_INFORMATION`, and `NOT_ELIGIBLE` keep
   * today's commercial behavior and are not linked. A created Bridge PA is
   * linked to the case. The link is not approval. No pharmacy note is required:
   * Groundwork has not published a preset, and a Photon prescription has no
   * note field.
   * Patients with no open case are unchanged. The flag off skips the Bridge check.
   */
  submitGlp1PriorAuth: PlatformSubmitGlp1PriorAuthResult;
  submitGlp1Screening: PlatformBenefitsCheck;
  /**
   * Records a provider's Medicare Bridge review and moves eligibilityReview
   * to that decision. The acting provider comes from the verified provider
   * assertion, never from input.
   *
   * Requires GrowthBook `medication-program-medicare-bridge-review`. The
   * checklist version must be the current one. `ELIGIBLE` is rejected when a
   * required checklist item is unmet, when `unresolvedItems` is non-empty, or
   * when `therapy_start_date` is after the current UTC date. `NEEDS_INFORMATION`
   * requires at least one unresolved checklist key. `nextRoute` is required
   * unless the decision is `ELIGIBLE`, is rejected when the decision is
   * `ELIGIBLE`, and must be one of the checklist routes.
   *
   * Idempotent on `idempotencyKey`: a retry for the same case returns the
   * stored case and writes nothing further, before checklist validation, so a
   * later checklist version does not turn that retry into an error. The same
   * key on another case is rejected. A closed or ruled-out case is rejected.
   *
   * The stored protocol version is null until the checklist names a protocol
   * document. A missing attestation does not block the review.
   */
  submitMedicareBridgeReview: PlatformSubmitMedicareBridgeReviewPayload;
  /**
   * Files an onboarding bundle for one person: a Linear parent ticket on the IT
   * team plus one sub-ticket per provisioning step of every item, each marked
   * as needing no explicit approval. Rejected before any ticket is filed when
   * `requestedFor` isn't a berrystreet.co address. Not idempotent: a retry
   * files a second set of tickets. Fails fast: if Linear rejects a ticket
   * mid-way, the tickets already created stay in Linear for IT to reconcile.
   */
  submitOnboardingBundle: PlatformSubmitOnboardingBundlePayload;
  /**
   * Validates and applies an optional earlier-step correction, then submits the
   * session's current step. The correction and current submission are one
   * logical recovery attempt: the cursor advances only when the current step
   * succeeds. If the current action requests another retry, the corrected
   * earlier submission is retained. A step that is no longer the cursor, or any
   * submit on a terminal session, is an idempotent no-op including its recovery.
   */
  submitOnboardingStep: PlatformSubmitOnboardingStepResult;
  /**
   * Saves a provider referral and queues CBF-compatible outreach. API key only.
   * Identical retries with the same submissionId return the original link; different
   * data with that id returns a field error. Persistence or workflow-dispatch failures
   * raise system errors; retry with the same id, since the referral may already be saved.
   * Physician and provider-email failures retry in the worker without undoing acceptance.
   * Patient outreach uses the shared queued RudderStack delivery behavior.
   * The generated link's referral reader is not implemented in this release.
   */
  submitPatientReferral: PlatformSubmitPatientReferralPayload;
  /**
   * Stores a prescription photo for the secure link, in monorepo Documents and
   * the patient's record. Idempotent for the link: a photo already stored is
   * returned and a second file is not created. A record-copy failure leaves the
   * link `INCOMPLETE` and keeps the stored photo. Unknown token is `UNAVAILABLE`.
   * A file that is not a JPEG or PNG, or is larger than 8MB, returns `REJECTED`
   * with `message` and stores nothing. A failure while filing a valid photo throws.
   */
  submitPrescriptionPhotoLink: PlatformPrescriptionPhotoLink;
  /** Sync a batch of health metrics with automatic aggregation and routing. A forwarded category is written as createHealthMetricEntry writes it, so STEPS goes to NaviHealth while steps are served from there. Errors: `BAD_USER_INPUT` when neither id is set, or when `patientRegistryId` is empty or has no Healthie user id in the patient registry. `INTERNAL_SERVER_ERROR` when the patient registry lookup of `patientRegistryId` fails; when the lookup of a Healthie user id's patient registry id fails, the write goes to Healthie. While the entry's type is served from NaviHealth: `NAVIHEALTH_UNAVAILABLE` when NaviHealth is unreachable, times out or answers 5xx (the write may still have landed); `NAVIHEALTH_REQUEST_FAILED` when NaviHealth refuses it; `NOT_FOUND` when NaviHealth doesn't know the patient; `CONFLICT` when NaviHealth reports a conflicting write. There is no fallback to Healthie. */
  syncHealthMetrics: PlatformSyncHealthMetricsPayload;
  /**
   * Trigger a Temporal workflow that syncs a patient's demographic record to Zus.
   *
   * Behaviour:
   * - Auto-registers the patient if no patient_registry row exists yet.
   * - When the last successful sync is within the 6-month cooldown and `override`
   *   is false, returns `triggered: false, skippedReason: "cooldown"` without
   *   starting a workflow.
   * - Otherwise starts the `syncPatientToZus` workflow on the `patient-registry`
   *   task queue. The workflow logs the FHIR payload to Datadog as a placeholder
   *   until the Zus HTTP call is implemented.
   */
  syncPatientToZus: PlatformSyncPatientToZusResult;
  /**
   * Ops backfill by Photon prescription id — starts the
   * `syncPhotonPrescriptionAndCreateMedication` workflow (sync + pharmacies +
   * Healthie medication + prescription.created event) once per id, the same
   * workflow the `photon.prescription.created` webhook runs. Ids are trimmed and
   * de-duplicated; returns one result per unique id. All steps are idempotent, so
   * re-running for an already-synced prescription is safe. `skippedReason` is
   * `already_running` when a run for that id is in flight, or `error` when the
   * start failed (does not abort the rest of the batch).
   */
  syncPhotonPrescriptions: Array<PlatformTriggerBackfillWorkflowResult>;
  /**
   * Starts a one-shot Temporal workflow to sync prior_authorizations with
   * Develop Health. Omit developCaseIds to refresh every row with a Develop case
   * id; provide ids to refresh existing rows or create missing ones. Does not POST
   * to Develop or start develop-pa. Per-row outcomes are in workflow/activity logs.
   * Service ops — use to backfill or reconcile PA data missing or stale in the DB.
   */
  syncPriorAuthorizationsFromDevelop: PlatformTriggerBackfillWorkflowResult;
  /**
   * Manually sync provider rows from Airtable by record id.
   *
   * Re-reads each row from the Airtable Records API, applies the same
   * completeness gate as the webhook drain, and upserts complete rows into
   * the registry. Idempotent. Each successful upsert may emit a Navi Health
   * propagation signal the same way the drain does.
   *
   * Incomplete, missing, or malformed ids are returned in `skipped` rather
   * than failing the mutation. Per-row upsert failures are isolated the same
   * way — already-committed rows stay in `syncedRecordIds`.
   */
  syncProvidersFromAirtable: PlatformSyncProvidersFromAirtableResult;
  /**
   * Submit Temporal backfill workflows for a batch of items.
   *
   * Each item routes to a workflow based on which secondary field is set:
   * - patientHealthieId present → backfillChatForPair (chat-backfill queue)
   * - conversationId present → provisionChatForConversation (chat-provision queue, USE_EXISTING)
   * - neither present → backfillProviderChatAccount (chat-provision queue, USE_EXISTING)
   *
   * All operations are idempotent — safe to call for already-provisioned items or duplicate rows.
   */
  triggerChatBackfill: PlatformTriggerChatBackfillResult;
  /**
   * Generates the GetStream chat history import files and writes them to S3.
   *
   * Read-only against Healthie, and writes no messages to GetStream: it produces
   * the JSONL an operator uploads with `stream-cli`. It does upload note
   * attachments to Stream's CDN, and creates a chat account and Stream user, with
   * no channel membership, for a sender outside the channel who has none. Returns
   * as soon as the workflow is submitted; the manifest written at the end lists
   * every file to upload.
   *
   * Files are bounded well under Stream's 300MB ceiling because one malformed
   * line fails a whole file and the upload reports `total: 0`, which makes file
   * size the blast radius of a single bad record. Re-running is safe: message ids
   * derive from the Healthie note id and Stream's import is an upsert, so a
   * repeated file or a repeated upload converges on the same channel state.
   */
  triggerChatHistoryImport: PlatformTriggerChatHistoryImportResult;
  /**
   * Measure what a chat history import (PAT-1434) would involve, and write the
   * answer to S3 as a manifest. Reads Healthie and Postgres; writes nothing to
   * GetStream and nothing to Healthie.
   *
   * This is the dry run that decides the message-length cap, the file splitting
   * and the runtime estimate for the import itself. Re-runnable: it is meant to
   * be run again between import attempts, not deleted after the first one.
   *
   * `runId` names the run. It is the workflow ID suffix and the S3 key prefix.
   * Repeating it while that run is still in flight joins it rather than starting
   * a second walk of the cohort, and the arguments you pass are then DISCARDED,
   * including `cutoverAt`, while the call still returns success. Use a fresh
   * `runId` to change an argument. Repeating it after a run has finished starts
   * a fresh walk; manifests are written under a timestamped key, so an earlier
   * run's manifest survives for comparison.
   *
   * `cutoverAt` is when the Healthie→GetStream sync went live, ISO-8601. Notes
   * after it should already carry a sync row, so the boundary is what makes the
   * manifest's missing-sync-row count meaningful. Required rather than assumed,
   * because a wrong value changes that number silently.
   *
   * `maxMessageLength` is GetStream's cap for the channel type (5000 on
   * `messaging`). Notes whose stripped text exceeds it are counted, not rejected.
   *
   * `maxChannels` stops the scan once that many channels are done, checked at
   * page boundaries so it can overshoot slightly. Omit to walk the whole cohort;
   * set it to rehearse against a slice first. The manifest's `truncated` flag
   * records whether the run stopped early.
   */
  triggerChatHistoryScan: PlatformTriggerChatHistoryScanResult;
  /**
   * Starts a one-shot Temporal workflow to backfill GLP-1 appointments from
   * Healthie into glp1_appointments. Org-wide only — pages initial + follow-up
   * appointment types. Idempotent upserts by appointment_healthie_id.
   */
  triggerGlp1AppointmentsBackfill: PlatformTriggerBackfillWorkflowResult;
  /**
   * Starts a one-shot read-only Temporal workflow to compare org-wide GLP-1
   * appointments in Healthie against glp1_appointments. Emits gap logs only;
   * does not upsert or ensure prescription tasks.
   */
  triggerGlp1AppointmentsMirrorReconcile: PlatformTriggerBackfillWorkflowResult;
  /**
   * Starts a one-shot Temporal workflow to backfill prescriptions from
   * Photon into the local table. `syncPhoton` must be true. Omit
   * `patientHealthieIds` to walk all GLP-1 enrollments sequentially.
   * Idempotent upserts by `(externalId, source)`.
   */
  triggerPrescriptionBackfill: PlatformTriggerBackfillWorkflowResult;
  /**
   * Removes a prior authorization or prescription link from a Medicare Bridge
   * case. Requires GrowthBook `medication-program-medicare-bridge-prescribing`
   * and a non-empty reason.
   *
   * Writes one ledger event and deletes the link. Does not delete the prior
   * authorization or prescription, and does not change medicationAccess.
   * A missing link is rejected. A retry after a successful unlink is rejected
   * because the link is already gone. Photon sync, prescription backfill, an
   * eligible review, and a later prior-authorization submit do not put that
   * target back. `linkMedicareBridgeCaseTarget` can link it again.
   */
  unlinkMedicareBridgeCaseTarget: PlatformUnlinkMedicareBridgeCaseTargetPayload;
  /** Edit requestText on an OPEN request owned by the acting clinician. Wrong owner / closed / unknown id is not-found. */
  updateDocumentRequest: PlatformDocumentRequest;
  /**
   * Sets the height on the patient's EHR profile (Healthie) and stores nothing here. Safe to
   * retry. An EHR rejection returns a null externalId with its messages; an EHR transport or
   * GraphQL failure fails the call.
   */
  updateEhrHeight: PlatformUpdateEhrHeightPayload;
  /**
   * Updates one of the patient's measurement entries in the EHR (Healthie) and stores nothing here.
   * First reads the entry, and writes only when it is a measurement the patient posted; otherwise
   * BAD_USER_INPUT and nothing is written. Safe to retry. An EHR rejection returns a null entryId
   * with its messages; an EHR transport or GraphQL failure, on the read or the write, fails the call
   * with INTERNAL_SERVER_ERROR. A blank patient or entry id is BAD_USER_INPUT.
   */
  updateEhrMetricEntry: PlatformUpdateEhrMetricEntryPayload;
  /** Reschedule or update appointment fields. */
  updateHealthieAppointment: PlatformUpdateHealthieAppointmentResponse;
  /** Update a document's Healthie document ID after successful sync */
  updateHealthieDocumentId: PlatformDocument;
  /** Update an existing patient's profile in Healthie. */
  updateHealthiePatient: PlatformUpdateHealthiePatientResponse;
  /** Update a journal entry of any writable type. It doesn't write steps or sleep, so JournalEntryType has no value for them; steps and sleep totals go through upsertDailyTotal. Ownership is the caller's to check (patient-app-api's guard reads `patientJournalEntry` first); this mutation isn't access control. The stored entry is read from the store its type is served from, and the update written there: an `nh-` id, or a Healthie id of a type served from NaviHealth, is updated in NaviHealth and returned with its `nh-` id. Errors: `BAD_USER_INPUT` when no writable entry has this id (including a legacy water id NaviHealth has merged into its day, and another patient's entry when `patientRegistryId` is set), when `patientRegistryId` is empty or has no Healthie user id in the patient registry, when `entryType` isn't the stored entry's type, or when `image.data` is over the limit. `INTERNAL_SERVER_ERROR` when the patient registry lookup of `patientRegistryId` fails; when the lookup of a Healthie user id's patient registry id fails, the write goes to Healthie. While the entry's type is served from NaviHealth: `NAVIHEALTH_UNAVAILABLE` when NaviHealth is unreachable, times out or answers 5xx (the write may still have landed); `NAVIHEALTH_REQUEST_FAILED` when NaviHealth refuses it; `NOT_FOUND` when NaviHealth doesn't know the patient; `CONFLICT` when NaviHealth reports a conflicting write. There is no fallback to Healthie. */
  updateJournalEntry: PlatformJournalEntry;
  /** Replace the current Patient App allergy response. */
  updateMedicalHistoryAllergies: PlatformMedicalHistory;
  /** Replace the current controlled condition response. */
  updateMedicalHistoryConditions: PlatformMedicalHistory;
  /** Replace the current structured social-history response. */
  updateMedicalHistorySocialHistory: PlatformMedicalHistory;
  /** Replace the current surgeries and hospitalizations response. */
  updateMedicalHistorySurgeriesHospitalizations: PlatformMedicalHistory;
  updateMedication: PlatformMedication;
  /**
   * Replace the patient-entered fields of a dose the patient logged. Every field
   * in the input is written, so an omitted optional field is cleared. The log stays
   * on its medication.
   *
   * Works on logs under inactive supplies. `firstDose`, `dosesTaken` and the
   * next-dose forecast are recomputed on read, so they follow the edit.
   *
   * Rejects with not-found when `logId` is unknown, already removed, or belongs to
   * another patient's medication. Rejects with a 400 when `doseDate` or
   * `doseTime` is malformed. Idempotent: a retry writes the same values.
   */
  updateMedicationTake: PlatformUpdateMedicationTakePayload;
  /**
   * Apply captured onboarding-interview facts to the patient's base profile
   * (append/patch — a captured field overwrites its column; completeness recomputed).
   * One atomic statement, safe to retry. A capture with `sourceAt` older than the
   * `sourceAt` already stored for its field is skipped for that field only, so a late
   * retry of an earlier turn never overwrites a newer answer.
   */
  updatePatientBaseProfile: PlatformPatientBaseProfile;
  /** Update the calling provider's own note. Fails if the note belongs to a different provider. */
  updatePatientNote: PlatformPatientNote;
  /**
   * Maps canonical race and ethnicity values to Healthie's demographic codes and updates only the
   * supplied fields. At least one field must be supplied. Setting an existing value is an idempotent
   * no-op. Exposed only to trusted program domains.
   */
  updatePatientRaceAndEthnicity: PlatformPatient;
  /** Updates Airtable first, then asks CBF to re-read this provider from Airtable immediately. */
  updateProviderBookingSettings: PlatformUpdateProviderBookingSettingsPayload;
  /**
   * Sets the reason on an existing Healthie referral, only when referralId is one of
   * input.patient's referrals to referringPhysicianId. Safe to retry. Healthie
   * rejections come back as messages.
   *
   * Errors: BAD_USER_INPUT for a blank externalId, referralId or referringPhysicianId;
   * REFERRING_PHYSICIAN_NOT_LINKED when the referral is not the patient's referral to
   * that physician; UPSTREAM_UNAVAILABLE when Healthie fails or errors, including the
   * ownership read.
   */
  updateReferralReason: PlatformUpdateReferralReasonPayload;
  /**
   * Updates a referring physician in Healthie, only when it is one of input.patient's
   * referring physicians. Healthie rejections come back as messages. Safe to retry.
   * Healthie dedups physicians, so the record may be shared with other patients.
   *
   * Errors: BAD_USER_INPUT for a blank id or externalId; REFERRING_PHYSICIAN_NOT_LINKED
   * when the physician is not one of the patient's referring physicians; UPSTREAM_UNAVAILABLE
   * when Healthie fails or errors.
   */
  updateReferringPhysician: PlatformUpdateReferringPhysicianPayload;
  /** Set a patient's running total for one local day: one entry per patient and date for WATER_INTAKE, and per patient, date and `thirdPartySource` for STEPS, which a second call updates instead of adding another; a steps write never changes another source's entry. A new water entry is created at noon of the local day. A new steps entry is created at noon of the local day with no description; with `journaling-steps-original-shape` on, a steps entry is dated at the start of the local day and described `Synced from <source>` (`Apple Health` for apple_health, `Health Connect` for google_fit, none otherwise), as device sync writes one, and an update sets both too. For water only WaterIntakeEntry entries count, so a MetricEntry in the Water category is left alone. Concurrent calls can both create while Healthie is the store; later calls remove the duplicates. Errors: `BAD_USER_INPUT` when neither id is set, or when `patientRegistryId` is empty or has no Healthie user id in the patient registry, when `date` isn't a YYYY-MM-DD date, when `timezone` isn't an IANA timezone, when `value` is negative or, for STEPS, not a whole number, when a STEPS or SLEEP_DURATION `thirdPartySource` isn't one Healthie accepts (`apple_health`, `google_fit`, `fitbit`), when only one of `externalIdType` and `externalId` is set, or when `externalId` is empty, all whitespace or over 255 characters. For WATER_INTAKE and STEPS, `externalIdType` and `externalId` are recorded, not a key: a retry sets the total again. SLEEP_DURATION is one entry per patient, date and session (`externalId`), last write wins: a repeat sync of a session updates its entry, and two sessions on one night are two entries on Healthie; while the type is served from NaviHealth each session is still stored on its own, but reads serve one entry per sleep day; `BAD_USER_INPUT` when its `externalIdType` and `externalId` are missing, when `externalIdType` is LOSEIT_FOOD_LOG, or when `endTime` is missing. While the type is served from NaviHealth, a sleep write that leaves the day empty returns a zero-valued entry under the day's id, as a zeroed total does on Healthie. Written to the store the type is served from. `INTERNAL_SERVER_ERROR` when the patient registry lookup of `patientRegistryId` fails; when the lookup of a Healthie user id's patient registry id fails, the write goes to Healthie. While the entry's type is served from NaviHealth: `NAVIHEALTH_UNAVAILABLE` when NaviHealth is unreachable, times out or answers 5xx (the write may still have landed); `NAVIHEALTH_REQUEST_FAILED` when NaviHealth refuses it; `NOT_FOUND` when NaviHealth doesn't know the patient; `CONFLICT` when NaviHealth reports a conflicting write. There is no fallback to Healthie. */
  upsertDailyTotal: PlatformUpsertDailyTotalPayload;
  /** Upsert patient nutrient goals (provider action) */
  upsertPatientNutrientGoals: PlatformPatientNutrientGoals;
  /** Upsert a session goal (provider action) - creates new if no ID, updates existing if ID provided */
  upsertSessionGoal: PlatformSessionGoal;
};


export type PlatformMutationAddHealthieStripeCardArgs = {
  input: PlatformAddHealthieStripeCardInput;
};


export type PlatformMutationAddPatientAdditionalProviderArgs = {
  input: PlatformAddPatientAdditionalProviderInput;
};


export type PlatformMutationApplyHealthieTagsArgs = {
  patientId: Scalars['ID']['input'];
  tagIds: Array<Scalars['ID']['input']>;
};


export type PlatformMutationApproveAccessCarePlanArgs = {
  input: PlatformApproveAccessCarePlanInput;
};


export type PlatformMutationAssignAccessNpArgs = {
  input: PlatformAssignAccessNpInput;
};


export type PlatformMutationAssignDietitianArgs = {
  input: PlatformAssignDietitianInput;
};


export type PlatformMutationAssignMedicareBridgeCaseArgs = {
  input: PlatformAssignMedicareBridgeCaseInput;
};


export type PlatformMutationAssignPrescriberArgs = {
  input: PlatformAssignPrescriberInput;
};


export type PlatformMutationAttachInsuranceCardImagesArgs = {
  input: PlatformAttachInsuranceCardImagesInput;
};


export type PlatformMutationAttachInsurancePolicyArgs = {
  input: PlatformAttachInsurancePolicyInput;
};


export type PlatformMutationAttestDocumentVersionArgs = {
  input: PlatformAttestDocumentVersionInput;
};


export type PlatformMutationBackfillMarketingSmsOptInsArgs = {
  input: PlatformBackfillMarketingSmsOptInsInput;
};


export type PlatformMutationBackfillPrescriptionDrugNameCleanArgs = {
  prescriptionIds: Array<Scalars['ID']['input']>;
};


export type PlatformMutationBackfillTrackedMedicationsArgs = {
  externalIds: Array<Scalars['ID']['input']>;
};


export type PlatformMutationBookAppointmentArgs = {
  input: PlatformBookAppointmentInput;
};


export type PlatformMutationBookGlp1AppointmentArgs = {
  input: PlatformBookGlp1AppointmentInput;
};


export type PlatformMutationBookGlp1FollowUpAppointmentArgs = {
  input: PlatformBookGlp1FollowUpAppointmentInput;
};


export type PlatformMutationBookMntInitialVisitArgs = {
  input: PlatformBookMntInitialVisitInput;
};


export type PlatformMutationCancelChatHistoryImportArgs = {
  runId: Scalars['String']['input'];
};


export type PlatformMutationCancelHealthieAppointmentArgs = {
  id: Scalars['ID']['input'];
};


export type PlatformMutationCancelPatientNavihealthBackfillArgs = {
  input?: InputMaybe<PlatformCancelPatientNavihealthBackfillInput>;
};


export type PlatformMutationCancelProviderEmailOriginBackfillArgs = {
  input: PlatformCancelProviderEmailOriginBackfillInput;
};


export type PlatformMutationCancelProviderNavihealthBackfillArgs = {
  input?: InputMaybe<PlatformCancelProviderNavihealthBackfillInput>;
};


export type PlatformMutationChangeAppointmentStatusArgs = {
  input: PlatformChangeAppointmentStatusInput;
};


export type PlatformMutationChargeAppointmentFeeArgs = {
  input: PlatformChargeAppointmentFeeInput;
};


export type PlatformMutationClearGlp1NotPrescribedDecisionArgs = {
  input: PlatformClearGlp1NotPrescribedDecisionInput;
};


export type PlatformMutationCloseDocumentRequestArgs = {
  input: PlatformCloseDocumentRequestInput;
};


export type PlatformMutationCloseMedicareBridgeCaseArgs = {
  input: PlatformCloseMedicareBridgeCaseInput;
};


export type PlatformMutationCompleteAgendaItemArgs = {
  agendaItemId: Scalars['ID']['input'];
  patientId: Scalars['String']['input'];
  responseText?: InputMaybe<Scalars['String']['input']>;
};


export type PlatformMutationCompleteBookingSessionArgs = {
  input: PlatformCompleteBookingSessionInput;
};


export type PlatformMutationCompleteCardSetupArgs = {
  input: PlatformCompleteCardSetupInput;
};


export type PlatformMutationCompleteGlp1PrescriptionTaskArgs = {
  input: PlatformCompleteGlp1PrescriptionTaskInput;
};


export type PlatformMutationCompleteHealthieCheckoutArgs = {
  input: PlatformCompleteHealthieCheckoutInput;
};


export type PlatformMutationConfirmChatHistoryImportArgs = {
  manifestKey: Scalars['String']['input'];
  runId: Scalars['String']['input'];
};


export type PlatformMutationConfirmDocumentUploadArgs = {
  input: PlatformConfirmUploadInput;
};


export type PlatformMutationCorrectAccessReferralEvidenceArgs = {
  input: PlatformCorrectAccessReferralEvidenceInput;
};


export type PlatformMutationCorrectMedicareBridgeIdentificationArgs = {
  input: PlatformCorrectMedicareBridgeIdentificationInput;
};


export type PlatformMutationCreateBookingSessionArgs = {
  input: PlatformCreateBookingSessionInput;
};


export type PlatformMutationCreateCardSetupIntentArgs = {
  sessionId: Scalars['ID']['input'];
};


export type PlatformMutationCreateCohortSeriesArgs = {
  input: PlatformCreateCohortSeriesInput;
};


export type PlatformMutationCreateDocumentRequestArgs = {
  input: PlatformCreateDocumentRequestInput;
};


export type PlatformMutationCreateEhrChartingNoteDraftArgs = {
  input: PlatformCreateEhrChartingNoteDraftInput;
};


export type PlatformMutationCreateEhrFormResponseArgs = {
  input: PlatformCreateEhrFormResponseInput;
};


export type PlatformMutationCreateEhrWeightEntryArgs = {
  input: PlatformCreateEhrWeightEntryInput;
};


export type PlatformMutationCreateHealthMetricEntryArgs = {
  input: PlatformCreateHealthMetricEntryInput;
};


export type PlatformMutationCreateHealthieAppointmentArgs = {
  input: PlatformCreateHealthieAppointmentInput;
};


export type PlatformMutationCreateHealthiePatientArgs = {
  input: PlatformCreateHealthiePatientInput;
};


export type PlatformMutationCreateJournalEntryArgs = {
  input: PlatformCreateJournalEntryInput;
};


export type PlatformMutationCreateJournalEntryCommentArgs = {
  input: PlatformCreateJournalEntryCommentInput;
};


export type PlatformMutationCreateMedicationArgs = {
  input: PlatformCreateMedicationInput;
};


export type PlatformMutationCreateOnboardingEntryLinkArgs = {
  input: PlatformCreateOnboardingEntryLinkInput;
};


export type PlatformMutationCreatePatientArgs = {
  input: PlatformCreatePatientInput;
};


export type PlatformMutationCreatePatientDocumentArgs = {
  input: PlatformCreatePatientDocumentInput;
};


export type PlatformMutationCreatePatientNoteArgs = {
  input: PlatformCreatePatientNoteInput;
};


export type PlatformMutationCreateReferringPhysicianArgs = {
  input: PlatformCreateReferringPhysicianInput;
};


export type PlatformMutationCreateSupportConversationArgs = {
  input: PlatformCreateSupportConversationInput;
};


export type PlatformMutationDeactivateCohortSeriesArgs = {
  id: Scalars['ID']['input'];
};


export type PlatformMutationDeactivateEnrollmentArgs = {
  id: Scalars['ID']['input'];
};


export type PlatformMutationDeleteDocumentArgs = {
  input: PlatformDeleteDocumentInput;
};


export type PlatformMutationDeleteEhrMetricEntryArgs = {
  input: PlatformDeleteEhrMetricEntryInput;
};


export type PlatformMutationDeleteHealthieStripeCardArgs = {
  cardId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type PlatformMutationDeleteJournalEntryArgs = {
  id: Scalars['ID']['input'];
  patientRegistryId?: InputMaybe<Scalars['ID']['input']>;
};


export type PlatformMutationDeleteJournalEntryCommentArgs = {
  id: Scalars['ID']['input'];
  patientRegistryId: Scalars['ID']['input'];
};


export type PlatformMutationDeleteMedicationArgs = {
  id: Scalars['ID']['input'];
};


export type PlatformMutationDeletePatientExternalIdArgs = {
  input: PlatformDeletePatientExternalIdInput;
};


export type PlatformMutationDeletePatientNoteArgs = {
  id: Scalars['ID']['input'];
};


export type PlatformMutationDeleteProviderExternalIdArgs = {
  input: PlatformDeleteProviderExternalIdInput;
};


export type PlatformMutationDeleteReferringPhysicianArgs = {
  input: PlatformDeleteReferringPhysicianInput;
};


export type PlatformMutationDeleteRudderstackSyncEventArgs = {
  eventName: Scalars['String']['input'];
  prescriptionId: Scalars['ID']['input'];
};


export type PlatformMutationEditAccessCarePlanArgs = {
  input: PlatformEditAccessCarePlanInput;
};


export type PlatformMutationEnsureGlp1EnrollmentArgs = {
  input: PlatformEnsureGlp1EnrollmentInput;
};


export type PlatformMutationEnsureGlp1PrescriptionTaskArgs = {
  input: PlatformEnsureGlp1PrescriptionTaskInput;
};


export type PlatformMutationEnsurePatientDietitianArgs = {
  input: PlatformEnsurePatientDietitianInput;
};


export type PlatformMutationEnsurePatientPrescriberArgs = {
  input: PlatformEnsurePatientPrescriberInput;
};


export type PlatformMutationGeneratePatientPriorAuthDocumentsArgs = {
  input: PlatformGeneratePatientPriorAuthDocumentsInput;
};


export type PlatformMutationGetDocumentUploadUrlArgs = {
  input: PlatformGetUploadUrlInput;
};


export type PlatformMutationGoBackOnboardingStepArgs = {
  input: PlatformGoBackOnboardingStepInput;
};


export type PlatformMutationHoldAppointmentSlotArgs = {
  input: PlatformHoldAppointmentSlotInput;
};


export type PlatformMutationHoldDietitianAppointmentArgs = {
  input: PlatformHoldDietitianAppointmentInput;
};


export type PlatformMutationHoldGlp1AppointmentArgs = {
  input: PlatformHoldGlp1AppointmentInput;
};


export type PlatformMutationIngestGlucoseReadingsArgs = {
  input: PlatformIngestGlucoseReadingsInput;
};


export type PlatformMutationLinkMedicareBridgeCaseTargetArgs = {
  input: PlatformLinkMedicareBridgeCaseTargetInput;
};


export type PlatformMutationLinkReferringPhysicianArgs = {
  input: PlatformLinkReferringPhysicianInput;
};


export type PlatformMutationLogMedicationTakeArgs = {
  input: PlatformLogMedicationTakeInput;
};


export type PlatformMutationMarkAccessReferralAwaitingRejectionArgs = {
  input: PlatformMarkAccessReferralAwaitingRejectionInput;
};


export type PlatformMutationMarkBpCuffConnectedArgs = {
  healthieUserId: Scalars['ID']['input'];
};


export type PlatformMutationMarkSessionGoalCompleteArgs = {
  input: PlatformMarkSessionGoalCompleteInput;
};


export type PlatformMutationMarkSupportConversationReadArgs = {
  input: PlatformMarkSupportConversationReadInput;
};


export type PlatformMutationMarkTrackedMedicationViewedArgs = {
  medicationId: Scalars['ID']['input'];
  patientHealthieId: Scalars['ID']['input'];
};


export type PlatformMutationMergeProvidersArgs = {
  input: PlatformMergeProvidersInput;
};


export type PlatformMutationPausePatientBaseProfileArgs = {
  healthieUserId: Scalars['ID']['input'];
};


export type PlatformMutationPlaceLabOrderArgs = {
  input: PlatformPlaceLabOrderInput;
};


export type PlatformMutationPrepareCrossSellBookingLinkArgs = {
  patientHealthieId: Scalars['ID']['input'];
  sourceAppointmentHealthieId: Scalars['ID']['input'];
};


export type PlatformMutationPrepareSupportAttachmentArgs = {
  input: PlatformPrepareSupportAttachmentInput;
};


export type PlatformMutationProvisionAccessEnrollmentArgs = {
  input: PlatformProvisionAccessEnrollmentInput;
};


export type PlatformMutationPublishProviderDocumentVersionArgs = {
  input: PlatformPublishProviderDocumentVersionInput;
};


export type PlatformMutationPublishProviderEventArgs = {
  input: PlatformPublishProviderEventInput;
};


export type PlatformMutationReassignPrimaryProviderArgs = {
  input: PlatformReassignPrimaryProviderInput;
};


export type PlatformMutationRecordAccessCareUpdateFaxArgs = {
  input: PlatformRecordAccessCareUpdateFaxInput;
};


export type PlatformMutationRecordAccessCmsUnalignmentArgs = {
  input: PlatformRecordAccessCmsUnalignmentInput;
};


export type PlatformMutationRecordAccessCommsOptOutArgs = {
  input: PlatformRecordAccessCommsOptOutInput;
};


export type PlatformMutationRecordAccessDocumentLabArgs = {
  input: PlatformRecordAccessDocumentLabInput;
};


export type PlatformMutationRecordAccessReferralClinicalDataArgs = {
  input: PlatformRecordAccessReferralClinicalDataInput;
};


export type PlatformMutationRecordAccessReferralOutcomeArgs = {
  input: PlatformRecordAccessReferralOutcomeInput;
};


export type PlatformMutationRecordBenefitsRequestDiagnosesArgs = {
  input: PlatformRecordBenefitsRequestDiagnosesInput;
};


export type PlatformMutationRecordBloodPressureArgs = {
  input: PlatformRecordBloodPressureInput;
};


export type PlatformMutationRecordConsentSnapshotArgs = {
  input: PlatformRecordConsentSnapshotInput;
};


export type PlatformMutationRecordGlp1NotPrescribedDecisionArgs = {
  input: PlatformRecordGlp1NotPrescribedDecisionInput;
};


export type PlatformMutationRecordMeasurementArgs = {
  input: PlatformRecordMeasurementInput;
};


export type PlatformMutationRecordMedicareBridgeMedicationAccessArgs = {
  input: PlatformRecordMedicareBridgeMedicationAccessInput;
};


export type PlatformMutationRecordMedicareBridgePatientCommunicationArgs = {
  input: PlatformRecordMedicareBridgePatientCommunicationInput;
};


export type PlatformMutationRecordPatientAcquisitionSourceArgs = {
  input: PlatformRecordPatientAcquisitionSourceInput;
};


export type PlatformMutationRecordPatientBookedByGuardianArgs = {
  input: PlatformRecordPatientBookedByGuardianInput;
};


export type PlatformMutationRecordPatientMedicalBackgroundArgs = {
  input: PlatformRecordPatientMedicalBackgroundInput;
};


export type PlatformMutationRecordPatientPharmacyCoverageArgs = {
  input: PlatformRecordPatientPharmacyCoverageInput;
};


export type PlatformMutationRecordPatientReferralArgs = {
  input: PlatformRecordPatientReferralInput;
};


export type PlatformMutationRecordPatientReportedCareTeamMemberArgs = {
  input: PlatformRecordPatientReportedCareTeamMemberInput;
};


export type PlatformMutationRecordPatientReportedHeightArgs = {
  input: PlatformRecordPatientVitalInput;
};


export type PlatformMutationRecordPatientReportedWeightArgs = {
  input: PlatformRecordPatientVitalInput;
};


export type PlatformMutationRecordPrescriptionPickupArgs = {
  input: PlatformRecordPrescriptionPickupInput;
};


export type PlatformMutationRefreshPharmacyBenefitCoverageArgs = {
  input: PlatformRefreshPharmacyBenefitCoverageInput;
};


export type PlatformMutationRegisterPatientArgs = {
  input: PlatformRegisterPatientInput;
};


export type PlatformMutationRegisterProviderArgs = {
  input: PlatformRegisterProviderInput;
};


export type PlatformMutationRegisterProviderFromHealthieArgs = {
  input: PlatformRegisterProviderFromHealthieInput;
};


export type PlatformMutationReleaseAppointmentHoldArgs = {
  input: PlatformReleaseAppointmentHoldInput;
};


export type PlatformMutationRemoveMedicationTakeArgs = {
  logId: Scalars['ID']['input'];
  patientHealthieId: Scalars['ID']['input'];
};


export type PlatformMutationReplyToSupportConversationArgs = {
  input: PlatformReplyToSupportConversationInput;
};


export type PlatformMutationRequestProviderDocumentUploadArgs = {
  input: PlatformRequestProviderDocumentUploadInput;
};


export type PlatformMutationResolveAccessReviewArgs = {
  input: PlatformResolveAccessReviewInput;
};


export type PlatformMutationResolveCareEscalationArgs = {
  patientHealthieId: Scalars['ID']['input'];
  resolvedBy: Scalars['String']['input'];
};


export type PlatformMutationResolvePatientEmailConflictArgs = {
  input: PlatformResolvePatientEmailConflictInput;
};


export type PlatformMutationResolvePatientExternalIdConflictArgs = {
  input: PlatformResolvePatientExternalIdConflictInput;
};


export type PlatformMutationResolveProviderEmailConflictArgs = {
  input: PlatformResolveProviderEmailConflictInput;
};


export type PlatformMutationResolveProviderExternalIdConflictArgs = {
  input: PlatformResolveProviderExternalIdConflictInput;
};


export type PlatformMutationResolveSupportConversationArgs = {
  input: PlatformResolveSupportConversationInput;
};


export type PlatformMutationResyncPatientToNavihealthArgs = {
  input: PlatformResyncPatientToNavihealthInput;
};


export type PlatformMutationResyncProviderToNavihealthArgs = {
  input: PlatformResyncProviderToNavihealthInput;
};


export type PlatformMutationRetireProviderDocumentArgs = {
  documentId: Scalars['ID']['input'];
};


export type PlatformMutationRetractPatientReportedCareTeamMemberArgs = {
  input: PlatformRetractPatientReportedCareTeamMemberInput;
};


export type PlatformMutationRetryAccessAlignmentArgs = {
  input: PlatformRetryAccessAlignmentInput;
};


export type PlatformMutationRetryCrmEventsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type PlatformMutationRetryPrescriptionPhotoLinkArgs = {
  token: Scalars['String']['input'];
};


export type PlatformMutationReturnAccessReferralToReviewArgs = {
  input: PlatformReturnAccessReferralToReviewInput;
};


export type PlatformMutationSavePatientInsuranceArgs = {
  input: PlatformSavePatientInsuranceInput;
};


export type PlatformMutationSavePatientOwnedFileArgs = {
  input: PlatformSavePatientOwnedFileInput;
};


export type PlatformMutationSavePaymentMethodArgs = {
  input: PlatformSavePaymentMethodInput;
};


export type PlatformMutationSendChatMessageArgs = {
  input: PlatformSendChatMessageInput;
};


export type PlatformMutationSendCrossSellBookingLinkArgs = {
  patientHealthieId: Scalars['ID']['input'];
  sourceAppointmentHealthieId: Scalars['ID']['input'];
};


export type PlatformMutationSendPrescriptionTakenEventArgs = {
  prescriptionId: Scalars['ID']['input'];
};


export type PlatformMutationSendProviderChatMessageArgs = {
  input: PlatformSendProviderChatMessageInput;
};


export type PlatformMutationSetDefaultHealthieStripeCardArgs = {
  id: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type PlatformMutationSetDefaultTrackedMedicationArgs = {
  medicationId: Scalars['ID']['input'];
  patientHealthieId: Scalars['ID']['input'];
};


export type PlatformMutationSetGlp1PatientPrescriberNotesArgs = {
  input: PlatformSetGlp1PatientPrescriberNotesInput;
};


export type PlatformMutationSetInsurancePolicyCardsArgs = {
  input: PlatformSetInsurancePolicyCardsInput;
};


export type PlatformMutationSetPatientEmergencyContactArgs = {
  input: PlatformSetPatientEmergencyContactInput;
};


export type PlatformMutationSnoozeMedicareBridgeCaseArgs = {
  input: PlatformSnoozeMedicareBridgeCaseInput;
};


export type PlatformMutationStartCardSetupArgs = {
  input: PlatformStartCardSetupInput;
};


export type PlatformMutationStartOnboardingSessionArgs = {
  input: PlatformStartOnboardingSessionInput;
};


export type PlatformMutationStartPatientGlp1JourneyArgs = {
  input: PlatformStartPatientGlp1JourneyInput;
};


export type PlatformMutationStartPatientNavihealthBackfillArgs = {
  input: PlatformStartPatientNavihealthBackfillInput;
};


export type PlatformMutationStartPatientOnboardingSessionArgs = {
  input: PlatformStartPatientOnboardingSessionInput;
};


export type PlatformMutationStartProviderEmailOriginBackfillArgs = {
  input: PlatformStartProviderEmailOriginBackfillInput;
};


export type PlatformMutationStartProviderNavihealthBackfillArgs = {
  input: PlatformStartProviderNavihealthBackfillInput;
};


export type PlatformMutationSubmitAccessAlignmentArgs = {
  input: PlatformSubmitAccessAlignmentInput;
};


export type PlatformMutationSubmitAccessEligibilityArgs = {
  input: PlatformSubmitAccessEligibilityInput;
};


export type PlatformMutationSubmitAccessRequestArgs = {
  input: PlatformSubmitAccessRequestInput;
};


export type PlatformMutationSubmitBpCuffOrderArgs = {
  input: PlatformSubmitBpCuffOrderInput;
};


export type PlatformMutationSubmitEhrChartingNoteArgs = {
  input: PlatformSubmitEhrChartingNoteInput;
};


export type PlatformMutationSubmitGlp1PriorAuthArgs = {
  input: PlatformSubmitGlp1PriorAuthInput;
};


export type PlatformMutationSubmitGlp1ScreeningArgs = {
  input: PlatformSubmitGlp1ScreeningInput;
};


export type PlatformMutationSubmitMedicareBridgeReviewArgs = {
  input: PlatformSubmitMedicareBridgeReviewInput;
};


export type PlatformMutationSubmitOnboardingBundleArgs = {
  input: PlatformSubmitOnboardingBundleInput;
};


export type PlatformMutationSubmitOnboardingStepArgs = {
  input: PlatformSubmitOnboardingStepInput;
};


export type PlatformMutationSubmitPatientReferralArgs = {
  input: PlatformSubmitPatientReferralInput;
};


export type PlatformMutationSubmitPrescriptionPhotoLinkArgs = {
  input: PlatformSubmitPrescriptionPhotoLinkInput;
};


export type PlatformMutationSyncHealthMetricsArgs = {
  input: PlatformSyncHealthMetricsInput;
};


export type PlatformMutationSyncPatientToZusArgs = {
  input: PlatformSyncPatientToZusInput;
};


export type PlatformMutationSyncPhotonPrescriptionsArgs = {
  prescriptionIds: Array<Scalars['ID']['input']>;
};


export type PlatformMutationSyncPriorAuthorizationsFromDevelopArgs = {
  input: PlatformSyncPriorAuthorizationsFromDevelopInput;
};


export type PlatformMutationSyncProvidersFromAirtableArgs = {
  input: PlatformSyncProvidersFromAirtableInput;
};


export type PlatformMutationTriggerChatBackfillArgs = {
  pairs: Array<PlatformChatBackfillPairInput>;
};


export type PlatformMutationTriggerChatHistoryImportArgs = {
  cutoverAt: Scalars['String']['input'];
  maxChannels?: InputMaybe<Scalars['Int']['input']>;
  maxInFlight?: InputMaybe<Scalars['Int']['input']>;
  maxMessageLength: Scalars['Int']['input'];
  onlyUnsynced?: InputMaybe<Scalars['Boolean']['input']>;
  runId: Scalars['String']['input'];
  startCursor?: InputMaybe<PlatformChatHistoryImportCursorInput>;
};


export type PlatformMutationTriggerChatHistoryScanArgs = {
  cutoverAt: Scalars['String']['input'];
  maxChannels?: InputMaybe<Scalars['Int']['input']>;
  maxInFlight?: InputMaybe<Scalars['Int']['input']>;
  maxMessageLength: Scalars['Int']['input'];
  runId: Scalars['String']['input'];
};


export type PlatformMutationTriggerPrescriptionBackfillArgs = {
  input: PlatformPrescriptionBackfillInput;
};


export type PlatformMutationUnlinkMedicareBridgeCaseTargetArgs = {
  input: PlatformUnlinkMedicareBridgeCaseTargetInput;
};


export type PlatformMutationUpdateDocumentRequestArgs = {
  input: PlatformUpdateDocumentRequestInput;
};


export type PlatformMutationUpdateEhrHeightArgs = {
  input: PlatformUpdateEhrHeightInput;
};


export type PlatformMutationUpdateEhrMetricEntryArgs = {
  input: PlatformUpdateEhrMetricEntryInput;
};


export type PlatformMutationUpdateHealthieAppointmentArgs = {
  input: PlatformUpdateHealthieAppointmentInput;
};


export type PlatformMutationUpdateHealthieDocumentIdArgs = {
  input: PlatformUpdateHealthieDocumentIdInput;
};


export type PlatformMutationUpdateHealthiePatientArgs = {
  input: PlatformUpdateHealthiePatientInput;
};


export type PlatformMutationUpdateJournalEntryArgs = {
  input: PlatformUpdateJournalEntryInput;
};


export type PlatformMutationUpdateMedicalHistoryAllergiesArgs = {
  input: PlatformUpdateMedicalHistoryAllergiesInput;
};


export type PlatformMutationUpdateMedicalHistoryConditionsArgs = {
  input: PlatformUpdateMedicalHistoryConditionsInput;
};


export type PlatformMutationUpdateMedicalHistorySocialHistoryArgs = {
  input: PlatformUpdateMedicalHistorySocialHistoryInput;
};


export type PlatformMutationUpdateMedicalHistorySurgeriesHospitalizationsArgs = {
  input: PlatformUpdateMedicalHistorySurgeriesHospitalizationsInput;
};


export type PlatformMutationUpdateMedicationArgs = {
  input: PlatformUpdateMedicationInput;
};


export type PlatformMutationUpdateMedicationTakeArgs = {
  input: PlatformUpdateMedicationTakeInput;
};


export type PlatformMutationUpdatePatientBaseProfileArgs = {
  input: PlatformUpdatePatientBaseProfileInput;
};


export type PlatformMutationUpdatePatientNoteArgs = {
  input: PlatformUpdatePatientNoteInput;
};


export type PlatformMutationUpdatePatientRaceAndEthnicityArgs = {
  input: PlatformUpdatePatientRaceAndEthnicityInput;
};


export type PlatformMutationUpdateProviderBookingSettingsArgs = {
  input: PlatformUpdateProviderBookingSettingsInput;
};


export type PlatformMutationUpdateReferralReasonArgs = {
  input: PlatformUpdateReferralReasonInput;
};


export type PlatformMutationUpdateReferringPhysicianArgs = {
  input: PlatformUpdateReferringPhysicianInput;
};


export type PlatformMutationUpsertDailyTotalArgs = {
  input: PlatformUpsertDailyTotalInput;
};


export type PlatformMutationUpsertPatientNutrientGoalsArgs = {
  input: PlatformUpsertPatientNutrientGoalsInput;
};


export type PlatformMutationUpsertSessionGoalArgs = {
  input: PlatformUpsertSessionGoalInput;
};

/** A numeric input. */
export type PlatformNumberField = {
  __typename?: 'NumberField';
  /** Optional helper text shown beneath the field. */
  helperText?: Maybe<Scalars['String']['output']>;
  /** Field id; the key to submit this value under. */
  id: Scalars['String']['output'];
  /** Label shown to the patient. */
  label: Scalars['String']['output'];
  /** Inclusive maximum accepted value, if bounded. */
  max?: Maybe<Scalars['Float']['output']>;
  /** Inclusive minimum accepted value, if bounded. */
  min?: Maybe<Scalars['Float']['output']>;
  /** Whether the patient must answer before advancing. */
  required: Scalars['Boolean']['output'];
  /** Optional unit label (e.g. `lbs`). */
  unit?: Maybe<Scalars['String']['output']>;
};

/** A single nutrient goal with quantity and unit */
export type PlatformNutrientGoal = {
  __typename?: 'NutrientGoal';
  /** Target quantity */
  quantity: Scalars['Float']['output'];
  /** Type of nutrient */
  type: PlatformNutrientType;
  /** Unit of measurement (e.g., 'kcal', 'g') */
  unit: Scalars['String']['output'];
};

/** Input for a single nutrient goal */
export type PlatformNutrientGoalInput = {
  /** Target quantity */
  quantity: Scalars['Float']['input'];
  /** Type of nutrient */
  type: PlatformNutrientType;
  /** Unit of measurement */
  unit: Scalars['String']['input'];
};

/**
 * Supported nutrient/metric types for goals.
 *
 * This enum is a SUPERSET of NutritionalMetricName from the journaling domain.
 * Values should match NutritionalMetricName to enable cross-domain consistency.
 *
 * To add a new metric type:
 * 1. Add the value here with appropriate documentation
 * 2. Regenerate types: pnpm --filter=@berry-street/goals-domain generate:types
 * 3. Rebuild the gateway: pnpm --filter=@berry-street/graphql-gateway-domain build
 * 4. If the metric should also be trackable in journal entries, add it to
 *    NutritionalMetricName in the journaling domain as well.
 */
export enum PlatformNutrientType {
  /** Total energy content (kcal) */
  Calories = 'CALORIES',
  /** Total carbohydrate content (g) */
  Carbohydrates = 'CARBOHYDRATES',
  /** Total fat content (g) */
  Fat = 'FAT',
  /** Dietary fiber content (g) */
  Fiber = 'FIBER',
  /** Total protein content (g) */
  Protein = 'PROTEIN',
  /** Saturated fat content (g) */
  SaturatedFat = 'SATURATED_FAT'
}

/** A single nutritional metric with its value and unit of measurement */
export type PlatformNutritionalMetric = {
  __typename?: 'NutritionalMetric';
  /** Name of the nutritional metric */
  name: PlatformNutritionalMetricName;
  /** Unit of measurement (automatically determined by metric name) */
  unit: Scalars['String']['output'];
  /** Numeric value of the metric */
  value: Scalars['Float']['output'];
};

/** Input for a single nutritional metric when creating an entry */
export type PlatformNutritionalMetricInput = {
  /** Name of the nutritional metric */
  name: PlatformNutritionalMetricName;
  /** Numeric value of the metric */
  value: Scalars['Float']['input'];
};

/** Supported nutritional metric names */
export enum PlatformNutritionalMetricName {
  /** Total energy content (kcal) */
  Calories = 'CALORIES',
  /** Total carbohydrate content (g) */
  Carbohydrates = 'CARBOHYDRATES',
  /** Total fat content (g) */
  Fat = 'FAT',
  /** Dietary fiber content (g) */
  Fiber = 'FIBER',
  /** Total protein content (g) */
  Protein = 'PROTEIN',
  /** Saturated fat content (g) */
  SaturatedFat = 'SATURATED_FAT'
}

/**
 * A fixed set of catalog grants filed together for one person. The contents are
 * defined server-side and can't be edited by the requester. The suite is
 * approved as a whole, so its tickets need no per-request approval.
 */
export type PlatformOnboardingBundle = {
  __typename?: 'OnboardingBundle';
  description: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  id: PlatformOnboardingBundleId;
  items: Array<PlatformOnboardingBundleItem>;
};

/** Stable identifiers for every onboarding bundle. */
export enum PlatformOnboardingBundleId {
  /** Standard access for a new engineer working on Berry Street code. */
  Engineer = 'ENGINEER'
}

/** One fixed grant in an onboarding bundle. */
export type PlatformOnboardingBundleItem = {
  __typename?: 'OnboardingBundleItem';
  /** The access level granted. Null for services without access levels. */
  accessLevel?: Maybe<Scalars['String']['output']>;
  /** Fixed per-service settings, in catalog field order. */
  details: Array<PlatformOnboardingBundleItemDetail>;
  displayName: Scalars['String']['output'];
  /** What IT must confirm before granting, e.g. HIPAA training. Null when nothing. */
  prerequisite?: Maybe<Scalars['String']['output']>;
  serviceId: PlatformServiceId;
};

/** A label/value pair describing a fixed setting on a bundle item, e.g. which AWS accounts. */
export type PlatformOnboardingBundleItemDetail = {
  __typename?: 'OnboardingBundleItemDetail';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/**
 * A business outcome committed by a step's action — a booking or enrollment.
 * Beyond identity, carries the patient's ad-attribution match keys (email,
 * name, DOB, address) snapshotted at commit time, so the client can attach
 * them to the corresponding ad-platform conversion event (e.g. Meta CAPI)
 * without re-deriving them from whatever step happens to be on screen.
 */
export type PlatformOnboardingConversion = {
  __typename?: 'OnboardingConversion';
  /** Patient city for ad-platform match keys. */
  city: Scalars['String']['output'];
  /** Patient date of birth (YYYY-MM-DD) for ad-platform match keys. */
  dateOfBirth: Scalars['String']['output'];
  /** Patient email for ad-platform match keys. Never used for messaging. */
  email: Scalars['String']['output'];
  /** Patient first name for ad-platform match keys. */
  firstName: Scalars['String']['output'];
  /** Stable identifier for the committed appointment or enrollment. */
  id: Scalars['ID']['output'];
  /** Patient last name for ad-platform match keys. */
  lastName: Scalars['String']['output'];
  /** Patient phone number for ad-platform match keys. */
  phone: Scalars['String']['output'];
  /** Final conversion value in USD for ad destinations, from an MNT prediction or configured program fallback, including any pilot multiplier already applied by the server. Never negative: a loss is sent as zero. Null when neither is available or enabled; absence never means zero. */
  predictedValueUsd?: Maybe<Scalars['Float']['output']>;
  /** Patient state for ad attribution. */
  stateCode: Scalars['String']['output'];
  /** Patient ZIP code for ad-platform match keys. */
  zip: Scalars['String']['output'];
};

export type PlatformOnboardingEntryLink = {
  __typename?: 'OnboardingEntryLink';
  expiresAt: Scalars['DateTime']['output'];
  /** Canonical URL the caller hands to the user. Server-constructed. */
  startUrl: Scalars['String']['output'];
  /** Opaque token. Embedded in the start URL. */
  token: Scalars['String']['output'];
};

/** Start-page policy for the currently registered version of an onboarding flow. */
export type PlatformOnboardingFlowStartPolicy = {
  __typename?: 'OnboardingFlowStartPolicy';
  /** Whether the flow can only start with a previously resolved patient identity. */
  requiresPatientIdentity: Scalars['Boolean']['output'];
};

/**
 * An active or completed patient onboarding session. Holds the flow cursor
 * and append-only history of submitted step data.
 */
export type PlatformOnboardingSession = {
  __typename?: 'OnboardingSession';
  /** Persisted browser analytics identity; null for sessions created without one. Never a session credential. */
  analyticsAnonymousId?: Maybe<Scalars['ID']['output']>;
  /** Referral outreach profile ID, or null for a session not started from a referral. */
  analyticsUserId?: Maybe<Scalars['ID']['output']>;
  /** True when there is a step the patient has advanced past and can rewind to. */
  canGoBack: Scalars['Boolean']['output'];
  /** Populated when status = COMPLETED. */
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * The client's consent-banner state as of the last recordConsentSnapshot
   * call, or null if none has been recorded for this session.
   */
  consentSnapshot?: Maybe<PlatformConsentSnapshot>;
  /** When the session was created. */
  createdAt: Scalars['DateTime']['output'];
  /** ID of the current step. Advances on each submitOnboardingStep call. */
  cursor: Scalars['String']['output'];
  /** ID of the flow this session is running (e.g. `glp-1`). */
  flowId: Scalars['String']['output'];
  /** Version of the flow definition this session started under. */
  flowVersion: Scalars['String']['output'];
  /**
   * Whether this flow version has an out-of-flow landing page the client can
   * send the patient back to. Declared per flow version so the client never
   * branches on `flowVersion` to decide whether a "back to landing" affordance
   * applies.
   */
  hasLanding: Scalars['Boolean']['output'];
  /**
   * Opaque session handle. Carried in the client cookie and passed back
   * on every mutation. Distinct from the internal database PK, which is
   * never exposed.
   */
  id: Scalars['ID']['output'];
  /** Progress through the flow, suitable for driving a progress indicator. */
  progress: PlatformSessionProgress;
  /** Lifecycle state — IN_PROGRESS until a terminal step is reached. */
  status: PlatformOnboardingSessionStatus;
  /**
   * Submitted steps on the session's active path, oldest first. Rows abandoned
   * by back-navigation (e.g. a slot picked on a program path the patient then
   * left) are excluded, matching guard-evaluation scoping.
   */
  submittedSteps: Array<PlatformSubmittedStep>;
  /** When the session was last advanced or rewound. */
  updatedAt: Scalars['DateTime']['output'];
};

/** Lifecycle state of an onboarding session. */
export enum PlatformOnboardingSessionStatus {
  /** Superseded by a newer session for the same patient; no further submissions are accepted. */
  Abandoned = 'ABANDONED',
  /** The patient reached a terminal step; no further submissions are accepted. */
  Completed = 'COMPLETED',
  /** The patient has steps remaining. */
  InProgress = 'IN_PROGRESS'
}

/** A session paired with the step the patient should render next. */
export type PlatformOnboardingSessionWithStep = {
  __typename?: 'OnboardingSessionWithStep';
  /**
   * Conversions committed by the operation that produced this payload. Empty for
   * reads, non-submit operations, and idempotent submit no-ops. The submitted
   * step owns which business outcomes count as conversions and their attribution;
   * clients must not derive either from program-specific submission fields.
   */
  conversions: Array<PlatformOnboardingConversion>;
  /**
   * Transient, non-error message about the transition that just happened (e.g.
   * "already verified — welcome back" when a proven session skips the code
   * screen). Set only on the submit that produced it; never persisted. The
   * client surfaces it as the notice banner on the step it lands on.
   */
  notice?: Maybe<Scalars['String']['output']>;
  /** The session in its current state. */
  session: PlatformOnboardingSession;
  /**
   * The step to render at the session's cursor. Null only for an unknown cursor
   * (e.g. a session on a removed flow version).
   */
  step?: Maybe<PlatformStep>;
  /**
   * Whether the cursor is a terminal (final) step — derived from the flow machine,
   * the single source of terminal-ness. The client renders `step` as a leaf (no
   * submit/advance) when true.
   */
  terminal: Scalars['Boolean']['output'];
};

/**
 * A corrected submission for an earlier completed step, applied as part of
 * submitting the session's current step. The target's normal validation and
 * server-side enrichment run before the current step action. The corrected
 * submission remains the latest value if the current action requests another
 * retry; applying it never moves the cursor independently.
 */
export type PlatformOnboardingStepRecoveryInput = {
  /** Corrected field values for that step, keyed by field id. */
  data: Scalars['JSON']['input'];
  /** The completed step named by `StepRetryRequired.retryStepId`. */
  stepId: Scalars['String']['input'];
};

export type PlatformPaActivityLogEntry = PlatformPaFaxActivity | PlatformPaFollowUpCallActivity;

export type PlatformPaDenialReasonAnalysis = {
  __typename?: 'PaDenialReasonAnalysis';
  categories: Array<Scalars['String']['output']>;
  explanation?: Maybe<Scalars['String']['output']>;
  nextSteps?: Maybe<Scalars['String']['output']>;
  nextStepsExplanation?: Maybe<Scalars['String']['output']>;
};

/**
 * Develop fax activity. `pdfUrl` is a short-lived signed Develop URL — use
 * immediately or re-query `priorAuthExtended`.
 */
export type PlatformPaFaxActivity = {
  __typename?: 'PaFaxActivity';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  pdfUrl: Scalars['String']['output'];
  type: PlatformPaFaxActivityType;
};

export enum PlatformPaFaxActivityType {
  ReceivedFax = 'RECEIVED_FAX',
  SentFax = 'SENT_FAX'
}

/**
 * Develop follow-up call activity. `recordingUrl` is a short-lived signed Develop
 * URL — use immediately or re-query `priorAuthExtended`.
 */
export type PlatformPaFollowUpCallActivity = {
  __typename?: 'PaFollowUpCallActivity';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  recordingUrl?: Maybe<Scalars['String']['output']>;
  transcript?: Maybe<Scalars['String']['output']>;
};

export type PlatformPaMessage = {
  __typename?: 'PaMessage';
  attachments: Array<PlatformPaMessageAttachment>;
  content: Scalars['String']['output'];
  direction: PlatformPaMessageDirection;
  id: Scalars['ID']['output'];
  isResolution: Scalars['Boolean']['output'];
  sentByName: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
};

/**
 * Message attachment. `url` is a short-lived signed Develop URL — use immediately
 * or re-query `priorAuthExtended`.
 */
export type PlatformPaMessageAttachment = {
  __typename?: 'PaMessageAttachment';
  fileName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  url: Scalars['String']['output'];
};

export enum PlatformPaMessageDirection {
  Received = 'RECEIVED',
  Sent = 'SENT'
}

export type PlatformPaMessageThread = {
  __typename?: 'PaMessageThread';
  isResolved: Scalars['Boolean']['output'];
  messages: Array<PlatformPaMessage>;
};

export type PlatformPaOutcome = {
  __typename?: 'PaOutcome';
  approvalDate?: Maybe<Scalars['DateTime']['output']>;
  copayOptions: Array<PlatformCopayOption>;
  /** Develop's outcome.detail — payer-facing human-readable outcome text. */
  detail?: Maybe<Scalars['String']['output']>;
  /** Develop's outcome.detail_code. */
  detailCode?: Maybe<Scalars['String']['output']>;
  expirationDate?: Maybe<Scalars['DateTime']['output']>;
  result: PlatformPaOutcomeResult;
};

export enum PlatformPaOutcomeResult {
  Approved = 'APPROVED',
  Denied = 'DENIED',
  Other = 'OTHER'
}

export enum PlatformPaRequirement {
  No = 'NO',
  NotApplicable = 'NOT_APPLICABLE',
  Yes = 'YES'
}

/** Pagination metadata for paginated results */
export type PlatformPageInfo = {
  __typename?: 'PageInfo';
  /** Whether there are more items after this page */
  hasMore: Scalars['Boolean']['output'];
};

/** Pagination parameters for list queries */
export type PlatformPaginationInput = {
  /** Number of items to skip (default: 0) */
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Number of items to return (default: 10, max: 500) */
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

/** Federation stub — resolved by patient-registry subgraph. */
export type PlatformPatient = {
  __typename?: 'Patient';
  /**
   * The patient's allergy and intolerance records with every status, newest onset first, then newest
   * recorded date, undated last. Empty when none are stored, which does not mean the patient has no
   * allergies. `limit` must be between 1 and 500. Exposed only to trusted program domains.
   */
  allergyIntolerances: Array<PlatformAllergyIntolerance>;
  /** Ascending by `appointmentTime`. Empty when the patient has none matching the filter. */
  appointments: Array<PlatformPatientAppointment>;
  /**
   * The current holder of each role, at most one per role, as last set by
   * `assignPrescriber` or `assignDietitian`. Empty when nothing is assigned.
   * Providers on the Healthie chart that hold no role, such as a replaced
   * prescriber or one added in Healthie directly, are not listed. Outside
   * clinicians (PCPs, specialists) are clinical-records' care team, not
   * assignments.
   */
  assignedProviders: Array<PlatformProviderAssignment>;
  bloodPressureReadings: PlatformBloodPressurePage;
  /**
   * The patient's conditions, one per code across every source record, newest recorded first. Reads
   * every stored record, so the dates cover the whole history even when it holds thousands of rows.
   * `limit` caps the summaries returned and must be between 1 and 500. Exposed only to trusted
   * program domains.
   */
  conditionSummaries: Array<PlatformConditionSummary>;
  /**
   * The patient's source Condition records, newest onset first, then newest recorded date, undated
   * last. Includes resolved and absent-from-source rows; callers filter on status. Empty when none are
   * stored, which does not mean the patient has no conditions. `limit` must be between 1 and 500;
   * otherwise the field fails with a bad-request error. Exposed only to trusted program domains.
   */
  conditions: Array<PlatformCondition>;
  /**
   * The email address to reach this patient at, exactly as the answering system
   * stores it.
   *
   * The GrowthBook flag `patient-contact-email-source` picks the source while
   * the registry's emails are being proven: `healthie` (the default) answers
   * with the patient's Healthie user's email; `shadow` answers the same and
   * logs how the registry's primary active email compares; `registry_first`
   * answers with the registry's primary active email when the patient has one,
   * and Healthie's otherwise. Once the flag is removed, the registry answers.
   * A patient with no Healthie account (no primary active Healthie id, or
   * Healthie has no user with it) gets the registry's primary active email in
   * every mode.
   *
   * Null when the answering system has no email for the patient; callers treat
   * that as missing, not as an error.
   *
   * Values selected in one request are batched, up to 50 patients per
   * Healthie request. A Healthie failure errors this field on every patient in
   * that batch.
   *
   * Errors (`extensions.code`):
   * - `BAD_GATEWAY`: Healthie could not be reached, timed out after 30 s or
   *   sent an invalid reply. Callers treat this as unknown, not as no email.
   * - `INTERNAL_SERVER_ERROR`: the registry database failed reading the
   *   patient's Healthie id, or, for a patient with no Healthie account, its
   *   email.
   */
  contactEmail?: Maybe<Scalars['String']['output']>;
  /** When the patient record was created */
  createdAt: Scalars['DateTime']['output'];
  /**
   * The patient's diagnostic reports, newest period start first, then newest issued date, undated
   * last. Empty when none are stored. `limit` must be between 1 and 500. Exposed only to trusted
   * program domains.
   */
  diagnosticReports: Array<PlatformDiagnosticReport>;
  /** Email addresses (filtered by default to primary only) */
  emails: Array<PlatformPatientEmail>;
  /** The patient's primary, active external id for the given system, or null if there is none. */
  externalId?: Maybe<PlatformPatientExternalId>;
  /** External system identifiers (filtered by default to primary/active only) */
  externalIds: Array<PlatformPatientExternalId>;
  /**
   * The Healthie care-team provider ids this patient's chart carried at the end of
   * the care-team write that produced THIS `Patient` value: the primary
   * (`dietitian_id`) plus the additional providers (`other_provider_ids`).
   *
   * Populated only by `addPatientAdditionalProvider`, and only from evidence
   * already in that request — Healthie's own `updateClient` echo when a write
   * happened, or the pre-write `getClientProviders` read on the
   * already-primary/already-a-member no-op. Null on every other query and
   * mutation, and never issues a Healthie call of its own.
   *
   * HEALTHIE ids, deliberately unmapped, because the point is to let the caller
   * check the write against the id IT expects rather than trust this subgraph to
   * have interpreted the write on its behalf.
   * `AddPatientAdditionalProviderInput.requireCareTeamConfirmation` asks this
   * subgraph to enforce the same thing server-side; selecting this field is what
   * makes a caller's decision correct even against a deployment that ignores that
   * flag, which matters during a rolling deploy where the two sides are briefly on
   * different builds.
   */
  healthieCareTeamProviderIds?: Maybe<Array<Scalars['ID']['output']>>;
  /** Unique identifier for the patient (internal ID) */
  id: Scalars['ID']['output'];
  /**
   * The patient's history for each requested lab test, one entry per distinct test in request
   * order, including tests with no results. `limit` caps each test's results after repeated
   * readings collapse and must be between 1 and 200; `tests` must be non-empty. Either violation
   * fails the field with a bad-request error.
   */
  labTestHistories: Array<PlatformClinicalLabTestHistory>;
  /** When the patient data was last synced from Clerk (via webhook) */
  lastSyncedFromClerkAt?: Maybe<Scalars['DateTime']['output']>;
  /** When the patient data was last synced from Healthie (via webhook) */
  lastSyncedFromHealthieAt?: Maybe<Scalars['DateTime']['output']>;
  /** When the patient was last successfully synced to Zus Health */
  lastSyncedToZusAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * The patient's valid measurements with any of the given codes, from every source, newest
   * `effectiveAt` first with undated rows last. Excludes soft-invalidated rows. Empty when none
   * are stored, which does not mean the patient has no such readings anywhere. `codes` must be
   * non-empty and `limit` between 1 and 200; otherwise the field fails with a bad-request error.
   */
  measurements: Array<PlatformMeasurement>;
  /**
   * The patient's pharmacy dispenses, newest handed-over date first, then newest prepared date,
   * undated last. Empty when none are stored. `limit` must be between 1 and 500. Exposed only to
   * trusted program domains.
   */
  medicationDispenses: Array<PlatformMedicationDispense>;
  /**
   * The patient's medications, one per drug across every source request and statement, newest dated
   * first. Reads every stored row, so the dates cover the whole history. `limit` caps the summaries
   * returned and must be between 1 and 500. Exposed only to trusted program domains.
   */
  medicationSummaries: Array<PlatformMedicationSummary>;
  /**
   * The patient's medication requests and statements from every source, newest authored date first,
   * then newest course start, undated last. Includes stopped, completed and absent-from-source rows;
   * excludes rows retracted as entered-in-error. Empty when none are stored. `limit` must be between 1
   * and 500. Exposed only to trusted program domains.
   */
  medications: Array<PlatformClinicalMedication>;
  /** Phone number from the patient's Healthie profile. */
  phone?: Maybe<Scalars['String']['output']>;
  /** Healthie payer id for the patient's active primary policy. */
  primaryPayerId?: Maybe<Scalars['String']['output']>;
  /** Canonical provider-registry id for the patient's primary Healthie provider. */
  primaryProviderId?: Maybe<Scalars['ID']['output']>;
  /**
   * The patient's Healthie `record_identifier`: the identifier Healthie holds
   * for the patient's record, read from the Healthie user behind the patient's
   * primary active Healthie id.
   *
   * Null when the patient has no Healthie account (no primary active Healthie
   * id, or Healthie has no user with it) or the user's `record_identifier` is
   * empty or unset; callers treat that as missing, not as an error.
   *
   * Values selected in one request are batched, up to 50 patients per Healthie
   * request. A Healthie failure errors this field on every patient in that
   * batch.
   *
   * Errors (`extensions.code`):
   * - `BAD_GATEWAY`: Healthie could not be reached, timed out after 30 s or
   *   sent an invalid reply. Callers treat this as unknown, not as no
   *   identifier.
   * - `INTERNAL_SERVER_ERROR`: the registry database failed reading the
   *   patient's Healthie id.
   */
  recordIdentifier?: Maybe<Scalars['String']['output']>;
  /** Two-letter state code from the patient's Healthie profile. */
  state?: Maybe<Scalars['String']['output']>;
  /** Patient status */
  status: PlatformPatientStatus;
  /** When the patient record was last updated */
  updatedAt: Scalars['DateTime']['output'];
  /**
   * Whether every Zus clinical resource type this patient owes has been pulled
   * into clinical-records since the latest Zus sync. COMPLETE includes empty
   * pulls (Zus found nothing) and terminal error/give-up stamps. Never synced,
   * or any owed type still due, is IN_PROGRESS.
   */
  zusDataStatus: PlatformZusDataStatus;
  /**
   * One of the patient's Zus documents with its text and original file, read live from Zus. Null when
   * the patient was never synced to Zus, Zus has no UPID for them, or the document does not exist or is
   * not the patient's. A Zus failure,
   * a document with no attachment, or an attachment over 10 MiB fails the field with an error. Has no
   * side effects; safe to retry. Exposed only to trusted program domains.
   */
  zusDocument?: Maybe<PlatformZusDocument>;
  /**
   * Every one of the patient's Zus documents, metadata only, read live from Zus on every call, in Zus
   * order. Each summary carries its dates, so callers sort and filter. Null when the patient was never
   * synced to Zus or Zus has no UPID for them. An empty list means Zus returned no documents. A Zus failure, or a
   * patient with more than 5,000 documents, fails the field rather than returning a partial list.
   * Exposed only to trusted program domains.
   */
  zusDocuments?: Maybe<Array<PlatformZusDocumentSummary>>;
  /**
   * Several of the patient's Zus documents with their text and original files, from one listing of
   * the patient's documents. One result per requested id, in request order. Null when the patient was
   * never synced to Zus or Zus has no UPID for them. A failed listing fails the field; a document
   * that cannot be read gets a failure reason and does not fail the others. `ids` takes 1 to 50
   * distinct ids. Exposed only to trusted program domains.
   */
  zusDocumentsByIds?: Maybe<Array<PlatformZusDocumentReadResult>>;
};


/** Federation stub — resolved by patient-registry subgraph. */
export type PlatformPatientAllergyIntolerancesArgs = {
  limit?: Scalars['Int']['input'];
};


/** Federation stub — resolved by patient-registry subgraph. */
export type PlatformPatientAppointmentsArgs = {
  input: PlatformPatientAppointmentsInput;
};


/** Federation stub — resolved by patient-registry subgraph. */
export type PlatformPatientBloodPressureReadingsArgs = {
  input: PlatformBloodPressureHistoryInput;
};


/** Federation stub — resolved by patient-registry subgraph. */
export type PlatformPatientConditionSummariesArgs = {
  limit?: Scalars['Int']['input'];
};


/** Federation stub — resolved by patient-registry subgraph. */
export type PlatformPatientConditionsArgs = {
  limit?: Scalars['Int']['input'];
};


/** Federation stub — resolved by patient-registry subgraph. */
export type PlatformPatientDiagnosticReportsArgs = {
  limit?: Scalars['Int']['input'];
};


/** Federation stub — resolved by patient-registry subgraph. */
export type PlatformPatientEmailsArgs = {
  includeAll?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Federation stub — resolved by patient-registry subgraph. */
export type PlatformPatientExternalIdArgs = {
  system: PlatformExternalSystem;
};


/** Federation stub — resolved by patient-registry subgraph. */
export type PlatformPatientExternalIdsArgs = {
  includeAll?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Federation stub — resolved by patient-registry subgraph. */
export type PlatformPatientLabTestHistoriesArgs = {
  limit?: Scalars['Int']['input'];
  tests: Array<PlatformClinicalLabTest>;
};


/** Federation stub — resolved by patient-registry subgraph. */
export type PlatformPatientMeasurementsArgs = {
  codes: Array<Scalars['String']['input']>;
  limit?: Scalars['Int']['input'];
};


/** Federation stub — resolved by patient-registry subgraph. */
export type PlatformPatientMedicationDispensesArgs = {
  limit?: Scalars['Int']['input'];
};


/** Federation stub — resolved by patient-registry subgraph. */
export type PlatformPatientMedicationSummariesArgs = {
  limit?: Scalars['Int']['input'];
};


/** Federation stub — resolved by patient-registry subgraph. */
export type PlatformPatientMedicationsArgs = {
  limit?: Scalars['Int']['input'];
};


/** Federation stub — resolved by patient-registry subgraph. */
export type PlatformPatientZusDocumentArgs = {
  id: Scalars['ID']['input'];
};


/** Federation stub — resolved by patient-registry subgraph. */
export type PlatformPatientZusDocumentsByIdsArgs = {
  ids: Array<Scalars['ID']['input']>;
};

/** Canonical choices for the post-booking how-did-you-hear-about-us question. Named acquisition source rather than referral, which in this supergraph means a provider referral. */
export enum PlatformPatientAcquisitionSource {
  Amazon = 'AMAZON',
  Doctor = 'DOCTOR',
  EmailNewsletter = 'EMAIL_NEWSLETTER',
  Facebook = 'FACEBOOK',
  Factor = 'FACTOR',
  FriendOrFamily = 'FRIEND_OR_FAMILY',
  FromADietitian = 'FROM_A_DIETITIAN',
  Google = 'GOOGLE',
  Instagram = 'INSTAGRAM',
  Insurance = 'INSURANCE',
  MayoClinic = 'MAYO_CLINIC',
  Nextdoor = 'NEXTDOOR',
  Other = 'OTHER',
  Pinterest = 'PINTEREST',
  Podcast = 'PODCAST',
  PressOrNewsArticle = 'PRESS_OR_NEWS_ARTICLE',
  Reddit = 'REDDIT',
  Therapist = 'THERAPIST',
  Tiktok = 'TIKTOK',
  TreatmentCenter = 'TREATMENT_CENTER',
  Zocdoc = 'ZOCDOC'
}

export type PlatformPatientAddressInput = {
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  line1: Scalars['String']['input'];
  line2?: InputMaybe<Scalars['String']['input']>;
  postalCode: Scalars['String']['input'];
  state: Scalars['String']['input'];
};

/** Tracks a patient's interaction with an agenda item. */
export type PlatformPatientAgendaHistory = {
  __typename?: 'PatientAgendaHistory';
  /** The agenda item this history tracks */
  agendaItem: PlatformAgendaItem;
  /** Linked Healthie appointment ID */
  appointmentId?: Maybe<Scalars['String']['output']>;
  /** When completed (null = not done) */
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  /** When the record was created */
  createdAt: Scalars['DateTime']['output'];
  /** Unique identifier */
  id: Scalars['ID']['output'];
  /** Healthie patient ID */
  patientId: Scalars['String']['output'];
  /** Patient's free-text response (e.g. reflection text) */
  responseText?: Maybe<Scalars['String']['output']>;
  /** Session number */
  step: Scalars['Int']['output'];
};

/** All conflicts for a single patient, broken down by type. */
export type PlatformPatientAllConflicts = {
  __typename?: 'PatientAllConflicts';
  /** Email conflict, if any (null if no email conflict exists) */
  emailConflict?: Maybe<PlatformEmailConflict>;
  /** External ID conflicts grouped by system */
  externalIdConflicts: Array<PlatformExternalIdConflict>;
  /** The patient record */
  patient: PlatformPatient;
  /** Internal patient ID */
  patientId: Scalars['ID']['output'];
};

/**
 * One of the patient's appointments. Read live from Healthie rather than a
 * webhook-lagged mirror, so an appointment booked moments ago in another session
 * is visible. Healthie exposes no batch appointments-by-many-patients read, so
 * resolving this field over a list of patients costs one Healthie call each —
 * resolve it for one patient at a time.
 */
export type PlatformPatientAppointment = {
  __typename?: 'PatientAppointment';
  appointmentHealthieId: Scalars['ID']['output'];
  appointmentTime: Scalars['DateTime']['output'];
  appointmentType: PlatformAppointmentType;
  /** Original creation time reported by Healthie; never inferred from the scheduled time. */
  createdAt: Scalars['DateTime']['output'];
  /** Canonical provider-registry id. Null when the Healthie provider has no registry counterpart. */
  providerId?: Maybe<Scalars['ID']['output']>;
  /** Provider's full name as Healthie holds it. Null when Healthie supplies none. */
  providerName?: Maybe<Scalars['String']['output']>;
  status: PlatformAppointmentStatus;
};

/**
 * Every filter is independent and every one is optional; omitting all of them
 * returns the patient's whole appointment history. Time and status are separate
 * axes on purpose — an appointment's status says nothing about whether its time
 * has passed, and vice versa.
 */
export type PlatformPatientAppointmentsInput = {
  /** Restrict to these appointment types. Null returns every catalogued type. */
  appointmentTypes?: InputMaybe<Array<PlatformAppointmentType>>;
  /**
   * Restrict to these statuses. Null returns every status, including cancelled
   * and no-showed ones.
   */
  statuses?: InputMaybe<Array<PlatformAppointmentStatus>>;
  /**
   * Inclusive bounds on appointment time. `start` at the current instant is how a
   * caller asks for upcoming appointments; a caller gating on recency supplies its
   * own cutoff as `start`. No cutoff is implied here.
   */
  window?: InputMaybe<PlatformAppointmentWindowInput>;
};

export type PlatformPatientAwaitingDocuments = {
  __typename?: 'PatientAwaitingDocuments';
  /** Open request ids for this patient, oldest first. */
  documentRequestIds: Array<Scalars['ID']['output']>;
  patientHealthieId: Scalars['ID']['output'];
};

/**
 * The patient's evolving base profile — the narrative + typed facts Perry's
 * get-to-know-you onboarding interview fills over one or more sessions. Keyed by
 * Healthie user id. All content fields are nullable: absence = not-yet-learned. Seeds
 * the Ria V2 Core-Patient Summary.
 */
export type PlatformPatientBaseProfile = {
  __typename?: 'PatientBaseProfile';
  beverages?: Maybe<Scalars['String']['output']>;
  /** How much of the interview core has been filled. */
  completeness: PlatformProfileCompleteness;
  constraints?: Maybe<Scalars['String']['output']>;
  culturalFoodContext?: Maybe<Scalars['String']['output']>;
  eatingDay?: Maybe<Scalars['String']['output']>;
  /** Populated prose fields with per-field provenance when the source recorded it. */
  fields: Array<PlatformBaseProfileField>;
  /** Storage-only: retained for future non-interview population; the onboarding interview no longer asks this. */
  foodEnvironment?: Maybe<Scalars['String']['output']>;
  foodPreferences?: Maybe<Scalars['String']['output']>;
  healthGoals?: Maybe<Scalars['String']['output']>;
  /** Healthie user id of the patient. */
  healthieUserId: Scalars['ID']['output'];
  /** Storage-only: retained for future non-interview population; the onboarding interview no longer asks this. */
  household?: Maybe<Scalars['String']['output']>;
  /** Core fields still empty — what the interview should steer toward next. */
  openThreads: Array<PlatformProfileFieldKey>;
  pastAttempts?: Maybe<Scalars['String']['output']>;
  schedule?: Maybe<Scalars['String']['output']>;
  /** ISO-8601 timestamp of the last update, or null if never written. */
  updatedAt?: Maybe<Scalars['String']['output']>;
  whatSuccessLooksLike?: Maybe<Scalars['String']['output']>;
  whyHere?: Maybe<Scalars['String']['output']>;
};

export type PlatformPatientBusyAppointment = {
  __typename?: 'PatientBusyAppointment';
  appointmentHealthieId: Scalars['ID']['output'];
  appointmentTypeHealthieId?: Maybe<Scalars['ID']['output']>;
  appointmentTypeName?: Maybe<Scalars['String']['output']>;
  endTime: Scalars['DateTime']['output'];
  providerHealthieId?: Maybe<Scalars['ID']['output']>;
  providerName?: Maybe<Scalars['String']['output']>;
  startTime: Scalars['DateTime']['output'];
  status: PlatformAppointmentStatus;
};

export enum PlatformPatientCareTeamAssignmentOutcome {
  /** Independent Healthie read confirms the requested care team. */
  Confirmed = 'CONFIRMED',
  /** Durable recovery continues; retry this mutation before booking. */
  Pending = 'PENDING',
  /** Assignment did not complete; reason distinguishes safe rollback from unverified state. */
  RequiresReview = 'REQUIRES_REVIEW'
}

/** One patient-confirmed member of the canonical care team. */
export type PlatformPatientCareTeamMember = {
  __typename?: 'PatientCareTeamMember';
  businessName?: Maybe<Scalars['String']['output']>;
  city: Scalars['String']['output'];
  fax?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  npi?: Maybe<Scalars['String']['output']>;
  patientId: Scalars['ID']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  recordedAt: Scalars['DateTime']['output'];
  sourceRecordId: Scalars['ID']['output'];
  specialty: Scalars['String']['output'];
  state: Scalars['String']['output'];
  /** When the patient confirmed this provider. */
  verifiedAt: Scalars['DateTime']['output'];
};

export type PlatformPatientChatHistoryInput = {
  /** Prior chat-owned token, passed back verbatim. Chat owns compatibility across source changes. */
  after?: InputMaybe<Scalars['String']['input']>;
  /**
   * Only turns SENT at or after this instant.
   *
   * This bounds the read by time and is the cheapest way to cap how much
   * history one call walks, independent of page size.
   *
   * It previously meant capture or reattribution time. Send time is what the
   * backing source can filter on, and the two differ for any message recorded
   * later than it was sent, so a bound set here will not surface a late-recorded
   * older message the way it once did.
   */
  changedSince?: InputMaybe<Scalars['String']['input']>;
  /**
   * Maximum turns requested. Defaults to 100. Capped at 200 here and at 100 by
   * the backing source, so a page may be smaller than asked for; paginate on
   * `endCursor` rather than assuming a short page means the end.
   */
  first?: InputMaybe<Scalars['Int']['input']>;
  /**
   * The patient's Healthie user id. Read only when `patientRegistryId` is not
   * set; does not select Healthie as the history source. At least one of the two
   * is required (`BAD_USER_INPUT` otherwise).
   */
  healthieUserId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * The patient's registry id. Takes precedence over `healthieUserId`. Resolved
   * through the patient registry: a registry id with no Healthie user id is a
   * `BAD_USER_INPUT` error, and a failed registry lookup an
   * `INTERNAL_SERVER_ERROR`.
   */
  patientRegistryId?: InputMaybe<Scalars['ID']['input']>;
};

export type PlatformPatientChatHistoryPage = {
  __typename?: 'PatientChatHistoryPage';
  /**
   * The Healthie user id the page was read for: the one requested, or the one
   * `patientRegistryId` resolved to.
   */
  healthieUserId: Scalars['ID']['output'];
  pageInfo: PlatformPatientChatHistoryPageInfo;
  turns: Array<PlatformPatientChatHistoryTurn>;
};

export type PlatformPatientChatHistoryPageInfo = {
  __typename?: 'PatientChatHistoryPageInfo';
  /** Chat-owned continuation token. Persist and return verbatim; never decode in consumers. */
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  /**
   * True when the supplied `after` could not be honoured and this page starts
   * from the beginning of the patient's history instead.
   *
   * Happens when a cursor predates a change of backing source and cannot be
   * translated. The page is valid and complete; what a consumer must not do is
   * append it to what it already holds. Replace prior coverage and identities
   * for this patient, and regenerate anything derived from them, rather than
   * merging.
   *
   * Reported here rather than as an error because it is an expected, actionable
   * outcome that the caller handles, not a failure it can only propagate.
   */
  restartedFromBeginning: Scalars['Boolean']['output'];
};

/** Author role retained by the long-term-memory chat-history source. */
export enum PlatformPatientChatHistoryRole {
  Patient = 'PATIENT',
  Perry = 'PERRY'
}

/** A normalized patient/Perry turn. Its backing source is an internal chat-domain detail. */
export type PlatformPatientChatHistoryTurn = {
  __typename?: 'PatientChatHistoryTurn';
  /** Opaque chat-domain channel identity, not a vendor channel ID. */
  channelId: Scalars['ID']['output'];
  /** Opaque chat-domain conversation identity, not a vendor conversation ID. */
  conversationId: Scalars['ID']['output'];
  occurredAt: Scalars['String']['output'];
  /**
   * When chat recorded the turn. Equal to `occurredAt` now that the backing
   * source is read directly rather than captured into a local store, and kept
   * distinct because a future source may reintroduce a real capture time.
   */
  recordedAt: Scalars['String']['output'];
  role: PlatformPatientChatHistoryRole;
  /** Opaque logical message identity, stable across mirroring and source cutovers. Preserve verbatim. */
  sourceId: Scalars['ID']['output'];
  text: Scalars['String']['output'];
};

/** Cursor-based pagination info for patient conflict queries */
export type PlatformPatientConflictPageInfo = {
  __typename?: 'PatientConflictPageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

/**
 * Summary of all conflict types for a single patient.
 * Used in the paginated patientsWithConflicts list.
 */
export type PlatformPatientConflictSummary = {
  __typename?: 'PatientConflictSummary';
  /** Number of email conflict groups (0 or 1, since emails are not per-system) */
  emailConflictCount: Scalars['Int']['output'];
  /** Number of external ID conflict groups (one per system in conflict) */
  externalIdConflictCount: Scalars['Int']['output'];
  /** The patient record */
  patient: PlatformPatient;
  /** Internal patient ID */
  patientId: Scalars['ID']['output'];
  /** Total number of conflict groups across all types */
  totalConflictCount: Scalars['Int']['output'];
};

/** Paginated list of patients with conflicts */
export type PlatformPatientConflictSummaryConnection = {
  __typename?: 'PatientConflictSummaryConnection';
  nodes: Array<PlatformPatientConflictSummary>;
  pageInfo: PlatformPatientConflictPageInfo;
  totalCount: Scalars['Int']['output'];
};

/** Paginated list of patients */
export type PlatformPatientConnection = {
  __typename?: 'PatientConnection';
  nodes: Array<PlatformPatient>;
  pageInfo: PlatformPatientConflictPageInfo;
  totalCount: Scalars['Int']['output'];
};

/** The current complete set of independently generated patient-context views. */
export type PlatformPatientContext = {
  __typename?: 'PatientContext';
  freshness: PlatformPatientContextFreshness;
  /** Opaque identifier for this generation, useful for tracing a response. */
  generationId: Scalars['ID']['output'];
  /** Longer narrative of the patient's health journey. */
  healthJourney?: Maybe<Scalars['String']['output']>;
  healthieUserId: Scalars['ID']['output'];
  /** Compact, broad context intended for small prompt surfaces such as routing. */
  patientSnapshot?: Maybe<Scalars['String']['output']>;
  sources: Array<PlatformPatientContextSourceCoverage>;
  /** All named views, including the snapshot and health journey when present. */
  summaries: Array<PlatformPatientContextSummary>;
  versions: PlatformPatientContextVersions;
};

/** When the current context was generated, published, and becomes stale. */
export type PlatformPatientContextFreshness = {
  __typename?: 'PatientContextFreshness';
  generatedAt: Scalars['DateTime']['output'];
  publishedAt: Scalars['DateTime']['output'];
  staleAfter: Scalars['DateTime']['output'];
};

/** A patient-scoped read result. MISSING is expected and is not an error. */
export type PlatformPatientContextReadResult = {
  __typename?: 'PatientContextReadResult';
  context?: Maybe<PlatformPatientContext>;
  healthieUserId: Scalars['ID']['output'];
  status: PlatformPatientContextStatus;
};

/** The bounded portion of one source considered during generation. */
export type PlatformPatientContextSourceCoverage = {
  __typename?: 'PatientContextSourceCoverage';
  fingerprint: Scalars['String']['output'];
  fromCursor?: Maybe<Scalars['String']['output']>;
  rangeEnd?: Maybe<Scalars['DateTime']['output']>;
  rangeStart?: Maybe<Scalars['DateTime']['output']>;
  recordIds: Array<Scalars['String']['output']>;
  sourceKind: Scalars['String']['output'];
  throughCursor?: Maybe<Scalars['String']['output']>;
};

/** Whether patient context is available and recent enough for normal use. */
export enum PlatformPatientContextStatus {
  /** The current context was generated within the configured freshness window. */
  Fresh = 'FRESH',
  /** No generated context exists for this patient. */
  Missing = 'MISSING',
  /** Context exists, but it is older than the configured freshness window. */
  Stale = 'STALE'
}

/** A named summary view. New kinds can be added without changing this schema. */
export type PlatformPatientContextSummary = {
  __typename?: 'PatientContextSummary';
  content: Scalars['String']['output'];
  kind: Scalars['String']['output'];
};

/** Generation settings that let consumers identify how context was produced. */
export type PlatformPatientContextVersions = {
  __typename?: 'PatientContextVersions';
  model: Scalars['String']['output'];
  promptVersion: Scalars['String']['output'];
  refreshMode: Scalars['String']['output'];
  schemaVersion: Scalars['String']['output'];
};

/** How a patient pays for care. */
export enum PlatformPatientCoverage {
  /** Commercial insurance */
  Insurance = 'INSURANCE',
  /** Medicare */
  Medicare = 'MEDICARE',
  /** Self pay */
  PrivatePay = 'PRIVATE_PAY'
}

/** A patient's documents and open document requests. */
export type PlatformPatientDocumentCenter = {
  __typename?: 'PatientDocumentCenter';
  /** Confirmed, not-deleted documents, newest first. */
  documents: Array<PlatformDocument>;
  /** Open requests, oldest first. */
  openRequests: Array<PlatformDocumentRequest>;
  patientHealthieId: Scalars['ID']['output'];
  /** Open requests with no confirmed documents attached. */
  unansweredRequestCount: Scalars['Int']['output'];
};

/** Input for requesting a presigned download URL by patient */
export type PlatformPatientDocumentDownloadInput = {
  /** The document ID to download */
  documentId: Scalars['ID']['input'];
  /** The patient who owns the document */
  patient: PlatformDocumentPatientInput;
};

/** A file in a patient's record. Read it straight away: the url lives for seconds. */
export type PlatformPatientDocumentFile = {
  __typename?: 'PatientDocumentFile';
  /** The file's content type. */
  contentType?: Maybe<Scalars['String']['output']>;
  /** The document's id in the patient's record, the id patientDocumentFile takes. */
  id: Scalars['ID']['output'];
  /** Opaque string the document's writer stored with it, or null. The platform does not parse it. */
  metadata?: Maybe<Scalars['String']['output']>;
  /** The patient the document belongs to, as the domain's patient key (the key the other inputs take). */
  ownerId?: Maybe<Scalars['ID']['output']>;
  /** Short-lived download URL. Fetch it straight away. */
  url?: Maybe<Scalars['String']['output']>;
};

/**
 * Email address for a patient.
 * Each email address is unique across all patients (case-insensitive).
 * A patient can have multiple email addresses with one marked as primary.
 */
export type PlatformPatientEmail = {
  __typename?: 'PatientEmail';
  /** When this email was added */
  createdAt: Scalars['DateTime']['output'];
  /** The email address */
  emailAddress: Scalars['String']['output'];
  /** Unique identifier for this email record */
  id: Scalars['ID']['output'];
  /** Whether this is the primary/active email for this patient */
  isPrimary: Scalars['Boolean']['output'];
  /** Reference to the patient this email belongs to */
  patientId: Scalars['ID']['output'];
  /** Note recorded by CS when this record was involved in a conflict resolution */
  resolutionNote?: Maybe<Scalars['String']['output']>;
  /** When this record was involved in a conflict resolution */
  resolvedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Current status of this email */
  status: PlatformEmailStatus;
  /** When this email was last updated */
  updatedAt: Scalars['DateTime']['output'];
};

/** Paginated list of patient email conflicts */
export type PlatformPatientEmailConflictConnection = {
  __typename?: 'PatientEmailConflictConnection';
  nodes: Array<PlatformEmailConflict>;
  pageInfo: PlatformPatientConflictPageInfo;
  totalCount: Scalars['Int']['output'];
};

/** Canonical ethnicity choices currently collected by the shared Medical background form. */
export enum PlatformPatientEthnicity {
  HispanicOrLatino = 'HISPANIC_OR_LATINO'
}

/**
 * External system identifier for a patient.
 * Maps patient identity across multiple platforms (Healthie, Clerk, Intercom, Customer.io).
 */
export type PlatformPatientExternalId = {
  __typename?: 'PatientExternalId';
  /** When this external ID was created */
  createdAt: Scalars['DateTime']['output'];
  /** The actual ID value in the external system */
  externalId: Scalars['String']['output'];
  /** Unique identifier for this external ID record */
  id: Scalars['ID']['output'];
  /** Whether this is the primary/active ID for this system */
  isPrimary: Scalars['Boolean']['output'];
  /** Reference to the patient this ID belongs to */
  patientId: Scalars['ID']['output'];
  /** Note recorded by CS when this record was involved in a conflict resolution */
  resolutionNote?: Maybe<Scalars['String']['output']>;
  /** When this record was involved in a conflict resolution */
  resolvedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Current status of this external ID */
  status: PlatformExternalIdStatus;
  /** External system name */
  system: PlatformExternalSystem;
  /** When this external ID was last updated */
  updatedAt: Scalars['DateTime']['output'];
};

/** Paginated list of patient external ID conflicts */
export type PlatformPatientExternalIdConflictConnection = {
  __typename?: 'PatientExternalIdConflictConnection';
  nodes: Array<PlatformExternalIdConflict>;
  pageInfo: PlatformPatientConflictPageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PlatformPatientExtraBusyIntervalInput = {
  durationMinutes: Scalars['Int']['input'];
  startTime: Scalars['DateTime']['input'];
};

/**
 * Canonical patient facts the minter knows about the user. Per-flow prefill
 * mappers translate these into seeded step submissions; minters do not know
 * about step ids or field names. Grows additively — add a field when a real
 * caller needs it.
 */
export type PlatformPatientFactsInput = {
  /**
   * When true, book-dietitian may book another MNT visit even though the patient
   * already has an occurred one. An upcoming scheduled visit still blocks.
   * Absent keeps the cross-sell rule: an occurred visit in the last 6 months
   * ends at already-participated. An older occurred visit does not.
   */
  allowPriorMntParticipation?: InputMaybe<Scalars['Boolean']['input']>;
  /** ISO 8601 date (YYYY-MM-DD). */
  dob?: InputMaybe<Scalars['String']['input']>;
  /** Total height in inches. */
  heightInches?: InputMaybe<Scalars['Float']['input']>;
  patientHealthieId?: InputMaybe<Scalars['String']['input']>;
  /** Healthie InsurancePlan.payer_id (e.g. 60054 — not change_healthcare_payer_id). Provider-match input. */
  payerId?: InputMaybe<Scalars['String']['input']>;
  /** Plan network type. Drives the closed-plan in-state enrollment restriction in provider matching; absent means open (most permissive). */
  planType?: InputMaybe<PlatformPlanType>;
  sexAtBirth?: InputMaybe<PlatformSexAtBirth>;
  /** Two-letter US state code of the patient (Healthie User.location.state). Provider-match input. */
  state?: InputMaybe<Scalars['String']['input']>;
  weightLbs?: InputMaybe<Scalars['Float']['input']>;
};

/** A patient-reported family-history choice. These are family history, never diagnoses of the patient having the named disease. */
export enum PlatformPatientFamilyHistoryCondition {
  AutoimmuneDisease = 'AUTOIMMUNE_DISEASE',
  CardiovascularDisease = 'CARDIOVASCULAR_DISEASE',
  ChronicKidneyDisease = 'CHRONIC_KIDNEY_DISEASE',
  DiabetesOrPrediabetes = 'DIABETES_OR_PREDIABETES',
  HighCholesterol = 'HIGH_CHOLESTEROL',
  Obesity = 'OBESITY',
  SuddenCardiacDeath = 'SUDDEN_CARDIAC_DEATH'
}

/** Current GLP-1 state and the complete newest-first transition history. */
export type PlatformPatientGlp1Journey = {
  __typename?: 'PatientGlp1Journey';
  current?: Maybe<PlatformPatientGlp1JourneyEvent>;
  history: Array<PlatformPatientGlp1JourneyEvent>;
};

/** A milestone in a patient's append-only GLP-1 journey history. */
export type PlatformPatientGlp1JourneyEvent = {
  __typename?: 'PatientGlp1JourneyEvent';
  createdAt: Scalars['DateTime']['output'];
  /** Source-specific context, such as appointment status or the originating row id. */
  details?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  patientHealthieId: Scalars['ID']['output'];
  reason: Scalars['String']['output'];
  source: PlatformPatientGlp1JourneySource;
  state: PlatformPatientGlp1JourneyState;
};

export enum PlatformPatientGlp1JourneySource {
  HealthieAppointment = 'HEALTHIE_APPOINTMENT',
  MedicationTakeLog = 'MEDICATION_TAKE_LOG',
  MobileApp = 'MOBILE_APP',
  Prescription = 'PRESCRIPTION',
  PriorAuthorization = 'PRIOR_AUTHORIZATION'
}

export enum PlatformPatientGlp1JourneyState {
  ConsultationBooked = 'CONSULTATION_BOOKED',
  ConsultationNotOccurred = 'CONSULTATION_NOT_OCCURRED',
  CoverageActionRequired = 'COVERAGE_ACTION_REQUIRED',
  CoverageApproved = 'COVERAGE_APPROVED',
  CoverageDenied = 'COVERAGE_DENIED',
  CoverageOther = 'COVERAGE_OTHER',
  CoverageSubmitted = 'COVERAGE_SUBMITTED',
  Discovery = 'DISCOVERY',
  FirstDoseLogged = 'FIRST_DOSE_LOGGED',
  FollowUpConsultationBooked = 'FOLLOW_UP_CONSULTATION_BOOKED',
  PreparationActionRequired = 'PREPARATION_ACTION_REQUIRED',
  PrescriptionCreated = 'PRESCRIPTION_CREATED',
  WaitingForPrescription = 'WAITING_FOR_PRESCRIPTION'
}

/** The insurance details of a patient's record. Nothing is stored. */
export type PlatformPatientInsuranceDetails = {
  __typename?: 'PatientInsuranceDetails';
  /** Null when the record does not say. */
  hasSelfPay?: Maybe<Scalars['Boolean']['output']>;
  /** The patient-level authorization, separate from each policy's. Null when the record has none. */
  insuranceAuthorization?: Maybe<PlatformInsuranceAuthorization>;
  /** In the order the record lists them; empty when the record has none. */
  policies: Array<PlatformInsurancePolicyDetails>;
  /** The patient's group. Null when the record has none. */
  userGroup?: Maybe<PlatformInsuranceUserGroup>;
};

export type PlatformPatientInsurancePoliciesPayload = {
  __typename?: 'PatientInsurancePoliciesPayload';
  /** The record's validation messages. Empty on success. */
  messages: Array<PlatformPatientRecordMessage>;
  /** The registry id of externalId's patient, or null when the registry has none. */
  patientId?: Maybe<Scalars['ID']['output']>;
  /** The patient's policies after the write. Null when the record did not confirm the write and answered with messages instead. */
  policies?: Maybe<Array<PlatformSavedInsurancePolicy>>;
};

/** OPEN | CLOSED — Intercom snoozed/other states map to CLOSED for Overview. */
export enum PlatformPatientIntercomConversationStatus {
  Closed = 'CLOSED',
  Open = 'OPEN'
}

/** One Intercom conversation, summarised for the Patient Overview list view. */
export type PlatformPatientIntercomConversationSummary = {
  __typename?: 'PatientIntercomConversationSummary';
  assigneeName?: Maybe<Scalars['String']['output']>;
  /** Originating channel, e.g. "email" or "conversation" (chat). */
  channel?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Deep link to the conversation in the Intercom inbox. */
  intercomUrl?: Maybe<Scalars['String']['output']>;
  /** Plaintext, truncated preview of the conversation source (opening) body. */
  messagePreview?: Maybe<Scalars['String']['output']>;
  status: PlatformPatientIntercomConversationStatus;
  teamName?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type PlatformPatientIntercomConversationThreadPayload = {
  __typename?: 'PatientIntercomConversationThreadPayload';
  /** Safe, generic message when matchStatus is error. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  intercomUrl?: Maybe<Scalars['String']['output']>;
  matchStatus: PlatformPatientIntercomMatchStatus;
  messages: Array<PlatformPatientIntercomMessage>;
};

export type PlatformPatientIntercomConversationsPayload = {
  __typename?: 'PatientIntercomConversationsPayload';
  conversations: Array<PlatformPatientIntercomConversationSummary>;
  /** Safe, generic message when matchStatus is error. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  intercomContactId?: Maybe<Scalars['String']['output']>;
  /** Deep link to the contact's Intercom conversation list. */
  intercomUrl?: Maybe<Scalars['String']['output']>;
  matchStatus: PlatformPatientIntercomMatchStatus;
  workspaceId?: Maybe<Scalars['String']['output']>;
};

/**
 * Outcome of resolving a patient's Intercom contact:
 * - matched: contact id known (registry link, healthieUserProfileUrl search, or unique email match)
 * - not_found: no registry link, no healthieUserProfileUrl match, and either no patient
 *   email or no email match
 * - ambiguous: more than one Intercom contact matched (healthieUserProfileUrl or email search)
 * - error: an upstream (Intercom or patient-registry) call failed
 */
export enum PlatformPatientIntercomMatchStatus {
  Ambiguous = 'AMBIGUOUS',
  Error = 'ERROR',
  Matched = 'MATCHED',
  NotFound = 'NOT_FOUND'
}

/** One plaintext message within an Intercom conversation thread. */
export type PlatformPatientIntercomMessage = {
  __typename?: 'PatientIntercomMessage';
  authorName?: Maybe<Scalars['String']['output']>;
  /** e.g. "user", "admin", "bot". */
  authorType?: Maybe<Scalars['String']['output']>;
  body: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
};

export type PlatformPatientInvoice = {
  __typename?: 'PatientInvoice';
  /** Remaining amount for this invoice only, in the currency's minor unit. */
  amountRemaining: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  dueAt?: Maybe<Scalars['DateTime']['output']>;
  /** Null means Stripe has no hosted page yet, including for owned draft invoices. */
  hostedInvoiceUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  number?: Maybe<Scalars['String']['output']>;
  paidAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Stripe's invoice status. Null only when Stripe explicitly returns null; it is
   * not a fallback for source failures or an inferred billing state.
   */
  status?: Maybe<PlatformPatientInvoiceStatus>;
};

export type PlatformPatientInvoiceInput = {
  invoiceId: Scalars['ID']['input'];
  /** Canonical patient-registry ID, not a Healthie ID; authorized by the caller. */
  patientId: Scalars['ID']['input'];
};

export type PlatformPatientInvoicePage = {
  __typename?: 'PatientInvoicePage';
  invoices: Array<PlatformPatientInvoice>;
  pageInfo: PlatformPatientInvoicePageInfo;
};

export type PlatformPatientInvoicePageInfo = {
  __typename?: 'PatientInvoicePageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
};

export enum PlatformPatientInvoiceStatus {
  Draft = 'DRAFT',
  Open = 'OPEN',
  Paid = 'PAID',
  Uncollectible = 'UNCOLLECTIBLE',
  Void = 'VOID'
}

export type PlatformPatientInvoicesInput = {
  /**
   * Opaque continuation bound to the canonical patient and current Healthie identity
   * set. An identity change invalidates the cursor with BAD_USER_INPUT; restart
   * from the first page without after.
   */
  after?: InputMaybe<Scalars['String']['input']>;
  /** Page size from 1 through 100. */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Canonical patient-registry ID, not a Healthie ID; authorized by the caller. */
  patientId: Scalars['ID']['input'];
};

/** The identity a patient signs in with, as returned by `patientLoginIdentity`. */
export type PlatformPatientLoginIdentity = {
  __typename?: 'PatientLoginIdentity';
  /** The account's email address, exactly as the EHR stores it. */
  emailAddress: Scalars['String']['output'];
  /** The account's full name as the EHR stores it, or null when unset. */
  fullName?: Maybe<Scalars['String']['output']>;
  /** The EHR (Healthie) user id of the matched account. Non-null today because every answer comes from a Healthie account; becomes null for patients without one once the registry can answer alone. Callers must handle null. */
  healthieUserId?: Maybe<Scalars['ID']['output']>;
  /** The registry patient holding the matched account. This is the long-term identity key; callers should move to it. Null when the registry does not hold the account or its database could not be read (best-effort; the lookup still answers). */
  patient?: Maybe<PlatformPatient>;
  /** The account's phone number as the EHR stores it (not normalized), or null when unset. */
  phone?: Maybe<Scalars['String']['output']>;
};

/** Provide exactly one of email or phone. National phone numbers are treated as US numbers. */
export type PlatformPatientLookupInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type PlatformPatientLookupResult = {
  __typename?: 'PatientLookupResult';
  healthieId: Scalars['ID']['output'];
};

/** Canonical result of recording one Medical background response. */
export type PlatformPatientMedicalBackground = {
  __typename?: 'PatientMedicalBackground';
  /** BMI derived from this call's complete vitals or the latest valid patient-reported vitals. Null when no complete pair exists. */
  bmi?: Maybe<Scalars['Float']['output']>;
  /** Latest exact family-history choices. Null when this call did not answer that section. */
  familyHistoryConditions?: Maybe<Array<PlatformPatientFamilyHistoryCondition>>;
  patientId: Scalars['ID']['output'];
  /** When this response was recorded. */
  recordedAt: Scalars['DateTime']['output'];
};

/** A snapshot of a single Navi Health backfill workflow execution. */
export type PlatformPatientNavihealthBackfillRun = {
  __typename?: 'PatientNavihealthBackfillRun';
  /** When the latest run closed, if it has. */
  closedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Live cumulative progress. Returned only when the workflow is reachable
   * (it isn't, e.g., immediately after `terminate`); null otherwise.
   */
  progress?: Maybe<PlatformBackfillProgress>;
  /**
   * Run id of the latest execution for this workflow id. Null when the
   * start helper synthesizes a snapshot because the post-start `describe`
   * raced ahead of Temporal indexing the new execution — admin should
   * retry the status query rather than render a broken UI deep-link.
   */
  runId?: Maybe<Scalars['ID']['output']>;
  /** When the latest run started. Null in the same describe-race case as `runId`. */
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Mapped from Temporal's execution status enum. */
  state: PlatformBackfillState;
  /**
   * Free-text identifier supplied by the caller of
   * `startPatientNavihealthBackfill` and surfaced in the Temporal memo.
   * Admin sets this to the operator's email for audit trail.
   */
  triggeredBy?: Maybe<Scalars['String']['output']>;
  /** Stable workflow id — always `backfill-patients-to-navihealth`. */
  workflowId: Scalars['ID']['output'];
};

/** Top-level status for the patient → Navi Health backfill workflow. */
export type PlatformPatientNavihealthBackfillStatus = {
  __typename?: 'PatientNavihealthBackfillStatus';
  /**
   * Whether the `navihealth-propagation-patient-enabled` GrowthBook flag is
   * on. Starting a backfill while the flag is off is rejected — the workflow
   * would enqueue propagation events that immediately get gated out
   * downstream.
   */
  flagEnabled: Scalars['Boolean']['output'];
  /**
   * Latest run, if any. Null when no execution has ever started for this
   * backfill id (fresh environment, or history fully expired).
   */
  latestRun?: Maybe<PlatformPatientNavihealthBackfillRun>;
};

/**
 * A free-text note authored by a provider about a patient.
 * Notes are private to the authoring provider and are not patient-visible.
 * A provider may have any number of notes for the same patient.
 */
export type PlatformPatientNote = {
  __typename?: 'PatientNote';
  /** Internal provider-registry ID of the authoring provider */
  authorId: Scalars['ID']['output'];
  /** Free-text body content */
  body: Scalars['String']['output'];
  /** When the note was created */
  createdAt: Scalars['DateTime']['output'];
  /** Unique identifier */
  id: Scalars['ID']['output'];
  /** Internal patient-registry ID */
  patientId: Scalars['ID']['output'];
  /** When the note was last updated */
  updatedAt: Scalars['DateTime']['output'];
};

/**
 * Nutrient goals for a patient.
 * Single record per patient containing all nutrient targets.
 */
export type PlatformPatientNutrientGoals = {
  __typename?: 'PatientNutrientGoals';
  /** When the record was created */
  createdAt: Scalars['DateTime']['output'];
  /** List of nutrient goals */
  goals: Array<PlatformNutrientGoal>;
  /** Unique identifier */
  id: Scalars['ID']['output'];
  /** Healthie patient ID */
  patientId: Scalars['ID']['output'];
  /** When the record was last updated */
  updatedAt: Scalars['DateTime']['output'];
};

/** The latest completed visit-reason and support selections for one patient. */
export type PlatformPatientOnboardingAnswers = {
  __typename?: 'PatientOnboardingAnswers';
  healthieUserId: Scalars['ID']['output'];
  primaryVisitReason?: Maybe<Scalars['String']['output']>;
  requestedServices: Array<Scalars['String']['output']>;
  secondaryVisitReasons: Array<Scalars['String']['output']>;
  sourceRecords: Array<PlatformPatientOnboardingAnswersRecord>;
};

/** The submission that supplied a current onboarding answer. */
export type PlatformPatientOnboardingAnswersRecord = {
  __typename?: 'PatientOnboardingAnswersRecord';
  flowId: Scalars['String']['output'];
  flowVersion: Scalars['String']['output'];
  sessionCompletedAt: Scalars['DateTime']['output'];
  /** Opaque onboarding session handle, not the database primary key. */
  sessionId: Scalars['ID']['output'];
  stepId: Scalars['String']['output'];
  submissionId: Scalars['ID']['output'];
  submittedAt: Scalars['DateTime']['output'];
};

/**
 * Result of storing one patient-owned file in both destinations.
 * `recordCopyId` is null and `complete` is false until the patient-record copy exists.
 */
export type PlatformPatientOwnedFileDelivery = {
  __typename?: 'PatientOwnedFileDelivery';
  /** True only when both the monorepo document and the record copy exist. */
  complete: Scalars['Boolean']['output'];
  documentId: Scalars['ID']['output'];
  /** Id of the copy in the patient's record. Null while that copy is missing. */
  recordCopyId?: Maybe<Scalars['ID']['output']>;
};

/**
 * A patient's pharmacy benefit coverage on file. Routing fields are nullable: a
 * patient-reported row carries only what was legible on the card, while a
 * DoseSpot-enriched row populates them. `source` is `patient_reported` or
 * `dosespot`.
 */
export type PlatformPatientPharmacyCoverage = {
  __typename?: 'PatientPharmacyCoverage';
  memberId?: Maybe<Scalars['String']['output']>;
  patientHealthieId: Scalars['ID']['output'];
  payerId?: Maybe<Scalars['String']['output']>;
  pcn?: Maybe<Scalars['String']['output']>;
  rxBin?: Maybe<Scalars['String']['output']>;
  rxGroup?: Maybe<Scalars['String']['output']>;
  source: Scalars['String']['output'];
};

/**
 * A curated, aggregated view of the attributes that are "always relevant" about a
 * patient. Keyed by Healthie user id (the operational key shared by the care agent
 * and the ACCESS program). This first cut exposes a small, deliberately-chosen
 * handful of attributes; the internal source pattern makes adding more cheap.
 */
export type PlatformPatientProfile = {
  __typename?: 'PatientProfile';
  /** Date the patient's ACCESS enrollment successfully aligned, read live from access-program. Null when never aligned, or the read was unavailable. */
  accessAlignmentDate?: Maybe<Scalars['DateTime']['output']>;
  /** Current ACCESS enrollment status, read live from access-program. Null when the patient is not enrolled, the status is unrecognized, or the read was unavailable. */
  accessEnrollmentStatus?: Maybe<PlatformAccessEnrollmentStatus>;
  /** Current BP cuff delivery status. NOT_ORDERED until the app reports otherwise; null only when the read was temporarily unavailable (distinct from NOT_ORDERED). */
  bpCuffDeliveryStatus?: Maybe<PlatformBpCuffDeliveryStatus>;
  /** Whether the patient has confirmed a cuff shipping address. Null only when the read was temporarily unavailable. */
  bpCuffShippingAddressSubmitted?: Maybe<Scalars['Boolean']['output']>;
  /** Healthie user id of the patient. */
  healthieUserId: Scalars['ID']['output'];
  /** Canonical patient-registry UUID, resolved best-effort (null if unmapped). */
  patientId?: Maybe<Scalars['ID']['output']>;
  /** Canonical patient record, resolved by the patient-registry subgraph. */
  patientRecord?: Maybe<PlatformPatient>;
};

/** Canonical race choices currently collected by the shared Medical background form. */
export enum PlatformPatientRace {
  AmericanIndianOrAlaskaNative = 'AMERICAN_INDIAN_OR_ALASKA_NATIVE',
  Asian = 'ASIAN',
  BlackOrAfricanAmerican = 'BLACK_OR_AFRICAN_AMERICAN',
  ChooseNotToDisclose = 'CHOOSE_NOT_TO_DISCLOSE',
  NativeHawaiianOrPacificIslander = 'NATIVE_HAWAIIAN_OR_PACIFIC_ISLANDER',
  OtherRace = 'OTHER_RACE',
  White = 'WHITE'
}

/** A validation message from the patient's record, as the record wrote it. */
export type PlatformPatientRecordMessage = {
  __typename?: 'PatientRecordMessage';
  /** The field the message is about, as the record names it. Null when it is not about one field. */
  field?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** The outreach identity of a saved referral; contains no patient data. */
export type PlatformPatientReferralIdentity = {
  __typename?: 'PatientReferralIdentity';
  /** The referral UUID used in the link and RudderStack outreach. */
  id: Scalars['ID']['output'];
};

export type PlatformPatientScheduleCandidateInput = {
  durationMinutes: Scalars['Int']['input'];
  startTime: Scalars['DateTime']['input'];
};

export type PlatformPatientScheduleChecked = {
  __typename?: 'PatientScheduleChecked';
  conflicts: Array<PlatformPatientScheduleConflict>;
};

export type PlatformPatientScheduleConflict = {
  __typename?: 'PatientScheduleConflict';
  /** Null when this conflicts with an extra interval. */
  appointment?: Maybe<PlatformPatientBusyAppointment>;
  candidateIndex: Scalars['Int']['output'];
  extraBusyIntervalIndex?: Maybe<Scalars['Int']['output']>;
};

export type PlatformPatientScheduleConflictsInput = {
  /** At most 2000 candidate intervals. */
  candidates: Array<PlatformPatientScheduleCandidateInput>;
  excludeAppointmentHealthieIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  extraBusyIntervals?: InputMaybe<Array<PlatformPatientExtraBusyIntervalInput>>;
  /** Healthie user id for callers that already hold it. */
  patientHealthieId?: InputMaybe<Scalars['ID']['input']>;
  /** Canonical patient id. Supply exactly one of this and patientHealthieId. */
  patientId?: InputMaybe<Scalars['ID']['input']>;
};

export type PlatformPatientScheduleConflictsResult = PlatformPatientScheduleChecked | PlatformPatientScheduleNotFoundError;

export type PlatformPatientScheduleNotFoundError = {
  __typename?: 'PatientScheduleNotFoundError';
  message: Scalars['String']['output'];
};

/** Status of a patient record. */
export enum PlatformPatientStatus {
  /** Active patient */
  Active = 'ACTIVE',
  /** Inactive patient */
  Inactive = 'INACTIVE',
  /** Merged into another patient record */
  Merged = 'MERGED'
}

/** A payer in the synced payer directory, keyed by Healthie InsurancePlan.payer_id. */
export type PlatformPayer = {
  __typename?: 'Payer';
  /** Healthie InsurancePlan.id to attach as a patient's insurance policy at booking. Manually curated; null when not yet curated or no Healthie plan exists for this payer. */
  healthieInsurancePlanId?: Maybe<Scalars['String']['output']>;
  /** Display label. */
  label: Scalars['String']['output'];
  /** Healthie InsurancePlan.payer_id. */
  payerId: Scalars['String']['output'];
};

/** A payer the lead can pick on the payer step. Submitting stores `payerId` + `label`. */
export type PlatformPayerOption = {
  __typename?: 'PayerOption';
  /**
   * Stable slug for the big-five cards, used to pre-seed the step by query param
   * (`?payer=<key>`). Null for long-tail payers.
   */
  key?: Maybe<Scalars['String']['output']>;
  /** Label shown to the patient. */
  label: Scalars['String']['output'];
  /** Healthie InsurancePlan.payer_id — the coverage-check key. Medicare's is the `CMS` routing sentinel. */
  payerId: Scalars['String']['output'];
};

/**
 * The PAYER_PICKER dynamic step's options: the five big-payer cards and the
 * long-tail typeahead behind "Other".
 */
export type PlatformPayerOptions = {
  __typename?: 'PayerOptions';
  /** The big-five payer cards, in display order. */
  featured: Array<PlatformPayerOption>;
  /** The long-tail payer list behind the 'Other' typeahead, synced from the payer directory. */
  other: Array<PlatformPayerOption>;
};

/** Why a charge failed. Processor decline codes outside this set map to OTHER. */
export enum PlatformPaymentFailureCode {
  /** The card needs the patient to authenticate, which an off-session charge cannot do; nothing was collected. */
  AuthenticationRequired = 'AUTHENTICATION_REQUIRED',
  CardDeclined = 'CARD_DECLINED',
  ExpiredCard = 'EXPIRED_CARD',
  InsufficientFunds = 'INSUFFICIENT_FUNDS',
  /** The patient has no saved card. */
  NoSavedCard = 'NO_SAVED_CARD',
  Other = 'OTHER',
  /** The processor refused the request before any charge existed. */
  ProcessorRejected = 'PROCESSOR_REJECTED'
}

/** One appointment-fee charge, with its attempts. */
export type PlatformPaymentOperation = {
  __typename?: 'PaymentOperation';
  /** Original amount in the currency's minor unit. */
  amountCents: Scalars['Int']['output'];
  currency: PlatformCurrency;
  failureCode?: Maybe<PlatformPaymentFailureCode>;
  id: Scalars['ID']['output'];
  /** Number of the latest attempt payments made (1, 2, ...); null before any attempt. */
  latestAttemptNumber?: Maybe<Scalars['Int']['output']>;
  /** Status of the latest attempt (not of the operation); null before any attempt. */
  latestAttemptStatus?: Maybe<PlatformPaymentStatus>;
  /** The processor's id for this charge, for lookup in its dashboard; null before an attempt reaches it. */
  processorPaymentId?: Maybe<Scalars['ID']['output']>;
  /** Cumulative amount refunded, in minor units. 0 when nothing was refunded. */
  refundedAmountCents: Scalars['Int']['output'];
  status: PlatformPaymentStatus;
  updatedAt: Scalars['DateTime']['output'];
};

export type PlatformPaymentOperationPage = {
  __typename?: 'PaymentOperationPage';
  operations: Array<PlatformPaymentOperation>;
  pageInfo: PlatformPaymentPageInfo;
};

export type PlatformPaymentOperationsInput = {
  /** `pageInfo.endCursor` of the previous page. */
  after?: InputMaybe<Scalars['String']['input']>;
  /** Page size from 1 through 500. */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Only these operations. Null applies no id filter. */
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Only operations changed after this instant. Null applies no time filter. */
  updatedAfter?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Cursor state of a payment-operations page; same shape as PatientInvoicePageInfo. */
export type PlatformPaymentPageInfo = {
  __typename?: 'PaymentPageInfo';
  /** Pass as `after` for the next page; null on an empty page. */
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
};

export type PlatformPaymentProfile = {
  __typename?: 'PaymentProfile';
  patient: PlatformPatient;
  /** The patient's default card; null when they have none. */
  savedCard?: Maybe<PlatformSavedCard>;
};

/** A Stripe SetupIntent for saving a card on file; it never charges the patient. */
export type PlatformPaymentSetupIntent = {
  __typename?: 'PaymentSetupIntent';
  /** Stripe client secret confirmed by the browser. */
  clientSecret: Scalars['String']['output'];
};

/** Input for minting a no-charge Healthie-backed Stripe SetupIntent. */
export type PlatformPaymentSetupIntentInput = {
  /** Canonical registry patient id whose Healthie record will hold the card. */
  patientId: Scalars['ID']['input'];
};

/**
 * Status of a payment operation or attempt. An attempt moves only from PENDING
 * to SUCCEEDED or FAILED. An operation has its latest attempt's status, so a
 * FAILED operation is PENDING again while a repeat's new attempt is open;
 * SUCCEEDED moves only to PARTIALLY_REFUNDED, REFUNDED or DISPUTED.
 */
export enum PlatformPaymentStatus {
  Disputed = 'DISPUTED',
  Failed = 'FAILED',
  PartiallyRefunded = 'PARTIALLY_REFUNDED',
  /** The outcome is not known yet; call chargeAppointmentFee again with the same input. */
  Pending = 'PENDING',
  Refunded = 'REFUNDED',
  Succeeded = 'SUCCEEDED'
}

/**
 * Pharmacy benefit routing identifiers (BIN, PCN, member id, payer id).
 * Served from `medication_program.patient_rx_coverage` when a complete row
 * exists; otherwise populated once via automation and then cached.
 */
export type PlatformPharmacyBenefitCoverage = {
  __typename?: 'PharmacyBenefitCoverage';
  memberId: Scalars['String']['output'];
  payerId: Scalars['String']['output'];
  pcn: Scalars['String']['output'];
  rxBin: Scalars['String']['output'];
};

export type PlatformPlaceLabOrderInput = {
  /** Optional opaque provider catalog id for a single test or panel. */
  externalTestId?: InputMaybe<Scalars['String']['input']>;
  /** Optional opaque provider catalog ids for a curated bundle. */
  externalTestIds?: InputMaybe<Array<Scalars['String']['input']>>;
  modality: PlatformLabOrderModality;
  /** Walk-in: selected lab network id. Auto-pick when null. */
  networkId?: InputMaybe<Scalars['Int']['input']>;
  /** Optional override for Junction patient_address (billing / identification). Defaults to Healthie profile address. */
  patientAddressOverride?: InputMaybe<PlatformPatientAddressInput>;
  patientId: Scalars['ID']['input'];
  triggerReason: PlatformLabOrderTrigger;
};

export type PlatformPlaceLabOrderPayload = {
  __typename?: 'PlaceLabOrderPayload';
  created: Scalars['Boolean']['output'];
  labOrder: PlatformLabOrder;
};

export type PlatformPlaceLabOrderResult = PlatformIncompletePatientProfileError | PlatformPlaceLabOrderPayload | PlatformUnservicedZipCodeError;

/** Insurance plan network type. Closed (HMO/EPO) restricts enrollment matching to the patient's state. */
export enum PlatformPlanType {
  Closed = 'CLOSED',
  Open = 'OPEN'
}

/**
 * Relationship of the insurance policyholder to the patient. SELF is the
 * default when a caller omits `holderRelationship` on
 * `AttachInsurancePolicyInput`.
 */
export enum PlatformPolicyHolderRelationship {
  /** The patient is a child on a parent's policy */
  Child = 'CHILD',
  /** Someone else holds the policy */
  Other = 'OTHER',
  /** The patient is the policyholder */
  Self = 'SELF',
  /** The patient's spouse holds the policy */
  Spouse = 'SPOUSE'
}

export type PlatformPrepareSupportAttachmentInput = {
  contentType: Scalars['String']['input'];
  fileSize: Scalars['Int']['input'];
  filename: Scalars['String']['input'];
};

export type PlatformPrepareSupportAttachmentPayload = {
  __typename?: 'PrepareSupportAttachmentPayload';
  error?: Maybe<PlatformSupportError>;
  upload?: Maybe<PlatformSupportAttachmentUpload>;
};

/** One prescriber row in the chooser. */
export type PlatformPrescriberOption = {
  __typename?: 'PrescriberOption';
  /**
   * This prescriber's earliest open GLP-1 initial consult in the 14-day booking
   * window that the session's network policy surfaces. Null means none; the row
   * is shown but cannot be chosen.
   */
  nextOpening?: Maybe<Scalars['DateTime']['output']>;
  prescriber: PlatformPrescriberProfile;
};

/**
 * Onboarding-owned prescriber snapshot. The canonical source remains
 * provider-matching's `Provider.profile`; onboarding copies it because its
 * Next.js client consumes this subgraph directly.
 */
export type PlatformPrescriberProfile = {
  __typename?: 'PrescriberProfile';
  /** Display-ready credentials, for example `MSN, FNP-C`. Null when absent; clients show the name alone. */
  credentials?: Maybe<Scalars['String']['output']>;
  /** Display name. Null when the provider has no match profile or no name on file. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Headshot URL. Null when none is configured; clients show initials. */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** Canonical provider-registry id. The same id across chooser, booking and celebration. */
  providerId: Scalars['ID']['output'];
  /** Short biography. Null when absent; clients hide the line. */
  shortBio?: Maybe<Scalars['String']['output']>;
};

export type PlatformPrescriptionBackfillInput = {
  /** Omit or leave empty to backfill all GLP-1 enrollments. */
  patientHealthieIds?: InputMaybe<Array<Scalars['String']['input']>>;
  syncPhoton?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * A prescription awaiting a patient-reported pickup date. Returned by
 * `prescriptionPendingPickup` to drive the patient-app prompt asking when the
 * patient collected their prescription.
 */
export type PlatformPrescriptionPendingPickup = {
  __typename?: 'PrescriptionPendingPickup';
  /** The tracked medication opened after pickup is recorded. */
  medicationId: Scalars['ID']['output'];
  pickedUpAt?: Maybe<Scalars['DateTime']['output']>;
  prescriptionId: Scalars['ID']['output'];
};

export type PlatformPrescriptionPhotoLink = {
  __typename?: 'PrescriptionPhotoLink';
  /** Why the file was refused. Set only when `status` is `REJECTED`. */
  message?: Maybe<Scalars['String']['output']>;
  status: PlatformPrescriptionPhotoLinkStatus;
};

export enum PlatformPrescriptionPhotoLinkStatus {
  Incomplete = 'INCOMPLETE',
  NeedsUpload = 'NEEDS_UPLOAD',
  /**
   * The file was not a JPEG or PNG, or it was larger than 8MB.
   * `message` says which. Nothing was stored. Only
   * `submitPrescriptionPhotoLink` returns this.
   */
  Rejected = 'REJECTED',
  Saved = 'SAVED',
  Unavailable = 'UNAVAILABLE'
}

export type PlatformPrescriptionReviewDecision = {
  __typename?: 'PrescriptionReviewDecision';
  decidedAt: Scalars['DateTime']['output'];
  decision: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  reason?: Maybe<Scalars['String']['output']>;
};

export type PlatformPrescriptionReviewPatient = {
  __typename?: 'PrescriptionReviewPatient';
  decision?: Maybe<PlatformPrescriptionReviewDecision>;
  /** @deprecated Use patient.dob */
  dob?: Maybe<Scalars['String']['output']>;
  /** Caller's open requests for this patient, oldest first. Stubs: id only. */
  documentRequests: Array<PlatformDocumentRequest>;
  enrolledAt: Scalars['DateTime']['output'];
  enrollmentId: Scalars['ID']['output'];
  /** @deprecated Use patient.fullName */
  fullName?: Maybe<Scalars['String']['output']>;
  /** True when any PA for this patient reached a terminal payer outcome (approved, denied, or other). Drives the post-PA prescribe modal — not prescribing eligibility. */
  hasResolvedPriorAuth: Scalars['Boolean']['output'];
  /** Latest occurred GLP-1 initial or follow-up visit for this patient. */
  lastOccurredGlp1Appointment?: Maybe<PlatformGlp1Appointment>;
  patient: PlatformMedicationProgramPatient;
  /** @deprecated Use patient.patientHealthieId */
  patientHealthieId: Scalars['ID']['output'];
  /** Caller-scoped free-text notes for this patient (keyed by query providerHealthieId). */
  prescriberNotes?: Maybe<Scalars['String']['output']>;
  prescription?: Maybe<PlatformMedicationProgramPrescription>;
  priorAuth?: Maybe<PlatformPrescriptionReviewPriorAuth>;
  /** Derived workflow stage for this patient. */
  stage: Scalars['String']['output'];
};

export type PlatformPrescriptionReviewPriorAuth = {
  __typename?: 'PrescriptionReviewPriorAuth';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  /** Develop's outcome.detail_code. */
  outcomeDetailCode?: Maybe<Scalars['String']['output']>;
  /** Develop's outcome.detail — payer-facing human-readable outcome text. */
  outcomeDetailMessage?: Maybe<Scalars['String']['output']>;
  outcomeResult?: Maybe<PlatformPaOutcomeResult>;
  status: PlatformPriorAuthorizationStatus;
  submittedAt: Scalars['DateTime']['output'];
};

/** Paginated prescription review list for a provider, filtered by workflow stage. */
export type PlatformPrescriptionReviewResult = {
  __typename?: 'PrescriptionReviewResult';
  patients: Array<PlatformPrescriptionReviewPatient>;
  stageCounts: PlatformPrescriptionReviewStageCounts;
  totalCount: Scalars['Int']['output'];
};

export type PlatformPrescriptionReviewStageCounts = {
  __typename?: 'PrescriptionReviewStageCounts';
  awaitingInformation: Scalars['Int']['output'];
  needsDecision: Scalars['Int']['output'];
  notPrescribed: Scalars['Int']['output'];
  paStatus: Scalars['Int']['output'];
  prescribed: Scalars['Int']['output'];
};

/**
 * Simplified prescription lifecycle status. Healthie's and Photon's raw
 * statuses collapse into three operational buckets:
 *
 * - `ACTIVE`   — dispensed / pharmacy-verified (Healthie) or active/depleted (Photon)
 * - `PENDING`  — in-flight, not yet dispensed
 * - `CANCELED` — canceled, expired, or otherwise inactive
 */
export enum PlatformPrescriptionStatus {
  Active = 'ACTIVE',
  Canceled = 'CANCELED',
  Pending = 'PENDING'
}

/**
 * A single supporting-document PDF generated for a PriorAuthorization,
 * stored in S3. `downloadUrl` is a short-lived presigned URL minted on
 * each read; callers download with browser-native semantics.
 */
export type PlatformPriorAuthDocument = {
  __typename?: 'PriorAuthDocument';
  downloadUrl: Scalars['String']['output'];
  generatedAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

/**
 * UI or automation surface that invoked `submitGlp1PriorAuth`. Used only on the
 * privacy-safe duplicate-prevented log — never to authorize the write.
 */
export enum PlatformPriorAuthSubmitSurface {
  PrescriptionReview = 'PRESCRIPTION_REVIEW',
  PrescriptionTasks = 'PRESCRIPTION_TASKS'
}

export type PlatformPriorAuthorization = {
  __typename?: 'PriorAuthorization';
  /** Server-derived soft link to the most-recent BenefitsCheck at submit time. */
  benefitsCheckId?: Maybe<Scalars['ID']['output']>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Populated when outcome is DENIED and Develop returned denial_reason_analysis. */
  denialReasonAnalysis?: Maybe<PlatformPaDenialReasonAnalysis>;
  developCaseId?: Maybe<Scalars['String']['output']>;
  diagnoses: Array<PlatformDiagnosis>;
  /** Populated when status = FAILED with a pre-submit failure on our side. */
  failureCode?: Maybe<Scalars['String']['output']>;
  failureMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Populated when status = NOT_SUBMITTED; Develop's outcome.detail_code. */
  notSubmittedReason?: Maybe<Scalars['String']['output']>;
  /** Populated when status = COMPLETE; null otherwise. */
  outcome?: Maybe<PlatformPaOutcome>;
  patientHealthieId: Scalars['ID']['output'];
  product: PlatformGlp1Product;
  /** Exact GLP-1 SKU used for PA submission. Null is treated as the product default. */
  productSkuId?: Maybe<Scalars['String']['output']>;
  programType: PlatformProgramType;
  providerHealthieId: Scalars['ID']['output'];
  status: PlatformPriorAuthorizationStatus;
  submittedAt: Scalars['DateTime']['output'];
};

/**
 * Live Develop PA detail for a single case — DB-backed PriorAuthorization plus
 * on-demand activity_log / message_thread from GET /prior-authorization/{id}.
 * Not for list views (Develop fetch is slow).
 */
export type PlatformPriorAuthorizationExtended = {
  __typename?: 'PriorAuthorizationExtended';
  activityLog: Array<PlatformPaActivityLogEntry>;
  messageThread?: Maybe<PlatformPaMessageThread>;
  priorAuthorization: PlatformPriorAuthorization;
};

export enum PlatformPriorAuthorizationStatus {
  Cancelled = 'CANCELLED',
  Complete = 'COMPLETE',
  Failed = 'FAILED',
  NotSubmitted = 'NOT_SUBMITTED',
  Pending = 'PENDING'
}

/**
 * Progress of the onboarding interview — a read-time projection, never stored.
 * NOT_STARTED/IN_PROGRESS/COMPLETED derive from how many fields are filled; PAUSED projects
 * from the explicit pausedAt opt-out fact.
 */
export enum PlatformProfileCompleteness {
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  NotStarted = 'NOT_STARTED',
  Paused = 'PAUSED'
}

export enum PlatformProfileFieldConfidence {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

/**
 * The interview field keys Perry can capture — a subset of the stored base-profile columns.
 * foodEnvironment/household are stored columns but NOT here: they are populated outside the
 * interview, so they are not interview-capturable and don't count toward completeness.
 */
export enum PlatformProfileFieldKey {
  Beverages = 'BEVERAGES',
  Constraints = 'CONSTRAINTS',
  CulturalFoodContext = 'CULTURAL_FOOD_CONTEXT',
  EatingDay = 'EATING_DAY',
  FoodPreferences = 'FOOD_PREFERENCES',
  HealthGoals = 'HEALTH_GOALS',
  PastAttempts = 'PAST_ATTEMPTS',
  Schedule = 'SCHEDULE',
  WhatSuccessLooksLike = 'WHAT_SUCCESS_LOOKS_LIKE',
  WhyHere = 'WHY_HERE'
}

/** Trust level for a captured fact. */
export enum PlatformProfileFieldProvenance {
  Inferred = 'INFERRED',
  Prefilled = 'PREFILLED',
  Stated = 'STATED'
}

/** A care program that patients can be enrolled in. */
export type PlatformProgram = {
  __typename?: 'Program';
  /** When the program was created */
  createdAt: Scalars['DateTime']['output'];
  /** Description of the program */
  description?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the program */
  id: Scalars['ID']['output'];
  /** Human-readable program name (e.g., 'MDPP') */
  name: Scalars['String']['output'];
  /** When the program was last updated */
  updatedAt: Scalars['DateTime']['output'];
};

export enum PlatformProgramType {
  Glp_1 = 'GLP_1'
}

/**
 * A provider record that consolidates identity information from multiple systems.
 * Central source of truth for provider identity mapping across Airtable, Healthie, Intercom, and Customer.io.
 */
export type PlatformProvider = {
  __typename?: 'Provider';
  /** When the provider record was created */
  createdAt: Scalars['DateTime']['output'];
  /** Email addresses (filtered by default to primary only) */
  emails: Array<PlatformProviderEmail>;
  /** The provider's primary, active external id for the given system, or null if there is none. */
  externalId?: Maybe<PlatformProviderExternalId>;
  /** External system identifiers (filtered by default to primary/active only) */
  externalIds: Array<PlatformProviderExternalId>;
  /** Unique identifier for the provider (internal ID) */
  id: Scalars['ID']['output'];
  /** When the provider data was last synced from Airtable (via webhook) */
  lastSyncedFromAirtableAt?: Maybe<Scalars['DateTime']['output']>;
  /** When the provider data was last synced from Healthie (via webhook) */
  lastSyncedFromHealthieAt?: Maybe<Scalars['DateTime']['output']>;
  /** When status is MERGED, the id of the surviving provider this record was consolidated into; null for active records */
  mergedIntoId?: Maybe<Scalars['ID']['output']>;
  /**
   * Providers merged directly or transitively into this active identity, ordered by ID.
   * Excludes this provider and unrelated identities. Fails rather than returning partial
   * lineage if this provider is not an active root or the lineage exceeds 100 records.
   */
  mergedProviders?: Maybe<Array<PlatformProvider>>;
  /** National Provider Identifier (NPI) - a 10-digit unique ID for US healthcare providers */
  npi?: Maybe<Scalars['String']['output']>;
  /**
   * The organization this provider belongs to in Healthie, read live from
   * Healthie on each request. It is the provider's direct organization, so for a
   * sub-org member it is the sub-org; follow `parent` for the top-level one.
   * Resolved from the provider's own primary, active HEALTHIE external id.
   *
   * Null with no error when the provider has no such id, Healthie has no user
   * with it, or the user has no organization. Null does not mean "the Berry
   * Street organization".
   *
   * Errors (`extensions.code`), each nulling only this field:
   * - BAD_GATEWAY: Healthie timed out, was unreachable, or answered with an error.
   *   Providers are read 50 per Healthie request, so one failed request returns
   *   this error on every provider in that batch.
   */
  organization?: Maybe<PlatformProviderOrganization>;
  /**
   * Whether this provider matches a patient with these facts, by the same rule
   * matchPrescribers and matchDietitians apply: licensed in stateCode, and —
   * when payerId is set — holding a bookable enrollment in the payer's group
   * (in-state only for closed plans). Role-agnostic: callers that need a role
   * read profile.role. Ranking, availability and quality floors never affect
   * it. False for a provider with no match profile.
   */
  patientMatch: Scalars['Boolean']['output'];
  /**
   * Whether this provider can be billed to the given payer for a consult on
   * dateOfService, computed as-of that date from the provider's credentialing
   * (licensure + payer enrollment) — the same source of truth matchPrescribers
   * uses, never a cached/patient-level flag. Enrollment still in "Health Plan
   * Processing" or otherwise not Effective as of dateOfService resolves
   * to NOT_BILLABLE. (Bookability gates matching, not billing.)
   */
  payerBillability: PlatformProviderPayerBillability;
  /**
   * Read-only public and booking profile projected from provider-matching's
   * provider row. Null when the provider has no match profile. With the
   * provider-profile-role-source flag on, role is provider-profile's clinical
   * role, and a provider with a clinical role but no match profile gets a
   * profile whose other fields are null, empty or false. A match-row provider
   * with no clinical role keeps its match row's role; once Provider.profile
   * moves to provider-profile (BSE-3895 step 2) it gets null instead. When the clinical role
   * cannot be read, a match-row provider keeps its match row's role and a
   * provider with no match profile gets null, as with the flag off.
   */
  profile?: Maybe<PlatformProviderProfile>;
  /** Provider status */
  status: PlatformProviderStatus;
  /** When the provider record was last updated */
  updatedAt: Scalars['DateTime']['output'];
};


/**
 * A provider record that consolidates identity information from multiple systems.
 * Central source of truth for provider identity mapping across Airtable, Healthie, Intercom, and Customer.io.
 */
export type PlatformProviderEmailsArgs = {
  includeAll?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * A provider record that consolidates identity information from multiple systems.
 * Central source of truth for provider identity mapping across Airtable, Healthie, Intercom, and Customer.io.
 */
export type PlatformProviderExternalIdArgs = {
  system: PlatformProviderExternalSystem;
};


/**
 * A provider record that consolidates identity information from multiple systems.
 * Central source of truth for provider identity mapping across Airtable, Healthie, Intercom, and Customer.io.
 */
export type PlatformProviderExternalIdsArgs = {
  includeAll?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * A provider record that consolidates identity information from multiple systems.
 * Central source of truth for provider identity mapping across Airtable, Healthie, Intercom, and Customer.io.
 */
export type PlatformProviderPatientMatchArgs = {
  payerId?: InputMaybe<Scalars['String']['input']>;
  planType?: InputMaybe<PlatformPlanType>;
  stateCode: Scalars['String']['input'];
};


/**
 * A provider record that consolidates identity information from multiple systems.
 * Central source of truth for provider identity mapping across Airtable, Healthie, Intercom, and Customer.io.
 */
export type PlatformProviderPayerBillabilityArgs = {
  dateOfService: Scalars['Date']['input'];
  payerId: Scalars['String']['input'];
  planType?: InputMaybe<PlatformPlanType>;
  stateCode: Scalars['String']['input'];
};

/** All conflicts for a single provider, broken down by type. */
export type PlatformProviderAllConflicts = {
  __typename?: 'ProviderAllConflicts';
  /** Email conflict, if any (null if no email conflict exists) */
  emailConflict?: Maybe<PlatformProviderEmailConflict>;
  /** External ID conflicts grouped by system */
  externalIdConflicts: Array<PlatformProviderExternalIdConflict>;
  /** The provider record */
  provider: PlatformProvider;
  /** Internal provider ID */
  providerId: Scalars['ID']['output'];
};

/** One Berry Street provider assigned to a patient in one role. */
export type PlatformProviderAssignment = {
  __typename?: 'ProviderAssignment';
  /** When this provider took the role. Unchanged when the same provider is assigned again. */
  assignedAt: Scalars['DateTime']['output'];
  provider: PlatformProvider;
  role: PlatformProviderAssignmentRole;
};

/**
 * What the provider is to this patient. Distinct from provider-matching's
 * `ProviderRole`, which is what kind of provider someone is.
 */
export enum PlatformProviderAssignmentRole {
  Dietitian = 'DIETITIAN',
  Prescriber = 'PRESCRIBER'
}

/**
 * One provider's open slots. Returned aligned to the requested `providerIds`,
 * including providers with no slots — coalescing across providers, and choosing
 * one, is the caller's policy. A slot whose interval overlaps another session's
 * hold is already excluded (see `AppointmentAvailabilityInput.sessionId`); this
 * domain never returns a slot it knows conflicts with a live hold.
 */
export type PlatformProviderAvailability = {
  __typename?: 'ProviderAvailability';
  /** Canonical provider-registry id. */
  providerId: Scalars['ID']['output'];
  /** Open start times, deduped by instant and ascending. Empty when the provider has no openings, or none are cached for it yet. */
  slots: Array<PlatformAppointmentAvailabilitySlot>;
};

export type PlatformProviderBookingSettings = {
  __typename?: 'ProviderBookingSettings';
  /** Raw Airtable notice floor. Null means the 1440-minute default; values at or above 1440 are valid stricter settings and are never clamped. */
  minimumNoticeMinutes?: Maybe<Scalars['Int']['output']>;
  /** UI projection: true only when the stored positive notice floor is below the 24-hour default. */
  sameDayBookingEnabled: Scalars['Boolean']['output'];
};

/** A provider-authored GetStream message accepted or recovered by its stable id. */
export type PlatformProviderChatMessageDelivery = {
  __typename?: 'ProviderChatMessageDelivery';
  messageId: Scalars['ID']['output'];
};

/** A provider-registry provider's stored clinical role. */
export type PlatformProviderClinicalRole = {
  __typename?: 'ProviderClinicalRole';
  /** provider-registry Provider.id. */
  providerId: Scalars['ID']['output'];
  /**
   * PRESCRIBER when any of the provider's active Airtable links in
   * provider-registry (primary or not) points at an RD Funnel row with
   * is_prescriber ticked, RD when its linked rows exist and none is ticked. As of
   * the last successful sync.
   */
  role: PlatformProviderRole;
};

/** Cursor-based pagination info for provider conflict queries */
export type PlatformProviderConflictPageInfo = {
  __typename?: 'ProviderConflictPageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

/**
 * Summary of all conflict types for a single provider.
 * Used in the paginated providersWithConflicts list.
 */
export type PlatformProviderConflictSummary = {
  __typename?: 'ProviderConflictSummary';
  /** Number of email conflict groups (0 or 1, since emails are not per-system) */
  emailConflictCount: Scalars['Int']['output'];
  /** Number of external ID conflict groups (one per system in conflict) */
  externalIdConflictCount: Scalars['Int']['output'];
  /** The provider record */
  provider: PlatformProvider;
  /** Internal provider ID */
  providerId: Scalars['ID']['output'];
  /** Total number of conflict groups across all types */
  totalConflictCount: Scalars['Int']['output'];
};

/** Paginated list of providers with conflicts */
export type PlatformProviderConflictSummaryConnection = {
  __typename?: 'ProviderConflictSummaryConnection';
  nodes: Array<PlatformProviderConflictSummary>;
  pageInfo: PlatformProviderConflictPageInfo;
  totalCount: Scalars['Int']['output'];
};

/** Paginated list of providers */
export type PlatformProviderConnection = {
  __typename?: 'ProviderConnection';
  nodes: Array<PlatformProvider>;
  pageInfo: PlatformProviderConflictPageInfo;
  totalCount: Scalars['Int']['output'];
};

/** One credential a provider lists, e.g. RDN. */
export type PlatformProviderCredential = {
  __typename?: 'ProviderCredential';
  /** Icon grouping. Null when the acronym is not in the curated definitions. */
  category?: Maybe<PlatformCredentialCategory>;
  /** Acronym in display casing, e.g. `PhD`. */
  displayCode: Scalars['String']['output'];
  /** Spelled-out name, e.g. `Registered Dietitian Nutritionist`. Null when the acronym is not in the curated definitions. */
  fullName?: Maybe<Scalars['String']['output']>;
};

/**
 * A document Berry Street publishes to providers. Catalog fields only — nothing
 * on this type depends on who is asking, so it is safe to resolve by reference.
 */
export type PlatformProviderDocument = {
  __typename?: 'ProviderDocument';
  /** Current published version. Exactly one version of a document is published at a time. */
  currentVersion: PlatformProviderDocumentVersion;
  id: Scalars['ID']['output'];
  /** Whether providers in the document's audience must attest to the current version */
  required: Scalars['Boolean']['output'];
  /** Document title shown wherever the document is listed */
  title: Scalars['String']['output'];
};

/** Which providers this document is assigned to. */
export enum PlatformProviderDocumentAudience {
  AllProviders = 'ALL_PROVIDERS',
  Prescribers = 'PRESCRIBERS'
}

/**
 * Authorized access to the current published file of an assigned document.
 * The signed URL's expiry starts when this query runs.
 */
export type PlatformProviderDocumentFile = {
  __typename?: 'ProviderDocumentFile';
  contentType: Scalars['String']['output'];
  documentId: Scalars['ID']['output'];
  /** Short-lived signed URL */
  downloadUrl: Scalars['String']['output'];
  expiresAt: Scalars['DateTime']['output'];
  versionId: Scalars['ID']['output'];
  versionLabel: Scalars['String']['output'];
};

export type PlatformProviderDocumentFileAccess = PlatformProviderDocumentFile | PlatformProviderDocumentFileUnavailable;

/** The document is assigned, but its current version has no published file object yet. */
export type PlatformProviderDocumentFileUnavailable = {
  __typename?: 'ProviderDocumentFileUnavailable';
  documentId: Scalars['ID']['output'];
  versionId: Scalars['ID']['output'];
  versionLabel: Scalars['String']['output'];
};

/**
 * Catalog lifecycle of a document. DRAFT has never been published. ACTIVE has a
 * current published version. RETIRED keeps versions and attestations but is
 * excluded from assignment and file access.
 */
export enum PlatformProviderDocumentLifecycleStatus {
  Active = 'ACTIVE',
  Draft = 'DRAFT',
  Retired = 'RETIRED'
}

/**
 * Internal catalog snapshot for a slug: metadata, lifecycle, and every version.
 * Used to decide whether to request an upload, reuse a draft, or publish with
 * the correct expectedCurrentVersionId.
 */
export type PlatformProviderDocumentPublishingState = {
  __typename?: 'ProviderDocumentPublishingState';
  audience: PlatformProviderDocumentAudience;
  displayOrder: Scalars['Int']['output'];
  documentId: Scalars['ID']['output'];
  owner?: Maybe<Scalars['String']['output']>;
  required: Scalars['Boolean']['output'];
  slug: Scalars['String']['output'];
  status: PlatformProviderDocumentLifecycleStatus;
  title: Scalars['String']['output'];
  versions: Array<PlatformProviderDocumentPublishingVersion>;
};

/** One version row as seen by the internal publishing API. */
export type PlatformProviderDocumentPublishingVersion = {
  __typename?: 'ProviderDocumentPublishingVersion';
  contentType?: Maybe<Scalars['String']['output']>;
  fileSizeBytes?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  /** When this version was published; null while DRAFT */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  status: PlatformProviderDocumentVersionLifecycleStatus;
  /** Human-readable version label, e.g. 1.7 */
  versionLabel: Scalars['String']['output'];
};

/** Short-lived signed PUT target for the draft object. Do not persist or log the URL. */
export type PlatformProviderDocumentUploadTarget = {
  __typename?: 'ProviderDocumentUploadTarget';
  documentId: Scalars['ID']['output'];
  expiresAt: Scalars['DateTime']['output'];
  /** Short-lived signed PUT URL */
  uploadUrl: Scalars['String']['output'];
  versionId: Scalars['ID']['output'];
};

/** A published version of a provider document. */
export type PlatformProviderDocumentVersion = {
  __typename?: 'ProviderDocumentVersion';
  /** Version ID — the unit an attestation binds to */
  id: Scalars['ID']['output'];
  /** When this version was published */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Human-readable version label, e.g. 1.7 */
  versionLabel: Scalars['String']['output'];
};

/**
 * Lifecycle of one version row. DRAFT can receive an upload and be published.
 * PUBLISHED is the current file providers attest to. SUPERSEDED stays for audit
 * and is never overwritten.
 */
export enum PlatformProviderDocumentVersionLifecycleStatus {
  Draft = 'DRAFT',
  Published = 'PUBLISHED',
  Superseded = 'SUPERSEDED'
}

/**
 * Email address for a provider.
 * Each email address is unique across all providers (case-insensitive).
 * A provider can have multiple email addresses with one marked as primary.
 */
export type PlatformProviderEmail = {
  __typename?: 'ProviderEmail';
  /** When this email was added */
  createdAt: Scalars['DateTime']['output'];
  /** The email address */
  emailAddress: Scalars['String']['output'];
  /** Unique identifier for this email record */
  id: Scalars['ID']['output'];
  /** Whether this is the primary/active email for this provider */
  isPrimary: Scalars['Boolean']['output'];
  /**
   * Where this address came from. Null means unknown / not yet claimed.
   * Upgraded toward higher authority; claim does not change status,
   * isPrimary, or resolvedAt.
   */
  origin?: Maybe<PlatformProviderEmailOrigin>;
  /** Reference to the provider this email belongs to */
  providerId: Scalars['ID']['output'];
  /** Note recorded by CS when this record was involved in a conflict resolution */
  resolutionNote?: Maybe<Scalars['String']['output']>;
  /** When this record was involved in a conflict resolution */
  resolvedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Current status of this email */
  status: PlatformEmailStatus;
  /** When this email was last updated */
  updatedAt: Scalars['DateTime']['output'];
};

/**
 * Detected conflict in email addresses within a provider.
 * Conflicts occur when a provider has multiple email addresses but none marked as primary.
 */
export type PlatformProviderEmailConflict = {
  __typename?: 'ProviderEmailConflict';
  /** List of conflicting emails for this provider */
  emails: Array<PlatformProviderEmail>;
  /** Provider ID with the conflict */
  providerId: Scalars['ID']['output'];
  /** Suggested primary email address (oldest by createdAt) */
  suggestedPrimary: Scalars['String']['output'];
};

/** Paginated list of provider email conflicts */
export type PlatformProviderEmailConflictConnection = {
  __typename?: 'ProviderEmailConflictConnection';
  nodes: Array<PlatformProviderEmailConflict>;
  pageInfo: PlatformProviderConflictPageInfo;
  totalCount: Scalars['Int']['output'];
};

/**
 * Provenance of a provider email address.
 * Upgraded toward higher authority: airtable_email > healthie > clerk >
 * airtable_preferred. A higher rung may overwrite a lower one; never the
 * reverse, never an equal. Null is claimed by anything.
 */
export enum PlatformProviderEmailOrigin {
  /** Airtable identity Email (source of truth for primary) */
  AirtableEmail = 'AIRTABLE_EMAIL',
  /** Airtable Preferred Email (secondary by construction) */
  AirtablePreferred = 'AIRTABLE_PREFERRED',
  /** Clerk login address */
  Clerk = 'CLERK',
  /** Healthie account address */
  Healthie = 'HEALTHIE'
}

/**
 * Progress for an email-origin backfill run. Superset of the four fields the
 * shared start helper maps for resume (`pagesProcessed`, `totalProcessed`,
 * `totalFailed`, `cursor`) plus origin counters. Units differ by field —
 * do not sum email-row buckets to provider counts.
 */
export type PlatformProviderEmailOriginBackfillProgress = {
  __typename?: 'ProviderEmailOriginBackfillProgress';
  /** Providers whose primary external id has no upstream record. */
  couldNotMatch: Scalars['Int']['output'];
  /**
   * Last provider page boundary as JSON `{ createdAt, id }`. Null at start
   * and at completion. Copy into start `cursor` to resume.
   */
  cursor?: Maybe<Scalars['String']['output']>;
  /**
   * Providers with an active primary external id for this stage's system —
   * the page denominator. Recounted at the start of each execution.
   */
  eligiblePopulation: Scalars['Int']['output'];
  /** Pages of eligible providers processed across continueAsNew rotations. */
  pagesProcessed: Scalars['Int']['output'];
  /** Providers whose process threw after activity retries. Non-fatal. */
  totalFailed: Scalars['Int']['output'];
  /** Providers processed (matched + skipped + failed) across rotations. */
  totalProcessed: Scalars['Int']['output'];
  /** Email rows that would (or did) claim a null origin. */
  wouldClaim: Scalars['Int']['output'];
  /** Email rows left alone: equal/higher origin, inactive, or resolvedAt. */
  wouldSkip: Scalars['Int']['output'];
  /** Email rows that would (or did) upgrade to a higher-authority origin. */
  wouldUpgrade: Scalars['Int']['output'];
};

/** A snapshot of a single email-origin backfill workflow execution. */
export type PlatformProviderEmailOriginBackfillRun = {
  __typename?: 'ProviderEmailOriginBackfillRun';
  closedAt?: Maybe<Scalars['DateTime']['output']>;
  progress?: Maybe<PlatformProviderEmailOriginBackfillProgress>;
  runId?: Maybe<Scalars['ID']['output']>;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  state: PlatformBackfillState;
  triggeredBy?: Maybe<Scalars['String']['output']>;
  /** Stable per-stage workflow id. */
  workflowId: Scalars['ID']['output'];
};

/**
 * Which upstream system the email-origin backfill walks. Each stage has its
 * own Temporal workflow id so cursors and double-start do not cross.
 */
export enum PlatformProviderEmailOriginBackfillStage {
  Airtable = 'AIRTABLE',
  Clerk = 'CLERK',
  Healthie = 'HEALTHIE'
}

/**
 * Top-level status for every email-origin backfill stage. Operator resume
 * resets per-bucket counters; continueAsNew does not. Cursor prevents redo.
 */
export type PlatformProviderEmailOriginBackfillStatus = {
  __typename?: 'ProviderEmailOriginBackfillStatus';
  airtable?: Maybe<PlatformProviderEmailOriginBackfillRun>;
  clerk?: Maybe<PlatformProviderEmailOriginBackfillRun>;
  healthie?: Maybe<PlatformProviderEmailOriginBackfillRun>;
};

export type PlatformProviderEventError = {
  __typename?: 'ProviderEventError';
  code: PlatformProviderEventErrorCode;
  message: Scalars['String']['output'];
};

export enum PlatformProviderEventErrorCode {
  InvalidInput = 'INVALID_INPUT',
  NotConfigured = 'NOT_CONFIGURED',
  ProviderNotFound = 'PROVIDER_NOT_FOUND',
  Unavailable = 'UNAVAILABLE'
}

/**
 * External system identifier for a provider.
 * Maps provider identity across multiple platforms (Airtable, Healthie, Intercom, Customer.io).
 */
export type PlatformProviderExternalId = {
  __typename?: 'ProviderExternalId';
  /** When this external ID was created */
  createdAt: Scalars['DateTime']['output'];
  /** The actual ID value in the external system */
  externalId: Scalars['String']['output'];
  /** Unique identifier for this external ID record */
  id: Scalars['ID']['output'];
  /** Whether this is the primary/active ID for this system */
  isPrimary: Scalars['Boolean']['output'];
  /** Reference to the provider this ID belongs to */
  providerId: Scalars['ID']['output'];
  /** Note recorded by CS when this record was involved in a conflict resolution */
  resolutionNote?: Maybe<Scalars['String']['output']>;
  /** When this record was involved in a conflict resolution */
  resolvedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Current status of this external ID */
  status: PlatformExternalIdStatus;
  /** External system name */
  system: PlatformProviderExternalSystem;
  /** When this external ID was last updated */
  updatedAt: Scalars['DateTime']['output'];
};

/**
 * Detected conflict in external IDs within a provider-system combination.
 * Conflicts occur when a provider has multiple IDs from the same system but none marked as primary.
 */
export type PlatformProviderExternalIdConflict = {
  __typename?: 'ProviderExternalIdConflict';
  /** List of conflicting external IDs for this provider-system */
  externalIds: Array<PlatformProviderExternalId>;
  /** Provider ID with the conflict */
  providerId: Scalars['ID']['output'];
  /** Suggested primary external ID (oldest by createdAt) */
  suggestedPrimary: Scalars['String']['output'];
  /** External system name */
  system: PlatformProviderExternalSystem;
};

/** Paginated list of provider external ID conflicts */
export type PlatformProviderExternalIdConflictConnection = {
  __typename?: 'ProviderExternalIdConflictConnection';
  nodes: Array<PlatformProviderExternalIdConflict>;
  pageInfo: PlatformProviderConflictPageInfo;
  totalCount: Scalars['Int']['output'];
};

/** External system names that providers can have identifiers in. */
export enum PlatformProviderExternalSystem {
  /** Airtable RD Funnel (recruitment/primary) */
  Airtable = 'AIRTABLE',
  /** Clerk authentication (Berry Street Provider Portal instance) */
  ClerkProviderPortal = 'CLERK_PROVIDER_PORTAL',
  /** Customer.io marketing automation platform */
  CustomerIo = 'CUSTOMER_IO',
  /** Healthie EHR system */
  Healthie = 'HEALTHIE',
  /** Healthify (Navi Health) — populated by the Berry Street identity propagation webhook */
  Healthify = 'HEALTHIFY',
  /** Intercom customer communication platform */
  Intercom = 'INTERCOM'
}

/** A snapshot of a single Navi Health backfill workflow execution. */
export type PlatformProviderNavihealthBackfillRun = {
  __typename?: 'ProviderNavihealthBackfillRun';
  closedAt?: Maybe<Scalars['DateTime']['output']>;
  progress?: Maybe<PlatformBackfillProgress>;
  /**
   * Run id of the latest execution. Null when the start helper synthesizes
   * a snapshot because the post-start `describe` raced ahead of Temporal
   * indexing the new execution — admin should retry the status query
   * rather than render a broken UI deep-link.
   */
  runId?: Maybe<Scalars['ID']['output']>;
  /** When the latest run started. Null in the same describe-race case as `runId`. */
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  state: PlatformBackfillState;
  triggeredBy?: Maybe<Scalars['String']['output']>;
  /** Stable workflow id — always `backfill-providers-to-navihealth`. */
  workflowId: Scalars['ID']['output'];
};

/** Top-level status for the provider → Navi Health backfill workflow. */
export type PlatformProviderNavihealthBackfillStatus = {
  __typename?: 'ProviderNavihealthBackfillStatus';
  flagEnabled: Scalars['Boolean']['output'];
  latestRun?: Maybe<PlatformProviderNavihealthBackfillRun>;
};

/**
 * A practice or group that providers work in, as Healthie reports it at request
 * time. The registry stores no organizations, so this type has no registry id:
 * identify an organization by its HEALTHIE external id. A sub-org is an
 * organization whose `parent` is set.
 */
export type PlatformProviderOrganization = {
  __typename?: 'ProviderOrganization';
  /** Identifiers in external systems. Holds exactly one HEALTHIE id today. */
  externalIds: Array<PlatformProviderOrganizationExternalId>;
  /** Display name in Healthie. Null when Healthie has none. */
  name?: Maybe<Scalars['String']['output']>;
  /**
   * The parent organization when this is a sub-org; null for a top-level
   * organization. Each hop is one more Healthie read, batched across the
   * request, and waits for the previous hop, each with its own 5 s timeout.
   * Healthie allows deeper nesting, so callers that need the top-level
   * organization walk until `parent` is null.
   *
   * Errors (`extensions.code`), each nulling only this field:
   * - BAD_GATEWAY: Healthie timed out, was unreachable, or answered with an error.
   *   Organizations are read 50 per Healthie request, so one failed request
   *   returns this error on every organization in that batch.
   */
  parent?: Maybe<PlatformProviderOrganization>;
};

/** A provider organization's identifier in an external system. */
export type PlatformProviderOrganizationExternalId = {
  __typename?: 'ProviderOrganizationExternalId';
  /**
   * The id in the external system. For HEALTHIE, the numeric Healthie
   * organization id as a string: the same value as Healthie's `Organization.id`,
   * `User.organization.id` and `Appointment.organization_id`.
   */
  externalId: Scalars['String']['output'];
  /** External system name */
  system: PlatformProviderOrganizationExternalSystem;
};

/** Systems a provider organization can have an identifier in. Healthie is the only source today. */
export enum PlatformProviderOrganizationExternalSystem {
  /** Healthie EHR organization. A sub-org has its own Healthie organization id. */
  Healthie = 'HEALTHIE'
}

export type PlatformProviderPayerBillability = {
  __typename?: 'ProviderPayerBillability';
  verdict: PlatformBillabilityVerdict;
};

export type PlatformProviderProfile = {
  __typename?: 'ProviderProfile';
  /** Mean of those ratings (1-5). Null exactly when reviewCount is 0. */
  averageRating?: Maybe<Scalars['Float']['output']>;
  /** Manual booking-priority override from Airtable `booking_override`. NORMAL when no override is set. Independent of prescriberAssignmentPriorityScore; callers decide how the two combine. */
  bookingPrioritization: PlatformBookingPrioritization;
  /** Cash-pay hourly rate in USD. Null when the source has no rate or the provider has no match profile; consumers apply their own default. */
  cashPayRate?: Maybe<Scalars['Float']['output']>;
  /**
   * The `credentials` string split into individual credentials, in the
   * provider's listed order. Empty when `credentials` is null or lists none.
   */
  credentialDetails: Array<PlatformProviderCredential>;
  /** Display-ready professional suffixes, for example `RDN, CIEC`. Null when absent or the provider has no match profile. */
  credentials?: Maybe<Scalars['String']['output']>;
  /** Airtable booking display name. Null until the reverse-ETL field is populated, or when the provider has no match profile. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Public provider headshot URL. Null when no image is configured or the provider has no match profile. */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** Non-English languages the provider speaks, sorted. Empty means English only, none on file, or no match profile. */
  languages: Array<Scalars['String']['output']>;
  /** Long biography for the provider profile view. Null when absent or the provider has no match profile. */
  longBio?: Maybe<Scalars['String']['output']>;
  /**
   * Same-day booking opt-in in minutes, mirroring CBF's Airtable-sourced
   * `appointment_minimum_notice_minutes`. Null means no opt-in — the 24-hour
   * default floor applies; a value below 1440 is the provider's configured
   * same-day notice window; a value at or above 1440 is a valid stricter
   * setting. This projection never coerces null to a number — the default
   * lives with the enforcing domain (scheduling), not here. Null also when the
   * provider has no match profile.
   */
  minimumNoticeMinutes?: Maybe<Scalars['Int']['output']>;
  /** Role-weighted GLP-1 assignment score; lower ranks first within an eligible timeslot. Null means missing, unrankable or no match profile, and uses the caller's fallback. Zero is valid. Does not grant booking eligibility. */
  prescriberAssignmentPriorityScore?: Maybe<Scalars['Float']['output']>;
  /** Raw practice-level recurring-appointments flag, surfaced uninterpreted. False when the provider has no match profile. */
  recurringEnabled: Scalars['Boolean']['output'];
  /** Count of 1-5 star post-visit ratings patients have left, all time. 0 when unrated. */
  reviewCount: Scalars['Int']['output'];
  /** The provider's clinical role. */
  role: PlatformProviderRole;
  /** Short biography for result cards. Null when absent or the provider has no match profile. */
  shortBio?: Maybe<Scalars['String']['output']>;
  /** Provider specialty categories in the specialtyCategories query's curated display order. Tags missing from that vocabulary follow alphabetically. Empty when the provider has no match profile. */
  specialtyCategories: Array<Scalars['String']['output']>;
};

/** What kind of clinician a provider is. */
export enum PlatformProviderRole {
  Prescriber = 'PRESCRIBER',
  Rd = 'RD'
}

/** Status of a provider record. */
export enum PlatformProviderStatus {
  /** Active provider */
  Active = 'ACTIVE',
  /** Merged into another provider record */
  Merged = 'MERGED'
}

/** ACCESS-owned provisioning input; vendor identity and fixed program policy are resolved server-side. */
export type PlatformProvisionAccessEnrollmentInput = {
  consent?: InputMaybe<PlatformAccessEnrollmentConsentInput>;
  memberId: Scalars['String']['input'];
  patient: PlatformAccessEligibilityPatientInput;
  patientId: Scalars['ID']['input'];
  selfReportedConditionKeys: Array<Scalars['String']['input']>;
  sessionId: Scalars['ID']['input'];
  sourceSystem: Scalars['String']['input'];
};

export type PlatformProvisionAccessEnrollmentResult = PlatformAccessMemberIdConflict | PlatformSubmitAccessEligibilityPayload;

/**
 * Finalize a draft into the current published version. Catalog fields on this
 * input replace the document's published metadata.
 */
export type PlatformPublishProviderDocumentVersionInput = {
  audience: PlatformProviderDocumentAudience;
  displayOrder: Scalars['Int']['input'];
  /**
   * Optimistic lock against the currently PUBLISHED version. Pass that version's
   * id when replacing it. Omit or pass null when no version is published yet
   * (first publish). A mismatch means another publish won and is a conflict.
   */
  expectedCurrentVersionId?: InputMaybe<Scalars['ID']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  required: Scalars['Boolean']['input'];
  title: Scalars['String']['input'];
  /** DRAFT version to publish, or the current PUBLISHED version for an identical retry */
  versionId: Scalars['ID']['input'];
};

export type PlatformPublishProviderEventInput = {
  /** JSON object of at most 8 KiB; use identifiers and refresh hints for application events. */
  payload: Scalars['JSON']['input'];
  /** Canonical active provider-registry UUID, independent of external identifiers. */
  providerId: Scalars['ID']['input'];
  /** Namespaced event type, for example support.invalidate or provider.test. */
  type: Scalars['String']['input'];
};

export type PlatformPublishProviderEventPayload = {
  __typename?: 'PublishProviderEventPayload';
  error?: Maybe<PlatformProviderEventError>;
  eventId?: Maybe<Scalars['ID']['output']>;
  /** Broker accepted the event; this does not establish that a provider is online or received it. */
  published: Scalars['Boolean']['output'];
};

export type PlatformQuery = {
  __typename?: 'Query';
  /** Provider onboarding must assign when it creates a new ACCESS patient. */
  accessAgentProvider: PlatformAccessAgentProvider;
  accessAlignmentReviewDetail?: Maybe<PlatformAccessAlignmentReviewDetail>;
  accessAlignmentReviewQueue: PlatformAccessAlignmentReviewQueueConnection;
  /**
   * The body measurements an ACCESS patient's weight progress is measured from,
   * by Patient Registry id (`patientId`). The registry's Healthie id picks the
   * enrollment the same way `accessEnrollment` does. Once CMS has accepted the enrollment's baseline OAP report,
   * `weight` is that report's body weight and no longer changes. Before then it
   * is the signup weight: within a day either side of the enrollment's creation,
   * the earliest Berry Street self-reported weight, else the earliest Apple
   * Health one, unrounded and without the report's 15-day validity window or
   * sanity range. On acceptance it switches once to the report's weight, which
   * can be a later reading if the patient logged or synced one before the report
   * was built. Both are null when the registry has no Healthie id for the patient
   * or the patient has no enrollment; `weight` is also null without a signup
   * weight, and `heightCm` when Healthie has no height. Registry and Healthie read
   * failures, and an accepted report without a usable body weight, surface as
   * errors, never as nulls.
   */
  accessBaselineBodyMeasurements: PlatformAccessBaselineBodyMeasurements;
  accessBaselineOapOperationalState: PlatformAccessBaselineOapOperationalState;
  /** Latest care-plan version (any status) for a patient's active enrollment. */
  accessCarePlan?: Maybe<PlatformAccessCarePlan>;
  /** All care-plan versions for a patient's active enrollment, newest first. */
  accessCarePlanHistory: Array<PlatformAccessCarePlan>;
  /**
   * Admin job only. At most 20 filed approvals after ACCESS_CARE_UPDATE_FAX_APPROVED_AFTER,
   * oldest first; empty when disabled. Excludes versions already audited. Supplying
   * carePlanId rechecks that version before submission, including previously audited ones.
   * Does not claim a send; Admin must reserve its per-version fax log first.
   */
  accessCareUpdatesForFax: Array<PlatformAccessCareUpdateFax>;
  /**
   * Which of these Healthie users asked ops to stop ACCESS comms (see
   * `recordAccessCommsOptOut`); the others are left out. Duplicate ids are read
   * once, and the result is in no particular order. BAD_REQUEST for more than 500
   * ids in one call.
   */
  accessCommsOptedOutHealthieUserIds: Array<Scalars['String']['output']>;
  accessDiagnosisOptions: PlatformAccessDiagnosisCatalog;
  accessEnrollment?: Maybe<PlatformAccessEnrollmentSummary>;
  /**
   * Ops lookup: resolve one opaque id to its ACCESS enrollment. Accepts an
   * ACCESS enrollment id, a Healthie user id (all digits), or the CMS `$align`
   * submission id (the UUID CMS returns as `$submission-status/<uuid>`, which is
   * what CMS quotes when it un-aligns a patient). Null when nothing matches; a
   * CMS uuid naming more than one enrollment comes back with `ambiguous: true`
   * and no enrollment.
   */
  accessEnrollmentLookup?: Maybe<PlatformAccessEnrollmentLookupResult>;
  accessFailedAlignmentCorrectionContext: PlatformAccessFailedAlignmentCorrectionContext;
  /** Aligned enrollments assigned to this NP, each with its latest care plan. */
  accessNpReviewQueue: Array<PlatformAccessNpReviewQueueItem>;
  accessPostAlignmentQueue: PlatformAccessPostAlignmentQueueConnection;
  accessRejectionQueue: PlatformAccessRejectionQueueConnection;
  activeLabOrder?: Maybe<PlatformLabOrder>;
  /** List agenda items, optionally filtered by default step and/or type */
  agendaItems: Array<PlatformAgendaItem>;
  /**
   * The patient's existing upcoming consult, snapshotted from the booking
   * submission the double-booking guard stamped — drives the ALREADY_SCHEDULED
   * terminal (GLPX-241). Null when the session is unknown or wasn't routed there.
   */
  alreadyScheduledAppointment?: Maybe<PlatformAlreadyScheduledAppointment>;
  appointmentAvailability: Array<PlatformProviderAvailability>;
  /** A session's current live holds. Never errors for a session with zero holds -- an empty list covers both 'never held' and 'held, then expired'. */
  appointmentHolds: Array<PlatformAppointmentHold>;
  /**
   * The IANA time zone set on an appointment's provider, read live from Healthie.
   * `appointmentId` is an opaque appointment id as this domain's operations
   * return it (a Healthie appointment id today). Null when there is no
   * appointment with that id, it has no provider, or the provider has no time
   * zone set; the caller picks its own default. A failed or timed-out read
   * raises INTERNAL_SERVER_ERROR, never null.
   */
  appointmentProviderTimeZone?: Maybe<Scalars['String']['output']>;
  /**
   * Healthie-sourced duration for a catalogued appointment type, in minutes.
   * Internal: exposed for program-domain orchestration and patient-facing
   * aggregates that must render the real environment-specific duration.
   */
  appointmentTypeDuration: Scalars['Int']['output'];
  /**
   * Documents assigned to the signed-in provider's audiences, with attestation
   * state against the current published version. Order: required documents still
   * PENDING first, then catalog display order.
   */
  assignedProviderDocuments: Array<PlatformAssignedProviderDocument>;
  /** Prior attestations by the signed-in provider, newest first. Optional documentId scopes the list. */
  attestationHistory: Array<PlatformAttestationHistoryItem>;
  /**
   * Look up automatic benefits decision from Airtable.
   * Returns decision details including copay, coinsurance, deductible, and authorization info.
   * Returns status UNKNOWN if no decision is found in Airtable.
   */
  automaticBenefitsDecision: PlatformAutomaticBenefitsDecisionResponse;
  /**
   * Resolved availability for the session's appointment picker: the bookable
   * times for the selected prescriber (or any, when `providerId` is null), the
   * prescriber chooser rows when the session is offered one, and the `outcome`
   * that explains an empty result (NO_MATCHED_PROVIDERS vs NO_AVAILABILITY) so
   * the client can branch its empty-state copy. Without the chooser its slots
   * are the ones `availableSlots` returns. Throws on the same invariant failures
   * `availableSlots` throws on (unknown session, a session that reached the
   * picker without state/payer facts).
   */
  availability: PlatformAvailabilityResult;
  /**
   * Open appointment times for the session's matched providers, deduped — the
   * provider is assigned server-side at booking and never surfaced. Empty when
   * the session is unknown, its facts can't match (no state/payer), or no slots
   * are currently warm.
   * @deprecated Use `availability`, which adds the empty-state `outcome` and, when offered, the prescriber chooser. Kept during the API-ships-before-frontend deploy window so the old frontend keeps working; remove once no client reads it.
   */
  availableSlots: Array<PlatformAvailabilitySlot>;
  /** Most recent BenefitsCheck for a patient (by submittedAt desc), or null. */
  benefitsCheckByPatient?: Maybe<PlatformBenefitsCheck>;
  /** List a canonical patient's blood-pressure history. */
  bloodPressureReadings: PlatformBloodPressurePage;
  /**
   * The session's booked GLP-1 appointment, snapshotted from its submissions —
   * drives the APPOINTMENT_CONFIRMATION terminal and the BOOKING_CELEBRATION
   * step. Null when the session is unknown or has no booked GLP-1 appointment
   * yet.
   */
  bookedAppointment?: Maybe<PlatformBookedAppointment>;
  /** Retrieve a booking session by its token */
  bookingSession?: Maybe<PlatformBookingSession>;
  /**
   * List care-agent crisis escalations, newest first — the read surface for human
   * triage/recovery UIs (admin escalation queue, future NP pipeline). Defaults to
   * OPEN (the actionable set: each row is a patient whose automated chat is paused).
   * Unpaginated: the open set is expected to stay small; revisit if RESOLVED history
   * grows a real consumer.
   */
  careEscalations: Array<PlatformCareEscalation>;
  /**
   * Presentation context for cash-pay journeys (GLPX-325), resolved from the
   * same submission rows and guard predicates the machine routes on. Throws
   * when the session does not exist.
   */
  cashPayContext: PlatformCashPayContext;
  /**
   * Resolve the Stream Chat channel for a patient-provider pair.
   *
   * Error codes (in extensions.code):
   * - CHANNEL_NOT_FOUND: No channel exists for this pair yet
   * - RELATIONSHIP_NOT_FOUND: No provider-patient relationship exists
   *
   * `providerId` is the provider's Healthie user ID.
   * `patientId` is the patient's Healthie user ID.
   *
   * @deprecated Implicitly 1:1 only — breaks when multi-member channels exist.
   * Use `chatChannels(userId)` and pick the channel by its members.
   * @deprecated Implicitly 1:1 only. Use chatChannels(userId) and select by members.
   */
  chatChannel: PlatformChatChannel;
  /**
   * The most recent turns in one channel, oldest first — the bounded context read
   * a reply path makes before responding.
   *
   * Separate from `patientChatHistory`, which is the paginated incremental feed
   * for long-term-memory ingestion, for two reasons. It includes the human
   * provider's turns, which that feed omits. And it is served by a channel read
   * rather than search, so a paginating memory job can never exhaust the budget
   * a patient's reply is waiting on.
   *
   * Returns an empty list, not an error, for a channel with no messages. Errors
   * when the channel is unknown to this domain (`CHANNEL_NOT_FOUND`), because a
   * reply built on silently absent context is worse than a failed one.
   */
  chatChannelRecentTurns: Array<PlatformChatChannelTurn>;
  /**
   * All active channels the user is a member of, newest-created first. The list
   * is the patient app's inbox and the provider's channel set.
   *
   * Returns membership only. Last message, unread count, and typing state come
   * from GetStream once the client connects with the chatToken credentials;
   * clinical role labels come from the caller's care-team source.
   *
   * `userId` is a Healthie user ID, patient or provider. Returns an empty list,
   * not an error, for a user with no chat account.
   */
  chatChannels: Array<PlatformChatChannel>;
  /**
   * Returns the canonical Healthie conversation ID for a patient-provider pair.
   *
   * TRANSITIONAL — exists only to establish a shared source of truth for callers
   * (provider portal, patient-app-api) that still write messages directly to Healthie
   * while the platform migrates to GetStream as the primary message store. Once all
   * message writes go through GetStream, this query has no further purpose and should
   * be removed.
   *
   * Resolution order:
   * 1. ChatChannel DB FK (fast path, O(1)) — set during provisioning/backfill
   * 2. Healthie conversationMemberships fallback — read-only, same params as provisioning,
   *    only_include_shared_memberships: true, CONVERSATION_UPDATED_AT_DESC
   *
   * Returns null if no conversation exists. Does NOT create a conversation.
   *
   * Multiple Healthie conversations for the same pair are safe — H→GS sync routes
   * messages from any of them into the single pair-keyed GS channel.
   *
   * `providerId` is the provider's Healthie user ID.
   * `patientId` is the patient's Healthie user ID.
   */
  chatHealthieConversationId?: Maybe<Scalars['String']['output']>;
  /**
   * Fetch Stream Chat credentials for a user.
   *
   * Returns credentials for the Berry Street GetStream app instance.
   * `userId` is the user's Healthie user ID.
   *
   * Error codes (in extensions.code):
   * - CHAT_ACCOUNT_NOT_FOUND: User has no chat account yet (pending provisioning)
   */
  chatToken: PlatformStreamChatCredentials;
  /** Check if a specific email address has conflicts */
  checkPatientEmailConflict?: Maybe<PlatformEmailConflict>;
  /** Check if a specific external ID has conflicts */
  checkPatientExternalIdConflict?: Maybe<PlatformExternalIdConflict>;
  /** Check if a specific provider email address has conflicts */
  checkProviderEmailConflict?: Maybe<PlatformProviderEmailConflict>;
  /** Check if a specific provider external ID has conflicts */
  checkProviderExternalIdConflict?: Maybe<PlatformProviderExternalIdConflict>;
  /** Retrieve a cohort by ID */
  cohort?: Maybe<PlatformCohort>;
  /** Find a cohort by Healthie recurring appointment ID */
  cohortByRecurringAppointmentId?: Maybe<PlatformCohort>;
  /** List all series for a cohort */
  cohortSeriesByCohortId: Array<PlatformCohortSeries>;
  /** Actual per-program outcomes for the welcome-v2 combined results screen. */
  combinedOnboardingResults?: Maybe<PlatformCombinedOnboardingResults>;
  /**
   * The session's payer-confirmed coverage (from the confirm-coverage Stedi
   * check), for the COVERAGE_FOUND review screen. Null when the session is
   * unknown or the check found no coverage to confirm.
   */
  coverageSummary?: Maybe<PlatformCoverageSummary>;
  /** Look up a single CRM event by id. */
  crmEvent?: Maybe<PlatformCrmEvent>;
  /** Returns the complementary program for an eligible MNT or GLP-1 session; otherwise null. */
  crossSellBookingOffer?: Maybe<PlatformCrossSellBookingOffer>;
  /** Retrieve daily health metrics stored locally (activity minutes, active calories, blood glucose). Errors: `BAD_USER_INPUT` when neither id is set, when `patientRegistryId` is empty, or when the registry has no Healthie user id for `patientRegistryId` and `healthieUserId` isn't set; `INTERNAL_SERVER_ERROR` when the registry lookup fails and `healthieUserId` isn't set. In both registry cases, `healthieUserId` is read when it's set. */
  dailyHealthMetrics: Array<PlatformDailyHealthMetric>;
  /**
   * Ranked dietitians, per-provider MNT availability, backend-sourced visit
   * durations, and this session's current MNT hold. State, payer, plan type,
   * visit reasons, and ranking experiments are derived from authoritative
   * session state. Missing or unavailable ranking experiments use documented
   * baseline values without emitting fabricated experiment exposures.
   * Pages of fixed server-side size: `offset` is the previous response's
   * `nextOffset` (null starts at the top; null back means no further page).
   * The provider named by `currentHold` is pinned via matching's
   * `pinnedProviderIds` — see provider-matching's schema for the exactly-once
   * paging contract — so an active hold stays resolvable after a refresh.
   * Availability is read through the later of the default window and the end
   * of `availableBetween`, up to `maxSchedulingWindowEnd`.
   */
  dietitianOptions: PlatformDietitianOptions;
  /** Every dietitian (the full matchable universe), regardless of state or payer. Used to warm provider availability. */
  dietitians: Array<PlatformProvider>;
  /** Get a single document by ID */
  document?: Maybe<PlatformDocument>;
  /** Get a presigned URL for downloading a document */
  documentDownloadUrl?: Maybe<PlatformDownloadUrlResponse>;
  /**
   * Five-minute S3 download URL for a document attached to a request owned by
   * the authenticated provider. Identity comes only from
   * x-bst-provider-assertion. Missing request, another provider's request
   * (including system/CX-raised with null requester), or a document not linked
   * to that request is not-found. Closed requests remain downloadable; status is
   * not part of the access check.
   */
  documentRequestDownloadUrl: PlatformDownloadUrlResponse;
  /** Retrieve documents for a patient (excludes soft-deleted documents) */
  documents: Array<PlatformDocument>;
  /**
   * The patient's EHR charting items (Healthie chartingItems), in the EHR's order, each with its
   * note when it is one. An EHR failure fails the query with INTERNAL_SERVER_ERROR rather than
   * returning an empty list. A blank patient id is BAD_USER_INPUT.
   */
  ehrChartingItems: Array<PlatformEhrChartingItem>;
  /**
   * One EHR charting note by its id alone, with no patient check: the caller must confirm the note
   * belongs to the patient it is acting for. Null when the EHR has no such note. A blank id is
   * BAD_USER_INPUT; an EHR failure fails the query with INTERNAL_SERVER_ERROR.
   */
  ehrChartingNote?: Maybe<PlatformEhrChartingNote>;
  /**
   * One page of the patient's EHR charting notes (Healthie), in the order asked.
   * Empty when the EHR returns none. Page by raising offset until a page is shorter than pageSize.
   * A pageSize outside 1 to 100, a negative offset or a blank patient id is BAD_USER_INPUT; an EHR
   * failure fails the query with INTERNAL_SERVER_ERROR.
   */
  ehrChartingNotes: Array<PlatformEhrChartingNote>;
  /**
   * Files in the patient's EHR record, read live (metadata only; no download
   * URL). Always reads patient.externalId's record. When the registry has no
   * patient for externalId, that patient's primary active Healthie id is not
   * externalId, or patientId names another patient, the platform logs
   * IDENTITY_FALLBACK and reads anyway. A failed registry check is logged and
   * does not fail the read. Acting-provider gate: an ACTIVE GLP-1
   * enrollment and the latest occurred GLP-1 prescriber.
   *
   * Errors: BAD_USER_INPUT (reason OTHER) for a blank externalId, before any
   * call; not found (`extensions.status` 404) when there is no enrollment;
   * FORBIDDEN for any other clinician; BAD_REQUEST when the enrollment is not
   * ACTIVE.
   */
  ehrDocuments: Array<PlatformEhrDocument>;
  /** The height and weight on the patient's EHR profile. Null when the EHR has no such patient; an EHR failure fails the query. */
  ehrHeightWeight?: Maybe<PlatformEhrHeightWeight>;
  /**
   * The patient's measurement entries from the EHR (Healthie): one EHR page of at most 500 entries.
   * Weight entries are left out when the patient's EHR chart hides the weight metric. An EHR
   * failure fails the query with INTERNAL_SERVER_ERROR rather than returning an empty list. A blank
   * patient id is BAD_USER_INPUT.
   */
  ehrMetricEntries: Array<PlatformEhrMetricEntry>;
  /**
   * One measurement entry from the EHR (Healthie). Null when the EHR has no such entry, it is not a
   * measurement, the patient did not post it, or it is a weight entry the patient's chart hides.
   * Blank and NaviHealth (nh-) ids are BAD_USER_INPUT; an EHR failure fails the query with
   * INTERNAL_SERVER_ERROR.
   */
  ehrMetricEntry?: Maybe<PlatformEhrMetricEntry>;
  /**
   * The patient's EHR prescriptions with status active, then pending, then error,
   * each in the EHR's order, read live from Healthie with no API version header.
   * Not sorted or deduplicated. Reads patient.externalId's record with no
   * registry check; an empty externalId returns no prescriptions without calling
   * Healthie. No enrollment gate. Any EHR error, including no answer within 20
   * seconds, fails the whole read with INTERNAL_SERVER_ERROR and a fixed message;
   * it never returns a partial list.
   *
   * Any provider with a verified provider identity can call it, so the caller must
   * do the prescriber check; provider-portal does it in getPatientDrawerOverview
   * with requirePrescribingProvider.
   */
  ehrPrescriptions: Array<PlatformEhrPrescription>;
  /**
   * The patient's Weight metric entries from the EHR (Healthie), newest first: one EHR page,
   * at most 10 entries. Unknown patient or other EHR failure fails the query.
   */
  ehrWeightEntries: Array<PlatformEhrWeightEntry>;
  /** The patient's EHR weight graph, every data point in the range. Null when the EHR returns none; an EHR failure fails the query. */
  ehrWeightGraph?: Maybe<PlatformEhrWeightGraph>;
  /**
   * Check insurance eligibility for a patient.
   * Performs real-time eligibility verification via Stedi and returns coverage details
   * and subscriber information.
   */
  eligibilityCheck: PlatformEligibilityResponse;
  /** Retrieve an enrollment by ID */
  enrollment?: Maybe<PlatformEnrollment>;
  /** List enrollments for a Healthie client */
  enrollmentsByHealthieClientId: Array<PlatformEnrollment>;
  /** Retrieve food journal entries for a patient with optional date filtering. Errors: `BAD_USER_INPUT` when neither id is set, when `patientRegistryId` is empty, or when the registry has no Healthie user id for `patientRegistryId` and `patientId` isn't set; `INTERNAL_SERVER_ERROR` when the registry lookup fails and `patientId` isn't set. In both registry cases, `patientId` is read when it's set. FOOD is read from the store it is served from for the patient; a patient with no patient registry id, or when only `patientId` is set and the lookup of its patient registry id fails, is read from Healthie. */
  foodJournalEntries: Array<PlatformFoodJournalEntry>;
  /** Retrieve a single food journal entry by ID */
  foodJournalEntry?: Maybe<PlatformFoodJournalEntry>;
  /** A bounded snapshot of one patient's current food-journal entries. */
  foodJournalSnapshot: PlatformFoodJournalSnapshotPage;
  /**
   * GLP-1 appointment summary for a Healthie patient, read from the local mirror.
   * Returns an empty summary when the patient has no mirrored appointments.
   */
  glp1AppointmentSummaryByPatient: PlatformGlp1AppointmentSummary;
  /**
   * Drives the GLP1_INELIGIBLE screen (GLPX-309): the reason bucket plus whether
   * the lead continues into ACCESS. Null when the session is unknown.
   */
  glp1IneligibleOutcome?: Maybe<PlatformGlp1IneligibleOutcome>;
  /** Most recent Glp1IntakeRecord for a patient (by createdAt desc), or null. */
  glp1IntakeByPatient?: Maybe<PlatformGlp1IntakeRecord>;
  /** Full GLP-1 medication/SKU catalog for prescriber picker UIs. */
  glp1MedicationOptions: Array<PlatformGlp1MedicationOption>;
  /**
   * Aggregated patient/appointment context for a single prescription task modal.
   * Input is task id (not appointment id). v1 trusts the M2M caller (no provider auth).
   */
  glp1PrescriptionTaskContext: PlatformGlp1PrescriptionTaskContext;
  /**
   * Open GLP-1 prescription tasks for the authenticated provider (status NEW or
   * PENDING, excluding outcome PRIOR_AUTH_STARTED). Ordered by appointment date
   * descending. Pagination params are caller-controlled (no server-side pageSize cap).
   *
   * The acting provider is inferred from the request auth context, never from
   * arguments. Missing or invalid provider auth is rejected.
   */
  glp1PrescriptionTasks: PlatformGlp1PrescriptionTasksResult;
  /** List the trailing seven days of canonical glucose readings, or the newest historical seven-day window when current history is empty. */
  glucoseReadings: Array<PlatformGlucoseReading>;
  /**
   * Who a parent or legal guardian is booking for, which the client shows on
   * every step and the booking confirmation and medical background address
   * the guardian with. Non-null once the guardian has identified themselves
   * and only while the session's date of birth makes the patient under 18
   * today; null for a patient booking for themselves and before the guardian
   * step. Throws when the session does not exist.
   */
  guardianBookingContext?: Maybe<PlatformGuardianBookingContext>;
  /** Whether the canonical patient has a current ICD-10 eating-disorder diagnosis in clinical records or an active one on the Healthie problem list. Exposed to trusted program domains for eligibility decisions. */
  hasActiveEatingDisorder: Scalars['Boolean']['output'];
  /** Fetch a single appointment by its Healthie ID. */
  healthieAppointment?: Maybe<PlatformHealthieAppointment>;
  /** List appointment types, optionally filtered by provider and search keywords. */
  healthieAppointmentTypes: Array<PlatformHealthieAppointmentType>;
  /** Get available booking slots for a single provider within a date range. */
  healthieAvailabilitySlots: Array<PlatformHealthieAvailabilitySlot>;
  /**
   * Fetch a charting note (FormAnswerGroup) by its Healthie ID.
   * @deprecated Unused. Read charting notes through clinical-records ehrChartingNote. Will be removed.
   */
  healthieFormAnswerGroup?: Maybe<PlatformHealthieFormAnswerGroup>;
  /** List insurance plans, optionally filtered by keywords. */
  healthieInsurancePlans: Array<PlatformHealthieInsurancePlan>;
  /** Fetch a single patient by their Healthie user ID. */
  healthiePatient?: Maybe<PlatformHealthiePatient>;
  /** List appointments for a patient. Defaults to ALL (past + future). */
  healthiePatientAppointments: Array<PlatformHealthieAppointment>;
  /** Fetch a single patient by email address. Returns the first exact match. */
  healthiePatientByEmail?: Maybe<PlatformHealthiePatient>;
  /** Fetch insurance policies and authorization details for a patient. */
  healthiePatientInsurancePolicies: Array<PlatformHealthieInsurancePolicy>;
  /** Fetch a single provider by their Healthie user ID. */
  healthieProvider?: Maybe<PlatformHealthieProvider>;
  /** Get available booking slots for multiple providers in one request. */
  healthieProvidersAvailability: Array<PlatformHealthieProviderAvailability>;
  /** List Stripe payment cards on file for a patient. */
  healthieStripeCards: Array<PlatformHealthieStripeCard>;
  /** List all tags in the Healthie organization. */
  healthieTags: Array<PlatformHealthieTag>;
  /** List user groups, optionally filtered by keywords. */
  healthieUserGroups: Array<PlatformHealthieUserGroup>;
  /** Retrieve a patient's journal entries as a unified timeline. `filters.types` decides which entry types come back; steps and sleep duration entries only when requested. Errors: `BAD_USER_INPUT` when neither `filters.patientId` nor `filters.patientRegistryId` is set, when `filters.patientRegistryId` is empty, when it has no Healthie user id in the patient registry and `filters.patientId` isn't set, when `filters.types` is an empty list, or when it is set and `pageSize` is above 500; `INTERNAL_SERVER_ERROR` when the registry lookup fails and `filters.patientId` isn't set. In both registry cases, `filters.patientId` is read when it's set. Each type is read from the store it is served from for the patient; a patient with no patient registry id, or when only `filters.patientId` is set and the lookup of its patient registry id fails, is read from Healthie with Healthie comments. */
  journalEntries: PlatformJournalEntryPage;
  /** Retrieve any single journal entry by ID, steps and sleep duration entries included. Returns null both when the entry doesn't exist and when it is a kind this schema doesn't model, such as heart rate; callers that need to tell them apart read the source themselves until measurements move to clinical-records. Returns the entry whoever posted it; to check that it belongs to a patient, read `patientJournalEntry`, which also reads a sleep `nh-` id for its patient. A sleep `nh-` id is a patient's day, so it is null here without `patientRegistryId`. An entry is read from the store its type is served from for the patient it belongs to, so a Healthie id of a type NaviHealth can serve looks up its poster's patient registry id; when that lookup fails, the Healthie entry is returned. An `nh-` id of a type served from Healthie for its patient (after a rollback) returns the Healthie entry NaviHealth links it to, under its Healthie id, and null when there is none. Errors: `INTERNAL_SERVER_ERROR` when an `nh-` id read without `patientRegistryId` fails to look up its owner in the patient registry. */
  journalEntry?: Maybe<PlatformJournalEntry>;
  /** Comments and reactions on a patient's journal entries, read from NaviHealth. Returns every requested entry id in order. The patient's own comments carry the patient registry id as `author.id`; provider comments carry an empty string. Errors with `INTERNAL_SERVER_ERROR` for a patient registry id NaviHealth has not linked; callers should keep the patient's existing Healthie comments on any error. */
  journalEntryComments: Array<PlatformJournalEntryComments>;
  /** The NaviHealth entry each legacy Healthie entry id maps to, for callers that store entry ids and add the NaviHealth id next to the Healthie one. Calls NaviHealth whatever the store flags say. Healthie ids NaviHealth has no entry for are left out, so the list can be shorter than the input, and so are mappings whose key the platform doesn't know; duplicate input ids are read once. Mappings come back in input order. An empty list returns an empty list without calling NaviHealth. Each `servedId` is evaluated for `patientRegistryId` as `journalEntryServedId` evaluates it, so a call names one patient. That patient's sleep ids are resolved in their Healthie timezone when the platform can resolve it (`patientTimezoneApplied`); when it can't, or NaviHealth doesn't know the patient, the ids are mapped without it. Errors: `BAD_USER_INPUT` when an id isn't all digits, there are more than 5000 ids or `patientRegistryId` is empty; `NAVIHEALTH_UNAVAILABLE` when NaviHealth can't be reached, times out or answers 5xx (retry later); `NAVIHEALTH_REQUEST_FAILED` when NaviHealth refuses the call or its reply isn't the documented shape (retrying won't help). Either NaviHealth error fails the whole query: there are no partial results. */
  journalEntryIdMap: Array<PlatformJournalEntryIdMapping>;
  /** The id the platform hands out for an entry, given the ids it has in each store: `nh-<navihealthKey>-<navihealthId>` while `type` is served from NaviHealth and both NaviHealth args are set, otherwise `healthieEntryId`. Null when there is no id to hand out (the caller should skip the entry). WEIGHT is always served from Healthie. The store flag is evaluated for `patientRegistryId`, as the patient's own reads evaluate it. Reads flags only; no store is called. The NaviHealth args are read only while `type` is served from NaviHealth. Errors: `BAD_USER_INPUT` when `patientRegistryId` is empty or only one of `navihealthKey` and `navihealthId` is set, or, while `type` is served from NaviHealth, when `navihealthKey` is unknown or belongs to another type, or `navihealthId` isn't all digits. */
  journalEntryServedId?: Maybe<Scalars['ID']['output']>;
  labOrder?: Maybe<PlatformLabOrder>;
  labOrdersByPatient: Array<PlatformLabOrder>;
  /**
   * The patient's most recently created active tracked medication, or null when
   * they have none. Inactive medications are never returned, so a patient whose
   * newest supply has expired gets the newest one still active.
   */
  latestTrackedMedication?: Maybe<PlatformTrackedMedication>;
  /**
   * Lead name for the welcome-v2 EMAIL step's Freshpaint pixel, resolved from
   * confirm-coverage/self-pay-details (+ a verify-coverage correction). Null
   * when neither candidate row is submitted yet (e.g. a direct/rewound load).
   * Throws when the session does not exist.
   */
  leadNameContext?: Maybe<PlatformLeadName>;
  /** Ranked, eligible dietitians for a patient. Insured (payerId set): licensed in-state AND enrolled with the payer. Cash-pay (payerId null): licensed in-state only. */
  matchDietitians: PlatformDietitianMatchPage;
  /** Eligible prescribers for a patient, by state licensure + payer enrollment. */
  matchPrescribers: Array<PlatformProvider>;
  /**
   * Returns the authenticated Google Workspace user and their granted
   * capabilities. Intended as a smoke test for the auth chain.
   */
  me: PlatformInternalOpsPrincipal;
  /** Context for rendering the current session's Medical background step. Throws when the session does not exist. */
  medicalBackgroundContext: PlatformMedicalBackgroundContext;
  /** Composed Patient App Medical History; returns an unanswered projection when no responses exist. */
  medicalHistory: PlatformMedicalHistory;
  /**
   * The patient's open Medicare Bridge case for the program, or the most
   * recently closed one when none is open. Null when the patient has never
   * had a case for that program. This is not a lookup by case id: an earlier
   * closed case stays hidden while a newer case exists.
   */
  medicareBridgeCase?: Maybe<PlatformMedicareBridgeCase>;
  /**
   * One Medicare Bridge case by its id, open or closed. Null when no case
   * has that id. Links resolved on this case stay on this case.
   */
  medicareBridgeCaseById?: Maybe<PlatformMedicareBridgeCase>;
  /**
   * Medicare Bridge work queue for Insurance Ops, newest openedAt first.
   * Omit status to list open cases. includeSnoozed defaults to false and
   * hides an open case whose snooze is still in the future. A closed case
   * stays listed. first defaults to 50 and is capped at 100. after is an
   * opaque keyset cursor.
   */
  medicareBridgeCases: PlatformMedicareBridgeCaseConnection;
  medication?: Maybe<PlatformMedication>;
  /** GLP-1 enrollment for a patient, or null if never enrolled. */
  medicationProgramEnrollmentByPatient?: Maybe<PlatformMedicationProgramEnrollment>;
  /** All platform-synced prescriptions for a patient, newest prescribedAt first. */
  medicationProgramPrescriptionsByPatient: Array<PlatformMedicationProgramPrescription>;
  /**
   * Every non-removed dose the patient logged whose entered dose day falls in
   * `[from, to]` inclusive, across all their medications, oldest first — the
   * calendar feed. Windows on the day the patient picked, so "August" means the
   * August they entered. Both bounds are `YYYY-MM-DD`.
   */
  medicationTakeLogs: Array<PlatformMedicationTakeLogEntry>;
  medications: Array<PlatformMedication>;
  nearbyLabs: Array<PlatformLabLocation>;
  /** Lists every onboarding bundle with its fixed contents, in definition order. */
  onboardingBundles: Array<PlatformOnboardingBundle>;
  /** Returns null when the flow has no currently registered version. */
  onboardingFlowStartPolicy?: Maybe<PlatformOnboardingFlowStartPolicy>;
  /** Fetch an existing onboarding session and its current step. Returns null if the session does not exist. */
  onboardingSession?: Maybe<PlatformOnboardingSessionWithStep>;
  /**
   * Retrieve a patient by their internal ID (the patient registry id). Null when
   * no patient has that id. Takes the platform API key, or an M2M JWT with the
   * patient-registry scope and `read:patient-registry`.
   */
  patient?: Maybe<PlatformPatient>;
  /** Get a patient's agenda history, optionally filtered by step */
  patientAgendaHistory: Array<PlatformPatientAgendaHistory>;
  /** Get all conflicts for a single patient, aggregated across types */
  patientAllConflicts?: Maybe<PlatformPatientAllConflicts>;
  /**
   * Fetch the patient's evolving base profile (Perry onboarding interview), keyed by
   * patientRegistryId or healthieUserId. patientRegistryId wins when both are given.
   * At least one is required; neither (empty or whitespace counts as missing) is a
   * BAD_USER_INPUT error. Always returns a profile for a well-formed Healthie id,
   * synthesizing an empty NOT_STARTED profile when no row exists yet. A
   * patientRegistryId with no Healthie user id in the registry is a BAD_USER_INPUT
   * error; a failed registry lookup is an INTERNAL_SERVER_ERROR, never a fallback
   * to healthieUserId.
   */
  patientBaseProfile: PlatformPatientBaseProfile;
  /** Retrieve a patient by any of their active or superseded email addresses (primary or not). Mirrors the create-time email reservation, so identity lookups and identity creation agree — a patient mid email-conflict (both addresses active, neither primary), or one whose Healthie email changed, still resolves by either address. */
  patientByEmail?: Maybe<PlatformPatient>;
  /** Retrieve a patient by external system ID. Resolves superseded/merged ids to the surviving patient — an external id that has ever identified a patient always resolves to the same patient. */
  patientByExternalId?: Maybe<PlatformPatient>;
  /**
   * Stable, bounded patient/Perry history for long-term-memory ingestion. The
   * cursor follows capture and attribution changes rather than send order, so
   * late-arriving and newly attributed messages remain visible to incremental readers.
   * The patient is selected by `input.patientRegistryId` (preferred) or
   * `input.healthieUserId`; a Healthie user id with no chat account gets an empty
   * page, not an error.
   */
  patientChatHistory: PlatformPatientChatHistoryPage;
  /**
   * Read the current generated context for one patient, keyed by patientRegistryId
   * or healthieUserId. patientRegistryId wins when both are given. At least one is
   * required; neither (empty or whitespace counts as missing) is a BAD_USER_INPUT
   * error. A Healthie id with no context answers MISSING. A patientRegistryId with
   * no Healthie user id in the registry is a BAD_USER_INPUT error; a failed registry
   * lookup is an INTERNAL_SERVER_ERROR, never a fallback to healthieUserId.
   */
  patientContext: PlatformPatientContextReadResult;
  /** A patient's documents and open requests. Trusted `healthieUserId` (patient-app-api validates the session). */
  patientDocumentCenter: PlatformPatientDocumentCenter;
  /**
   * `documentDownloadUrl` for input.patient.externalId, under the same identity
   * rule as `patientDocuments`. The audit's performer is the acting provider from
   * x-bst-provider-assertion, as in `documentRequestDownloadUrl`. Null when the
   * document is not externalId's (a failed audit, as `documentDownloadUrl`).
   *
   * Errors: BAD_USER_INPUT (reason OTHER) for a blank externalId, before any call.
   */
  patientDocumentDownloadUrl?: Maybe<PlatformDownloadUrlResponse>;
  /**
   * A file in a patient's record by its record document id, the opaque id the caller holds for it,
   * or null when the record has none. Does not check the owner: the caller checks ownerId.
   * Exposed only to first-party backends (platform API key).
   *
   * Errors: BAD_USER_INPUT when the record rejects the read; UPSTREAM_UNAVAILABLE on 429, 5xx or a
   * network failure, which may succeed on retry.
   */
  patientDocumentFile?: Maybe<PlatformPatientDocumentFile>;
  /**
   * `documents` for patient.externalId (excludes soft-deleted documents). Always
   * reads externalId's documents. When the registry has no patient for
   * externalId, that patient's primary active Healthie id is not externalId, or
   * patientId names another patient, the platform logs IDENTITY_FALLBACK and
   * reads anyway. A failed registry check is logged and does not fail the read.
   *
   * Errors: BAD_USER_INPUT (reason OTHER) for a blank externalId, before any call.
   *
   * Trusted M2M caller, like `documents`.
   */
  patientDocuments: Array<PlatformDocument>;
  /** Find all patient email conflicts */
  patientEmailConflicts: PlatformPatientEmailConflictConnection;
  /** Find all patient external ID conflicts (optionally filtered by system) */
  patientExternalIdConflicts: PlatformPatientExternalIdConflictConnection;
  /** The patient's current GLP-1 journey state and complete transition history. */
  patientGlp1JourneyByPatient: PlatformPatientGlp1Journey;
  /**
   * The patient's self-pay flag and policies with their benefits, authorization, plan and notes. Read
   * from the record on every call; nothing is stored. hasSelfPay is null when the record does not say. Within a policy, null benefits, authorization or plan mean the
   * record has none.
   *
   * Reads and errors as patientInsurancePolicies: the same identity check, which only logs, and the
   * same NOT_FOUND, BAD_USER_INPUT, UPSTREAM_UNAVAILABLE and INTERNAL_SERVER_ERROR.
   *
   * Returns notes, benefits and authorization for any externalId, so the caller must check that its
   * user may see this patient before calling.
   *
   * Exposed only to first-party backends with the platform API key.
   */
  patientInsuranceDetails: PlatformPatientInsuranceDetails;
  /**
   * The patient's insurance policies, in the order the patient's record lists them. Read from the
   * record on every call; nothing is stored.
   *
   * Always reads patient.externalId's chart. savePatientInsurance's registry check runs alongside the
   * read and only logs: a registry gap as IDENTITY_FALLBACK, a registry fault as REGISTRY_UNAVAILABLE.
   * Neither is an error.
   *
   * Errors:
   * - NOT_FOUND: the record has no user with id externalId.
   * - BAD_USER_INPUT: a blank externalId, refused before any call (extensions.reason OTHER), or the
   *   record refused the read with a status other than 429 or 5xx (no extensions.reason).
   * - UPSTREAM_UNAVAILABLE: the record answered 429, 5xx or not at all.
   * - INTERNAL_SERVER_ERROR: a fault in the platform itself.
   *
   * Exposed only to first-party backends with the platform API key.
   */
  patientInsurancePolicies: Array<PlatformInsurancePolicy>;
  /**
   * A single Intercom conversation thread (plaintext messages) for a patient.
   * Throws NotFound when the conversation doesn't exist or the resolved
   * contact does not participate in it.
   */
  patientIntercomConversationThread: PlatformPatientIntercomConversationThreadPayload;
  /** Intercom conversation summaries for a patient, resolved by Healthie user id. */
  patientIntercomConversations: PlatformPatientIntercomConversationsPayload;
  /**
   * Read current invoice state directly from Stripe. Null means the invoice does
   * not exist or does not belong to the canonical patient supplied by the caller.
   * The caller must authorize `patientId`; never pass a patient-supplied id
   * unchecked.
   * Errors: PATIENT_IDENTITY_UNAVAILABLE for missing/ambiguous patient identity;
   * INVOICE_SOURCE_UNAVAILABLE for configuration, upstream or response failures;
   * BAD_USER_INPUT for invalid invoice-ID syntax.
   */
  patientInvoice?: Maybe<PlatformPatientInvoice>;
  /**
   * The caller must authorize `patientId`; never pass a patient-supplied id
   * unchecked. Returns existing invoices ordered by createdAt descending, then invoice id
   * descending for ties. No invoices returns an empty page.
   * Errors: PATIENT_IDENTITY_UNAVAILABLE for missing/ambiguous patient identity;
   * INVOICE_SOURCE_UNAVAILABLE for configuration, upstream or response failures;
   * BAD_USER_INPUT for invalid pagination or a cursor that no longer matches.
   */
  patientInvoices: PlatformPatientInvoicePage;
  /** Retrieve one of a patient's own journal entries by ID: null when the entry doesn't exist, is a kind this schema doesn't model, or wasn't posted by that patient. This checks the entry against the patient a caller acts for; it isn't access control, since a caller with these permissions can read any entry through `journalEntry`. Errors: `BAD_USER_INPUT` when `patientRegistryId` is empty or has no Healthie user id in the patient registry. */
  patientJournalEntry?: Maybe<PlatformJournalEntry>;
  /**
   * The identity a patient signs in with, found by the email they typed. Null
   * when no patient account matches the email exactly (case-sensitive, as
   * stored in the EHR).
   *
   * The result has the same shape whichever system answers. The
   * `patient-login-identity-source` flag decides which does: the EHR's email
   * search (default), the EHR with the registry compared and logged
   * (`shadow`), or the registry's primary EHR account when it is live and
   * holds the same email, falling back to the EHR search (`registry_first`).
   *
   * Exposed only to the patient app's API, which calls it before the patient
   * has a session.
   *
   * Errors (`extensions.code`):
   * - `BAD_GATEWAY` — the EHR could not be reached or returned an invalid
   *   response. Callers treat this as "unknown", not "not found".
   * - `BAD_REQUEST` — `emailAddress` is not a valid email address.
   */
  patientLoginIdentity?: Maybe<PlatformPatientLoginIdentity>;
  /**
   * Find a patient's Healthie ID. Email searches the registry, Healthie, then
   * Intercom; phone searches the registry, then Intercom using E.164. Returns null
   * when no ID is found. Conflicting matches and upstream failures return GraphQL errors.
   */
  patientLookup?: Maybe<PlatformPatientLookupResult>;
  /**
   * Live status of the patient → Navi Health backfill workflow, including
   * the GrowthBook kill-switch state and progress of the latest run.
   */
  patientNavihealthBackfillStatus: PlatformPatientNavihealthBackfillStatus;
  /** List the calling provider's notes for the given patient. Returns only notes authored by the caller. */
  patientNotes: Array<PlatformPatientNote>;
  /**
   * Retrieve nutrient goals for a patient, keyed by patientRegistryId or patientId.
   * patientRegistryId wins when both are given. At least one is required; neither
   * (empty or whitespace counts as missing) is a BAD_USER_INPUT error. Null when the
   * patient has no nutrient goals. A patientRegistryId with no Healthie user id in
   * the registry is a BAD_USER_INPUT error; a failed registry lookup is an
   * INTERNAL_SERVER_ERROR, never a fallback to patientId.
   */
  patientNutrientGoals?: Maybe<PlatformPatientNutrientGoals>;
  /** Latest completed visit-reason and support selections for one patient. */
  patientOnboardingAnswers: PlatformPatientOnboardingAnswers;
  /**
   * Fetch the curated profile for a patient by Healthie user id. Always returns a
   * profile for a well-formed id, synthesizing defaults for attributes that have no
   * data yet (e.g. bpCuffDeliveryStatus = NOT_ORDERED). This does NOT verify the id
   * exists in Healthie; an empty id is rejected.
   */
  patientProfile: PlatformPatientProfile;
  /**
   * Validates a referral UUID for analytics attribution. API key only. Null for
   * malformed or unknown IDs. Does not authenticate a patient or grant access
   * to referral details or an existing onboarding session.
   */
  patientReferralIdentity?: Maybe<PlatformPatientReferralIdentity>;
  /**
   * Every referring physician linked to the patient in Healthie, in Healthie's order.
   * Null when Healthie has no user for patient.externalId. Read live; nothing is stored.
   *
   * Errors: BAD_USER_INPUT for a blank externalId; UPSTREAM_UNAVAILABLE when Healthie
   * fails or errors. A registry mismatch is logged (IDENTITY_FALLBACK) and never fails the read.
   */
  patientReferringPhysicians?: Maybe<Array<PlatformReferringPhysician>>;
  /** Checks candidate times against live, uncancelled appointments of any Healthie type. A schedule read failure raises a GraphQL error. */
  patientScheduleConflicts: PlatformPatientScheduleConflictsResult;
  /**
   * Paginated list of all patients, with optional search filters.
   *
   * `system` + `hasExternalId` filter by whether a record has an active
   * external ID for the given system: `hasExternalId: true` keeps only
   * records with one, `false` keeps only those without (including records
   * with no external IDs at all). Both args must be supplied together;
   * either one alone is a no-op. The filter is reflected in `totalCount`.
   */
  patients: PlatformPatientConnection;
  /** Every open request for the acting clinician (x-bst-provider-assertion). One entry per patient; no pagination. */
  patientsAwaitingDocuments: Array<PlatformPatientAwaitingDocuments>;
  /** Find all active patients with a current phone matching this E.164 number. Shared numbers can match multiple patients. */
  patientsByPhone: Array<PlatformPatient>;
  /** List patients that have ANY unresolved conflicts, with counts per conflict type */
  patientsWithConflicts: PlatformPatientConflictSummaryConnection;
  /**
   * Options for the PAYER_PICKER dynamic step: the hardcoded big-five cards and
   * the long-tail payer list behind "Other" (synced from the payer directory).
   * With a `sessionId`, the session's flow decides whether the self-pay card is
   * offered — only flows whose machine can route the Self-pay sentinel get it;
   * omitted or unknown sessions never do.
   */
  payerOptions: PlatformPayerOptions;
  /** Active payers from the synced payer directory (the onboarding payer step's long-tail typeahead source). */
  payers: Array<PlatformPayer>;
  /**
   * Appointment-fee operations matching every given filter, oldest change first
   * (then id). Use `ids` to reconcile known operations and `updatedAfter` to
   * follow changes (refunds and disputes arrive after the charge). A charge to a
   * card in Healthie's Stripe is refunded and disputed outside payments, so its
   * operation never moves past SUCCEEDED here. Empty page when none match.
   */
  paymentOperations: PlatformPaymentOperationPage;
  /**
   * The patient's saved card in the Stripe account that takes their new cards,
   * or in the other account when that one has none; the caller never learns or
   * chooses the account. Never null: a patient with no card has a null
   * `savedCard`. A processor read failure is a top-level error, never a
   * null card. The caller must authorize `patientId`.
   */
  paymentProfile: PlatformPaymentProfile;
  /**
   * Mint a Healthie-backed Stripe SetupIntent for wallet card entry. Nothing is
   * charged. Null means the caller should render manual card entry only.
   */
  paymentSetupIntent?: Maybe<PlatformPaymentSetupIntent>;
  /** Every prescriber (the full matchable universe), regardless of state or payer. Used to warm provider availability. */
  prescribers: Array<PlatformProvider>;
  /**
   * The patient's ACTIVE prescription that has no recorded pickup date and is
   * still within its supply window (today < effectiveAt + daysSupply days).
   * Returns null when none qualifies (no active Rx, pickup already recorded, the
   * supply window has ended, or effectiveAt/daysSupply are unknown). Drives the
   * patient-app prompt asking when the prescription was picked up.
   */
  prescriptionPendingPickup?: Maybe<PlatformPrescriptionPendingPickup>;
  /**
   * The secure prescription-photo link from the post-booking email.
   * `UNAVAILABLE` means the token is unknown. `NEEDS_UPLOAD` means the patient
   * skipped during intake and no photo is stored. `SAVED` means a photo is
   * stored in monorepo Documents. `INCOMPLETE` means that copy exists and the
   * patient-record copy does not yet — retry files the stored photo and does
   * not need another upload. `REJECTED` is not stored.
   */
  prescriptionPhotoLink: PlatformPrescriptionPhotoLink;
  /**
   * Paginated prescription review for the authenticated provider.
   * stage: "needs_decision" | "pa_status" | "prescribed" | "not_prescribed" | "awaiting_information" | "all"
   *
   * The acting provider is inferred from the request auth context, never from
   * arguments. Missing or invalid provider auth is rejected.
   */
  prescriptionReview: PlatformPrescriptionReviewResult;
  /**
   * Generate (WITHOUT submitting to CMS) the baseline OAP measures bundle for an
   * enrollment, for staging inspection/testing. Returns the FHIR
   * access-data-reporting-bundle document plus a measure summary, and logs a
   * PHI-safe summary. The returned bundle contains PHI — admin/testing use only.
   */
  previewAccessOapBundle: PlatformAccessOapBundlePreview;
  /** Most recently submitted in-progress or completed PriorAuthorization; otherwise the latest non-failed authorization, then the latest failed authorization, or null. */
  priorAuthByPatient?: Maybe<PlatformPriorAuthorization>;
  /**
   * Single PriorAuthorization by local id, plus live Develop activity_log and
   * message_thread. Prefer list queries for browse; use this for detail only
   * (Develop GET is slow). Returns null when the PA id is unknown.
   */
  priorAuthExtended?: Maybe<PlatformPriorAuthorizationExtended>;
  /** All PriorAuthorizations for a patient (newest submittedAt first). */
  priorAuthsByPatient: Array<PlatformPriorAuthorization>;
  /** Retrieve a program by ID */
  program?: Maybe<PlatformProgram>;
  /** List all programs */
  programs: Array<PlatformProgram>;
  /** Retrieve a provider by their internal ID */
  provider?: Maybe<PlatformProvider>;
  /** Get all conflicts for a single provider, aggregated across types */
  providerAllConflicts?: Maybe<PlatformProviderAllConflicts>;
  /** Canonical same-day booking settings read directly from the provider Airtable record. */
  providerBookingSettings: PlatformProviderBookingSettings;
  /** Retrieve a provider by email address */
  providerByEmail?: Maybe<PlatformProvider>;
  /** Retrieve a provider by external system ID */
  providerByExternalId?: Maybe<PlatformProvider>;
  /** Retrieve a provider by NPI (National Provider Identifier) */
  providerByNpi?: Maybe<PlatformProvider>;
  /**
   * Exposed only to first-party backends (global API-key guard). Stored clinical
   * roles, synced on a schedule from the Airtable RD Funnel. A refused sync keeps
   * the last roles. Results are unordered and an id with no stored role is left
   * out, so match results by providerId. More than 500 distinct ids is a
   * BAD_USER_INPUT error. A step-1 read for provider-matching's flagged role
   * filters (BSE-3895), removed when Provider.profile moves to provider-profile;
   * read Provider.profile instead.
   */
  providerClinicalRoles: Array<PlatformProviderClinicalRole>;
  /**
   * Authorize access to the current published file for an assigned document.
   * Access and denial are both audited. Returns the unavailable branch while the
   * current version has no published object; unassigned or unknown documents
   * are a not-found error.
   */
  providerDocumentFileAccess: PlatformProviderDocumentFileAccess;
  /**
   * Internal publishing snapshot for a catalog slug. Null when the slug is
   * unknown. Includes version ids and statuses needed to reuse a draft or set
   * expectedCurrentVersionId.
   */
  providerDocumentPublishingState?: Maybe<PlatformProviderDocumentPublishingState>;
  /** Find all provider email conflicts */
  providerEmailConflicts: PlatformProviderEmailConflictConnection;
  /**
   * Latest email-origin backfill run for each stage, with origin counters
   * from the workflow progress query. Do not overlap Airtable and Healthie
   * stages on the shared origin-backfill queue.
   */
  providerEmailOriginBackfillStatus: PlatformProviderEmailOriginBackfillStatus;
  /** Find all provider external ID conflicts (optionally filtered by system) */
  providerExternalIdConflicts: PlatformProviderExternalIdConflictConnection;
  providerNavihealthBackfillStatus: PlatformProviderNavihealthBackfillStatus;
  /**
   * Paginated list of all providers, with optional search filters.
   *
   * `system` + `hasExternalId` filter by whether a record has an active
   * external ID for the given system: `hasExternalId: true` keeps only
   * records with one, `false` keeps only those without (including records
   * with no external IDs at all). Both args must be supplied together;
   * either one alone is a no-op. The filter is reflected in `totalCount`.
   */
  providers: PlatformProviderConnection;
  /**
   * Retrieve multiple providers by internal ID in one call. Positional —
   * result order matches `ids`, with an unknown id resolved to null.
   */
  providersByIds: Array<Maybe<PlatformProvider>>;
  /** List providers that have ANY unresolved conflicts, with counts per conflict type */
  providersWithConflicts: PlatformProviderConflictSummaryConnection;
  /**
   * One referring physician by Healthie's id. Null when Healthie has no such physician.
   * Read live; nothing is stored. Platform API key only; machine tokens are refused.
   *
   * Errors: BAD_USER_INPUT for a blank id; UPSTREAM_UNAVAILABLE when Healthie fails or errors.
   */
  referringPhysician?: Maybe<PlatformReferringPhysician>;
  /**
   * `referringPhysicians` with each physician's referrals instead of its details, under
   * the same paging rules. Platform API key only; machine tokens are refused.
   *
   * Errors: BAD_USER_INPUT for an out-of-range offset or pageSize; UPSTREAM_UNAVAILABLE
   * when Healthie fails or errors.
   */
  referringPhysicianReferrals: Array<PlatformReferringPhysicianReferrals>;
  /**
   * One page of every referring physician in Healthie, ordered by name. Page with
   * offset; an empty list is the end. pageSize must be between 1 and 1000. Platform API key only; machine tokens are refused.
   * Healthie caps `after`-cursor pages at 100 rows, so this pages by offset.
   *
   * Errors: BAD_USER_INPUT for an out-of-range offset or pageSize; UPSTREAM_UNAVAILABLE
   * when Healthie fails or errors.
   */
  referringPhysicians: Array<PlatformReferringPhysician>;
  /**
   * Searches the CMS NPI Registry by provider name, or by exact NPI for a
   * ten-digit numeric search. Returns at most ten unique matches in CMS response
   * order. A trimmed search shorter than two characters returns an empty list.
   * CMS failures surface as query errors so the client can fall back to manual
   * entry rather than presenting a false no-match result.
   */
  referringProviderOptions: Array<PlatformReferringProviderOption>;
  /** Get a presigned URL for downloading a static resource (e.g., journey PDFs) */
  resourceDownloadUrl: PlatformDownloadUrlResponse;
  /** Retrieve all rollover goals related to a root goal (includes the root goal itself) */
  rolloverGoals: Array<PlatformSessionGoal>;
  /** Valid ICD-10 codes matching the keywords, read live from Healthie in Healthie's order. Errors: BAD_REQUEST when keywords are shorter than 2 characters; INTERNAL_SERVER_ERROR when the Healthie lookup fails or returns a code without a value, rather than returning an empty list. */
  searchIcdCodes: Array<PlatformIcdCode>;
  /**
   * Lists every service in the access-request catalog, including allowed
   * access levels and a preview of the sub-tickets that will be opened.
   */
  serviceCatalog: Array<PlatformServiceCatalogEntry>;
  /** Retrieve a single session goal by ID */
  sessionGoal?: Maybe<PlatformSessionGoal>;
  /** Retrieve session goals for a patient */
  sessionGoals: Array<PlatformSessionGoal>;
  /** The provider specialty / visit-reason vocabulary, in curated display order. */
  specialtyCategories: Array<PlatformSpecialtyCategory>;
  /** Every NP licensed/bookable in the state. Used as the preferred-provider set for booking-time NP-first tiering. */
  stateLicensedNursePractitioners: Array<PlatformProvider>;
  /** Every prescriber licensed in a state, regardless of payer enrollment. The relaxation set a caller widens to when no payer-matched prescriber is available soon (a superset of matchPrescribers for that state). */
  stateLicensedPrescribers: Array<PlatformProvider>;
  /** Whether the verified provider is eligible, mapped and configured. Fails closed. */
  supportAvailability: PlatformSupportAvailability;
  /** Current eligible conversation owned solely by the acting provider; missing or inaccessible conversations return NOT_FOUND without content. Requires a provider assertion. */
  supportConversation: PlatformSupportConversationPayload;
  /** Acting provider's tagged requests or verified human-admin outreach, newest update first, 20 candidates per page. Optional patientId matches structured string metadata; unread: true returns only conversations Intercom reports unread. Empty filtered pages can have a cursor. Requires a provider assertion. */
  supportConversations: PlatformSupportConversationPage;
  /** Checks Intercom unread conversation metadata for the verified provider without fetching message histories. Requires a provider assertion; failures return unknown status and a typed error. */
  supportUnreadStatus: PlatformSupportUnreadStatus;
  /**
   * One tracked medication with its full non-removed dose history. Returns null
   * when the id is unknown *or* belongs to another patient — a mismatch is
   * indistinguishable from not-found, so the response never confirms an id exists.
   */
  trackedMedication?: Maybe<PlatformTrackedMedication>;
  /**
   * Active medications plus the effective default as a separate object, allowing
   * clients to select dose logs only on `defaultMedication`.
   */
  trackedMedicationOverview: PlatformTrackedMedicationOverview;
  /**
   * A patient's active tracked medications, newest first, each with its adherence
   * figures and next-dose forecast. Use `trackedMedicationOverview` when the
   * client needs logs only for the effective default medication.
   * Set `includeInactive` to read historical supplies; this never changes dose-entry
   * eligibility or makes an inactive supply the default.
   */
  trackedMedications: Array<PlatformTrackedMedication>;
  /**
   * The patient's soonest UPCOMING initial GLP-1 consultation, or null if none.
   * `patientId` is the canonical patient-registry id (resolved to Healthie
   * server-side). Queries Healthie directly — the authority, not the
   * webhook-lagged local mirror — so a consult booked moments ago in another
   * session is seen. Follow-up visits, past visits, and cancelled / re-scheduled
   * / no-show visits never count. Backs the onboarding funnel's double-booking
   * guard (GLPX-241): a patient who already holds one is routed to an
   * "already scheduled" terminal instead of booking a second.
   */
  upcomingGlp1InitialConsult?: Maybe<PlatformUpcomingGlp1Consult>;
  /** Current ordered visit-reason choices. Uses the frozen CBF vocabulary when provider-matching is empty or unavailable. */
  visitReasonOptions: Array<PlatformStepFieldOption>;
  /** Recent Zocdoc attempts for operations review. Filter by patient or status. */
  zocdocImportAttempts: Array<PlatformZocdocImportAttempt>;
};


export type PlatformQueryAccessAlignmentReviewDetailArgs = {
  accessEnrollmentId: Scalars['ID']['input'];
};


export type PlatformQueryAccessAlignmentReviewQueueArgs = {
  input: PlatformAccessAlignmentReviewQueueInput;
};


export type PlatformQueryAccessBaselineBodyMeasurementsArgs = {
  patientId: Scalars['ID']['input'];
};


export type PlatformQueryAccessBaselineOapOperationalStateArgs = {
  accessEnrollmentId: Scalars['ID']['input'];
};


export type PlatformQueryAccessCarePlanArgs = {
  healthieUserId: Scalars['String']['input'];
};


export type PlatformQueryAccessCarePlanHistoryArgs = {
  healthieUserId: Scalars['String']['input'];
};


export type PlatformQueryAccessCareUpdatesForFaxArgs = {
  carePlanId?: InputMaybe<Scalars['ID']['input']>;
};


export type PlatformQueryAccessCommsOptedOutHealthieUserIdsArgs = {
  healthieUserIds: Array<Scalars['String']['input']>;
};


export type PlatformQueryAccessDiagnosisOptionsArgs = {
  track: PlatformAccessTrack;
};


export type PlatformQueryAccessEnrollmentArgs = {
  healthieUserId: Scalars['String']['input'];
};


export type PlatformQueryAccessEnrollmentLookupArgs = {
  query: Scalars['String']['input'];
};


export type PlatformQueryAccessFailedAlignmentCorrectionContextArgs = {
  accessEnrollmentId: Scalars['ID']['input'];
};


export type PlatformQueryAccessNpReviewQueueArgs = {
  npProviderId: Scalars['String']['input'];
};


export type PlatformQueryAccessPostAlignmentQueueArgs = {
  input: PlatformAccessPostAlignmentQueueInput;
};


export type PlatformQueryAccessRejectionQueueArgs = {
  input: PlatformAccessRejectionQueueInput;
};


export type PlatformQueryActiveLabOrderArgs = {
  patientId: Scalars['ID']['input'];
};


export type PlatformQueryAgendaItemsArgs = {
  defaultStep?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<PlatformAgendaItemType>;
};


export type PlatformQueryAlreadyScheduledAppointmentArgs = {
  sessionId: Scalars['ID']['input'];
};


export type PlatformQueryAppointmentAvailabilityArgs = {
  input: PlatformAppointmentAvailabilityInput;
};


export type PlatformQueryAppointmentHoldsArgs = {
  sessionId: Scalars['ID']['input'];
};


export type PlatformQueryAppointmentProviderTimeZoneArgs = {
  appointmentId: Scalars['ID']['input'];
};


export type PlatformQueryAppointmentTypeDurationArgs = {
  appointmentType: PlatformAppointmentType;
};


export type PlatformQueryAttestationHistoryArgs = {
  documentId?: InputMaybe<Scalars['ID']['input']>;
};


export type PlatformQueryAutomaticBenefitsDecisionArgs = {
  input: PlatformAutomaticBenefitsDecisionInput;
};


export type PlatformQueryAvailabilityArgs = {
  providerId?: InputMaybe<Scalars['ID']['input']>;
  sessionId: Scalars['ID']['input'];
};


export type PlatformQueryAvailableSlotsArgs = {
  sessionId: Scalars['ID']['input'];
};


export type PlatformQueryBenefitsCheckByPatientArgs = {
  patientHealthieId: Scalars['ID']['input'];
};


export type PlatformQueryBloodPressureReadingsArgs = {
  input: PlatformBloodPressureHistoryInput;
};


export type PlatformQueryBookedAppointmentArgs = {
  sessionId: Scalars['ID']['input'];
};


export type PlatformQueryBookingSessionArgs = {
  token: Scalars['String']['input'];
};


export type PlatformQueryCareEscalationsArgs = {
  status?: InputMaybe<PlatformCareEscalationStatus>;
};


export type PlatformQueryCashPayContextArgs = {
  sessionId: Scalars['ID']['input'];
};


export type PlatformQueryChatChannelArgs = {
  patientId: Scalars['String']['input'];
  providerId: Scalars['String']['input'];
};


export type PlatformQueryChatChannelRecentTurnsArgs = {
  input: PlatformChatChannelRecentTurnsInput;
};


export type PlatformQueryChatChannelsArgs = {
  userId: Scalars['String']['input'];
};


export type PlatformQueryChatHealthieConversationIdArgs = {
  patientId: Scalars['String']['input'];
  providerId: Scalars['String']['input'];
};


export type PlatformQueryChatTokenArgs = {
  userId: Scalars['String']['input'];
};


export type PlatformQueryCheckPatientEmailConflictArgs = {
  emailAddress: Scalars['String']['input'];
};


export type PlatformQueryCheckPatientExternalIdConflictArgs = {
  externalId: Scalars['String']['input'];
  system: PlatformExternalSystem;
};


export type PlatformQueryCheckProviderEmailConflictArgs = {
  emailAddress: Scalars['String']['input'];
};


export type PlatformQueryCheckProviderExternalIdConflictArgs = {
  externalId: Scalars['String']['input'];
  system: PlatformProviderExternalSystem;
};


export type PlatformQueryCohortArgs = {
  id: Scalars['ID']['input'];
};


export type PlatformQueryCohortByRecurringAppointmentIdArgs = {
  healthieRecurringAppointmentId: Scalars['String']['input'];
};


export type PlatformQueryCohortSeriesByCohortIdArgs = {
  cohortId: Scalars['ID']['input'];
};


export type PlatformQueryCombinedOnboardingResultsArgs = {
  sessionId: Scalars['ID']['input'];
};


export type PlatformQueryCoverageSummaryArgs = {
  sessionId: Scalars['ID']['input'];
};


export type PlatformQueryCrmEventArgs = {
  id: Scalars['ID']['input'];
};


export type PlatformQueryCrossSellBookingOfferArgs = {
  patientHealthieId: Scalars['ID']['input'];
  sourceAppointmentHealthieId: Scalars['ID']['input'];
};


export type PlatformQueryDailyHealthMetricsArgs = {
  input: PlatformGetDailyHealthMetricsInput;
};


export type PlatformQueryDietitianOptionsArgs = {
  availableBetween?: InputMaybe<PlatformAvailabilityRangeInput>;
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sessionId: Scalars['ID']['input'];
};


export type PlatformQueryDocumentArgs = {
  documentId: Scalars['ID']['input'];
  healthieUserId: Scalars['ID']['input'];
};


export type PlatformQueryDocumentDownloadUrlArgs = {
  input: PlatformDocumentDownloadInput;
};


export type PlatformQueryDocumentRequestDownloadUrlArgs = {
  input: PlatformDocumentRequestDownloadInput;
};


export type PlatformQueryDocumentsArgs = {
  filters: PlatformDocumentFiltersInput;
};


export type PlatformQueryEhrChartingItemsArgs = {
  patient: PlatformEhrVitalsPatientInput;
};


export type PlatformQueryEhrChartingNoteArgs = {
  id: Scalars['ID']['input'];
};


export type PlatformQueryEhrChartingNotesArgs = {
  input: PlatformEhrChartingNotesInput;
};


export type PlatformQueryEhrDocumentsArgs = {
  patient: PlatformEhrDocumentPatientInput;
};


export type PlatformQueryEhrHeightWeightArgs = {
  patient: PlatformEhrVitalsPatientInput;
};


export type PlatformQueryEhrMetricEntriesArgs = {
  input: PlatformEhrMetricEntriesInput;
};


export type PlatformQueryEhrMetricEntryArgs = {
  entryId: Scalars['ID']['input'];
  patient: PlatformEhrVitalsPatientInput;
};


export type PlatformQueryEhrPrescriptionsArgs = {
  patient: PlatformEhrDocumentPatientInput;
};


export type PlatformQueryEhrWeightEntriesArgs = {
  input: PlatformEhrWeightEntriesInput;
};


export type PlatformQueryEhrWeightGraphArgs = {
  input: PlatformEhrWeightGraphInput;
};


export type PlatformQueryEligibilityCheckArgs = {
  input: PlatformEligibilityRequestInput;
};


export type PlatformQueryEnrollmentArgs = {
  id: Scalars['ID']['input'];
};


export type PlatformQueryEnrollmentsByHealthieClientIdArgs = {
  healthieClientId: Scalars['String']['input'];
};


export type PlatformQueryFoodJournalEntriesArgs = {
  input: PlatformGetFoodEntriesInput;
};


export type PlatformQueryFoodJournalEntryArgs = {
  id: Scalars['ID']['input'];
};


export type PlatformQueryFoodJournalSnapshotArgs = {
  input: PlatformFoodJournalSnapshotInput;
};


export type PlatformQueryGlp1AppointmentSummaryByPatientArgs = {
  patientHealthieId: Scalars['ID']['input'];
};


export type PlatformQueryGlp1IneligibleOutcomeArgs = {
  sessionId: Scalars['ID']['input'];
};


export type PlatformQueryGlp1IntakeByPatientArgs = {
  patientHealthieId: Scalars['ID']['input'];
};


export type PlatformQueryGlp1PrescriptionTaskContextArgs = {
  taskId: Scalars['ID']['input'];
};


export type PlatformQueryGlp1PrescriptionTasksArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  providerHealthieId?: InputMaybe<Scalars['ID']['input']>;
};


export type PlatformQueryGlucoseReadingsArgs = {
  input: PlatformGlucoseHistoryInput;
};


export type PlatformQueryGuardianBookingContextArgs = {
  sessionId: Scalars['ID']['input'];
};


export type PlatformQueryHasActiveEatingDisorderArgs = {
  patientId: Scalars['ID']['input'];
};


export type PlatformQueryHealthieAppointmentArgs = {
  id: Scalars['ID']['input'];
};


export type PlatformQueryHealthieAppointmentTypesArgs = {
  keywords?: InputMaybe<Scalars['String']['input']>;
  providerId?: InputMaybe<Scalars['ID']['input']>;
};


export type PlatformQueryHealthieAvailabilitySlotsArgs = {
  appointmentTypeId: Scalars['ID']['input'];
  endDate: Scalars['String']['input'];
  providerId: Scalars['ID']['input'];
  startDate: Scalars['String']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
};


export type PlatformQueryHealthieFormAnswerGroupArgs = {
  id: Scalars['ID']['input'];
};


export type PlatformQueryHealthieInsurancePlansArgs = {
  keywords?: InputMaybe<Scalars['String']['input']>;
};


export type PlatformQueryHealthiePatientArgs = {
  id: Scalars['ID']['input'];
};


export type PlatformQueryHealthiePatientAppointmentsArgs = {
  filter?: InputMaybe<PlatformHealthieAppointmentFilter>;
  patientId: Scalars['ID']['input'];
};


export type PlatformQueryHealthiePatientByEmailArgs = {
  email: Scalars['String']['input'];
};


export type PlatformQueryHealthiePatientInsurancePoliciesArgs = {
  patientId: Scalars['ID']['input'];
};


export type PlatformQueryHealthieProviderArgs = {
  id: Scalars['ID']['input'];
};


export type PlatformQueryHealthieProvidersAvailabilityArgs = {
  appointmentTypeId: Scalars['ID']['input'];
  endDate: Scalars['String']['input'];
  providerIds: Array<Scalars['ID']['input']>;
  startDate: Scalars['String']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
};


export type PlatformQueryHealthieStripeCardsArgs = {
  patientId: Scalars['ID']['input'];
};


export type PlatformQueryHealthieUserGroupsArgs = {
  keywords?: InputMaybe<Scalars['String']['input']>;
};


export type PlatformQueryJournalEntriesArgs = {
  input: PlatformGetJournalEntriesInput;
};


export type PlatformQueryJournalEntryArgs = {
  id: Scalars['ID']['input'];
  patientRegistryId?: InputMaybe<Scalars['ID']['input']>;
};


export type PlatformQueryJournalEntryCommentsArgs = {
  input: PlatformJournalEntryCommentsInput;
};


export type PlatformQueryJournalEntryIdMapArgs = {
  healthieEntryIds: Array<Scalars['ID']['input']>;
  patientRegistryId: Scalars['ID']['input'];
};


export type PlatformQueryJournalEntryServedIdArgs = {
  healthieEntryId?: InputMaybe<Scalars['ID']['input']>;
  navihealthId?: InputMaybe<Scalars['ID']['input']>;
  navihealthKey?: InputMaybe<Scalars['String']['input']>;
  patientRegistryId: Scalars['ID']['input'];
  type: PlatformJournalEntryFilterType;
};


export type PlatformQueryLabOrderArgs = {
  orderId: Scalars['ID']['input'];
  patientId: Scalars['ID']['input'];
};


export type PlatformQueryLabOrdersByPatientArgs = {
  patientId: Scalars['ID']['input'];
};


export type PlatformQueryLatestTrackedMedicationArgs = {
  patientHealthieId: Scalars['ID']['input'];
};


export type PlatformQueryLeadNameContextArgs = {
  sessionId: Scalars['ID']['input'];
};


export type PlatformQueryMatchDietitiansArgs = {
  input: PlatformMatchDietitiansInput;
};


export type PlatformQueryMatchPrescribersArgs = {
  input: PlatformMatchPrescribersInput;
};


export type PlatformQueryMedicalBackgroundContextArgs = {
  sessionId: Scalars['ID']['input'];
};


export type PlatformQueryMedicalHistoryArgs = {
  patientId: Scalars['ID']['input'];
};


export type PlatformQueryMedicareBridgeCaseArgs = {
  patientHealthieId: Scalars['ID']['input'];
  programType?: InputMaybe<PlatformProgramType>;
};


export type PlatformQueryMedicareBridgeCaseByIdArgs = {
  id: Scalars['ID']['input'];
};


export type PlatformQueryMedicareBridgeCasesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<PlatformMedicareBridgeCaseFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type PlatformQueryMedicationArgs = {
  id: Scalars['ID']['input'];
};


export type PlatformQueryMedicationProgramEnrollmentByPatientArgs = {
  patientHealthieId: Scalars['ID']['input'];
  programType?: InputMaybe<PlatformProgramType>;
};


export type PlatformQueryMedicationProgramPrescriptionsByPatientArgs = {
  patientHealthieId: Scalars['ID']['input'];
};


export type PlatformQueryMedicationTakeLogsArgs = {
  from: Scalars['String']['input'];
  patientHealthieId: Scalars['ID']['input'];
  to: Scalars['String']['input'];
};


export type PlatformQueryMedicationsArgs = {
  filters: PlatformMedicationFiltersInput;
};


export type PlatformQueryNearbyLabsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  radiusMiles?: InputMaybe<Scalars['Int']['input']>;
  zipCode: Scalars['String']['input'];
};


export type PlatformQueryOnboardingFlowStartPolicyArgs = {
  flowId: Scalars['String']['input'];
};


export type PlatformQueryOnboardingSessionArgs = {
  id: Scalars['ID']['input'];
};


export type PlatformQueryPatientArgs = {
  id: Scalars['ID']['input'];
};


export type PlatformQueryPatientAgendaHistoryArgs = {
  patientId: Scalars['String']['input'];
  step?: InputMaybe<Scalars['Int']['input']>;
};


export type PlatformQueryPatientAllConflictsArgs = {
  patientId: Scalars['ID']['input'];
};


export type PlatformQueryPatientBaseProfileArgs = {
  healthieUserId?: InputMaybe<Scalars['ID']['input']>;
  patientRegistryId?: InputMaybe<Scalars['ID']['input']>;
};


export type PlatformQueryPatientByEmailArgs = {
  emailAddress: Scalars['String']['input'];
};


export type PlatformQueryPatientByExternalIdArgs = {
  externalId: Scalars['String']['input'];
  system: PlatformExternalSystem;
};


export type PlatformQueryPatientChatHistoryArgs = {
  input: PlatformPatientChatHistoryInput;
};


export type PlatformQueryPatientContextArgs = {
  healthieUserId?: InputMaybe<Scalars['ID']['input']>;
  patientRegistryId?: InputMaybe<Scalars['ID']['input']>;
};


export type PlatformQueryPatientDocumentCenterArgs = {
  healthieUserId: Scalars['ID']['input'];
};


export type PlatformQueryPatientDocumentDownloadUrlArgs = {
  input: PlatformPatientDocumentDownloadInput;
};


export type PlatformQueryPatientDocumentFileArgs = {
  documentId: Scalars['ID']['input'];
};


export type PlatformQueryPatientDocumentsArgs = {
  documentType?: InputMaybe<PlatformDocumentType>;
  patient: PlatformDocumentPatientInput;
};


export type PlatformQueryPatientEmailConflictsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type PlatformQueryPatientExternalIdConflictsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  system?: InputMaybe<PlatformExternalSystem>;
};


export type PlatformQueryPatientGlp1JourneyByPatientArgs = {
  patientHealthieId: Scalars['ID']['input'];
};


export type PlatformQueryPatientInsuranceDetailsArgs = {
  patient: PlatformInsurancePatientInput;
};


export type PlatformQueryPatientInsurancePoliciesArgs = {
  patient: PlatformInsurancePatientInput;
};


export type PlatformQueryPatientIntercomConversationThreadArgs = {
  conversationId: Scalars['ID']['input'];
  healthieUserId: Scalars['String']['input'];
};


export type PlatformQueryPatientIntercomConversationsArgs = {
  healthieUserId: Scalars['String']['input'];
};


export type PlatformQueryPatientInvoiceArgs = {
  input: PlatformPatientInvoiceInput;
};


export type PlatformQueryPatientInvoicesArgs = {
  input: PlatformPatientInvoicesInput;
};


export type PlatformQueryPatientJournalEntryArgs = {
  id: Scalars['ID']['input'];
  patientRegistryId: Scalars['ID']['input'];
};


export type PlatformQueryPatientLoginIdentityArgs = {
  emailAddress: Scalars['String']['input'];
};


export type PlatformQueryPatientLookupArgs = {
  input: PlatformPatientLookupInput;
};


export type PlatformQueryPatientNotesArgs = {
  patientId: Scalars['ID']['input'];
};


export type PlatformQueryPatientNutrientGoalsArgs = {
  patientId?: InputMaybe<Scalars['ID']['input']>;
  patientRegistryId?: InputMaybe<Scalars['ID']['input']>;
};


export type PlatformQueryPatientOnboardingAnswersArgs = {
  healthieUserId: Scalars['ID']['input'];
};


export type PlatformQueryPatientProfileArgs = {
  healthieUserId: Scalars['ID']['input'];
};


export type PlatformQueryPatientReferralIdentityArgs = {
  id: Scalars['ID']['input'];
};


export type PlatformQueryPatientReferringPhysiciansArgs = {
  patient: PlatformReferringPhysicianPatientInput;
};


export type PlatformQueryPatientScheduleConflictsArgs = {
  input: PlatformPatientScheduleConflictsInput;
};


export type PlatformQueryPatientsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasExternalId?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<PlatformPatientStatus>;
  system?: InputMaybe<PlatformExternalSystem>;
};


export type PlatformQueryPatientsByPhoneArgs = {
  phoneNumber: Scalars['String']['input'];
};


export type PlatformQueryPatientsWithConflictsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type PlatformQueryPayerOptionsArgs = {
  sessionId?: InputMaybe<Scalars['ID']['input']>;
};


export type PlatformQueryPaymentOperationsArgs = {
  input: PlatformPaymentOperationsInput;
};


export type PlatformQueryPaymentProfileArgs = {
  patientId: Scalars['ID']['input'];
};


export type PlatformQueryPaymentSetupIntentArgs = {
  input: PlatformPaymentSetupIntentInput;
};


export type PlatformQueryPrescriptionPendingPickupArgs = {
  patientHealthieId: Scalars['ID']['input'];
};


export type PlatformQueryPrescriptionPhotoLinkArgs = {
  token: Scalars['String']['input'];
};


export type PlatformQueryPrescriptionReviewArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  patientHealthieIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  providerHealthieId?: InputMaybe<Scalars['ID']['input']>;
  stage: Scalars['String']['input'];
};


export type PlatformQueryPreviewAccessOapBundleArgs = {
  accessEnrollmentId: Scalars['ID']['input'];
  authorProviderId?: InputMaybe<Scalars['ID']['input']>;
};


export type PlatformQueryPriorAuthByPatientArgs = {
  patientHealthieId: Scalars['ID']['input'];
  submittedAt?: InputMaybe<Scalars['DateTime']['input']>;
};


export type PlatformQueryPriorAuthExtendedArgs = {
  id: Scalars['ID']['input'];
};


export type PlatformQueryPriorAuthsByPatientArgs = {
  patientHealthieId: Scalars['ID']['input'];
};


export type PlatformQueryProgramArgs = {
  id: Scalars['ID']['input'];
};


export type PlatformQueryProviderArgs = {
  id: Scalars['ID']['input'];
};


export type PlatformQueryProviderAllConflictsArgs = {
  providerId: Scalars['ID']['input'];
};


export type PlatformQueryProviderBookingSettingsArgs = {
  healthieProviderId: Scalars['ID']['input'];
};


export type PlatformQueryProviderByEmailArgs = {
  emailAddress: Scalars['String']['input'];
};


export type PlatformQueryProviderByExternalIdArgs = {
  externalId: Scalars['String']['input'];
  system: PlatformProviderExternalSystem;
};


export type PlatformQueryProviderByNpiArgs = {
  npi: Scalars['String']['input'];
};


export type PlatformQueryProviderClinicalRolesArgs = {
  providerIds: Array<Scalars['ID']['input']>;
};


export type PlatformQueryProviderDocumentFileAccessArgs = {
  documentId: Scalars['ID']['input'];
};


export type PlatformQueryProviderDocumentPublishingStateArgs = {
  slug: Scalars['String']['input'];
};


export type PlatformQueryProviderEmailConflictsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type PlatformQueryProviderExternalIdConflictsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  system?: InputMaybe<PlatformProviderExternalSystem>;
};


export type PlatformQueryProvidersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasExternalId?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<PlatformProviderStatus>;
  system?: InputMaybe<PlatformProviderExternalSystem>;
};


export type PlatformQueryProvidersByIdsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type PlatformQueryProvidersWithConflictsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type PlatformQueryReferringPhysicianArgs = {
  id: Scalars['ID']['input'];
};


export type PlatformQueryReferringPhysicianReferralsArgs = {
  offset: Scalars['Int']['input'];
  pageSize?: Scalars['Int']['input'];
};


export type PlatformQueryReferringPhysiciansArgs = {
  offset: Scalars['Int']['input'];
  pageSize?: Scalars['Int']['input'];
};


export type PlatformQueryReferringProviderOptionsArgs = {
  search: Scalars['String']['input'];
};


export type PlatformQueryResourceDownloadUrlArgs = {
  resourceId: Scalars['String']['input'];
};


export type PlatformQueryRolloverGoalsArgs = {
  rootGoalId: Scalars['ID']['input'];
};


export type PlatformQuerySearchIcdCodesArgs = {
  keywords: Scalars['String']['input'];
};


export type PlatformQuerySessionGoalArgs = {
  id: Scalars['ID']['input'];
};


export type PlatformQuerySessionGoalsArgs = {
  filters: PlatformSessionGoalFiltersInput;
};


export type PlatformQueryStateLicensedNursePractitionersArgs = {
  stateCode: Scalars['String']['input'];
};


export type PlatformQueryStateLicensedPrescribersArgs = {
  stateCode: Scalars['String']['input'];
};


export type PlatformQuerySupportConversationArgs = {
  id: Scalars['ID']['input'];
};


export type PlatformQuerySupportConversationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  patientId?: InputMaybe<Scalars['String']['input']>;
  unread?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PlatformQueryTrackedMedicationArgs = {
  medicationId: Scalars['ID']['input'];
  patientHealthieId: Scalars['ID']['input'];
};


export type PlatformQueryTrackedMedicationOverviewArgs = {
  patientHealthieId: Scalars['ID']['input'];
};


export type PlatformQueryTrackedMedicationsArgs = {
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
  patientHealthieId: Scalars['ID']['input'];
};


export type PlatformQueryUpcomingGlp1InitialConsultArgs = {
  patientId: Scalars['ID']['input'];
};


export type PlatformQueryZocdocImportAttemptsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  patientHealthieId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

/** Input for reassigning a patient's primary provider. */
export type PlatformReassignPrimaryProviderInput = {
  /** Canonical provider-registry id of the provider to assign as the patient's primary provider. Resolved to the provider's Healthie id internally. */
  assignedProviderId: Scalars['ID']['input'];
  /** Internal patient registry id whose primary provider is being reassigned */
  patientId: Scalars['ID']['input'];
};

export type PlatformRecordAccessCareUpdateFaxInput = {
  carePlanId: Scalars['ID']['input'];
  documentSha256?: InputMaybe<Scalars['String']['input']>;
  externalFaxId?: InputMaybe<Scalars['String']['input']>;
  faxLogId: Scalars['ID']['input'];
  faxNumber?: InputMaybe<Scalars['String']['input']>;
  healthieDocumentId: Scalars['ID']['input'];
  /** Time recorded by Admin or InterFAX, rather than the later audit-sync time. */
  occurredAt: Scalars['DateTime']['input'];
  outcome: PlatformAccessCareUpdateFaxOutcome;
  recipientName?: InputMaybe<Scalars['String']['input']>;
  recipientNpi?: InputMaybe<Scalars['String']['input']>;
  skipReason?: InputMaybe<Scalars['String']['input']>;
};

export type PlatformRecordAccessCareUpdateFaxPayload = {
  __typename?: 'RecordAccessCareUpdateFaxPayload';
  recorded: Scalars['Boolean']['output'];
};

/**
 * Record that CMS un-aligned an ACCESS beneficiary after a successful `$align`.
 * CMS reports this out of band and identifies the patient by the `$align`
 * submission id (the UUID tail of the stored external submission id).
 *
 * Allowed only from ALIGNED / ALIGNED_SUCCESSFULLY_SWITCHED. Replaying the same
 * notice (already UNALIGNED_BY_CMS with the same `cmsSubmissionId`) is an
 * idempotent no-op; any other state, or a different submission id, errors. When
 * `cmsSubmissionId` is given it must match an ALIGN submission on THIS enrollment,
 * so a notice cannot be recorded against the wrong patient.
 */
export type PlatformRecordAccessCmsUnalignmentInput = {
  accessEnrollmentId: Scalars['ID']['input'];
  /** The $align submission id from CMS's notice; optional when the notice carried none. */
  cmsSubmissionId?: InputMaybe<Scalars['String']['input']>;
  /** Effective date of the un-alignment as CMS reported it. */
  effectiveDate: Scalars['DateTime']['input'];
  reason: Scalars['String']['input'];
  reviewerActorId?: InputMaybe<Scalars['ID']['input']>;
  /** Recording surface, e.g. `admin_access_alignment_ui`; defaults to `access-program`. */
  source?: InputMaybe<Scalars['String']['input']>;
};

export type PlatformRecordAccessCmsUnalignmentPayload = {
  __typename?: 'RecordAccessCmsUnalignmentPayload';
  accessEnrollmentId: Scalars['ID']['output'];
  /** True when this call recorded nothing because the same notice was already recorded. */
  idempotent: Scalars['Boolean']['output'];
  isActive: Scalars['Boolean']['output'];
  status: PlatformAccessEnrollmentStatus;
  unalignedAt: Scalars['DateTime']['output'];
  unalignmentCmsSubmissionId?: Maybe<Scalars['String']['output']>;
  unalignmentReason: Scalars['String']['output'];
};

/**
 * Record that the patient asked to stop participating in ACCESS.
 * Stops patient comms only: Customer.io excludes the patient on the
 * `access_comms_opted_out_at` profile attribute (sent with the
 * `access.journey.comms_opted_out` event) and Perry's proactive sweep skips them.
 * The enrollment keeps its state, because CMS still considers the patient aligned
 * until a formal exit.
 *
 * Allowed for any enrollment, active or not. Recorded once per patient, including
 * under concurrent calls: when the patient already has an opt-out, recording
 * again (from any of their enrollments) changes nothing, returns that opt-out
 * (`idempotent: true`) and sends the same attribute and event again, which is
 * safe to repeat.
 *
 * Errors: BAD_REQUEST when `reason` is empty or longer than 500 characters,
 * NOT_FOUND for an unknown enrollment.
 */
export type PlatformRecordAccessCommsOptOutInput = {
  accessEnrollmentId: Scalars['ID']['input'];
  /** Why the patient asked to stop, as ops recorded it; 1 to 500 characters. */
  reason: Scalars['String']['input'];
  /**
   * Admin user id of the reviewer recording it, supplied by the calling surface
   * and not verified here; null records a system actor.
   */
  reviewerActorId?: InputMaybe<Scalars['ID']['input']>;
  /** Recording surface, e.g. `admin_access_alignment_ui`; defaults to `access-program`. */
  source?: InputMaybe<Scalars['String']['input']>;
};

/**
 * The patient's opt-out. On an idempotent call these describe the opt-out as
 * first recorded, so `accessEnrollmentId`, `status`, the reason and the reviewer
 * can differ from the input: the new reason and reviewer are not stored and no
 * audit event is written.
 */
export type PlatformRecordAccessCommsOptOutPayload = {
  __typename?: 'RecordAccessCommsOptOutPayload';
  /** The enrollment the opt-out was first recorded from; may differ from the input. */
  accessEnrollmentId: Scalars['ID']['output'];
  commsOptOutReason: Scalars['String']['output'];
  commsOptedOutAt: Scalars['DateTime']['output'];
  /** The recording reviewer's id; null when the opt-out was recorded without one. */
  commsOptedOutBy?: Maybe<Scalars['String']['output']>;
  /** True when this call recorded nothing because the opt-out was already recorded. */
  idempotent: Scalars['Boolean']['output'];
  /** That enrollment's current state, unchanged by the opt-out. */
  status: PlatformAccessEnrollmentStatus;
};

/** One add-only lab transcribed by an authorized reviewer from a Zus document. */
export type PlatformRecordAccessDocumentLabInput = {
  accessEnrollmentId: Scalars['ID']['input'];
  comparator: PlatformAccessLabComparator;
  documentUrl: Scalars['String']['input'];
  effectiveAt: Scalars['DateTime']['input'];
  /** LDL-C only. Omit when the document is silent; the server defaults to CALCULATED. */
  ldlMethod?: InputMaybe<PlatformAccessLdlMethod>;
  measureType: PlatformAccessClinicalMeasureType;
  reviewerActorId: Scalars['ID']['input'];
  value: Scalars['Float']['input'];
};

export type PlatformRecordAccessDocumentLabPayload = {
  __typename?: 'RecordAccessDocumentLabPayload';
  accessEnrollmentId: Scalars['ID']['output'];
  sourceResourceId: Scalars['ID']['output'];
};

/**
 * Append manually-entered referral clinical data for an ACCESS patient. Diagnoses
 * and measurements are written to clinical-records with source REFERRAL, alongside
 * (never overwriting) Zus data. Idempotent per (patient, type, value, date).
 */
export type PlatformRecordAccessReferralClinicalDataInput = {
  accessEnrollmentId: Scalars['ID']['input'];
  diagnoses?: InputMaybe<Array<PlatformRecordAccessReferralDiagnosisInput>>;
  measurements?: InputMaybe<Array<PlatformRecordAccessReferralMeasurementInput>>;
};

/**
 * Result of recording referral clinical data, including the refreshed review
 * projection so the admin UI updates without a second round-trip.
 */
export type PlatformRecordAccessReferralClinicalDataPayload = {
  __typename?: 'RecordAccessReferralClinicalDataPayload';
  accessEnrollmentId: Scalars['ID']['output'];
  diagnoses: Array<PlatformAccessClinicalDiagnosis>;
  diagnosesWritten: Scalars['Int']['output'];
  measurements: Array<PlatformAccessClinicalMeasurement>;
  measurementsWritten: Scalars['Int']['output'];
  warnings: Array<PlatformAccessReferralClinicalWarning>;
};

/** One manually-entered ICD-10 diagnosis from a referral PDF. */
export type PlatformRecordAccessReferralDiagnosisInput = {
  /** When the diagnosis was made per the referral. Required — a referral diagnosis carries a date. */
  diagnosedAt: Scalars['DateTime']['input'];
  icd10Code: Scalars['String']['input'];
};

/**
 * One manually-entered measurement from a referral PDF. Provide a direct `value`,
 * OR (for UACR only) `uacrComponents` to compute it. `measureType` maps to a
 * canonical LOINC code + unit server-side.
 */
export type PlatformRecordAccessReferralMeasurementInput = {
  measureType: PlatformAccessClinicalMeasureType;
  /** When the measurement was taken per the referral, if known. */
  measuredAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** UACR only: compute the ratio from albumin + creatinine instead of a direct value. */
  uacrComponents?: InputMaybe<PlatformAccessUacrComponentsInput>;
  /** Direct numeric value in the measure's canonical unit. Omit only when giving uACR components. */
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type PlatformRecordAccessReferralOutcomeInput = {
  accessEnrollmentId: Scalars['ID']['input'];
  adminReferralCorrelationKey: Scalars['String']['input'];
  evidence?: InputMaybe<PlatformAccessReferralEvidenceInput>;
  healthieUserId: Scalars['ID']['input'];
  icd10Code?: InputMaybe<Scalars['String']['input']>;
  patientReferralId?: InputMaybe<Scalars['ID']['input']>;
  referralOutcome: PlatformAccessReferralOutcome;
  referralStatusLogId?: InputMaybe<Scalars['ID']['input']>;
};

export type PlatformRecordAccessReferralOutcomePayload = {
  __typename?: 'RecordAccessReferralOutcomePayload';
  accessEnrollmentId: Scalars['ID']['output'];
  referralOutcome: PlatformAccessReferralOutcome;
  status: PlatformAccessEnrollmentStatus;
};

export type PlatformRecordBenefitsRequestDiagnosesInput = {
  dxCodes: Array<PlatformBenefitsRequestDiagnosisInput>;
  /** History ICD-10 codes retain their exact history meaning. */
  hxCodes?: InputMaybe<Array<PlatformBenefitsRequestDiagnosisInput>>;
  patientHealthieId: Scalars['ID']['input'];
  providerHealthieId: Scalars['ID']['input'];
  /** Admin request UUID, used as the immutable delivery key. */
  requestId: Scalars['ID']['input'];
  submittedAt: Scalars['DateTime']['input'];
};

export type PlatformRecordBenefitsRequestDiagnosesPayload = {
  __typename?: 'RecordBenefitsRequestDiagnosesPayload';
  diagnosisCount: Scalars['Int']['output'];
  patientId: Scalars['ID']['output'];
  requestId: Scalars['ID']['output'];
};

/** One blood-pressure submission for a canonical patient. */
export type PlatformRecordBloodPressureInput = {
  diastolic: Scalars['Float']['input'];
  /** Measurement time stamped by the capturing application, stable across retries. */
  measuredAt: Scalars['DateTime']['input'];
  patientId: Scalars['ID']['input'];
  sourceId: Scalars['String']['input'];
  systolic: Scalars['Float']['input'];
  unit: PlatformBloodPressureUnit;
};

/** Input to record the client's current consent-banner state on a session. */
export type PlatformRecordConsentSnapshotInput = {
  /** Consent categories the visitor accepted, or null if not reported. */
  acceptedCategories?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Whether the banner auto-displayed for this visitor, or null if not reported. */
  autoShow?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether a consent cookie was already present at capture time. */
  cookiePresent: Scalars['Boolean']['input'];
  /** Consent-banner interaction mode reported by the CMP, or null if not reported. */
  mode?: InputMaybe<Scalars['String']['input']>;
  /** Opaque session handle returned at session start. */
  sessionId: Scalars['ID']['input'];
};

/** Successful consent-snapshot capture (updated session) or a business error the client must handle. */
export type PlatformRecordConsentSnapshotResult = PlatformOnboardingSession | PlatformSessionNotFoundError;

export type PlatformRecordGlp1NotPrescribedDecisionInput = {
  patientHealthieId: Scalars['ID']['input'];
  /** @deprecated Ignored. The acting provider comes from the verified provider assertion (x-bst-provider-assertion). Stop sending it; this argument will be removed. */
  providerHealthieId?: InputMaybe<Scalars['ID']['input']>;
  /** Optional clinician-provided reason (e.g. contraindication, patient declined). */
  reason?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Input for recording a single measurement. Insert-only: (source, sourceResourceId) is globally
 * unique, so recording a pair that already exists is rejected (never updated), and callers must make
 * sourceResourceId unique within a source. Provide exactly one of value (+ unit) for quantitative
 * readings or valueText for qualitative ones; required strings must be non-blank.
 */
export type PlatformRecordMeasurementInput = {
  /** Measurement code (e.g. a LOINC code) */
  code: Scalars['String']['input'];
  /** Human-readable label for the code */
  display?: InputMaybe<Scalars['String']['input']>;
  /** When the measurement was clinically effective (taken/observed) */
  effectiveAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Soft-invalidation date. Omit/null to record as valid. */
  invalidFromDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Internal patient-registry ID this measurement belongs to */
  patientId: Scalars['ID']['input'];
  /** Originating system for this measurement (half of the natural upsert key) */
  source: Scalars['String']['input'];
  /** When the source itself recorded the reading */
  sourceRecordedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Stable identifier of this reading within the source (half of the natural upsert key) */
  sourceResourceId: Scalars['String']['input'];
  /** Status of the reading (e.g. "final") */
  status?: InputMaybe<Scalars['String']['input']>;
  /** Coding system the code belongs to (e.g. "loinc") */
  system: Scalars['String']['input'];
  /** Unit of measure for value (e.g. "mg/dL") */
  unit?: InputMaybe<Scalars['String']['input']>;
  /** Numeric value, for quantitative measurements */
  value?: InputMaybe<Scalars['Float']['input']>;
  /** Textual value, for qualitative measurements */
  valueText?: InputMaybe<Scalars['String']['input']>;
};

export type PlatformRecordMedicareBridgeMedicationAccessInput = {
  caseId: Scalars['ID']['input'];
  /** Retries with the same key write nothing further. */
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  /** Required. Stored on the ledger. */
  reason: Scalars['String']['input'];
};

export type PlatformRecordMedicareBridgeMedicationAccessPayload = {
  __typename?: 'RecordMedicareBridgeMedicationAccessPayload';
  medicareBridgeCase: PlatformMedicareBridgeCase;
};

export type PlatformRecordMedicareBridgePatientCommunicationInput = {
  caseId: Scalars['ID']['input'];
  /** Retries with the same key write nothing further. */
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  /** Required. Stored on the ledger. This does not send a message. */
  reason: Scalars['String']['input'];
};

export type PlatformRecordMedicareBridgePatientCommunicationPayload = {
  __typename?: 'RecordMedicareBridgePatientCommunicationPayload';
  medicareBridgeCase: PlatformMedicareBridgeCase;
};

export type PlatformRecordPatientAcquisitionSourceInput = {
  /** Internal patient-registry ID whose Healthie profile is projected to. */
  patientId: Scalars['ID']['input'];
  /** How the patient reports finding Berry Street. */
  source: PlatformPatientAcquisitionSource;
};

export type PlatformRecordPatientBookedByGuardianInput = {
  /** Internal patient-registry ID whose Healthie client is tagged. */
  patientId: Scalars['ID']['input'];
};

export type PlatformRecordPatientBookedByGuardianPayload = {
  __typename?: 'RecordPatientBookedByGuardianPayload';
  /** The tagged patient. */
  patient: PlatformPatient;
};

export type PlatformRecordPatientMedicalBackgroundInput = {
  /** Exact family-history choices. Null means unanswered; an empty list means the patient explicitly selected none. */
  familyHistoryConditions?: InputMaybe<Array<PlatformPatientFamilyHistoryCondition>>;
  /** Patient-reported height in inches. Height and weight must either both be supplied or both be omitted. */
  heightInches?: InputMaybe<Scalars['Float']['input']>;
  /** Internal patient-registry ID this response belongs to. */
  patientId: Scalars['ID']['input'];
  /** Stable producer identity for this questionnaire response, supplied by onboarding and retained as provenance. */
  sourceRecordId: Scalars['ID']['input'];
  /** Patient-reported weight in pounds. Height and weight must either both be supplied or both be omitted. */
  weightPounds?: InputMaybe<Scalars['Float']['input']>;
};

/** Patient-reported pharmacy coverage. All card fields optional. */
export type PlatformRecordPatientPharmacyCoverageInput = {
  /** Pharmacy member id as printed on the card. */
  memberId?: InputMaybe<Scalars['String']['input']>;
  /** Canonical patient-registry id; resolved to a Healthie id server-side. */
  patientId: Scalars['ID']['input'];
  rxBin?: InputMaybe<Scalars['String']['input']>;
  /** Rx group from the pharmacy card (distinct from the medical-policy group). */
  rxGroup?: InputMaybe<Scalars['String']['input']>;
  rxPcn?: InputMaybe<Scalars['String']['input']>;
};

/** A referral field that needs correction before submission can be accepted. */
export type PlatformRecordPatientReferralFieldError = {
  __typename?: 'RecordPatientReferralFieldError';
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

/** A provider-submitted referral, with a stable submission UUID reused on retries. */
export type PlatformRecordPatientReferralInput = {
  patientEmail?: InputMaybe<Scalars['String']['input']>;
  patientFirstName: Scalars['String']['input'];
  patientHealthConditions: Array<Scalars['String']['input']>;
  patientInsurance?: InputMaybe<Scalars['String']['input']>;
  patientLastName: Scalars['String']['input'];
  patientNotes?: InputMaybe<Scalars['String']['input']>;
  patientPhoneNumber: Scalars['String']['input'];
  patientState?: InputMaybe<Scalars['String']['input']>;
  providerCity: Scalars['String']['input'];
  providerEmail: Scalars['String']['input'];
  providerFax: Scalars['String']['input'];
  providerFirstName: Scalars['String']['input'];
  providerLastName: Scalars['String']['input'];
  providerNpi: Scalars['String']['input'];
  providerPhoneNumber: Scalars['String']['input'];
  providerPracticeName?: InputMaybe<Scalars['String']['input']>;
  providerSpecialty: Scalars['String']['input'];
  providerState: Scalars['String']['input'];
  submissionId: Scalars['ID']['input'];
};

/** Saved referral receipt, or field errors; notification delivery happens asynchronously. */
export type PlatformRecordPatientReferralPayload = {
  __typename?: 'RecordPatientReferralPayload';
  errors: Array<PlatformRecordPatientReferralFieldError>;
  /** The original onboarding link on success, including identical retries; null on validation failure. */
  referralLink?: Maybe<Scalars['String']['output']>;
};

export type PlatformRecordPatientReportedCareTeamMemberInput = {
  /** Practice name supplied by the NPI Registry. Null for manual entry or when CMS has none. */
  businessName?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  /** Fax number supplied by the NPI Registry. Null for manual entry or when CMS has none. */
  fax?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  /** Ten-digit National Provider Identifier. Null for manual entry or when the patient cannot supply one. */
  npi?: InputMaybe<Scalars['String']['input']>;
  /** Canonical patient-registry id. */
  patientId: Scalars['ID']['input'];
  /** Phone number supplied by the NPI Registry. Null for manual entry or when CMS has none. */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Stable producer identity for this response, supplied by the caller and reused across retries (e.g. an onboarding session id). */
  sourceRecordId: Scalars['ID']['input'];
  specialty: Scalars['String']['input'];
  /** Two-letter US state code. */
  state: Scalars['String']['input'];
};

export type PlatformRecordPatientReportedCareTeamMemberPayload = {
  __typename?: 'RecordPatientReportedCareTeamMemberPayload';
  /**
   * Whether the Healthie referring-physician projection completed: physician
   * creation and the patient referral link. False means that projection did not
   * complete (a Healthie rejection or a transport failure) — the canonical
   * member above is committed and verified regardless, and the projection is
   * repairable from that row (operationally, not via a client-facing retry).
   */
  healthieReferralLinked: Scalars['Boolean']['output'];
  member: PlatformPatientCareTeamMember;
};

export type PlatformRecordPatientVitalInput = {
  /** Internal patient-registry ID this measurement belongs to */
  patientId: Scalars['ID']['input'];
  /** Height in inches or weight in pounds, according to the mutation */
  value: Scalars['Float']['input'];
};

export type PlatformRecordPrescriptionPickupInput = {
  patientHealthieId: Scalars['ID']['input'];
  /** ISO 8601 date the patient reported picking up the prescription. */
  pickedUpAt: Scalars['DateTime']['input'];
  prescriptionId: Scalars['ID']['input'];
};

/**
 * A referring physician (a patient's PCP or other referrer) in Healthie, read live and
 * not stored. Every string is what Healthie returned: dates are not parsed and blanks
 * are not trimmed.
 */
export type PlatformReferringPhysician = {
  __typename?: 'ReferringPhysician';
  businessName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  faxNumber?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  /** Healthie's referring physician id. */
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  location?: Maybe<PlatformReferringPhysicianLocation>;
  /** Opaque JSON string Healthie stores with the physician. */
  metadata?: Maybe<Scalars['String']['output']>;
  npi?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  specialty?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type PlatformReferringPhysicianLocation = {
  __typename?: 'ReferringPhysicianLocation';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  line1?: Maybe<Scalars['String']['output']>;
  line2?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type PlatformReferringPhysicianLocationInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  line1?: InputMaybe<Scalars['String']['input']>;
  line2?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

/** Healthie's validation message, as returned. */
export type PlatformReferringPhysicianMessage = {
  __typename?: 'ReferringPhysicianMessage';
  field?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

/** The patient a referring-physician operation acts on. */
export type PlatformReferringPhysicianPatientInput = {
  /** The patient's Healthie user id. The platform always acts on this patient; the registry is only checked against it. */
  externalId: Scalars['ID']['input'];
  /** Berry Street patient registry id, when the caller has one. Only checked against externalId. */
  patientId?: InputMaybe<Scalars['ID']['input']>;
};

/** A link between a patient and a referring physician in Healthie. */
export type PlatformReferringPhysicianReferral = {
  __typename?: 'ReferringPhysicianReferral';
  createdAt?: Maybe<Scalars['String']['output']>;
  /** Healthie's referral id. */
  id: Scalars['ID']['output'];
  /** The patient's Healthie user id. */
  patientExternalId?: Maybe<Scalars['ID']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  referringPhysicianId?: Maybe<Scalars['ID']['output']>;
};

/** Links the physician being created to a patient in the same Healthie call. */
export type PlatformReferringPhysicianReferralInput = {
  patient: PlatformReferringPhysicianPatientInput;
  reason?: InputMaybe<Scalars['String']['input']>;
};

/** One page row of `referringPhysicianReferrals`: a physician and the patients linked to it. */
export type PlatformReferringPhysicianReferrals = {
  __typename?: 'ReferringPhysicianReferrals';
  referrals: Array<PlatformReferringPhysicianReferral>;
  /** Healthie's referring physician id. */
  referringPhysicianId: Scalars['ID']['output'];
};

/** A normalized individual-provider match from the CMS NPI Registry. */
export type PlatformReferringProviderOption = {
  __typename?: 'ReferringProviderOption';
  businessName?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  credential?: Maybe<Scalars['String']['output']>;
  /** Display name including credential when CMS supplies one. */
  displayName: Scalars['String']['output'];
  fax?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  /** Ten-digit National Provider Identifier. */
  npi: Scalars['String']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  specialty?: Maybe<Scalars['String']['output']>;
  /** Two-letter US state code. */
  state?: Maybe<Scalars['String']['output']>;
};

export type PlatformRefreshPharmacyBenefitCoverageInput = {
  patientHealthieId: Scalars['ID']['input'];
  /**
   * Used when there is no complete cached row: selects prescriber context for
   * the automation step. Ignored when a full cache hit is returned.
   */
  providerHealthieId: Scalars['ID']['input'];
};

/** Input for registering a patient identity. */
export type PlatformRegisterPatientInput = {
  /** Healthie user ID - required, used as the unique identifier for the patient */
  healthieUserId: Scalars['String']['input'];
};

/**
 * Input for registering a provider identity from Healthie.
 *
 * Used when the only available identifier is a Healthie user ID (e.g. an
 * admin-sourced backfill) rather than an Airtable record ID. Matches an existing
 * provider by Healthie external ID, then NPI, then email, and creates a new
 * provider keyed on the Healthie ID if none match.
 */
export type PlatformRegisterProviderFromHealthieInput = {
  /** Provider's email address - optional, used to match an existing provider or set on creation */
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  /** Healthie user ID - required, used as the unique identifier for the provider */
  healthieUserId: Scalars['String']['input'];
  /** National Provider Identifier (NPI) - optional 10-digit unique ID, used to match an existing provider or set on creation */
  npi?: InputMaybe<Scalars['String']['input']>;
};

/** Input for registering a provider identity. */
export type PlatformRegisterProviderInput = {
  /** Airtable record ID - required, used as the unique identifier for the provider */
  airtableRecordId: Scalars['String']['input'];
  /** Provider's email address - optional, only used when creating a new provider */
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  /** National Provider Identifier (NPI) - optional 10-digit unique ID */
  npi?: InputMaybe<Scalars['String']['input']>;
};

export type PlatformReleaseAppointmentHoldInput = {
  appointmentType: PlatformAppointmentType;
  sessionId: Scalars['ID']['input'];
};

export type PlatformRemoveMedicationTakePayload = {
  __typename?: 'RemoveMedicationTakePayload';
  /** Id of the removed log. */
  logId: Scalars['ID']['output'];
};

export type PlatformReplyToSupportConversationInput = {
  /** References from prepareSupportAttachment, after upload succeeds. Omitted/null/empty sends text only. Files are revalidated and must belong to the acting provider. */
  attachmentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  conversationId: Scalars['ID']['input'];
  message: Scalars['String']['input'];
  /** Tags to attach after confirmed delivery, including required PRESCRIBER. Omitted, null or empty retains the default; duplicates are applied once. Tag failures do not fail the delivered reply. */
  tags?: InputMaybe<Array<PlatformSupportConversationTag>>;
};

export type PlatformReplyToSupportConversationPayload = {
  __typename?: 'ReplyToSupportConversationPayload';
  conversationId?: Maybe<Scalars['ID']['output']>;
  error?: Maybe<PlatformSupportError>;
  /** Confirmed new provider reply; null when delivery cannot be established. */
  message?: Maybe<PlatformSupportMessage>;
};

/**
 * Request options for Stedi API calls.
 * Controls automatic retry behavior, timeouts, and request correlation.
 */
export type PlatformRequestOptions = {
  /**
   * Optional correlation ID for tracing requests across logs.
   * If not provided, one will be auto-generated.
   * Useful for tracking a request through multiple retry attempts.
   */
  correlationId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Maximum number of retry attempts (default: 0, no retries).
   * Total attempts will be maxRetries + 1 (initial attempt + retries).
   * Example: maxRetries=2 means 1 initial + 2 retries = 3 total attempts.
   */
  maxRetries?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Request timeout in milliseconds (default: varies by Stedi client configuration).
   * Sets the maximum time to wait for a response from the Stedi API.
   * Example: 10000 for a 10-second timeout.
   */
  requestTimeoutMs?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Whether to retry on network timeout errors (default: false).
   * When enabled, uses exponential backoff strategy.
   */
  retryOnTimeout?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * Request a signed PUT for a draft PDF. Repeating the same slug, versionLabel,
 * contentType, and fileSizeBytes reuses the existing DRAFT and issues a new
 * upload URL; it does not create a second version or return an error.
 */
export type PlatformRequestProviderDocumentUploadInput = {
  /** Must be application/pdf */
  contentType: Scalars['String']['input'];
  /** Existing document ID. Omit to create by slug. If set, slug must match that document. */
  documentId?: InputMaybe<Scalars['ID']['input']>;
  fileSizeBytes: Scalars['Int']['input'];
  slug: Scalars['String']['input'];
  versionLabel: Scalars['String']['input'];
};

export type PlatformResolveAccessReviewInput = {
  accessEnrollmentId: Scalars['ID']['input'];
  action: PlatformAccessReviewAction;
  finalTrack?: InputMaybe<PlatformAccessTrack>;
  icd10Code?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type PlatformResolveAccessReviewPayload = {
  __typename?: 'ResolveAccessReviewPayload';
  accessEnrollmentId: Scalars['ID']['output'];
  availableActions: Array<PlatformAccessReviewAction>;
  finalIcd10Code?: Maybe<Scalars['String']['output']>;
  finalTrack?: Maybe<PlatformAccessTrack>;
  status: PlatformAccessEnrollmentStatus;
};

/** Result of a resolveCareEscalation call — how many open escalations were resolved. */
export type PlatformResolveCareEscalationResult = {
  __typename?: 'ResolveCareEscalationResult';
  /** Number of open escalations resolved for the patient (0 if none were open) */
  resolvedCount: Scalars['Int']['output'];
};

/**
 * Input for resolving a patient email conflict.
 * Marks one email as primary and supersedes all others in the conflict group.
 */
export type PlatformResolvePatientEmailConflictInput = {
  /** Optional note explaining the resolution decision */
  note?: InputMaybe<Scalars['String']['input']>;
  /** Patient ID with the conflict */
  patientId: Scalars['ID']['input'];
  /** ID of the PatientEmail record to set as primary */
  primaryEmailId: Scalars['ID']['input'];
};

/**
 * Input for resolving a patient external ID conflict.
 * Marks one external ID as primary and supersedes all others in the conflict group.
 */
export type PlatformResolvePatientExternalIdConflictInput = {
  /** Optional note explaining the resolution decision */
  note?: InputMaybe<Scalars['String']['input']>;
  /** Patient ID with the conflict */
  patientId: Scalars['ID']['input'];
  /** ID of the PatientExternalId record to set as primary */
  primaryExternalIdId: Scalars['ID']['input'];
  /** External system the conflict is in */
  system: PlatformExternalSystem;
};

/**
 * Input for resolving a provider email conflict.
 * Marks one email as primary and supersedes all others in the conflict group.
 */
export type PlatformResolveProviderEmailConflictInput = {
  /** Optional note explaining the resolution decision */
  note?: InputMaybe<Scalars['String']['input']>;
  /** ID of the ProviderEmail record to set as primary */
  primaryEmailId: Scalars['ID']['input'];
  /** Provider ID with the conflict */
  providerId: Scalars['ID']['input'];
};

/**
 * Input for resolving a provider external ID conflict.
 * Marks one external ID as primary and supersedes all others in the conflict group.
 */
export type PlatformResolveProviderExternalIdConflictInput = {
  /** Optional note explaining the resolution decision */
  note?: InputMaybe<Scalars['String']['input']>;
  /** ID of the ProviderExternalId record to set as primary */
  primaryExternalIdId: Scalars['ID']['input'];
  /** Provider ID with the conflict */
  providerId: Scalars['ID']['input'];
  /** External system the conflict is in */
  system: PlatformProviderExternalSystem;
};

export type PlatformResolveSupportConversationInput = {
  conversationId: Scalars['ID']['input'];
};

export type PlatformResolveSupportConversationPayload = {
  __typename?: 'ResolveSupportConversationPayload';
  conversation?: Maybe<PlatformSupportConversation>;
  error?: Maybe<PlatformSupportError>;
};

/**
 * Distinguishes user-actionable rejection paths for per-record resync.
 * Returned in-band so admin can render a specific UI per case.
 *
 * Patient and provider subgraphs declare identical copies; Federation v2
 * auto-merges enums by name across subgraphs.
 */
export enum PlatformResyncError {
  /** Navi Health propagation kill switch is off for this registry. */
  NavihealthPropagationDisabled = 'NAVIHEALTH_PROPAGATION_DISABLED',
  /**
   * The record has an unresolved conflict that blocks Navi Health
   * propagation. Mirrors the gate the auto-emit path enforces
   * (`isRegistryEntryClean`); pushing a half-resolved record would cache a
   * wrong `healthify_user_id` against it in Navi Health. Admin should
   * resolve the conflict first, then retry the re-sync.
   */
  RecordConflicted = 'RECORD_CONFLICTED',
  /** No registry row exists for the supplied id. */
  RegistryRecordNotFound = 'REGISTRY_RECORD_NOT_FOUND'
}

/** Input for `resyncPatientToNavihealth`. */
export type PlatformResyncPatientToNavihealthInput = {
  /** Internal patient registry id of the record to re-sync. */
  registryId: Scalars['ID']['input'];
  /**
   * Caller-supplied operator identifier, recorded on the propagation
   * workflow memo for audit trail.
   */
  triggeredBy?: InputMaybe<Scalars['String']['input']>;
};

/** Result of `resyncPatientToNavihealth`. Exactly one of `workflowId` / `error` is set. */
export type PlatformResyncPatientToNavihealthResult = {
  __typename?: 'ResyncPatientToNavihealthResult';
  /** Set when the request was rejected. */
  error?: Maybe<PlatformResyncError>;
  /** Echo of the input registry id. */
  registryId: Scalars['ID']['output'];
  /** Run id of the propagation execution the signal landed on. */
  runId?: Maybe<Scalars['ID']['output']>;
  /** Echo of the caller-supplied triggeredBy, if any. */
  triggeredBy?: Maybe<Scalars['String']['output']>;
  /** Set on success — propagation workflow id (`propagate-identity:patient:<registryId>`). */
  workflowId?: Maybe<Scalars['ID']['output']>;
};

export type PlatformResyncProviderToNavihealthInput = {
  registryId: Scalars['ID']['input'];
  triggeredBy?: InputMaybe<Scalars['String']['input']>;
};

export type PlatformResyncProviderToNavihealthResult = {
  __typename?: 'ResyncProviderToNavihealthResult';
  error?: Maybe<PlatformResyncError>;
  registryId: Scalars['ID']['output'];
  runId?: Maybe<Scalars['ID']['output']>;
  triggeredBy?: Maybe<Scalars['String']['output']>;
  workflowId?: Maybe<Scalars['ID']['output']>;
};

/** Result of retireProviderDocument. */
export type PlatformRetireProviderDocumentResult = {
  __typename?: 'RetireProviderDocumentResult';
  documentId: Scalars['ID']['output'];
  /** Always true on success, including when the document was already RETIRED */
  retired: Scalars['Boolean']['output'];
};

export type PlatformRetractPatientReportedCareTeamMemberInput = {
  /** Canonical patient-registry id. */
  patientId: Scalars['ID']['input'];
  /** The same producer identity originally passed to recordPatientReportedCareTeamMember. */
  sourceRecordId: Scalars['ID']['input'];
};

export type PlatformRetryAccessAlignmentInput = {
  accessEnrollmentId: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
  retryRequestId: Scalars['ID']['input'];
  reviewerActorId: Scalars['ID']['input'];
};

export type PlatformRetryAccessAlignmentPayload = {
  __typename?: 'RetryAccessAlignmentPayload';
  accessEnrollmentId: Scalars['ID']['output'];
  alignmentSubmissionId: Scalars['ID']['output'];
  idempotent: Scalars['Boolean']['output'];
  status: PlatformAccessEnrollmentStatus;
};

export type PlatformReturnAccessReferralToReviewInput = {
  accessEnrollmentId: Scalars['ID']['input'];
  actorId: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};

export type PlatformReturnAccessReferralToReviewPayload = {
  __typename?: 'ReturnAccessReferralToReviewPayload';
  accessEnrollmentId: Scalars['ID']['output'];
  idempotent: Scalars['Boolean']['output'];
  status: PlatformAccessEnrollmentStatus;
};

export type PlatformSavePatientInsuranceInput = {
  cardBack?: InputMaybe<PlatformInsuranceCardFileInput>;
  cardFront?: InputMaybe<PlatformInsuranceCardFileInput>;
  /** The patient's current primary policy. When set and not policyId, it is made inactive in the same write. */
  currentPrimaryPolicyId?: InputMaybe<Scalars['ID']['input']>;
  groupNumber?: InputMaybe<Scalars['String']['input']>;
  holder?: InputMaybe<PlatformInsurancePolicyHolderInput>;
  memberId?: InputMaybe<Scalars['String']['input']>;
  patient: PlatformInsurancePatientInput;
  /** The insurance plan's id on the patient's record. */
  planId?: InputMaybe<Scalars['String']['input']>;
  /** The policy being edited. Left out to add a policy. */
  policyId?: InputMaybe<Scalars['ID']['input']>;
};

export type PlatformSavePatientOwnedFileInput = {
  /** Base64 file bytes. Required on the first save. When the monorepo copy exists and the record copy does not, a new value replaces the stored bytes before filing. */
  fileBase64?: InputMaybe<Scalars['String']['input']>;
  filename: Scalars['String']['input'];
  healthieUserId: Scalars['ID']['input'];
  /** Stable key for this logical file. Repeats return the same document. */
  idempotencyKey: Scalars['ID']['input'];
  /** image/jpeg, image/png, or application/pdf. */
  mimeType: Scalars['String']['input'];
};

/** Attach a tokenized card to a patient's Healthie Stripe customer. */
export type PlatformSavePaymentMethodInput = {
  /** Canonical registry patient id whose Healthie client the card attaches to. */
  patientId: Scalars['ID']['input'];
  /** Single-use Stripe token (`tok_…`) or confirmed SetupIntent id (`seti_…`). */
  stripeToken: Scalars['String']['input'];
  /** Browser confirmation time for a wallet SetupIntent; ignored for manual cards. */
  walletConfirmedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Outcome of saving a card in Healthie's Stripe integration. */
export type PlatformSavePaymentMethodResult = {
  __typename?: 'SavePaymentMethodResult';
  /** Customer-safe decline detail when saving fails. */
  declineMessage?: Maybe<Scalars['String']['output']>;
  /** True when the card is on file; false for a decline or missing wallet card. */
  saved: Scalars['Boolean']['output'];
};

/** A card on file. No card number beyond last4 is ever exposed. */
export type PlatformSavedCard = {
  __typename?: 'SavedCard';
  /**
   * Card brand as a display name, e.g. "Visa" or "American Express". Display
   * only: show it as-is; never map, compare or parse it.
   */
  brand: Scalars['String']['output'];
  expMonth: Scalars['Int']['output'];
  expYear: Scalars['Int']['output'];
  /** True through the final day of the card's expiry month. */
  isValid: Scalars['Boolean']['output'];
  last4: Scalars['String']['output'];
};

/** A policy on the patient's record after the write. */
export type PlatformSavedInsurancePolicy = {
  __typename?: 'SavedInsurancePolicy';
  id: Scalars['ID']['output'];
  memberId?: Maybe<Scalars['String']['output']>;
  planId?: Maybe<Scalars['String']['output']>;
  /** Null when the record holds a priority outside InsurancePolicyPriority. */
  priority?: Maybe<PlatformInsurancePolicyPriority>;
};

export type PlatformSendChatMessageInput = {
  attachments?: InputMaybe<Array<PlatformChatAttachmentInput>>;
  /** Stream Chat channel id from chatChannel. */
  channelId: Scalars['String']['input'];
  /**
   * Caller-supplied key that becomes the GetStream message id. A retry with the
   * same key returns the original message and sends nothing. Message ids are
   * unique across the whole Stream app, not per channel, so derive the key from
   * the record being sent (e.g. `follow-up-note-<id>`), never per attempt.
   */
  idempotencyKey: Scalars['String']['input'];
  /**
   * Healthie user id of the sender. Must be a member of the channel; otherwise the
   * mutation rejects with FORBIDDEN. The message appears in GetStream as sent by
   * this member's Stream user.
   */
  senderUserId: Scalars['String']['input'];
  /**
   * Message body as Stream-native Markdown; the Stream SDKs render it. May be
   * empty when at least one attachment is present. The caller validates that a
   * message has a body or an attachment; the domain does not.
   */
  text: Scalars['String']['input'];
};

export type PlatformSendChatMessagePayload = {
  __typename?: 'SendChatMessagePayload';
  channelId: Scalars['String']['output'];
  /** GetStream message id. Equals the idempotencyKey supplied. */
  messageId: Scalars['String']['output'];
};

export type PlatformSendFirstDosageReminderEventsPayload = {
  __typename?: 'SendFirstDosageReminderEventsPayload';
  /** Number of medications whose event attempt failed. */
  failed: Scalars['Int']['output'];
  /** Number of eligible tracked medications examined during this call. */
  matched: Scalars['Int']['output'];
  /** Number of patients this run newly notified (lost UTC-day claims are not counted). */
  sent: Scalars['Int']['output'];
  /** Run-level reason when no processing occurred. Unused when the batch ran. */
  skippedReason?: Maybe<Scalars['String']['output']>;
};

export type PlatformSendPrescriptionTakenEventResult = {
  __typename?: 'SendPrescriptionTakenEventResult';
  /** Whether the event was sent and the sync record created. */
  sent: Scalars['Boolean']['output'];
  /** Reason when sent=false (e.g. 'not_found', 'missing_effective_at', 'already_synced'). */
  skippedReason?: Maybe<Scalars['String']['output']>;
};

export type PlatformSendProviderChatMessageInput = {
  messageId: Scalars['ID']['input'];
  patientHealthieId: Scalars['ID']['input'];
  providerHealthieId: Scalars['ID']['input'];
  sourceAppointmentHealthieId: Scalars['ID']['input'];
  targetProgram: Scalars['String']['input'];
  text: Scalars['String']['input'];
};

/**
 * One entry in the self-service access catalog. `accessLevels` advertises the
 * allowed values for `SubmitAccessRequestInput.accessLevel`; an empty list
 * means the service does not accept an access level.
 */
export type PlatformServiceCatalogEntry = {
  __typename?: 'ServiceCatalogEntry';
  accessLevels: Array<Scalars['String']['output']>;
  /** Default approver for this service, referenced on the tickets. A requester-supplied `approver` overrides it at submit time. */
  approver?: Maybe<PlatformApprover>;
  category: PlatformServiceCategory;
  description: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  /** Per-service form fields, collected alongside accessLevel + justification. */
  extraFields: Array<PlatformExtraFieldDefinition>;
  id: PlatformServiceId;
  /** Human-readable description of what happens when a request is submitted. Shown to the requester before they submit. */
  previewSteps: Array<Scalars['String']['output']>;
};

/** Grouping used by the UI to organise the catalog into sections. */
export enum PlatformServiceCategory {
  Communications = 'COMMUNICATIONS',
  Engineering = 'ENGINEERING',
  Observability = 'OBSERVABILITY',
  Operations = 'OPERATIONS'
}

/**
 * Stable identifiers for every system employees can request access to via the
 * service catalog. New entries require a code change + gateway rebuild.
 */
export enum PlatformServiceId {
  Airtable = 'AIRTABLE',
  AnthropicApi = 'ANTHROPIC_API',
  AnthropicChat = 'ANTHROPIC_CHAT',
  Aws = 'AWS',
  BerryStreetAdminProduction = 'BERRY_STREET_ADMIN_PRODUCTION',
  BerryStreetAdminStaging = 'BERRY_STREET_ADMIN_STAGING',
  Clerk = 'CLERK',
  CustomerIo = 'CUSTOMER_IO',
  Datadog = 'DATADOG',
  DevelopHealth = 'DEVELOP_HEALTH',
  Expo = 'EXPO',
  Gcp = 'GCP',
  Gitbook = 'GITBOOK',
  Github = 'GITHUB',
  Granola = 'GRANOLA',
  Growthbook = 'GROWTHBOOK',
  HealthieProduction = 'HEALTHIE_PRODUCTION',
  HealthieStaging = 'HEALTHIE_STAGING',
  Intercom = 'INTERCOM',
  Kernel = 'KERNEL',
  Langfuse = 'LANGFUSE',
  Linear = 'LINEAR',
  Onepassword = 'ONEPASSWORD',
  OpenaiApi = 'OPENAI_API',
  Openvpn = 'OPENVPN',
  /**
   * Catch-all for systems that aren't in the catalog. Requires
   * `customSystemName` on the mutation input; the requester types the system
   * name themselves and IT figures out the rest.
   */
  Other = 'OTHER',
  Rudderstack = 'RUDDERSTACK',
  Stripe = 'STRIPE',
  TriggerDev = 'TRIGGER_DEV',
  Vercel = 'VERCEL'
}

/**
 * A session goal set by a provider for a patient.
 * SMART goals that are valid from one session to the next.
 */
export type PlatformSessionGoal = {
  __typename?: 'SessionGoal';
  /** Healthie appointment ID during which the goal was created (optional) */
  appointmentId?: Maybe<Scalars['ID']['output']>;
  /** When the goal was archived (null if active) */
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  /** When the goal was marked complete (null if not completed) */
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Who marked the goal complete */
  completedByRole?: Maybe<PlatformCompletedByRole>;
  /** The SMART goal content */
  content: Scalars['String']['output'];
  /** When the goal was created */
  createdAt: Scalars['DateTime']['output'];
  /** Unique identifier */
  id: Scalars['ID']['output'];
  /** Whether the goal is currently active (not archived) */
  isActive: Scalars['Boolean']['output'];
  /** Whether the goal has been marked complete */
  isComplete: Scalars['Boolean']['output'];
  /** ID of the goal this was rolled over from */
  parentGoalId?: Maybe<Scalars['ID']['output']>;
  /** Healthie patient ID */
  patientId: Scalars['ID']['output'];
  /** ID of the root goal in the rollover chain */
  rootGoalId?: Maybe<Scalars['ID']['output']>;
  /** When the goal was last updated */
  updatedAt: Scalars['DateTime']['output'];
};

/** Filter options for session goals queries */
export type PlatformSessionGoalFiltersInput = {
  /** Filter to goals created during a specific appointment (optional) */
  appointmentId?: InputMaybe<Scalars['ID']['input']>;
  /** Include archived goals (default: false) */
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  /** Include completed goals (default: true) */
  includeCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  /** Patient ID (required) */
  patientId: Scalars['ID']['input'];
};

/**
 * Returned when the supplied session id matches no session (e.g. an expired or
 * tampered cookie). The client should restart onboarding.
 */
export type PlatformSessionNotFoundError = {
  __typename?: 'SessionNotFoundError';
  /** Human-readable summary, safe to surface to the patient. */
  message: Scalars['String']['output'];
};

/**
 * Progress through a flow.
 *
 * `current` is 1-indexed and reflects the step the patient is currently on,
 * not the count of completed submissions — so a fresh session reports
 * `current: 1`. On a completed (terminal) session, `current` equals `total`.
 *
 * `total` is the count of non-terminal states reachable in the flow. Because
 * flows branch (e.g. female-only steps), this is an upper bound — patients
 * following shorter paths see the bar catch up faster than expected, which
 * is the right UX trade-off vs. recomputing on every step.
 */
export type PlatformSessionProgress = {
  __typename?: 'SessionProgress';
  /** 1-indexed position of the current step. */
  current: Scalars['Int']['output'];
  /** Upper-bound count of non-terminal steps in the flow. */
  total: Scalars['Int']['output'];
};

export type PlatformSetGlp1PatientPrescriberNotesInput = {
  /** Full replace. Null or empty clears. */
  notes?: InputMaybe<Scalars['String']['input']>;
  patientHealthieId: Scalars['ID']['input'];
  /** @deprecated Ignored. The acting provider comes from the verified provider assertion (x-bst-provider-assertion). Stop sending it; this argument will be removed. */
  providerHealthieId?: InputMaybe<Scalars['ID']['input']>;
};

export type PlatformSetInsurancePolicyCardsInput = {
  cardBack?: InputMaybe<PlatformInsuranceCardFileInput>;
  cardFront?: InputMaybe<PlatformInsuranceCardFileInput>;
  patient: PlatformInsurancePatientInput;
  /** An existing policy on the patient's record. */
  policyId: Scalars['ID']['input'];
};

export type PlatformSetPatientEmergencyContactInput = {
  /** Contact email. Null when the patient did not provide one; a replacement with null clears a previously stored email. */
  email?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  /** Canonical patient-registry id. */
  patientId: Scalars['ID']['input'];
  /** E.164 or ten-digit US phone number. */
  phoneNumber: Scalars['String']['input'];
};

export enum PlatformSexAtBirth {
  Female = 'FEMALE',
  Male = 'MALE'
}

/**
 * How long a patient slept, synced from a device: one entry per sleep period as
 * the device reports it. On Android it is one Health Connect sleep session,
 * timestamped at its start, so a nap is a second entry. On iOS it is one night:
 * the HealthKit asleep stages ending on the same UTC date, merged and
 * timestamped when the first of them ends. The entry counts toward the day of
 * its createdAt. journalEntries returns it only when SLEEP_DURATION is listed in
 * `filters.types`; journalEntry(id) returns it by id. createJournalEntry and
 * updateJournalEntry reject it; upsertDailyTotal writes it, one entry per
 * session source id. An entry without a duration is left out. That is how
 * Healthie stores and serves sleep. While SLEEP_DURATION is served from
 * NaviHealth, the sessions are still written one by one, but read back as one
 * entry per patient and sleep day (`nh-sl-<yyyymmdd>`), its sessions merged and
 * overlaps counted once, created at the night's end.
 */
export type PlatformSleepDurationJournalEntry = PlatformJournalEntryBase & {
  __typename?: 'SleepDurationJournalEntry';
  /** Comments from providers or other users on this entry */
  comments: Array<PlatformEntryComment>;
  /** When the entry was created */
  createdAt: Scalars['DateTime']['output'];
  /** User ID of the person the entry is about */
  createdBy: Scalars['String']['output'];
  /** Optional description or notes */
  description?: Maybe<Scalars['String']['output']>;
  /** Sleep duration in whole minutes. The source holds hours to one decimal, so in practice it is a multiple of 6. */
  durationMinutes: Scalars['Int']['output'];
  /** Unique identifier */
  id: Scalars['ID']['output'];
  /** The device or app integration that wrote the entry, such as 'apple_health', 'google_fit' or 'fitbit'. Null when the entry was logged by hand or its source isn't known. */
  thirdPartySource?: Maybe<Scalars['String']['output']>;
  /** IANA timezone identifier for the poster (e.g., 'America/Los_Angeles') */
  timezone?: Maybe<Scalars['String']['output']>;
};

export type PlatformSlotFlexibilityInput = {
  /** Days either side of the target to search. */
  windowDays: Scalars['Int']['input'];
  /** Hours either side of the target's time-of-day to accept. */
  windowHours: Scalars['Int']['input'];
};

/**
 * The chosen slot was taken before the booking completed (rejected by Healthie's
 * `enforce_availability`), or no assigned provider was free at that instant. The
 * caller should refresh availability and have the patient re-select a time.
 */
export type PlatformSlotUnavailableError = {
  __typename?: 'SlotUnavailableError';
  /** The slot that was no longer bookable. */
  appointmentTime: Scalars['DateTime']['output'];
  /** Human-readable summary, safe to surface to the patient. */
  message: Scalars['String']['output'];
};

export type PlatformSnoozeMedicareBridgeCaseInput = {
  caseId: Scalars['ID']['input'];
  /** Retries with the same key write nothing further. */
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  /** Required. Stored on the ledger. */
  reason: Scalars['String']['input'];
  snoozedUntil: Scalars['DateTime']['input'];
};

export type PlatformSnoozeMedicareBridgeCasePayload = {
  __typename?: 'SnoozeMedicareBridgeCasePayload';
  medicareBridgeCase: PlatformMedicareBridgeCase;
};

/** Sort order options for food journal entry queries */
export enum PlatformSortOrder {
  /** Sort by creation date in ascending order (oldest first) */
  CreatedAtAsc = 'CREATED_AT_ASC',
  /** Sort by creation date in descending order (newest first) */
  CreatedAtDesc = 'CREATED_AT_DESC'
}

/** A provider specialty / visit-reason category. Vocabulary source for MatchDietitiansInput's visit-reason fields. */
export type PlatformSpecialtyCategory = {
  __typename?: 'SpecialtyCategory';
  category: Scalars['String']['output'];
  /** Picker icon. Null when the source has none. */
  iconUrl?: Maybe<Scalars['String']['output']>;
};

/**
 * Distinguishes the user-actionable rejection paths for starting a
 * registry → Navi Health backfill. Returned in-band (errors-as-data) so
 * admin can render a specific UI per case.
 *
 * Patient and provider subgraphs declare identical copies; Federation v2
 * auto-merges enums by name across subgraphs.
 */
export enum PlatformStartBackfillError {
  /** A backfill execution is already running. */
  BackfillAlreadyRunning = 'BACKFILL_ALREADY_RUNNING',
  /** The supplied resume `cursor` was not a valid JSON `{ createdAt, id }` object. */
  InvalidCursor = 'INVALID_CURSOR',
  /** Navi Health propagation kill switch is off for this registry. */
  NavihealthPropagationDisabled = 'NAVIHEALTH_PROPAGATION_DISABLED'
}

export type PlatformStartCardSetupInput = {
  /** Stable per intended setup (at most 200 characters), e.g. the onboarding session id. */
  idempotencyKey: Scalars['String']['input'];
  /** Canonical patient-registry id when the patient exists; omit before registration. */
  patientId?: InputMaybe<Scalars['ID']['input']>;
};

export type PlatformStartCardSetupPayload = PlatformCardSetupStarted | PlatformCardSetupUnavailableError;

/** Input to start a new onboarding session. */
export type PlatformStartOnboardingSessionInput = {
  /**
   * Single-use entry-link token. When supplied the session is created with
   * prefilled step submissions derived from the link's PatientFacts. The
   * link's flow must match `flowId`.
   */
  entryToken?: InputMaybe<Scalars['String']['input']>;
  /** ID of the flow to start (e.g. `glp-1`). */
  flowId: Scalars['String']['input'];
  /**
   * Referral UUID from /welcome/start?referral=. Validated through patient-registry
   * and frozen on the session; overrides visitorId for analytics. Only supported
   * for welcome, without entryToken. Invalid IDs return EntryLinkUnusableError.
   * Attribution only: does not bind a patient, prefill answers, or resume a session.
   */
  referralId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * The browser's IANA timezone (e.g. `America/New_York`), captured client-side
   * once at session start. Frozen for the session's lifetime; null when the
   * caller has no browser to read one from.
   */
  timezone?: InputMaybe<Scalars['String']['input']>;
  /**
   * Sticky per-browser anonymous id (the `bs_anonymous_id` cookie — the
   * cross-site RudderStack anonymous id where the .co bridge could supply it,
   * locally minted otherwise). Persisted on the session, frozen at creation,
   * for both a self-serve start and an entry-link consume (a real browser is
   * behind both). Used as the RudderStack `anonymousId` for every one of this
   * session's server-side funnel events, so they land on the same profile as
   * the client-side `page()` events this id already drives — a session
   * created before this field existed falls back to the session id instead.
   * Also still emitted as `visitor_anonymous_id` on the session-started
   * analytics event, for anything reading that property directly. Null on
   * the tokenless M2M patient-scoped start — no browser behind that caller.
   */
  visitorId?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * Successful start (a session at its first step — possibly resumed from an
 * already-used entry link) or a terminal entry-link error the client must handle.
 */
export type PlatformStartOnboardingSessionResult = PlatformEntryLinkUnusableError | PlatformOnboardingSessionWithStep;

export type PlatformStartPatientGlp1JourneyInput = {
  patientHealthieId: Scalars['ID']['input'];
};

/** Input for `startPatientNavihealthBackfill`. */
export type PlatformStartPatientNavihealthBackfillInput = {
  /**
   * JSON-encoded `{ createdAt, id }` cursor to resume a previously cancelled
   * run from where it stopped — copy the `progress.cursor` value shown for the
   * last run on `patientNavihealthBackfillStatus`. Omit to start from the
   * beginning. Cumulative progress counters (pages / processed / failed) are
   * carried forward automatically from the cancelled run, so the resumed run's
   * totals stay continuous. Rejected as `INVALID_CURSOR` if it isn't a valid
   * `{ createdAt, id }` object.
   */
  cursor?: InputMaybe<Scalars['String']['input']>;
  /**
   * Hard cap on records propagated to Navi Health concurrently. Forwarded to
   * the workflow as `maxInFlight`. Defaults to 5. Each batch fully completes
   * before the next starts, so this bounds the backfill's concurrent Navi
   * Health calls directly.
   */
  maxInFlight?: InputMaybe<Scalars['Int']['input']>;
  /** Forwarded to the workflow as `pageSize`. Defaults: see workflow input. */
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Caller-supplied operator identifier, recorded on the workflow memo
   * for audit trail. Admin sets this to the operator's email; tests can
   * pass an arbitrary string.
   */
  triggeredBy?: InputMaybe<Scalars['String']['input']>;
};

/** Result of `startPatientNavihealthBackfill`. Exactly one of `run` / `error` is set. */
export type PlatformStartPatientNavihealthBackfillResult = {
  __typename?: 'StartPatientNavihealthBackfillResult';
  /** Set when the start was rejected for a user-actionable reason. */
  error?: Maybe<PlatformStartBackfillError>;
  /** Set when the start succeeded. */
  run?: Maybe<PlatformPatientNavihealthBackfillRun>;
};

/**
 * Input to start a tokenless, patient-scoped onboarding session. M2M-only —
 * the caller (a trusted machine acting on behalf of an already-authenticated
 * patient) supplies facts directly rather than through a minted entry link.
 */
export type PlatformStartPatientOnboardingSessionInput = {
  /**
   * Canonical patient facts. `patientHealthieId` identifies the patient and is
   * required on this path — the caller has already authenticated them.
   */
  facts: PlatformPatientFactsInput;
  /** ID of the flow to start (e.g. `glp-1`). */
  flowId: Scalars['String']['input'];
};

export enum PlatformStartProviderEmailOriginBackfillError {
  /** A backfill execution for this stage is already running. */
  BackfillAlreadyRunning = 'BACKFILL_ALREADY_RUNNING',
  /** The supplied resume cursor was not a valid JSON `{ createdAt, id }` object. */
  InvalidCursor = 'INVALID_CURSOR'
}

export type PlatformStartProviderEmailOriginBackfillInput = {
  /**
   * When true, write origin. Default false (dry run counts only). Dry run
   * then apply is two full walks of the eligible population.
   */
  apply?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * JSON `{ createdAt, id }` from a prior run's progress.cursor. Omit to
   * start from the beginning. Bucket counters reset on resume; processed/
   * failed/pages carry forward via the shared start helper.
   */
  cursor?: InputMaybe<Scalars['String']['input']>;
  stage: PlatformProviderEmailOriginBackfillStage;
  triggeredBy?: InputMaybe<Scalars['String']['input']>;
};

export type PlatformStartProviderEmailOriginBackfillResult = {
  __typename?: 'StartProviderEmailOriginBackfillResult';
  error?: Maybe<PlatformStartProviderEmailOriginBackfillError>;
  run?: Maybe<PlatformProviderEmailOriginBackfillRun>;
};

export type PlatformStartProviderNavihealthBackfillInput = {
  /**
   * JSON-encoded `{ createdAt, id }` cursor to resume a previously cancelled
   * run from where it stopped — copy the `progress.cursor` value shown for the
   * last run on `providerNavihealthBackfillStatus`. Omit to start from the
   * beginning. Cumulative progress counters (pages / processed / failed) are
   * carried forward automatically from the cancelled run, so the resumed run's
   * totals stay continuous. Rejected as `INVALID_CURSOR` if it isn't a valid
   * `{ createdAt, id }` object.
   */
  cursor?: InputMaybe<Scalars['String']['input']>;
  /**
   * Hard cap on records propagated to Navi Health concurrently. Forwarded to
   * the workflow as `maxInFlight`. Defaults to 5. Each batch fully completes
   * before the next starts, so this bounds the backfill's concurrent Navi
   * Health calls directly.
   */
  maxInFlight?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  triggeredBy?: InputMaybe<Scalars['String']['input']>;
};

export type PlatformStartProviderNavihealthBackfillResult = {
  __typename?: 'StartProviderNavihealthBackfillResult';
  error?: Maybe<PlatformStartBackfillError>;
  run?: Maybe<PlatformProviderNavihealthBackfillRun>;
};

/**
 * A step's render contract — the screen the client should draw for the current
 * cursor. Switch on `__typename` to pick the screen. *Which* step this is
 * (identity) comes from the session cursor, not from the step itself.
 */
export type PlatformStep = PlatformContentStep | PlatformDynamicStep | PlatformFormStep;

/** One of the renderable field kinds. Clients switch on `__typename`. */
export type PlatformStepField = PlatformCheckboxField | PlatformChoiceField | PlatformDateField | PlatformMultiSelectField | PlatformNumberField | PlatformTextAreaField | PlatformTextField;

/** A single field-level validation problem the client should surface inline. */
export type PlatformStepFieldError = {
  __typename?: 'StepFieldError';
  /** ID of the field that failed validation; matches a StepField.id on the current step. */
  fieldId: Scalars['String']['output'];
  /** Human-readable explanation of why the value was rejected. */
  message: Scalars['String']['output'];
};

/** A selectable option for a ChoiceField or MultiSelectField. */
export type PlatformStepFieldOption = {
  __typename?: 'StepFieldOption';
  /**
   * MultiSelectField only: when true, selecting this option clears every other
   * selected option, and selecting any other option clears this one (e.g. a
   * "None of the above" option). Server-side validation rejects a submission
   * that pairs this option with another. Null (or false) for an ordinary
   * option; always null/unused on a ChoiceField option, which is already
   * single-select.
   */
  exclusive?: Maybe<Scalars['Boolean']['output']>;
  /** Optional image shown with the option. Null renders the existing text-only option. */
  iconUrl?: Maybe<Scalars['String']['output']>;
  /** Label shown to the patient. */
  label: Scalars['String']['output'];
  /** Stable value submitted when this option is selected. */
  value: Scalars['String']['output'];
};

/**
 * Returned when a step action determined the patient must redo a step (e.g. the
 * chosen appointment slot was taken before booking completed, or a card was
 * declined). When `retryStepId` is set, the session was NOT rewound — the
 * client should recollect that input and call `submitOnboardingStep` again with
 * the current step data plus `recovery`. When `retryStepId` is null, the session
 * has already been rewound to the step to retry server-side — the client should
 * navigate to `session.cursor`. Which step to retry, and which recovery applies,
 * is decided server-side, so the client needs no per-flow knowledge.
 */
export type PlatformStepRetryRequired = {
  __typename?: 'StepRetryRequired';
  /** Why the patient must redo a step, safe to surface to the patient. */
  message: Scalars['String']['output'];
  /**
   * Set only when the session was NOT rewound: the id of the step to redo in
   * place via `SubmitOnboardingStepInput.recovery`. Null means the session has
   * already been rewound and the client should navigate to `session.cursor`.
   */
  retryStepId?: Maybe<Scalars['String']['output']>;
  /** The session — rewound to the step to retry when `retryStepId` is null, unchanged otherwise. */
  session: PlatformOnboardingSession;
};

/**
 * Returned when submitted step data fails server-side validation. The client
 * should re-render the current step with these field errors; the session cursor
 * is unchanged and nothing was persisted.
 */
export type PlatformStepValidationError = {
  __typename?: 'StepValidationError';
  /** Per-field validation problems. */
  fieldErrors: Array<PlatformStepFieldError>;
  /** Human-readable summary, safe to surface to the patient. */
  message: Scalars['String']['output'];
};

/**
 * A patient's steps for the day from one source, such as a device. A day can hold
 * one entry per source; readers add a day's entries up, as the provider portal's
 * daily totals do. While steps are served from NaviHealth, each source's day is
 * one entry (`nh-sp-<row id>`), as on Healthie. journalEntries returns it only when STEPS is listed in
 * `filters.types`; journalEntry(id) returns it by id. createJournalEntry and
 * updateJournalEntry don't write it; upsertDailyTotal does. An entry without a
 * step count is left out.
 */
export type PlatformStepsJournalEntry = PlatformJournalEntryBase & {
  __typename?: 'StepsJournalEntry';
  /** Comments from providers or other users on this entry */
  comments: Array<PlatformEntryComment>;
  /** When the entry was created */
  createdAt: Scalars['DateTime']['output'];
  /** User ID of the person the entry is about */
  createdBy: Scalars['String']['output'];
  /** Optional description or notes */
  description?: Maybe<Scalars['String']['output']>;
  /** Unique identifier */
  id: Scalars['ID']['output'];
  /** Steps for the day, rounded to a whole step */
  steps: Scalars['Int']['output'];
  /** The device or app integration that wrote the entry, such as 'apple_health', 'google_fit' or 'fitbit'. Null when the entry was logged by hand or its source isn't known. */
  thirdPartySource?: Maybe<Scalars['String']['output']>;
  /** IANA timezone identifier for the poster (e.g., 'America/Los_Angeles') */
  timezone?: Maybe<Scalars['String']['output']>;
};

/** A stool journal entry logged by a patient, capturing bowel movement data using the Bristol stool scale. */
export type PlatformStoolJournalEntry = PlatformJournalEntryBase & {
  __typename?: 'StoolJournalEntry';
  /** Bristol stool scale value (1-7, null if not recorded) */
  bristolScale?: Maybe<Scalars['Int']['output']>;
  /** Comments from providers or other users on this entry */
  comments: Array<PlatformEntryComment>;
  /** When the entry was created */
  createdAt: Scalars['DateTime']['output'];
  /** The entry owner's Healthie user id, or `unknown` when journaling has none */
  createdBy: Scalars['String']['output'];
  /** Optional description or notes about the bowel movement */
  description?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the stool journal entry */
  id: Scalars['ID']['output'];
  /** IANA timezone identifier for the poster (e.g., 'America/Los_Angeles') */
  timezone?: Maybe<Scalars['String']['output']>;
};

/**
 * Stream Chat credentials for connecting to the GetStream app instance.
 *
 * The `token` is a GetStream JWT containing `{ user_id }` in its payload.
 * Clients decode the token to extract the user ID for `connectUser()`.
 */
export type PlatformStreamChatCredentials = {
  __typename?: 'StreamChatCredentials';
  /** GetStream public API key — uniquely identifies the app instance */
  apiKey: Scalars['String']['output'];
  /** User-scoped Stream Chat JWT — decode payload to get user_id for connectUser() */
  token: Scalars['String']['output'];
};

export type PlatformSubmitAccessAlignmentInput = {
  accessEnrollmentId: Scalars['ID']['input'];
  alignmentType: PlatformAccessAlignmentType;
  conditions?: InputMaybe<Array<Scalars['String']['input']>>;
  finalTrack: PlatformAccessTrack;
  icd10Code?: InputMaybe<Scalars['String']['input']>;
  providerReferral?: InputMaybe<PlatformAccessProviderReferralInput>;
  reviewerActorId?: InputMaybe<Scalars['ID']['input']>;
  switchAttestation?: InputMaybe<Scalars['JSON']['input']>;
};

export type PlatformSubmitAccessAlignmentPayload = {
  __typename?: 'SubmitAccessAlignmentPayload';
  accessEnrollmentId: Scalars['ID']['output'];
  alignmentSubmissionId?: Maybe<Scalars['ID']['output']>;
  eligibilitySubmissionId?: Maybe<Scalars['ID']['output']>;
  status: PlatformAccessEnrollmentStatus;
};

export type PlatformSubmitAccessEligibilityInput = {
  consent?: InputMaybe<PlatformAccessEnrollmentConsentInput>;
  healthieUserId: Scalars['ID']['input'];
  memberId: Scalars['String']['input'];
  patient: PlatformAccessEligibilityPatientInput;
  selfReportedConditionKeys: Array<Scalars['String']['input']>;
  sessionId: Scalars['ID']['input'];
  sourceSystem: Scalars['String']['input'];
};

export type PlatformSubmitAccessEligibilityPayload = {
  __typename?: 'SubmitAccessEligibilityPayload';
  /**
   * True when `id`/`status` refer to a pre-existing active enrollment for this
   * Healthie user rather than one just created by this call — e.g. a returning
   * patient submitting eligibility again in a new session. Callers should treat
   * this as a terminal outcome (do not retry): the patient is already enrolled.
   * Absent/false for a freshly created enrollment.
   */
  alreadyEnrolled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  status: PlatformAccessEnrollmentStatus;
};

export type PlatformSubmitAccessRequestInput = {
  /** Must match one of the corresponding ServiceCatalogEntry.accessLevels. Must be null if that list is empty. */
  accessLevel?: InputMaybe<Scalars['String']['input']>;
  /** Email of an approver to reference on the ticket, overriding the service's default. Validated as an email address; referenced in the ticket body and, when it matches a Linear user, subscribed to the ticket. */
  approver?: InputMaybe<Scalars['String']['input']>;
  /** Name of the system, when serviceId is OTHER. Required when OTHER, rejected otherwise. Used verbatim in the Linear ticket title. */
  customSystemName?: InputMaybe<Scalars['String']['input']>;
  /** Values for the per-service `extraFields`. Each key must match an `ExtraFieldDefinition.key` on the chosen `ServiceCatalogEntry`; required fields must be present with non-empty values; SELECT/MULTI_SELECT values must come from the entry's `options`. */
  extraFields?: InputMaybe<Array<PlatformExtraFieldValueInput>>;
  /** Optional free-text justification included in the parent Linear ticket body. */
  justification?: InputMaybe<Scalars['String']['input']>;
  /** Email of the person who actually needs the access. Defaults to the submitter when omitted (i.e. requesting for yourself). */
  requestedFor?: InputMaybe<Scalars['String']['input']>;
  serviceId: PlatformServiceId;
};

export type PlatformSubmitBpCuffOrderInput = {
  healthieUserId: Scalars['ID']['input'];
  shippingAddress: PlatformBpCuffShippingAddressInput;
};

export type PlatformSubmitEhrChartingNoteInput = {
  chartingNoteId: Scalars['ID']['input'];
  content: PlatformEhrSoapNoteContentInput;
  /** Lock after saving. */
  lock: Scalars['Boolean']['input'];
  patient: PlatformEhrVitalsPatientInput;
  /** Sign as the acting provider after saving. Ignored (not attempted) when the write ran as the organization. */
  sign: Scalars['Boolean']['input'];
};

export type PlatformSubmitEhrChartingNotePayload = {
  __typename?: 'SubmitEhrChartingNotePayload';
  authoredBy: PlatformEhrChartingNoteAuthor;
  chartingNoteId: Scalars['ID']['output'];
  /** KEPT_SIGNED: the note was already signed, so its content was left unchanged. */
  content: PlatformEhrChartingNoteContentOutcome;
  hasProviderSignature: Scalars['Boolean']['output'];
  isLocked: Scalars['Boolean']['output'];
  lockOutcome: PlatformEhrChartingNoteStepOutcome;
  signOutcome: PlatformEhrChartingNoteStepOutcome;
};

export type PlatformSubmitGlp1PriorAuthInput = {
  /** ICD-10 codes. */
  diagnoses: Array<PlatformDiagnosisInput>;
  /** Free-text Sig supplied by the prescribing provider. */
  directions: Scalars['String']['input'];
  /** Previously generated PA document IDs to attach as evidence. If omitted the submission workflow generates them automatically. */
  documentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * When true, create a new PA even if a matching in-progress or already-approved
   * PA exists for this patient + program + product/SKU. Default false / omitted.
   * The existing blocking PA id is stored on replacesPaId when one is found.
   * A PENDING row with no developCaseId is reused instead of inserting a second
   * PA — Temporal start never landed on that row. Concurrent non-force submits
   * still serialize on the advisory lock.
   */
  forceSubmit?: InputMaybe<Scalars['Boolean']['input']>;
  /** Optional prescription task to link; moves task to pending with prior_auth_started. */
  glp1PrescriptionTaskId?: InputMaybe<Scalars['ID']['input']>;
  patientHealthieId: Scalars['ID']['input'];
  product: PlatformGlp1Product;
  /** Exact GLP-1 SKU for PA submission. Omit to use the product default SKU. */
  productSkuId?: InputMaybe<Scalars['String']['input']>;
  providerHealthieId: Scalars['ID']['input'];
  /**
   * Calling surface for duplicate-prevented measurement. Opaque analytics only.
   * Omit for non-UI / automation callers.
   */
  sourceSurface?: InputMaybe<PlatformPriorAuthSubmitSurface>;
};

/**
 * Created PA, a commercial duplicate, or a Medicare Bridge rejection.
 * Bridge checks run only while `medication-program-medicare-bridge-prescribing`
 * is on and the patient has an open case that is ELIGIBLE on the current
 * checklist. `NOT_STARTED`, `NEEDS_INFORMATION`, and `NOT_ELIGIBLE` keep
 * today's commercial behavior and are not linked. Concurrent Bridge submits
 * for the same case and product lock that case inside the submit transaction,
 * so only one PA is created.
 */
export type PlatformSubmitGlp1PriorAuthResult = PlatformActivePriorAuthorizationConflict | PlatformBridgeProductNotAllowed | PlatformBridgeReviewRequired | PlatformDuplicateBridgePriorAuth | PlatformPriorAuthorization;

export type PlatformSubmitGlp1ScreeningInput = {
  appointmentHealthieId: Scalars['ID']['input'];
  /** ICD-10 codes. */
  diagnoses: Array<PlatformDiagnosisInput>;
  patientHealthieId: Scalars['ID']['input'];
  providerHealthieId: Scalars['ID']['input'];
};

export type PlatformSubmitMedicareBridgeReviewInput = {
  appointmentHealthieId?: InputMaybe<Scalars['ID']['input']>;
  caseId: Scalars['ID']['input'];
  /** Must be the checklist version returned on the case. */
  checklistVersion: Scalars['String']['input'];
  decision: PlatformMedicareBridgeReviewDecision;
  /** Client-generated. A retry with the same key writes nothing further. */
  idempotencyKey: Scalars['String']['input'];
  /** Required unless decision is ELIGIBLE. Rejected when decision is ELIGIBLE. Must be one of the checklist nextRoutes. */
  nextRoute?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  /** Keyed by checklist item. Boolean items are booleans. Evidence and dates are strings. Numbers are numbers. A choice is a string. Choices are a list of strings. */
  responses: Scalars['JSON']['input'];
  /** Checklist keys still open. Required, and at least one, when decision is NEEDS_INFORMATION. Rejected when decision is ELIGIBLE. */
  unresolvedItems?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** The case after a provider review is recorded or replayed. */
export type PlatformSubmitMedicareBridgeReviewPayload = {
  __typename?: 'SubmitMedicareBridgeReviewPayload';
  medicareBridgeCase: PlatformMedicareBridgeCase;
};

export type PlatformSubmitOnboardingBundleInput = {
  bundleId: PlatformOnboardingBundleId;
  /**
   * The person's existing GitHub username, so IT invites that account and links
   * it in Vanta. Must be a valid GitHub username; rejected when the bundle has no
   * GitHub item. Omit to have the invite sent to their work email.
   */
  githubUsername?: InputMaybe<Scalars['String']['input']>;
  /** Optional free-text notes added to every ticket, e.g. extra Linear teams or a start date. */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Work email of the person being onboarded. Must be a berrystreet.co address. */
  requestedFor: Scalars['String']['input'];
};

/** Result of a submitOnboardingBundle mutation. */
export type PlatformSubmitOnboardingBundlePayload = {
  __typename?: 'SubmitOnboardingBundlePayload';
  bundleId: PlatformOnboardingBundleId;
  parent: PlatformLinearTicketRef;
  /** One per provisioning step, in bundle order. */
  subTickets: Array<PlatformLinearTicketRef>;
  submittedByEmail: Scalars['String']['output'];
};

/** Input to submit the current step of a session. */
export type PlatformSubmitOnboardingStepInput = {
  /** Field values for the current step, keyed by field id. */
  data: Scalars['JSON']['input'];
  /**
   * A correction requested by a prior `StepRetryRequired`. Accepted only for a
   * server-approved step already completed on this session's active path. The
   * correction is validated, enriched, and appended before the current step
   * action runs. If `stepId` is no longer the cursor, the entire request,
   * including this correction, is an idempotent no-op.
   */
  recovery?: InputMaybe<PlatformOnboardingStepRecoveryInput>;
  /** Opaque session handle returned at session start. */
  sessionId: Scalars['ID']['input'];
  /** ID of the step being submitted; must match the session's current cursor. */
  stepId: Scalars['String']['input'];
};

/** Successful submit (advanced session) or a business error the client must handle. */
export type PlatformSubmitOnboardingStepResult = PlatformOnboardingSessionWithStep | PlatformSessionNotFoundError | PlatformStepRetryRequired | PlatformStepValidationError;

/** A referral field that needs correction before submission can be accepted. */
export type PlatformSubmitPatientReferralFieldError = {
  __typename?: 'SubmitPatientReferralFieldError';
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

/** A provider-submitted referral, with a stable submission UUID reused on retries. */
export type PlatformSubmitPatientReferralInput = {
  patientEmail?: InputMaybe<Scalars['String']['input']>;
  patientFirstName: Scalars['String']['input'];
  patientHealthConditions: Array<Scalars['String']['input']>;
  patientInsurance?: InputMaybe<Scalars['String']['input']>;
  patientLastName: Scalars['String']['input'];
  patientNotes?: InputMaybe<Scalars['String']['input']>;
  patientPhoneNumber: Scalars['String']['input'];
  patientState?: InputMaybe<Scalars['String']['input']>;
  providerCity: Scalars['String']['input'];
  providerEmail: Scalars['String']['input'];
  providerFax: Scalars['String']['input'];
  providerFirstName: Scalars['String']['input'];
  providerLastName: Scalars['String']['input'];
  providerNpi: Scalars['String']['input'];
  providerPhoneNumber: Scalars['String']['input'];
  providerPracticeName?: InputMaybe<Scalars['String']['input']>;
  providerSpecialty: Scalars['String']['input'];
  providerState: Scalars['String']['input'];
  submissionId: Scalars['ID']['input'];
};

/** Saved referral receipt, or field errors; notification delivery happens asynchronously. */
export type PlatformSubmitPatientReferralPayload = {
  __typename?: 'SubmitPatientReferralPayload';
  errors: Array<PlatformSubmitPatientReferralFieldError>;
  /** The original onboarding link on success, including identical retries; null on validation failure. */
  referralLink?: Maybe<Scalars['String']['output']>;
};

export type PlatformSubmitPrescriptionPhotoLinkInput = {
  /** Base64 JPEG or PNG bytes. */
  content: Scalars['String']['input'];
  contentType: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

/** A single step's submitted data, appended to the session history. */
export type PlatformSubmittedStep = {
  __typename?: 'SubmittedStep';
  /** Field values submitted by the user (plus any server-side action output). */
  data: Scalars['JSON']['output'];
  /** ID of the step this submission was for. */
  stepId: Scalars['String']['output'];
  /** When the submission was recorded. */
  submittedAt: Scalars['DateTime']['output'];
};

/** Subscriber (patient/member) information */
export type PlatformSubscriber = {
  __typename?: 'Subscriber';
  /** Mailing address */
  address?: Maybe<PlatformAddress>;
  /** Date of birth */
  dateOfBirth?: Maybe<Scalars['Date']['output']>;
  /** First name */
  firstName?: Maybe<Scalars['String']['output']>;
  /** Gender: F, M, or U (unknown) */
  gender?: Maybe<Scalars['String']['output']>;
  /** Group number for the insurance plan */
  groupNumber?: Maybe<Scalars['String']['output']>;
  /** Last name */
  lastName?: Maybe<Scalars['String']['output']>;
  /** Member ID from the payer */
  memberId?: Maybe<Scalars['String']['output']>;
  /** Middle name */
  middleName?: Maybe<Scalars['String']['output']>;
};

export type PlatformSupportAttachment = {
  __typename?: 'SupportAttachment';
  name: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type PlatformSupportAttachmentPolicy = {
  __typename?: 'SupportAttachmentPolicy';
  allowedContentTypes: Array<Scalars['String']['output']>;
  maxFileBytes: Scalars['Int']['output'];
  maxFiles: Scalars['Int']['output'];
  maxTotalBytes: Scalars['Int']['output'];
};

export type PlatformSupportAttachmentUpload = {
  __typename?: 'SupportAttachmentUpload';
  /** Opaque provider-owned upload reference to pass on create or reply after PUT succeeds. */
  attachmentId: Scalars['ID']['output'];
  contentType: Scalars['String']['output'];
  /** Unix timestamp in seconds; abandoned uploads expire automatically. */
  expiresAt: Scalars['Float']['output'];
  /** Short-lived signed PUT URL. Upload the file bytes with the returned Content-Type. */
  uploadUrl: Scalars['String']['output'];
};

export type PlatformSupportAvailability = {
  __typename?: 'SupportAvailability';
  /** File limits for both create and reply; null when attachment storage is not configured. */
  attachmentPolicy?: Maybe<PlatformSupportAttachmentPolicy>;
  enabled: Scalars['Boolean']['output'];
  /** Whether prescriber resolve is configured (the Resolved at attribute ID is set). The attribute itself is verified on each resolve. Hide the resolve action when false. */
  resolveEnabled: Scalars['Boolean']['output'];
};

export type PlatformSupportConversation = {
  __typename?: 'SupportConversation';
  createdAt: Scalars['Float']['output'];
  /** Intercom returns at most the latest 500 parts; true when history may be incomplete. */
  historyTruncated: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** Public messages only, oldest first; plaintext safe for text rendering. */
  messages: Array<PlatformSupportMessage>;
  /** Optional Healthie patient reference, stored as a string without numeric coercion. */
  patientId?: Maybe<Scalars['String']['output']>;
  /** Intercom conversation read state; null only for a provisional creation confirmation. */
  read?: Maybe<Scalars['Boolean']['output']>;
  /** When the prescriber last marked the conversation resolved (Unix seconds), or null. Independent of Intercom's open/closed state; clients treat it as resolved while no public message is newer. */
  resolvedAt?: Maybe<Scalars['Float']['output']>;
  state: PlatformSupportConversationState;
  title: Scalars['String']['output'];
  updatedAt: Scalars['Float']['output'];
};

export type PlatformSupportConversationPage = {
  __typename?: 'SupportConversationPage';
  conversations: Array<PlatformSupportConversation>;
  error?: Maybe<PlatformSupportError>;
  /** Opaque Intercom cursor; a filtered page can be empty and still have a next cursor. */
  nextCursor?: Maybe<Scalars['String']['output']>;
  /** Some candidates or public history could not be parsed or fetched; retry with refresh. */
  partial: Scalars['Boolean']['output'];
};

export type PlatformSupportConversationPayload = {
  __typename?: 'SupportConversationPayload';
  conversation?: Maybe<PlatformSupportConversation>;
  error?: Maybe<PlatformSupportError>;
};

export enum PlatformSupportConversationState {
  Closed = 'CLOSED',
  Open = 'OPEN',
  Snoozed = 'SNOOZED'
}

/** Logical conversation tags resolved to environment-specific Intercom IDs by the support domain. */
export enum PlatformSupportConversationTag {
  Prescriber = 'PRESCRIBER'
}

export type PlatformSupportError = {
  __typename?: 'SupportError';
  code: PlatformSupportErrorCode;
  message: Scalars['String']['output'];
};

export enum PlatformSupportErrorCode {
  ConfigurationRequired = 'CONFIGURATION_REQUIRED',
  ContactNotLinked = 'CONTACT_NOT_LINKED',
  DeliveryUnknown = 'DELIVERY_UNKNOWN',
  InvalidInput = 'INVALID_INPUT',
  NotEligible = 'NOT_ELIGIBLE',
  NotFound = 'NOT_FOUND',
  Unavailable = 'UNAVAILABLE'
}

export type PlatformSupportMessage = {
  __typename?: 'SupportMessage';
  attachments: Array<PlatformSupportAttachment>;
  authorName: Scalars['String']['output'];
  body: Scalars['String']['output'];
  /** Unix timestamp in seconds. */
  createdAt: Scalars['Float']['output'];
  fromProvider: Scalars['Boolean']['output'];
  /** Sanitized public HTML; HTTPS-only links and no active content. */
  html: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** True for the opening message, which is also included in messages. */
  isInitial: Scalars['Boolean']['output'];
};

export type PlatformSupportUnreadStatus = {
  __typename?: 'SupportUnreadStatus';
  error?: Maybe<PlatformSupportError>;
  /** Whether an eligible conversation is unread in Intercom; null when the check could not complete. */
  hasUnread?: Maybe<Scalars['Boolean']['output']>;
  /** Number of eligible unread conversations; a lower bound when the search hit its page limit, null when the check could not complete. */
  unreadCount?: Maybe<Scalars['Int']['output']>;
};

/** A symptom journal entry logged by a patient, capturing reported symptoms. */
export type PlatformSymptomJournalEntry = PlatformJournalEntryBase & {
  __typename?: 'SymptomJournalEntry';
  /** Comments from providers or other users on this entry */
  comments: Array<PlatformEntryComment>;
  /** When the entry was created */
  createdAt: Scalars['DateTime']['output'];
  /** The entry owner's Healthie user id, or `unknown` when journaling has none */
  createdBy: Scalars['String']['output'];
  /** Optional description or notes about the symptoms */
  description?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the symptom journal entry */
  id: Scalars['ID']['output'];
  /** Custom symptom text if not in predefined list */
  otherSymptom?: Maybe<Scalars['String']['output']>;
  /** Array of human-readable symptom names (e.g., ['Bloating', 'Nausea']) */
  symptomNames: Array<Scalars['String']['output']>;
  /** Array of symptom identifiers (e.g., ['3', '7']) */
  symptoms: Array<Scalars['String']['output']>;
  /** IANA timezone identifier for the poster (e.g., 'America/Los_Angeles') */
  timezone?: Maybe<Scalars['String']['output']>;
};

/** Input for syncing a batch of health metrics */
export type PlatformSyncHealthMetricsInput = {
  /** Metric category being synced */
  category: PlatformHealthMetricCategory;
  /** Date for the sync (used for daily aggregation) */
  date: Scalars['DateTime']['input'];
  /** Healthie user id of the patient. Ignored when `patientRegistryId` is set. */
  healthieUserId?: InputMaybe<Scalars['ID']['input']>;
  /** Patient registry id of the patient. Takes precedence over the Healthie id. At least one of the two is required. */
  patientRegistryId?: InputMaybe<Scalars['ID']['input']>;
  /** Individual readings to process */
  readings: Array<PlatformHealthMetricReadingInput>;
  /** Third-party source identifier (e.g., 'apple_health', 'health_connect') */
  thirdPartySource?: InputMaybe<Scalars['String']['input']>;
};

/** Result of syncing health metrics */
export type PlatformSyncHealthMetricsPayload = {
  __typename?: 'SyncHealthMetricsPayload';
  /** Aggregated value sent to Healthie (if applicable) */
  aggregatedValue?: Maybe<Scalars['Float']['output']>;
  /** Healthie entry ID if metric was forwarded to Healthie (null if skipped) */
  healthieEntryId?: Maybe<Scalars['ID']['output']>;
  /** Number of readings processed */
  readingsProcessed: Scalars['Int']['output'];
  /** Whether the sync was successful */
  success: Scalars['Boolean']['output'];
};

/** Input for triggering a Zus Health sync for a patient. */
export type PlatformSyncPatientToZusInput = {
  /** Healthie user ID of the patient to sync */
  healthieUserId: Scalars['String']['input'];
  /** Bypass the 6-month cooldown check */
  override?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * Result of a sync-to-Zus trigger. The workflow runs asynchronously; this
 * payload describes whether a run was started, not its outcome.
 */
export type PlatformSyncPatientToZusResult = {
  __typename?: 'SyncPatientToZusResult';
  /** Last successful Zus sync timestamp at decision time, if any */
  lastSyncedToZusAt?: Maybe<Scalars['DateTime']['output']>;
  /** Patient record (auto-registered if previously unknown) */
  patient: PlatformPatient;
  /** Reason when triggered=false (e.g. 'cooldown') */
  skippedReason?: Maybe<Scalars['String']['output']>;
  /** Whether a workflow was started (false = cooldown skipped the run) */
  triggered: Scalars['Boolean']['output'];
};

export type PlatformSyncPriorAuthorizationsFromDevelopInput = {
  /**
   * Optional Develop case ids. Omit or empty to refresh every prior_authorization
   * row with a developCaseId. When provided, refreshes existing rows or creates
   * missing ones per id.
   */
  developCaseIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * When true, fetch and resolve each case but do not write to the DB or signal
   * Temporal workflows. Logs the resolved payload (Datadog: pa-develop-ops-sync,
   * dryRun=true).
   */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PlatformSyncProvidersFromAirtableInput = {
  /** Airtable provider-table record ids (`rec…`) to re-read and upsert. Max 50 unique ids per call after trim/dedupe. */
  airtableRecordIds: Array<Scalars['ID']['input']>;
};

export type PlatformSyncProvidersFromAirtableResult = {
  __typename?: 'SyncProvidersFromAirtableResult';
  /** Record ids that were not upserted, with reason. */
  skipped: Array<PlatformSyncProvidersFromAirtableSkip>;
  /** Record ids upserted into the registry. */
  syncedRecordIds: Array<Scalars['ID']['output']>;
};

/** One skipped record from a manual Airtable sync. */
export type PlatformSyncProvidersFromAirtableSkip = {
  __typename?: 'SyncProvidersFromAirtableSkip';
  /** Airtable field names that failed the completeness gate. Empty unless INCOMPLETE_ROW. */
  failedFields: Array<Scalars['String']['output']>;
  reason: PlatformAirtableSyncSkipReason;
  recordId: Scalars['ID']['output'];
};

/** A free-text multi-line input. */
export type PlatformTextAreaField = {
  __typename?: 'TextAreaField';
  /** Optional helper text shown beneath the field. */
  helperText?: Maybe<Scalars['String']['output']>;
  /** Field id; the key to submit this value under. */
  id: Scalars['String']['output'];
  /** Label shown to the patient. */
  label: Scalars['String']['output'];
  /** Optional placeholder text. */
  placeholder?: Maybe<Scalars['String']['output']>;
  /** Whether the patient must answer before advancing. */
  required: Scalars['Boolean']['output'];
};

/** A free-text single-line input. */
export type PlatformTextField = {
  __typename?: 'TextField';
  /**
   * Autofill hint (an HTML `autocomplete` token, e.g. "given-name"). Null means
   * no explicit hint — the client falls back to a token implied by `format`
   * ("phone" -> "tel", "email" -> "email"), or none for plain text.
   *
   * The standard address tokens (`address-line1`, `address-line2`,
   * `address-level2`, `postal-code`) are the semantic address-role vocabulary:
   * clients key address-population behavior (Places autocomplete wiring, city
   * and zip population from a selected place) on these specific token values,
   * not on field id or position.
   */
  autoComplete?: Maybe<Scalars['String']['output']>;
  /**
   * Optional input format hint driving client masking + validation. Null is a
   * plain free-text field. "phone" masks to (555) 123-4567 (US 10-digit).
   * "email" drives client keyboard/autocapitalize/autocorrect behavior only.
   * "code" is a 6-digit one-time code: numeric keyboard, digits-only input
   * capped at 6, `one-time-code` autofill.
   */
  format?: Maybe<Scalars['String']['output']>;
  /** Optional helper text shown beneath the field. */
  helperText?: Maybe<Scalars['String']['output']>;
  /** Field id; the key to submit this value under. */
  id: Scalars['String']['output'];
  /** Label shown to the patient. */
  label: Scalars['String']['output'];
  /**
   * Set when this field is the canonical capture point for the lead's email or
   * phone number, for downstream marketing attribution. Null for ordinary
   * fields.
   */
  marketingCapture?: Maybe<PlatformMarketingCaptureKind>;
  /** Optional placeholder text. */
  placeholder?: Maybe<Scalars['String']['output']>;
  /**
   * When true, the client renders this field read-only (non-editable) and never
   * submits its value — the field displays a value locked upstream rather than
   * collecting one here. The welcome address step surfaces the licensing state
   * this way: seeded from the earlier `state` step (see FormStep.currentValues)
   * and shown between City and ZIP, but never re-collected, so the mailing state
   * can't diverge from the state the patient was matched/booked under
   * (GLPX-236/247). Null (or false) is an ordinary editable field.
   */
  readOnly?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the patient must answer before advancing. */
  required: Scalars['Boolean']['output'];
};

/**
 * A medication the patient logs doses against, with the adherence figures derived
 * from its non-removed logs. Created automatically from a prescription (see
 * `prescriptionId`).
 *
 * Every derived field — `dosesRemaining`, `nextDoseDate`, `endDateForecast` —
 * comes from `doseIntervalDays`. When the cadence couldn't be determined for a
 * medication, `doseIntervalDays` is null and each of those is null too: no
 * forecast is offered rather than a guessed one.
 *
 * All timing here is the patient's own wall clock. Dates are `YYYY-MM-DD` and
 * times `HH:mm`, exactly as entered; no timezone is stored and no absolute instant
 * is returned.
 */
export type PlatformTrackedMedication = {
  __typename?: 'TrackedMedication';
  /** False once this tracked prescription supply is complete, expired, or stopped. */
  active: Scalars['Boolean']['output'];
  /** Canonical brand (e.g. "Zepbound"). Null when the brand isn't recognized yet. */
  brand?: Maybe<Scalars['String']['output']>;
  /** When Berry Street created this medication record. */
  createdAt: Scalars['DateTime']['output'];
  /**
   * Patient-facing label, e.g. "Zepbound KwikPen". Falls back to the full `name`
   * when the brand is unrecognized. Prefer this over `name` in UI.
   */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Days between consecutive doses: 7 weekly, 1 daily. Null when undetermined. */
  doseIntervalDays?: Maybe<Scalars['Int']['output']>;
  /** Doses the supply contains — 4 weekly injections or 28 daily tablets. */
  dosesCount?: Maybe<Scalars['Int']['output']>;
  /** Doses left in the supply, floored at 0. Null when `dosesCount` is unknown. */
  dosesRemaining?: Maybe<Scalars['Int']['output']>;
  /** Non-removed doses logged so far. */
  dosesTaken: Scalars['Int']['output'];
  /**
   * Projected last day the supply covers, `YYYY-MM-DD` — `startDate` plus
   * `dosesCount * doseIntervalDays` days. Null when the cadence is unknown or no
   * dose has been logged yet.
   */
  endDateForecast?: Maybe<Scalars['String']['output']>;
  /**
   * Earliest non-removed dose log by the patient's entered dose date and time.
   * Ties are resolved by creation time, then id, both ascending. Null when no
   * non-removed logs exist. Selecting this on `trackedMedicationOverview` or
   * `trackedMedications` fetches at most one log per selected medication.
   */
  firstDose?: Maybe<PlatformMedicationTakeLog>;
  /** Dosage form as written (e.g. "Auto-injector"). Null when unreported. */
  form?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** When this tracked supply became inactive. Null while active. */
  inactivatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Why this tracked supply became inactive. Null while active. */
  inactiveReason?: Maybe<PlatformTrackedMedicationInactiveReason>;
  /** Whether this is the patient's selected medication, with newest-active fallback when no preference exists. */
  isDefault: Scalars['Boolean']['output'];
  /** Day of the most recent logged dose, `YYYY-MM-DD`. Null if none yet. */
  lastDoseDate?: Maybe<Scalars['String']['output']>;
  /** Time of the most recent logged dose, `HH:mm`. Null if none yet. */
  lastDoseTime?: Maybe<Scalars['String']['output']>;
  /**
   * Non-removed dose history ordered by dose date and time, newest first. Pass
   * `limit` to fetch only the newest entries needed by a summary view; omit it for
   * the complete history. Selecting this on `trackedMedications` issues one query
   * per medication.
   */
  logs: Array<PlatformMedicationTakeLog>;
  /** Drug name as the source system wrote it — verbose, and rarely what to display. */
  name: Scalars['String']['output'];
  /**
   * Day the next dose is due, `YYYY-MM-DD` — anchored on the last dose actually
   * logged (not on a schedule), so a late dose shifts the whole remaining schedule
   * rather than accruing overdue doses. Null when the cadence is unknown, no dose
   * has been logged yet, or the course is complete.
   */
  nextDoseDate?: Maybe<Scalars['String']['output']>;
  /**
   * Time the next dose is due, `HH:mm` — the same time of day as the last dose.
   * Advancing the day and keeping the wall clock is deliberate: adding 24-hour
   * blocks would drift the patient's dose time by an hour across a daylight-saving
   * change.
   */
  nextDoseTime?: Maybe<Scalars['String']['output']>;
  /** The prescription this medication came from. Null when it wasn't prescription-sourced. */
  prescriptionId?: Maybe<Scalars['ID']['output']>;
  /** Administration route resolved from the medication name. Null when it cannot be classified. */
  route?: Maybe<PlatformMedicationRoute>;
  /**
   * First day of the supply, `YYYY-MM-DD` — the day of the patient's first logged
   * dose. Null until they log one: nothing knows when a supply actually starts
   * before the first dose is taken, so no date is assumed at creation.
   */
  startDate?: Maybe<Scalars['String']['output']>;
  /** Unit each log's `doseAmount` is expressed in (e.g. "mg"). Null when unreported. */
  unit?: Maybe<Scalars['String']['output']>;
  /** Most recent time the patient opened their medication list. */
  viewedAt?: Maybe<Scalars['DateTime']['output']>;
};


/**
 * A medication the patient logs doses against, with the adherence figures derived
 * from its non-removed logs. Created automatically from a prescription (see
 * `prescriptionId`).
 *
 * Every derived field — `dosesRemaining`, `nextDoseDate`, `endDateForecast` —
 * comes from `doseIntervalDays`. When the cadence couldn't be determined for a
 * medication, `doseIntervalDays` is null and each of those is null too: no
 * forecast is offered rather than a guessed one.
 *
 * All timing here is the patient's own wall clock. Dates are `YYYY-MM-DD` and
 * times `HH:mm`, exactly as entered; no timezone is stored and no absolute instant
 * is returned.
 */
export type PlatformTrackedMedicationLogsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

/** Why a tracked supply became inactive; this is not a clinical stop-medication status. */
export enum PlatformTrackedMedicationInactiveReason {
  /** Every dose in the supply was logged. No longer written; older supplies still carry it. */
  SupplyCompleted = 'SUPPLY_COMPLETED',
  /** No dose was logged for 40 days. */
  SupplyExpired = 'SUPPLY_EXPIRED',
  /** An older supply was replaced by a newer active medication for the same patient. */
  SupplyExpiredNewActiveMedication = 'SUPPLY_EXPIRED_NEW_ACTIVE_MEDICATION'
}

/** Medication-list data shaped so clients can request logs only for the default row. */
export type PlatformTrackedMedicationOverview = {
  __typename?: 'TrackedMedicationOverview';
  defaultMedication?: Maybe<PlatformTrackedMedication>;
  medications: Array<PlatformTrackedMedication>;
};

/**
 * Result of ops mutations that start a one-shot Temporal backfill workflow.
 * The workflow runs asynchronously; this payload describes whether a run
 * was started, not its outcome.
 */
export type PlatformTriggerBackfillWorkflowResult = {
  __typename?: 'TriggerBackfillWorkflowResult';
  /** Reason when triggered=false (e.g. 'already_running'). */
  skippedReason?: Maybe<Scalars['String']['output']>;
  /** Whether a new workflow execution was started (false when one is already running). */
  triggered: Scalars['Boolean']['output'];
  /** Temporal workflow id — use for deep links in Temporal UI. */
  workflowId: Scalars['ID']['output'];
};

/** Result of a triggerChatBackfill call — count of workflows submitted. */
export type PlatformTriggerChatBackfillResult = {
  __typename?: 'TriggerChatBackfillResult';
  /** Number of workflows submitted */
  submitted: Scalars['Int']['output'];
};

/**
 * Result of a triggerChatHistoryImport call: the accepted run, not its files.
 *
 * The generator is long-running and rotates, so the mutation returns as soon as
 * Temporal accepts the workflow. Watch progress with the
 * `chatHistoryImportProgress` workflow query, and read the manifest from S3 when
 * it completes for the list of files to upload.
 */
export type PlatformTriggerChatHistoryImportResult = {
  __typename?: 'TriggerChatHistoryImportResult';
  /** Echoes the run ID, which is also the workflow ID suffix and the S3 key prefix */
  runId: Scalars['String']['output'];
  /** Temporal workflow ID, `chat-history-import-<runId>` */
  workflowId: Scalars['String']['output'];
};

/**
 * Result of a triggerChatHistoryScan call: the accepted run, not its numbers.
 *
 * The scan is long-running (roughly 115k channels at one Healthie call each), so
 * the mutation returns as soon as Temporal accepts the workflow. Watch progress
 * with the `chatHistoryScanProgress` workflow query and read the manifest from S3
 * when it completes.
 */
export type PlatformTriggerChatHistoryScanResult = {
  __typename?: 'TriggerChatHistoryScanResult';
  /** Echoes the run ID, which is also the workflow ID suffix and the S3 key prefix */
  runId: Scalars['String']['output'];
  /** Temporal workflow ID, `chat-history-scan-<runId>` */
  workflowId: Scalars['String']['output'];
};

export type PlatformUnlinkMedicareBridgeCaseTargetInput = {
  caseId: Scalars['ID']['input'];
  kind: PlatformMedicareBridgeCaseLinkKind;
  /** Why this link is being removed. Required. */
  reason: Scalars['String']['input'];
  targetId: Scalars['ID']['input'];
};

export type PlatformUnlinkMedicareBridgeCaseTargetPayload = {
  __typename?: 'UnlinkMedicareBridgeCaseTargetPayload';
  medicareBridgeCase: PlatformMedicareBridgeCase;
};

export type PlatformUnservicedZipCodeError = PlatformLabsError & {
  __typename?: 'UnservicedZipCodeError';
  message: Scalars['String']['output'];
  modality: PlatformLabOrderModality;
  zipCode: Scalars['String']['output'];
};

/**
 * A patient's upcoming initial GLP-1 consultation — the minimal slice needed by
 * the double-booking guard and idempotent retry orchestration. See
 * `Query.upcomingGlp1InitialConsult`.
 */
export type PlatformUpcomingGlp1Consult = {
  __typename?: 'UpcomingGlp1Consult';
  /** Healthie appointment id. */
  appointmentHealthieId: Scalars['ID']['output'];
  /** ISO 8601 start time (UTC). */
  appointmentTime: Scalars['DateTime']['output'];
  /** Canonical provider-registry id. Null when the Healthie provider has no registry counterpart. */
  providerId?: Maybe<Scalars['ID']['output']>;
  /** Prescriber display name when Healthie has one; null otherwise. */
  providerName?: Maybe<Scalars['String']['output']>;
};

export type PlatformUpdateDocumentRequestInput = {
  id: Scalars['ID']['input'];
  requestText: Scalars['String']['input'];
};

export type PlatformUpdateEhrHeightInput = {
  /** The height, passed to the EHR as given. */
  height: Scalars['String']['input'];
  patient: PlatformEhrVitalsPatientInput;
};

export type PlatformUpdateEhrHeightPayload = {
  __typename?: 'UpdateEhrHeightPayload';
  /** The EHR patient id the EHR confirmed. Null when it rejected the write; messages then say why. */
  externalId?: Maybe<Scalars['ID']['output']>;
  messages: Array<PlatformEhrWriteMessage>;
};

export type PlatformUpdateEhrMetricEntryInput = {
  /** When the entry was recorded, passed to the EHR as given. Null or left out leaves it unchanged. */
  createdAt?: InputMaybe<Scalars['String']['input']>;
  /** Null or left out leaves it unchanged. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The EHR entry id. Blank and NaviHealth (nh-) ids are BAD_USER_INPUT. */
  entryId: Scalars['ID']['input'];
  /** The value, passed to the EHR as given. Null or left out leaves it unchanged. */
  metricStat?: InputMaybe<Scalars['String']['input']>;
  patient: PlatformEhrVitalsPatientInput;
};

export type PlatformUpdateEhrMetricEntryPayload = {
  __typename?: 'UpdateEhrMetricEntryPayload';
  /** The updated EHR entry id. Null when the EHR rejected the write; messages then say why. */
  entryId?: Maybe<Scalars['ID']['output']>;
  messages: Array<PlatformEhrWriteMessage>;
};

export type PlatformUpdateHealthieAppointmentInput = {
  appointmentTypeId?: InputMaybe<Scalars['ID']['input']>;
  /** How the session connects. Common values: 'Secure Videochat', 'Healthie Video Call', 'phone_call'. Actual options depend on the appointment type. */
  contactType?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  location?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type PlatformUpdateHealthieAppointmentResponse = {
  __typename?: 'UpdateHealthieAppointmentResponse';
  appointment?: Maybe<PlatformHealthieAppointment>;
  messages: Array<PlatformHealthieMessage>;
};

/** Input for updating a document's Healthie document ID */
export type PlatformUpdateHealthieDocumentIdInput = {
  /** The document ID to update */
  documentId: Scalars['ID']['input'];
  /** The Healthie document ID to set */
  healthieDocumentId: Scalars['ID']['input'];
  /** Healthie user ID (required) - used to verify document ownership */
  healthieUserId: Scalars['ID']['input'];
};

export type PlatformUpdateHealthiePatientInput = {
  dob?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type PlatformUpdateHealthiePatientResponse = {
  __typename?: 'UpdateHealthiePatientResponse';
  messages: Array<PlatformHealthieMessage>;
  patient?: Maybe<PlatformHealthiePatient>;
};

/** Input for updating any journal entry type via the unified mutation */
export type PlatformUpdateJournalEntryInput = {
  /** Updated timestamp */
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Updated description or notes */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Updated emotion tags — FOOD only */
  emotions?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Type of journal entry (needed for validation and transform routing — not sent to Healthie) */
  entryType: PlatformJournalEntryType;
  /** ID of the entry to update */
  id: Scalars['ID']['input'];
  /** Updated image — FOOD only */
  image?: InputMaybe<PlatformImageInput>;
  /** Updated macro sourcing — FOOD only. Omitted keeps the stored value, null clears it. */
  macroMetadata?: InputMaybe<PlatformFoodEntryMacroMetadataInput>;
  /** Updated meal category — FOOD only */
  mealType?: InputMaybe<PlatformMealType>;
  /** Updated metric value — WEIGHT, ACTIVITY, WATER_INTAKE, STOOL */
  metricStat?: InputMaybe<Scalars['String']['input']>;
  /** Updated nutritional metrics — FOOD only */
  nutritionalMetrics?: InputMaybe<Array<PlatformNutritionalMetricInput>>;
  /** Updated custom symptom text — SYMPTOM only */
  otherSymptom?: InputMaybe<Scalars['String']['input']>;
  /** Patient registry id of the patient the entry is for. When set, an entry that isn't theirs is not found and NaviHealth is sent this id; unset, the entry's owner is. */
  patientRegistryId?: InputMaybe<Scalars['ID']['input']>;
  /** Updated symptom catalog ids (1-15) or names; while symptoms are stored in NaviHealth, an id outside the catalog is dropped and an unknown name is kept as an other symptom — SYMPTOM only */
  symptoms?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type PlatformUpdateMedicalHistoryAllergiesInput = {
  patientId: Scalars['ID']['input'];
  response: Scalars['String']['input'];
  source: PlatformMedicalHistorySource;
};

export type PlatformUpdateMedicalHistoryConditionsInput = {
  conditionIds: Array<Scalars['ID']['input']>;
  patientId: Scalars['ID']['input'];
  source: PlatformMedicalHistorySource;
};

export type PlatformUpdateMedicalHistorySocialHistoryInput = {
  alcohol: Scalars['Boolean']['input'];
  drinksPerWeek?: InputMaybe<Scalars['Int']['input']>;
  nonPrescribedSubstances: Scalars['Boolean']['input'];
  patientId: Scalars['ID']['input'];
  source: PlatformMedicalHistorySource;
  tobacco: PlatformMedicalHistoryTobacco;
};

export type PlatformUpdateMedicalHistorySurgeriesHospitalizationsInput = {
  patientId: Scalars['ID']['input'];
  response: Scalars['String']['input'];
  source: PlatformMedicalHistorySource;
};

export type PlatformUpdateMedicationInput = {
  comments?: InputMaybe<Scalars['String']['input']>;
  directions?: InputMaybe<Scalars['String']['input']>;
  dosage?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export type PlatformUpdateMedicationTakeInput = {
  /** Amount taken, in the medication's `unit`. Null clears it. */
  doseAmount?: InputMaybe<Scalars['Float']['input']>;
  /** Calendar day the patient picked, `YYYY-MM-DD`. Stored exactly as sent. */
  doseDate: Scalars['String']['input'];
  /** Wall-clock time the patient picked, `HH:mm` on a 24-hour clock. Stored as sent. */
  doseTime: Scalars['String']['input'];
  /** Null clears it. */
  injectionSite?: InputMaybe<PlatformMedicationInjectionSite>;
  logId: Scalars['ID']['input'];
  /** Null clears it. */
  notes?: InputMaybe<Scalars['String']['input']>;
  patientHealthieId: Scalars['ID']['input'];
  /** Identifier of the pen or vial used for this dose. Null clears it. */
  penOrVialId?: InputMaybe<Scalars['String']['input']>;
};

export type PlatformUpdateMedicationTakePayload = {
  __typename?: 'UpdateMedicationTakePayload';
  /** The log as stored after the update. */
  log: PlatformMedicationTakeLog;
};

export type PlatformUpdatePatientBaseProfileInput = {
  captured: Array<PlatformCapturedProfileFieldInput>;
  healthieUserId: Scalars['ID']['input'];
};

/** Input for updating an existing patient note. Only the author may update their own note. */
export type PlatformUpdatePatientNoteInput = {
  /** New body content */
  body: Scalars['String']['input'];
  /** Note ID */
  id: Scalars['ID']['input'];
};

export type PlatformUpdatePatientRaceAndEthnicityInput = {
  /** Ethnicity to set. Null leaves Healthie's current ethnicity unchanged. */
  ethnicity?: InputMaybe<PlatformPatientEthnicity>;
  /** Internal patient-registry ID whose Healthie profile is updated. */
  patientId: Scalars['ID']['input'];
  /** Race to set. Null leaves Healthie's current race unchanged. */
  race?: InputMaybe<PlatformPatientRace>;
};

export type PlatformUpdateProviderBookingSettingsInput = {
  healthieProviderId: Scalars['ID']['input'];
  /** Required when enabling same-day booking; must be 1-1439. Ignored when disabling, which writes null (the 1440-minute default). */
  minimumNoticeMinutes?: InputMaybe<Scalars['Int']['input']>;
  sameDayBookingEnabled: Scalars['Boolean']['input'];
};

export type PlatformUpdateProviderBookingSettingsPayload = {
  __typename?: 'UpdateProviderBookingSettingsPayload';
  /** False when Airtable was updated but the immediate targeted CBF sync failed; the regular cron will still reconcile it. */
  appliedImmediately: Scalars['Boolean']['output'];
  settings: PlatformProviderBookingSettings;
};

export type PlatformUpdateReferralReasonInput = {
  patient: PlatformReferringPhysicianPatientInput;
  reason: Scalars['String']['input'];
  /** Healthie's referral id. */
  referralId: Scalars['ID']['input'];
  /** Healthie's referring physician id on that referral. */
  referringPhysicianId: Scalars['ID']['input'];
};

export type PlatformUpdateReferralReasonPayload = {
  __typename?: 'UpdateReferralReasonPayload';
  /** Healthie's validation messages. Empty on success. */
  messages: Array<PlatformReferringPhysicianMessage>;
  /** The updated referral. Null when Healthie rejected the update. */
  referral?: Maybe<PlatformReferringPhysicianReferral>;
};

/** Omitted fields are not sent to Healthie and stay unchanged; a null clears the field. */
export type PlatformUpdateReferringPhysicianInput = {
  businessName?: InputMaybe<Scalars['String']['input']>;
  faxNumber?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Healthie's referring physician id. */
  id: Scalars['ID']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Changes the physician's existing Healthie location; the platform supplies that location's id. */
  location?: InputMaybe<PlatformReferringPhysicianLocationInput>;
  /** The patient the physician must already be linked to. */
  patient: PlatformReferringPhysicianPatientInput;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type PlatformUpdateReferringPhysicianPayload = {
  __typename?: 'UpdateReferringPhysicianPayload';
  /** Healthie's validation messages. Empty on success. */
  messages: Array<PlatformReferringPhysicianMessage>;
  /** The updated physician. Null when Healthie rejected the update. */
  referringPhysician?: Maybe<PlatformReferringPhysician>;
};

/** Response containing a presigned URL for uploading a document to S3 */
export type PlatformUploadUrlResponse = {
  __typename?: 'UploadUrlResponse';
  /** The document ID to use when confirming the upload */
  documentId: Scalars['ID']['output'];
  /** When the presigned URL expires */
  expiresAt: Scalars['DateTime']['output'];
  /** The presigned S3 URL for uploading the file (expires in 15 minutes) */
  uploadUrl: Scalars['String']['output'];
};

/** Input for upsertDailyTotal */
export type PlatformUpsertDailyTotalInput = {
  /** The patient's local date the total is for, as YYYY-MM-DD in `timezone` */
  date: Scalars['String']['input'];
  /** The sleep session's end (start + duration). Required for SLEEP_DURATION, where Healthie dates the entry at it and NaviHealth stores it as the session's end; ignored for WATER_INTAKE and STEPS. */
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** The total's id in the `externalIdType` system, such as `HK-Steps-2026-10-07`, or for SLEEP_DURATION the session's source id, such as `HK-Sleep-2026-10-07` or `HC-Sleep-<session id>` (a hashed form such as `HC-Sleep-h:<sha256>` when the id is longer than 255): 1 to 255 characters, not all whitespace. Set with `externalIdType`, or leave both unset. */
  externalId?: InputMaybe<Scalars['String']['input']>;
  /**
   * The system the total came from. Set with `externalId`, or leave both unset; required for
   * SLEEP_DURATION, where it must be HEALTHKIT_SOURCE_ID or HEALTH_CONNECT_SOURCE_ID. For WATER_INTAKE
   * and STEPS it is recorded with the total where the store keeps it, and never a key: a repeat with
   * the same `externalId` still sets the new total and never replays the first result. For
   * SLEEP_DURATION, `externalId` names the sleep session and is part of the key, last write wins:
   * a repeat for the same session updates its entry in place.
   */
  externalIdType?: InputMaybe<PlatformJournalEntryExternalIdType>;
  /** Healthie user id of the patient. Ignored when `patientRegistryId` is set. */
  patientId?: InputMaybe<Scalars['ID']['input']>;
  /** Patient registry id of the patient. Takes precedence over the Healthie id. At least one of the two is required. */
  patientRegistryId?: InputMaybe<Scalars['ID']['input']>;
  /** Device or app the total came from: 'apple_health', 'google_fit' or 'fitbit', the values Healthie accepts. Part of the steps day key: each source keeps its own entry for the day, and entries with no source share one key of their own; readers add a day's entries up. Stored as the entry's source when a STEPS or SLEEP_DURATION entry is created, and not part of the sleep key; an update keeps the stored source. Ignored for WATER_INTAKE. */
  thirdPartySource?: InputMaybe<Scalars['String']['input']>;
  /** IANA timezone `date` is in, such as 'America/New_York' */
  timezone: Scalars['String']['input'];
  /** Which daily total this is */
  type: PlatformDailyTotalType;
  /** The total, replacing any earlier value: millilitres for WATER_INTAKE, a whole step count for STEPS, minutes for SLEEP_DURATION. Not negative. */
  value: Scalars['Float']['input'];
};

/** Result of upsertDailyTotal */
export type PlatformUpsertDailyTotalPayload = {
  __typename?: 'UpsertDailyTotalPayload';
  /** The entry, created or updated: a WaterIntakeJournalEntry, a StepsJournalEntry or a SleepDurationJournalEntry. Its id is an `nh-` id while the type is served from NaviHealth. */
  entry: PlatformJournalEntry;
  /** The total as stored, in the type's unit (millilitres, steps or minutes), read back from the entry */
  value: Scalars['Float']['output'];
};

/** Input for upserting patient nutrient goals */
export type PlatformUpsertPatientNutrientGoalsInput = {
  /** List of nutrient goals (replaces all existing goals) */
  goals: Array<PlatformNutrientGoalInput>;
  /** Healthie patient ID */
  patientId: Scalars['ID']['input'];
};

/** Input for upserting a session goal */
export type PlatformUpsertSessionGoalInput = {
  /** Healthie appointment ID during which the goal was created (optional) */
  appointmentId?: InputMaybe<Scalars['ID']['input']>;
  /** Set to true to archive, false to unarchive (ignored for create) */
  archive?: InputMaybe<Scalars['Boolean']['input']>;
  /** The goal content - required for create, optional for update */
  content?: InputMaybe<Scalars['String']['input']>;
  /** Goal ID - if provided, updates existing goal; if omitted, creates new goal */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Set to true to mark complete (provider action), false to uncomplete (ignored for create) */
  markComplete?: InputMaybe<Scalars['Boolean']['input']>;
  /** ID of the goal this was rolled over from (for rollover tracking) */
  parentGoalId?: InputMaybe<Scalars['ID']['input']>;
  /** Patient ID - always required for ownership/quota validation */
  patientId: Scalars['ID']['input'];
};

export type PlatformVitalsInput = {
  heightFeet: Scalars['Int']['input'];
  heightInches: Scalars['Int']['input'];
  sexAtBirth: PlatformSexAtBirth;
  weightLbs: Scalars['Float']['input'];
};

/** A water intake journal entry logged by a patient, capturing fluid consumption. */
export type PlatformWaterIntakeJournalEntry = PlatformJournalEntryBase & {
  __typename?: 'WaterIntakeJournalEntry';
  /** Numeric amount of water consumed (null if not recorded) */
  amount?: Maybe<Scalars['Float']['output']>;
  /** Comments from providers or other users on this entry */
  comments: Array<PlatformEntryComment>;
  /** When the entry was created */
  createdAt: Scalars['DateTime']['output'];
  /** The entry owner's Healthie user id, or `unknown` when journaling has none */
  createdBy: Scalars['String']['output'];
  /** Optional description or notes about the water intake */
  description?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the water intake journal entry */
  id: Scalars['ID']['output'];
  /** IANA timezone identifier for the poster (e.g., 'America/Los_Angeles') */
  timezone?: Maybe<Scalars['String']['output']>;
  /** Unit of measurement (e.g., 'oz', 'ml') */
  unit: Scalars['String']['output'];
};

/** A weight journal entry logged by a patient, capturing body weight measurements. */
export type PlatformWeightJournalEntry = PlatformJournalEntryBase & {
  __typename?: 'WeightJournalEntry';
  /** Comments from providers or other users on this entry */
  comments: Array<PlatformEntryComment>;
  /** When the entry was created */
  createdAt: Scalars['DateTime']['output'];
  /** The entry owner's Healthie user id, or `unknown` when journaling has none */
  createdBy: Scalars['String']['output'];
  /** Optional description or notes about the measurement */
  description?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the weight journal entry */
  id: Scalars['ID']['output'];
  /** The device or app integration that wrote the entry, such as 'apple_health', 'google_fit' or 'fitbit'. Null when the entry was logged by hand or its source isn't known, and on the entry createJournalEntry and updateJournalEntry return, which don't read it. */
  thirdPartySource?: Maybe<Scalars['String']['output']>;
  /** IANA timezone identifier for the poster (e.g., 'America/Los_Angeles') */
  timezone?: Maybe<Scalars['String']['output']>;
  /** Unit of measurement (e.g., 'lbs', 'kg') */
  unit: Scalars['String']['output'];
  /** Numeric weight value (null if not recorded) */
  value?: Maybe<Scalars['Float']['output']>;
};

export type PlatformZocdocImportAttempt = {
  __typename?: 'ZocdocImportAttempt';
  appointmentId?: Maybe<Scalars['ID']['output']>;
  candidatePlanIds: Array<Scalars['ID']['output']>;
  enrichmentAttemptCount: Scalars['Int']['output'];
  enrichmentReasonCode?: Maybe<Scalars['String']['output']>;
  enrichmentStatus?: Maybe<Scalars['String']['output']>;
  extractionAttemptCount: Scalars['Int']['output'];
  extractionAttemptedAt?: Maybe<Scalars['String']['output']>;
  kind: Scalars['String']['output'];
  nextAction: Scalars['String']['output'];
  operationId: Scalars['ID']['output'];
  patientHealthieId: Scalars['ID']['output'];
  policyId?: Maybe<Scalars['ID']['output']>;
  reasons: Array<Scalars['String']['output']>;
  sources: Array<PlatformZocdocImportSource>;
  status: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

/** Reviewable source-to-destination attempt, including partial packets and enrichment. */
export type PlatformZocdocImportSource = {
  __typename?: 'ZocdocImportSource';
  createdAt?: Maybe<Scalars['String']['output']>;
  documentId: Scalars['ID']['output'];
  kind: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

/**
 * Warehouse copy of Zus clinical data for a patient. Distinct from demographic
 * sync-to-Zus (`lastSyncedToZusAt`): this is inbound pull completeness.
 */
export enum PlatformZusDataStatus {
  Complete = 'COMPLETE',
  InProgress = 'IN_PROGRESS'
}

/** One Zus document with its attachment, read live from Zus. Nothing is stored. */
export type PlatformZusDocument = {
  __typename?: 'ZusDocument';
  /** The original attachment bytes, base64-encoded and unaltered. */
  content: Scalars['String']['output'];
  /** SHA-256 of the original attachment bytes, hex. Equal hashes mean the same file. */
  sha256: Scalars['String']['output'];
  summary: PlatformZusDocumentSummary;
  /**
   * Text extracted from the attachment: section titles and narrative blocks for C-CDA, visible text
   * for HTML, the content of plain text, and the text layer of a PDF. Null for images, for a PDF with
   * no text layer (a scan), and for a PDF that could not be read.
   */
  text?: Maybe<Scalars['String']['output']>;
};

/** A code as Zus sent it. Any part is null when Zus omitted it. */
export type PlatformZusDocumentCoding = {
  __typename?: 'ZusDocumentCoding';
  code?: Maybe<Scalars['String']['output']>;
  display?: Maybe<Scalars['String']['output']>;
  system?: Maybe<Scalars['String']['output']>;
};

export enum PlatformZusDocumentReadFailure {
  /** Zus failed to return the attachment. */
  DownloadFailed = 'DOWNLOAD_FAILED',
  /** The id is not among the patient's documents. */
  NotFound = 'NOT_FOUND',
  /** The document has no attachment to read. */
  NoAttachment = 'NO_ATTACHMENT',
  /** The attachment is over 10 MiB. */
  TooLarge = 'TOO_LARGE'
}

/** One requested Zus document: the document, or why it could not be read. */
export type PlatformZusDocumentReadResult = {
  __typename?: 'ZusDocumentReadResult';
  /** Null when `failure` is set. */
  document?: Maybe<PlatformZusDocument>;
  failure?: Maybe<PlatformZusDocumentReadFailure>;
  /** The requested Zus DocumentReference id. */
  id: Scalars['ID']['output'];
};

/**
 * Metadata for one Zus DocumentReference, read live from Zus. Dates are FHIR date or dateTime strings
 * exactly as Zus sent them, so a partial date (YYYY or YYYY-MM) keeps its precision.
 */
export type PlatformZusDocumentSummary = {
  __typename?: 'ZusDocumentSummary';
  /** When the read attachment was created at the source. */
  attachmentCreatedAt?: Maybe<Scalars['String']['output']>;
  /** Author display names, as sent. */
  authors: Array<Scalars['String']['output']>;
  /** Size of that attachment in bytes, when Zus reports it. */
  byteSize?: Maybe<Scalars['Int']['output']>;
  /** Document categories, one coding each, LOINC preferred. */
  categories: Array<PlatformZusDocumentCoding>;
  /**
   * MIME type of the attachment this document is read from: the first C-CDA, HTML or plain-text
   * attachment, else the first PDF, else the first image, else the first attachment. Null when the
   * reference has no attachment.
   */
  contentType?: Maybe<Scalars['String']['output']>;
  /** FHIR docStatus (preliminary, final, amended, entered-in-error). Null when Zus omitted it. */
  docStatus?: Maybe<Scalars['String']['output']>;
  /** Zus DocumentReference id. */
  id: Scalars['ID']['output'];
  /** When the reference was indexed in the network (DocumentReference.date). Often an import time; not a clinical date. */
  indexedAt?: Maybe<Scalars['String']['output']>;
  /** End of the clinical period the document covers. */
  periodEnd?: Maybe<Scalars['String']['output']>;
  /** Start of the clinical period the document covers. */
  periodStart?: Maybe<Scalars['String']['output']>;
  /** FHIR status (current, superseded, entered-in-error). */
  status?: Maybe<Scalars['String']['output']>;
  /** The read attachment's title, else the DocumentReference description. */
  title?: Maybe<Scalars['String']['output']>;
  /** Document type as the source coded it, LOINC preferred (e.g. 34117-2, History and physical note). */
  type?: Maybe<PlatformZusDocumentCoding>;
};

export type PlatformAccessCarePlanMedicationReviewFragment = { __typename?: 'AccessCarePlan', medicationReview?: { __typename?: 'AccessCarePlanMedicationReview', historyAvailable: boolean, undatedHistoryCount: number, history: Array<{ __typename?: 'AccessCarePlanMedicationReviewItem', name: string, dosage?: string | null, status?: string | null, recordedAt?: string | null, source: string }>, programPrescriptions: Array<{ __typename?: 'AccessCarePlanMedicationReviewItem', name: string, dosage?: string | null, status?: string | null, recordedAt?: string | null, source: string }> } | null };

export type PlatformAccessNpReviewQueueQueryVariables = Exact<{
  npProviderId: Scalars['String']['input'];
}>;


export type PlatformAccessNpReviewQueueQuery = { __typename?: 'Query', accessNpReviewQueue: Array<{ __typename?: 'AccessNpReviewQueueItem', accessEnrollmentId: string, healthieUserId: string, patientLegalFirstName: string, patientLegalLastName: string, patientDateOfBirth?: string | null, patientState?: string | null, memberIdLast4: string, track: PlatformAccessTrack, alignmentDate?: any | null, baselineOapSubmissionCompletedAt?: any | null, latestCarePlan?: { __typename?: 'AccessCarePlan', id: string, accessEnrollmentId: string, healthieUserId: string, version: number, status: PlatformAccessCarePlanStatus, track: PlatformAccessTrack, schemaVersion: number, contentJson: any, renderedMarkdown: string, validationPassed: boolean, requiresAttention: boolean, generationValidationMessages: Array<string>, baselineApprovalBlockedReasons: Array<string>, generatedAt: any, generatedBy: string, approvedAt?: any | null, approvedBy?: string | null, advisories: Array<{ __typename?: 'AccessCarePlanAdvisory', rule: string, detail: string, codes: Array<string>, assignedTrack: PlatformAccessTrack, impliedTrack: PlatformAccessTrack }>, approvalBlocks: { __typename?: 'AccessCarePlanApprovalBlocks', status: PlatformAccessCarePlanApprovalBlockStatus, blocks: Array<{ __typename?: 'AccessCarePlanApprovalBlock', reason: string, message: string, advisory: { __typename?: 'AccessCarePlanAdvisory', rule: string, detail: string, codes: Array<string>, assignedTrack: PlatformAccessTrack, impliedTrack: PlatformAccessTrack } }> }, medicationReview?: { __typename?: 'AccessCarePlanMedicationReview', historyAvailable: boolean, undatedHistoryCount: number, history: Array<{ __typename?: 'AccessCarePlanMedicationReviewItem', name: string, dosage?: string | null, status?: string | null, recordedAt?: string | null, source: string }>, programPrescriptions: Array<{ __typename?: 'AccessCarePlanMedicationReviewItem', name: string, dosage?: string | null, status?: string | null, recordedAt?: string | null, source: string }> } | null } | null }> };

export type PlatformApproveAccessCarePlanMutationVariables = Exact<{
  input: PlatformApproveAccessCarePlanInput;
}>;


export type PlatformApproveAccessCarePlanMutation = { __typename?: 'Mutation', approveAccessCarePlan: { __typename?: 'AccessCarePlan', id: string, accessEnrollmentId: string, healthieUserId: string, version: number, status: PlatformAccessCarePlanStatus, track: PlatformAccessTrack, schemaVersion: number, contentJson: any, renderedMarkdown: string, validationPassed: boolean, requiresAttention: boolean, generationValidationMessages: Array<string>, baselineApprovalBlockedReasons: Array<string>, generatedAt: any, generatedBy: string, approvedAt?: any | null, approvedBy?: string | null, advisories: Array<{ __typename?: 'AccessCarePlanAdvisory', rule: string, detail: string, codes: Array<string>, assignedTrack: PlatformAccessTrack, impliedTrack: PlatformAccessTrack }>, approvalBlocks: { __typename?: 'AccessCarePlanApprovalBlocks', status: PlatformAccessCarePlanApprovalBlockStatus, blocks: Array<{ __typename?: 'AccessCarePlanApprovalBlock', reason: string, message: string, advisory: { __typename?: 'AccessCarePlanAdvisory', rule: string, detail: string, codes: Array<string>, assignedTrack: PlatformAccessTrack, impliedTrack: PlatformAccessTrack } }> }, medicationReview?: { __typename?: 'AccessCarePlanMedicationReview', historyAvailable: boolean, undatedHistoryCount: number, history: Array<{ __typename?: 'AccessCarePlanMedicationReviewItem', name: string, dosage?: string | null, status?: string | null, recordedAt?: string | null, source: string }>, programPrescriptions: Array<{ __typename?: 'AccessCarePlanMedicationReviewItem', name: string, dosage?: string | null, status?: string | null, recordedAt?: string | null, source: string }> } | null } };

export type PlatformEditAccessCarePlanMutationVariables = Exact<{
  input: PlatformEditAccessCarePlanInput;
}>;


export type PlatformEditAccessCarePlanMutation = { __typename?: 'Mutation', editAccessCarePlan: { __typename?: 'AccessCarePlan', id: string, accessEnrollmentId: string, healthieUserId: string, version: number, status: PlatformAccessCarePlanStatus, track: PlatformAccessTrack, schemaVersion: number, contentJson: any, renderedMarkdown: string, validationPassed: boolean, requiresAttention: boolean, generationValidationMessages: Array<string>, baselineApprovalBlockedReasons: Array<string>, generatedAt: any, generatedBy: string, approvedAt?: any | null, approvedBy?: string | null, advisories: Array<{ __typename?: 'AccessCarePlanAdvisory', rule: string, detail: string, codes: Array<string>, assignedTrack: PlatformAccessTrack, impliedTrack: PlatformAccessTrack }>, approvalBlocks: { __typename?: 'AccessCarePlanApprovalBlocks', status: PlatformAccessCarePlanApprovalBlockStatus, blocks: Array<{ __typename?: 'AccessCarePlanApprovalBlock', reason: string, message: string, advisory: { __typename?: 'AccessCarePlanAdvisory', rule: string, detail: string, codes: Array<string>, assignedTrack: PlatformAccessTrack, impliedTrack: PlatformAccessTrack } }> }, medicationReview?: { __typename?: 'AccessCarePlanMedicationReview', historyAvailable: boolean, undatedHistoryCount: number, history: Array<{ __typename?: 'AccessCarePlanMedicationReviewItem', name: string, dosage?: string | null, status?: string | null, recordedAt?: string | null, source: string }>, programPrescriptions: Array<{ __typename?: 'AccessCarePlanMedicationReviewItem', name: string, dosage?: string | null, status?: string | null, recordedAt?: string | null, source: string }> } | null } };

export type PlatformAssignAccessNpMutationVariables = Exact<{
  input: PlatformAssignAccessNpInput;
}>;


export type PlatformAssignAccessNpMutation = { __typename?: 'Mutation', assignAccessNp: { __typename?: 'AssignAccessNpPayload', accessEnrollmentId: string, assignedNpProviderId?: string | null } };

export type PlatformAccessDiagnosisOptionsQueryVariables = Exact<{
  track: PlatformAccessTrack;
}>;


export type PlatformAccessDiagnosisOptionsQuery = { __typename?: 'Query', accessDiagnosisOptions: { __typename?: 'AccessDiagnosisCatalog', track: PlatformAccessTrack, version: string, options: Array<{ __typename?: 'AccessDiagnosisOption', code: string, display: string }> } };

export type PlatformChangeAppointmentStatusMutationVariables = Exact<{
  input: PlatformChangeAppointmentStatusInput;
}>;


export type PlatformChangeAppointmentStatusMutation = { __typename?: 'Mutation', changeAppointmentStatus:
    | { __typename: 'AppointmentNotFoundError', appointmentHealthieId: string, message: string }
    | { __typename: 'AppointmentStatusChanged', appointmentHealthieId: string, status: any, cascadeEligible: boolean, cancelledFutureAppointmentHealthieIds: Array<string> }
   };

export type PlatformAppointmentProviderTimeZoneQueryVariables = Exact<{
  appointmentId: Scalars['ID']['input'];
}>;


export type PlatformAppointmentProviderTimeZoneQuery = { __typename?: 'Query', appointmentProviderTimeZone?: string | null };

export type PlatformCreateChartingNoteDraftMutationVariables = Exact<{
  input: PlatformCreateEhrChartingNoteDraftInput;
}>;


export type PlatformCreateChartingNoteDraftMutation = { __typename?: 'Mutation', createEhrChartingNoteDraft: { __typename?: 'CreateEhrChartingNoteDraftPayload', chartingNoteId: string, authoredBy?: PlatformEhrChartingNoteAuthor | null } };

export type PlatformSubmitChartingNoteMutationVariables = Exact<{
  input: PlatformSubmitEhrChartingNoteInput;
}>;


export type PlatformSubmitChartingNoteMutation = { __typename?: 'Mutation', submitEhrChartingNote: { __typename?: 'SubmitEhrChartingNotePayload', chartingNoteId: string, authoredBy: PlatformEhrChartingNoteAuthor, content: PlatformEhrChartingNoteContentOutcome, hasProviderSignature: boolean, isLocked: boolean, signOutcome: PlatformEhrChartingNoteStepOutcome, lockOutcome: PlatformEhrChartingNoteStepOutcome } };

export type PlatformChartingItemsByPatientQueryVariables = Exact<{
  patient: PlatformEhrVitalsPatientInput;
}>;


export type PlatformChartingItemsByPatientQuery = { __typename?: 'Query', ehrChartingItems: Array<{ __typename?: 'EhrChartingItem', id: string, chartingNote?: { __typename?: 'EhrChartingNote', id: string, name?: string | null, createdAt: string, metadata?: string | null, formAnswers: Array<{ __typename?: 'EhrChartingNoteAnswer', answer?: string | null, label?: string | null }>, appointment?: { __typename?: 'EhrChartingNoteAppointment', id: string, date?: string | null, appointmentTypeName?: string | null } | null } | null }> };

export type PlatformChartingNoteDetailQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type PlatformChartingNoteDetailQuery = { __typename?: 'Query', ehrChartingNote?: { __typename?: 'EhrChartingNote', id: string, name?: string | null, createdAt: string, formAnswers: Array<{ __typename?: 'EhrChartingNoteAnswer', id: string, label?: string | null, answer?: string | null, displayedAnswer?: string | null, customModuleId?: string | null, customModuleLabel?: string | null, customModuleModType?: string | null }>, appointment?: { __typename?: 'EhrChartingNoteAppointment', id: string, date?: string | null, pmStatus?: string | null } | null, patient?: { __typename?: 'EhrChartingNotePatient', id: string, firstName?: string | null, lastName?: string | null } | null } | null };

export type PlatformChartingNoteForSubmissionQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type PlatformChartingNoteForSubmissionQuery = { __typename?: 'Query', ehrChartingNote?: { __typename?: 'EhrChartingNote', id: string, isLocked: boolean, formAnswers: Array<{ __typename?: 'EhrChartingNoteAnswer', id: string, label?: string | null, answer?: string | null, customModuleId?: string | null, userId?: string | null }>, signings: Array<{ __typename?: 'EhrChartingNoteSigning', userId?: string | null }> } | null };

export type PlatformGlp1IntakeNotesQueryVariables = Exact<{
  input: PlatformEhrChartingNotesInput;
}>;


export type PlatformGlp1IntakeNotesQuery = { __typename?: 'Query', ehrChartingNotes: Array<{ __typename?: 'EhrChartingNote', id: string, formAnswers: Array<{ __typename?: 'EhrChartingNoteAnswer', label?: string | null, answer?: string | null }> }> };

export type PlatformGetChatTokenQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type PlatformGetChatTokenQuery = { __typename?: 'Query', chatToken: { __typename?: 'StreamChatCredentials', apiKey: string, token: string } };

export type PlatformGetChatChannelQueryVariables = Exact<{
  providerId: Scalars['String']['input'];
  patientId: Scalars['String']['input'];
}>;


export type PlatformGetChatChannelQuery = { __typename?: 'Query', chatChannel: { __typename?: 'ChatChannel', channelId: string, members: Array<{ __typename?: 'ChatChannelMember', streamUserId: string, accountRole: string }> } };

export type PlatformSendChatMessageMutationVariables = Exact<{
  input: PlatformSendChatMessageInput;
}>;


export type PlatformSendChatMessageMutation = { __typename?: 'Mutation', sendChatMessage: { __typename?: 'SendChatMessagePayload', messageId: string, channelId: string } };

export type PlatformCrossSellBookingOfferQueryVariables = Exact<{
  sourceAppointmentHealthieId: Scalars['ID']['input'];
  patientHealthieId: Scalars['ID']['input'];
}>;


export type PlatformCrossSellBookingOfferQuery = { __typename?: 'Query', crossSellBookingOffer?: { __typename?: 'CrossSellBookingOffer', targetProgram: PlatformCrossSellTargetProgram, chatDeliveryCompleted: boolean, smsDeliveryCompleted: boolean, sentAt?: any | null } | null };

export type PlatformSendCrossSellBookingLinkMutationVariables = Exact<{
  sourceAppointmentHealthieId: Scalars['ID']['input'];
  patientHealthieId: Scalars['ID']['input'];
}>;


export type PlatformSendCrossSellBookingLinkMutation = { __typename?: 'Mutation', sendCrossSellBookingLink: { __typename?: 'CrossSellBookingLinkDelivery', chatStatus: PlatformCrossSellChatDeliveryStatus, smsStatus: PlatformCrossSellSmsDeliveryStatus } };

export type PlatformPrepareCrossSellBookingLinkMutationVariables = Exact<{
  sourceAppointmentHealthieId: Scalars['ID']['input'];
  patientHealthieId: Scalars['ID']['input'];
}>;


export type PlatformPrepareCrossSellBookingLinkMutation = { __typename?: 'Mutation', prepareCrossSellBookingLink: { __typename?: 'OnboardingEntryLink', startUrl: string } };

export type PlatformCreateDocumentRequestMutationVariables = Exact<{
  input: PlatformCreateDocumentRequestInput;
}>;


export type PlatformCreateDocumentRequestMutation = { __typename?: 'Mutation', createDocumentRequest: { __typename?: 'DocumentRequest', id: string, status: PlatformDocumentRequestStatus, requestText: string, createdAt: any, documentCount: number } };

export type PlatformUpdateDocumentRequestMutationVariables = Exact<{
  input: PlatformUpdateDocumentRequestInput;
}>;


export type PlatformUpdateDocumentRequestMutation = { __typename?: 'Mutation', updateDocumentRequest: { __typename?: 'DocumentRequest', id: string, status: PlatformDocumentRequestStatus, requestText: string, createdAt: any, documentCount: number } };

export type PlatformCloseDocumentRequestMutationVariables = Exact<{
  input: PlatformCloseDocumentRequestInput;
}>;


export type PlatformCloseDocumentRequestMutation = { __typename?: 'Mutation', closeDocumentRequest: { __typename?: 'DocumentRequest', id: string, status: PlatformDocumentRequestStatus, closedAt?: any | null } };

export type PlatformDocumentRequestDownloadUrlQueryVariables = Exact<{
  input: PlatformDocumentRequestDownloadInput;
}>;


export type PlatformDocumentRequestDownloadUrlQuery = { __typename?: 'Query', documentRequestDownloadUrl: { __typename?: 'DownloadUrlResponse', downloadUrl: string, expiresAt: any } };

export type PlatformFollowUpVisitsQueryVariables = Exact<{
  patient: PlatformInsurancePatientInput;
}>;


export type PlatformFollowUpVisitsQuery = { __typename?: 'Query', patientInsuranceDetails: { __typename?: 'PatientInsuranceDetails', insuranceAuthorization?: { __typename?: 'InsuranceAuthorization', visitsLeft?: string | null } | null, policies: Array<{ __typename?: 'InsurancePolicyDetails', authorization?: { __typename?: 'InsuranceAuthorization', visitsLeft?: string | null } | null }> } };

export type PlatformGetFoodEntriesQueryVariables = Exact<{
  input: PlatformGetFoodEntriesInput;
}>;


export type PlatformGetFoodEntriesQuery = { __typename?: 'Query', foodJournalEntries: Array<{ __typename?: 'FoodJournalEntry', id: string, mealType?: PlatformMealType | null, description?: string | null, imageUrl?: string | null, createdAt: any, emotions: Array<string>, nutritionalMetrics: Array<{ __typename?: 'NutritionalMetric', name: PlatformNutritionalMetricName, value: number, unit: string }> }> };

export type PlatformGetJournalDailyTotalsEntriesQueryVariables = Exact<{
  input: PlatformGetJournalEntriesInput;
}>;


export type PlatformGetJournalDailyTotalsEntriesQuery = { __typename?: 'Query', journalEntries: { __typename?: 'JournalEntryPage', entries: Array<
      | { __typename: 'ActivityJournalEntry', id: string, createdAt: any, value?: number | null }
      | { __typename: 'FoodJournalEntry', id: string, createdAt: any, nutritionalMetrics: Array<{ __typename?: 'NutritionalMetric', name: PlatformNutritionalMetricName, value: number }> }
      | { __typename: 'SleepDurationJournalEntry', id: string, createdAt: any, durationMinutes: number }
      | { __typename: 'StepsJournalEntry', id: string, createdAt: any, steps: number }
      | { __typename: 'StoolJournalEntry' }
      | { __typename: 'SymptomJournalEntry' }
      | { __typename: 'WaterIntakeJournalEntry', id: string, createdAt: any, amount?: number | null }
      | { __typename: 'WeightJournalEntry' }
    >, pageInfo: { __typename?: 'PageInfo', hasMore: boolean } } };

export type PlatformJournalEntryCommentFragment = { __typename?: 'EntryComment', id: string, content: string, createdAt: any, author: { __typename?: 'FoodEntryCommentAuthor', id: string, fullName: string, avatarUrl?: string | null } };

export type PlatformFoodJournalEntryFragment = { __typename?: 'FoodJournalEntry', id: string, createdBy: string, createdAt: any, timezone?: string | null, description?: string | null, mealType?: PlatformMealType | null, imageUrl?: string | null, emotions: Array<string>, comments: Array<{ __typename?: 'EntryComment', id: string, content: string, createdAt: any, author: { __typename?: 'FoodEntryCommentAuthor', id: string, fullName: string, avatarUrl?: string | null } }>, nutritionalMetrics: Array<{ __typename?: 'NutritionalMetric', name: PlatformNutritionalMetricName, value: number, unit: string }> };

export type PlatformWaterIntakeJournalEntryFragment = { __typename?: 'WaterIntakeJournalEntry', id: string, createdBy: string, createdAt: any, timezone?: string | null, description?: string | null, amount?: number | null, unit: string, comments: Array<{ __typename?: 'EntryComment', id: string, content: string, createdAt: any, author: { __typename?: 'FoodEntryCommentAuthor', id: string, fullName: string, avatarUrl?: string | null } }> };

export type PlatformSymptomJournalEntryFragment = { __typename?: 'SymptomJournalEntry', id: string, createdBy: string, createdAt: any, timezone?: string | null, description?: string | null, symptoms: Array<string>, symptomNames: Array<string>, comments: Array<{ __typename?: 'EntryComment', id: string, content: string, createdAt: any, author: { __typename?: 'FoodEntryCommentAuthor', id: string, fullName: string, avatarUrl?: string | null } }> };

export type PlatformStoolJournalEntryFragment = { __typename?: 'StoolJournalEntry', id: string, createdBy: string, createdAt: any, timezone?: string | null, description?: string | null, bristolScale?: number | null, comments: Array<{ __typename?: 'EntryComment', id: string, content: string, createdAt: any, author: { __typename?: 'FoodEntryCommentAuthor', id: string, fullName: string, avatarUrl?: string | null } }> };

export type PlatformWeightJournalEntryFragment = { __typename?: 'WeightJournalEntry', id: string, createdBy: string, createdAt: any, timezone?: string | null, description?: string | null, value?: number | null, unit: string, comments: Array<{ __typename?: 'EntryComment', id: string, content: string, createdAt: any, author: { __typename?: 'FoodEntryCommentAuthor', id: string, fullName: string, avatarUrl?: string | null } }> };

export type PlatformActivityJournalEntryFragment = { __typename?: 'ActivityJournalEntry', id: string, createdBy: string, createdAt: any, timezone?: string | null, description?: string | null, value?: number | null, unit: string, comments: Array<{ __typename?: 'EntryComment', id: string, content: string, createdAt: any, author: { __typename?: 'FoodEntryCommentAuthor', id: string, fullName: string, avatarUrl?: string | null } }> };

export type PlatformGetJournalEntriesQueryVariables = Exact<{
  input: PlatformGetJournalEntriesInput;
}>;


export type PlatformGetJournalEntriesQuery = { __typename?: 'Query', journalEntries: { __typename?: 'JournalEntryPage', entries: Array<
      | { __typename: 'ActivityJournalEntry', id: string, createdBy: string, createdAt: any, timezone?: string | null, description?: string | null, value?: number | null, unit: string, comments: Array<{ __typename?: 'EntryComment', id: string, content: string, createdAt: any, author: { __typename?: 'FoodEntryCommentAuthor', id: string, fullName: string, avatarUrl?: string | null } }> }
      | { __typename: 'FoodJournalEntry', id: string, createdBy: string, createdAt: any, timezone?: string | null, description?: string | null, mealType?: PlatformMealType | null, imageUrl?: string | null, emotions: Array<string>, comments: Array<{ __typename?: 'EntryComment', id: string, content: string, createdAt: any, author: { __typename?: 'FoodEntryCommentAuthor', id: string, fullName: string, avatarUrl?: string | null } }>, nutritionalMetrics: Array<{ __typename?: 'NutritionalMetric', name: PlatformNutritionalMetricName, value: number, unit: string }> }
      | { __typename: 'SleepDurationJournalEntry' }
      | { __typename: 'StepsJournalEntry' }
      | { __typename: 'StoolJournalEntry', id: string, createdBy: string, createdAt: any, timezone?: string | null, description?: string | null, bristolScale?: number | null, comments: Array<{ __typename?: 'EntryComment', id: string, content: string, createdAt: any, author: { __typename?: 'FoodEntryCommentAuthor', id: string, fullName: string, avatarUrl?: string | null } }> }
      | { __typename: 'SymptomJournalEntry', id: string, createdBy: string, createdAt: any, timezone?: string | null, description?: string | null, symptoms: Array<string>, symptomNames: Array<string>, comments: Array<{ __typename?: 'EntryComment', id: string, content: string, createdAt: any, author: { __typename?: 'FoodEntryCommentAuthor', id: string, fullName: string, avatarUrl?: string | null } }> }
      | { __typename: 'WaterIntakeJournalEntry', id: string, createdBy: string, createdAt: any, timezone?: string | null, description?: string | null, amount?: number | null, unit: string, comments: Array<{ __typename?: 'EntryComment', id: string, content: string, createdAt: any, author: { __typename?: 'FoodEntryCommentAuthor', id: string, fullName: string, avatarUrl?: string | null } }> }
      | { __typename: 'WeightJournalEntry', id: string, createdBy: string, createdAt: any, timezone?: string | null, description?: string | null, value?: number | null, unit: string, comments: Array<{ __typename?: 'EntryComment', id: string, content: string, createdAt: any, author: { __typename?: 'FoodEntryCommentAuthor', id: string, fullName: string, avatarUrl?: string | null } }> }
    >, pageInfo: { __typename?: 'PageInfo', hasMore: boolean } } };

export type PlatformProviderPortalGlucoseHistoryQueryVariables = Exact<{
  input: PlatformGlucoseHistoryInput;
}>;


export type PlatformProviderPortalGlucoseHistoryQuery = { __typename?: 'Query', glucoseReadings: Array<{ __typename?: 'GlucoseReading', value: number, unit: string, observedAt: any, source?: PlatformGlucoseSource | null }> };

export type PlatformSearchIcdCodesQueryVariables = Exact<{
  keywords: Scalars['String']['input'];
}>;


export type PlatformSearchIcdCodesQuery = { __typename?: 'Query', searchIcdCodes: Array<{ __typename?: 'IcdCode', id: string, code: string, displayName?: string | null }> };

export type PlatformPatientsAwaitingDocumentsQueryVariables = Exact<{ [key: string]: never; }>;


export type PlatformPatientsAwaitingDocumentsQuery = { __typename?: 'Query', patientsAwaitingDocuments: Array<{ __typename?: 'PatientAwaitingDocuments', patientHealthieId: string, documentRequestIds: Array<string> }> };

export type PlatformLabAlertPatientDocumentsQueryVariables = Exact<{
  patient: PlatformDocumentPatientInput;
  documentType?: InputMaybe<PlatformDocumentType>;
}>;


export type PlatformLabAlertPatientDocumentsQuery = { __typename?: 'Query', patientDocuments: Array<{ __typename?: 'Document', id: string, confirmedAt?: any | null, ehrDocumentId?: string | null, documentRequest?: { __typename?: 'DocumentRequest', id: string, status: PlatformDocumentRequestStatus } | null }> };

export type PlatformPatientEhrDocumentsQueryVariables = Exact<{
  patient: PlatformEhrDocumentPatientInput;
}>;


export type PlatformPatientEhrDocumentsQuery = { __typename?: 'Query', ehrDocuments: Array<{ __typename?: 'EhrDocument', id: string, displayName?: string | null, contentType?: string | null, createdAt: any }> };

export type PlatformLabDocumentFragment = { __typename?: 'Document', id: string, documentType: PlatformDocumentType, filename: string, mimeType: string, fileSize: number, healthieUserId: string, createdAt: any, confirmedAt?: any | null };

export type PlatformGetPatientLabDocumentsQueryVariables = Exact<{
  patient: PlatformDocumentPatientInput;
  documentType?: InputMaybe<PlatformDocumentType>;
}>;


export type PlatformGetPatientLabDocumentsQuery = { __typename?: 'Query', patientDocuments: Array<{ __typename?: 'Document', id: string, documentType: PlatformDocumentType, filename: string, mimeType: string, fileSize: number, healthieUserId: string, createdAt: any, confirmedAt?: any | null }> };

export type PlatformGetPatientLabDocumentDownloadUrlQueryVariables = Exact<{
  input: PlatformPatientDocumentDownloadInput;
}>;


export type PlatformGetPatientLabDocumentDownloadUrlQuery = { __typename?: 'Query', patientDocumentDownloadUrl?: { __typename?: 'DownloadUrlResponse', downloadUrl: string, expiresAt: any } | null };

export type PlatformLabResultFragment = { __typename?: 'Measurement', code: string, display?: string | null, value?: number | null, valueText?: string | null, unit?: string | null, effectiveAt?: any | null, source: string, referenceLow?: number | null, referenceHigh?: number | null, referenceText?: string | null, interpretation?: string | null };

export type PlatformPatientLabsQueryVariables = Exact<{
  patientHealthieId: Scalars['String']['input'];
  tests: Array<PlatformClinicalLabTest> | PlatformClinicalLabTest;
  limit: Scalars['Int']['input'];
}>;


export type PlatformPatientLabsQuery = { __typename?: 'Query', patientByExternalId?: { __typename?: 'Patient', labTestHistories: Array<{ __typename?: 'ClinicalLabTestHistory', test: PlatformClinicalLabTest, results: Array<{ __typename?: 'Measurement', code: string, display?: string | null, value?: number | null, valueText?: string | null, unit?: string | null, effectiveAt?: any | null, source: string, referenceLow?: number | null, referenceHigh?: number | null, referenceText?: string | null, interpretation?: string | null }> }> } | null };

export type PlatformMedicareBridgeChecklistFieldsFragment = { __typename?: 'MedicareBridgeChecklist', version: string, protocolDocumentSlug?: string | null, handoffSteps: Array<string>, partDDenialRequired: boolean, nextRoutes: Array<{ __typename?: 'MedicareBridgeChecklistOption', value: string, label: string }>, items: Array<{ __typename?: 'MedicareBridgeChecklistItem', key: string, label: string, kind: PlatformMedicareBridgeChecklistItemKind, required: boolean, requiredWhen?: { __typename?: 'MedicareBridgeChecklistRequirement', key: string, numberGte?: number | null, numberLt?: number | null, includesAny: Array<string> } | null, options: Array<{ __typename?: 'MedicareBridgeChecklistOption', value: string, label: string }> }> };

export type PlatformMedicareBridgeCaseQueryVariables = Exact<{
  patientHealthieId: Scalars['ID']['input'];
}>;


export type PlatformMedicareBridgeCaseQuery = { __typename?: 'Query', medicareBridgeCase?: { __typename?: 'MedicareBridgeCase', id: string, patientHealthieId: string, status: PlatformMedicareBridgeCaseStatus, identification: PlatformMedicareBridgeIdentification, eligibilityReview: PlatformMedicareBridgeEligibilityReview, medicationAccess: PlatformMedicareBridgeMedicationAccess, closeReason?: string | null, ownerTeam?: string | null, nextAction?: string | null, blocker?: string | null, blockerNote?: string | null, assignedUserId?: string | null, snoozedUntil?: any | null, reviewSubmissionEnabled: boolean, outstandingRequirements: Array<string>, checklist: { __typename?: 'MedicareBridgeChecklist', version: string, protocolDocumentSlug?: string | null, handoffSteps: Array<string>, partDDenialRequired: boolean, nextRoutes: Array<{ __typename?: 'MedicareBridgeChecklistOption', value: string, label: string }>, items: Array<{ __typename?: 'MedicareBridgeChecklistItem', key: string, label: string, kind: PlatformMedicareBridgeChecklistItemKind, required: boolean, requiredWhen?: { __typename?: 'MedicareBridgeChecklistRequirement', key: string, numberGte?: number | null, numberLt?: number | null, includesAny: Array<string> } | null, options: Array<{ __typename?: 'MedicareBridgeChecklistOption', value: string, label: string }> }> }, priorAuthorizations: Array<{ __typename?: 'PriorAuthorization', id: string, status: PlatformPriorAuthorizationStatus, product: PlatformGlp1Product, submittedAt: any, outcome?: { __typename?: 'PaOutcome', result: PlatformPaOutcomeResult } | null }>, prescriptions: Array<{ __typename?: 'MedicationProgramPrescription', id: string, status: PlatformPrescriptionStatus, drugDisplayName?: string | null, prescribedAt?: any | null }>, latestReview?: { __typename?: 'MedicareBridgeReview', id: string, decision: PlatformMedicareBridgeReviewDecision, checklistVersion: string, nextRoute?: string | null, unresolvedItems: Array<string>, note?: string | null, createdAt: any, providerHealthieId: string, responses: any, checklist: { __typename?: 'MedicareBridgeChecklist', version: string, protocolDocumentSlug?: string | null, handoffSteps: Array<string>, partDDenialRequired: boolean, nextRoutes: Array<{ __typename?: 'MedicareBridgeChecklistOption', value: string, label: string }>, items: Array<{ __typename?: 'MedicareBridgeChecklistItem', key: string, label: string, kind: PlatformMedicareBridgeChecklistItemKind, required: boolean, requiredWhen?: { __typename?: 'MedicareBridgeChecklistRequirement', key: string, numberGte?: number | null, numberLt?: number | null, includesAny: Array<string> } | null, options: Array<{ __typename?: 'MedicareBridgeChecklistOption', value: string, label: string }> }> } } | null } | null };

export type PlatformSubmitMedicareBridgeReviewMutationVariables = Exact<{
  input: PlatformSubmitMedicareBridgeReviewInput;
}>;


export type PlatformSubmitMedicareBridgeReviewMutation = { __typename?: 'Mutation', submitMedicareBridgeReview: { __typename?: 'SubmitMedicareBridgeReviewPayload', medicareBridgeCase: { __typename?: 'MedicareBridgeCase', id: string, identification: PlatformMedicareBridgeIdentification, eligibilityReview: PlatformMedicareBridgeEligibilityReview, status: PlatformMedicareBridgeCaseStatus, reviewSubmissionEnabled: boolean, outstandingRequirements: Array<string>, checklist: { __typename?: 'MedicareBridgeChecklist', version: string, protocolDocumentSlug?: string | null, handoffSteps: Array<string>, partDDenialRequired: boolean, nextRoutes: Array<{ __typename?: 'MedicareBridgeChecklistOption', value: string, label: string }>, items: Array<{ __typename?: 'MedicareBridgeChecklistItem', key: string, label: string, kind: PlatformMedicareBridgeChecklistItemKind, required: boolean, requiredWhen?: { __typename?: 'MedicareBridgeChecklistRequirement', key: string, numberGte?: number | null, numberLt?: number | null, includesAny: Array<string> } | null, options: Array<{ __typename?: 'MedicareBridgeChecklistOption', value: string, label: string }> }> }, latestReview?: { __typename?: 'MedicareBridgeReview', id: string, decision: PlatformMedicareBridgeReviewDecision, checklistVersion: string, nextRoute?: string | null, unresolvedItems: Array<string>, note?: string | null, createdAt: any, providerHealthieId: string, responses: any, checklist: { __typename?: 'MedicareBridgeChecklist', version: string, protocolDocumentSlug?: string | null, handoffSteps: Array<string>, partDDenialRequired: boolean, nextRoutes: Array<{ __typename?: 'MedicareBridgeChecklistOption', value: string, label: string }>, items: Array<{ __typename?: 'MedicareBridgeChecklistItem', key: string, label: string, kind: PlatformMedicareBridgeChecklistItemKind, required: boolean, requiredWhen?: { __typename?: 'MedicareBridgeChecklistRequirement', key: string, numberGte?: number | null, numberLt?: number | null, includesAny: Array<string> } | null, options: Array<{ __typename?: 'MedicareBridgeChecklistOption', value: string, label: string }> }> } } | null } } };

export type PlatformGetMedicationsQueryVariables = Exact<{
  filters: PlatformMedicationFiltersInput;
}>;


export type PlatformGetMedicationsQuery = { __typename?: 'Query', medications: Array<{ __typename?: 'Medication', id: string, name: string, dosage?: string | null, directions?: string | null, isActive: boolean, startDate?: string | null, endDate?: string | null }> };

export type PlatformPatientNutrientGoalsFragment = { __typename?: 'PatientNutrientGoals', id: string, patientId: string, updatedAt: any, goals: Array<{ __typename?: 'NutrientGoal', type: PlatformNutrientType, quantity: number, unit: string }> };

export type PlatformGetPatientNutrientGoalsQueryVariables = Exact<{
  patientId: Scalars['ID']['input'];
}>;


export type PlatformGetPatientNutrientGoalsQuery = { __typename?: 'Query', patientNutrientGoals?: { __typename?: 'PatientNutrientGoals', id: string, patientId: string, updatedAt: any, goals: Array<{ __typename?: 'NutrientGoal', type: PlatformNutrientType, quantity: number, unit: string }> } | null };

export type PlatformUpsertPatientNutrientGoalsMutationVariables = Exact<{
  input: PlatformUpsertPatientNutrientGoalsInput;
}>;


export type PlatformUpsertPatientNutrientGoalsMutation = { __typename?: 'Mutation', upsertPatientNutrientGoals: { __typename?: 'PatientNutrientGoals', id: string, patientId: string, updatedAt: any, goals: Array<{ __typename?: 'NutrientGoal', type: PlatformNutrientType, quantity: number, unit: string }> } };

export type PlatformPatientDocumentFileQueryVariables = Exact<{
  documentId: Scalars['ID']['input'];
}>;


export type PlatformPatientDocumentFileQuery = { __typename?: 'Query', patientDocumentFile?: { __typename?: 'PatientDocumentFile', url?: string | null } | null };

export type PlatformCreatePatientDocumentMutationVariables = Exact<{
  input: PlatformCreatePatientDocumentInput;
}>;


export type PlatformCreatePatientDocumentMutation = { __typename?: 'Mutation', createPatientDocument: string };

export type PlatformPatientDrawerZusProfileQueryVariables = Exact<{
  patientHealthieId: Scalars['String']['input'];
}>;


export type PlatformPatientDrawerZusProfileQuery = { __typename?: 'Query', patientByExternalId?: { __typename?: 'Patient', externalId?: { __typename?: 'PatientExternalId', externalId: string } | null } | null };

export type PlatformMedicationProgramPrescriptionsByPatientQueryVariables = Exact<{
  patientHealthieId: Scalars['ID']['input'];
}>;


export type PlatformMedicationProgramPrescriptionsByPatientQuery = { __typename?: 'Query', medicationProgramPrescriptionsByPatient: Array<{ __typename?: 'MedicationProgramPrescription', id: string, status: PlatformPrescriptionStatus, prescribedAt?: any | null, effectiveAt?: any | null, daysSupply?: number | null, drugDisplayName?: string | null, source: string }> };

export type PlatformGlp1IntakeByPatientDrawerQueryVariables = Exact<{
  patientHealthieId: Scalars['ID']['input'];
}>;


export type PlatformGlp1IntakeByPatientDrawerQuery = { __typename?: 'Query', glp1IntakeByPatient?: { __typename?: 'Glp1IntakeRecord', verdict: PlatformGlp1EligibilityVerdict, verdictReasons: Array<string>, bmiAtScreening: number, screeningAnswers: any, diagnoses: Array<{ __typename?: 'Diagnosis', code: string }> } | null };

export type PlatformGlp1IntakeByPatientBasicQueryVariables = Exact<{
  patientHealthieId: Scalars['ID']['input'];
}>;


export type PlatformGlp1IntakeByPatientBasicQuery = { __typename?: 'Query', glp1IntakeByPatient?: { __typename?: 'Glp1IntakeRecord', verdict: PlatformGlp1EligibilityVerdict, verdictReasons: Array<string>, bmiAtScreening: number, diagnoses: Array<{ __typename?: 'Diagnosis', code: string }> } | null };

export type PlatformEhrPrescriptionsQueryVariables = Exact<{
  patient: PlatformEhrDocumentPatientInput;
}>;


export type PlatformEhrPrescriptionsQuery = { __typename?: 'Query', ehrPrescriptions: Array<{ __typename?: 'EhrPrescription', id: string, displayName?: string | null, dosage?: string | null, dateWritten?: string | null, effectiveDate?: string | null, dateInactive?: string | null, pharmacyName?: string | null }> };

export type PlatformPatientInsuranceDetailsQueryVariables = Exact<{
  patient: PlatformInsurancePatientInput;
}>;


export type PlatformPatientInsuranceDetailsQuery = { __typename?: 'Query', patientInsuranceDetails: { __typename?: 'PatientInsuranceDetails', hasSelfPay?: boolean | null, policies: Array<{ __typename?: 'InsurancePolicyDetails', priority?: string | null, notes?: string | null, benefits?: Array<{ __typename?: 'InsuranceBenefit', copay?: string | null, coinsurance?: string | null, deductibleCalendarYear?: string | null, deductibleYearToDate?: string | null, telemedicine?: boolean | null }> | null, authorization?: { __typename?: 'InsuranceAuthorization', startOn?: string | null, endOn?: string | null, visitsAuthorized?: string | null, visitsLeft?: string | null, visitsUsed?: string | null } | null, plan?: { __typename?: 'InsurancePlan', payerName?: string | null, payerId?: string | null } | null }> } };

export type PlatformPatientRegistryIdByHealthieIdQueryVariables = Exact<{
  patientHealthieId: Scalars['String']['input'];
}>;


export type PlatformPatientRegistryIdByHealthieIdQuery = { __typename?: 'Query', patientByExternalId?: { __typename?: 'Patient', id: string } | null };

export type PlatformPatientUserGroupQueryVariables = Exact<{
  patient: PlatformInsurancePatientInput;
}>;


export type PlatformPatientUserGroupQuery = { __typename?: 'Query', patientInsuranceDetails: { __typename?: 'PatientInsuranceDetails', userGroup?: { __typename?: 'InsuranceUserGroup', id: string, name?: string | null } | null } };

export type PlatformPayerPoliciesQueryVariables = Exact<{
  patient: PlatformInsurancePatientInput;
}>;


export type PlatformPayerPoliciesQuery = { __typename?: 'Query', patientInsurancePolicies: Array<{ __typename?: 'InsurancePolicy', priority?: string | null, plan?: { __typename?: 'InsurancePlan', payerId?: string | null } | null }> };

export type PlatformPaymentProfileQueryVariables = Exact<{
  patientId: Scalars['ID']['input'];
}>;


export type PlatformPaymentProfileQuery = { __typename?: 'Query', paymentProfile: { __typename?: 'PaymentProfile', savedCard?: { __typename?: 'SavedCard', brand: string, last4: string, expMonth: number, expYear: number, isValid: boolean } | null } };

export type PlatformPatientStateForPhotonPrescriberNoteQueryVariables = Exact<{
  patientHealthieId: Scalars['String']['input'];
}>;


export type PlatformPatientStateForPhotonPrescriberNoteQuery = { __typename?: 'Query', patientByExternalId?: { __typename?: 'Patient', state?: string | null } | null };

export type PlatformGlp1MedicationOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type PlatformGlp1MedicationOptionsQuery = { __typename?: 'Query', glp1MedicationOptions: Array<{ __typename?: 'Glp1MedicationOption', skuId: string, product: PlatformGlp1Product, label: string, dose: string, packageType: string, quantity: number, ndc: string, defaultDirections: string }> };

export type PlatformBenefitsCheckByPatientQueryVariables = Exact<{
  patientHealthieId: Scalars['ID']['input'];
}>;


export type PlatformBenefitsCheckByPatientQuery = { __typename?: 'Query', benefitsCheckByPatient?: { __typename?: 'BenefitsCheck', id: string, status: PlatformBenefitsCheckStatus, diagnoses: Array<{ __typename?: 'Diagnosis', code: string }>, drugResults: Array<{ __typename?: 'DrugBenefitsResult', product: PlatformGlp1Product, ndc?: string | null, coverage: PlatformDrugCoverage, coverageDetailCode?: string | null, priorAuthRequired: PlatformPaRequirement, copayDisplay?: string | null, determinationDetails?: { __typename?: 'DeterminationDetails', isOnFormulary?: boolean | null, isExplicitPlanExclusion?: boolean | null, isPriorAuthActingAsExceptionRequest?: boolean | null } | null, copayOptions: Array<{ __typename?: 'CopayOption', amountCents: number, supplyDurationDays?: number | null }> }> } | null };

export type PlatformMedicationProgramEnrollmentByPatientQueryVariables = Exact<{
  patientHealthieId: Scalars['ID']['input'];
}>;


export type PlatformMedicationProgramEnrollmentByPatientQuery = { __typename?: 'Query', medicationProgramEnrollmentByPatient?: { __typename?: 'MedicationProgramEnrollment', id: string, patientHealthieId: string, assignedProviderHealthieId?: string | null, status: PlatformMedicationProgramEnrollmentStatus, provisionedAt?: any | null, lastSyncedToPhotonAt?: any | null, patient?: { __typename?: 'Patient', externalId?: { __typename?: 'PatientExternalId', externalId: string } | null } | null } | null };

export type PlatformRecordGlp1NotPrescribedDecisionMutationVariables = Exact<{
  input: PlatformRecordGlp1NotPrescribedDecisionInput;
}>;


export type PlatformRecordGlp1NotPrescribedDecisionMutation = { __typename?: 'Mutation', recordGlp1NotPrescribedDecision: { __typename?: 'PrescriptionReviewDecision', id: string, decision: string, reason?: string | null, decidedAt: any } };

export type PlatformClearGlp1NotPrescribedDecisionMutationVariables = Exact<{
  input: PlatformClearGlp1NotPrescribedDecisionInput;
}>;


export type PlatformClearGlp1NotPrescribedDecisionMutation = { __typename?: 'Mutation', clearGlp1NotPrescribedDecision: { __typename?: 'PrescriptionReviewDecision', id: string, decision: string, reason?: string | null, decidedAt: any } };

export type PlatformSetGlp1PatientPrescriberNotesMutationVariables = Exact<{
  input: PlatformSetGlp1PatientPrescriberNotesInput;
}>;


export type PlatformSetGlp1PatientPrescriberNotesMutation = { __typename?: 'Mutation', setGlp1PatientPrescriberNotes: { __typename?: 'Glp1PatientPrescriberNotesPayload', patientHealthieId: string, providerHealthieId: string, notes?: string | null } };

export type PlatformSubmitGlp1PriorAuthMutationVariables = Exact<{
  input: PlatformSubmitGlp1PriorAuthInput;
}>;


export type PlatformSubmitGlp1PriorAuthMutation = { __typename?: 'Mutation', submitGlp1PriorAuth:
    | { __typename: 'ActivePriorAuthorizationConflict', reason: PlatformActivePriorAuthorizationConflictReason, drugName: string, existingPriorAuthorization: { __typename?: 'PriorAuthorization', id: string, status: PlatformPriorAuthorizationStatus } }
    | { __typename: 'BridgeProductNotAllowed', message: string }
    | { __typename: 'BridgeReviewRequired', message: string }
    | { __typename: 'DuplicateBridgePriorAuth', message: string }
    | { __typename: 'PriorAuthorization', id: string, status: PlatformPriorAuthorizationStatus, patientHealthieId: string, submittedAt: any }
   };

export type PlatformPriorAuthsByPatientQueryVariables = Exact<{
  patientHealthieId: Scalars['ID']['input'];
}>;


export type PlatformPriorAuthsByPatientQuery = { __typename?: 'Query', priorAuthsByPatient: Array<{ __typename?: 'PriorAuthorization', id: string, status: PlatformPriorAuthorizationStatus, product: PlatformGlp1Product, productSkuId?: string | null, benefitsCheckId?: string | null, submittedAt: any, completedAt?: any | null, failureCode?: string | null, failureMessage?: string | null, notSubmittedReason?: string | null, diagnoses: Array<{ __typename?: 'Diagnosis', code: string }>, denialReasonAnalysis?: { __typename?: 'PaDenialReasonAnalysis', categories: Array<string>, explanation?: string | null, nextSteps?: string | null, nextStepsExplanation?: string | null } | null, outcome?: { __typename?: 'PaOutcome', result: PlatformPaOutcomeResult, detail?: string | null, detailCode?: string | null, approvalDate?: any | null, expirationDate?: any | null, copayOptions: Array<{ __typename?: 'CopayOption', amountCents: number, supplyDurationDays?: number | null }> } | null }> };

export type PlatformPrescriptionReviewPriorAuthFragment = { __typename?: 'PrescriptionReviewPriorAuth', id: string, status: PlatformPriorAuthorizationStatus, outcomeResult?: PlatformPaOutcomeResult | null, outcomeDetailCode?: string | null, outcomeDetailMessage?: string | null, submittedAt: any, completedAt?: any | null };

export type PlatformPrescriptionReviewPrescriptionFragment = { __typename?: 'MedicationProgramPrescription', id: string, status: PlatformPrescriptionStatus, prescribedAt?: any | null, drugDisplayName?: string | null, source: string };

export type PlatformPrescriptionReviewDecisionFragment = { __typename?: 'PrescriptionReviewDecision', id: string, decision: string, reason?: string | null, decidedAt: any };

export type PlatformGlp1AppointmentFragment = { __typename?: 'Glp1Appointment', appointmentHealthieId: string, appointmentTypeHealthieId: string, date: any, patientHealthieId: string, providerHealthieId: string, status?: string | null };

export type PlatformPrescriptionReviewQueryVariables = Exact<{
  providerHealthieId: Scalars['ID']['input'];
  stage: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  patientHealthieIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type PlatformPrescriptionReviewQuery = { __typename?: 'Query', prescriptionReview: { __typename?: 'PrescriptionReviewResult', totalCount: number, patients: Array<{ __typename?: 'PrescriptionReviewPatient', enrollmentId: string, patientHealthieId: string, enrolledAt: any, fullName?: string | null, dob?: string | null, stage: string, hasResolvedPriorAuth: boolean, prescriberNotes?: string | null, priorAuth?: { __typename?: 'PrescriptionReviewPriorAuth', id: string, status: PlatformPriorAuthorizationStatus, outcomeResult?: PlatformPaOutcomeResult | null, outcomeDetailCode?: string | null, outcomeDetailMessage?: string | null, submittedAt: any, completedAt?: any | null } | null, prescription?: { __typename?: 'MedicationProgramPrescription', id: string, status: PlatformPrescriptionStatus, prescribedAt?: any | null, drugDisplayName?: string | null, source: string } | null, decision?: { __typename?: 'PrescriptionReviewDecision', id: string, decision: string, reason?: string | null, decidedAt: any } | null, documentRequests: Array<{ __typename?: 'DocumentRequest', id: string, status: PlatformDocumentRequestStatus, requestText: string, createdAt: any, documentCount: number, documents: Array<{ __typename?: 'Document', id: string, documentType: PlatformDocumentType, filename: string, mimeType: string, fileSize: number, confirmedAt?: any | null }> }>, lastOccurredGlp1Appointment?: { __typename?: 'Glp1Appointment', appointmentHealthieId: string, appointmentTypeHealthieId: string, date: any, patientHealthieId: string, providerHealthieId: string, status?: string | null } | null }>, stageCounts: { __typename?: 'PrescriptionReviewStageCounts', needsDecision: number, paStatus: number, prescribed: number, notPrescribed: number, awaitingInformation: number } } };

export type PlatformGlp1PrescriptionTaskFragment = { __typename?: 'Glp1PrescriptionTask', id: string, appointmentHealthieId: string, status: PlatformGlp1PrescriptionTaskStatus, outcome?: PlatformGlp1PrescriptionTaskOutcome | null, skipReason?: string | null, priorAuthorizationId?: string | null, completedAt?: any | null };

export type PlatformGlp1PrescriptionTaskAppointmentFragment = { __typename?: 'Glp1Appointment', appointmentHealthieId: string, appointmentTypeHealthieId: string, date: any, patientHealthieId: string, providerHealthieId: string, status?: string | null };

export type PlatformGlp1PrescriptionTaskPatientFragment = { __typename?: 'MedicationProgramPatient', patientHealthieId: string, fullName?: string | null };

export type PlatformGlp1PrescriptionTaskPrescriptionFragment = { __typename?: 'MedicationProgramPrescription', id: string, status: PlatformPrescriptionStatus, prescribedAt?: any | null, drugDisplayName?: string | null, source: string };

export type PlatformGlp1PrescriptionTaskBenefitsCheckFragment = { __typename?: 'BenefitsCheck', id: string, status: PlatformBenefitsCheckStatus, diagnoses: Array<{ __typename?: 'Diagnosis', code: string }>, drugResults: Array<{ __typename?: 'DrugBenefitsResult', product: PlatformGlp1Product, ndc?: string | null, coverage: PlatformDrugCoverage, coverageDetailCode?: string | null, priorAuthRequired: PlatformPaRequirement, copayDisplay?: string | null, determinationDetails?: { __typename?: 'DeterminationDetails', isOnFormulary?: boolean | null, isExplicitPlanExclusion?: boolean | null, isPriorAuthActingAsExceptionRequest?: boolean | null } | null, copayOptions: Array<{ __typename?: 'CopayOption', amountCents: number, supplyDurationDays?: number | null }> }> };

export type PlatformGlp1PrescriptionTasksQueryVariables = Exact<{
  providerHealthieId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PlatformGlp1PrescriptionTasksQuery = { __typename?: 'Query', glp1PrescriptionTasks: { __typename?: 'Glp1PrescriptionTasksResult', totalCount: number, tasks: Array<{ __typename?: 'Glp1PrescriptionTaskListItem', task: { __typename?: 'Glp1PrescriptionTask', id: string, appointmentHealthieId: string, status: PlatformGlp1PrescriptionTaskStatus, outcome?: PlatformGlp1PrescriptionTaskOutcome | null, skipReason?: string | null, priorAuthorizationId?: string | null, completedAt?: any | null }, appointment: { __typename?: 'Glp1Appointment', appointmentHealthieId: string, appointmentTypeHealthieId: string, date: any, patientHealthieId: string, providerHealthieId: string, status?: string | null }, patient: { __typename?: 'MedicationProgramPatient', patientHealthieId: string, fullName?: string | null } }> } };

export type PlatformGlp1PrescriptionTaskContextQueryVariables = Exact<{
  taskId: Scalars['ID']['input'];
}>;


export type PlatformGlp1PrescriptionTaskContextQuery = { __typename?: 'Query', glp1PrescriptionTaskContext: { __typename?: 'Glp1PrescriptionTaskContext', task: { __typename?: 'Glp1PrescriptionTask', id: string, appointmentHealthieId: string, status: PlatformGlp1PrescriptionTaskStatus, outcome?: PlatformGlp1PrescriptionTaskOutcome | null, skipReason?: string | null, priorAuthorizationId?: string | null, completedAt?: any | null }, appointment: { __typename?: 'Glp1Appointment', appointmentHealthieId: string, appointmentTypeHealthieId: string, date: any, patientHealthieId: string, providerHealthieId: string, status?: string | null }, patient: { __typename?: 'MedicationProgramPatient', patientHealthieId: string, fullName?: string | null }, priorAuthorizations: Array<{ __typename?: 'PriorAuthorization', id: string, status: PlatformPriorAuthorizationStatus, product: PlatformGlp1Product, productSkuId?: string | null, benefitsCheckId?: string | null, submittedAt: any, completedAt?: any | null, failureCode?: string | null, failureMessage?: string | null, notSubmittedReason?: string | null, diagnoses: Array<{ __typename?: 'Diagnosis', code: string }>, denialReasonAnalysis?: { __typename?: 'PaDenialReasonAnalysis', categories: Array<string>, explanation?: string | null, nextSteps?: string | null, nextStepsExplanation?: string | null } | null, outcome?: { __typename?: 'PaOutcome', result: PlatformPaOutcomeResult, detail?: string | null, detailCode?: string | null, approvalDate?: any | null, expirationDate?: any | null, copayOptions: Array<{ __typename?: 'CopayOption', amountCents: number, supplyDurationDays?: number | null }> } | null }>, prescriptions: Array<{ __typename?: 'MedicationProgramPrescription', id: string, status: PlatformPrescriptionStatus, prescribedAt?: any | null, drugDisplayName?: string | null, source: string }>, benefitsCheck?: { __typename?: 'BenefitsCheck', id: string, status: PlatformBenefitsCheckStatus, diagnoses: Array<{ __typename?: 'Diagnosis', code: string }>, drugResults: Array<{ __typename?: 'DrugBenefitsResult', product: PlatformGlp1Product, ndc?: string | null, coverage: PlatformDrugCoverage, coverageDetailCode?: string | null, priorAuthRequired: PlatformPaRequirement, copayDisplay?: string | null, determinationDetails?: { __typename?: 'DeterminationDetails', isOnFormulary?: boolean | null, isExplicitPlanExclusion?: boolean | null, isPriorAuthActingAsExceptionRequest?: boolean | null } | null, copayOptions: Array<{ __typename?: 'CopayOption', amountCents: number, supplyDurationDays?: number | null }> }> } | null } };

export type PlatformCompleteGlp1PrescriptionTaskMutationVariables = Exact<{
  input: PlatformCompleteGlp1PrescriptionTaskInput;
}>;


export type PlatformCompleteGlp1PrescriptionTaskMutation = { __typename?: 'Mutation', completeGlp1PrescriptionTask: { __typename?: 'Glp1PrescriptionTask', id: string, appointmentHealthieId: string, status: PlatformGlp1PrescriptionTaskStatus, outcome?: PlatformGlp1PrescriptionTaskOutcome | null, skipReason?: string | null, priorAuthorizationId?: string | null, completedAt?: any | null } };

export type PlatformPriorAuthorizationDetailFragment = { __typename?: 'PriorAuthorization', id: string, status: PlatformPriorAuthorizationStatus, product: PlatformGlp1Product, productSkuId?: string | null, benefitsCheckId?: string | null, submittedAt: any, completedAt?: any | null, failureCode?: string | null, failureMessage?: string | null, notSubmittedReason?: string | null, diagnoses: Array<{ __typename?: 'Diagnosis', code: string }>, denialReasonAnalysis?: { __typename?: 'PaDenialReasonAnalysis', categories: Array<string>, explanation?: string | null, nextSteps?: string | null, nextStepsExplanation?: string | null } | null, outcome?: { __typename?: 'PaOutcome', result: PlatformPaOutcomeResult, detail?: string | null, detailCode?: string | null, approvalDate?: any | null, expirationDate?: any | null, copayOptions: Array<{ __typename?: 'CopayOption', amountCents: number, supplyDurationDays?: number | null }> } | null };

export type PlatformGetProviderBookingSettingsQueryVariables = Exact<{
  healthieProviderId: Scalars['ID']['input'];
}>;


export type PlatformGetProviderBookingSettingsQuery = { __typename?: 'Query', providerBookingSettings: { __typename?: 'ProviderBookingSettings', sameDayBookingEnabled: boolean, minimumNoticeMinutes?: number | null } };

export type PlatformUpdateProviderBookingSettingsMutationVariables = Exact<{
  input: PlatformUpdateProviderBookingSettingsInput;
}>;


export type PlatformUpdateProviderBookingSettingsMutation = { __typename?: 'Mutation', updateProviderBookingSettings: { __typename?: 'UpdateProviderBookingSettingsPayload', appliedImmediately: boolean, settings: { __typename?: 'ProviderBookingSettings', sameDayBookingEnabled: boolean, minimumNoticeMinutes?: number | null } } };

export type PlatformAssignedProviderDocumentsQueryVariables = Exact<{ [key: string]: never; }>;


export type PlatformAssignedProviderDocumentsQuery = { __typename?: 'Query', assignedProviderDocuments: Array<{ __typename?: 'AssignedProviderDocument', status: PlatformAttestationStatus, attestedAt?: any | null, document: { __typename?: 'ProviderDocument', id: string, title: string, required: boolean, currentVersion: { __typename?: 'ProviderDocumentVersion', id: string, versionLabel: string, publishedAt?: any | null } } }> };

export type PlatformProviderDocumentFileAccessQueryVariables = Exact<{
  documentId: Scalars['ID']['input'];
}>;


export type PlatformProviderDocumentFileAccessQuery = { __typename?: 'Query', providerDocumentFileAccess:
    | { __typename: 'ProviderDocumentFile', documentId: string, versionId: string, versionLabel: string, contentType: string, downloadUrl: string, expiresAt: any }
    | { __typename: 'ProviderDocumentFileUnavailable', documentId: string, versionId: string, versionLabel: string }
   };

export type PlatformAttestDocumentVersionMutationVariables = Exact<{
  input: PlatformAttestDocumentVersionInput;
}>;


export type PlatformAttestDocumentVersionMutation = { __typename?: 'Mutation', attestDocumentVersion:
    | { __typename: 'AttestationRecorded', documentId: string, versionId: string, versionLabel: string, attestedAt: any, alreadyAttested: boolean }
    | { __typename: 'DocumentVersionSupersededError', message: string, documentId: string, currentVersion: { __typename?: 'ProviderDocumentVersion', id: string, versionLabel: string, publishedAt?: any | null } }
   };

export type PlatformProviderEventIdentityQueryVariables = Exact<{
  clerkUserId: Scalars['String']['input'];
}>;


export type PlatformProviderEventIdentityQuery = { __typename?: 'Query', providerByExternalId?: { __typename?: 'Provider', id: string, status: PlatformProviderStatus } | null };

export type PlatformProviderOrganizationByHealthieIdQueryVariables = Exact<{
  providerHealthieId: Scalars['String']['input'];
}>;


export type PlatformProviderOrganizationByHealthieIdQuery = { __typename?: 'Query', providerByExternalId?: { __typename?: 'Provider', id: string, organization?: { __typename?: 'ProviderOrganization', externalIds: Array<{ __typename?: 'ProviderOrganizationExternalId', system: PlatformProviderOrganizationExternalSystem, externalId: string }> } | null } | null };

export type PlatformSessionGoalFragment = { __typename?: 'SessionGoal', id: string, patientId: string, content: string, appointmentId?: string | null, parentGoalId?: string | null, rootGoalId?: string | null, isActive: boolean, isComplete: boolean, archivedAt?: any | null, completedAt?: any | null, completedByRole?: PlatformCompletedByRole | null, createdAt: any, updatedAt: any };

export type PlatformGetSessionGoalsQueryVariables = Exact<{
  patientId: Scalars['ID']['input'];
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  includeCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  appointmentId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type PlatformGetSessionGoalsQuery = { __typename?: 'Query', sessionGoals: Array<{ __typename?: 'SessionGoal', id: string, patientId: string, content: string, appointmentId?: string | null, parentGoalId?: string | null, rootGoalId?: string | null, isActive: boolean, isComplete: boolean, archivedAt?: any | null, completedAt?: any | null, completedByRole?: PlatformCompletedByRole | null, createdAt: any, updatedAt: any }> };

export type PlatformGetSessionGoalQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type PlatformGetSessionGoalQuery = { __typename?: 'Query', sessionGoal?: { __typename?: 'SessionGoal', id: string, patientId: string, content: string, appointmentId?: string | null, parentGoalId?: string | null, rootGoalId?: string | null, isActive: boolean, isComplete: boolean, archivedAt?: any | null, completedAt?: any | null, completedByRole?: PlatformCompletedByRole | null, createdAt: any, updatedAt: any } | null };

export type PlatformUpsertSessionGoalMutationVariables = Exact<{
  input: PlatformUpsertSessionGoalInput;
}>;


export type PlatformUpsertSessionGoalMutation = { __typename?: 'Mutation', upsertSessionGoal: { __typename?: 'SessionGoal', id: string, patientId: string, content: string, appointmentId?: string | null, parentGoalId?: string | null, rootGoalId?: string | null, isActive: boolean, isComplete: boolean, archivedAt?: any | null, completedAt?: any | null, completedByRole?: PlatformCompletedByRole | null, createdAt: any, updatedAt: any } };

export type PlatformMarkSessionGoalCompleteMutationVariables = Exact<{
  input: PlatformMarkSessionGoalCompleteInput;
}>;


export type PlatformMarkSessionGoalCompleteMutation = { __typename?: 'Mutation', markSessionGoalComplete: { __typename?: 'SessionGoal', id: string, patientId: string, content: string, appointmentId?: string | null, parentGoalId?: string | null, rootGoalId?: string | null, isActive: boolean, isComplete: boolean, archivedAt?: any | null, completedAt?: any | null, completedByRole?: PlatformCompletedByRole | null, createdAt: any, updatedAt: any } };

export type PlatformSupportMessageFieldsFragment = { __typename?: 'SupportMessage', id: string, body: string, html: string, authorName: string, fromProvider: boolean, isInitial: boolean, createdAt: number, attachments: Array<{ __typename?: 'SupportAttachment', name: string, url: string }> };

export type PlatformSupportConversationFieldsFragment = { __typename?: 'SupportConversation', id: string, title: string, state: PlatformSupportConversationState, read?: boolean | null, patientId?: string | null, resolvedAt?: number | null, updatedAt: number, historyTruncated: boolean, messages: Array<{ __typename?: 'SupportMessage', id: string, body: string, html: string, authorName: string, fromProvider: boolean, isInitial: boolean, createdAt: number, attachments: Array<{ __typename?: 'SupportAttachment', name: string, url: string }> }> };

export type PlatformSupportAvailabilityQueryVariables = Exact<{ [key: string]: never; }>;


export type PlatformSupportAvailabilityQuery = { __typename?: 'Query', supportAvailability: { __typename?: 'SupportAvailability', enabled: boolean, resolveEnabled: boolean, attachmentPolicy?: { __typename?: 'SupportAttachmentPolicy', maxFiles: number, maxFileBytes: number, maxTotalBytes: number, allowedContentTypes: Array<string> } | null } };

export type PlatformSupportConversationsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  unread?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type PlatformSupportConversationsQuery = { __typename?: 'Query', supportConversations: { __typename?: 'SupportConversationPage', nextCursor?: string | null, partial: boolean, conversations: Array<{ __typename?: 'SupportConversation', id: string, title: string, state: PlatformSupportConversationState, read?: boolean | null, patientId?: string | null, resolvedAt?: number | null, updatedAt: number, historyTruncated: boolean, messages: Array<{ __typename?: 'SupportMessage', id: string, body: string, html: string, authorName: string, fromProvider: boolean, isInitial: boolean, createdAt: number, attachments: Array<{ __typename?: 'SupportAttachment', name: string, url: string }> }> }>, error?: { __typename?: 'SupportError', code: PlatformSupportErrorCode, message: string } | null } };

export type PlatformSupportConversationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type PlatformSupportConversationQuery = { __typename?: 'Query', supportConversation: { __typename?: 'SupportConversationPayload', conversation?: { __typename?: 'SupportConversation', id: string, title: string, state: PlatformSupportConversationState, read?: boolean | null, patientId?: string | null, resolvedAt?: number | null, updatedAt: number, historyTruncated: boolean, messages: Array<{ __typename?: 'SupportMessage', id: string, body: string, html: string, authorName: string, fromProvider: boolean, isInitial: boolean, createdAt: number, attachments: Array<{ __typename?: 'SupportAttachment', name: string, url: string }> }> } | null, error?: { __typename?: 'SupportError', code: PlatformSupportErrorCode, message: string } | null } };

export type PlatformPrepareSupportAttachmentMutationVariables = Exact<{
  input: PlatformPrepareSupportAttachmentInput;
}>;


export type PlatformPrepareSupportAttachmentMutation = { __typename?: 'Mutation', prepareSupportAttachment: { __typename?: 'PrepareSupportAttachmentPayload', upload?: { __typename?: 'SupportAttachmentUpload', attachmentId: string, uploadUrl: string, contentType: string, expiresAt: number } | null, error?: { __typename?: 'SupportError', code: PlatformSupportErrorCode, message: string } | null } };

export type PlatformCreateSupportConversationMutationVariables = Exact<{
  input: PlatformCreateSupportConversationInput;
}>;


export type PlatformCreateSupportConversationMutation = { __typename?: 'Mutation', createSupportConversation: { __typename?: 'CreateSupportConversationPayload', conversationId?: string | null, setupComplete: boolean, incompleteSteps: Array<string>, conversation?: { __typename?: 'SupportConversation', id: string, title: string, state: PlatformSupportConversationState, read?: boolean | null, patientId?: string | null, resolvedAt?: number | null, updatedAt: number, historyTruncated: boolean, messages: Array<{ __typename?: 'SupportMessage', id: string, body: string, html: string, authorName: string, fromProvider: boolean, isInitial: boolean, createdAt: number, attachments: Array<{ __typename?: 'SupportAttachment', name: string, url: string }> }> } | null, error?: { __typename?: 'SupportError', code: PlatformSupportErrorCode, message: string } | null } };

export type PlatformReplyToSupportConversationMutationVariables = Exact<{
  input: PlatformReplyToSupportConversationInput;
}>;


export type PlatformReplyToSupportConversationMutation = { __typename?: 'Mutation', replyToSupportConversation: { __typename?: 'ReplyToSupportConversationPayload', conversationId?: string | null, message?: { __typename?: 'SupportMessage', id: string, body: string, html: string, authorName: string, fromProvider: boolean, isInitial: boolean, createdAt: number, attachments: Array<{ __typename?: 'SupportAttachment', name: string, url: string }> } | null, error?: { __typename?: 'SupportError', code: PlatformSupportErrorCode, message: string } | null } };

export type PlatformMarkSupportConversationReadMutationVariables = Exact<{
  input: PlatformMarkSupportConversationReadInput;
}>;


export type PlatformMarkSupportConversationReadMutation = { __typename?: 'Mutation', markSupportConversationRead: { __typename?: 'MarkSupportConversationReadPayload', conversation?: { __typename?: 'SupportConversation', id: string, title: string, state: PlatformSupportConversationState, read?: boolean | null, patientId?: string | null, resolvedAt?: number | null, updatedAt: number, historyTruncated: boolean, messages: Array<{ __typename?: 'SupportMessage', id: string, body: string, html: string, authorName: string, fromProvider: boolean, isInitial: boolean, createdAt: number, attachments: Array<{ __typename?: 'SupportAttachment', name: string, url: string }> }> } | null, error?: { __typename?: 'SupportError', code: PlatformSupportErrorCode, message: string } | null } };

export type PlatformResolveSupportConversationMutationVariables = Exact<{
  input: PlatformResolveSupportConversationInput;
}>;


export type PlatformResolveSupportConversationMutation = { __typename?: 'Mutation', resolveSupportConversation: { __typename?: 'ResolveSupportConversationPayload', conversation?: { __typename?: 'SupportConversation', id: string, title: string, state: PlatformSupportConversationState, read?: boolean | null, patientId?: string | null, resolvedAt?: number | null, updatedAt: number, historyTruncated: boolean, messages: Array<{ __typename?: 'SupportMessage', id: string, body: string, html: string, authorName: string, fromProvider: boolean, isInitial: boolean, createdAt: number, attachments: Array<{ __typename?: 'SupportAttachment', name: string, url: string }> }> } | null, error?: { __typename?: 'SupportError', code: PlatformSupportErrorCode, message: string } | null } };

export type PlatformEhrWeightEntriesQueryVariables = Exact<{
  input: PlatformEhrWeightEntriesInput;
}>;


export type PlatformEhrWeightEntriesQuery = { __typename?: 'Query', ehrWeightEntries: Array<{ __typename?: 'EhrWeightEntry', metricStat?: number | null, createdAt?: string | null }> };

export type PlatformEhrHeightWeightQueryVariables = Exact<{
  patient: PlatformEhrVitalsPatientInput;
}>;


export type PlatformEhrHeightWeightQuery = { __typename?: 'Query', ehrHeightWeight?: { __typename?: 'EhrHeightWeight', weight?: string | null, height?: string | null } | null };

export const AccessCarePlanMedicationReviewFragmentDoc = gql`
    fragment AccessCarePlanMedicationReviewFragment on AccessCarePlan {
  medicationReview {
    historyAvailable
    undatedHistoryCount
    history {
      name
      dosage
      status
      recordedAt
      source
    }
    programPrescriptions {
      name
      dosage
      status
      recordedAt
      source
    }
  }
}
    `;
export const JournalEntryCommentFragmentDoc = gql`
    fragment JournalEntryComment on EntryComment {
  id
  content
  createdAt
  author {
    id
    fullName
    avatarUrl
  }
}
    `;
export const FoodJournalEntryFragmentDoc = gql`
    fragment FoodJournalEntryFragment on FoodJournalEntry {
  id
  createdBy
  createdAt
  timezone
  description
  mealType
  imageUrl
  emotions
  comments {
    ...JournalEntryComment
  }
  nutritionalMetrics {
    name
    value
    unit
  }
}
    ${JournalEntryCommentFragmentDoc}`;
export const WaterIntakeJournalEntryFragmentDoc = gql`
    fragment WaterIntakeJournalEntryFragment on WaterIntakeJournalEntry {
  id
  createdBy
  createdAt
  timezone
  description
  amount
  unit
  comments {
    ...JournalEntryComment
  }
}
    ${JournalEntryCommentFragmentDoc}`;
export const SymptomJournalEntryFragmentDoc = gql`
    fragment SymptomJournalEntryFragment on SymptomJournalEntry {
  id
  createdBy
  createdAt
  timezone
  description
  symptoms
  symptomNames
  comments {
    ...JournalEntryComment
  }
}
    ${JournalEntryCommentFragmentDoc}`;
export const StoolJournalEntryFragmentDoc = gql`
    fragment StoolJournalEntryFragment on StoolJournalEntry {
  id
  createdBy
  createdAt
  timezone
  description
  bristolScale
  comments {
    ...JournalEntryComment
  }
}
    ${JournalEntryCommentFragmentDoc}`;
export const WeightJournalEntryFragmentDoc = gql`
    fragment WeightJournalEntryFragment on WeightJournalEntry {
  id
  createdBy
  createdAt
  timezone
  description
  value
  unit
  comments {
    ...JournalEntryComment
  }
}
    ${JournalEntryCommentFragmentDoc}`;
export const ActivityJournalEntryFragmentDoc = gql`
    fragment ActivityJournalEntryFragment on ActivityJournalEntry {
  id
  createdBy
  createdAt
  timezone
  description
  value
  unit
  comments {
    ...JournalEntryComment
  }
}
    ${JournalEntryCommentFragmentDoc}`;
export const LabDocumentFragmentDoc = gql`
    fragment LabDocumentFragment on Document {
  id
  documentType
  filename
  mimeType
  fileSize
  healthieUserId
  createdAt
  confirmedAt
}
    `;
export const LabResultFragmentDoc = gql`
    fragment LabResult on Measurement {
  code
  display
  value
  valueText
  unit
  effectiveAt
  source
  referenceLow
  referenceHigh
  referenceText
  interpretation
}
    `;
export const MedicareBridgeChecklistFieldsFragmentDoc = gql`
    fragment MedicareBridgeChecklistFields on MedicareBridgeChecklist {
  version
  protocolDocumentSlug
  handoffSteps
  partDDenialRequired
  nextRoutes {
    value
    label
  }
  items {
    key
    label
    kind
    required
    requiredWhen {
      key
      numberGte
      numberLt
      includesAny
    }
    options {
      value
      label
    }
  }
}
    `;
export const PatientNutrientGoalsFragmentDoc = gql`
    fragment PatientNutrientGoalsFragment on PatientNutrientGoals {
  id
  patientId
  goals {
    type
    quantity
    unit
  }
  updatedAt
}
    `;
export const PrescriptionReviewPriorAuthFragmentDoc = gql`
    fragment PrescriptionReviewPriorAuthFragment on PrescriptionReviewPriorAuth {
  id
  status
  outcomeResult
  outcomeDetailCode
  outcomeDetailMessage
  submittedAt
  completedAt
}
    `;
export const PrescriptionReviewPrescriptionFragmentDoc = gql`
    fragment PrescriptionReviewPrescriptionFragment on MedicationProgramPrescription {
  id
  status
  prescribedAt
  drugDisplayName
  source
}
    `;
export const PrescriptionReviewDecisionFragmentDoc = gql`
    fragment PrescriptionReviewDecisionFragment on PrescriptionReviewDecision {
  id
  decision
  reason
  decidedAt
}
    `;
export const Glp1AppointmentFragmentDoc = gql`
    fragment Glp1AppointmentFragment on Glp1Appointment {
  appointmentHealthieId
  appointmentTypeHealthieId
  date
  patientHealthieId
  providerHealthieId
  status
}
    `;
export const Glp1PrescriptionTaskFragmentDoc = gql`
    fragment Glp1PrescriptionTaskFragment on Glp1PrescriptionTask {
  id
  appointmentHealthieId
  status
  outcome
  skipReason
  priorAuthorizationId
  completedAt
}
    `;
export const Glp1PrescriptionTaskAppointmentFragmentDoc = gql`
    fragment Glp1PrescriptionTaskAppointmentFragment on Glp1Appointment {
  appointmentHealthieId
  appointmentTypeHealthieId
  date
  patientHealthieId
  providerHealthieId
  status
}
    `;
export const Glp1PrescriptionTaskPatientFragmentDoc = gql`
    fragment Glp1PrescriptionTaskPatientFragment on MedicationProgramPatient {
  patientHealthieId
  fullName
}
    `;
export const Glp1PrescriptionTaskPrescriptionFragmentDoc = gql`
    fragment Glp1PrescriptionTaskPrescriptionFragment on MedicationProgramPrescription {
  id
  status
  prescribedAt
  drugDisplayName
  source
}
    `;
export const Glp1PrescriptionTaskBenefitsCheckFragmentDoc = gql`
    fragment Glp1PrescriptionTaskBenefitsCheckFragment on BenefitsCheck {
  id
  status
  diagnoses {
    code
  }
  drugResults {
    product
    ndc
    coverage
    coverageDetailCode
    determinationDetails {
      isOnFormulary
      isExplicitPlanExclusion
      isPriorAuthActingAsExceptionRequest
    }
    priorAuthRequired
    copayDisplay
    copayOptions {
      amountCents
      supplyDurationDays
    }
  }
}
    `;
export const PriorAuthorizationDetailFragmentDoc = gql`
    fragment PriorAuthorizationDetailFragment on PriorAuthorization {
  id
  status
  product
  productSkuId
  benefitsCheckId
  diagnoses {
    code
  }
  submittedAt
  completedAt
  failureCode
  failureMessage
  notSubmittedReason
  denialReasonAnalysis {
    categories
    explanation
    nextSteps
    nextStepsExplanation
  }
  outcome {
    result
    detail
    detailCode
    approvalDate
    expirationDate
    copayOptions {
      amountCents
      supplyDurationDays
    }
  }
}
    `;
export const SessionGoalFragmentDoc = gql`
    fragment SessionGoalFragment on SessionGoal {
  id
  patientId
  content
  appointmentId
  parentGoalId
  rootGoalId
  isActive
  isComplete
  archivedAt
  completedAt
  completedByRole
  createdAt
  updatedAt
}
    `;
export const SupportMessageFieldsFragmentDoc = gql`
    fragment SupportMessageFields on SupportMessage {
  id
  body
  html
  authorName
  fromProvider
  isInitial
  createdAt
  attachments {
    name
    url
  }
}
    `;
export const SupportConversationFieldsFragmentDoc = gql`
    fragment SupportConversationFields on SupportConversation {
  id
  title
  state
  read
  patientId
  resolvedAt
  updatedAt
  historyTruncated
  messages {
    ...SupportMessageFields
  }
}
    ${SupportMessageFieldsFragmentDoc}`;
export const AccessNpReviewQueueDocument = gql`
    query accessNpReviewQueue($npProviderId: String!) {
  accessNpReviewQueue(npProviderId: $npProviderId) {
    accessEnrollmentId
    healthieUserId
    patientLegalFirstName
    patientLegalLastName
    patientDateOfBirth
    patientState
    memberIdLast4
    track
    alignmentDate
    baselineOapSubmissionCompletedAt
    latestCarePlan {
      id
      accessEnrollmentId
      healthieUserId
      version
      status
      track
      schemaVersion
      contentJson
      renderedMarkdown
      ...AccessCarePlanMedicationReviewFragment
      validationPassed
      requiresAttention
      generationValidationMessages
      baselineApprovalBlockedReasons
      advisories {
        rule
        detail
        codes
        assignedTrack
        impliedTrack
      }
      approvalBlocks {
        status
        blocks {
          reason
          message
          advisory {
            rule
            detail
            codes
            assignedTrack
            impliedTrack
          }
        }
      }
      generatedAt
      generatedBy
      approvedAt
      approvedBy
    }
  }
}
    ${AccessCarePlanMedicationReviewFragmentDoc}`;
export const ApproveAccessCarePlanDocument = gql`
    mutation approveAccessCarePlan($input: ApproveAccessCarePlanInput!) {
  approveAccessCarePlan(input: $input) {
    id
    accessEnrollmentId
    healthieUserId
    version
    status
    track
    schemaVersion
    contentJson
    renderedMarkdown
    ...AccessCarePlanMedicationReviewFragment
    validationPassed
    requiresAttention
    generationValidationMessages
    baselineApprovalBlockedReasons
    advisories {
      rule
      detail
      codes
      assignedTrack
      impliedTrack
    }
    approvalBlocks {
      status
      blocks {
        reason
        message
        advisory {
          rule
          detail
          codes
          assignedTrack
          impliedTrack
        }
      }
    }
    generatedAt
    generatedBy
    approvedAt
    approvedBy
  }
}
    ${AccessCarePlanMedicationReviewFragmentDoc}`;
export const EditAccessCarePlanDocument = gql`
    mutation editAccessCarePlan($input: EditAccessCarePlanInput!) {
  editAccessCarePlan(input: $input) {
    id
    accessEnrollmentId
    healthieUserId
    version
    status
    track
    schemaVersion
    contentJson
    renderedMarkdown
    ...AccessCarePlanMedicationReviewFragment
    validationPassed
    requiresAttention
    generationValidationMessages
    baselineApprovalBlockedReasons
    advisories {
      rule
      detail
      codes
      assignedTrack
      impliedTrack
    }
    approvalBlocks {
      status
      blocks {
        reason
        message
        advisory {
          rule
          detail
          codes
          assignedTrack
          impliedTrack
        }
      }
    }
    generatedAt
    generatedBy
    approvedAt
    approvedBy
  }
}
    ${AccessCarePlanMedicationReviewFragmentDoc}`;
export const AssignAccessNpDocument = gql`
    mutation assignAccessNp($input: AssignAccessNpInput!) {
  assignAccessNp(input: $input) {
    accessEnrollmentId
    assignedNpProviderId
  }
}
    `;
export const AccessDiagnosisOptionsDocument = gql`
    query accessDiagnosisOptions($track: AccessTrack!) {
  accessDiagnosisOptions(track: $track) {
    track
    version
    options {
      code
      display
    }
  }
}
    `;
export const ChangeAppointmentStatusDocument = gql`
    mutation changeAppointmentStatus($input: ChangeAppointmentStatusInput!) {
  changeAppointmentStatus(input: $input) {
    __typename
    ... on AppointmentStatusChanged {
      appointmentHealthieId
      status
      cascadeEligible
      cancelledFutureAppointmentHealthieIds
    }
    ... on AppointmentNotFoundError {
      appointmentHealthieId
      message
    }
  }
}
    `;
export const AppointmentProviderTimeZoneDocument = gql`
    query appointmentProviderTimeZone($appointmentId: ID!) {
  appointmentProviderTimeZone(appointmentId: $appointmentId)
}
    `;
export const CreateChartingNoteDraftDocument = gql`
    mutation createChartingNoteDraft($input: CreateEhrChartingNoteDraftInput!) {
  createEhrChartingNoteDraft(input: $input) {
    chartingNoteId
    authoredBy
  }
}
    `;
export const SubmitChartingNoteDocument = gql`
    mutation submitChartingNote($input: SubmitEhrChartingNoteInput!) {
  submitEhrChartingNote(input: $input) {
    chartingNoteId
    authoredBy
    content
    hasProviderSignature
    isLocked
    signOutcome
    lockOutcome
  }
}
    `;
export const ChartingItemsByPatientDocument = gql`
    query chartingItemsByPatient($patient: EhrVitalsPatientInput!) {
  ehrChartingItems(patient: $patient) {
    id
    chartingNote {
      id
      name
      createdAt
      metadata
      formAnswers {
        answer
        label
      }
      appointment {
        id
        date
        appointmentTypeName
      }
    }
  }
}
    `;
export const ChartingNoteDetailDocument = gql`
    query chartingNoteDetail($id: ID!) {
  ehrChartingNote(id: $id) {
    id
    name
    createdAt
    formAnswers {
      id
      label
      answer
      displayedAnswer
      customModuleId
      customModuleLabel
      customModuleModType
    }
    appointment {
      id
      date
      pmStatus
    }
    patient {
      id
      firstName
      lastName
    }
  }
}
    `;
export const ChartingNoteForSubmissionDocument = gql`
    query chartingNoteForSubmission($id: ID!) {
  ehrChartingNote(id: $id) {
    id
    isLocked
    formAnswers {
      id
      label
      answer
      customModuleId
      userId
    }
    signings {
      userId
    }
  }
}
    `;
export const Glp1IntakeNotesDocument = gql`
    query glp1IntakeNotes($input: EhrChartingNotesInput!) {
  ehrChartingNotes(input: $input) {
    id
    formAnswers {
      label
      answer
    }
  }
}
    `;
export const GetChatTokenDocument = gql`
    query getChatToken($userId: String!) {
  chatToken(userId: $userId) {
    apiKey
    token
  }
}
    `;
export const GetChatChannelDocument = gql`
    query getChatChannel($providerId: String!, $patientId: String!) {
  chatChannel(providerId: $providerId, patientId: $patientId) {
    channelId
    members {
      streamUserId
      accountRole
    }
  }
}
    `;
export const SendChatMessageDocument = gql`
    mutation sendChatMessage($input: SendChatMessageInput!) {
  sendChatMessage(input: $input) {
    messageId
    channelId
  }
}
    `;
export const CrossSellBookingOfferDocument = gql`
    query crossSellBookingOffer($sourceAppointmentHealthieId: ID!, $patientHealthieId: ID!) {
  crossSellBookingOffer(
    sourceAppointmentHealthieId: $sourceAppointmentHealthieId
    patientHealthieId: $patientHealthieId
  ) {
    targetProgram
    chatDeliveryCompleted
    smsDeliveryCompleted
    sentAt
  }
}
    `;
export const SendCrossSellBookingLinkDocument = gql`
    mutation sendCrossSellBookingLink($sourceAppointmentHealthieId: ID!, $patientHealthieId: ID!) {
  sendCrossSellBookingLink(
    sourceAppointmentHealthieId: $sourceAppointmentHealthieId
    patientHealthieId: $patientHealthieId
  ) {
    chatStatus
    smsStatus
  }
}
    `;
export const PrepareCrossSellBookingLinkDocument = gql`
    mutation prepareCrossSellBookingLink($sourceAppointmentHealthieId: ID!, $patientHealthieId: ID!) {
  prepareCrossSellBookingLink(
    sourceAppointmentHealthieId: $sourceAppointmentHealthieId
    patientHealthieId: $patientHealthieId
  ) {
    startUrl
  }
}
    `;
export const CreateDocumentRequestDocument = gql`
    mutation createDocumentRequest($input: CreateDocumentRequestInput!) {
  createDocumentRequest(input: $input) {
    id
    status
    requestText
    createdAt
    documentCount
  }
}
    `;
export const UpdateDocumentRequestDocument = gql`
    mutation updateDocumentRequest($input: UpdateDocumentRequestInput!) {
  updateDocumentRequest(input: $input) {
    id
    status
    requestText
    createdAt
    documentCount
  }
}
    `;
export const CloseDocumentRequestDocument = gql`
    mutation closeDocumentRequest($input: CloseDocumentRequestInput!) {
  closeDocumentRequest(input: $input) {
    id
    status
    closedAt
  }
}
    `;
export const DocumentRequestDownloadUrlDocument = gql`
    query documentRequestDownloadUrl($input: DocumentRequestDownloadInput!) {
  documentRequestDownloadUrl(input: $input) {
    downloadUrl
    expiresAt
  }
}
    `;
export const FollowUpVisitsDocument = gql`
    query followUpVisits($patient: InsurancePatientInput!) {
  patientInsuranceDetails(patient: $patient) {
    insuranceAuthorization {
      visitsLeft
    }
    policies {
      authorization {
        visitsLeft
      }
    }
  }
}
    `;
export const GetFoodEntriesDocument = gql`
    query getFoodEntries($input: GetFoodEntriesInput!) {
  foodJournalEntries(input: $input) {
    id
    mealType
    description
    imageUrl
    createdAt
    emotions
    nutritionalMetrics {
      name
      value
      unit
    }
  }
}
    `;
export const GetJournalDailyTotalsEntriesDocument = gql`
    query getJournalDailyTotalsEntries($input: GetJournalEntriesInput!) {
  journalEntries(input: $input) {
    entries {
      __typename
      ... on FoodJournalEntry {
        id
        createdAt
        nutritionalMetrics {
          name
          value
        }
      }
      ... on WaterIntakeJournalEntry {
        id
        createdAt
        amount
      }
      ... on ActivityJournalEntry {
        id
        createdAt
        value
      }
      ... on StepsJournalEntry {
        id
        createdAt
        steps
      }
      ... on SleepDurationJournalEntry {
        id
        createdAt
        durationMinutes
      }
    }
    pageInfo {
      hasMore
    }
  }
}
    `;
export const GetJournalEntriesDocument = gql`
    query getJournalEntries($input: GetJournalEntriesInput!) {
  journalEntries(input: $input) {
    entries {
      __typename
      ...FoodJournalEntryFragment
      ...WaterIntakeJournalEntryFragment
      ...SymptomJournalEntryFragment
      ...StoolJournalEntryFragment
      ...WeightJournalEntryFragment
      ...ActivityJournalEntryFragment
    }
    pageInfo {
      hasMore
    }
  }
}
    ${FoodJournalEntryFragmentDoc}
${WaterIntakeJournalEntryFragmentDoc}
${SymptomJournalEntryFragmentDoc}
${StoolJournalEntryFragmentDoc}
${WeightJournalEntryFragmentDoc}
${ActivityJournalEntryFragmentDoc}`;
export const ProviderPortalGlucoseHistoryDocument = gql`
    query ProviderPortalGlucoseHistory($input: GlucoseHistoryInput!) {
  glucoseReadings(input: $input) {
    value
    unit
    observedAt
    source
  }
}
    `;
export const SearchIcdCodesDocument = gql`
    query searchIcdCodes($keywords: String!) {
  searchIcdCodes(keywords: $keywords) {
    id
    code
    displayName
  }
}
    `;
export const PatientsAwaitingDocumentsDocument = gql`
    query patientsAwaitingDocuments {
  patientsAwaitingDocuments {
    patientHealthieId
    documentRequestIds
  }
}
    `;
export const LabAlertPatientDocumentsDocument = gql`
    query labAlertPatientDocuments($patient: DocumentPatientInput!, $documentType: DocumentType) {
  patientDocuments(patient: $patient, documentType: $documentType) {
    id
    confirmedAt
    ehrDocumentId
    documentRequest {
      id
      status
    }
  }
}
    `;
export const PatientEhrDocumentsDocument = gql`
    query patientEhrDocuments($patient: EhrDocumentPatientInput!) {
  ehrDocuments(patient: $patient) {
    id
    displayName
    contentType
    createdAt
  }
}
    `;
export const GetPatientLabDocumentsDocument = gql`
    query getPatientLabDocuments($patient: DocumentPatientInput!, $documentType: DocumentType) {
  patientDocuments(patient: $patient, documentType: $documentType) {
    ...LabDocumentFragment
  }
}
    ${LabDocumentFragmentDoc}`;
export const GetPatientLabDocumentDownloadUrlDocument = gql`
    query getPatientLabDocumentDownloadUrl($input: PatientDocumentDownloadInput!) {
  patientDocumentDownloadUrl(input: $input) {
    downloadUrl
    expiresAt
  }
}
    `;
export const PatientLabsDocument = gql`
    query patientLabs($patientHealthieId: String!, $tests: [ClinicalLabTest!]!, $limit: Int!) {
  patientByExternalId(system: HEALTHIE, externalId: $patientHealthieId) {
    labTestHistories(tests: $tests, limit: $limit) {
      test
      results {
        ...LabResult
      }
    }
  }
}
    ${LabResultFragmentDoc}`;
export const MedicareBridgeCaseDocument = gql`
    query MedicareBridgeCase($patientHealthieId: ID!) {
  medicareBridgeCase(patientHealthieId: $patientHealthieId) {
    id
    patientHealthieId
    status
    identification
    eligibilityReview
    medicationAccess
    closeReason
    ownerTeam
    nextAction
    blocker
    blockerNote
    assignedUserId
    snoozedUntil
    reviewSubmissionEnabled
    checklist {
      ...MedicareBridgeChecklistFields
    }
    outstandingRequirements
    priorAuthorizations {
      id
      status
      product
      submittedAt
      outcome {
        result
      }
    }
    prescriptions {
      id
      status
      drugDisplayName
      prescribedAt
    }
    latestReview {
      id
      decision
      checklistVersion
      nextRoute
      unresolvedItems
      note
      createdAt
      providerHealthieId
      responses
      checklist {
        ...MedicareBridgeChecklistFields
      }
    }
  }
}
    ${MedicareBridgeChecklistFieldsFragmentDoc}`;
export const SubmitMedicareBridgeReviewDocument = gql`
    mutation SubmitMedicareBridgeReview($input: SubmitMedicareBridgeReviewInput!) {
  submitMedicareBridgeReview(input: $input) {
    medicareBridgeCase {
      id
      identification
      eligibilityReview
      status
      reviewSubmissionEnabled
      checklist {
        ...MedicareBridgeChecklistFields
      }
      outstandingRequirements
      latestReview {
        id
        decision
        checklistVersion
        nextRoute
        unresolvedItems
        note
        createdAt
        providerHealthieId
        responses
        checklist {
          ...MedicareBridgeChecklistFields
        }
      }
    }
  }
}
    ${MedicareBridgeChecklistFieldsFragmentDoc}`;
export const GetMedicationsDocument = gql`
    query getMedications($filters: MedicationFiltersInput!) {
  medications(filters: $filters) {
    id
    name
    dosage
    directions
    isActive
    startDate
    endDate
  }
}
    `;
export const GetPatientNutrientGoalsDocument = gql`
    query getPatientNutrientGoals($patientId: ID!) {
  patientNutrientGoals(patientId: $patientId) {
    ...PatientNutrientGoalsFragment
  }
}
    ${PatientNutrientGoalsFragmentDoc}`;
export const UpsertPatientNutrientGoalsDocument = gql`
    mutation upsertPatientNutrientGoals($input: UpsertPatientNutrientGoalsInput!) {
  upsertPatientNutrientGoals(input: $input) {
    ...PatientNutrientGoalsFragment
  }
}
    ${PatientNutrientGoalsFragmentDoc}`;
export const PatientDocumentFileDocument = gql`
    query patientDocumentFile($documentId: ID!) {
  patientDocumentFile(documentId: $documentId) {
    url
  }
}
    `;
export const CreatePatientDocumentDocument = gql`
    mutation createPatientDocument($input: CreatePatientDocumentInput!) {
  createPatientDocument(input: $input)
}
    `;
export const PatientDrawerZusProfileDocument = gql`
    query patientDrawerZusProfile($patientHealthieId: String!) {
  patientByExternalId(system: HEALTHIE, externalId: $patientHealthieId) {
    externalId(system: ZUS_UPID) {
      externalId
    }
  }
}
    `;
export const MedicationProgramPrescriptionsByPatientDocument = gql`
    query medicationProgramPrescriptionsByPatient($patientHealthieId: ID!) {
  medicationProgramPrescriptionsByPatient(patientHealthieId: $patientHealthieId) {
    id
    status
    prescribedAt
    effectiveAt
    daysSupply
    drugDisplayName
    source
  }
}
    `;
export const Glp1IntakeByPatientDrawerDocument = gql`
    query glp1IntakeByPatientDrawer($patientHealthieId: ID!) {
  glp1IntakeByPatient(patientHealthieId: $patientHealthieId) {
    verdict
    verdictReasons
    bmiAtScreening
    screeningAnswers
    diagnoses {
      code
    }
  }
}
    `;
export const Glp1IntakeByPatientBasicDocument = gql`
    query glp1IntakeByPatientBasic($patientHealthieId: ID!) {
  glp1IntakeByPatient(patientHealthieId: $patientHealthieId) {
    verdict
    verdictReasons
    bmiAtScreening
    diagnoses {
      code
    }
  }
}
    `;
export const EhrPrescriptionsDocument = gql`
    query ehrPrescriptions($patient: EhrDocumentPatientInput!) {
  ehrPrescriptions(patient: $patient) {
    id
    displayName
    dosage
    dateWritten
    effectiveDate
    dateInactive
    pharmacyName
  }
}
    `;
export const PatientInsuranceDetailsDocument = gql`
    query patientInsuranceDetails($patient: InsurancePatientInput!) {
  patientInsuranceDetails(patient: $patient) {
    hasSelfPay
    policies {
      priority
      notes
      benefits {
        copay
        coinsurance
        deductibleCalendarYear
        deductibleYearToDate
        telemedicine
      }
      authorization {
        startOn
        endOn
        visitsAuthorized
        visitsLeft
        visitsUsed
      }
      plan {
        payerName
        payerId
      }
    }
  }
}
    `;
export const PatientRegistryIdByHealthieIdDocument = gql`
    query patientRegistryIdByHealthieId($patientHealthieId: String!) {
  patientByExternalId(system: HEALTHIE, externalId: $patientHealthieId) {
    id
  }
}
    `;
export const PatientUserGroupDocument = gql`
    query patientUserGroup($patient: InsurancePatientInput!) {
  patientInsuranceDetails(patient: $patient) {
    userGroup {
      id
      name
    }
  }
}
    `;
export const PayerPoliciesDocument = gql`
    query payerPolicies($patient: InsurancePatientInput!) {
  patientInsurancePolicies(patient: $patient) {
    priority
    plan {
      payerId
    }
  }
}
    `;
export const PaymentProfileDocument = gql`
    query paymentProfile($patientId: ID!) {
  paymentProfile(patientId: $patientId) {
    savedCard {
      brand
      last4
      expMonth
      expYear
      isValid
    }
  }
}
    `;
export const PatientStateForPhotonPrescriberNoteDocument = gql`
    query patientStateForPhotonPrescriberNote($patientHealthieId: String!) {
  patientByExternalId(system: HEALTHIE, externalId: $patientHealthieId) {
    state
  }
}
    `;
export const Glp1MedicationOptionsDocument = gql`
    query glp1MedicationOptions {
  glp1MedicationOptions {
    skuId
    product
    label
    dose
    packageType
    quantity
    ndc
    defaultDirections
  }
}
    `;
export const BenefitsCheckByPatientDocument = gql`
    query benefitsCheckByPatient($patientHealthieId: ID!) {
  benefitsCheckByPatient(patientHealthieId: $patientHealthieId) {
    id
    status
    diagnoses {
      code
    }
    drugResults {
      product
      ndc
      coverage
      coverageDetailCode
      determinationDetails {
        isOnFormulary
        isExplicitPlanExclusion
        isPriorAuthActingAsExceptionRequest
      }
      priorAuthRequired
      copayDisplay
      copayOptions {
        amountCents
        supplyDurationDays
      }
    }
  }
}
    `;
export const MedicationProgramEnrollmentByPatientDocument = gql`
    query medicationProgramEnrollmentByPatient($patientHealthieId: ID!) {
  medicationProgramEnrollmentByPatient(patientHealthieId: $patientHealthieId) {
    id
    patientHealthieId
    patient {
      externalId(system: PHOTON) {
        externalId
      }
    }
    assignedProviderHealthieId
    status
    provisionedAt
    lastSyncedToPhotonAt
  }
}
    `;
export const RecordGlp1NotPrescribedDecisionDocument = gql`
    mutation recordGlp1NotPrescribedDecision($input: RecordGlp1NotPrescribedDecisionInput!) {
  recordGlp1NotPrescribedDecision(input: $input) {
    id
    decision
    reason
    decidedAt
  }
}
    `;
export const ClearGlp1NotPrescribedDecisionDocument = gql`
    mutation clearGlp1NotPrescribedDecision($input: ClearGlp1NotPrescribedDecisionInput!) {
  clearGlp1NotPrescribedDecision(input: $input) {
    id
    decision
    reason
    decidedAt
  }
}
    `;
export const SetGlp1PatientPrescriberNotesDocument = gql`
    mutation setGlp1PatientPrescriberNotes($input: SetGlp1PatientPrescriberNotesInput!) {
  setGlp1PatientPrescriberNotes(input: $input) {
    patientHealthieId
    providerHealthieId
    notes
  }
}
    `;
export const SubmitGlp1PriorAuthDocument = gql`
    mutation submitGlp1PriorAuth($input: SubmitGlp1PriorAuthInput!) {
  submitGlp1PriorAuth(input: $input) {
    __typename
    ... on PriorAuthorization {
      id
      status
      patientHealthieId
      submittedAt
    }
    ... on ActivePriorAuthorizationConflict {
      reason
      drugName
      existingPriorAuthorization {
        id
        status
      }
    }
    ... on BridgeReviewRequired {
      message
    }
    ... on BridgeProductNotAllowed {
      message
    }
    ... on DuplicateBridgePriorAuth {
      message
    }
  }
}
    `;
export const PriorAuthsByPatientDocument = gql`
    query priorAuthsByPatient($patientHealthieId: ID!) {
  priorAuthsByPatient(patientHealthieId: $patientHealthieId) {
    ...PriorAuthorizationDetailFragment
  }
}
    ${PriorAuthorizationDetailFragmentDoc}`;
export const PrescriptionReviewDocument = gql`
    query prescriptionReview($providerHealthieId: ID!, $stage: String!, $page: Int, $pageSize: Int, $patientHealthieIds: [ID!]) {
  prescriptionReview(
    providerHealthieId: $providerHealthieId
    stage: $stage
    page: $page
    pageSize: $pageSize
    patientHealthieIds: $patientHealthieIds
  ) {
    patients {
      enrollmentId
      patientHealthieId
      enrolledAt
      fullName
      dob
      stage
      priorAuth {
        ...PrescriptionReviewPriorAuthFragment
      }
      prescription {
        ...PrescriptionReviewPrescriptionFragment
      }
      decision {
        ...PrescriptionReviewDecisionFragment
      }
      hasResolvedPriorAuth
      prescriberNotes
      documentRequests {
        id
        status
        requestText
        createdAt
        documentCount
        documents {
          id
          documentType
          filename
          mimeType
          fileSize
          confirmedAt
        }
      }
      lastOccurredGlp1Appointment {
        ...Glp1AppointmentFragment
      }
    }
    totalCount
    stageCounts {
      needsDecision
      paStatus
      prescribed
      notPrescribed
      awaitingInformation
    }
  }
}
    ${PrescriptionReviewPriorAuthFragmentDoc}
${PrescriptionReviewPrescriptionFragmentDoc}
${PrescriptionReviewDecisionFragmentDoc}
${Glp1AppointmentFragmentDoc}`;
export const Glp1PrescriptionTasksDocument = gql`
    query glp1PrescriptionTasks($providerHealthieId: ID!, $page: Int, $pageSize: Int) {
  glp1PrescriptionTasks(
    providerHealthieId: $providerHealthieId
    page: $page
    pageSize: $pageSize
  ) {
    totalCount
    tasks {
      task {
        ...Glp1PrescriptionTaskFragment
      }
      appointment {
        ...Glp1PrescriptionTaskAppointmentFragment
      }
      patient {
        ...Glp1PrescriptionTaskPatientFragment
      }
    }
  }
}
    ${Glp1PrescriptionTaskFragmentDoc}
${Glp1PrescriptionTaskAppointmentFragmentDoc}
${Glp1PrescriptionTaskPatientFragmentDoc}`;
export const Glp1PrescriptionTaskContextDocument = gql`
    query glp1PrescriptionTaskContext($taskId: ID!) {
  glp1PrescriptionTaskContext(taskId: $taskId) {
    task {
      ...Glp1PrescriptionTaskFragment
    }
    appointment {
      ...Glp1PrescriptionTaskAppointmentFragment
    }
    patient {
      ...Glp1PrescriptionTaskPatientFragment
    }
    priorAuthorizations {
      ...PriorAuthorizationDetailFragment
    }
    prescriptions {
      ...Glp1PrescriptionTaskPrescriptionFragment
    }
    benefitsCheck {
      ...Glp1PrescriptionTaskBenefitsCheckFragment
    }
  }
}
    ${Glp1PrescriptionTaskFragmentDoc}
${Glp1PrescriptionTaskAppointmentFragmentDoc}
${Glp1PrescriptionTaskPatientFragmentDoc}
${PriorAuthorizationDetailFragmentDoc}
${Glp1PrescriptionTaskPrescriptionFragmentDoc}
${Glp1PrescriptionTaskBenefitsCheckFragmentDoc}`;
export const CompleteGlp1PrescriptionTaskDocument = gql`
    mutation completeGlp1PrescriptionTask($input: CompleteGlp1PrescriptionTaskInput!) {
  completeGlp1PrescriptionTask(input: $input) {
    ...Glp1PrescriptionTaskFragment
  }
}
    ${Glp1PrescriptionTaskFragmentDoc}`;
export const GetProviderBookingSettingsDocument = gql`
    query getProviderBookingSettings($healthieProviderId: ID!) {
  providerBookingSettings(healthieProviderId: $healthieProviderId) {
    sameDayBookingEnabled
    minimumNoticeMinutes
  }
}
    `;
export const UpdateProviderBookingSettingsDocument = gql`
    mutation updateProviderBookingSettings($input: UpdateProviderBookingSettingsInput!) {
  updateProviderBookingSettings(input: $input) {
    settings {
      sameDayBookingEnabled
      minimumNoticeMinutes
    }
    appliedImmediately
  }
}
    `;
export const AssignedProviderDocumentsDocument = gql`
    query assignedProviderDocuments {
  assignedProviderDocuments {
    status
    attestedAt
    document {
      id
      title
      required
      currentVersion {
        id
        versionLabel
        publishedAt
      }
    }
  }
}
    `;
export const ProviderDocumentFileAccessDocument = gql`
    query providerDocumentFileAccess($documentId: ID!) {
  providerDocumentFileAccess(documentId: $documentId) {
    __typename
    ... on ProviderDocumentFile {
      documentId
      versionId
      versionLabel
      contentType
      downloadUrl
      expiresAt
    }
    ... on ProviderDocumentFileUnavailable {
      documentId
      versionId
      versionLabel
    }
  }
}
    `;
export const AttestDocumentVersionDocument = gql`
    mutation attestDocumentVersion($input: AttestDocumentVersionInput!) {
  attestDocumentVersion(input: $input) {
    __typename
    ... on AttestationRecorded {
      documentId
      versionId
      versionLabel
      attestedAt
      alreadyAttested
    }
    ... on DocumentVersionSupersededError {
      message
      documentId
      currentVersion {
        id
        versionLabel
        publishedAt
      }
    }
  }
}
    `;
export const ProviderEventIdentityDocument = gql`
    query ProviderEventIdentity($clerkUserId: String!) {
  providerByExternalId(system: CLERK_PROVIDER_PORTAL, externalId: $clerkUserId) {
    id
    status
  }
}
    `;
export const ProviderOrganizationByHealthieIdDocument = gql`
    query providerOrganizationByHealthieId($providerHealthieId: String!) {
  providerByExternalId(system: HEALTHIE, externalId: $providerHealthieId) {
    id
    organization {
      externalIds {
        system
        externalId
      }
    }
  }
}
    `;
export const GetSessionGoalsDocument = gql`
    query getSessionGoals($patientId: ID!, $includeArchived: Boolean, $includeCompleted: Boolean, $appointmentId: ID) {
  sessionGoals(
    filters: {patientId: $patientId, includeArchived: $includeArchived, includeCompleted: $includeCompleted, appointmentId: $appointmentId}
  ) {
    ...SessionGoalFragment
  }
}
    ${SessionGoalFragmentDoc}`;
export const GetSessionGoalDocument = gql`
    query getSessionGoal($id: ID!) {
  sessionGoal(id: $id) {
    ...SessionGoalFragment
  }
}
    ${SessionGoalFragmentDoc}`;
export const UpsertSessionGoalDocument = gql`
    mutation upsertSessionGoal($input: UpsertSessionGoalInput!) {
  upsertSessionGoal(input: $input) {
    ...SessionGoalFragment
  }
}
    ${SessionGoalFragmentDoc}`;
export const MarkSessionGoalCompleteDocument = gql`
    mutation markSessionGoalComplete($input: MarkSessionGoalCompleteInput!) {
  markSessionGoalComplete(input: $input) {
    ...SessionGoalFragment
  }
}
    ${SessionGoalFragmentDoc}`;
export const SupportAvailabilityDocument = gql`
    query SupportAvailability {
  supportAvailability {
    enabled
    resolveEnabled
    attachmentPolicy {
      maxFiles
      maxFileBytes
      maxTotalBytes
      allowedContentTypes
    }
  }
}
    `;
export const SupportConversationsDocument = gql`
    query SupportConversations($after: String, $unread: Boolean) {
  supportConversations(after: $after, unread: $unread) {
    conversations {
      ...SupportConversationFields
    }
    nextCursor
    partial
    error {
      code
      message
    }
  }
}
    ${SupportConversationFieldsFragmentDoc}`;
export const SupportConversationDocument = gql`
    query SupportConversation($id: ID!) {
  supportConversation(id: $id) {
    conversation {
      ...SupportConversationFields
    }
    error {
      code
      message
    }
  }
}
    ${SupportConversationFieldsFragmentDoc}`;
export const PrepareSupportAttachmentDocument = gql`
    mutation PrepareSupportAttachment($input: PrepareSupportAttachmentInput!) {
  prepareSupportAttachment(input: $input) {
    upload {
      attachmentId
      uploadUrl
      contentType
      expiresAt
    }
    error {
      code
      message
    }
  }
}
    `;
export const CreateSupportConversationDocument = gql`
    mutation CreateSupportConversation($input: CreateSupportConversationInput!) {
  createSupportConversation(input: $input) {
    conversationId
    conversation {
      ...SupportConversationFields
    }
    setupComplete
    incompleteSteps
    error {
      code
      message
    }
  }
}
    ${SupportConversationFieldsFragmentDoc}`;
export const ReplyToSupportConversationDocument = gql`
    mutation ReplyToSupportConversation($input: ReplyToSupportConversationInput!) {
  replyToSupportConversation(input: $input) {
    conversationId
    message {
      ...SupportMessageFields
    }
    error {
      code
      message
    }
  }
}
    ${SupportMessageFieldsFragmentDoc}`;
export const MarkSupportConversationReadDocument = gql`
    mutation MarkSupportConversationRead($input: MarkSupportConversationReadInput!) {
  markSupportConversationRead(input: $input) {
    conversation {
      ...SupportConversationFields
    }
    error {
      code
      message
    }
  }
}
    ${SupportConversationFieldsFragmentDoc}`;
export const ResolveSupportConversationDocument = gql`
    mutation ResolveSupportConversation($input: ResolveSupportConversationInput!) {
  resolveSupportConversation(input: $input) {
    conversation {
      ...SupportConversationFields
    }
    error {
      code
      message
    }
  }
}
    ${SupportConversationFieldsFragmentDoc}`;
export const EhrWeightEntriesDocument = gql`
    query ehrWeightEntries($input: EhrWeightEntriesInput!) {
  ehrWeightEntries(input: $input) {
    metricStat
    createdAt
  }
}
    `;
export const EhrHeightWeightDocument = gql`
    query ehrHeightWeight($patient: EhrVitalsPatientInput!) {
  ehrHeightWeight(patient: $patient) {
    weight
    height
  }
}
    `;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string, operationType?: string, variables?: any) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType, _variables) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    accessNpReviewQueue(variables: PlatformAccessNpReviewQueueQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PlatformAccessNpReviewQueueQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PlatformAccessNpReviewQueueQuery>({ document: AccessNpReviewQueueDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'accessNpReviewQueue', 'query', variables);
    },
    approveAccessCarePlan(variables: PlatformApproveAccessCarePlanMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PlatformApproveAccessCarePlanMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<PlatformApproveAccessCarePlanMutation>({ document: ApproveAccessCarePlanDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'approveAccessCarePlan', 'mutation', variables);
    },
    editAccessCarePlan(variables: PlatformEditAccessCarePlanMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PlatformEditAccessCarePlanMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<PlatformEditAccessCarePlanMutation>({ document: EditAccessCarePlanDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'editAccessCarePlan', 'mutation', variables);
    },
    assignAccessNp(variables: PlatformAssignAccessNpMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PlatformAssignAccessNpMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<PlatformAssignAccessNpMutation>({ document: AssignAccessNpDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'assignAccessNp', 'mutation', variables);
    },
    accessDiagnosisOptions(variables: PlatformAccessDiagnosisOptionsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PlatformAccessDiagnosisOptionsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PlatformAccessDiagnosisOptionsQuery>({ document: AccessDiagnosisOptionsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'accessDiagnosisOptions', 'query', variables);
    },
    changeAppointmentStatus(variables: PlatformChangeAppointmentStatusMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PlatformChangeAppointmentStatusMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<PlatformChangeAppointmentStatusMutation>({ document: ChangeAppointmentStatusDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'changeAppointmentStatus', 'mutation', variables);
    },
    appointmentProviderTimeZone(variables: PlatformAppointmentProviderTimeZoneQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PlatformAppointmentProviderTimeZoneQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PlatformAppointmentProviderTimeZoneQuery>({ document: AppointmentProviderTimeZoneDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'appointmentProviderTimeZone', 'query', variables);
    },
    createChartingNoteDraft(variables: PlatformCreateChartingNoteDraftMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PlatformCreateChartingNoteDraftMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<PlatformCreateChartingNoteDraftMutation>({ document: CreateChartingNoteDraftDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'createChartingNoteDraft', 'mutation', variables);
    },
    submitChartingNote(variables: PlatformSubmitChartingNoteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PlatformSubmitChartingNoteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<PlatformSubmitChartingNoteMutation>({ document: SubmitChartingNoteDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'submitChartingNote', 'mutation', variables);
    },
    chartingItemsByPatient(variables: PlatformChartingItemsByPatientQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PlatformChartingItemsByPatientQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PlatformChartingItemsByPatientQuery>({ document: ChartingItemsByPatientDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'chartingItemsByPatient', 'query', variables);
    },
    chartingNoteDetail(variables: PlatformChartingNoteDetailQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PlatformChartingNoteDetailQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PlatformChartingNoteDetailQuery>({ document: ChartingNoteDetailDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'chartingNoteDetail', 'query', variables);
    },
    chartingNoteForSubmission(variables: PlatformChartingNoteForSubmissionQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PlatformChartingNoteForSubmissionQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PlatformChartingNoteForSubmissionQuery>({ document: ChartingNoteForSubmissionDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'chartingNoteForSubmission', 'query', variables);
    },
    glp1IntakeNotes(variables: PlatformGlp1IntakeNotesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PlatformGlp1IntakeNotesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PlatformGlp1IntakeNotesQuery>({ document: Glp1IntakeNotesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'glp1IntakeNotes', 'query', variables);
    },
    getChatToken(variables: PlatformGetChatTokenQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PlatformGetChatTokenQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PlatformGetChatTokenQuery>({ document: GetChatTokenDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getChatToken', 'query', variables);
    },
    getChatChannel(variables: PlatformGetChatChannelQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PlatformGetChatChannelQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PlatformGetChatChannelQuery>({ document: GetChatChannelDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getChatChannel', 'query', variables);
    },
    sendChatMessage(variables: PlatformSendChatMessageMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PlatformSendChatMessageMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<PlatformSendChatMessageMutation>({ document: SendChatMessageDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'sendChatMessage', 'mutation', variables);
    },
    crossSellBookingOffer(variables: PlatformCrossSellBookingOfferQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PlatformCrossSellBookingOfferQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PlatformCrossSellBookingOfferQuery>({ document: CrossSellBookingOfferDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'crossSellBookingOffer', 'query', variables);
    },
    sendCrossSellBookingLink(variables: PlatformSendCrossSellBookingLinkMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PlatformSendCrossSellBookingLinkMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<PlatformSendCrossSellBookingLinkMutation>({ document: SendCrossSellBookingLinkDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'sendCrossSellBookingLink', 'mutation', variables);
    },
    prepareCrossSellBookingLink(variables: PlatformPrepareCrossSellBookingLinkMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PlatformPrepareCrossSellBookingLinkMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<PlatformPrepareCrossSellBookingLinkMutation>({ document: PrepareCrossSellBookingLinkDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'prepareCrossSellBookingLink', 'mutation', variables);
    },
    createDocumentRequest(variables: PlatformCreateDocumentRequestMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PlatformCreateDocumentRequestMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<PlatformCreateDocumentRequestMutation>({ document: CreateDocumentRequestDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'createDocumentRequest', 'mutation', variables);
    },
    updateDocumentRequest(variables: PlatformUpdateDocumentRequestMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PlatformUpdateDocumentRequestMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<PlatformUpdateDocumentRequestMutation>({ document: UpdateDocumentRequestDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'updateDocumentRequest', 'mutation', variables);
    },
    closeDocumentRequest(variables: PlatformCloseDocumentRequestMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PlatformCloseDocumentRequestMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<PlatformCloseDocumentRequestMutation>({ document: CloseDocumentRequestDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'closeDocumentRequest', 'mutation', variables);
    },
    documentRequestDownloadUrl(variables: PlatformDocumentRequestDownloadUrlQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PlatformDocumentRequestDownloadUrlQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PlatformDocumentRequestDownloadUrlQuery>({ document: DocumentRequestDownloadUrlDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'documentRequestDownloadUrl', 'query', variables);
    },
    followUpVisits(variables: PlatformFollowUpVisitsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PlatformFollowUpVisitsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PlatformFollowUpVisitsQuery>({ document: FollowUpVisitsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'followUpVisits', 'query', variables);
    },
    getFoodEntries(variables: PlatformGetFoodEntriesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PlatformGetFoodEntriesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PlatformGetFoodEntriesQuery>({ document: GetFoodEntriesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getFoodEntries', 'query', variables);
    },
    getJournalDailyTotalsEntries(variables: PlatformGetJournalDailyTotalsEntriesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PlatformGetJournalDailyTotalsEntriesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PlatformGetJournalDailyTotalsEntriesQuery>({ document: GetJournalDailyTotalsEntriesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getJournalDailyTotalsEntries', 'query', variables);
    },
    getJournalEntries(variables: PlatformGetJournalEntriesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PlatformGetJournalEntriesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PlatformGetJournalEntriesQuery>({ document: GetJournalEntriesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getJournalEntries', 'query', variables);
    },
    ProviderPortalGlucoseHistory(variables: PlatformProviderPortalGlucoseHistoryQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PlatformProviderPortalGlucoseHistoryQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PlatformProviderPortalGlucoseHistoryQuery>({ document: ProviderPortalGlucoseHistoryDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'ProviderPortalGlucoseHistory', 'query', variables);
    },
    searchIcdCodes(variables: PlatformSearchIcdCodesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PlatformSearchIcdCodesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PlatformSearchIcdCodesQuery>({ document: SearchIcdCodesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'searchIcdCodes', 'query', variables);
    },
    patientsAwaitingDocuments(variables?: PlatformPatientsAwaitingDocumentsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PlatformPatientsAwaitingDocumentsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PlatformPatientsAwaitingDocumentsQuery>({ document: PatientsAwaitingDocumentsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'patientsAwaitingDocuments', 'query', variables);
    },
    labAlertPatientDocuments(variables: PlatformLabAlertPatientDocumentsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PlatformLabAlertPatientDocumentsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PlatformLabAlertPatientDocumentsQuery>({ document: LabAlertPatientDocumentsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'labAlertPatientDocuments', 'query', variables);
    },
    patientEhrDocuments(variables: PlatformPatientEhrDocumentsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PlatformPatientEhrDocumentsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PlatformPatientEhrDocumentsQuery>({ document: PatientEhrDocumentsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'patientEhrDocuments', 'query', variables);
    },
    getPatientLabDocuments(variables: PlatformGetPatientLabDocumentsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PlatformGetPatientLabDocumentsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PlatformGetPatientLabDocumentsQuery>({ document: GetPatientLabDocumentsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getPatientLabDocuments', 'query', variables);
    },
    getPatientLabDocumentDownloadUrl(variables: PlatformGetPatientLabDocumentDownloadUrlQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PlatformGetPatientLabDocumentDownloadUrlQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PlatformGetPatientLabDocumentDownloadUrlQuery>({ document: GetPatientLabDocumentDownloadUrlDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getPatientLabDocumentDownloadUrl', 'query', variables);
    },
    patientLabs(variables: PlatformPatientLabsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PlatformPatientLabsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PlatformPatientLabsQuery>({ document: PatientLabsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'patientLabs', 'query', variables);
    },
    MedicareBridgeCase(variables: PlatformMedicareBridgeCaseQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PlatformMedicareBridgeCaseQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PlatformMedicareBridgeCaseQuery>({ document: MedicareBridgeCaseDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'MedicareBridgeCase', 'query', variables);
    },
    SubmitMedicareBridgeReview(variables: PlatformSubmitMedicareBridgeReviewMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PlatformSubmitMedicareBridgeReviewMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<PlatformSubmitMedicareBridgeReviewMutation>({ document: SubmitMedicareBridgeReviewDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SubmitMedicareBridgeReview', 'mutation', variables);
    },
    getMedications(variables: PlatformGetMedicationsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PlatformGetMedicationsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PlatformGetMedicationsQuery>({ document: GetMedicationsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getMedications', 'query', variables);
    },
    getPatientNutrientGoals(variables: PlatformGetPatientNutrientGoalsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PlatformGetPatientNutrientGoalsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PlatformGetPatientNutrientGoalsQuery>({ document: GetPatientNutrientGoalsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getPatientNutrientGoals', 'query', variables);
    },
    upsertPatientNutrientGoals(variables: PlatformUpsertPatientNutrientGoalsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PlatformUpsertPatientNutrientGoalsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<PlatformUpsertPatientNutrientGoalsMutation>({ document: UpsertPatientNutrientGoalsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'upsertPatientNutrientGoals', 'mutation', variables);
    },
    patientDocumentFile(variables: PlatformPatientDocumentFileQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PlatformPatientDocumentFileQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PlatformPatientDocumentFileQuery>({ document: PatientDocumentFileDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'patientDocumentFile', 'query', variables);
    },
    createPatientDocument(variables: PlatformCreatePatientDocumentMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PlatformCreatePatientDocumentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<PlatformCreatePatientDocumentMutation>({ document: CreatePatientDocumentDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'createPatientDocument', 'mutation', variables);
    },
    patientDrawerZusProfile(variables: PlatformPatientDrawerZusProfileQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PlatformPatientDrawerZusProfileQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PlatformPatientDrawerZusProfileQuery>({ document: PatientDrawerZusProfileDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'patientDrawerZusProfile', 'query', variables);
    },
    medicationProgramPrescriptionsByPatient(variables: PlatformMedicationProgramPrescriptionsByPatientQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PlatformMedicationProgramPrescriptionsByPatientQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PlatformMedicationProgramPrescriptionsByPatientQuery>({ document: MedicationProgramPrescriptionsByPatientDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'medicationProgramPrescriptionsByPatient', 'query', variables);
    },
    glp1IntakeByPatientDrawer(variables: PlatformGlp1IntakeByPatientDrawerQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PlatformGlp1IntakeByPatientDrawerQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PlatformGlp1IntakeByPatientDrawerQuery>({ document: Glp1IntakeByPatientDrawerDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'glp1IntakeByPatientDrawer', 'query', variables);
    },
    glp1IntakeByPatientBasic(variables: PlatformGlp1IntakeByPatientBasicQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PlatformGlp1IntakeByPatientBasicQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PlatformGlp1IntakeByPatientBasicQuery>({ document: Glp1IntakeByPatientBasicDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'glp1IntakeByPatientBasic', 'query', variables);
    },
    ehrPrescriptions(variables: PlatformEhrPrescriptionsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PlatformEhrPrescriptionsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PlatformEhrPrescriptionsQuery>({ document: EhrPrescriptionsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'ehrPrescriptions', 'query', variables);
    },
    patientInsuranceDetails(variables: PlatformPatientInsuranceDetailsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PlatformPatientInsuranceDetailsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PlatformPatientInsuranceDetailsQuery>({ document: PatientInsuranceDetailsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'patientInsuranceDetails', 'query', variables);
    },
    patientRegistryIdByHealthieId(variables: PlatformPatientRegistryIdByHealthieIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PlatformPatientRegistryIdByHealthieIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PlatformPatientRegistryIdByHealthieIdQuery>({ document: PatientRegistryIdByHealthieIdDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'patientRegistryIdByHealthieId', 'query', variables);
    },
    patientUserGroup(variables: PlatformPatientUserGroupQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PlatformPatientUserGroupQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PlatformPatientUserGroupQuery>({ document: PatientUserGroupDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'patientUserGroup', 'query', variables);
    },
    payerPolicies(variables: PlatformPayerPoliciesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PlatformPayerPoliciesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PlatformPayerPoliciesQuery>({ document: PayerPoliciesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'payerPolicies', 'query', variables);
    },
    paymentProfile(variables: PlatformPaymentProfileQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PlatformPaymentProfileQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PlatformPaymentProfileQuery>({ document: PaymentProfileDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'paymentProfile', 'query', variables);
    },
    patientStateForPhotonPrescriberNote(variables: PlatformPatientStateForPhotonPrescriberNoteQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PlatformPatientStateForPhotonPrescriberNoteQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PlatformPatientStateForPhotonPrescriberNoteQuery>({ document: PatientStateForPhotonPrescriberNoteDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'patientStateForPhotonPrescriberNote', 'query', variables);
    },
    glp1MedicationOptions(variables?: PlatformGlp1MedicationOptionsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PlatformGlp1MedicationOptionsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PlatformGlp1MedicationOptionsQuery>({ document: Glp1MedicationOptionsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'glp1MedicationOptions', 'query', variables);
    },
    benefitsCheckByPatient(variables: PlatformBenefitsCheckByPatientQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PlatformBenefitsCheckByPatientQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PlatformBenefitsCheckByPatientQuery>({ document: BenefitsCheckByPatientDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'benefitsCheckByPatient', 'query', variables);
    },
    medicationProgramEnrollmentByPatient(variables: PlatformMedicationProgramEnrollmentByPatientQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PlatformMedicationProgramEnrollmentByPatientQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PlatformMedicationProgramEnrollmentByPatientQuery>({ document: MedicationProgramEnrollmentByPatientDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'medicationProgramEnrollmentByPatient', 'query', variables);
    },
    recordGlp1NotPrescribedDecision(variables: PlatformRecordGlp1NotPrescribedDecisionMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PlatformRecordGlp1NotPrescribedDecisionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<PlatformRecordGlp1NotPrescribedDecisionMutation>({ document: RecordGlp1NotPrescribedDecisionDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'recordGlp1NotPrescribedDecision', 'mutation', variables);
    },
    clearGlp1NotPrescribedDecision(variables: PlatformClearGlp1NotPrescribedDecisionMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PlatformClearGlp1NotPrescribedDecisionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<PlatformClearGlp1NotPrescribedDecisionMutation>({ document: ClearGlp1NotPrescribedDecisionDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'clearGlp1NotPrescribedDecision', 'mutation', variables);
    },
    setGlp1PatientPrescriberNotes(variables: PlatformSetGlp1PatientPrescriberNotesMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PlatformSetGlp1PatientPrescriberNotesMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<PlatformSetGlp1PatientPrescriberNotesMutation>({ document: SetGlp1PatientPrescriberNotesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'setGlp1PatientPrescriberNotes', 'mutation', variables);
    },
    submitGlp1PriorAuth(variables: PlatformSubmitGlp1PriorAuthMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PlatformSubmitGlp1PriorAuthMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<PlatformSubmitGlp1PriorAuthMutation>({ document: SubmitGlp1PriorAuthDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'submitGlp1PriorAuth', 'mutation', variables);
    },
    priorAuthsByPatient(variables: PlatformPriorAuthsByPatientQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PlatformPriorAuthsByPatientQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PlatformPriorAuthsByPatientQuery>({ document: PriorAuthsByPatientDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'priorAuthsByPatient', 'query', variables);
    },
    prescriptionReview(variables: PlatformPrescriptionReviewQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PlatformPrescriptionReviewQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PlatformPrescriptionReviewQuery>({ document: PrescriptionReviewDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'prescriptionReview', 'query', variables);
    },
    glp1PrescriptionTasks(variables: PlatformGlp1PrescriptionTasksQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PlatformGlp1PrescriptionTasksQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PlatformGlp1PrescriptionTasksQuery>({ document: Glp1PrescriptionTasksDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'glp1PrescriptionTasks', 'query', variables);
    },
    glp1PrescriptionTaskContext(variables: PlatformGlp1PrescriptionTaskContextQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PlatformGlp1PrescriptionTaskContextQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PlatformGlp1PrescriptionTaskContextQuery>({ document: Glp1PrescriptionTaskContextDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'glp1PrescriptionTaskContext', 'query', variables);
    },
    completeGlp1PrescriptionTask(variables: PlatformCompleteGlp1PrescriptionTaskMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PlatformCompleteGlp1PrescriptionTaskMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<PlatformCompleteGlp1PrescriptionTaskMutation>({ document: CompleteGlp1PrescriptionTaskDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'completeGlp1PrescriptionTask', 'mutation', variables);
    },
    getProviderBookingSettings(variables: PlatformGetProviderBookingSettingsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PlatformGetProviderBookingSettingsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PlatformGetProviderBookingSettingsQuery>({ document: GetProviderBookingSettingsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getProviderBookingSettings', 'query', variables);
    },
    updateProviderBookingSettings(variables: PlatformUpdateProviderBookingSettingsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PlatformUpdateProviderBookingSettingsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<PlatformUpdateProviderBookingSettingsMutation>({ document: UpdateProviderBookingSettingsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'updateProviderBookingSettings', 'mutation', variables);
    },
    assignedProviderDocuments(variables?: PlatformAssignedProviderDocumentsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PlatformAssignedProviderDocumentsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PlatformAssignedProviderDocumentsQuery>({ document: AssignedProviderDocumentsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'assignedProviderDocuments', 'query', variables);
    },
    providerDocumentFileAccess(variables: PlatformProviderDocumentFileAccessQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PlatformProviderDocumentFileAccessQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PlatformProviderDocumentFileAccessQuery>({ document: ProviderDocumentFileAccessDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'providerDocumentFileAccess', 'query', variables);
    },
    attestDocumentVersion(variables: PlatformAttestDocumentVersionMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PlatformAttestDocumentVersionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<PlatformAttestDocumentVersionMutation>({ document: AttestDocumentVersionDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'attestDocumentVersion', 'mutation', variables);
    },
    ProviderEventIdentity(variables: PlatformProviderEventIdentityQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PlatformProviderEventIdentityQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PlatformProviderEventIdentityQuery>({ document: ProviderEventIdentityDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'ProviderEventIdentity', 'query', variables);
    },
    providerOrganizationByHealthieId(variables: PlatformProviderOrganizationByHealthieIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PlatformProviderOrganizationByHealthieIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PlatformProviderOrganizationByHealthieIdQuery>({ document: ProviderOrganizationByHealthieIdDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'providerOrganizationByHealthieId', 'query', variables);
    },
    getSessionGoals(variables: PlatformGetSessionGoalsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PlatformGetSessionGoalsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PlatformGetSessionGoalsQuery>({ document: GetSessionGoalsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getSessionGoals', 'query', variables);
    },
    getSessionGoal(variables: PlatformGetSessionGoalQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PlatformGetSessionGoalQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PlatformGetSessionGoalQuery>({ document: GetSessionGoalDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getSessionGoal', 'query', variables);
    },
    upsertSessionGoal(variables: PlatformUpsertSessionGoalMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PlatformUpsertSessionGoalMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<PlatformUpsertSessionGoalMutation>({ document: UpsertSessionGoalDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'upsertSessionGoal', 'mutation', variables);
    },
    markSessionGoalComplete(variables: PlatformMarkSessionGoalCompleteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PlatformMarkSessionGoalCompleteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<PlatformMarkSessionGoalCompleteMutation>({ document: MarkSessionGoalCompleteDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'markSessionGoalComplete', 'mutation', variables);
    },
    SupportAvailability(variables?: PlatformSupportAvailabilityQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PlatformSupportAvailabilityQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PlatformSupportAvailabilityQuery>({ document: SupportAvailabilityDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SupportAvailability', 'query', variables);
    },
    SupportConversations(variables?: PlatformSupportConversationsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PlatformSupportConversationsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PlatformSupportConversationsQuery>({ document: SupportConversationsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SupportConversations', 'query', variables);
    },
    SupportConversation(variables: PlatformSupportConversationQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PlatformSupportConversationQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PlatformSupportConversationQuery>({ document: SupportConversationDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SupportConversation', 'query', variables);
    },
    PrepareSupportAttachment(variables: PlatformPrepareSupportAttachmentMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PlatformPrepareSupportAttachmentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<PlatformPrepareSupportAttachmentMutation>({ document: PrepareSupportAttachmentDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'PrepareSupportAttachment', 'mutation', variables);
    },
    CreateSupportConversation(variables: PlatformCreateSupportConversationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PlatformCreateSupportConversationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<PlatformCreateSupportConversationMutation>({ document: CreateSupportConversationDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CreateSupportConversation', 'mutation', variables);
    },
    ReplyToSupportConversation(variables: PlatformReplyToSupportConversationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PlatformReplyToSupportConversationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<PlatformReplyToSupportConversationMutation>({ document: ReplyToSupportConversationDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'ReplyToSupportConversation', 'mutation', variables);
    },
    MarkSupportConversationRead(variables: PlatformMarkSupportConversationReadMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PlatformMarkSupportConversationReadMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<PlatformMarkSupportConversationReadMutation>({ document: MarkSupportConversationReadDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'MarkSupportConversationRead', 'mutation', variables);
    },
    ResolveSupportConversation(variables: PlatformResolveSupportConversationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PlatformResolveSupportConversationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<PlatformResolveSupportConversationMutation>({ document: ResolveSupportConversationDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'ResolveSupportConversation', 'mutation', variables);
    },
    ehrWeightEntries(variables: PlatformEhrWeightEntriesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PlatformEhrWeightEntriesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PlatformEhrWeightEntriesQuery>({ document: EhrWeightEntriesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'ehrWeightEntries', 'query', variables);
    },
    ehrHeightWeight(variables: PlatformEhrHeightWeightQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PlatformEhrHeightWeightQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PlatformEhrHeightWeightQuery>({ document: EhrHeightWeightDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'ehrHeightWeight', 'query', variables);
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;